
/**
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 * @preserve
 */

webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._ = _;
exports.__ = __;
exports.getLocale = getLocale;
exports.setLocale = setLocale;
exports.createLocalizer = createLocalizer;
exports.init = init;

var _misc = __webpack_require__(52);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*!
                                                                                                                                                                                                     * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                     * All rights reserved.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                     * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                     *    list of conditions and the following disclaimer.
                                                                                                                                                                                                     * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                     *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                     *    and/or other materials provided with the distribution.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                     * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                     * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                     * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                     * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                     * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                     * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                     * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                     * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                     * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                     * @licence Simplified BSD License
                                                                                                                                                                                                     */


var DefaultLocale = 'en_EN';
var CurrentLocale = 'en_EN';
var CurrentRTL = [];

/////////////////////////////////////////////////////////////////////////////
// LOCALE API METHODS
/////////////////////////////////////////////////////////////////////////////

/**
 * Translate given string
 *
 * @param  {String}       s       Translation key/string
 * @param  {...String}    sargs   Format values
 *
 * @return {String}
 */
function _() {
  var userLocale = {};
  var systemLocale = {};
  try {
    userLocale = __webpack_require__(186)("./" + CurrentLocale + '.js');
    systemLocale = __webpack_require__(186)("./" + DefaultLocale + '.js');
  } catch (e) {
    console.warn('Locale error', e);
  }

  var s = arguments[0];
  var a = arguments;
  try {
    if (userLocale && userLocale[s]) {
      a[0] = userLocale[s];
    } else {
      a[0] = systemLocale[s] || s;
    }

    return a.length > 1 ? _misc.format.apply(null, a) : a[0];
  } catch (e) {
    console.warn(e.stack, e);
  }

  return s;
}

/**
 * Same as _ only you can supply the list as first argument
 * @see _
 *
 * @return {String}
 */
function __() {
  var l = arguments[0];
  var s = arguments[1];

  var a = Array.prototype.slice.call(arguments, 1);
  if (l[CurrentLocale] && l[CurrentLocale][s]) {
    a[0] = l[CurrentLocale][s];
  } else {
    a[0] = l[DefaultLocale] ? l[DefaultLocale][s] || s : s;
    if (a[0] && a[0] === s) {
      a[0] = _.apply(null, a);
    }
  }

  return a.length > 1 ? _misc.format.apply(null, a) : a[0];
}

/**
 * Get current locale
 *
 * @return {String}
 */
function getLocale() {
  return CurrentLocale;
}

/**
 * Set locale
 *
 * @param  {String}   l     Locale name
 */
function setLocale(l) {
  var locale = void 0;

  try {
    locale = __webpack_require__(186)("./" + l + '.js');
  } catch (e) {
    console.warn('Failed to set locale', e);
    return;
  }

  if (locale) {
    CurrentLocale = l;
  } else {
    console.warn('Locales::setLocale()', 'Invalid locale', l, '(Using default)');
    CurrentLocale = DefaultLocale;
  }

  var major = CurrentLocale.split('_')[0];
  var html = document.querySelector('html');
  if (html) {
    html.setAttribute('lang', l);
    html.setAttribute('dir', CurrentRTL.indexOf(major) !== -1 ? 'rtl' : 'ltr');
  }

  console.info('Locales::setLocale()', CurrentLocale);
}

/**
 * Creates a new translation function based on a map
 * @param {Object} locales A localization map
 * @return {Function}
 */
function createLocalizer(locales) {
  return function () {
    var args = Array.prototype.slice.call(arguments, 0);
    args.unshift(locales);
    return __.apply(undefined, _toConsumableArray(args));
  };
}

/**
 * Initializes locales
 * @param {String}  locale         Locale name
 * @param {Object}  options        Locale options
 * @param {Array}   [options.RTL]  RTL Languages
 * @param {Array}   languages      Available languages
 */
function init(locale, options, languages) {
  options = options || {};

  var names = languages ? Object.keys(languages) : {};
  if (names instanceof Array && names.indexOf(locale) !== -1) {
    CurrentLocale = locale;
  }

  CurrentRTL = options.RTL || [];

  names.forEach(function (k) {
    OSjs.Locales[k] = __webpack_require__(186)("./" + k + '.js');
  });
}

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                               * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                               * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                               *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                               * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                               *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                               *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                               * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                               * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                               * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                               * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                               * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                               * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                               * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                               * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                               * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * @licence Simplified BSD License
                                                                                                                                                                                                                                                                               */


exports.getConfig = getConfig;
exports.getDefaultPath = getDefaultPath;
exports.getBrowserPath = getBrowserPath;
exports.getUserLocale = getUserLocale;

var _simplejsonconf = __webpack_require__(486);

var SimpleJSON = _interopRequireWildcard(_simplejsonconf);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Method for getting a config parameter by path (Ex: "VFS.Mountpoints.shared.enabled")
 *
 * @param   {String}    [path]                        Path
 * @param   {*}         [defaultValue=undefined]      Use default value
 *
 * @return  {*}             Parameter value or entire tree on no path
 */
function getConfig(path, defaultValue) {
  var config = OSjs.getConfig();
  if (!path) {
    return config;
  }

  var result = SimpleJSON.getJSON(config, path, defaultValue);
  return (typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && !(result instanceof Array) ? Object.assign({}, result) : result;
}

/**
 * Get default configured path
 *
 * @param   {String}    fallback      Fallback path on error
 * @return  {String}
 */
function getDefaultPath(fallback) {
  if (fallback && fallback.match(/^\//)) {
    fallback = null;
  }
  return getConfig('VFS.Home') || fallback || getConfig('VFS.Dist');
}

/**
 * Gets the browser window path
 *
 * @param {String}    [app]     Append this path
 *
 * @return {String}
 */
function getBrowserPath(app) {
  var str = getConfig('Connection.RootURI');
  if (typeof app === 'string') {
    str = str.replace(/\/?$/, app.replace(/^\/?/, '/'));
  }
  return str;
}

/**
 * Gets the browser Locale
 *
 * For example 'en_EN'
 *
 * @return  {String}          Locale string
 */
function getUserLocale() {
  var loc = (window.navigator.userLanguage || window.navigator.language || 'en-EN').replace('-', '_');

  // Restricts to a certain type of language.
  // Example: There are lots of variants of the English language, but currently we only
  // provide locales for one of them, so we force to use the one available.
  var map = {
    'nb': 'no_NO',
    'es': 'es_ES',
    'ru': 'ru_RU',
    'en': 'en_EN'
  };

  var major = loc.split('_')[0] || 'en';
  var minor = loc.split('_')[1] || major.toUpperCase();
  if (map[major]) {
    return map[major];
  }
  return major + '_' + minor;
}

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _config = __webpack_require__(15);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This is the Metadata object you have to use when passing files around
 * in the VFS API.
 *
 * This object has the same properties as in the option list below
 *
 * If you construct without a MIME type, OS.js will try to guess what it is.
 */
var FileMetadata = function () {
  /*eslint valid-jsdoc: "off"*/

  /**
   * @param   {(String|Object)} arg           Either a 'path' or 'object' (filled with properties)
   * @param   {String}          arg.path      Full path
   * @param   {String}          arg.filename  Filename (automatically detected)
   * @param   {String}          arg.type      File type (file/dir)
   * @param   {Number}          arg.size      File size (in bytes)
   * @param   {String}          arg.mime      File MIME (ex: application/json)
   * @param   {*}               arg.id        Unique identifier (not required)
   * @param   {String}          [mime]        MIME type of File Type (ex: 'application/json' or 'dir')
   */
  function FileMetadata(arg, mime) {
    _classCallCheck(this, FileMetadata);

    if (!arg) {
      throw new Error((0, _locales._)('ERR_VFS_FILE_ARGS'));
    }

    /**
     * Full path
     * @type {String}
     * @example home:///foo/bar.baz
     */
    this.path = null;

    /**
     * Filename
     * @type {String}
     * @example foo.baz
     */
    this.filename = null;

    /**
     * Type (dir or file)
     * @type {String}
     * @example file
     */
    this.type = null;

    /**
     * Size in bytes
     * @type {Number}
     * @example 1234
     */
    this.size = null;

    /**
     * MIME type
     * @type {String}
     * @example application/octet-stream
     */
    this.mime = null;

    /**
     * Unique identifier (Only used for external services requring it)
     * @type {String}
     */
    this.id = null;

    /**
     * Internal boolean for a shortcut type file
     * @type {Boolean}
     */
    this.shortcut = false;

    if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
      this.setData(arg);
    } else if (typeof arg === 'string') {
      this.path = arg;
      this.setData();
    }

    if (typeof mime === 'string') {
      if (mime.match(/\//)) {
        this.mime = mime;
      } else {
        this.type = mime;
      }
    }

    this._guessMime();
  }

  /**
   * Set data from Object (key/value pair)
   *
   * @param {Object}    o     Object
   */


  _createClass(FileMetadata, [{
    key: 'setData',
    value: function setData(o) {
      var _this = this;

      if (o) {
        Object.keys(o).forEach(function (k) {
          if (k !== '_element') {
            _this[k] = o[k];
          }
        });
      }

      if (!this.filename) {
        this.filename = FS.filename(this.path);
      }
    }

    /**
     * Get object data as key/value pair.
     *
     * @return {Object}
     */

  }, {
    key: 'getData',
    value: function getData() {
      return {
        path: this.path,
        filename: this.filename,
        type: this.type,
        size: this.size,
        mime: this.mime,
        id: this.id
      };
    }
  }, {
    key: '_guessMime',
    value: function _guessMime() {
      if (this.mime || this.type === 'dir' || !this.path || this.path.match(/\/$/)) {
        return;
      }

      var ext = FS.filext(this.path);
      this.mime = (0, _config.getConfig)('MIME.mapping')['.' + ext] || 'application/octet-stream';
    }

    /**
     * Creates a new VFS.File from an upload
     *
     * @param     {String}      destination         Destination path
     * @param     {File}        f                   File
     *
     * @return {FileMetadata}
     */

  }], [{
    key: 'fromUpload',
    value: function fromUpload(destination, f) {
      return new FileMetadata({
        filename: f.name,
        path: (destination + '/' + f.name).replace(/\/\/\/\/+/, '///'),
        mime: f.mime || 'application/octet-stream',
        size: f.size
      });
    }
  }]);

  return FileMetadata;
}();

exports.default = FileMetadata;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$ = $;
exports.$safeName = $safeName;
exports.$remove = $remove;
exports.$empty = $empty;
exports.$getStyle = $getStyle;
exports.$position = $position;
exports.$parent = $parent;
exports.$index = $index;
exports.$selectRange = $selectRange;
exports.$addClass = $addClass;
exports.$removeClass = $removeClass;
exports.$hasClass = $hasClass;
exports.$escape = $escape;
exports.$create = $create;
exports.$createCSS = $createCSS;
exports.$createJS = $createJS;
exports.$isFormElement = $isFormElement;
exports.$css = $css;
exports.$path = $path;
exports.$fromPath = $fromPath;
exports.$clean = $clean;
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * Get element by ID
 *
 * @param   {String}    id      DOM Element ID
 *
 * @return  {Node}        Found element or null
 */
function $(id) {
  return document.getElementById(id);
}

/**
 * Remove unwanted characters from ID or className
 *
 * @param   {String}    str     The name
 *
 * @return  {String}            The new name
 */
function $safeName(str) {
  return (str || '').replace(/[^a-zA-Z0-9]/g, '_');
}

/**
 * Remove given element from parent
 *
 * @param   {Node}    node      The DOM Element
 */
function $remove(node) {
  if (node) {
    if (typeof node.remove === 'function') {
      node.remove();
    } else if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
  }
}

/**
 * Empty this element (remove children)
 *
 * @param   {Node}             myNode                 The DOM Element
 */
function $empty(myNode) {
  if (myNode) {
    while (myNode.firstChild) {
      myNode.removeChild(myNode.firstChild);
    }
  }
}

/**
 * Get CSS style attribute
 *
 * @param   {Node}          oElm          The DOM Element
 * @param   {String}        strCssRule    The CSS rule to get
 *
 * @return  {String}                      Style attribute
 */
function $getStyle(oElm, strCssRule) {
  var strValue = '';
  if (document.defaultView && document.defaultView.getComputedStyle) {
    strValue = document.defaultView.getComputedStyle(oElm, '').getPropertyValue(strCssRule);
  } else if (oElm.currentStyle) {
    strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1) {
      return p1.toUpperCase();
    });
    strValue = oElm.currentStyle[strCssRule];
  }
  return strValue;
}

/**
 * Get element absolute position
 *
 * Modern browsers will return getBoundingClientRect()
 * See DOM documentation
 *
 * @param   {Node}      el          The Element to find position of
 * @param   {Node}      [parentEl]  Parent to end loop in
 *
 * @return  {Object}                    The bounding box
 */
function $position(el, parentEl) {
  if (el) {
    if (parentEl) {
      var result = { left: 0, top: 0, width: el.offsetWidth, height: el.offsetHeight };
      while (true) {
        result.left += el.offsetLeft;
        result.top += el.offsetTop;
        if (el.offsetParent === parentEl || el.offsetParent === null) {
          break;
        }
        el = el.offsetParent;
      }
      return result;
    }
    return el.getBoundingClientRect();
  }
  return null;
}

/**
 * Traverses down to the parentnode validated by filter
 *
 * @param   {Node}            el        The Element to find position of
 * @param   {Function}        cb        The callback function => fn(node) return true/false here
 *
 * @return  {Node}            el        The DOM element
 */
function $parent(el, cb) {
  var result = null;

  if (el && cb) {
    var current = el;
    while (current.parentNode) {
      if (cb(current)) {
        result = current;
        break;
      }
      current = current.parentNode;
    }
  }

  return result;
}

/**
 * Get the index of an element within a node
 *
 * @param   {Node}      el          The Element to check
 * @param   {Node}      [parentEl]  Parent to end loop in
 *
 * @return  {Number}              The index
 */
function $index(el, parentEl) {
  if (el) {
    parentEl = parentEl || el.parentNode;
    if (parentEl) {
      var nodeList = Array.prototype.slice.call(parentEl.children);
      var nodeIndex = nodeList.indexOf(el, parentEl);
      return nodeIndex;
    }
  }
  return -1;
}

/**
 * Selects range in a text field
 *
 * @param     {Node}      field     The DOM Element
 * @param     {Number}    start     Start position
 * @param     {Number}    end       End position
 */
function $selectRange(field, start, end) {
  if (!field) {
    throw new Error('Cannot select range: missing element');
  }

  if (typeof start === 'undefined' || typeof end === 'undefined') {
    throw new Error('Cannot select range: mising start/end');
  }

  if (field.createTextRange) {
    var selRange = field.createTextRange();
    selRange.collapse(true);
    selRange.moveStart('character', start);
    selRange.moveEnd('character', end);
    selRange.select();
    field.focus();
  } else if (field.setSelectionRange) {
    field.focus();
    field.setSelectionRange(start, end);
  } else if (typeof field.selectionStart !== 'undefined') {
    field.selectionStart = start;
    field.selectionEnd = end;
    field.focus();
  }
}

/**
 * Add a className to a DOM Element
 *
 * @param   {Node}      el      The dom Element
 * @param   {String}    name    The class name
 */
function $addClass(el, name) {
  if (el) {
    name.split(' ').forEach(function (n) {
      el.classList.add(n);
    });
  }
}

/**
 * Remove a className from a DOM Element
 *
 * @param   {Node}      el      The dom Element
 * @param   {String}    name    The class name
 */
function $removeClass(el, name) {
  if (el) {
    name.split(' ').forEach(function (n) {
      el.classList.remove(n);
    });
  }
}

/**
 * Check if a DOM Element has given className
 *
 * @param   {Node}      el      The dom Element
 * @param   {String}    name    The class name
 *
 * @return {Boolean}
 */
function $hasClass(el, name) {
  if (el && name) {
    return name.split(' ').every(function (n) {
      return el.classList.contains(n);
    });
  }
  return false;
}

/**
 * Escapes the given string for HTML
 *
 * works sort of like PHPs htmlspecialchars()
 *
 * @param   {String}    str       Input
 *
 * @return  {String}              Escaped HTML
 */
function $escape(str) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(str));
  return div.innerHTML;
}

/**
 * Creates a new DOM element
 *
 * @example
 * $create('div', {
 *  className: 'foo',
 *  style: {
 *    width: '200px'
 *  },
 *  data: {
 *    custom_attribute: 'bar'
 *  },
 *  aria: {
 *    role: 'button'
 *  },
 *  some_custom_attribute: 'baz'
 * })
 *
 * @param   {String}    tagName     Tag Name
 * @param   {Object}    properties  Tag Properties
 *
 * @return  {Node}
 */
function $create(tagName, properties) {
  var element = document.createElement(tagName);

  function _foreach(dict, l) {
    dict = dict || {};
    Object.keys(dict).forEach(function (name) {
      l(name.replace(/_/g, '-'), String(dict[name]));
    });
  }

  _foreach(properties.style, function (key, val) {
    element.style[key] = val;
  });

  _foreach(properties.aria, function (key, val) {
    if (['role'].indexOf(key) !== -1) {
      key = 'aria-' + key;
    }
    element.setAttribute(key, val);
  });

  _foreach(properties.data, function (key, val) {
    element.setAttribute('data-' + key, val);
  });

  _foreach(properties, function (key, val) {
    if (['style', 'aria', 'data'].indexOf(key) === -1) {
      element[key] = val;
    }
  });

  return element;
}

/**
 * Create a link stylesheet tag
 *
 * @param   {String}      src           The URL of resource
 * @param   {Function}    onload        onload callback
 * @param   {Function}    onerror       onerror callback
 *
 * @return  {Node}                The tag
 */
function $createCSS(src, onload, onerror) {
  var link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('type', 'text/css');
  link.onload = onload || function () {};
  link.onerror = onerror || function () {};
  link.setAttribute('href', src);

  document.getElementsByTagName('head')[0].appendChild(link);

  return link;
}

/**
 * Create a script tag
 *
 * @param   {String}      src                   The URL of resource
 * @param   {Function}    onreadystatechange    readystatechange callback
 * @param   {Function}    onload                onload callback
 * @param   {Function}    onerror               onerror callback
 * @param   {Object}      [attrs]               dict with optional arguments
 *
 * @return  {Node}                              The tag
 */
function $createJS(src, onreadystatechange, onload, onerror, attrs) {
  var res = document.createElement('script');

  res.onreadystatechange = onreadystatechange || function () {};
  res.onerror = onerror || function () {};
  res.onload = onload || function () {};

  attrs = Object.assign({}, {
    type: 'text/javascript',
    charset: 'utf-8',
    src: src
  }, attrs || {});

  Object.keys(attrs).forEach(function (k) {
    res[k] = String(attrs[k]);
  });

  document.getElementsByTagName('head')[0].appendChild(res);

  return res;
}

/**
 * Check if event happened on a form element
 *
 * @param   {Event|Element}   input     DOM Event or Element
 * @param   {Array}           [types]   Optional Array of types
 *
 * @return  {Boolean}             If is a form element
 */
function $isFormElement(input, types) {
  types = types || ['TEXTAREA', 'INPUT', 'SELECT'];

  if (input instanceof window.Event) {
    input = input.srcElement || input.target;
  }

  if (input instanceof window.Element) {
    if (types.indexOf(input.tagName.toUpperCase()) >= 0) {
      if (!(input.readOnly || input.disabled)) {
        return true;
      }
    }
  }

  return false;
}

/**
 * Set or Get element CSS
 *
 * @param {Node}                  el      DOM Node
 * @param {(String|Object)}       ink     CSS attribute name to get/set, or full dict to set
 * @param {(String|Number)}       [inv]   If previous argument was a string, this is the value that will be set
 *
 * @return {String} CSS attribute value
 *
 * @example
 * $css(element, {
 *  backgroundColor: '#000',
 *  'font-size': '14px' // You can also use CSS attributes like normal
 * });
 *
 * @example
 * $css(element, 'font-family', 'Arial');
 *
 * @example
 * $css(element, 'font-family'); // -> 'Arial'. Same as $getStyle
 */
function $css(el, ink, inv) {
  function rep(k) {
    return k.replace(/\-(\w)/g, function (strMatch, p1) {
      return p1.toUpperCase();
    });
  }

  var obj = {};
  if (arguments.length === 2) {
    if (typeof ink === 'string') {
      return el.parentNode ? $getStyle(el, ink) : el.style[rep(ink)];
    }
    obj = ink;
  } else if (arguments.length === 3) {
    obj[ink] = inv;
  }

  Object.keys(obj).forEach(function (k) {
    el.style[rep(k)] = String(obj[k]);
  });

  return null;
}

/**
 * Gets the Xpath to a DOM Element
 *
 * @param {Node} el DOM Element
 * @return {String}
 */
function $path(el) {
  function _path(e) {
    if (e === document.body) {
      return e.tagName;
    } else if (e === window) {
      return 'WINDOW';
    } else if (e === document) {
      return 'DOCUMENT';
    }

    if (e.id !== '') {
      return 'id("' + e.id + '")';
    }

    var ix = 0;

    var siblings = e.parentNode ? e.parentNode.childNodes : [];
    for (var i = 0; i < siblings.length; i++) {
      var sibling = siblings[i];
      if (sibling === e) {
        return _path(e.parentNode) + '/' + e.tagName + '[' + (ix + 1) + ']';
      }

      if (sibling.nodeType === 1 && sibling.tagName === e.tagName) {
        ix++;
      }
    }

    return null;
  }

  return _path(el);
}

/**
 * Gets a DOM Element from Xpath
 *
 * @param {String} path The path
 * @param {HTMLDocument} [doc] The document to resolve in
 * @return {Node}
 */
function $fromPath(path, doc) {
  doc = doc || document;

  var evaluator = new XPathEvaluator();
  var result = evaluator.evaluate(path, doc.documentElement, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
  return result.singleNodeValue;
}

/**
 * Remove whitespaces and newlines from HTML document
 *
 * @param   {String}    html          HTML string input
 *
 * @return  {String}
 */
function $clean(html) {
  if (typeof html !== 'string') {
    html = html.innerHTML;
  }

  return (html || '').replace(/\n/g, '').replace(/[\t ]+</g, '<').replace(/\>[\t ]+</g, '><').replace(/\>[\t ]+$/g, '>');
}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var _keycodes = __webpack_require__(88);

var _keycodes2 = _interopRequireDefault(_keycodes);

var _window = __webpack_require__(121);

var _window2 = _interopRequireDefault(_window);

var _application = __webpack_require__(124);

var _application2 = _interopRequireDefault(_application);

var _windowManager = __webpack_require__(89);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _scheme = __webpack_require__(190);

var _scheme2 = _interopRequireDefault(_scheme);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * A callback for Dialogs.
 *
 * <pre>
 * The list of included buttons are: ok, cancel, yes, no
 * depending on which dialog was called.
 *
 * The result also depends on which dialog was called.
 *
 * The default button is 'cancel' if window was closed.
 *
 * You only get an event back if an actual button was pressed.
 * </pre>
 *
 * @callback CallbackDialog
 * @param {Event}   ev      Browser event that occured from action
 * @param {String}  button  Which button that was clicked
 * @param {*}       result  Result from dialog input
 */

/////////////////////////////////////////////////////////////////////////////
// DIALOG
/////////////////////////////////////////////////////////////////////////////

/**
 * Base Dialog Window Class
 *
 * @desc Class used for basis as a Dialog.
 *
 * @extends {Window}
 * @abstract
 */
var DialogWindow = function (_Window) {
  _inherits(DialogWindow, _Window);

  /**
   * @param {String}          className     Dialog Class Name
   * @param {Object}          opts          Dialog Class Options
   * @param {Object}          args          Dialog Class Arguments
   * @param {CallbackDialog}  callback      Callback function
   */
  function DialogWindow(className, opts, args, callback) {
    _classCallCheck(this, DialogWindow);

    opts = opts || {};
    args = args || {};
    callback = callback || function () {};

    if (typeof callback !== 'function') {
      throw new TypeError('DialogWindow expects a callback Function, gave: ' + (typeof callback === 'undefined' ? 'undefined' : _typeof(callback)));
    }

    console.info('DialogWindow::construct()', className, opts, args);

    var _this = _possibleConstructorReturn(this, (DialogWindow.__proto__ || Object.getPrototypeOf(DialogWindow)).call(this, className, opts));

    _this._properties.gravity = 'center';
    _this._properties.allow_resize = false;
    _this._properties.allow_minimize = false;
    _this._properties.allow_maximize = false;
    _this._properties.allow_windowlist = false;
    _this._properties.allow_session = false;
    _this._state.ontop = true;
    _this._tag = 'DialogWindow';

    if (args.scheme && args.scheme instanceof _scheme2.default) {
      _this.scheme = args.scheme;
      delete args.scheme;
    }

    _this.args = args;
    _this.className = className;
    _this.buttonClicked = false;
    _this.closeCallback = function (ev, button, result) {
      if (_this._destroyed) {
        return;
      }

      _this.buttonClicked = true;
      callback.call(_this, ev, button, result);
      _this._close();
    };
    return _this;
  }

  /**
   * @override
   */


  _createClass(DialogWindow, [{
    key: 'destroy',
    value: function destroy() {
      if (this.scheme) {
        this.scheme = this.scheme.destroy();
      }

      return _get(DialogWindow.prototype.__proto__ || Object.getPrototypeOf(DialogWindow.prototype), 'destroy', this).apply(this, arguments);
    }

    /**
     * @override
     */

  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(DialogWindow.prototype.__proto__ || Object.getPrototypeOf(DialogWindow.prototype), 'init', this).apply(this, arguments);

      root.setAttribute('role', 'dialog');

      var windowName = this.className.replace(/Dialog$/, '');
      var focusButtons = ['ButtonCancel', 'ButtonNo'];
      var buttonMap = {
        ButtonOK: 'ok',
        ButtonCancel: 'cancel',
        ButtonYes: 'yes',
        ButtonNo: 'no'
      };

      if (this.scheme) {
        this.scheme.render(this, windowName, root, 'application-dialog', function (node) {
          node.querySelectorAll('gui-label').forEach(function (el) {
            if (el.childNodes.length && el.childNodes[0].nodeType === 3 && el.childNodes[0].nodeValue) {
              var label = el.childNodes[0].nodeValue;
              (0, _dom.$empty)(el);
              el.appendChild(document.createTextNode((0, _locales._)(label)));
            }
          });
        });
      } else {
        this._render(windowName, __webpack_require__(489));
      }

      Object.keys(buttonMap).filter(function (id) {
        return _this2._findDOM(id);
      }).forEach(function (id) {
        var btn = _this2._find(id);
        btn.on('click', function (ev) {
          _this2.onClose(ev, buttonMap[id]);
        });

        if (focusButtons.indexOf(id) >= 0) {
          btn.focus();
        }
      });

      (0, _dom.$addClass)(root, 'DialogWindow');

      return root;
    }

    /**
     * When dialog closes
     *
     * @param   {Event}     ev        DOM Event
     * @param   {String}    button    Button used
     */

  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      this.closeCallback(ev, button, null);
    }

    /**
     * @override
     */

  }, {
    key: '_close',
    value: function _close() {
      if (!this.buttonClicked) {
        this.onClose(null, 'cancel', null);
      }
      return _get(DialogWindow.prototype.__proto__ || Object.getPrototypeOf(DialogWindow.prototype), '_close', this).apply(this, arguments);
    }

    /**
     * @override
     */

  }, {
    key: '_onKeyEvent',
    value: function _onKeyEvent(ev) {
      _get(DialogWindow.prototype.__proto__ || Object.getPrototypeOf(DialogWindow.prototype), '_onKeyEvent', this).apply(this, arguments);

      if (ev.keyCode === _keycodes2.default.ESC) {
        this.onClose(ev, 'cancel');
      }
    }

    /**
     * Parses given message to be inserted into Dialog
     *
     * @param {String}  msg   Message
     *
     * @return {DocumentFragment}
     */

  }], [{
    key: 'parseMessage',
    value: function parseMessage(msg) {
      msg = (0, _dom.$escape)(msg || '').replace(/\*\*(.*)\*\*/g, '<span>$1</span>');

      var tmp = document.createElement('div');
      tmp.innerHTML = msg;

      var frag = document.createDocumentFragment();
      for (var i = 0; i < tmp.childNodes.length; i++) {
        frag.appendChild(tmp.childNodes[i].cloneNode(true));
      }
      tmp = null;

      return frag;
    }

    /**
     * Create a new dialog
     *
     * You can also pass a function as `className` to return an instance of your own class
     *
     * @param   {String}                     className             Dialog Namespace Class Name
     * @param   {Object}                     args                  Arguments you want to send to dialog
     * @param   {CallbackDialog}             callback              Callback on dialog action (close/ok etc) => fn(ev, button, result)
     * @param   {Object|Window|Application}  [options]             A window or app (to make it a child window) or a set of options:
     * @param   {Window|Application}         [options.parent]      Same as above argument (without options context)
     * @param   {Boolean}                    [options.modal=false] If you provide a parent you can toggle "modal" mode.
     *
     * @return  {Window}
     */

  }, {
    key: 'create',
    value: function create(className, args, callback, options) {

      callback = callback || function () {};
      options = options || {};

      var parentObj = options;
      var parentIsWindow = parentObj instanceof _window2.default;
      var parentIsProcess = parentObj instanceof _application2.default;
      if (parentObj && !(parentIsWindow && parentIsProcess)) {
        parentObj = options.parent;
        parentIsWindow = parentObj instanceof _window2.default;
        parentIsProcess = parentObj instanceof _application2.default;
      }

      function cb() {
        if (parentObj) {
          if (parentIsWindow && parentObj._destroyed) {
            console.warn('DialogWindow::create()', 'INGORED EVENT: Window was destroyed');
            return;
          }
          if (parentIsProcess && parentObj.__destroyed) {
            console.warn('DialogWindow::create()', 'INGORED EVENT: Process was destroyed');
            return;
          }
        }

        if (options.modal && parentIsWindow) {
          parentObj._toggleDisabled(false);
        }

        callback.apply(null, arguments);
      }

      var win = typeof className === 'string' ? new OSjs.Dialogs[className](args, cb) : className(args, cb);

      if (!parentObj) {
        var wm = _windowManager2.default.instance;
        wm.addWindow(win, true);
      } else if (parentObj instanceof _window2.default) {
        win._on('destroy', function () {
          if (parentObj) {
            parentObj._focus();
          }
        });
        parentObj._addChild(win, true);
      } else if (parentObj instanceof _application2.default) {
        parentObj._addWindow(win);
      }

      if (options.modal && parentIsWindow) {
        parentObj._toggleDisabled(true);
      }

      win._focus();

      return win;
    }
  }]);

  return DialogWindow;
}(_window2.default);

exports.default = DialogWindow;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$bind = exports.keyCombination = undefined;
exports.mousePosition = mousePosition;
exports.mouseButton = mouseButton;
exports.$unbind = $unbind;

var _keycodes = __webpack_require__(88);

var Keycodes = _interopRequireWildcard(_keycodes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * The callback for browser events bound by OS.js
 * @callback CallbackEvent
 * @param {Event} ev Browser event
 * @param {Object} pos Event pointer position in form of x and y
 */

/////////////////////////////////////////////////////////////////////////////
// MISC
/////////////////////////////////////////////////////////////////////////////

/*
 * Gets the event name considering compability with
 * MSPointerEvent and PointerEvent interfaces.
 */
function getRealEventName(evName) {
  var realName = evName;
  if (evName !== 'mousewheel' && evName.match(/^mouse/)) {
    if (window.PointerEvent) {
      realName = evName.replace(/^mouse/, 'pointer');
    } else if (window.MSPointerEvent) {
      var tmpName = evName.replace(/^mouse/, '');
      realName = 'MSPointer' + tmpName.charAt(0).toUpperCase() + tmpName.slice(1).toLowerCase();
    }
  }
  return realName;
}

/*
 * Gets a list from string of event names
 */
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

function getEventList(str) {
  return str.replace(/\s/g, '').split(',');
}

/////////////////////////////////////////////////////////////////////////////
// EVENTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Gets mouse position in all cases (including touch)
 *
 * @example
 * mousePosition(ev); // -> {x:1, y:1}
 *
 * @param {Event}   ev    DOM Event
 *
 * @return {(Event|Object)}   ev      DOM Event or an Object
 * @return Object
 */
function mousePosition(ev) {
  // If this is a custom event containing position
  if (ev.detail && typeof ev.detail.x !== 'undefined' && typeof ev.detail.y !== 'undefined') {
    return { x: ev.detail.x, y: ev.detail.y };
  }

  // If this was a touch event
  var touch = ev.touches || ev.changedTouches || [];
  if (touch.length) {
    return { x: touch[0].clientX, y: touch[0].clientY };
  }

  return { x: ev.clientX, y: ev.clientY };
}

/**
 * Get the mouse button pressed
 *
 * @param   {Event}     ev    The DOM Event
 *
 * @return  {String}          The mouse button (left/middle/right)
 */
function mouseButton(ev) {
  if (typeof ev.button !== 'undefined') {
    if (ev.button === 0) {
      return 'left';
    } else if (ev.button === 1) {
      return 'middle';
    }
    return 'right';
  }

  if (ev.which === 2 || ev.which === 4) {
    return 'middle';
  } else if (ev.which === 1) {
    return 'left';
  }
  return 'right';
}

/**
 * Checks if the event currently has the given key comination.
 *
 * Example: 'CTRL+SHIFT+A'
 *
 * @param   {Event}     ev            The DOM Event
 * @param   {String}    checkFor      The string of keystrokes to check
 *
 * @return  {Boolean}
 */
var keyCombination = exports.keyCombination = function () {
  var modifiers = {
    CTRL: function CTRL(ev) {
      return ev.ctrlKey;
    },
    SHIFT: function SHIFT(ev) {
      return ev.shiftKey;
    },
    ALT: function ALT(ev) {
      return ev.altKey;
    },
    META: function META(ev) {
      return ev.metaKey;
    }
  };

  function getKeyName(keyCode) {
    var result = false;
    Object.keys(Keycodes).forEach(function (k) {
      if (!result && keyCode === Keycodes[k]) {
        result = k;
      }
    });
    return result;
  }

  return function (ev, checkFor) {
    var checks = checkFor.toUpperCase().split('+');
    var checkMods = { CTRL: false, SHIFT: false, ALT: false };
    var checkKeys = [];

    checks.forEach(function (f) {
      if (modifiers[f]) {
        checkMods[f] = true;
      } else {
        checkKeys.push(f);
      }
    });

    var hasmod = Object.keys(checkMods).every(function (f) {
      var fk = !!modifiers[f](ev);
      return checkMods[f] === fk;
    });

    var haskey = checkKeys.every(function (f) {
      return getKeyName(ev.keyCode) === f;
    });

    return hasmod && haskey;
  };
}();

/**
 * Wrapper for event-binding
 *
 * <pre><code>
 * You can bind multiple events by separating types with a comma.
 *
 * This also automatically binds Touch events.
 *
 *   mousedown = touchstart
 *   mouseup = touchend
 *   mousemove = touchend
 *   contextmenu = long-hold
 *   dblclick = double-tap
 *   click = tap
 * </code></pre>
 *
 * @example
 * $bind(el, 'click', function(ev, pos, touch) {
 *  // A click event
 * });
 *
 * @example
 * $bind(el, 'click:customname', function(ev, pos, touch) {
 *  // A click event with custom namespace. Useful
 *  // for when you want to separate events with same
 *  // type.
 * });
 *
 * @example
 * $bind(el, 'click, mousedown, mouseup', function(ev, pos, touch) {
 *  // You can bind multiple events in one go
 * });
 *
 * @param   {Node}            el            DOM Element to attach event to
 * @param   {String}          ev            DOM Event Name
 * @param   {CallbackEvent}   callback      Callback on event
 * @param   {Boolean}         [useCapture]  Use capture mode
 */
var $bind = exports.$bind = function () {
  function makeFakeEvent(name, ev) {
    var pos = mousePosition(ev);
    var nev = Object.assign({
      clientX: pos.x,
      clientY: pos.y,
      x: pos.x,
      y: pos.y
    }, ev);

    return new MouseEvent(name, nev);
  }

  /*
   * This is the wrapper for using addEventListener
   */
  function addEventHandler(el, n, t, callback, handler, useCapture, realType) {
    var args = [t, handler, useCapture];

    el.addEventListener.apply(el, args);

    el._boundEvents[n].push({
      realType: realType,
      args: args,
      callback: callback
    });
  }

  /*
   * Creates mousewheel handler
   */
  function createWheelHandler(el, n, t, callback, useCapture) {

    function _wheel(ev) {
      var pos = mousePosition(ev);
      var direction = ev.detail < 0 || ev.wheelDelta > 0 ? 1 : -1;
      pos.z = direction;

      return callback(ev, pos);
    }

    addEventHandler(el, n, 'mousewheel', callback, _wheel, useCapture, 'mousewheel');
    addEventHandler(el, n, 'DOMMouseScroll', callback, _wheel, useCapture, 'DOMMouseScroll');
  }

  function createClick(el, n, t, callback, useCapture) {
    var cancelled = false;
    var timeout = void 0;
    var firstTarget = void 0;
    var firstEvent = void 0;

    var tempMove = function tempMove() {
      return cancelled = true;
    };

    function cancel() {
      clearTimeout(timeout);

      firstTarget = null;
      cancelled = true;

      window.removeEventListener('touchmove', tempMove);
    }

    function tempEnd(ev) {
      clearTimeout(timeout);

      window.removeEventListener('touchmove', tempMove);

      if (!cancelled && ev.target === firstTarget) {
        var newEvent = makeFakeEvent('click', firstEvent);
        Object.defineProperty(newEvent, 'target', {
          value: firstEvent.target,
          enumerable: false
        });
        el.dispatchEvent(newEvent);
      }
    }

    function tempStart(ev) {
      firstEvent = ev;
      firstTarget = ev.target;
      timeout = setTimeout(function () {
        cancelled = true;
      }, 300);
      window.addEventListener('touchmove', tempMove);
    }

    addEventHandler(el, n, 'touchcancel', callback, cancel, useCapture, 'dblclick');
    addEventHandler(el, n, 'touchstart', callback, tempStart, useCapture, 'click');
    addEventHandler(el, n, 'touchend', callback, tempEnd, useCapture, 'click');
  }

  function createDoubleClick(el, n, t, callback, useCapture) {
    var count = 0;
    var cancelled = false;
    var firstTarget = void 0;
    var firstEvent = void 0;
    var debounce = void 0;

    var tempMove = function tempMove() {
      return cancelled = true;
    };

    function cancel() {
      firstTarget = null;
      cancelled = true;
      count = 0;

      window.removeEventListener('toucmove', tempMove);
    }

    function tempEnd() {
      window.removeEventListener('touchmove', tempMove);
      debounce = setTimeout(cancel, 680);
    }

    function tempStart(ev) {
      window.addEventListener('touchmove', tempMove);
      clearTimeout(debounce);

      if (count === 0) {
        firstEvent = ev;
        firstTarget = ev.target;
      } else if (count > 0) {
        if (ev.target !== firstTarget) {
          cancel();
          return;
        }

        if (!cancelled) {
          ev.preventDefault(); // Prevent any zooming etc
          ev.stopPropagation(); // The first tap already propagated
          ev.target.dispatchEvent(makeFakeEvent('dblclick', firstEvent));
        }
      }

      cancelled = false;
      count++;
    }

    addEventHandler(el, n, 'touchcancel', callback, cancel, useCapture, 'dblclick');
    addEventHandler(el, n, 'touchstart', callback, tempStart, useCapture, 'dblclick');
    addEventHandler(el, n, 'touchend', callback, tempEnd, useCapture, 'dblclick');
  }

  function createContextMenu(el, n, t, callback, useCapture) {
    var cancelled = false;
    var timeout = void 0;

    var tempMove = function tempMove() {
      return cancelled = true;
    };

    function cancel() {
      clearTimeout(timeout);
      cancelled = true;

      window.removeEventListener('toucmove', tempMove);
    }

    function tempEnd(ev) {
      cancelled = true;
      clearTimeout(timeout);
      window.removeEventListener('touchmove', tempMove);
    }

    function tempStart(ev) {
      timeout = setTimeout(function () {
        if (!cancelled) {
          ev.preventDefault();
          ev.target.dispatchEvent(makeFakeEvent('contextmenu', ev));
        }
      }, 300);
      window.addEventListener('touchmove', tempMove);
    }

    addEventHandler(el, n, 'touchcancel', callback, cancel, useCapture, 'contextmenu');
    addEventHandler(el, n, 'touchstart', callback, tempStart, useCapture, 'contextmenu');
    addEventHandler(el, n, 'touchend', callback, tempEnd, useCapture, 'contextmenu');
  }

  /*
   * Map of touch events
   */
  var customEvents = {
    mousewheel: createWheelHandler,
    click: createClick,
    dblclick: createDoubleClick,
    contextmenu: createContextMenu
  };

  return function Utils_$bind(el, evName, callback, useCapture, noBind) {
    useCapture = useCapture === true;

    if (arguments.length < 3) {
      throw new Error('$bind expects 3 or more arguments');
    }
    if (typeof evName !== 'string') {
      throw new Error('Given event type was not a string');
    }
    if (typeof callback !== 'function') {
      throw new Error('Given callback was not a function');
    }

    function addEvent(nsType, type) {
      type = getRealEventName(type);

      addEventHandler(el, nsType, type, callback, function mouseEventHandler(ev) {
        if (!window.OSjs) {
          // Probably shut down
          return;
        }

        if (noBind) {
          callback(ev, mousePosition(ev));
        }
        callback.call(el, ev, mousePosition(ev));
      }, useCapture);

      if (type === 'click' && el.tagName === 'BUTTON') {
        return;
      }

      if (customEvents[type]) {
        customEvents[type](el, nsType, type, function fakeEventHandler(ev) {
          if (noBind) {
            callback(ev, mousePosition(ev));
          }
          callback.call(el, ev, mousePosition(ev));
        }, useCapture);
      }
    }

    function initNamespace(ns) {
      if (!el._boundEvents) {
        el._boundEvents = {};
      }

      if (!el._boundEvents[ns]) {
        el._boundEvents[ns] = [];
      }

      var found = el._boundEvents[ns].filter(function (iter) {
        return iter.callback === callback;
      });

      return found.length === 0;
    }

    getEventList(evName).forEach(function (ns) {
      var type = ns.split(':')[0];

      if (!initNamespace(ns)) {
        console.warn('Utils::$bind()', 'This event was already bound, skipping');
        return;
      }

      addEvent(ns, type);
    });
  };
}();

/**
 * Unbinds the given event
 *
 * <pre><b>
 * If you don't give a callback it will unbind *all* events in this category.
 *
 * You can unbind multiple events by separating types with a comma
 * </b></pre>
 *
 * @example
 * $unbind(el, 'click', function() {...}); // Unbinds spesific function
 *
 * @example
 * $unbind(el, 'click'); // Unbinds all click events
 *
 * @example
 * $unbind(el); // Unbinds all events
 *
 * @see $bind
 *
 * @param   {Node}          el            DOM Element to attach event to
 * @param   {String}        [evName]      DOM Event Name
 * @param   {Function}      [callback]    Callback on event
 * @param   {Boolean}       [useCapture]  Use capture mode
 */
function $unbind(el, evName, callback, useCapture) {

  function unbindNamed(type) {
    if (el._boundEvents) {
      var list = el._boundEvents || {};

      if (list[type]) {
        for (var i = 0; i < list[type].length; i++) {
          var iter = list[type][i];

          // If a callback/handler was applied make sure we remove the correct one
          if (callback && iter.callback !== callback) {
            continue;
          }

          // We stored the event binding earlier
          el.removeEventListener.apply(el, iter.args);

          list[type].splice(i, 1);
          i--;
        }
      }
    }
  }

  function unbindAll() {
    if (el._boundEvents) {
      Object.keys(el._boundEvents).forEach(function (type) {
        unbindNamed(type);
      });
      delete el._boundEvents;
    }
  }

  if (el) {
    if (evName) {
      getEventList(evName).forEach(function (type) {
        unbindNamed(type);
      });
    } else {
      unbindAll();
    }
  }
}

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathFromVirtual = getPathFromVirtual;
exports.getPathProtocol = getPathProtocol;
exports.filename = filename;
exports.filext = filext;
exports.dirname = dirname;
exports.humanFileSize = humanFileSize;
exports.escapeFilename = escapeFilename;
exports.replaceFileExtension = replaceFileExtension;
exports.replaceFilename = replaceFilename;
exports.pathJoin = pathJoin;
exports.getFilenameRange = getFilenameRange;
exports.btoaUrlsafe = btoaUrlsafe;
exports.atobUrlsafe = atobUrlsafe;
exports.btoaUtf = btoaUtf;
exports.atobUtf = atobUtf;
exports.checkAcceptMime = checkAcceptMime;
exports.filterScandir = filterScandir;
exports.addFormFile = addFormFile;
exports.dataSourceToAb = dataSourceToAb;
exports.textToAb = textToAb;
exports.abToDataSource = abToDataSource;
exports.abToText = abToText;
exports.abToBinaryString = abToBinaryString;
exports.abToBlob = abToBlob;
exports.blobToAb = blobToAb;

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/////////////////////////////////////////////////////////////////////////////
// FS
/////////////////////////////////////////////////////////////////////////////

/**
 * Gets the path from a location
 *
 * @param   {String}    str         Path name
 *
 * @return  {String}
 */
function getPathFromVirtual(str) {
  str = str || '';
  var res = str.split(/([A-z0-9\-_]+)\:\/\/(.*)/)[2] || '';
  return res.replace(/^\/?/, '/');
}

/**
 * Gets the protocol from a location
 *
 * @param   {String}    orig        Path name
 *
 * @return  {String}
 */
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

function getPathProtocol(orig) {
  //return orig.replace(/^([A-z0-9\-_]+)\:\/\//, '');
  var tmp = document.createElement('a');
  tmp.href = orig;
  return tmp.protocol.replace(/:$/, '');
}

/**
 * Get filename from path
 *
 * @param   {String}    p     Path
 *
 * @return  {String}          The filename
 */
function filename(p) {
  return (p || '').replace(/\/$/, '').split('/').pop();
}

/**
 * Get file extension of filename/path
 *
 * @param   {String}    d       filename/path
 *
 * @return  {String}            The file extension
 */
function filext(d) {
  var ext = filename(d).split('.').pop();
  return ext ? ext.toLowerCase() : null;
}

/**
 * Get directory from path
 *
 * If you use this on a directory path, you will
 * get the parent
 *
 * @param   {String}    f       filename/path
 *
 * @return  {String}            The resulted path
 */
function dirname(f) {

  function _parentDir(p) {
    var pstr = p.split(/^(.*)\:\/\/(.*)/).filter(function (n) {
      return n !== '';
    });

    var args = pstr.pop();
    var prot = pstr.pop();
    var result = '';

    var tmp = args.split('/').filter(function (n) {
      return n !== '';
    });

    if (tmp.length) {
      tmp.pop();
    }
    result = tmp.join('/');

    if (!result.match(/^\//)) {
      result = '/' + result;
    }

    if (prot) {
      result = prot + '://' + result;
    }

    return result;
  }

  return f.match(/^((.*)\:\/\/)?\/$/) ? f : _parentDir(f.replace(/\/$/, ''));
}

/**
 * Get human-readable size from integer
 *
 * Example return: '128 MB'
 * @link http://stackoverflow.com/users/65387/mark
 *
 * @param   {Number}  bytes     Size in bytes
 * @param   {String}  si        Use SI units ?
 *
 * @return  {String}            Size
 */
function humanFileSize(bytes, si) {
  var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  var thresh = si ? 1000 : 1024;

  if (bytes < thresh) {
    return bytes + ' B';
  }

  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (bytes >= thresh);
  return bytes.toFixed(1) + ' ' + units[u];
}

/**
 * Escape filename (removes invalid characters)
 *
 * @param   {String}    n     Filename
 *
 * @return  {String}          Escaped filename
 */
function escapeFilename(n) {
  return (n || '').replace(/[\|&;\$%@"<>\(\)\+,\*\/]/g, '').trim();
}

/**
 * Replace file extension of filename
 *
 * @param   {String}    filename      The filename
 * @param   {String}    rep           New file extension (without dot)
 *
 * @return  {String}                  New filename
 */
function replaceFileExtension(filename, rep) {
  var spl = filename.split('.');
  spl.pop();
  spl.push(rep);
  return spl.join('.');
}

/**
 * Replace the filename of a path
 *
 * @param   {String}    orig      The full path to file
 * @param   {String}    newname   Replace with this filename
 *
 * @return  {String}              The new path
 */
function replaceFilename(orig, newname) {
  var spl = orig.split('/');
  spl.pop();
  spl.push(newname);
  return spl.join('/');
}

/**
 * Joins arguments to a path (path.join)
 *
 * @param   {...String}   s   Input
 * @return  {String}
 */
function pathJoin() {
  var parts = [];
  var prefix = '';

  function getPart(s) {
    if (s.match(/^([A-z0-9\-_]+)\:\//)) {
      var spl = s.split(/^([A-z0-9\-_]+)\:\//);
      if (!prefix) {
        prefix = spl[1] + '://';
      }
      s = spl[2] || '';
    }

    s = s.replace(/^\/+/, '').replace(/\/+$/, '');

    return s.split('/').filter(function (i) {
      return ['', '.', '..'].indexOf(i) === -1;
    }).join('/');
  }

  for (var i = 0; i < arguments.length; i++) {
    var str = getPart(String(arguments[i]));
    if (str) {
      parts.push(str);
    }
  }

  return prefix + parts.join('/').replace(/^\/?/, '/');
}

/**
 * Gets the range of filename in a path (without extension)
 *
 * This is used for example in text boxes to highlight the filename
 *
 * @param   {String}    val     The path
 *
 * @return  {Object}            Range in form of min/max
 */
function getFilenameRange(val) {
  val = val || '';

  var range = { min: 0, max: val.length };
  if (val.match(/^\./)) {
    if (val.length >= 2) {
      range.min = 1;
    }
  } else {
    if (val.match(/\.(\w+)$/)) {
      var m = val.split(/\.(\w+)$/);
      for (var i = m.length - 1; i >= 0; i--) {
        if (m[i].length) {
          range.max = val.length - m[i].length - 1;
          break;
        }
      }
    }
  }
  return range;
}

/**
 * (Encode) Convert URL-safe String to Base64
 *
 * @param   {String}      str     String
 *
 * @return  {String}              Base64 String
 */
function btoaUrlsafe(str) {
  return !str || !str.length ? '' : btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/**
 * (Decode) Convert Base64 to URL-safe String
 *
 * @param   {String}      str     Base64 String
 *
 * @return  {String}              String
 */
function atobUrlsafe(str) {
  if (str && str.length) {
    str = (str + '===').slice(0, str.length + str.length % 4);
    return atob(str.replace(/-/g, '+').replace(/_/g, '/'));
  }
  return '';
}

/**
 * (Encode) Convert String to Base64 with UTF-8
 *
 * @param   {String}      str     String
 *
 * @return  {String}              Base64 String
 */
function btoaUtf(str) {
  // Encode
  var _unescape = window.unescape || function (s) {
    function d(x, n) {
      return String.fromCharCode(parseInt(n, 16));
    }
    return s.replace(/%([0-9A-F]{2})/i, d);
  };
  str = _unescape(encodeURIComponent(str));
  return btoa(str);
}

/**
 * (Decode) Convert Base64 with UTF-8 to String
 *
 * @param   {String}      str     Base64 String
 *
 * @return  {String}              String
 */
function atobUtf(str) {
  // Decode
  var _escape = window.escape || function (s) {
    function q(c) {
      c = c.charCodeAt();
      return '%' + (c < 16 ? '0' : '') + c.toString(16).toUpperCase();
    }
    return s.replace(/[\x00-),:-?[-^`{-\xFF]/g, q);
  };

  var trans = _escape(atob(str));
  return decodeURIComponent(trans);
}

/**
 * Check if this MIME type is inside list
 * This matches by regex
 *
 * @param   {String}      mime      The mime string
 * @param   {Array}       list      Array of regex matches
 *
 * @return  {Boolean}               If found
 */
function checkAcceptMime(mime, list) {
  if (mime && list.length) {
    var re = void 0;
    for (var i = 0; i < list.length; i++) {
      re = new RegExp(list[i]);
      if (re.test(mime) === true) {
        return true;
      }
    }
  }
  return false;
}

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

/**
 * Filters a scandir() request
 *
 * @param {Array}     list                      List of results from scandir()
 * @param {Object}    options                   Filter options
 * @param {String}    options.typeFilter        `type` filter
 * @param {Array}     options.mimeFilter        `mime` filter
 * @param {Boolean}   options.showHiddenFiles   Show dotfiles
 * @param {String}    [options.sortBy=null]     Sort by this key
 * @param {String}    [options.sortDir='asc']   Sort in this direction
 * @param {Object}    [defaultOptions]          The default options (usually loaded from SettingsManager)
 *
 * @return  {Boolean}
 */
function filterScandir(list, options, defaultOptions) {
  defaultOptions = Utils.cloneObject(defaultOptions || {});

  var ioptions = Utils.cloneObject(options, true);

  var ooptions = Object.assign({}, defaultOptions.scandir || {}, ioptions);
  ooptions = Object.assign({}, {
    sortBy: null,
    sortDir: 'asc',
    typeFilter: null,
    mimeFilter: [],
    showHiddenFiles: true
  }, ooptions);

  function filterFile(iter) {
    if (ooptions.typeFilter && iter.type !== ooptions.typeFilter || !ooptions.showHiddenFiles && iter.filename.match(/^\.\w/)) {
      return false;
    }
    return true;
  }

  function validMime(iter) {
    if (ooptions.mimeFilter && ooptions.mimeFilter.length && iter.mime) {
      return ooptions.mimeFilter.some(function (miter) {
        if (iter.mime.match(miter)) {
          return true;
        }
        return false;
      });
    }
    return true;
  }

  var result = list.filter(function (iter) {
    if (iter.filename === '..' || !filterFile(iter)) {
      return false;
    }

    if (iter.type === 'file' && !validMime(iter)) {
      return false;
    }

    return true;
  }).map(function (iter) {
    if (iter.mime === 'application/vnd.google-apps.folder') {
      iter.type = 'dir';
    }
    return iter;
  });

  var sb = ooptions.sortBy;
  var types = {
    mtime: 'date',
    ctime: 'date'
  };

  if (['filename', 'size', 'mime', 'ctime', 'mtime'].indexOf(sb) !== -1) {
    if (types[sb] === 'date') {
      result.sort(function (a, b) {
        a = new Date(a[sb]);
        b = new Date(b[sb]);
        return a > b ? 1 : b > a ? -1 : 0;
      });
    } else {
      if (sb === 'size' || !String.prototype.localeCompare) {
        result.sort(function (a, b) {
          return a[sb] > b[sb] ? 1 : b[sb] > a[sb] ? -1 : 0;
        });
      } else {
        result.sort(function (a, b) {
          return String(a[sb]).localeCompare(String(b[sb]));
        });
      }
    }

    if (ooptions.sortDir === 'desc') {
      result.reverse();
    }
  }

  return result.filter(function (iter) {
    return iter.type === 'dir';
  }).concat(result.filter(function (iter) {
    return iter.type !== 'dir';
  }));
}

/*
 * Wrapper for converting data
 */
function _abToSomething(m, arrayBuffer, mime, callback) {
  mime = mime || 'application/octet-stream';

  try {
    var blob = new Blob([arrayBuffer], { type: mime });
    var r = new FileReader();
    r.onerror = function (e) {
      callback(e);
    };
    r.onloadend = function () {
      callback(false, r.result);
    };
    r[m](blob);
  } catch (e) {
    console.warn(e, e.stack);
    callback(e);
  }
}

/////////////////////////////////////////////////////////////////////////////
// CONVERSION HELPERS
/////////////////////////////////////////////////////////////////////////////

/**
 * This is a helper to add a File to FormData
 *
 * @param   {FormData}                        fd      FormData instance
 * @param   {String}                          key     FormData entry name
 * @param   {(window.File|window.Blob)}       data    File Data (see supported types)
 * @param   {FileMetadata}                    file    File Metadata
 */
function addFormFile(fd, key, data, file) {
  file = file || { mime: 'application/octet-stream', filename: 'filename' };

  if (data instanceof window.File) {
    fd.append(key, data);
  } else if (data instanceof window.ArrayBuffer) {
    try {
      data = new Blob([data], { type: file.mime });
    } catch (e) {
      data = null;
      console.warn(e, e.stack);
    }

    fd.append(key, data, file.filename);
  } else {
    if (data.data && data.filename) {
      // In case user defines custom
      fd.append(key, data.data, data.filename);
    }
  }
}

/**
 * Convert DataSourceURL to ArrayBuffer
 *
 * @param   {String}        data        The datasource string
 * @param   {String}        mime        The mime type
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function dataSourceToAb(data, mime, callback) {
  var byteString = atob(data.split(',')[1]);
  //const mimeString = data.split(',')[0].split(':')[1].split(';')[0];

  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  callback(false, ab);
}

/**
 * Convert PlainText to ArrayBuffer
 *
 * @param   {String}        data        The plaintext string
 * @param   {String}        mime        The mime type
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function textToAb(data, mime, callback) {
  _abToSomething('readAsArrayBuffer', data, mime, callback);
}

/**
 * Convert ArrayBuffer to DataSourceURL
 *
 * @param   {ArrayBuffer}   arrayBuffer The ArrayBuffer
 * @param   {String}        mime        The mime type
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function abToDataSource(arrayBuffer, mime, callback) {
  _abToSomething('readAsDataURL', arrayBuffer, mime, callback);
}

/**
 * Convert ArrayBuffer to PlainText
 *
 * @param   {ArrayBuffer}   arrayBuffer The ArrayBuffer
 * @param   {String}        mime        The mime type
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function abToText(arrayBuffer, mime, callback) {
  _abToSomething('readAsText', arrayBuffer, mime, callback);
}

/**
 * Convert ArrayBuffer to BinaryString
 *
 * @param   {ArrayBuffer}   arrayBuffer The ArrayBuffer
 * @param   {String}        mime        The mime type
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function abToBinaryString(arrayBuffer, mime, callback) {
  _abToSomething('readAsBinaryString', arrayBuffer, mime, callback);
}

/**
 * Convert ArrayBuffer to Blob
 *
 * @param   {ArrayBuffer}   arrayBuffer The ArrayBuffer
 * @param   {String}        mime        The mime type
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function abToBlob(arrayBuffer, mime, callback) {
  mime = mime || 'application/octet-stream';

  try {
    var blob = new Blob([arrayBuffer], { type: mime });
    callback(false, blob);
  } catch (e) {
    console.warn(e, e.stack);
    callback(e);
  }
}

/**
 * Convert Blob to ArrayBuffer
 *
 * @param   {Blob}          data        The blob
 * @param   {Function}      callback    Callback function => fn(error, result)
 */
function blobToAb(data, callback) {
  try {
    var r = new FileReader();
    r.onerror = function (e) {
      callback(e);
    };
    r.onloadend = function () {
      callback(false, r.result);
    };
    r.readAsArrayBuffer(data);
  } catch (e) {
    console.warn(e, e.stack);
    callback(e);
  }
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _locales = __webpack_require__(10);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REGISTRY = {};

/*
 * Wrapper for getting which element to focus/blur
 */
function getFocusElement(inst) {
  var tagMap = {
    'gui-switch': 'button',
    'gui-list-view': 'textarea',
    'gui-tree-view': 'textarea',
    'gui-icon-view': 'textarea',
    'gui-input-modal': 'button'
  };

  if (tagMap[inst.tagName]) {
    return inst.$element.querySelector(tagMap[inst.tagName]);
  }
  return inst.$element.firstChild || inst.$element;
}

/*
 * Internal for parsing GUI elements
 */
function parseDynamic(node, win, args) {
  args = args || {};

  var translator = args._ || _locales._;

  node.querySelectorAll('*[data-label]').forEach(function (el) {
    var label = translator(el.getAttribute('data-label'));
    el.setAttribute('data-label', label);
  });

  node.querySelectorAll('gui-label, gui-button, gui-list-view-column, gui-select-option, gui-select-list-option').forEach(function (el) {
    if (!el.children.length && !el.getAttribute('data-no-translate')) {
      var lbl = GUI.getValueLabel(el);
      el.appendChild(document.createTextNode(translator(lbl)));
    }
  });

  node.querySelectorAll('gui-button').forEach(function (el) {
    var label = GUI.getValueLabel(el);
    if (label) {
      el.appendChild(document.createTextNode((0, _locales._)(label)));
    }
  });

  node.querySelectorAll('*[data-icon], *[data-stock-icon]').forEach(function (el) {
    var image = GUI.getIcon(el, win);
    el.setAttribute('data-icon', image);
  });

  node.querySelectorAll('*[data-src],*[src]').forEach(function (el) {
    var isNative = el.hasAttribute('src');
    var src = isNative ? el.getAttribute('src') : el.getAttribute('data-src') || '';

    if (win && win._app && !src.match(/^(https?:)?\//)) {
      var source = _packageManager2.default.getPackageResource(win._app, src);
      el.setAttribute(isNative ? 'src' : 'data-src', source);
    }
  });
}

/*
 * Wrapper for creating a new element instance
 */
function createElementInstance(tagName, el, q, buildArgs) {
  tagName = tagName || el.tagName.toLowerCase();

  var instance = void 0;
  if (REGISTRY[tagName]) {
    /*eslint new-cap: 0*/
    instance = new REGISTRY[tagName].component(el, q);
    if (buildArgs) {
      instance.build.apply(instance, buildArgs);
    }
  }

  return instance;
}

/////////////////////////////////////////////////////////////////////////////
// GUI ELEMENT CLASS
/////////////////////////////////////////////////////////////////////////////

/**
 * Base GUIElement Class
 *
 * @desc The Class used for all UI Elements.
 *
 * @link https://manual.os-js.org/packages/scheme/
 */

var GUIElement = function () {

  /**
   * @param {Node}      el      DOM Node
   * @param {String}    [q]     Query that element came from
   */
  function GUIElement(el, q) {
    _classCallCheck(this, GUIElement);

    /**
     * The DOM Node
     * @type {Node}
     */
    this.$element = el || null;

    /**
     * The DOM Tag Name
     * @type {String}
     */
    this.tagName = el ? el.tagName.toLowerCase() : null;

    this.oldDisplay = null;

    if (!el) {
      console.warn('GUIElement() was constructed without a DOM element', q);
    }
  }

  /**
   * Builds the DOM nodes etc
   *
   * @return {GUIElement} The current instance (this)
   */


  _createClass(GUIElement, [{
    key: 'build',
    value: function build() {
      return this;
    }

    /**
     * Removes element from the DOM
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'remove',
    value: function remove() {
      this.$element = DOM.$remove(this.$element);
      return this;
    }

    /**
     * Empties the DOM element
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'empty',
    value: function empty() {
      DOM.$empty(this.$element);
      return this;
    }

    /**
     * Blur (unfocus)
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'blur',
    value: function blur() {
      if (this.$element) {
        var firstChild = getFocusElement(this);
        if (firstChild) {
          firstChild.blur();
        }
      }
      return this;
    }

    /**
     * Focus (focus)
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'focus',
    value: function focus() {
      if (this.$element) {
        var firstChild = getFocusElement(this);
        if (firstChild) {
          firstChild.focus();
        }
      }
      return this;
    }

    /**
     * Show
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'show',
    value: function show() {
      if (this.$element && !this.$element.offsetParent) {
        if (this.$element) {
          this.$element.style.display = this.oldDisplay || '';
        }
      }
      return this;
    }

    /**
     * Hide
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'hide',
    value: function hide() {
      if (this.$element && this.$element.offsetParent) {
        if (!this.oldDisplay) {
          this.oldDisplay = this.$element.style.display;
        }
        this.$element.style.display = 'none';
      }
      return this;
    }

    /**
     * Register Event
     *
     * @example
     * element.on('click', function() {});
     *
     * @param   {String}        evName      Event Name
     * @param   {CallbackEvent} callback    Callback function
     * @param   {Object}        [args]      Binding arguments
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'on',
    value: function on(evName, callback, args) {
      return this;
    }

    /**
     * Register Event with scope
     *
     * <pre><code>
     * This is the same as on() except that you can proxy your callback.
     * Useful for binding UI events directly to a Window.
     * </code></pre>
     *
     * <b><code>
     * The callback produced from the event will the same as original, except
     * **the first parameter is always the GUI element**
     *
     * fn(obj, ev, pos, isTouch)
     * </code></b>
     *
     * @example
     * element.son('click', this, this.onClick);
     *
     * @example
     * MyWindow.prototype.onClick = function(obj, ev, pos, isTouch ) {
     *  // obj = 'element'
     * }
     *
     * @see GUIElement#on
     *
     * @param   {String}        evName      Event Name
     * @param   {Object}        thisArg     Which object instance to bind to
     * @param   {CallbackEvent} callback    Callback function
     * @param   {Object}        [args]      Binding arguments
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'son',
    value: function son(evName, thisArg, callback, args) {
      return this.on(evName, function () {
        /* eslint no-invalid-this: "off" */
        var args = Array.prototype.slice.call(arguments);
        args.unshift(this);
        callback.apply(thisArg, args);
      }, args);
    }

    /**
     * Sets a parameter/property by name
     *
     * @param   {String}    param     Parameter name
     * @param   {*}         value     Parameter value
     * @param   {*}         [arg]     Extra argument ...
     * @param   {*}         [arg2]    Extra argument ...
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'set',
    value: function set(param, value, arg, arg2) {
      if (this.$element) {
        GUI.setProperty(this.$element, param, value, arg, arg2);
      }
      return this;
    }

    /**
     * Get a parameter/property by name
     *
     * @param   {String}    param     Parameter name
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'get',
    value: function get(param) {
      if (this.$element) {
        return GUI.getProperty(this.$element, param);
      }
      return null;
    }

    /**
     * Appends a childNode to this element
     *
     * @param   {(Node|GUIElement)}     el        Element
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'append',
    value: function append(el) {
      if (el instanceof GUIElement) {
        el = el.$element;
      } else if (typeof el === 'string' || typeof el === 'number') {
        el = document.createTextNode(String(el));
      }

      var outer = document.createElement('div');
      outer.appendChild(el);

      this._append(outer);
      outer = null;

      return this;
    }

    /**
     * Appends (and builds) HTML into the node
     *
     * @param   {String}    html        HTML code
     * @param   {Window}    [win]       Reference to the Window
     * @param   {Object}    [args]      List of arguments to send to the parser
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'appendHTML',
    value: function appendHTML(html, win, args) {
      var el = document.createElement('div');
      el.innerHTML = html;

      return this._append(el, win, args);
    }

    /*
     * Internal method for appending a Node
     */

  }, {
    key: '_append',
    value: function _append(el, win, args) {
      if (el instanceof Element) {
        GUIElement.parseNode(win, el, null, args);
      }

      // Move elements over
      while (el.childNodes.length) {
        this.$element.appendChild(el.childNodes[0]);
      }

      el = null;

      return this;
    }

    /**
     * Perform `querySelector`
     *
     * @param     {String}      q             Query
     * @param     {Boolean}     [rui=false]   Return UI Element if possible
     *
     * @return    {(Node|GUIElement)} Depending on arguments
     */

  }, {
    key: 'querySelector',
    value: function querySelector(q, rui) {
      var el = this.$element.querySelector(q);
      if (rui) {
        return GUIElement.createFromNode(el, q);
      }
      return el;
    }

    /**
     * Perform `querySelectorAll`
     *
     * @param     {String}      q             Query
     * @param     {Boolean}     [rui=false]   Return UI Element if possible
     *
     * @return    {GUIElement[]}
     */

  }, {
    key: 'querySelectorAll',
    value: function querySelectorAll(q, rui) {
      var el = this.$element.querySelectorAll(q);
      if (rui) {
        el = el.map(function (i) {
          return GUIElement.createFromNode(i, q);
        });
      }
      return el;
    }

    /**
     * Set or get CSS attributes
     *
     * @param {String}          k     CSS key
     * @param {(String|Number)} v     CSS value
     *
     * @return {GUIElement} The current instance (this)
     */

  }, {
    key: 'css',
    value: function css(k, v) {
      DOM.$css(this.$element, k, v);
      return this;
    }

    /**
     * Get position
     * @return {Object}
     */

  }, {
    key: 'position',
    value: function position() {
      return DOM.$position(this.$element);
    }

    // NOTE: DEPRECATED

  }, {
    key: '_call',
    value: function _call(method, args, thisArg) {
      if (arguments.length < 3) {
        console.warn('Element::_call("methodName") is DEPRECATED, use "instance.methodName()" instead');
      }
      try {
        if (typeof this._call === 'function') {
          return this._call(method, args);
        }
        return this[method](args);
      } catch (e) {
        console.warn(e.stack, e);
      }
      return null;
    }

    // NOTE: DEPRECATED

  }, {
    key: 'fn',
    value: function fn(name, args, thisArg) {
      console.warn('Element::fn("methodName") is DEPRECATED, use "instance.methodName()" instead');
      args = args || [];
      thisArg = thisArg || this;

      return this.fn(name, args, thisArg);
    }

    /////////////////////////////////////////////////////////////////////////////
    // GUI ELEMENT STATIC METHODS
    /////////////////////////////////////////////////////////////////////////////

    /**
     * Creates a new GUI Element into given parent
     *
     * @param   {String}      tagName       OS.js GUI Element name
     * @param   {Object}      params        Parameters
     * @param   {Node}        [parentNode]  Parent Node
     * @param   {Object}      [applyArgs]   New element parameters
     * @param   {Window}      [win]         OS.js Window
     *
     * @return  {GUIElement}
     */

  }], [{
    key: 'createInto',
    value: function createInto(tagName, params, parentNode, applyArgs, win) {
      if (parentNode instanceof GUIElement) {
        parentNode = parentNode.$element;
      }

      var gel = GUIElement.create(tagName, params, applyArgs, win);
      parentNode.appendChild(gel.$element);
      return gel;
    }

    /**
     * Creates a new GUI.Element from Node
     *
     * @param {Element}     el          DOM Element
     * @param {String}      [q]         DOM Element query
     * @param {String}      [tagName]   Custom tag name
     *
     * @return  {GUIElement}
     */

  }, {
    key: 'createFromNode',
    value: function createFromNode(el, q, tagName) {
      if (el) {
        var instance = createElementInstance(null, el, q);
        if (instance) {
          return instance;
        }
      }
      return new GUIElement(el, q);
    }

    /**
     * Creates a new GUI.Element
     *
     * @param   {String}      tagName         OS.js GUI Element name
     * @param   {Object}      params          Parameters
     * @param   {Object}      [applyArgs]     New element parameters
     * @param   {Window}      [win]           OS.js Window
     *
     * @return  {GUIElement}
     */

  }, {
    key: 'create',
    value: function create(tagName, params, applyArgs, win) {
      tagName = tagName || '';
      applyArgs = applyArgs || {};
      params = params || {};

      var el = GUI.createElement(tagName, params);
      return createElementInstance(null, el, null, [applyArgs, win]);
    }

    /**
     * Creates a new GUI.Element instance from Node
     *
     * NOTE: DEPRECATED
     *
     * @param {Element}     el          DOM Element
     * @param {String}      [q]         DOM Element query
     * @param {String}      [tagName]   Custom tag name
     *
     * @return {GUIElement}
     */

  }, {
    key: 'createInstance',
    value: function createInstance(el, q, tagName) {
      console.warn('Element::createInstance() is DEPRECATED, use Element::createFromNode() instead');
      return this.createFromNode(el, q, tagName);
    }

    /**
     * Parses the given HTML node and makes OS.js compatible markup
     *
     * @param   {Window}    win               Reference to the Window
     * @param   {Node}      node              The HTML node to parse
     * @param   {String}    [type=snipplet]   Node type
     * @param   {Object}    [args]            List of arguments to send to the parser
     * @param   {Function}  [onparse]         Method to signal when parsing has started
     * @param   {*}         [id]              The id of the source (for debugging)
     */

  }, {
    key: 'parseNode',
    value: function parseNode(win, node, type, args, onparse, id) {
      onparse = onparse || function () {};
      args = args || {};
      type = type || 'snipplet';

      // Apply a default className to non-containers
      node.querySelectorAll('*').forEach(function (el) {
        var lcase = el.tagName.toLowerCase();
        if (lcase.match(/^gui\-/) && !lcase.match(/(\-container|\-(h|v)box|\-columns?|\-rows?|(status|tool)bar|(button|menu)\-bar|bar\-entry)$/)) {
          DOM.$addClass(el, 'gui-element');
        }
      });

      // Go ahead and parse dynamic elements (like labels)
      parseDynamic(node, win, args);

      // Lastly render elements
      onparse(node);

      Object.keys(REGISTRY).forEach(function (key) {
        node.querySelectorAll(key).forEach(function (pel) {
          if (pel._wasParsed || DOM.$hasClass(pel, 'gui-data-view')) {
            return;
          }

          try {
            createElementInstance(key, pel, null, []);
          } catch (e) {
            console.warn('parseNode()', id, type, win, 'exception');
            console.warn(e, e.stack);
          }
          pel._wasParsed = true;
        });
      });
    }

    /**
     * Register a GUI Element
     *
     * @param {Object}      data                 GUI Element Metadata
     * @param {String}      data.tagName         Node tagName
     * @param {GUIElement}  classRef             An object used as a class
     */

  }, {
    key: 'register',
    value: function register(data, classRef) {
      var name = data.tagName;

      if (REGISTRY[name]) {
        throw new Error('GUI Element "' + name + '" already exists');
      }

      REGISTRY[name] = function () {
        var metadata = Object.assign({}, {
          type: 'element',
          allowedChildren: [],
          allowedParents: []
        }, data);

        if (metadata.parent) {
          delete metadata.parent;
        }

        if (metadata.type === 'input') {
          metadata.allowedChildren = true;
        } else if (metadata.type !== 'container') {
          metadata.allowedChildren = false;
        }

        return {
          metadata: metadata,
          component: classRef
        };
      }();
    }

    /**
     * Get Element from registry
     * @param {String} tagName HTML Tag Name
     * @return {Object}
     */

  }, {
    key: 'getRegisteredElement',
    value: function getRegisteredElement(tagName) {
      return REGISTRY[tagName];
    }
  }]);

  return GUIElement;
}();

exports.default = GUIElement;

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.format = format;
exports.parseurl = parseurl;
exports.urlparams = urlparams;
exports.argumentDefaults = argumentDefaults;
exports.mergeObject = mergeObject;
exports.cloneObject = cloneObject;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/////////////////////////////////////////////////////////////////////////////
// STRING
/////////////////////////////////////////////////////////////////////////////

/**
 * Format a string (almost like sprintf)
 *
 * @link http://stackoverflow.com/a/4673436
 *
 * @param   {String}      format        String format
 * @param   {...String}   s             Insert into format
 *
 * @return  {String}                    The formatted string
 */
function format(format) {
  var args = Array.prototype.slice.call(arguments, 1);
  var sprintfRegex = /\{(\d+)\}/g;

  function sprintf(match, number) {
    return number in args ? args[number] : match;
  }

  return format.replace(sprintfRegex, sprintf);
}

/**
 * Parses url into a dictionary (supports modification)
 *
 * @param     {String}        url       Input URL
 * @param     {Object}        [modify]  Modify URL with these options
 *
 * @return    {Object}                  Object with protocol, host, path
 */
function parseurl(url, modify) {
  modify = modify || {};

  if (!url.match(/^(\w+\:)\/\//)) {
    url = '//' + url;
  }

  var protocol = url.split(/^(\w+\:)?\/\//);

  var splitted = function () {
    var tmp = protocol[2].replace(/^\/\//, '').split('/');
    return {
      proto: (modify.protocol || protocol[1] || window.location.protocol || '').replace(/\:$/, ''),
      host: modify.host || tmp.shift(),
      path: modify.path || '/' + tmp.join('/')
    };
  }();

  function _parts() {
    var parts = [splitted.proto, '://'];

    if (modify.username) {
      var authstr = String(modify.username) + ':' + String(modify.password);
      parts.push(authstr);
      parts.push('@');
    }

    parts.push(splitted.host);
    parts.push(splitted.path);
    return parts.join('');
  }

  return {
    protocol: splitted.proto,
    host: splitted.host,
    path: splitted.path,
    url: _parts()
  };
}

/**
 * Get URL query parameters
 * @link https://gist.github.com/pirate/9298155edda679510723
 * @param {String} search The url to search
 * @param {Boolean} [hash=false] Use hash instead of query
 * @return {String[]}
 */
function urlparams(search, hash) {
  var hashes = search.slice(search.indexOf(hash ? '#' : '?') + 1).split('&');
  return hashes.reduce(function (params, hash) {
    var _hash$split = hash.split('='),
        _hash$split2 = _slicedToArray(_hash$split, 2),
        key = _hash$split2[0],
        val = _hash$split2[1];

    return Object.assign(params, _defineProperty({}, key, decodeURIComponent(val)));
  }, {});
}

/////////////////////////////////////////////////////////////////////////////
// OBJECT HELPERS
/////////////////////////////////////////////////////////////////////////////

/**
 * Wrapper for merging function argument dictionaries
 *
 * @param  {Object}   args      Given function Dictionary
 * @param  {Object}   defaults  Defaults Dictionary
 * @param  {Boolean}  undef     Check with 'undefined'
 * @return {Object}
 */
function argumentDefaults(args, defaults, undef) {
  args = args || {};
  Object.keys(defaults).forEach(function (key) {
    if (typeof defaults[key] === 'boolean' || typeof defaults[key] === 'number') {
      if (typeof args[key] === 'undefined' || args[key] === null) {
        args[key] = defaults[key];
      }
    } else {
      args[key] = args[key] || defaults[key];
    }
  });
  return args;
}

/**
 * Deep-merge to objects
 *
 * @param   {Object}      obj1                    Object to merge to
 * @param   {Object}      obj2                    Object to merge with
 * @param   {Object}      [opts]                  Options
 * @param   {Bollean}     [opts.overwrite=true]   Overwrite existing
 *
 * @return  {Object}                The merged object
 */
function mergeObject(obj1, obj2, opts) {
  opts = opts || {};

  for (var p in obj2) {
    if (obj2.hasOwnProperty(p)) {
      try {
        if (opts.overwrite === false && obj1.hasOwnProperty(p)) {
          continue;
        }

        if (obj2[p].constructor === Object) {
          obj1[p] = mergeObject(obj1[p], obj2[p]);
        } else {
          obj1[p] = obj2[p];
        }
      } catch (e) {
        obj1[p] = obj2[p];
      }
    }
  }
  return obj1;
}

/**
 * Clone a object
 *
 * @param   {Object}      o                     The object to clone
 * @param   {Boolean}     [alternative=false]   Do a programatic deep clone approach
 *
 * @return  {Object}            An identical object
 */
function cloneObject(o, alternative) {
  function _clone(i) {
    if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) !== 'object' || i === null) {
      return i;
    } else if (i instanceof Array) {
      return i.map(_clone);
    }

    var iter = {};
    Object.keys(i).forEach(function (k) {
      iter[k] = _clone(i[k]);
    });
    return iter;
  }

  if (alternative) {
    return _clone(o);
  }

  return JSON.parse(JSON.stringify(o, function (key, value) {
    if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.tagName) {
      return window.undefined;
    }
    return value;
  }));
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _eventHandler = __webpack_require__(122);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _loader = __webpack_require__(187);

var _loader2 = _interopRequireDefault(_loader);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//let _CALL_INDEX = 1;
function progressHandler(ev, onprogress) {
  if (ev.lengthComputable) {
    onprogress(ev, ev.loaded / ev.total);
  } else {
    onprogress(ev, -1);
  }
}

/*
 * Attaches options to a XHR call
 */
function appendRequestOptions(data, options) {
  options = options || {};

  var onprogress = options.onprogress || function () {};
  var ignore = ['onsuccess', 'onerror', 'onprogress', 'oncanceled'];

  Object.keys(options).forEach(function (key) {
    if (ignore.indexOf(key) === -1) {
      data[key] = options[key];
    }
  });

  data.onUploadProgress = function (ev) {
    return progressHandler(ev, onprogress);
  };
  data.onDownloadProgress = function (ev) {
    return progressHandler(ev, onprogress);
  };

  return data;
}

var _instance = void 0;

/**
 * Default Connection Implementation
 *
 * @desc Wrappers for communicating over HTTP, WS and NW
 *
 * @mixes utils/event-handler~EventHandler
 */

var Connection = function () {
  _createClass(Connection, null, [{
    key: 'instance',
    get: function get() {
      return _instance;
    }

    /**
     * Create a new Connection
     */

  }]);

  function Connection() {
    var _this = this;

    _classCallCheck(this, Connection);

    /* eslint consistent-this: "off" */
    if (!_instance) {
      _instance = this;
    }

    /**
     * If browser is offline
     * @type {Boolean}
     */
    this.offline = false;

    this.index = 0;
    this._evHandler = new _eventHandler2.default(name, []);

    this.onlineFn = function () {
      return _this.onOnline();
    };
    this.offlineFn = function () {
      return _this.onOffline();
    };
  }

  /**
   * Initializes the instance
   * @return {Promise<undefined, Error>}
   */


  _createClass(Connection, [{
    key: 'init',
    value: function init() {
      if (typeof navigator.onLine !== 'undefined') {
        window.addEventListener('offline', this.offlineFn);
        window.addEventListener('online', this.onlineFn);
      }

      return _bluebird2.default.resolve();
    }

    /**
     * Destroys the instance
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      window.removeEventListener('offline', this.offlineFn);
      window.removeEventListener('online', this.onlineFn);

      if (this._evHandler) {
        this._evHandler = this._evHandler.destroy();
      }

      _instance = null;
    }

    /**
     * Default method to perform a resolve on a VFS File object.
     *
     * This should return the URL for given resource.
     *
     * @param   {FileMetadata}       item      The File Object
     * @param   {Object}             [options] Options. These are added to the URL
     *
     * @return  {String}
     */

  }, {
    key: 'getVFSPath',
    value: function getVFSPath(item, options) {
      options = options || {};

      var base = (0, _config.getConfig)('Connection.RootURI', '/').replace(/\/?$/, '/');
      var defaultDist = (0, _config.getConfig)('VFS.Dist');
      if (window.location.protocol === 'file:') {
        return item ? base + item.path.substr(defaultDist.length) : base;
      }

      var url = (0, _config.getConfig)('Connection.FSURI', '/');
      if (item) {
        url += '/read';
        options.path = item.path;
      } else {
        url += '/upload';
      }

      if (options) {
        var q = Object.keys(options).map(function (k) {
          return k + '=' + encodeURIComponent(options[k]);
        });

        if (q.length) {
          url += '?' + q.join('&');
        }
      }

      return url;
    }

    /**
     * Get if connection is Online
     *
     * @return {Boolean}
     */

  }, {
    key: 'isOnline',
    value: function isOnline() {
      return !this.offline;
    }

    /**
     * Get if connection is Offline
     *
     * @return {Boolean}
     */

  }, {
    key: 'isOffline',
    value: function isOffline() {
      return this.offline;
    }

    /**
     * Called upon a VFS request completion
     *
     * It is what gets called 'after' a VFS request has taken place
     *
     * @param   {Mountpoint} mount     VFS Module Name
     * @param   {String}     method    VFS Method Name
     * @param   {Object}     args      VFS Method Arguments
     * @param   {*}          response  VFS Response Result
     * @param   {Process}    [appRef]  Application reference
     * @return  {Promise<Boolean, Error>}
     */

  }, {
    key: 'onVFSRequestCompleted',
    value: function onVFSRequestCompleted(mount, method, args, response, appRef) {
      return _bluebird2.default.resolve(true);
    }

    /**
     * When browser goes online
     */

  }, {
    key: 'onOnline',
    value: function onOnline() {
      console.warn('Connection::onOnline()', 'Going online...');
      this.offline = false;

      if (this._evHandler) {
        this._evHandler.emit('online');
      }
    }

    /**
     * When browser goes offline
     *
     * @param {Number} reconnecting Amount retries for connection
     */

  }, {
    key: 'onOffline',
    value: function onOffline(reconnecting) {
      console.warn('Connection::onOffline()', 'Going offline...');

      if (!this.offline && this._evHandler) {
        this._evHandler.emit('offline', [reconnecting]);
      }

      this.offline = true;
    }

    /**
     * Default method to perform a call to the backend (API)
     *
     * Please use the static request() method externally.
     *
     * @param {String}    method      API method name
     * @param {Object}    args        API method arguments
     * @param {Object}    [options]   Options passed on to the connection request method (ex: XHR.ajax)
     *
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'createRequest',
    value: function createRequest(method, args, options) {
      args = args || {};
      options = options || {};

      if (this.offline) {
        return _bluebird2.default.reject(new Error('You are currently off-line and cannot perform this operation!'));
      }

      var _createRequestOptions = this.createRequestOptions(method, args),
          raw = _createRequestOptions.raw,
          requestOptions = _createRequestOptions.requestOptions;

      return new _bluebird2.default(function (resolve, reject) {
        (0, _axios2.default)(appendRequestOptions(requestOptions, options)).then(function (result) {
          return resolve(raw ? result.data : { error: false, result: result.data });
        }).catch(function (error) {
          reject(new Error(error.message || error));
        });
      });
    }

    /**
     * Creates default request options
     *
     * @param {String}    method      API method name
     * @param {Object}    args        API method arguments
     *
     * @return {Object}
     */

  }, {
    key: 'createRequestOptions',
    value: function createRequestOptions(method, args) {
      var realMethod = method.replace(/^FS:/, '');

      var raw = true;
      var requestOptions = {
        responseType: 'json',
        url: (0, _config.getConfig)('Connection.APIURI') + '/' + realMethod,
        method: 'POST',
        data: args
      };

      if (method.match(/^FS:/)) {
        if (realMethod === 'get') {
          requestOptions.responseType = 'arraybuffer';
          requestOptions.url = args.url || this.getVFSPath({ path: args.path });
          requestOptions.method = args.method || 'GET';
          raw = false;
        } else if (realMethod === 'upload') {
          requestOptions.url = this.getVFSPath();
        } else {
          requestOptions.url = (0, _config.getConfig)('Connection.FSURI') + '/' + realMethod;
        }
      }

      return { raw: raw, requestOptions: requestOptions };
    }

    /**
     * Subscribe to a event
     *
     * NOTE: This is only available on WebSocket connections
     *
     * @param   {String}    k       Event name
     * @param   {Function}  func    Callback function
     *
     * @return  {Number}
     *
     * @see EventHandler#on
     */

  }, {
    key: 'subscribe',
    value: function subscribe(k, func) {
      return this._evHandler.on(k, func, this);
    }

    /**
     * Removes an event subscription
     *
     * @param   {String}    k       Event name
     * @param   {Number}    [idx]   The hook index returned from subscribe()
     *
     * @return {Boolean}
     *
     * @see EventHandler#off
     */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe(k, idx) {
      return this._evHandler.off(k, idx);
    }

    /*
     * This is a wrapper for making a request
     *
     * @desc This method performs a request to the server
     *
     * @param {String}   m        Method name
     * @param {Object}   a        Method arguments
     * @param {Object}   options  Request options
     * @return {Promise<Object, Error>}
     */

  }], [{
    key: 'request',
    value: function request(m, a, options) {
      var _this2 = this;

      a = a || {};
      options = options || {};

      if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
        return _bluebird2.default.reject(new TypeError('request() expects an object as options'));
      }

      _loader2.default.create('Connection.request');

      if (typeof options.indicator !== 'undefined') {
        delete options.indicator;
      }

      return new _bluebird2.default(function (resolve, reject) {
        _this2.instance.createRequest(m, a, options).then(function (response) {
          if (response.error) {
            return reject(new Error(response.error));
          }
          return resolve(response.result);
        }).catch(function (err) {
          reject(new Error(err));
        }).finally(function () {
          _loader2.default.destroy('Connection.request');
        });
      });
    }
  }]);

  return Connection;
}();

exports.default = Connection;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _storage = __webpack_require__(118);

var _storage2 = _interopRequireDefault(_storage);

var _settingsFragment = __webpack_require__(410);

var _settingsFragment2 = _interopRequireDefault(_settingsFragment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Settings Manager Class
 *
 * @desc Used for managing Settings across all applications and modules.
 */
var SettingsManager = function () {
  function SettingsManager() {
    _classCallCheck(this, SettingsManager);

    this.storage = {};
    this.defaultSettings = {};
    this.watches = [];
  }

  /**
   * Initialize Settings.
   * This is run when a user logs in. It will give saved data here
   *
   * @param {Object}    settings      Entire settings tree
   * @return {Promise<undefined, Error>}
   */


  _createClass(SettingsManager, [{
    key: 'init',
    value: function init(settings) {
      this.storage = settings || {};

      return _bluebird2.default.resolve();
    }

    /**
     * Gets either the full tree or tree entry by key
     *
     * @param  {String}     pool      Name of settings pool
     * @param  {String}     [key]     Key entry of tree
     *
     * @return  {*}
     */

  }, {
    key: 'get',
    value: function get(pool, key) {
      try {
        if (this.storage[pool] && Object.keys(this.storage[pool]).length) {
          return key ? this.storage[pool][key] : this.storage[pool];
        }

        return key ? this.defaultSettings[pool][key] : this.defaultSettings[pool];
      } catch (e) {
        console.warn('SettingsManager::get()', 'exception', e, e.stack);
      }

      return false;
    }

    /**
     * Sets either full tree or a tree entry by key
     *
     * @param  {String}             pool                  Name of settings pool
     * @param  {String}             [key]                 Key entry of tree
     * @param  {*}                  value                 The value (or entire tree if no key given)
     * @param  {Boolean|Function}   [save]                boolean or callback function for saving
     * @param  {Boolean}    [triggerWatch=true]   trigger change event for watchers
     *
     * @return  {Promise<Boolean, Error>}
     */

  }, {
    key: 'set',
    value: function set(pool, key, value, save, triggerWatch) {
      var promise = _bluebird2.default.resolve(true);

      try {
        if (key) {
          if (typeof this.storage[pool] === 'undefined') {
            this.storage[pool] = {};
          }
          if (['number', 'string'].indexOf(typeof key === 'undefined' ? 'undefined' : _typeof(key)) >= 0) {
            this.storage[pool][key] = value;
          } else {
            console.warn('SettingsManager::set()', 'expects key to be a valid iter, not', key);
          }
        } else {
          this.storage[pool] = value;
        }
      } catch (e) {
        console.warn('SettingsManager::set()', 'exception', e, e.stack);
      }

      if (save) {
        promise = this.save(pool);
        if (typeof save === 'function') {
          console.warn('Using a callback is deprecated, you should use the returned promise');
          promise.then(function (res) {
            return save(false, res);
          }).catch(function (err) {
            return save(err, false);
          });
        }
      }

      if (typeof triggerWatch === 'undefined' || triggerWatch === true) {
        this.changed(pool);
      }

      return promise;
    }

    /**
     * Saves the storage to a location
     *
     * @param  {String}     pool      Name of settings pool
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'save',
    value: function save(pool) {
      var _this = this;

      console.debug('SettingsManager::save()', pool, this.storage);

      var saveableStorage = {};
      Object.keys(this.storage).filter(function (n) {
        return !n.match(/^__/);
      }).forEach(function (n) {
        saveableStorage[n] = _this.storage[n];
      });

      return _storage2.default.instance.saveSettings(pool, saveableStorage);
    }

    /**
     * Sets the defaults for a specific pool
     *
     * @param  {String}     pool       Name of settings pool
     * @param  {Object}     [defaults] Default settings tree
     */

  }, {
    key: 'defaults',
    value: function defaults(pool, _defaults) {
      this.defaultSettings[pool] = _defaults;
    }

    /**
     * Creates a new proxy instance
     *
     * @param  {String}     pool       Name of settings pool
     * @param  {Object}     [defaults] Default settings tree
     *
     * @return {Object}
     */

  }, {
    key: 'instance',
    value: function instance(pool, defaults) {
      if (!this.storage[pool] || this.storage[pool] instanceof Array) {
        this.storage[pool] = {};
      }

      var instance = new _settingsFragment2.default(this.storage[pool], pool, this);
      if (arguments.length > 1) {
        this.defaults(pool, defaults);
        instance.mergeDefaults(defaults);
      }

      return instance;
    }

    /**
     * Destroy a watcher
     *
     * @param  {Number}    index     The index from watch()
     */

  }, {
    key: 'unwatch',
    value: function unwatch(index) {
      if (typeof this.watches[index] !== 'undefined') {
        delete this.watches[index];
      }
    }

    /**
     * Receive events when a pool changes.
     *
     * @param  {String}     pool      Name of settings pool
     * @param  {Function}   callback  Callback
     *
     * @return {Boolean|Number}                false on error, index for unwatch() otherwise
     */

  }, {
    key: 'watch',
    value: function watch(pool, callback) {
      if (!this.storage[pool]) {
        return false;
      }

      var index = this.watches.push({
        pool: pool,
        callback: callback
      });

      return index - 1;
    }

    /**
     * Notify the SettingsManager that somewhere in a pool's tree it has changed.
     *
     * @param  {String}     pool      Name of settings pool that changed
     *
     * @return {SettingsManager}      this
     */

  }, {
    key: 'changed',
    value: function changed(pool) {
      var _this2 = this;

      this.watches.forEach(function (watch) {
        if (watch && watch.pool === pool) {
          watch.callback(_this2.storage[pool]);
        }
      });

      return this;
    }

    /**
     * Clears a pool
     *
     * @param  {String}                pool        Name of settings pool
     * @param  {Boolean|Function}      [save=true] Boolean or callback function for saving
     *
     * @return {SettingsManager}      this
     */

  }, {
    key: 'clear',
    value: function clear(pool, save) {
      save = typeof save === 'undefined' || save === true;
      this.set(pool, null, {}, save);
      return this;
    }
  }]);

  return SettingsManager;
}();

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = new SettingsManager();

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProperty = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                               * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                               * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                               *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                               * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                               *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                               *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                               * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                               * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                               * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                               * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                               * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                               * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                               * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                               * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                               * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * @licence Simplified BSD License
                                                                                                                                                                                                                                                                               */


exports.getWindowId = getWindowId;
exports.getLabel = getLabel;
exports.getValueLabel = getValueLabel;
exports.getViewNodeValue = getViewNodeValue;
exports.getIcon = getIcon;
exports.getProperty = getProperty;
exports.createInputLabel = createInputLabel;
exports.createElement = createElement;
exports.setFlexbox = setFlexbox;
exports.createDrag = createDrag;
exports.getNextElement = getNextElement;
exports.createDraggable = createDraggable;
exports.createDroppable = createDroppable;

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _compability = __webpack_require__(123);

var Compability = _interopRequireWildcard(_compability);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

/**
 * Gets window id from upper parent element
 *
 * @param   {Node}      el      Child element (can be anything)
 *
 * @return  {Number}
 */
function getWindowId(el) {
  while (el.parentNode) {
    var attr = el.getAttribute('data-window-id');
    if (attr !== null) {
      return parseInt(attr, 10);
    }
    el = el.parentNode;
  }
  return null;
}

/**
 * Gets "label" from a node
 *
 * @param   {Node}      el      The element
 *
 * @return  {String}
 */
function getLabel(el) {
  var label = el.getAttribute('data-label');
  return label || '';
}

/**
 * Gets "label" from a node (Where it can be innerHTML and parameter)
 *
 * @param   {Node}      el              The element
 * @param   {Boolean}   [attr=false]    Get from attribute istead of node text
 *
 * @return  {String}
 */
function getValueLabel(el, attr) {
  var label = attr ? el.getAttribute('data-label') : null;

  if (el.childNodes.length && el.childNodes[0].nodeType === 3 && el.childNodes[0].nodeValue) {
    label = el.childNodes[0].nodeValue;
    DOM.$empty(el);
  }

  return label || '';
}

/**
 * Gets "value" from a node
 *
 * @param   {Node}      el       The element
 *
 * @return  {String}
 */
function getViewNodeValue(el) {
  var value = el.getAttribute('data-value');
  if (typeof value === 'string' && value.match(/^\[|\{/)) {
    try {
      value = JSON.parse(value);
    } catch (e) {
      value = null;
    }
  }
  return value;
}

/**
 * Internal for getting
 *
 * @param   {Node}      el      Element
 * @param   {Window}    [win]   Window Reference
 *
 * @return  {String}
 */
function getIcon(el, win) {
  var image = el.getAttribute('data-icon');
  if (image) {
    return win ? _packageManager2.default.getPackageResource(win._app, image) : image;
  }

  image = el.getAttribute('data-stock-icon');

  if (image && image !== 'undefined') {
    var size = '16x16';
    try {
      var spl = image.split('/');
      var tmp = spl.shift();
      var siz = tmp.match(/^\d+x\d+/);
      if (siz) {
        size = siz[0];
        image = spl.join('/');
      }

      image = _theme2.default.getIcon(image, size);
    } catch (e) {}

    return image;
  }

  return null;
}

/**
 * Wrapper for getting custom dom element property value
 *
 * @param   {Node}     el          Element
 * @param   {String}   param       Parameter name
 * @param   {String}   [tagName]   What tagname is in use? Automatic
 *
 * @return  {Object|String}
 */
function getProperty(el, param, tagName) {
  tagName = tagName || el.tagName.toLowerCase();
  var isDataView = tagName.match(/^gui\-(tree|icon|list|file)\-view$/);

  if (param === 'value' && !isDataView) {
    if (['gui-text', 'gui-password', 'gui-textarea', 'gui-slider', 'gui-select', 'gui-select-list'].indexOf(tagName) >= 0) {
      return el.querySelector('input, textarea, select').value;
    }
    if (['gui-checkbox', 'gui-radio', 'gui-switch'].indexOf(tagName) >= 0) {
      return !!el.querySelector('input').checked;
      //return el.querySelector('input').value === 'on';
    }
    return null;
  }

  if ((param === 'value' || param === 'selected') && isDataView) {
    return _element2.default.createFromNode(el).values();
  }

  return el.getAttribute('data-' + param);
}

/**
 * Creates a label for given input element
 *
 * @param   {Node}            el        Element root
 * @param   {String}          type      Input element type
 * @param   {Node}            input     The input element
 * @param   {String}          [label]   Used when updating
 */
function createInputLabel(el, type, input, label) {
  label = label || getLabel(el);

  if (label) {
    var lbl = document.createElement('label');
    var span = document.createElement('span');
    span.appendChild(document.createTextNode(label));

    if (type === 'checkbox' || type === 'radio') {
      lbl.appendChild(input);
      lbl.appendChild(span);
    } else {
      lbl.appendChild(span);
      lbl.appendChild(input);
    }
    el.appendChild(lbl);
  } else {
    el.appendChild(input);
  }
}

/**
 * Wrapper for setting custom dom element property value
 *
 * @param   {Node}            el            Element
 * @param   {String}          param         Parameter name
 * @param   {String}          value         Parameter value
 * @param   {String}          [tagName]     What tagname is in use? Automatic
 */
function setProperty(el, param, _value, tagName) {
  tagName = tagName || el.tagName.toLowerCase();

  function _setKnownAttribute(i, k, v, a) {
    if (v) {
      i.setAttribute(k, k);
    } else {
      i.removeAttribute(k);
    }

    if (a) {
      el.setAttribute('aria-' + k, String(_value === true));
    }
  }

  function _setValueAttribute(i, k, v) {
    if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
      try {
        v = JSON.stringify(_value);
      } catch (e) {}
    }

    i.setAttribute(k, String(v));
  }

  // Generics for input elements
  var inner = el.children[0];

  var accept = ['gui-slider', 'gui-text', 'gui-password', 'gui-textarea', 'gui-checkbox', 'gui-radio', 'gui-select', 'gui-select-list', 'gui-button'];

  (function () {
    var firstChild = void 0;

    var params = {
      readonly: function readonly() {
        _setKnownAttribute(firstChild, 'readonly', _value, true);
      },

      disabled: function disabled() {
        _setKnownAttribute(firstChild, 'disabled', _value, true);
      },

      value: function value() {
        if (tagName === 'gui-radio' || tagName === 'gui-checkbox') {
          _setKnownAttribute(firstChild, 'checked', _value);

          firstChild.checked = !!_value;
        }
        firstChild.value = _value;
      },

      label: function label() {
        el.appendChild(firstChild);
        DOM.$remove(el.querySelector('label'));
        createInputLabel(el, tagName.replace(/^gui\-/, ''), firstChild, _value);
      }
    };

    if (accept.indexOf(tagName) >= 0) {
      firstChild = el.querySelector('textarea, input, select, button');

      if (firstChild) {
        if (params[param]) {
          params[param]();
        } else {
          _setValueAttribute(firstChild, param, _value || '');
        }
      }
    }
  })();

  // Other types of elements
  accept = ['gui-image', 'gui-audio', 'gui-video'];
  if (['src', 'controls', 'autoplay', 'alt'].indexOf(param) >= 0 && accept.indexOf(tagName) >= 0) {
    inner[param] = _value;
  }

  // Normal DOM attributes
  if (['_id', '_class', '_style'].indexOf(param) >= 0) {
    inner.setAttribute(param.replace(/^_/, ''), _value);
    return;
  }

  // Set the actual root element property value
  if (param !== 'value') {
    _setValueAttribute(el, 'data-' + param, _value);
  }
}

/**
 * Create a new custom DOM element
 *
 * @param   {String}      tagName           Tag Name
 * @param   {Object}      params            Dict with data-* properties
 * @param   {Array}       [ignoreParams]    List of arguments to ignore
 *
 * @return {Node}
 */
exports.setProperty = setProperty;
function createElement(tagName, params, ignoreParams) {
  ignoreParams = ignoreParams || [];

  var el = document.createElement(tagName);

  var classMap = {
    textalign: function textalign(v) {
      DOM.$addClass(el, 'gui-align-' + v);
    },
    className: function className(v) {
      DOM.$addClass(el, v);
    }
  };

  function getValue(k, value) {
    if (typeof value === 'boolean') {
      value = value ? 'true' : 'false';
    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      try {
        value = JSON.stringify(value);
      } catch (e) {}
    }

    return value;
  }

  if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    Object.keys(params).forEach(function (k) {
      if (ignoreParams.indexOf(k) >= 0) {
        return;
      }

      var value = params[k];
      if (typeof value !== 'undefined' && typeof value !== 'function') {
        if (classMap[k]) {
          classMap[k](value);
          return;
        }

        var fvalue = getValue(k, value);
        el.setAttribute('data-' + k, fvalue);
      }
    });
  }

  return el;
}

/**
 * Sets the flexbox CSS style properties for given container
 *
 * @param   {Node}            el              The container
 * @param   {Number}          grow            Grow factor
 * @param   {Number}          shrink          Shrink factor
 * @param   {String}          [basis=auto]    Basis
 * @param   {Node}            [checkel]       Take defaults from this node
 */
function setFlexbox(el, grow, shrink, basis, checkel) {
  checkel = checkel || el;
  (function () {
    if (typeof basis === 'undefined' || basis === null) {
      basis = checkel.getAttribute('data-basis') || 'auto';
    }
  })();

  (function () {
    if (typeof grow === 'undefined' || grow === null) {
      grow = checkel.getAttribute('data-grow') || 0;
    }
  })();

  (function () {
    if (typeof shrink === 'undefined' || shrink === null) {
      shrink = checkel.getAttribute('data-shrink') || 0;
    }
  })();

  var flex = [grow, shrink];
  if (basis.length) {
    flex.push(basis);
  }

  var style = flex.join(' ');
  el.style.webkitBoxFlex = style;
  el.style.mozBoxFlex = style;
  el.style.webkitFlex = style;
  el.style.mozFlex = style;
  el.style.msFlex = style;
  el.style.oFlex = style;
  el.style.flex = style;

  var align = el.getAttribute('data-align');
  DOM.$removeClass(el, 'gui-flex-align-start');
  DOM.$removeClass(el, 'gui-flex-align-end');
  if (align) {
    DOM.$addClass(el, 'gui-flex-align-' + align);
  }
}

/**
 * Wrapper for creating a draggable container
 *
 * @param   {Node}              el          The container
 * @param   {Function}          onDown      On down action callback
 * @param   {Function}          onMove      On move action callback
 * @param   {Function}          onUp        On up action callback
 */
function createDrag(el, onDown, onMove, onUp) {
  onDown = onDown || function () {};
  onMove = onMove || function () {};
  onUp = onUp || function () {};

  var startX = void 0,
      startY = void 0,
      currentX = void 0,
      currentY = void 0;
  var dragging = false;

  function _onMouseMove(ev, pos, touchDevice) {
    ev.preventDefault();

    if (dragging) {
      currentX = pos.x;
      currentY = pos.y;

      var diffX = currentX - startX;
      var diffY = currentY - startY;

      onMove(ev, { x: diffX, y: diffY }, { x: currentX, y: currentY });
    }
  }

  function _onMouseUp(ev, pos, touchDevice) {
    onUp(ev, { x: currentX, y: currentY });
    dragging = false;

    Events.$unbind(window, 'pointerup:guidrag');
    Events.$unbind(window, 'pointermove:guidrag');
  }

  function _onMouseDown(ev, pos, touchDevice) {
    ev.preventDefault();

    startX = pos.x;
    startY = pos.y;

    onDown(ev, { x: startX, y: startY });
    dragging = true;

    Events.$bind(window, 'pointerup:guidrag', _onMouseUp, false);
    Events.$bind(window, 'pointermove:guidrag', _onMouseMove, false);
  }

  Events.$bind(el, 'pointerdown', _onMouseDown, false);
}

/**
 * Method for getting the next (or previous) element in sequence
 *
 * If you don't supply a current element, the first one will be taken!
 *
 * @param   {Boolean}     prev        Get previous element instead of next
 * @param   {Node}        current     The current element
 * @param   {Node}        root        The root container
 *
 * @return {Node}
 */
function getNextElement(prev, current, root) {
  function getElements() {
    var ignore_roles = ['menu', 'menuitem', 'grid', 'gridcell', 'listitem'];
    var list = [];

    root.querySelectorAll('.gui-element').forEach(function (e) {
      // Ignore focused and disabled elements, and certain aria roles
      if (DOM.$hasClass(e, 'gui-focus-element') || ignore_roles.indexOf(e.getAttribute('role')) >= 0 || e.getAttribute('data-disabled') === 'true') {
        return;
      }

      // Elements without offsetParent are invisible
      if (e.offsetParent) {
        list.push(e);
      }
    });
    return list;
  }

  function getCurrentIndex(els, m) {
    var found = -1;

    // Simply get index from array, it seems indexOf is a bit iffy here ?!
    if (m) {
      els.every(function (e, idx) {
        if (e === m) {
          found = idx;
        }
        return found === -1;
      });
    }

    return found;
  }

  function getCurrentParent(els, m) {
    if (m) {
      var cur = m;
      while (cur.parentNode) {
        if (DOM.$hasClass(cur, 'gui-element')) {
          return cur;
        }
        cur = cur.parentNode;
      }

      return null;
    }

    // When we dont have a initial element, take the first one
    return els[0];
  }

  function getNextIndex(els, p, i) {
    // This could probably be prettier, but it does the job
    if (prev) {
      i = i <= 0 ? els.length - 1 : i - 1;
    } else {
      i = i >= els.length - 1 ? 0 : i + 1;
    }
    return i;
  }

  function getNext(els, i) {
    var next = els[i];

    // Get "real" elements from input wrappers
    if (next.tagName.match(/^GUI\-(BUTTON|TEXT|PASSWORD|SWITCH|CHECKBOX|RADIO|SELECT)/)) {
      next = next.querySelectorAll('input, textarea, button, select')[0];
    }

    // Special case for elements that wraps
    if (next.tagName === 'GUI-FILE-VIEW') {
      next = next.children[0];
    }

    return next;
  }

  if (root) {
    var elements = getElements();
    if (elements.length) {
      var currentParent = getCurrentParent(elements, current);
      var currentIndex = getCurrentIndex(elements, currentParent);

      if (currentIndex >= 0) {
        var nextIndex = getNextIndex(elements, currentParent, currentIndex);
        return getNext(elements, nextIndex);
      }
    }
  }

  return null;
}

/**
 * Create a draggable DOM element
 *
 * @param  {Node}          el                               DOMElement
 * @param  {Object}        args                             JSON of draggable params
 * @param  {Object}        args.data                        The data (JSON by default)
 * @param  {String}        [args.type]                      A custom drag event 'type'
 * @param  {String}        [args.effect=move]               The draggable effect (cursor)
 * @param  {String}        [args.mime=application/json]     The mime type of content
 * @param  {Function}      args.onStart                     Callback when drag started => fn(ev, el, args)
 * @param  {Function}      args.onEnd                       Callback when drag ended => fn(ev, el, args)
 */
function createDraggable(el, args) {
  /* eslint no-invalid-this: "off" */

  args = Object.assign({}, {
    type: null,
    effect: 'move',
    data: null,
    mime: 'application/json',
    dragImage: null,
    onStart: function onStart() {
      return true;
    },
    onEnd: function onEnd() {
      return true;
    }
  }, args);

  if (Compability.isIE()) {
    args.mime = 'text';
  }

  function _toString(mime) {
    return JSON.stringify({
      type: args.type,
      effect: args.effect,
      data: args.data,
      mime: args.mime
    });
  }

  function _dragStart(ev) {
    try {
      ev.dataTransfer.effectAllowed = args.effect;
      if (args.dragImage && typeof args.dragImage === 'function') {
        if (ev.dataTransfer.setDragImage) {
          var dragImage = args.dragImage(ev, el);
          if (dragImage) {
            var dragEl = dragImage.element;
            var dragPos = dragImage.offset;

            document.body.appendChild(dragEl);
            ev.dataTransfer.setDragImage(dragEl, dragPos.x, dragPos.y);
          }
        }
      }
      ev.dataTransfer.setData(args.mime, _toString(args.mime));
    } catch (e) {
      console.warn('Failed to dragstart: ' + e);
      console.warn(e.stack);
    }
  }

  el.setAttribute('draggable', 'true');
  el.setAttribute('aria-grabbed', 'false');

  Events.$bind(el, 'dragstart', function (ev) {
    this.setAttribute('aria-grabbed', 'true');

    this.style.opacity = '0.4';
    if (ev.dataTransfer) {
      _dragStart(ev);
    }
    return args.onStart(ev, this, args);
  }, false);

  Events.$bind(el, 'dragend', function (ev) {
    this.setAttribute('aria-grabbed', 'false');
    this.style.opacity = '1.0';
    return args.onEnd(ev, this, args);
  }, false);
}

/**
 * Create a droppable DOM element
 *
 * @param   {Node}            el                              DOMElement
 * @param   {Object}          args                            JSON of droppable params
 * @param   {String}          [args.accept]                   Accept given drag event 'type'
 * @param   {String}          [args.effect=move]              The draggable effect (cursor)
 * @param   {String}          [args.mime=application/json]    The mime type of content
 * @param   {Boolean}         [args.files=true]               Support file drops from OS
 * @param   {Function}        args.onEnter                    Callback when drag entered => fn(ev, el)
 * @param   {Function}        args.onOver                     Callback when drag over => fn(ev, el)
 * @param   {Function}        args.onLeave                    Callback when drag leave => fn(ev, el)
 * @param   {Function}        args.onDrop                     Callback when drag drop all => fn(ev, el)
 * @param   {Function}        args.onFilesDropped             Callback when drag drop file => fn(ev, el, files, args)
 * @param   {Function}        args.onItemDropped              Callback when drag drop internal object => fn(ev, el, item, args)
 */
function createDroppable(el, args) {
  /* eslint no-invalid-this: "off" */

  args = Object.assign({}, {
    accept: null,
    effect: 'move',
    mime: 'application/json',
    files: true,
    onFilesDropped: function onFilesDropped() {
      return true;
    },
    onItemDropped: function onItemDropped() {
      return true;
    },
    onEnter: function onEnter() {
      return true;
    },
    onOver: function onOver() {
      return true;
    },
    onLeave: function onLeave() {
      return true;
    },
    onDrop: function onDrop() {
      return true;
    }
  }, args);

  if (Compability.isIE()) {
    args.mime = 'text';
  }

  function getParent(start, matcher) {
    if (start === matcher) {
      return true;
    }

    var i = 10;

    while (start && i > 0) {
      if (start === matcher) {
        return true;
      }
      start = start.parentNode;
      i--;
    }
    return false;
  }

  function _doDrop(ev, el) {
    if (!ev.dataTransfer) {
      return true;
    }

    if (args.files) {
      var files = ev.dataTransfer.files;
      if (files && files.length) {
        return args.onFilesDropped(ev, el, files, args);
      }
    }

    try {
      var data = ev.dataTransfer.getData(args.mime);
      var item = JSON.parse(data);
      if (args.accept === null || args.accept === item.type) {
        return args.onItemDropped(ev, el, item, args);
      }
    } catch (e) {
      console.warn('Failed to drop: ' + e);
    }

    return false;
  }

  function _onDrop(ev, el) {
    ev.stopPropagation();
    ev.preventDefault();

    var result = _doDrop(ev, el);
    args.onDrop(ev, el);
    return result;
  }

  el.setAttribute('aria-dropeffect', args.effect);

  Events.$bind(el, 'drop', function (ev) {
    //DOM.$removeClass(el, 'onDragEnter');
    return _onDrop(ev, this);
  }, false);

  Events.$bind(el, 'dragenter', function (ev) {
    //DOM.$addClass(el, 'onDragEnter');
    return args.onEnter.call(this, ev, this, args);
  }, false);

  Events.$bind(el, 'dragover', function (ev) {
    ev.preventDefault();
    if (!getParent(ev.target, el)) {
      return false;
    }

    ev.stopPropagation();
    ev.dataTransfer.dropEffect = args.effect;
    return args.onOver.call(this, ev, this, args);
  }, false);

  Events.$bind(el, 'dragleave', function (ev) {
    //DOM.$removeClass(el, 'onDragEnter');
    return args.onLeave.call(this, ev, this, args);
  }, false);
}

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _config = __webpack_require__(15);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _compability = __webpack_require__(123);

var Compability = _interopRequireWildcard(_compability);

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _fs2 = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Theme resource handling
 */
var Theme = function () {
  function Theme() {
    _classCallCheck(this, Theme);

    var compability = Compability.getCompability();

    this.settings = null;
    this.$themeScript = null;
    this.audioAvailable = !!compability.audio;
    this.oggAvailable = !!compability.audioTypes.ogg;
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      this.settings = _settingsManager2.default.instance('__theme__', {
        enableSounds: true,
        styleTheme: 'default',
        soundTheme: 'default',
        iconTheme: 'default',
        sounds: {}
      });
    }
  }, {
    key: 'update',
    value: function update(settings, settheme) {
      this.settings.set(null, settings);
      if (settheme) {
        this.setTheme(settings);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.$themeScript = DOM.$remove(this.$themeScript);
    }

    /**
     * Perform an action on current theme
     * @param {String} action Method name
     * @param {Array} args Method arumentgs
     * @return {*}
     */

  }, {
    key: 'themeAction',
    value: function themeAction(action, args) {
      var theme = this.getStyleTheme();
      args = args || [];

      try {
        if (OSjs.Themes[theme]) {
          return OSjs.Themes[theme][action].apply(null, args);
        }
      } catch (e) {
        console.warn(e);
      }

      return null;
    }

    /**
     * Set the background
     * @param {Object} settings Settings
     */

  }, {
    key: '_setBackground',
    value: function _setBackground(settings) {
      var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      var typeMap = {
        'image': 'normal',
        'image-center': 'center',
        'image-fill': 'fill',
        'image-strech': 'strech'
      };

      var className = 'color';
      var back = 'none';
      if (settings.wallpaper && settings.background.match(/^image/)) {
        back = settings.wallpaper;
        className = typeMap[settings.background] || 'default';
      }

      if (back !== 'none') {
        try {
          VFS.url(back).then(function (result) {
            back = 'url(\'' + result + '\')';
            document.body.style.backgroundImage = back;
            return true;
          });
        } catch (e) {
          console.warn(e);
        }
      } else {
        document.body.style.backgroundImage = back;
      }

      if (settings.backgroundColor) {
        document.body.style.backgroundColor = settings.backgroundColor;
      }

      if (settings.fontFamily) {
        document.body.style.fontFamily = settings.fontFamily;
      }

      if (isFirefox) {
        document.body.style.backgroundAttachment = 'fixed';
      } else {
        document.body.style.backgroundAttachment = 'scroll';
      }

      document.body.setAttribute('data-background-style', className);
    }
  }, {
    key: 'getThemeCSS',
    value: function getThemeCSS(name) {
      var root = (0, _config.getConfig)('Connection.RootURI', '/');
      if (name === null) {
        return root + 'blank.css';
      }

      root = (0, _config.getConfig)('Connection.ThemeURI');
      return root + '/' + name + '.css';
    }

    /**
     * Set theme
     * @param {Object} settings Settings
     */

  }, {
    key: 'setTheme',
    value: function setTheme(settings) {
      this.themeAction('destroy');

      this.setThemeScript(this.getThemeResource('theme.js'));

      document.body.setAttribute('data-style-theme', settings.styleTheme);
      document.body.setAttribute('data-icon-theme', settings.iconTheme);
      document.body.setAttribute('data-sound-theme', settings.soundTheme);
      document.body.setAttribute('data-animations', String(settings.animations));

      this._setBackground(settings);

      this.settings.set(null, settings);
    }

    /**
     * Set theme script
     * @param {String} src Source file
     */

  }, {
    key: 'setThemeScript',
    value: function setThemeScript(src) {
      var _this = this;

      if (this.$themeScript) {
        this.$themeScript = DOM.$remove(this.$themeScript);
      }

      if (src) {
        this.$themeScript = DOM.$createJS(src, null, function () {
          _this.themeAction('init');
        });
      }
    }

    /**
     * Gets current Style theme
     *
     * @param   {Boolean}    returnMetadata      Return theme metadata instead of name
     * @param   {Boolean}    [convert=false]     Converts the measures into px
     *
     * @return  {String}                      Or JSON
     */

  }, {
    key: 'getStyleTheme',
    value: function getStyleTheme(returnMetadata, convert) {
      var name = this.settings.get('styleTheme') || null;
      if (returnMetadata) {
        var found = null;
        if (name) {
          this.getStyleThemes().forEach(function (t) {
            if (t && t.name === name) {
              found = t;
            }
          });
        }

        // FIXME: Optimize
        if (found && convert === true) {
          var tmpEl = document.createElement('div');
          tmpEl.style.visibility = 'hidden';
          tmpEl.style.position = 'fixed';
          tmpEl.style.top = '-10000px';
          tmpEl.style.left = '-10000px';
          tmpEl.style.width = '1em';
          tmpEl.style.height = '1em';

          document.body.appendChild(tmpEl);
          var wd = tmpEl.offsetWidth;
          tmpEl.parentNode.removeChild(tmpEl);

          if (typeof found.style.window.margin === 'string' && found.style.window.margin.match(/em$/)) {
            var marginf = parseFloat(found.style.window.margin);
            found.style.window.margin = marginf * wd;
          }

          if (typeof found.style.window.border === 'string' && found.style.window.border.match(/em$/)) {
            var borderf = parseFloat(found.style.window.border);
            found.style.window.border = borderf * wd;
          }
        }

        return found;
      }

      return name;
    }

    /**
     * Default method for getting a resource from current theme
     *
     * @param   {String}    name    Resource filename
     * @param   {String}    type    Type ('base' or a sub-folder)
     *
     * @return  {String}            The absolute URL to the resource
     */

  }, {
    key: 'getThemeResource',
    value: function getThemeResource(name, type) {
      name = name || null;
      type = type || null;

      var root = (0, _config.getConfig)('Connection.ThemeURI');

      function getName(str, theme) {
        if (!str.match(/^\//)) {
          if (type === 'base' || type === null) {
            str = root + '/' + theme + '/' + str;
          } else {
            str = root + '/' + theme + '/' + type + '/' + str;
          }
        }
        return str;
      }

      if (name) {
        var theme = this.getStyleTheme();
        name = getName(name, theme);
      }

      return name;
    }

    /**
     * Default method for getting a sound from theme
     *
     * @param   {String}    name    Resource filename
     *
     * @return  {String}            The absolute URL to the resource
     */

  }, {
    key: 'getSound',
    value: function getSound(name) {
      name = name || null;
      if (name && !name.match(/^(https?:)?\//)) {
        var theme = this.getSoundTheme();
        var root = (0, _config.getConfig)('Connection.SoundURI');
        var ext = this.oggAvailable ? 'oga' : 'mp3';

        name = root + '/' + theme + '/' + name + '.' + ext;
      }

      return name;
    }

    /**
     * Global function for playing a sound
     *
     * @param   {String}      name      Sound name
     * @param   {Number}      volume    Sound volume (0.0 - 1.0)
     *
     * @return {Audio}
     */

  }, {
    key: 'playSound',
    value: function playSound(name, volume) {
      var filename = this.getSoundFilename(name);
      if (!filename) {
        console.debug('playSound()', 'Cannot play sound, no compability or not enabled!');
        return null;
      }

      if (typeof volume === 'undefined') {
        volume = 1.0;
      }

      var f = this.getSound(filename);
      console.debug('playSound()', name, filename, f, volume);

      var a = new Audio(f);
      a.volume = volume;
      a.play();
      return a;
    }

    /**
     * Default method for getting a icon from theme
     *
     * @param   {String}    name          Resource filename
     * @param   {String}    [size=16x16]  Icon size
     *
     * @return  {String}            The absolute URL to the resource
     */

  }, {
    key: 'getIcon',
    value: function getIcon(name, size) {
      name = name || '';
      size = size || '16x16';

      if (!name.match(/^(https:?)?\//)) {
        var root = (0, _config.getConfig)('Connection.IconURI');
        var theme = this.getIconTheme();

        name = root + '/' + theme + '/' + size + '/' + name;
      }

      return name;
    }

    /**
     * Get a icon based in file and mime
     *
     * @param   {File}      file            File Data (see supported types)
     * @param   {String}    [size=16x16]    Icon size
     * @param   {String}    [icon]          Default icon
     *
     * @return  {String}            The absolute URL to the icon
     */

  }, {
    key: 'getFileIcon',
    value: function getFileIcon(file, size, icon) {
      icon = icon || 'mimetypes/text-x-preview.png';

      if ((typeof file === 'undefined' ? 'undefined' : _typeof(file)) === 'object' && !(file instanceof _file2.default)) {
        file = new _file2.default(file);
      }

      if (!file.filename) {
        throw new Error('Filename is required for getFileIcon()');
      }

      var map = [{ match: 'application/pdf', icon: 'mimetypes/x-office-document.png' }, { match: 'application/zip', icon: 'mimetypes/package-x-generic.png' }, { match: 'application/x-python', icon: 'mimetypes/text-x-script.png' }, { match: 'application/x-lua', icon: 'mimetypes/text-x-script.png' }, { match: 'application/javascript', icon: 'mimetypes/text-x-script.png' }, { match: 'text/html', icon: 'mimetypes/text-html.png' }, { match: 'text/xml', icon: 'mimetypes/text-html.png' }, { match: 'text/css', icon: 'mimetypes/text-x-script.png' }, { match: 'osjs/document', icon: 'mimetypes/x-office-document.png' }, { match: 'osjs/draw', icon: 'mimetypes/image-x-generic.png' }, { match: /^text\//, icon: 'mimetypes/text-x-generic.png' }, { match: /^audio\//, icon: 'mimetypes/audio-x-generic.png' }, { match: /^video\//, icon: 'mimetypes/video-x-generic.png' }, { match: /^image\//, icon: 'mimetypes/image-x-generic.png' }, { match: /^application\//, icon: 'mimetypes/application-x-executable.png' }];

      if (file.type === 'dir') {
        icon = 'places/folder.png';
      } else if (file.type === 'trash') {
        icon = 'places/user-trash.png';
      } else if (file.type === 'application') {
        var appname = FS.filename(file.path);
        var meta = _packageManager2.default.getPackage(appname);

        if (meta) {
          if (!meta.icon.match(/^((https?:)|\.)?\//)) {
            return this.getIcon(meta.icon, size);
          }
          return _packageManager2.default.getPackageResource(appname, meta.icon);
        }
      } else {
        var mime = file.mime || 'application/octet-stream';

        map.every(function (iter) {
          var match = false;
          if (typeof iter.match === 'string') {
            match = mime === iter.match;
          } else {
            match = mime.match(iter.match);
          }

          if (match) {
            icon = iter.icon;
            return false;
          }

          return true;
        });
      }

      return this.getIcon(icon, size);
    }

    /**
     * Gets current icon theme
     * @return {String}
     */

  }, {
    key: 'getIconTheme',
    value: function getIconTheme() {
      return this.settings.get('iconTheme', 'default');
    }

    /**
     * Gets current sound theme
     * @return {String}
     */

  }, {
    key: 'getSoundTheme',
    value: function getSoundTheme() {
      return this.settings.get('soundTheme', 'default');
    }

    /**
     * Gets sound filename from key
     *
     * @param  {String}     k       Sound name key
     *
     * @return  {String}
     */

  }, {
    key: 'getSoundFilename',
    value: function getSoundFilename(k) {
      if (!this.audioAvailable || !this.settings.get('enableSounds') || !k) {
        return false;
      }

      var sounds = this.settings.get('sounds', {});
      return sounds[k] || null;
    }

    /**
     * Gets a list of Style themes
     *
     * @return  {String[]}   The list of themes
     */

  }, {
    key: 'getStyleThemes',
    value: function getStyleThemes() {
      return (0, _config.getConfig)('Styles', []);
    }

    /**
     * Gets a list of Sound themes
     *
     * @return  {String[]}   The list of themes
     */

  }, {
    key: 'getSoundThemes',
    value: function getSoundThemes() {
      return (0, _config.getConfig)('Sounds', []);
    }

    /**
     * Gets a list of Icon themes
     *
     * @return  {String[]}   The list of themes
     */

  }, {
    key: 'getIconThemes',
    value: function getIconThemes() {
      return (0, _config.getConfig)('Icons', []);
    }
  }]);

  return Theme;
}();

exports.default = new Theme();

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

// TODO: Could use a cleanup after 2.1

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _authenticator = __webpack_require__(119);

var _authenticator2 = _interopRequireDefault(_authenticator);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _misc = __webpack_require__(52);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

var _fs2 = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs2);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var resolvePreloads = function resolvePreloads(metadata, pm) {
  var packageURI = (0, _config.getConfig)('Connection.PackageURI');

  var mapIter = function mapIter(s) {
    return typeof s === 'string' ? { src: s } : s;
  };

  var additions = [];
  var list = (metadata.preload || []).slice(0).map(mapIter);

  // If this package depends on another package, make sure
  // to load the resources for the related one as well
  if (metadata.depends instanceof Array) {
    metadata.depends.forEach(function (k) {
      if (!OSjs.Applications[k]) {
        var pkg = pm.getPackage(k);
        if (pkg) {
          console.info('Using dependency', k);
          additions = additions.concat(pkg.preload.map(mapIter));
        }
      }
    });
  }

  // ... same goes for packages that uses this package
  // as a dependency.
  var pkgs = pm.getPackages(false);
  Object.keys(pkgs).forEach(function (pn) {
    var p = pkgs[pn];
    if (p.type === 'extension' && p.uses === name) {
      if (p) {
        console.info('Using extension', pn);
        additions = additions.concat(p.preload.map(mapIter));
      }
    }
  });

  return additions.concat(list).map(function (p) {
    if (!p.src.match(/^(\/|https?|ftp)/)) {
      if (metadata.scope === 'user') {
        // For user packages, make sure to load the correct URL
        VFS.url(FS.pathJoin(metadata.path, p.src)).then(function (url) {
          p.src = url;
          return true;
        });
      } else {
        p.src = FS.pathJoin(packageURI, metadata.path, p.src);
      }
    }

    return p;
  });
};

/////////////////////////////////////////////////////////////////////////////
// PACKAGE MANAGER
/////////////////////////////////////////////////////////////////////////////

var PackageManager = function () {
  function PackageManager() {
    _classCallCheck(this, PackageManager);

    this.packages = {};
    this.blacklist = [];
  }

  _createClass(PackageManager, [{
    key: 'destroy',
    value: function destroy() {
      this.packages = {};
      this.blacklist = [];
    }

    /**
     * Initializes Package Manager
     * @param {Object} [metadata] An initial set of packages
     * @param {Boolean} [isStandalone] If we're in standalone mode
     * @return {Promise<undefined, Error>}
     */

  }, {
    key: 'init',
    value: function init(metadata, isStandalone) {
      var _this = this;

      console.debug('PackageManager::load()', metadata);

      return new _bluebird2.default(function (resolve, reject) {
        var setPackages = metadata ? _this.setPackages(metadata) : _bluebird2.default.resolve();

        setPackages.then(function () {
          if (isStandalone) {
            return resolve(true);
          }

          return _this._loadMetadata().then(function () {
            var len = Object.keys(_this.packages).length;
            if (len) {
              return resolve(true);
            }
            return reject(new Error((0, _locales._)('ERR_PACKAGE_ENUM_FAILED')));
          }).catch(reject);
        }).catch(reject);
      });
    }

    /**
     * Internal method for loading all package metadata
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: '_loadMetadata',
    value: function _loadMetadata() {
      var _this2 = this;

      var paths = _settingsManager2.default.instance('PackageManager').get('PackagePaths', []);
      return new _bluebird2.default(function (resolve, reject) {
        _connection2.default.request('packages', { command: 'list', args: { paths: paths } }).then(function (res) {
          return _this2.setPackages(res).then(resolve).catch(reject);
        }).catch(reject);
      });
    }

    /**
     * Generates user-installed package metadata (on runtime)
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'generateUserMetadata',
    value: function generateUserMetadata() {
      var _this3 = this;

      var paths = _settingsManager2.default.instance('PackageManager').get('PackagePaths', []);
      return new _bluebird2.default(function (resolve, reject) {
        var cb = function cb() {
          return _this3._loadMetadata().then(resolve).catch(reject);
        };

        _connection2.default.request('packages', { command: 'cache', args: { action: 'generate', scope: 'user', paths: paths } }).then(cb).catch(cb);
      });
    }

    /**
     * Add a list of packages
     *
     * @param   {Object}    result    Package dict (manifest data)
     * @param   {String}    scope     Package scope (system/user)
     */

  }, {
    key: '_addPackages',
    value: function _addPackages(result, scope) {
      var _this4 = this;

      console.debug('PackageManager::_addPackages()', result);

      var keys = Object.keys(result);
      if (!keys.length) {
        return;
      }

      var currLocale = (0, _locales.getLocale)();

      keys.forEach(function (i) {
        var newIter = (0, _misc.cloneObject)(result[i]);
        if ((typeof newIter === 'undefined' ? 'undefined' : _typeof(newIter)) !== 'object') {
          return;
        }

        if (typeof newIter.names !== 'undefined' && newIter.names[currLocale]) {
          newIter.name = newIter.names[currLocale];
        }
        if (typeof newIter.descriptions !== 'undefined' && newIter.descriptions[currLocale]) {
          newIter.description = newIter.descriptions[currLocale];
        }
        if (!newIter.description) {
          newIter.description = newIter.name;
        }

        newIter.scope = scope || 'system';
        newIter.type = newIter.type || 'application';

        _this4.packages[i] = newIter;
      });
    }

    /**
     * Installs a package by ZIP
     *
     * @param {FileMetadata}    file        The ZIP file
     * @param {String}          root        Packge install root (defaults to first path)
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'install',
    value: function install(file, root) {
      var _this5 = this;

      var paths = _settingsManager2.default.instance('PackageManager').get('PackagePaths', []);
      if (typeof root !== 'string') {
        root = paths[0];
      }

      var dest = FS.pathJoin(root, file.filename.replace(/\.zip$/i, ''));
      return new _bluebird2.default(function (resolve, reject) {
        _connection2.default.request('packages', { command: 'install', args: { zip: file.path, dest: dest, paths: paths } }).then(function () {
          return _this5.generateUserMetadata().then(resolve).catch(reject);
        }).catch(reject);
      });
    }

    /**
     * Uninstalls given package
     *
     * @param {FileMetadata}   file        The path
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'uninstall',
    value: function uninstall(file) {
      var _this6 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _connection2.default.request('packages', { command: 'uninstall', args: { path: file.path } }).then(function () {
          return _this6.generateUserMetadata().then(resolve).catch(reject);
        }).catch(reject);
      });
    }

    /**
     * Sets the package blacklist
     *
     * @param   {String[]}       list        List of package names
     */

  }, {
    key: 'setBlacklist',
    value: function setBlacklist(list) {
      this.blacklist = list || [];
    }

    /**
     * Get a list of packges from online repositories
     *
     * @param {Object}    opts      Options
     * @return {Promise<Array, Error>}
     */

  }, {
    key: 'getStorePackages',
    value: function getStorePackages(opts) {
      var repos = _settingsManager2.default.instance('PackageManager').get('Repositories', []);

      var entries = [];

      return new _bluebird2.default(function (resolve, reject) {
        _bluebird2.default.all(repos.map(function (url) {
          return new _bluebird2.default(function (yes, no) {
            _connection2.default.request('curl', {
              url: url,
              method: 'GET'
            }).then(function (result) {
              var list = [];
              if (typeof result.body === 'string') {
                try {
                  list = JSON.parse(result.body);
                } catch (e) {}
              }

              entries = entries.concat(list.map(function (iter) {
                iter._repository = url;
                return iter;
              }));

              return yes();
            }).catch(no);
          });
        })).then(function () {
          return resolve(entries);
        }).catch(reject);
      });
    }

    /**
     * Get package by name
     *
     * @param {String}    name      Package name
     *
     * @return {Object}
     */

  }, {
    key: 'getPackage',
    value: function getPackage(name) {
      if (typeof this.packages[name] !== 'undefined') {
        return Object.freeze((0, _misc.cloneObject)(this.packages)[name]);
      }
      return false;
    }

    /**
     * Get all packages
     *
     * @param {Boolean}     [filtered=true]      Returns filtered list
     *
     * @return {Object[]}
     */

  }, {
    key: 'getPackages',
    value: function getPackages(filtered) {
      var _this7 = this;

      var hidden = _settingsManager2.default.instance('PackageManager').get('Hidden', []);
      var p = (0, _misc.cloneObject)(this.packages);

      var allowed = function allowed(iter) {
        if (_this7.blacklist.indexOf(iter.path) >= 0) {
          return false;
        }

        if (iter && iter.groups instanceof Array) {
          if (!_authenticator2.default.instance().checkPermission(iter.groups)) {
            return false;
          }
        }

        return true;
      };

      if (typeof filtered === 'undefined' || filtered === true) {
        var result = {};
        Object.keys(p).forEach(function (name) {
          var iter = p[name];
          if (!allowed(iter)) {
            return;
          }
          if (iter && hidden.indexOf(name) < 0) {
            result[name] = iter;
          }
        });

        return Object.freeze(result);
      }

      return Object.freeze(p);
    }

    /**
     * Get packages by Mime support type
     *
     * @param {String}    mime      MIME string
     *
     * @return  {Object[]}
     */

  }, {
    key: 'getPackagesByMime',
    value: function getPackagesByMime(mime) {
      var _this8 = this;

      var list = [];
      var p = (0, _misc.cloneObject)(this.packages);

      Object.keys(p).forEach(function (i) {
        if (_this8.blacklist.indexOf(i) < 0) {
          var a = p[i];
          if (a && a.mime) {
            if (FS.checkAcceptMime(mime, a.mime)) {
              list.push(i);
            }
          }
        }
      });
      return list;
    }

    /**
     * Get package resource
     *
     * @param {Process|String}    app       The application (or package name)
     * @param {String}            name      Resource name
     * @param {String}            vfspath   Return a VFS path
     * @return {String}
     */

  }, {
    key: 'getPackageResource',
    value: function getPackageResource(app, name, vfspath) {
      if (name.match(/^((https?:)|\.)?\//)) {
        return name;
      }
      name = name.replace(/^\.\//, '');

      var appname = typeof app === 'string' ? app : app.__pname;
      var fsuri = (0, _config.getConfig)('Connection.FSURI');
      var pkg = this.getPackage(appname);

      var path = name;
      if (pkg) {
        path = pkg.scope === 'user' ? '/user-package/' + FS.filename(pkg.path) + '/' + name.replace(/^\//, '') : 'packages/' + pkg.path + '/' + name;

        if (vfspath) {
          return pkg.scope === 'user' ? path.substr(fsuri.length) : (0, _config.getConfig)('VFS.Dist') + path;
        }
      }

      return path;
    }

    /**
     * Sets the current list of packages
     * @param {Object} res Package map
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'setPackages',
    value: function setPackages(res) {
      var _this9 = this;

      var packages = {};
      var locale = (0, _locales.getLocale)();

      var checkEntry = function checkEntry(key, iter, scope) {
        iter = Object.assign({}, iter);
        iter.type = iter.type || 'application';

        if (scope) {
          iter.scope = scope;
        }

        if (iter.names && iter.names[locale]) {
          iter.name = iter.names[locale];
        }

        if (iter.descriptions && iter.descriptions[locale]) {
          iter.description = iter.descriptions[locale];
        }

        var resolveIcon = function resolveIcon() {
          if (iter.icon && iter.path) {
            var packagePath = iter.path.replace(/^\//, '');

            if (iter.scope === 'user') {
              return VFS.url(FS.pathJoin(packagePath, iter.icon));
            } else {
              if (iter.icon.match(/^\.\//)) {
                var packageURI = (0, _config.getConfig)('Connection.PackageURI').replace(/\/?$/, '/');
                return _bluebird2.default.resolve(packageURI + packagePath + iter.icon.replace(/^\./, ''));
              }
            }
          }

          return _bluebird2.default.resolve(iter.icon);
        };

        iter.preload = resolvePreloads(iter, _this9);
        return new _bluebird2.default(function (resolve, reject) {
          resolveIcon().then(function (icon) {
            if (icon) {
              iter.icon = icon;
            }

            return resolve(iter);
          }).catch(reject);
        });
      };

      return new _bluebird2.default(function (resolve, reject) {
        var entries = Object.keys(res || {});
        _bluebird2.default.each(entries, function (key) {
          return new _bluebird2.default(function (yes, no) {
            var iter = res[key];
            if (iter && !packages[iter.className]) {
              checkEntry(key, iter).then(function (pkg) {
                packages[iter.className] = pkg;
                return yes();
              }).catch(no);
            } else {
              console.warn('No such package', key);
              yes();
            }
          });
        }).catch(reject).then(function () {
          _this9.packages = packages;
          return resolve();
        });
      });
    }
  }]);

  return PackageManager;
}();

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = new PackageManager();

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                               * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                               * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                               *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                               * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                               *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                               *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                               * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                               * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                               * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                               * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                               * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                               * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                               * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                               * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                               * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * @licence Simplified BSD License
                                                                                                                                                                                                                                                                               */


exports.broadcastMessage = broadcastMessage;
exports.find = find;
exports.scandir = scandir;
exports.write = write;
exports.read = read;
exports.copy = copy;
exports.move = move;
exports.rename = rename;
exports.unlink = unlink;
exports.mkdir = mkdir;
exports.exists = exists;
exports.fileinfo = fileinfo;
exports.url = url;
exports.upload = upload;
exports.download = download;
exports.trash = trash;
exports.untrash = untrash;
exports.emptyTrash = emptyTrash;
exports.freeSpace = freeSpace;
exports.watch = watch;
exports.unwatch = unwatch;
exports.triggerWatch = triggerWatch;

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _filedataurl = __webpack_require__(188);

var _filedataurl2 = _interopRequireDefault(_filedataurl);

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var watches = [];

/**
 * A supported file data type
 * @typedef {(window.File|window.Blob|FileMetadata|FileDataURL)} File
 */

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

/*
 * The default callback function when none was defined
 */
function noop(err, res) {
  if (err) {
    console.error('VFS operation without callback caused an error', err);
  } else {
    console.warn('VFS operation without callback', res);
  }
}

/*
 * Check if given item has an aliased mount associated with it
 * and return the real path
 */
function hasAlias(item, retm) {
  var module = _mountManager2.default.getModuleFromPath(item.path);

  if (module) {
    var match = module.option('match');
    var options = module.option('options');
    if (options && options.alias) {
      return retm ? module : item.path.replace(match, options.alias);
    }
  }

  return false;
}

/*
 * Will transform the argument to a VFS.File instance
 * or throw an error depending on input
 */
function checkMetadataArgument(item, err, checkRo) {
  if (typeof item === 'string') {
    item = new _file2.default(item);
  } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item.path) {
    item = new _file2.default(item);
  }

  if (!(item instanceof _file2.default)) {
    throw new TypeError(err || (0, _locales._)('ERR_VFS_EXPECT_FILE'));
  }

  var alias = hasAlias(item);
  if (alias) {
    item.path = alias;
  }

  var mountpoint = _mountManager2.default.getModuleFromPath(item.path);
  if (!mountpoint) {
    throw new Error((0, _locales._)('ERR_VFSMODULE_NOT_FOUND_FMT', item.path));
  }

  if (checkRo && mountpoint.isReadOnly()) {
    throw new Error((0, _locales._)('ERR_VFSMODULE_READONLY_FMT', mountpoint.name));
  }

  return item;
}

/*
 * Check if targets have the same transport/module
 */
function hasSameTransport(src, dest) {
  // Modules using the normal server API
  var msrc = _mountManager2.default.getModuleFromPath(src.path);
  var mdst = _mountManager2.default.getModuleFromPath(dest.path);

  if (!msrc || !mdst || msrc === mdst) {
    return true;
  }

  if (msrc && mdst && msrc.option('internal') && mdst.option('internal')) {
    return true;
  }

  return msrc.option('transport') === mdst.option('tranport');
}

/*
 * A wrapper for checking if a file exists
 */
function existsWrapper(item, options) {
  options = options || {};

  if (options.overwrite) {
    return _bluebird2.default.resolve();
  }

  return new _bluebird2.default(function (resolve, reject) {
    exists(item).then(function (result) {
      if (result) {
        return reject(new Error((0, _locales._)('ERR_VFS_FILE_EXISTS')));
      }
      return resolve();
    }).catch(function (error) {
      if (error) {
        console.warn('existsWrapper() error', error);
      }
      reject(error);
    });
  });
}

/*
 * Creates the '..' entry for scandir if not detected
 */
function createBackLink(item, result, alias, oitem) {
  var path = item.path.split('://')[1].replace(/\/+/g, '/').replace(/^\/?/, '/');

  var isOnRoot = path === '/';
  if (alias) {
    isOnRoot = oitem.path === alias.root;
  }

  if (!isOnRoot) {
    var foundBack = result.some(function (iter) {
      return iter.filename === '..';
    });

    if (!foundBack) {
      return new _file2.default({
        filename: '..',
        path: FS.dirname(item.path),
        mime: null,
        size: 0,
        type: 'dir'
      });
    }
  }

  return false;
}

/*
 * Checks if an action mathes given path
 */
function checkWatches(msg, obj) {
  watches.forEach(function (w) {
    var checkPath = w.path;

    function _check(f) {
      if (w.type === 'dir') {
        return f.path.substr(0, checkPath.length) === checkPath;
      }
      return f.path === checkPath;
    }

    var wasTouched = false;
    if (obj.destination) {
      wasTouched = _check(obj.destination);
      if (!wasTouched) {
        wasTouched = _check(obj.source);
      }
    } else {
      wasTouched = _check(obj);
    }

    if (wasTouched) {
      w.cb(msg, obj);
    }
  });
}

/*
 * See if given item matches up with any VFS modules with aliases
 * and return given entry.
 */
function findAlias(item) {
  var mm = _mountManager2.default;

  var found = null;
  mm.getModules().forEach(function (iter) {
    if (!found && iter.option('options').alias) {
      var a = iter.option('options').alias;
      if (item.path.substr(0, a.length) === a) {
        found = iter;
      }
    }
  });

  return found;
}

function convertWriteData(data, mime) {
  var convertTo = function convertTo(m, d, resolve, reject) {
    FS[m](d, mime, function (error, response) {
      if (error) {
        reject(new Error(error));
      } else {
        resolve(response);
      }
    });
  };

  return new _bluebird2.default(function (resolve, reject) {
    try {
      if (typeof data === 'string') {
        if (data.length) {
          return convertTo('textToAb', data, resolve, reject);
        }
      } else {
        if (data instanceof _filedataurl2.default) {
          return convertTo('dataSourceToAb', data.toString(), resolve, reject);
        } else if (window.Blob && data instanceof window.Blob) {
          return convertTo('blobToAb', data, resolve, reject);
        }
      }
    } catch (e) {
      return reject(e);
    }

    return resolve(data);
  });
}

function requestWrapper(mountpoint, method, args, options, appRef) {
  var _console;

  (_console = console).info.apply(_console, ['VFS operation'].concat(Array.prototype.slice.call(arguments)));
  if (!mountpoint) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFSMODULE_INVALID')));
  }

  return new _bluebird2.default(function (resolve, reject) {
    mountpoint.request(method, args, options).then(function (response) {
      return _connection2.default.instance.onVFSRequestCompleted(mountpoint, method, args, response, appRef).then(function () {
        return resolve(response);
      }).catch(reject);
    }).catch(reject);
  });
}

function performRequest(method, args, options, test, appRef, errorStr) {
  return new _bluebird2.default(function (resolve, reject) {
    if (options && !(options instanceof Object)) {
      reject(new TypeError((0, _locales._)('ERR_ARGUMENT_FMT', 'VFS::' + method, 'options', 'Object', typeof options === 'undefined' ? 'undefined' : _typeof(options))));
      return;
    }

    var mountpoint = _mountManager2.default.getModuleFromPath(test);
    if (!mountpoint) {
      reject(new Error((0, _locales._)('ERR_VFSMODULE_NOT_FOUND_FMT', test)));
      return;
    }

    requestWrapper(mountpoint, method, args, options, appRef).then(resolve).catch(reject);
  });
}

/////////////////////////////////////////////////////////////////////////////
// VFS METHODS
/////////////////////////////////////////////////////////////////////////////

/*
 * Wrapper for broadcasting VFS messages
 */
function broadcastMessage(msg, item, appRef) {
  function _message(i) {
    _process2.default.message(msg, i, { source: appRef ? appRef.__pid : null });

    checkWatches(msg, item);
  }

  // Makes sure aliased paths are called for
  var aliased = function () {
    function _transform(i) {
      if (i instanceof _file2.default) {
        var n = new _file2.default(i);
        var alias = findAlias(n);
        if (alias) {
          n.path = n.path.replace(alias.option('options').alias, alias.option('root'));
          return n;
        }
      }

      return false;
    }

    if (item instanceof _file2.default) {
      return _transform(item);
    } else if (item && item.destination && item.source) {
      return {
        source: _transform(item.source),
        destination: _transform(item.destination)
      };
    }

    return null;
  }();

  _message(item);

  var tuple = aliased.source || aliased.destination;
  if (aliased && (aliased instanceof _file2.default || tuple)) {
    if (tuple) {
      aliased.source = aliased.source || item.source;
      aliased.destination = aliased.destination || item.destination;
    }

    _message(aliased);
  }
}

/**
 * Find file(s)
 *
 * @param  {FileMetadata} item              Root path
 * @param  {Object}       args              Search query
 * @param  {Object}       [options]         Set of options
 * @param  {String}       options.query     The search query string
 * @param  {Number}       [options.limit]   Limit results to this amount
 * @return {Promise<Array, Error>}
 */
function find(item, args, options) {
  options = options || {};

  if (arguments.length < 2) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('find', [item, args], options, item.path, null, 'ERR_VFSMODULE_FIND_FMT');
}

/**
 * Scandir
 *
 * @desc Scans a directory for files and directories.
 *
 * @param  {FileMetadata}    item                             File Metadata
 * @param  {Object}          [options]                        Set of options
 * @param  {String}          [options.typeFilter]             Filter by 'file' or 'dir'
 * @param  {Array}           [options.mimeFilter]             Array of mime regex matchers
 * @param  {Boolean}         [options.showHiddenFiles=true]   Show hidden files
 * @param  {Boolean}         [options.backlink=true]          Return '..' when applicable
 * @param  {String}          [options.sortBy=null]            Sort by this key
 * @param  {String}          [options.sortDir='asc']          Sort in this direction
 * @return {Promise<Array, Error>}
 */
function scandir(item, options) {
  var vfsSettings = _settingsManager2.default.get('VFS');

  options = options || {};

  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  var oitem = new _file2.default(item);
  var alias = hasAlias(oitem, true);

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return new _bluebird2.default(function (resolve, reject) {
    performRequest('scandir', [item], options, item.path, null, 'ERR_VFSMODULE_SCANDIR_FMT').then(function (result) {
      if (result instanceof Array) {

        result = FS.filterScandir(result, options, vfsSettings);

        if (alias) {
          result = result.map(function (iter) {
            var isShortcut = iter.shortcut === true;
            var niter = new _file2.default(iter);
            if (!isShortcut) {
              var str = iter.path.replace(/\/?$/, '');
              var opt = alias.option('options') || {};
              var tmp = opt.alias.replace(/\/?$/, '');
              niter.path = FS.pathJoin(alias.option('root'), str.replace(tmp, ''));
            }

            return niter;
          });
        }

        // Inserts the correct '..' entry if missing
        if (options.backlink !== false) {
          var back = createBackLink(item, result, alias, oitem);
          if (back) {
            result.unshift(back);
          }
        }
      }
      return resolve(result);
    }).catch(reject);
  });
}

/**
 * Write File
 *
 * @desc Writes data to a file
 *
 * @param  {FileMetadata} item          File Metadata (you can also provide a string)
 * @param  {File}         data          File Data (see supported types)
 * @param  {Object}       [options]     Set of options
 * @param  {Application}  [appRef]      Reference to an Application
 * @return {Promise<Boolean, Error>}
 */
function write(item, data, options, appRef) {
  options = options || {};

  if (arguments.length < 2) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item, null, true);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return new _bluebird2.default(function (resolve, reject) {
    var mountpoint = _mountManager2.default.getModuleFromPath(item.path);
    convertWriteData(data, item.mime).then(function (ab) {

      requestWrapper(mountpoint, 'write', [item, ab], options, appRef).then(resolve).catch(function (e) {
        reject(new Error((0, _locales._)('ERR_VFSMODULE_WRITE_FMT', e)));
      });

      return true;
    }).catch(function (e) {
      reject(new Error((0, _locales._)('ERR_VFSMODULE_WRITE_FMT', e)));
    });
  });
}

/**
 * Read File
 *
 * @desc Reads data from a file
 *
 * @param  {FileMetadata} item                File Metadata (you can also provide a string)
 * @param  {Object}       [options]           Set of options
 * @param  {String}       [options.type]      What to return, default: binary. Can also be: text, datasource, json
 * @return {Promise<ArrayBuffer, Error>}
 */
function read(item, options) {
  options = options || {};

  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return new _bluebird2.default(function (resolve, reject) {
    var mountpoint = _mountManager2.default.getModuleFromPath(item.path);
    requestWrapper(mountpoint, 'read', [item], options).then(function (response) {
      if (options.type) {
        var types = {
          datasource: function datasource() {
            return new _bluebird2.default(function (yes, no) {
              FS.abToDataSource(response, item.mime, function (error, dataSource) {
                return error ? no(error) : yes(dataSource);
              });
            });
          },
          text: function text() {
            return new _bluebird2.default(function (yes, no) {
              FS.abToText(response, item.mime, function (error, text) {
                return error ? no(error) : yes(text);
              });
            });
          },
          blob: function blob() {
            return new _bluebird2.default(function (yes, no) {
              FS.abToBlob(response, item.mime, function (error, blob) {
                return error ? no(error) : yes(blob);
              });
            });
          },
          json: function json() {
            return new _bluebird2.default(function (yes, no) {
              FS.abToText(response, item.mime, function (error, text) {
                var jsn = void 0;
                if (typeof text === 'string') {
                  try {
                    jsn = JSON.parse(text);
                  } catch (e) {
                    console.warn('VFS::read()', 'readToJSON', e.stack, e);
                  }
                }
                return error ? no(error) : yes(jsn);
              });
            });
          }
        };

        var type = options.type.toLowerCase();
        if (types[type]) {
          return types[type]().then(resolve).catch(reject);
        }
      }

      return resolve(response);
    }).catch(function (e) {
      reject(new Error((0, _locales._)('ERR_VFSMODULE_READ_FMT', e)));
    });
  });
}

/**
 * Copy File
 *
 * @desc Copies a file to a destination
 *
 * @param  {FileMetadata}   src                   Source File Metadata (you can also provide a string)
 * @param  {FileMetadata}   dest                  Destination File Metadata (you can also provide a string)
 * @param  {Object}         [options]             Set of options
 * @param  {Boolean}        [options.overwrite]   If set to true it will not check if the destination exists
 * @param  {Application}    [appRef]              Seference to an Application
 * @return {Promise<Boolean, Error>}
 */
function copy(src, dest, options, appRef) {
  options = options || {};

  if (arguments.length < 2) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    src = checkMetadataArgument(src, (0, _locales._)('ERR_VFS_EXPECT_SRC_FILE'));
    dest = checkMetadataArgument(dest, (0, _locales._)('ERR_VFS_EXPECT_DST_FILE'), true);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  options = Object.assign({}, {
    type: 'binary',
    dialog: null
  }, options);

  options.arrayBuffer = true;

  function dialogProgress(prog) {
    if (options.dialog) {
      options.dialog.setProgress(prog);
    }
  }

  var promise = new _bluebird2.default(function (resolve, reject) {
    existsWrapper(dest, options).then(function () {
      var sourceMountpoint = _mountManager2.default.getModuleFromPath(src.path);
      var destMountpoint = _mountManager2.default.getModuleFromPath(dest.path);
      if (hasSameTransport(src, dest)) {
        requestWrapper(sourceMountpoint, 'copy', [src, dest], options, appRef).then(function () {
          dialogProgress(100);

          return resolve(true);
        }).catch(reject);
      } else {
        requestWrapper(sourceMountpoint, 'read', [src], options, appRef).then(function (data) {
          dialogProgress(50);

          return requestWrapper(destMountpoint, 'write', [dest, data], options, appRef).then(function (res) {
            dialogProgress(100);

            return resolve(res);
          }).catch(reject);
        }).catch(reject);
      }
      return true;
    }).catch(reject);
  });

  return new _bluebird2.default(function (resolve, reject) {
    promise.then(resolve).catch(function (e) {
      dialogProgress(100);

      reject(new Error((0, _locales._)('ERR_VFSMODULE_COPY_FMT', e)));
    });
  });
}

/**
 * Move File
 *
 * @desc Moves a file to a destination
 *
 * @param  {FileMetadata}   src                   Source File Metadata (you can also provide a string)
 * @param  {FileMetadata}   dest                  Destination File Metadata (you can also provide a string)
 * @param  {Object}         [options]             Set of options
 * @param  {Boolean}        [options.overwrite]   If set to true it will not check if the destination exists
 * @param  {Application}    [appRef]              Seference to an Application
 * @return {Promise<Boolean, Error>}
 */
function move(src, dest, options, appRef) {
  options = options || {};

  if (arguments.length < 2) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    src = checkMetadataArgument(src, (0, _locales._)('ERR_VFS_EXPECT_SRC_FILE'));
    dest = checkMetadataArgument(dest, (0, _locales._)('ERR_VFS_EXPECT_DST_FILE'), true);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  function dialogProgress(prog) {
    if (options.dialog) {
      options.dialog.setProgress(prog);
    }
  }

  var promise = new _bluebird2.default(function (resolve, reject) {
    existsWrapper(dest, options).then(function () {
      var sourceMountpoint = _mountManager2.default.getModuleFromPath(src.path);
      var destMountpoint = _mountManager2.default.getModuleFromPath(dest.path);
      if (hasSameTransport(src, dest)) {
        requestWrapper(sourceMountpoint, 'move', [src, dest], options, appRef).then(function () {
          dialogProgress(100);

          return resolve(true);
        }).catch(reject);
      } else {
        requestWrapper(sourceMountpoint, 'read', [src], options, appRef).then(function (data) {
          dialogProgress(50);

          return requestWrapper(destMountpoint, 'write', [dest, data], options, appRef).then(function (res) {
            return requestWrapper(sourceMountpoint, 'unlink', [src], options, appRef).then(function (res) {
              dialogProgress(100);

              return resolve(res);
            }).catch(reject);
          }).catch(reject);
        }).catch(reject);
      }
      return true;
    }).catch(reject);
  });

  return new _bluebird2.default(function (resolve, reject) {
    promise.then(resolve).catch(function (e) {
      dialogProgress(100);

      reject(new Error((0, _locales._)('ERR_VFSMODULE_MOVE_FMT', e)));
    });
  });
}

/**
 * Alias of move
 * @alias move
 *
 * @param  {FileMetadata}   src                   Source File Metadata (you can also provide a string)
 * @param  {FileMetadata}   dest                  Destination File Metadata (you can also provide a string)
 * @param  {Object}         [options]             Set of options
 * @param  {Boolean}        [options.overwrite]   If set to true it will not check if the destination exists
 * @param  {Application}    [appRef]              Seference to an Application
 * @return {Promise<Boolean, Error>}
 */
function rename(src, dest) {
  return move.apply(undefined, arguments);
}

/**
 * Delete File
 *
 * This function currently have no options.
 *
 * @desc Deletes a file
 *
 * @param  {FileMetadata} item                  File Metadata (you can also provide a string)
 * @param  {Object}       [options]             Set of options
 * @param  {Application}  [appRef]              Reference to an Application
 * @return {Promise<Boolean, Error>}
 */
function unlink(item, options, appRef) {
  options = options || {};

  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item, null, true);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return new _bluebird2.default(function (resolve, reject) {
    performRequest('unlink', [item], options, item.path, appRef, 'ERR_VFSMODULE_UNLINK_FMT').then(function (response) {
      var pkgdir = _settingsManager2.default.instance('PackageManager').get('PackagePaths', []);

      var found = pkgdir.some(function (i) {
        var chkdir = new _file2.default(i);
        var idir = FS.dirname(item.path);
        return idir === chkdir.path;
      });

      if (found) {
        _packageManager2.default.generateUserMetadata(function () {});
      }

      return resolve(response);
    }).catch(reject);
  });
}

/**
 * Create Directory
 *
 * @desc Creates a directory
 *
 * @param  {FileMetadata} item                  File Metadata (you can also provide a string)
 * @param  {Object}       [options]             Set of options
 * @param  {Boolean}      [options.overwrite]   If set to true it will not check if the destination exists
 * @param  {Application}  [appRef]              Reference to an Application
 * @return {Promise<Boolean, Error>}
 */
function mkdir(item, options, appRef) {
  options = options || {};

  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item, null, true);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('mkdir', [item], options, item.path, appRef, 'ERR_VFSMODULE_MKDIR_FMT');
}

/**
 * Check if file exists
 *
 * @desc Check if a target exists
 *
 * @param  {FileMetadata} item      File Metadata (you can also provide a string)
 * @return {Promise<Boolean, Error>}
 */
function exists(item) {
  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('exists', [item], {}, item.path, null, 'ERR_VFSMODULE_EXISTS_FMT');
}

/**
 * Get file info
 *
 * @desc Gets information about a file
 *
 * @param  {FileMetadata} item      File Metadata (you can also provide a string)
 * @return {Promise<Object, Error>}
 */
function fileinfo(item) {
  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('fileinfo', [item], {}, item.path, null, 'ERR_VFSMODULE_FILEINFO_FMT');
}

/**
 * Get file URL
 *
 * @desc Gets absolute HTTP URL to a file
 *
 * @param  {FileMetadata} item      File Metadata (you can also provide a string)
 * @param  {Object}       [options] Set of options
 * @return {Promise<String, Error>}
 */
function url(item, options) {
  options = options || {};

  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('url', [item], options, item.path, null, 'ERR_VFSMODULE_URL_FMT');
}

/**
 * Upload file(s)
 *
 * @desc Uploads a file to the target from browser
 *
 * @param  {Object}          args                      Function arguments (see below)
 * @param  {String}          args.destination          Full path to destination
 * @param  {Array}           args.files                Array of 'File'
 * @param  {Object}          [options]                 Set of options
 * @param  {Boolean}         [options.overwrite=false] If set to true it will not check if the destination exists
 * @param  {Application}     [appRef]                  Reference to an Application
 * @return {Promise<FileMetadata, Error>}
 */
function upload(args, options, appRef) {
  args = args || {};

  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }
  if (!args.files) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UPLOAD_NO_FILES')));
  }
  if (!args.destination) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UPLOAD_NO_DEST')));
  }

  var dest = new _file2.default(args.destination);
  var mountpoint = _mountManager2.default.getModuleFromPath(args.destination);

  return new _bluebird2.default(function (resolve, reject) {
    _bluebird2.default.all(args.files.map(function (f) {
      var filename = f instanceof window.File ? f.name : f.filename;
      var fileDest = new _file2.default(FS.pathJoin(args.destination, filename));

      return new _bluebird2.default(function (resolve, reject) {
        existsWrapper(fileDest, options).then(function () {
          return requestWrapper(mountpoint, 'upload', [dest, f], options, appRef).then(resolve).catch(reject);
        }).catch(reject);
      });
    })).then(resolve).catch(function (e) {
      reject(new Error((0, _locales._)('ERR_VFS_UPLOAD_FAIL_FMT', e)));
    });
  });
}

/**
 * Download a file
 *
 * @desc Downloads a file to the computer
 *
 * @param  {FileMetadata} file      File Metadata (you can also provide a string)
 * @return {Promise<String, Error>}
 */
function download(file) {
  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    file = checkMetadataArgument(file);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  if (!file.path) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_DOWNLOAD_NO_FILE')));
  }

  var promise = new _bluebird2.default(function (resolve, reject) {
    var mountpoint = _mountManager2.default.getModuleFromPath(file);
    requestWrapper(mountpoint, 'download', [file], {}).then(function () {

      if (mountpoint.option('internal')) {
        mountpoint.download(file).then(resolve).catch(reject);
      } else {
        mountpoint.read(file).then(resolve).catch(reject);
      }

      return true;
    });
  });

  return new _bluebird2.default(function (resolve, reject) {
    promise.then(resolve).catch(function (e) {
      reject(new Error((0, _locales._)('ERR_VFS_DOWNLOAD_FAILED', e)));
    });
  });
}

/**
 * Move file to trash (Not used in internal storage)
 *
 * @desc Trashes a file
 *
 * @param  {FileMetadata} item      File Metadata (you can also provide a string)
 * @return {Promise<Boolean, Error>}
 */
function trash(item) {
  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('trash', [item], {}, item.path, null, 'ERR_VFSMODULE_TRASH_FMT');
}

/**
 * Restore file from trash
 *
 * @desc Removes a file from trash
 *
 * @param  {FileMetadata} item      File Metadata (you can also provide a string)
 * @return {Promise<Boolean, Error>}
 */
function untrash(item) {
  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return performRequest('untrash', [item], {}, item.path, null, 'ERR_VFSMODULE_UNTRASH_FMT');
}

/**
 * Permanently empty trash
 *
 * @desc Empties the trash
 * @return {Promise<Boolean, Error>}
 */
function emptyTrash() {
  return performRequest('emptyTrash', [], {}, null, null, 'ERR_VFSMODULE_EMPTYTRASH_FMT');
}

/**
 * Checks for free space in given protocol from file
 *
 * Result is -1 when unavailable
 *
 * @desc Gets free space on target
 *
 * @param  {FileMetadata} item      File Metadata (you can also provide a string)
 * @return {Promise<Number, Error>}
 */
function freeSpace(item) {
  if (arguments.length < 1) {
    return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_NUM_ARGS')));
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  var m = _mountManager2.default.getModuleFromPath(item.path, false, true);

  return performRequest('freeSpace', [m.option('root')], {}, item.path, null, 'ERR_VFSMODULE_FREESPACE_FMT');
}

/**
 * Watches a file or directory for changes. Please note that this currently only works for
 * client-side APIs.
 * @desc Watches a file or directory for changes.
 *
 * @param   {FileMetadata} item      File Metadata (you can also provide a string)
 * @param   {Function}     callback  Callback function
 *
 * @return {Promise<Object, Boolean>} The index of your watch (you can unwatch with this)
 */
function watch(item, callback) {
  callback = callback || noop;

  if (arguments.length < 2) {
    callback((0, _locales._)('ERR_VFS_NUM_ARGS'));
    return -1;
  }

  try {
    item = checkMetadataArgument(item);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }

  return _bluebird2.default.resolve(watches.push({
    path: item.path,
    type: item.type,
    cb: callback
  }) - 1);
}

/**
 * Remove a watch
 *
 * @param {Number}      idx     Watch index (from watch() method)
 */
function unwatch(idx) {
  if (typeof watches[idx] !== 'undefined') {
    delete watches[idx];
  }
}

/**
 * Triggers a VFS watch event
 *
 * @param   {String}    method      VFS method
 * @param   {Object}    arg         VFS file
 * @param   {Process}   [appRef]    Optional application reference
 */
function triggerWatch(method, arg, appRef) {
  broadcastMessage('vfs:' + method, arg, appRef);
}

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _mountpoint = __webpack_require__(408);

var _mountpoint2 = _interopRequireDefault(_mountpoint);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loadTransports() {
  var list = ['web', 'osjs', 'dist', 'applications', 'webdav', 'google-drive', 'onedrive', 'dropbox'];
  var result = {};
  list.forEach(function (name) {
    result[name] = __webpack_require__(490)("./" + name).default;
  });
  return result;
}

/////////////////////////////////////////////////////////////////////////////
// MOUNT MANAGER
/////////////////////////////////////////////////////////////////////////////

/**
 * Mount Manager Class
 *
 * @desc Class for maintaining mountpoints and handling
 *       requests over to VFS.
 */

var MountManager = function () {

  /**
   * Constructs a new MountManager
   */
  function MountManager() {
    _classCallCheck(this, MountManager);

    this.inited = false;
    this.mountpoints = [];
    this.transports = loadTransports();
  }

  /**
   * Initializes MountManager
   *
   * @return {Promise<Boolean, Error>}
   */


  _createClass(MountManager, [{
    key: 'init',
    value: function init() {
      var _this = this;

      if (this.inited) {
        return _bluebird2.default.resolve();
      }

      this.inited = true;

      var config = (0, _config.getConfig)('VFS.Mountpoints', {});
      var enabled = Object.keys(config).filter(function (name) {
        return config[name].enabled !== false;
      });

      return _bluebird2.default.each(enabled, function (name) {
        return new _bluebird2.default(function (resolve) {
          var iter = Object.assign({
            name: name,
            dynamic: false
          }, config[name]);

          _this.add(iter, true, {
            notify: false
          }).then(resolve).catch(function (e) {
            console.warn('Failed to init VFS Mountpoint', name, iter, String(e));
            return resolve(false); // We skip errors on init
          });
        });
      });
    }

    /**
     * Adds a list of mountpoints
     *
     * @param {Mountpoint[]|Object[]} mountPoints Mountpoints
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'addList',
    value: function addList(mountPoints) {
      var _this2 = this;

      return _bluebird2.default.each(mountPoints, function (iter) {
        return _this2.add(iter);
      });
    }

    /**
     * Adds a mountpoint
     *
     * @param {Mountpoint|Object} point   The mountpoint
     * @param {Boolean}           mount   Mounts the mountpoint
     * @param {Object}            options Mount options
     * @return {Promise<Mountpoint, Error>}
     */

  }, {
    key: 'add',
    value: function add(point, mount, options) {

      try {
        if (!(point instanceof _mountpoint2.default)) {

          if (typeof point.transport === 'string') {
            var T = this.transports[point.transport];
            if (!T) {
              return _bluebird2.default.reject(new Error('No such transport: ' + point.transport));
            }
            point.transport = new T();
          }

          point = new _mountpoint2.default(point);
        }

        var found = this.mountpoints.filter(function (m) {
          if (m.option('name') === point.option('name')) {
            return true;
          }
          if (m.option('root') === point.option('root')) {
            return true;
          }
          return false;
        });

        if (found.length) {
          return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFSMODULE_ALREADY_MOUNTED_FMT', point.option('name'))));
        }

        this.mountpoints.push(point);
      } catch (e) {
        return _bluebird2.default.reject(e);
      }

      console.info('Mounting', point);

      return new _bluebird2.default(function (resolve, reject) {
        if (mount) {
          point.mount().then(function () {
            return resolve(point);
          }).catch(reject);
        } else {
          resolve(point);
        }
      });
    }

    /**
     * Removes a mountpoint
     *
     * @param {String}      moduleName      Name of the mountpoint
     * @param {Object}      options         Unmount options
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'remove',
    value: function remove(moduleName, options) {
      var _this3 = this;

      var module = this.getModule(moduleName);
      var index = this.getModule(moduleName, true);
      if (module) {
        return new _bluebird2.default(function (resolve, reject) {
          module.unmount(options).then(function (res) {
            if (index !== -1) {
              _this3.mountpoints.splice(index, 1);
            }
            return resolve(res);
          }).catch(reject);
        });
      }

      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFSMODULE_NOT_MOUNTED_FMT', moduleName)));
    }

    /**
     * Gets all modules (with filtering)
     *
     * @param {Object} filter The filter
     * @return {Mountpoint[]}
     */

  }, {
    key: 'getModules',
    value: function getModules(filter) {
      filter = Object.assign({}, {
        visible: true,
        special: false
      }, filter);

      return this.mountpoints.filter(function (mount) {
        if (mount.enabled() && mount.option('visible')) {

          var hits = Object.keys(filter).filter(function (filterName) {
            return mount.option(filterName) === filter[filterName];
          });

          return hits.length > 0;
        }

        return false;
      });
    }

    /**
     * Gets a mountpoint from a matching path
     * @param {String} test Path to test
     * @return {Mountpoint}
     */

  }, {
    key: 'getModuleFromPath',
    value: function getModuleFromPath(test) {
      return this.mountpoints.find(function (mount) {
        if (typeof test === 'string' && mount.enabled()) {
          if (mount.option('match') && test.match(mount.option('match'))) {
            return true;
          }
        }
        return false;
      });
    }

    /**
     * Gets a mountpoint by name
     * @param {String}  name         Mountpoint name
     * @param {Boolean} [idx=false]  Get index and not the actual mountpoint
     * @return {Mountpoint|Number}
     */

  }, {
    key: 'getModule',
    value: function getModule(name, idx) {
      var m = idx ? 'findIndex' : 'find';
      return this.mountpoints[m](function (i) {
        return i.option('name') === name;
      });
    }

    /**
     * Gets a transport by name
     * @param {String}  name   Transport name
     * @return {Mountpoint}
     */

  }, {
    key: 'getTransport',
    value: function getTransport(name) {
      return this.transports[name];
    }
  }]);

  return MountManager;
}();

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = new MountManager();

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _eventHandler = __webpack_require__(122);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _config = __webpack_require__(15);

var Config = _interopRequireWildcard(_config);

var _compability = __webpack_require__(123);

var Compability = _interopRequireWildcard(_compability);

var _locales = __webpack_require__(10);

var _hooks = __webpack_require__(181);

var _loader = __webpack_require__(187);

var _loader2 = _interopRequireDefault(_loader);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _preloader = __webpack_require__(120);

var _preloader2 = _interopRequireDefault(_preloader);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The predefined events are as follows:
 * <pre><code>
 *  message       All events                               => (msg, object, options)
 *  attention     When application gets attention signal   => (args)
 *  hashchange    When URL hash has changed                => (args)
 *  api           API event                                => (method)
 *  destroy       Destruction event                        => (killed)
 *  destroyWindow Attached window destruction event        => (win)
 *  initedWindow  Attached window event                    => (win)
 *  vfs           For all VFS events                       => (msg, object, options)
 *  vfs:mount     VFS mount event                          => (module, options, msg)
 *  vfs:unmount   VFS unmount event                        => (module, options, msg)
 *  vfs:write     VFS write event                          => (dest, options, msg)
 *  vfs:mkdir     VFS mkdir event                          => (dest, options, msg)
 *  vfs:move      VFS move event                           => ({src,dest}, options, msg)
 *  vfs:delete    VFS delete event                         => (dest, options, msg)
 *  vfs:upload    VFS upload event                         => (file, options, msg)
 *  vfs:update    VFS update event                         => (dir, options, msg)
 * </code></pre>
 * @typedef ProcessEvent
 */

/////////////////////////////////////////////////////////////////////////////
// GLOBALS
/////////////////////////////////////////////////////////////////////////////

var alreadyLaunching = [];
var runningProcesses = [];

function _kill(pid, force) {
  if (pid >= 0 && runningProcesses[pid]) {
    try {
      var res = runningProcesses[pid].destroy(force);
      console.warn('Killing application', pid, res);
      if (res !== false) {
        runningProcesses[pid] = null;
        return true;
      }
    } catch (e) {
      console.warn(e);
    }
  }
  return false;
}

function getLaunchObject(s) {
  if (typeof s === 'string') {
    var spl = s.split('@');
    var name = spl[0];

    var args = {};
    if (typeof spl[1] !== 'undefined') {
      try {
        args = JSON.parse(spl[1]);
      } catch (e) {}
    }

    s = {
      name: name,
      args: args
    };
  }

  return s;
}

/////////////////////////////////////////////////////////////////////////////
// PROCESS
/////////////////////////////////////////////////////////////////////////////

/**
 * Process Base Class
 *
 * @desc The basis for an Application or Service
 *
 * @abstract
 * @mixes EventHandler
 */

var Process = function () {

  /**
   * @param   {string}  name        Process Name
   * @param   {Object}  args        Process Arguments
   * @param   {Object}  metadata    Package Metadata
   */
  function Process(name, args, metadata) {
    _classCallCheck(this, Process);

    console.group('Process::constructor()', runningProcesses.length, arguments);

    /**
     * Process ID
     * @type {Number}
     */
    this.__pid = runningProcesses.push(this) - 1;

    /**
     * Process Name
     * @type {String}
     */
    this.__pname = name;

    /**
     * Process Arguments
     * @type {Object}
     */
    this.__args = args || {};

    /**
     * Package Metadata
     * @type {Metadata}
     */
    this.__metadata = metadata || {};

    /**
     * Started timestamp
     * @type {Date}
     */
    this.__started = new Date();

    /**
     * If process was destroyed
     * @type {Boolean}
     */
    this.__destroyed = false;

    this.__evHandler = new _eventHandler2.default(name, ['message', 'attention', 'hashchange', 'api', 'destroy', 'destroyWindow', 'vfs', 'vfs:mount', 'vfs:unmount', 'vfs:mkdir', 'vfs:write', 'vfs:move', 'vfs:copy', 'vfs:delete', 'vfs:upload', 'vfs:update']);

    this.__label = this.__metadata.name;
    this.__path = this.__metadata.path;
    this.__scope = this.__metadata.scope || 'system';
    this.__iter = this.__metadata.className;

    console.groupEnd();
  }

  /**
   * Destroys the process
   *
   * @return  {Boolean}
   */


  _createClass(Process, [{
    key: 'destroy',
    value: function destroy() {
      if (!this.__destroyed) {
        this.__destroyed = true;

        console.group('Process::destroy()', this.__pid, this.__pname);

        this._emit('destroy', []);

        if (this.__evHandler) {
          this.__evHandler = this.__evHandler.destroy();
        }

        if (this.__pid >= 0) {
          runningProcesses[this.__pid] = null;
        }

        console.groupEnd();

        return true;
      }

      return false;
    }

    /**
     * Method for handling internal messaging system
     *
     * @param   {string}    msg       Message type
     * @param   {Object}    obj       Message object
     * @param   {Object}    [opts]    Message options
     */

  }, {
    key: '_onMessage',
    value: function _onMessage(msg, obj, opts) {
      opts = opts || {};

      var sourceId = opts.source;
      if (sourceId && (typeof sourceId === 'undefined' ? 'undefined' : _typeof(sourceId)) === 'object') {
        if (sourceId instanceof Process) {
          sourceId = sourceId.__pid;
        } else if (sourceId._app) {
          sourceId = sourceId._app ? sourceId._app.__pid : -1;
        }
      }

      if (this.__evHandler && sourceId !== this.__pid) {
        console.debug('Process::_onMessage()', msg, obj, opts, this.__pid, this.__pname);

        // => fn('message', msg, obj, opts)
        this.__evHandler.emit('message', [msg, obj, opts]);

        // Emit another message for VFS events
        if (msg.substr(0, 3) === 'vfs') {
          this.__evHandler.emit('vfs', [msg, obj, opts]);
        }

        // => fn(msg, obj, opts)
        // for custom events bound with _on(evname)
        this.__evHandler.emit(msg, [obj, opts, msg]);
      }
    }

    /**
     * Fire a hook to internal event
     *
     * @see Process#on
     * @see EventHandler#emit
     *
     * @param   {ProcessEvent}    k       Event name
     * @param   {Array}           args    Send these arguments (fn.apply)
     *
     * @return {*} Result (last) from bound function(s)
     */

  }, {
    key: '_emit',
    value: function _emit(k, args) {
      return this.__evHandler ? this.__evHandler.emit(k, args) : null;
    }

    /**
     * Adds a hook to internal event
     *
     * @see EventHandler#on
     *
     * @param   {ProcessEvent}    k       Event name
     * @param   {Function}        func    Callback function
     *
     * @return  {Number}
     */

  }, {
    key: '_on',
    value: function _on(k, func) {
      return this.__evHandler ? this.__evHandler.on(k, func, this) : null;
    }

    /**
     * Removes a hook to an internal even
     *
     * @see Process#_on
     * @see EventHandler#off
     *
     * @param   {ProcessEvent}    k       Event name
     * @param   {Number}          idx     The hook index returned from _on()
     */

  }, {
    key: '_off',
    value: function _off(k, idx) {
      if (this.__evHandler) {
        this.__evHandler.off(k, idx);
      }
    }

    /**
     * Call the ApplicationAPI
     *
     * This is used for calling 'api.php' or 'api.js' in your Application.
     *
     * On Lua or Arduino it is called 'server.lua'
     *
     * @param   {String}      method                      Name of method
     * @param   {Object}      args                        Arguments in JSON
     * @param   {Object}      [options]                   Options (See API::call)
     * @return  {Promise}
     */

  }, {
    key: '_api',
    value: function _api(method, args, options) {
      var _this = this;

      // NOTE: Backward compability
      if (typeof options === 'boolean') {
        options = {
          indicator: options
        };
      } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
        options = {};
      }

      this._emit('api', [method]);

      return new _bluebird2.default(function (resolve, reject) {
        _connection2.default.request('application', {
          application: _this.__iter,
          path: _this.__path,
          method: method,
          args: args
        }, options).then(function (res) {
          if (!_this.__destroyed) {
            resolve(res);
            return true;
          }
          console.warn('Process::_api()', 'INGORED RESPONSE: Process was closed');
          return false;
        }).catch(function (err) {
          if (!_this.__destroyed) {
            reject(err instanceof Error ? err : new Error(err));
          }
        });
      });
    }

    /**
     * Get a launch/session argument
     *
     * @param   {String}  [k]     Argument
     *
     * @return  {*}     Argument value or null
     */

  }, {
    key: '_getArgument',
    value: function _getArgument(k) {
      return typeof this.__args[k] === 'undefined' ? null : this.__args[k];
    }

    /**
     * Get all launch/session argument
     *
     * @return  {Object}
     */

  }, {
    key: '_getArguments',
    value: function _getArguments() {
      return this.__args;
    }

    /**
     * Get full path to a resorce belonging to this process (package)
     *
     * @param   {String}      src       Resource name (path)
     * @param   {Boolean}     [vfspath] Return a valid VFS path
     *
     * @return  {String}
     */

  }, {
    key: '_getResource',
    value: function _getResource(src, vfspath) {
      return _packageManager2.default.getPackageResource(this, src, vfspath);
    }

    /**
     * Set a launch/session argument
     *
     * @param   {String}    k             Key
     * @param   {String}    v             Value
     */

  }, {
    key: '_setArgument',
    value: function _setArgument(k, v) {
      this.__args[k] = v;
    }

    /**
     * Kills a process
     *
     * @param   {Number}  pid       Process ID
     *
     * @return  {Boolean}           Success or not
     */

  }], [{
    key: 'kill',
    value: function kill(pid) {
      return _kill(pid);
    }

    /**
     * Kills all processes
     *
     * @param   {(String|RegExp)}     match     Kill all matching this
     */

  }, {
    key: 'killAll',
    value: function killAll(match) {
      var matcher = function matcher() {
        return true;
      };

      if (match) {
        matcher = match instanceof RegExp ? function (p) {
          return p.__pname.match(match);
        } : function (p) {
          return p.__pname === match;
        };
      }

      this.getProcesses().filter(function (p) {
        return matcher(p);
      }).forEach(function (p) {
        return _kill(p.__pid, true);
      });

      runningProcesses = [];
    }

    /**
     * Sends a message to all processes
     *
     * Example: VFS uses this to signal file changes etc.
     *
     * @param   {String}                    msg             Message name
     * @param   {Object}                    obj             Message object
     * @param   {Object}                    opts            Options
     * @param   {Process|Window|Number}    [opts.source]    Source Process, Window or ID
     * @param   {String|Function}          [opts.filter]    Filter by string or fn(process)
     *
     * @see Process#_onMessage
     */

  }, {
    key: 'message',
    value: function message(msg, obj, opts) {
      opts = opts || {};

      console.debug('Process::message()', msg, obj, opts);

      var filter = opts.filter || function () {
        return true;
      };
      if (typeof filter === 'string') {
        var s = filter;
        filter = function filter(p) {
          return p.__pname === s;
        };
      }

      this.getProcesses().filter(filter).forEach(function (p) {
        return p._onMessage(msg, obj, opts);
      });
    }

    /**
     * Get a process by name
     *
     * @param   {String}    name    Process Name (or by number)
     * @param   {Boolean}   first   Return the first found
     *
     * @return  {(Process[]|Process)}  Array of Processes or a Process depending on arguments
     */

  }, {
    key: 'getProcess',
    value: function getProcess(name, first) {
      if (typeof name === 'number') {
        return runningProcesses[name];
      }

      var found = this.getProcesses().filter(function (p) {
        return p.__pname === name;
      });

      return first ? found[0] : found;
    }

    /**
     * Get all processes
     *
     * @return  {Process[]}
     */

  }, {
    key: 'getProcesses',
    value: function getProcesses() {
      return runningProcesses.filter(function (p) {
        return !!p;
      });
    }

    /**
     * Reloads a process
     * @param {String|String[]} n  Process name(s)
     */

  }, {
    key: 'reload',
    value: function reload(n) {
      var _this2 = this;

      if (!(n instanceof Array)) {
        n = [n];
      }

      n.map(function (name) {
        return _this2.getProcess(name, true);
      }).filter(function (p) {
        return !!p;
      }).forEach(function (p) {
        var promise = null;
        var data = p._getSessionData();
        var args = {};
        var name = void 0;

        try {
          name = p.__pname;
          promise = p.destroy(); // kill
        } catch (e) {
          console.warn('Process::reload()', e.stack, e);
        }

        if (data !== null) {
          args = data.args;
          args.__resume__ = true;
          args.__windows__ = data.windows || [];
        }
        args.__preload__ = { force: true };

        if (!(promise instanceof _bluebird2.default)) {
          promise = _bluebird2.default.resolve(true);
        }

        if (name) {
          promise.then(function () {
            return setTimeout(function () {
              _this2.create(name, args);
            }, 500);
          });
        }
      });
    }

    /**
     * Launch a Process
     *
     * @param   {String}      name          Application Name
     * @param   {Object}      [args]          Launch arguments
     * @param   {Function}    [onconstruct]   Callback on application init
     * @return  {Promise<Process, Error>}
     */

  }, {
    key: 'create',
    value: function create(name, args, onconstruct) {
      args = args || {};
      onconstruct = onconstruct || function () {};

      var hash = name + JSON.stringify(args);
      if (alreadyLaunching.indexOf(hash) !== -1) {
        return _bluebird2.default.resolve(null);
      }
      alreadyLaunching.push(hash);

      var init = function init() {
        if (!name) {
          throw new Error('Cannot Process::create() witout a application name');
        }

        var compability = Compability.getCompability();
        var metadata = _packageManager2.default.getPackage(name);
        var alreadyRunning = Process.getProcess(name, true);

        //
        // Pre-checks
        //

        if (!metadata) {
          throw new Error((0, _locales._)('ERR_APP_LAUNCH_MANIFEST_FAILED_FMT', name));
        }

        var compabilityFailures = (metadata.compability || []).filter(function (c) {
          if (typeof compability[c] !== 'undefined') {
            return !compability[c];
          }
          return false;
        });

        if (compabilityFailures.length) {
          throw new Error((0, _locales._)('ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT', name, compabilityFailures.join(', ')));
        }

        if (metadata.singular === true && alreadyRunning) {
          console.warn('Process::create()', 'detected that this application is a singular and already running...');
          alreadyRunning._onMessage('attention', args);

          //throw new Error(_('ERR_APP_LAUNCH_ALREADY_RUNNING_FMT', name));
          return _bluebird2.default.resolve(alreadyRunning);
        }

        (0, _hooks.triggerHook)('processStart', [name, args]);

        // Create loading ui
        _loader2.default.create('Main.launch.' + name, {
          title: (0, _locales._)('LBL_STARTING') + ' ' + metadata.name,
          icon: _theme2.default.getIcon(metadata.icon, '16x16')
        });

        // Preload
        var pargs = {
          max: metadata.preloadParallel === true ? Config.getConfig('Connection.PreloadParallel') : metadata.preloadParallel /*,
                                                                                                                             progress: (index, total) => {
                                                                                                                             }*/
        };

        if (args.__preload__) {
          // This is for Process.reload()
          pargs = Object.assign(pargs, args.__preload__);
          delete args.__preload__;
        }

        return new _bluebird2.default(function (resolve, reject) {
          var onerror = function onerror(e) {
            console.warn(e);
            return reject(new Error(e));
          };

          _preloader2.default.preload(metadata.preload, pargs).then(function (result) {
            if (result.failed.length) {
              return onerror((0, _locales._)('ERR_APP_PRELOAD_FAILED_FMT', name, result.failed.join(',')));
            }

            if (typeof OSjs.Applications[name] === 'undefined') {
              return onerror(new Error((0, _locales._)('ERR_APP_RESOURCES_MISSING_FMT', name)));
            }

            // Run
            var instance = void 0;

            try {
              var ResolvedPackage = OSjs.Applications[name];
              instance = new ResolvedPackage(args, metadata);

              onconstruct(instance, metadata);
            } catch (e) {
              return onerror(e);
            }

            try {
              var settings = _settingsManager2.default.get(instance.__pname) || {};
              instance.init(settings, metadata);

              (0, _hooks.triggerHook)('processStarted', [{
                application: instance,
                name: name,
                args: args,
                settings: settings,
                metadata: metadata
              }]);
            } catch (e) {
              return onerror(e);
            }

            return resolve(instance);
          }).catch(onerror);
        });
      };

      var onerror = function onerror(err) {
        OSjs.error((0, _locales._)('ERR_APP_LAUNCH_FAILED'), (0, _locales._)('ERR_APP_LAUNCH_FAILED_FMT', name), err, err, true);
      };

      return new _bluebird2.default(function (resolve, reject) {
        console.group('Process::create()', name, args);

        var remove = function remove() {
          console.groupEnd();
          var i = alreadyLaunching.indexOf(hash);
          if (i >= 0) {
            alreadyLaunching.splice(i, 1);
          }
          _loader2.default.destroy('Main.launch.' + name);
        };

        var fail = function fail(e) {
          _loader2.default.destroy('Main.launch.' + name);
          remove();
          onerror(e);
          return reject(e);
        };

        try {
          init().then(resolve).catch(fail).finally(remove);
        } catch (e) {
          fail(e);
        }
      });
    }

    /**
     * Launch Processes from a List
     *
     * @param   {Array}         list        List of launch application arguments
     * @param   {Function}      onconstruct Callback on success => fn(app, metadata, appName, appArgs)
     * @return  {Promise<Process[], Error>}
     */

  }, {
    key: 'createFromArray',
    value: function createFromArray(list, onconstruct) {
      var _this3 = this;

      list = list || [];
      onconstruct = onconstruct || function () {};

      console.info('Process::createFromArray()', list);

      return _bluebird2.default.each(list, function (s) {
        return new _bluebird2.default(function (resolve, reject) {
          s = getLaunchObject(s);
          if (s.name) {
            try {
              _this3.create(s.name, s.args, function (instance, metadata) {
                onconstruct(instance, metadata, s.name, s.args);
              }).then(resolve).catch(reject);
            } catch (e) {
              reject(e);
            }
          } else {
            resolve();
          }
        });
      });
    }

    /**
     * Open a file
     *
     * @param   {FileMetadata}   file    The File reference (can also be a tuple with 'path' and 'mime')
     * @param   {Object}         args    Arguments to send to process launch function
     * @return  {Promise<Process, Error>}
     */

  }, {
    key: 'createFromFile',
    value: function createFromFile(file, args) {
      var _this4 = this;

      file = new _file2.default(file);

      args = Object.assign({
        file: file
      }, args || {});

      if (args.args) {
        Object.keys(args.args).forEach(function (i) {
          args[i] = args.args[i];
        });
      }

      if (!file.path) {
        throw new Error('Cannot open file without a path');
      }

      console.info('Process::createFromFile()', file, args);

      if (file.mime === 'osjs/application') {
        return this.create(FS.filename(file.path));
      } else if (file.type === 'dir') {
        var fm = _settingsManager2.default.instance('DefaultApplication').get('dir', 'ApplicationFileManager');
        return this.create(fm, { path: file.path });
      }

      return new _bluebird2.default(function (resolve, reject) {
        var val = _settingsManager2.default.get('DefaultApplication', file.mime);
        var pack = _packageManager2.default.getPackagesByMime(file.mime);
        if (!args.forceList && val) {
          if (_packageManager2.default.getPackage(val)) {
            console.debug('Process::createFromFile()', 'default application', val);
            pack = [val];
          }
        }

        if (pack.length === 0) {
          OSjs.error((0, _locales._)('ERR_FILE_OPEN'), (0, _locales._)('ERR_FILE_OPEN_FMT', file.path), (0, _locales._)('ERR_APP_MIME_NOT_FOUND_FMT', file.mime));

          reject(new Error((0, _locales._)('ERR_APP_MIME_NOT_FOUND_FMT', file.mime)));
        } else if (pack.length === 1) {
          _this4.create(pack[0], args).then(resolve).catch(reject);
        } else {
          var DialogWindow = __webpack_require__(34);
          DialogWindow.default.create('ApplicationChooser', {
            file: file,
            list: pack
          }, function (ev, btn, result) {
            if (btn === 'ok') {
              _this4.create(result.name, args);

              _settingsManager2.default.set('DefaultApplication', file.mime, result.useDefault ? result.name : null, true).then(resolve).catch(function (err) {
                reject(typeof err === 'string' ? new Error(err) : err);
              });
            }
          });
        }
      });
    }
  }]);

  return Process;
}();

exports.default = Process;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A VFS transport
 *
 * @desc Used via a Mountpoint
 */
var Transport = function () {
  function Transport() {
    _classCallCheck(this, Transport);
  }

  _createClass(Transport, [{
    key: 'request',


    /**
     * Performs a request
     *
     * @param {String}      method    Method name
     * @param {Array}       args      Method arguments
     * @param {Object}      options   Options
     * @param {Mountpoint}  mount     Requested from this mountpoint
     * @return {Promise<Object, Error>}
     */
    value: function request(method, args, options, mount) {
      var readOnly = ['upload', 'unlink', 'write', 'mkdir', 'move', 'trash', 'untrash', 'emptyTrash'];
      if (mount.isReadOnly()) {
        if (readOnly.indexOf(method) !== -1) {
          return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFSMODULE_READONLY')));
        }
      }

      var newArgs = args.concat([options, mount]);
      return this[method].apply(this, _toConsumableArray(newArgs));
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'read',
    value: function read(item, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'write',
    value: function write(file, data, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'unlink',
    value: function unlink(src, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'copy',
    value: function copy(src, dest, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'move',
    value: function move(src, dest, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'exists',
    value: function exists(item, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'fileinfo',
    value: function fileinfo(item, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'mkdir',
    value: function mkdir(dir, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'upload',
    value: function upload(file, dest, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'download',
    value: function download(item, options, mount) {
      var _this = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this.url(item).then(function (url) {
          return (0, _axios2.default)({
            responseType: 'arraybuffer',
            url: url,
            method: 'GET'
          }).then(function (result) {
            return resolve(result.data);
          }).catch(function (error) {
            reject(error.message);
          });
        }).catch(reject);
      });
    }
  }, {
    key: 'url',
    value: function url(item, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'find',
    value: function find(file, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'trash',
    value: function trash(file, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'untrash',
    value: function untrash(file, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'emptyTrash',
    value: function emptyTrash(options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'freeSpace',
    value: function freeSpace(root, options, mount) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }]);

  return Transport;
}();

exports.default = Transport;

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * A collection of keycode mappings
 *
 * @var
 */
var Keycodes = function () {
  var list = {
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F6: 118,
    F7: 119,
    F8: 120,
    F9: 121,
    F10: 122,
    F11: 123,
    F12: 124,

    TILDE: 220,
    GRAVE: 192,

    CMD: 17,
    LSUPER: 91,
    RSUPER: 92,

    DELETE: 46,
    INSERT: 45,
    HOME: 36,
    END: 35,
    PGDOWN: 34,
    PGUP: 33,
    PAUSE: 19,
    BREAK: 19,
    CAPS_LOCK: 20,
    SCROLL_LOCK: 186,

    BACKSPACE: 8,
    SPACE: 32,
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
    DOWN: 40
  };

  // Add all ASCII chacters to the map
  for (var n = 33; n <= 126; n++) {
    list[String.fromCharCode(n)] = n;
  }

  return Object.freeze(list);
}();

exports.default = Keycodes;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _menu = __webpack_require__(90);

var Menu = _interopRequireWildcard(_menu);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _keycodes = __webpack_require__(88);

var _keycodes2 = _interopRequireDefault(_keycodes);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

var _window = __webpack_require__(121);

var _window2 = _interopRequireDefault(_window);

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _notification = __webpack_require__(189);

var _notification2 = _interopRequireDefault(_notification);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

var _windowBehaviour = __webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/////////////////////////////////////////////////////////////////////////////
// MISC HELPERS
/////////////////////////////////////////////////////////////////////////////

function checkForbiddenKeyCombo(ev) {
  return false;
  /* FIXME: This is not supported in browsers :( (in app mode it should be)
  var forbiddenCtrl = ['n', 't', 'w'];
  if ( ev.ctrlKey ) {
    return forbiddenCtrl.some(function(i) {
      return String.fromCharCode(ev.keyCode).toLowerCase() === i;
    });
  }
  return false;
  */
}

function checkPrevent(ev, win) {
  var d = ev.srcElement || ev.target;
  var accept = [122, 123];
  var doPrevent = d.tagName === 'BODY' ? true : false;

  // What browser default keys we prevent in certain situations
  if (ev.keyCode === _keycodes2.default.BACKSPACE && !DOM.$isFormElement(ev)) {
    // Backspace
    doPrevent = true;
  } else if (ev.keyCode === _keycodes2.default.TAB && DOM.$isFormElement(ev)) {
    // Tab
    doPrevent = true;
  } else {
    if (accept.indexOf(ev.keyCode) !== -1) {
      doPrevent = false;
    } else if (checkForbiddenKeyCombo(ev)) {
      doPrevent = true;
    }
  }

  // Only prevent default event if current window is not set up to capture them by force
  if (doPrevent && (!win || !win._properties.key_capture)) {
    return true;
  }

  return false;
}

function triggerFullscreen(el, state) {
  function _request() {
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullScreen) {
      el.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  }

  function _restore() {
    if (el.webkitCancelFullScreen) {
      el.webkitCancelFullScreen();
    } else if (el.mozCancelFullScreen) {
      el.mozCancelFullScreen();
    } else if (el.exitFullscreen) {
      el.exitFullscreen();
    }
  }

  if (el) {
    if (state) {
      _request();
    } else {
      _restore();
    }
  }
}

/////////////////////////////////////////////////////////////////////////////
// WINDOW MANAGER
/////////////////////////////////////////////////////////////////////////////

var _instance = void 0;

/**
 * WindowManager Process Class
 *
 * @desc Class used for basis as a Window Manager.
 *
 * @abstract
 */

var WindowManager = function (_Process) {
  _inherits(WindowManager, _Process);

  _createClass(WindowManager, null, [{
    key: 'instance',
    get: function get() {
      return _instance;
    }

    /**
     * @param   {String}            name      Window Manager name
     * @param   {Object}            args      Constructed arguments
     * @param   {Object}            metadata  Package Metadata
     * @param   {Object}            settings  Restored settings
     */

  }]);

  function WindowManager(name, args, metadata, settings) {
    _classCallCheck(this, WindowManager);

    console.group('WindowManager::constructor()');
    console.debug('Name', name);
    console.debug('Arguments', args);

    /* eslint consistent-this: "off" */
    var _this = _possibleConstructorReturn(this, (WindowManager.__proto__ || Object.getPrototypeOf(WindowManager)).call(this, name, args, metadata));

    _instance = _this;

    _this._windows = [];
    _this._settings = _settingsManager2.default.instance(name, settings);
    _this._currentWin = null;
    _this._lastWin = null;
    _this._mouselock = true;
    _this._stylesheet = null;
    _this._sessionLoaded = false;
    _this._fullyLoaded = false;
    _this._isResponsive = false;
    _this._responsiveRes = 800;
    _this._dcTimeout = null;
    _this._resizeTimeout = null;
    _this._$fullscreen = null;
    _this._$lastDomInput = null;

    // Important for usage as "Application"
    _this.__name = name || 'WindowManager';
    _this.__path = metadata.path;
    _this.__iter = metadata.iter;

    _connection2.default.instance.subscribe('online', function () {
      _notification2.default.create({ title: (0, _locales._)('LBL_INFO'), message: (0, _locales._)('CONNECTION_RESTORED') });
    });

    _connection2.default.instance.subscribe('offline', function (reconnecting) {
      _notification2.default.create({ title: (0, _locales._)('LBL_WARNING'), message: (0, _locales._)(reconnecting ? 'CONNECTION_RESTORE_FAILED' : 'CONNECTION_LOST') });
    });

    console.groupEnd();
    return _this;
  }

  /**
   * Destroy the WindowManager
   *
   * @return {Boolean}
   */


  _createClass(WindowManager, [{
    key: 'destroy',
    value: function destroy() {
      var _this2 = this;

      console.debug('WindowManager::destroy()');

      this.destroyStylesheet();

      Events.$unbind(document, 'pointerout:windowmanager');
      Events.$unbind(document, 'pointerenter:windowmanager');
      Events.$unbind(window, 'orientationchange:windowmanager');
      Events.$unbind(window, 'hashchange:windowmanager');
      Events.$unbind(window, 'resize:windowmanager');
      Events.$unbind(window, 'scroll:windowmanager');
      Events.$unbind(window, 'fullscreenchange:windowmanager');
      Events.$unbind(window, 'mozfullscreenchange:windowmanager');
      Events.$unbind(window, 'webkitfullscreenchange:windowmanager');
      Events.$unbind(window, 'msfullscreenchange:windowmanager');
      Events.$unbind(document.body, 'contextmenu:windowmanager');
      Events.$unbind(document.body, 'pointerdown:windowmanager,touchstart:windowmanager');
      Events.$unbind(document.body, 'click:windowmanager');
      Events.$unbind(document, 'keyup:windowmanager');
      Events.$unbind(document, 'keydown:windowmanager');
      Events.$unbind(document, 'keypress:windowmanager');

      window.onerror = null;
      window.onbeforeunload = null;

      // Destroy all windows
      this._windows.forEach(function (win, i) {
        if (win) {
          win.destroy(true);
          _this2._windows[i] = null;
        }
      });

      this._windows = [];
      this._currentWin = null;
      this._lastWin = null;
      this._$fullscreen = null;

      _instance = null;

      return _get(WindowManager.prototype.__proto__ || Object.getPrototypeOf(WindowManager.prototype), 'destroy', this).call(this);
    }

    /**
     * Initialize the WindowManager
     *
     * @param   {Object}            metadata      Package metadata
     * @param   {Object}            settings      Package settings
     */

  }, {
    key: 'init',
    value: function init(metadata, settings) {
      var _this3 = this;

      console.debug('WindowManager::init()');

      document.body.addEventListener('touchend', function (ev) {
        if (ev.target === document.body) {
          ev.preventDefault();
        }
      });

      Events.$bind(document, 'pointerout:windowmanager', function (ev) {
        return _this3._onMouseLeave(ev);
      });
      Events.$bind(document, 'pointerenter:windowmanager', function (ev) {
        return _this3._onMouseLeave(ev);
      });
      Events.$bind(window, 'orientationchange:windowmanager', function (ev) {
        return _this3._onOrientationChange(ev);
      });
      Events.$bind(window, 'hashchange:windowmanager', function (ev) {
        return _this3._onHashChange(ev);
      });
      Events.$bind(window, 'resize:windowmanager', function (ev) {
        return _this3._onResize(ev);
      });
      Events.$bind(window, 'scroll:windowmanager', function (ev) {
        return _this3._onScroll(ev);
      });
      Events.$bind(window, 'fullscreenchange:windowmanager', function (ev) {
        return _this3._onFullscreen(ev);
      });
      Events.$bind(window, 'mozfullscreenchange:windowmanager', function (ev) {
        return _this3._onFullscreen(ev);
      });
      Events.$bind(window, 'webkitfullscreenchange:windowmanager', function (ev) {
        return _this3._onFullscreen(ev);
      });
      Events.$bind(window, 'msfullscreenchange:windowmanager', function (ev) {
        return _this3._onFullscreen(ev);
      });
      Events.$bind(document.body, 'contextmenu:windowmanager', function (ev) {
        return _this3._onContextMenu(ev);
      });
      Events.$bind(document.body, 'pointerdown:windowmanager,touchstart:windowmanager', function (ev) {
        return _this3._onMouseDown(ev);
      });
      Events.$bind(document.body, 'click:windowmanager', function (ev) {
        return _this3._onClick(ev);
      });
      Events.$bind(document, 'keyup:windowmanager', function (ev) {
        return _this3._onKeyUp(ev);
      });
      Events.$bind(document, 'keydown:windowmanager', function (ev) {
        return _this3._onKeyDown(ev);
      });
      Events.$bind(document, 'keypress:windowmanager', function (ev) {
        return _this3._onKeyPress(ev);
      });

      window.onerror = this._onError.bind(this);
      window.onbeforeunload = this._onBeforeUnload(this);

      var queries = this.getDefaultSetting('mediaQueries') || {};

      var maxWidth = 0;
      Object.keys(queries).forEach(function (q) {
        maxWidth = Math.max(maxWidth, queries[q]);
      });
      this._responsiveRes = maxWidth || 800;

      this._onOrientationChange();
      this.resize();
    }

    /**
     * Setup features
     *
     * THIS IS IMPLEMENTED IN COREWM
     *
     * @param   {Function}  cb        Callback
     */

  }, {
    key: 'setup',
    value: function setup(cb) {
      // Implement in your WM
      cb();
    }

    /**
     * Get a Window by name
     *
     * @param   {String}      name        Window name
     *
     * @return  {Window}
     */

  }, {
    key: 'getWindow',
    value: function getWindow(name) {
      return this.getWindows().find(function (w) {
        return w.__name === name;
      });
    }

    /**
     * Add a Window
     *
     * @throws {Error} If invalid window is given
     *
     * @param   {Window}      w         Window reference
     * @param   {Boolean}     focus     Focus the window
     *
     * @return  {Window}                The added window
     */

  }, {
    key: 'addWindow',
    value: function addWindow(w, focus) {
      if (!(w instanceof _window2.default)) {
        console.warn('WindowManager::addWindow()', 'Got', w);
        throw new TypeError('given argument was not instance of Core.Window');
      }
      console.debug('WindowManager::addWindow()');

      try {
        w.init(this, w._app);
      } catch (e) {
        console.error('WindowManager::addWindow()', '=>', 'Window::init()', e, e.stack);
      }

      (0, _windowBehaviour.createWindowBehaviour)(w, this);

      this._windows.push(w);
      w._inited();

      if (focus === true || w instanceof _dialog2.default) {
        w._focus();
      }

      return w;
    }

    /**
     * Remove a Window
     *
     * @throws {Error} If invalid window is given
     *
     * @param   {Window}      w         Window reference
     *
     * @return  {Boolean}               On success
     */

  }, {
    key: 'removeWindow',
    value: function removeWindow(w) {
      if (!(w instanceof _window2.default)) {
        console.warn('WindowManager::removeWindow()', 'Got', w);
        throw new TypeError('given argument was not instance of Core.Window');
      }

      var foundIndex = this._windows.findIndex(function (win) {
        return win && win._wid === w._wid;
      });

      console.debug('WindowManager::removeWindow()', w._wid, foundIndex);

      if (foundIndex !== -1) {
        this._windows[foundIndex] = null;
        return true;
      }
      return false;
    }

    /**
     * Set WindowManager settings
     *
     * OVERRIDE THIS IN YOUR WM IMPLEMENTATION
     *
     * @param   {Object}      settings              JSON Settings
     * @param   {Boolean}     force                 If forced, no merging will take place
     * @param   {Boolean}     save                  Saves settings
     * @param   {Boolean}     [triggerWatch=true]   Trigger change event for watchers
     *
     * @return  {Boolean}                     On success
     */

  }, {
    key: 'applySettings',
    value: function applySettings(settings, force, save, triggerWatch) {
      settings = settings || {};
      console.debug('WindowManager::applySettings()', 'forced?', force);

      var result = force ? settings : Utils.mergeObject(this._settings.get(), settings);
      this._settings.set(null, result, save, triggerWatch);

      return true;
    }

    /**
     * Create Window Manager self-contained CSS from this object
     *
     * {
     *    '.classname': {
     *      'background-image': 'url()'
     *    }
     * }
     *
     * @param   {Object}    styles      Style object
     * @param   {String}    [rawStyles] Raw CSS data
     */

  }, {
    key: 'createStylesheet',
    value: function createStylesheet(styles, rawStyles) {
      this.destroyStylesheet();

      var innerHTML = [];
      Object.keys(styles).forEach(function (key) {
        var rules = [];
        Object.keys(styles[key]).forEach(function (r) {
          rules.push(Utils.format('    {0}: {1};', r, styles[key][r]));
        });

        rules = rules.join('\n');
        innerHTML.push(Utils.format('{0} {\n{1}\n}', key, rules));
      });

      innerHTML = innerHTML.join('\n');
      if (rawStyles) {
        innerHTML += '\n' + rawStyles;
      }

      var style = document.createElement('style');
      style.type = 'text/css';
      style.id = 'WMGeneratedStyles';
      style.innerHTML = innerHTML;
      document.getElementsByTagName('head')[0].appendChild(style);

      this._stylesheet = style;
    }

    /**
     * Destroy Window Manager self-contained CSS
     */

  }, {
    key: 'destroyStylesheet',
    value: function destroyStylesheet() {
      if (this._stylesheet) {
        DOM.$remove(this._stylesheet);
      }
      this._stylesheet = null;
    }
  }, {
    key: 'resize',
    value: function resize(ev, rect) {
      // Implement in your WM
      this._isResponsive = window.innerWidth <= 1024;

      this.onResize(ev);
    }

    /**
     * Whenever a window event occurs
     *
     * THIS IS IMPLEMENTED IN COREWM
     *
     * @param   {String}  ev      Event name
     * @param   {Window}  win     Window ref
     *
     * @return  {Boolean}
     */

  }, {
    key: 'eventWindow',
    value: function eventWindow(ev, win) {
      // Implement in your WM
      return false;
    }

    /**
     * Show Settings Window (Application)
     *
     * THIS IS IMPLEMENTED IN COREWM
     */

  }, {
    key: 'showSettings',
    value: function showSettings() {}
    // Implement in your WM


    /**
     * Toggles fullscreen for given DOM element
     * @param {Node} el The element
     * @param {Boolean} t Fullscreen state
     */

  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen(el, t) {
      if (typeof t === 'boolean') {
        triggerFullscreen(el, t);
      } else {
        var prev = this._$fullscreen;
        if (prev && prev !== el) {
          triggerFullscreen(prev, false);
        }
        triggerFullscreen(el, prev !== el);
      }

      this._$fullscreen = el;
    }

    /////////////////////////////////////////////////////////////////////////////
    // EVENT HANDLERS
    /////////////////////////////////////////////////////////////////////////////

    /**
     * When Key Down Event received
     *
     * @param   {Event}        ev      DOM Event
     * @param   {Window}       win     Active window
     */

  }, {
    key: 'onKeyDown',
    value: function onKeyDown(ev, win) {}
    // Implement in your WM


    /**
     * When orientation of device has changed
     *
     * @param   {Event}    ev             DOM Event
     * @param   {String}   orientation    Orientation string
     */

  }, {
    key: 'onOrientationChange',
    value: function onOrientationChange(ev, orientation) {
      console.info('ORIENTATION CHANGED', ev, orientation);

      document.body.setAttribute('data-orientation', orientation);

      this._onDisplayChange();
    }

    /**
     * When size of the device display has been changed
     *
     * @param   {Event}    ev             DOM Event
     */

  }, {
    key: 'onResize',
    value: function onResize(ev) {
      this._onDisplayChange();
      this._emit('resized');
    }

    /**
     * When session has been loaded
     *
     * @return {Boolean}
     */

  }, {
    key: 'onSessionLoaded',
    value: function onSessionLoaded() {
      if (this._sessionLoaded) {
        return false;
      }

      this._sessionLoaded = true;
      return true;
    }

    /////////////////////////////////////////////////////////////////////////////
    // BASE EVENT HANDLERS
    /////////////////////////////////////////////////////////////////////////////

  }, {
    key: '_onMouseEnter',
    value: function _onMouseEnter(ev) {
      this._mouselock = true;
    }
  }, {
    key: '_onMouseLeave',
    value: function _onMouseLeave(ev) {
      var from = ev.relatedTarget || ev.toElement;
      if (!from || from.nodeName === 'HTML') {
        this._mouselock = false;
      } else {
        this._mouselock = true;
      }
    }
  }, {
    key: '_onDisplayChange',
    value: function _onDisplayChange() {
      var _this4 = this;

      this._dcTimeout = clearTimeout(this._dcTimeout);
      this._dcTimeout = setTimeout(function () {
        if (!_this4._windows) {
          return;
        }

        _this4.getWindows().forEach(function (w) {
          w._onResize();
          w._emit('resize');
        });
      }, 100);

      document.body.setAttribute('data-responsive', String(this._isResponsive));
    }
  }, {
    key: '_onOrientationChange',
    value: function _onOrientationChange(ev) {
      var orientation = 'landscape';
      if (window.screen && window.screen.orientation) {
        if (window.screen.orientation.type.indexOf('portrait') !== -1) {
          orientation = 'portrait';
        }
      }

      this.onOrientationChange(ev, orientation);
    }
  }, {
    key: '_onHashChange',
    value: function _onHashChange(ev) {
      var hash = window.location.hash.substr(1);
      var spl = hash.split(/^([\w\.\-_]+)\:(.*)/);

      function getArgs(q) {
        var args = {};
        q.split('&').forEach(function (a) {
          var b = a.split('=');
          var k = decodeURIComponent(b[0]);
          args[k] = decodeURIComponent(b[1] || '');
        });
        return args;
      }

      if (spl.length === 4) {
        var root = spl[1];
        var args = getArgs(spl[2]);

        if (root) {
          _process2.default.getProcess(root).forEach(function (p) {
            p._onMessage('hashchange', {
              hash: hash,
              args: args
            }, { source: null });
          });
        }
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize(ev) {
      var _this5 = this;

      clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(function () {
        var space = _this5.getWindowSpace();
        _this5.resize(ev, space);
      }, 100);
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(ev) {
      if (ev.target === document || ev.target === document.body) {
        ev.preventDefault();
        ev.stopPropagation();
        return false;
      }

      document.body.scrollTop = 0;
      document.body.scrollLeft = 0;
      return true;
    }
  }, {
    key: '_onFullscreen',
    value: function _onFullscreen(ev) {
      try {
        var notif = _notification2.default.getIcon('_FullscreenNotification');
        if (notif) {
          if (!document.fullScreen && !document.mozFullScreen && !document.webkitIsFullScreen && !document.msFullscreenElement) {
            notif.opts._isFullscreen = false;
            notif.setImage(_theme2.default.getIcon('actions/view-fullscreen.png', '16x16'));
          } else {
            notif.opts._isFullscreen = true;
            notif.setImage(_theme2.default.getIcon('actions/view-restore.png', '16x16'));
          }
        }
      } catch (e) {
        console.warn(e.stack, e);
      }
    }
  }, {
    key: '_onContextMenu',
    value: function _onContextMenu(ev) {
      this.onContextMenu(ev);

      if (DOM.$isFormElement(ev)) {
        Menu.blur();
      } else {
        ev.preventDefault();
        return false;
      }

      return true;
    }
  }, {
    key: '_onMouseDown',
    value: function _onMouseDown(ev) {
      if (DOM.$isFormElement(ev)) {
        this._$lastDomInput = ev.target;
      } else {
        if (this._$lastDomInput) {
          try {
            this._$lastDomInput.blur();
          } catch (e) {}

          this._$lastDomInput = null;
        }
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(ev) {
      var hitWindow = void 0,
          hitMenu = void 0;
      var el = ev.target;

      while (el.parentNode) {
        if (el.tagName.match(/^GUI\-MENU/)) {
          hitMenu = el;
        } else if (el.tagName.match(/^APPLICATION\-WINDOW/)) {
          hitWindow = true;
        }

        if (hitWindow || hitMenu) {
          break;
        }

        el = el.parentNode;
      }

      // We should hide the menu if the clicked entry does not match up with
      // the following conditions
      if (hitMenu) {
        if (hitMenu.tagName === 'GUI-MENU-ENTRY') {
          if (hitMenu.getAttribute('data-disabled') !== 'true') {
            if (!DOM.$hasClass(hitMenu, 'gui-menu-expand')) {
              hitMenu = null;
            }
          }
        } else if (hitMenu.tagName === 'GUI-MENU-BAR') {
          hitMenu = null;
        }
      }

      if (!hitMenu) {
        Menu.blur();
      }

      // Blur menu if we click body
      if (ev.target.tagName === 'BODY') {
        var win = this.getCurrentWindow();
        if (win) {
          win._blur();
        }
      }

      _theme2.default.themeAction('event', [ev]);
    }
  }, {
    key: '_onKeyUp',
    value: function _onKeyUp(ev) {
      var win = this.getCurrentWindow();

      this.onKeyUp(ev, win);

      if (win) {
        return win._onKeyEvent(ev, 'keyup');
      }

      return true;
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(ev) {
      var _this6 = this;

      var win = this.getCurrentWindow();

      var reacted = function () {
        var combination = _this6.onKeyDown(ev, win);
        if (win && !combination) {
          win._onKeyEvent(ev, 'keydown');
        }
        return combination;
      }();

      if (checkPrevent(ev, win) || reacted) {
        ev.preventDefault();
      }

      return true;
    }
  }, {
    key: '_onKeyPress',
    value: function _onKeyPress(ev) {
      if (checkForbiddenKeyCombo(ev)) {
        ev.preventDefault();
      }

      var win = this.getCurrentWindow();
      if (win) {
        return win._onKeyEvent(ev, 'keypress');
      }
      return true;
    }
  }, {
    key: '_onBeforeUnload',
    value: function _onBeforeUnload(ev) {
      if ((0, _config.getConfig)('ShowQuitWarning')) {
        return (0, _locales._)('MSG_SESSION_WARNING');
      }
      return null;
    }
  }, {
    key: '_onError',
    value: function _onError(message, url, linenumber, column, exception) {
      if (typeof exception === 'string') {
        exception = null;
      }

      exception = exception || {
        name: 'window::onerror()',
        fileName: url,
        lineNumber: linenumber + ':' + column,
        message: message
      };

      console.warn('window::onerror()', arguments);

      OSjs.error((0, _locales._)('ERR_JAVASCRIPT_EXCEPTION'), (0, _locales._)('ERR_JAVACSRIPT_EXCEPTION_DESC'), (0, _locales._)('BUGREPORT_MSG'), exception, true);

      return false;
    }

    /////////////////////////////////////////////////////////////////////////////
    // GETTERS AND SETTERS
    /////////////////////////////////////////////////////////////////////////////

    /**
     * Get default Settings
     *
     * @return  {Object}      JSON Data
     */

  }, {
    key: 'getDefaultSetting',
    value: function getDefaultSetting() {
      // Implement in your WM
      return null;
    }

    /**
     * Get panel
     *
     * @return {OSjs.Applications.CoreWM.Panel}
     */

  }, {
    key: 'getPanel',
    value: function getPanel() {
      // Implement in your WM
      return null;
    }

    /**
     * Gets all panels
     *
     * @return  {OSjs.Packages.CoreWM.Panel[]}       Panel List
     */

  }, {
    key: 'getPanels',
    value: function getPanels() {
      // Implement in your WM
      return [];
    }

    /**
     * Sets a setting
     *
     * @param   {String}  k       Key
     * @param   {*}       v       Value
     *
     * @return  {Boolean}             On success
     */

  }, {
    key: 'setSetting',
    value: function setSetting(k, v) {
      return this._settings.set(k, v);
    }

    /**
     * Gets the rectangle for window space
     *
     * @return    {Object} rectangle
     */

  }, {
    key: 'getWindowSpace',
    value: function getWindowSpace() {
      return {
        top: 0,
        left: 0,
        width: document.body.offsetWidth,
        height: document.body.offsetHeight
      };
    }

    /**
     * Get next window position
     *
     * @return    {Object} rectangle
     */

  }, {
    key: 'getWindowPosition',
    value: function getWindowPosition() {
      var winCount = this._windows.reduce(function (count, win) {
        return win === null ? count : count + 1;
      }, 0);
      return { x: 10 * winCount, y: 10 * winCount };
    }

    /**
     * Gets a setting
     *
     * @param   {String}    k     Key
     *
     * @return  {*}           Setting value or 'null'
     */

  }, {
    key: 'getSetting',
    value: function getSetting(k) {
      return this._settings.get(k);
    }

    /**
     * Gets all settings
     *
     * @return    {Object}        JSON With all settings
     */

  }, {
    key: 'getSettings',
    value: function getSettings() {
      return this._settings.get();
    }

    /**
     * Gets all Windows
     *
     * @return    {Window[]}           List of all Windows
     */

  }, {
    key: 'getWindows',
    value: function getWindows() {
      return this._windows.filter(function (w) {
        return !!w;
      });
    }

    /**
     * Gets current Window
     *
     * @return {Window}        Current Window or 'null'
     */

  }, {
    key: 'getCurrentWindow',
    value: function getCurrentWindow() {
      return this._currentWin;
    }

    /**
     * Sets the current Window
     *
     * @param   {Window}    w       Window
     */

  }, {
    key: 'setCurrentWindow',
    value: function setCurrentWindow(w) {
      this._currentWin = w || null;
    }

    /**
     * Gets previous Window
     *
     * @return {Window}        Current Window or 'null'
     */

  }, {
    key: 'getLastWindow',
    value: function getLastWindow() {
      return this._lastWin;
    }

    /**
     * Sets the last Window
     *
     * @param   {Window}    w       Window
     */

  }, {
    key: 'setLastWindow',
    value: function setLastWindow(w) {
      this._lastWin = w || null;
    }

    /**
     * If the pointer is inside the browser window
     *
     * @return  {Boolean}
     */

  }, {
    key: 'getMouseLocked',
    value: function getMouseLocked() {
      return this._mouselock;
    }
  }]);

  return WindowManager;
}(_process2.default);

exports.default = WindowManager;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickWrapper = clickWrapper;
exports.clamp = clamp;
exports.blur = blur;
exports.create = create;
exports.setActive = setActive;

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

var _windowManager = __webpack_require__(89);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _hooks = __webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
var lastMenu = void 0;

function clickWrapper(ev, pos, onclick, original) {
  ev.stopPropagation();

  var t = ev.target;
  if (t && t.tagName === 'LABEL') {
    t = t.parentNode;
  }

  var isExpander = false;
  if (t && t.tagName === 'GUI-MENU-ENTRY') {
    var subMenu = t.querySelector('gui-menu');
    isExpander = !!subMenu;

    try {
      // Only do this on non-mouse devices
      if (isExpander && !ev.isTrusted) {
        t.parentNode.querySelectorAll('gui-menu-entry').forEach(function (pn) {
          DOM.$removeClass(pn, 'active');
        });

        DOM.$addClass(t, 'active');
      }
    } catch (e) {
      console.warn(e);
    }

    onclick(ev, pos, t, original, isExpander);
  }
}

function clamp(r) {
  function _clamp(rm) {
    rm.querySelectorAll('gui-menu-entry').forEach(function (srm) {
      var sm = srm.querySelector('gui-menu');
      if (sm) {
        sm.style.left = String(-parseInt(sm.offsetWidth, 10)) + 'px';
        _clamp(sm);
      }
    });
  }

  var pos = DOM.$position(r);
  if (pos && window.innerWidth - pos.right < r.offsetWidth) {
    DOM.$addClass(r, 'gui-overflowing');
    _clamp(r);
  }

  // this class is used in caclulations (DOM needs to be visible for that)
  DOM.$addClass(r, 'gui-showing');
}

function clampSubMenu(sm) {
  if (sm) {
    var pos = DOM.$position(sm);
    var wm = _windowManager2.default.instance;
    var space = wm.getWindowSpace(true);

    if (pos) {
      var diff = space.height - pos.bottom;
      if (diff < 0) {
        sm.style.marginTop = String(diff) + 'px';
      }
    }
  }
}

/**
 * Blur the currently open menu (aka hiding)
 *
 * @param {Event} [ev] Browser event
 */
function blur(ev) {
  if (lastMenu) {
    lastMenu(ev);
  }
  lastMenu = null;

  (0, _hooks.triggerHook)('menuBlur');
}

/**
 * Create and show a new menu
 *
 * @example
 * create([
 *    {
 *      title: "Title",
 *      icon: "Icon",
 *      onClick: function() {}, // Callback
 *      menu: [] // Recurse :)
 *    }
 * ])
 *
 * @param   {Array}                items             Array of items
 * @param   {(Event|Object)}       ev                DOM Event or dict with x/y
 * @param   {Object}               [customInstance]  Show a custom created menu
 */
function create(items, ev, customInstance) {
  items = items || [];

  blur(ev);

  var root = customInstance;
  var callbackMap = [];

  function resolveItems(arr, par) {
    arr.forEach(function (iter) {
      var props = { label: iter.title, icon: iter.icon, disabled: iter.disabled, labelHTML: iter.titleHTML, type: iter.type, checked: iter.checked };
      var entry = GUI.createElement('gui-menu-entry', props);
      if (iter.menu) {
        var nroot = GUI.createElement('gui-menu', {});
        resolveItems(iter.menu, nroot);
        entry.appendChild(nroot);
      }
      if (iter.onClick) {
        var index = callbackMap.push(iter.onClick);
        entry.setAttribute('data-callback-id', String(index - 1));
      }
      par.appendChild(entry);
    });
  }

  if (!root) {
    root = GUI.createElement('gui-menu', {});
    resolveItems(items || [], root);

    _element2.default.createFromNode(root, null, 'gui-menu').build(true);

    Events.$bind(root, 'mouseover', function (ev, pos) {
      if (ev.target && ev.target.tagName === 'GUI-MENU-ENTRY') {
        setTimeout(function () {
          clampSubMenu(ev.target.querySelector('gui-menu'));
        }, 1);
      }
    }, true);

    Events.$bind(root, 'click', function (ev, pos) {
      clickWrapper(ev, pos, function (ev, pos, t, orig, isExpander) {
        var index = parseInt(t.getAttribute('data-callback-id'), 10);
        if (callbackMap[index]) {
          callbackMap[index](ev, pos);
        }

        if (!isExpander) {
          blur(ev);
        }
      });
    }, true);
  }

  if (root.$element) {
    root = root.$element;
  }

  var wm = _windowManager2.default.instance;
  var space = wm.getWindowSpace(true);
  var pos = Events.mousePosition(ev);

  DOM.$addClass(root, 'gui-root-menu');
  root.style.left = pos.x + 'px';
  root.style.top = pos.y + 'px';
  document.body.appendChild(root);

  // Make sure it stays within viewport
  setTimeout(function () {
    var pos = DOM.$position(root);
    if (pos) {
      if (pos.right > space.width) {
        var newLeft = Math.round(space.width - pos.width);
        root.style.left = Math.max(0, newLeft) + 'px';
      }
      if (pos.bottom > space.height) {
        var newTop = Math.round(space.height - pos.height);
        root.style.top = Math.max(0, newTop) + 'px';
      }
    }

    clamp(root);

    lastMenu = function lastMenu() {
      callbackMap = [];
      if (root) {
        root.querySelectorAll('gui-menu-entry').forEach(function (el) {
          Events.$unbind(el);
        });
        Events.$unbind(root);
      }
      root = DOM.$remove(root);
    };
  }, 1);
}

function setActive(menu) {
  blur();

  lastMenu = menu;
}

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _instance = void 0;

/**
 * Storage Base Class
 *
 * @abstract
 */

var Storage = function () {
  _createClass(Storage, null, [{
    key: 'instance',
    get: function get() {
      return _instance;
    }
  }]);

  function Storage() {
    _classCallCheck(this, Storage);

    /* eslint consistent-this: "off" */
    _instance = this;

    this.saveTimeout = null;
  }

  /**
   * Initializes the Storage
   * @return {Promise<undefined, Error>}
   */


  _createClass(Storage, [{
    key: 'init',
    value: function init() {
      return _bluebird2.default.resolve();
    }

    /**
     * Destroys the Storage
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _instance = null;
    }

    /**
     * Default method to save given settings pool
     *
     * @param  {String}           [pool]        Pool Name
     * @param  {*}                storage       Storage data
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'saveSettings',
    value: function saveSettings(pool, storage) {
      var _this = this;

      clearTimeout(this.saveTimeout);

      return new _bluebird2.default(function (resolve, reject) {
        _this.saveTimeout = setTimeout(function () {
          _connection2.default.request('settings', { pool: pool, settings: Object.assign({}, storage) }).then(resolve).catch(reject);
          clearTimeout(_this.saveTimeout);
        }, 250);
      });
    }

    /**
     * Default method for saving current sessions
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'saveSession',
    value: function saveSession() {
      return new _bluebird2.default(function (resolve, reject) {
        var data = _process2.default.getProcesses().filter(function (proc) {
          return typeof proc._getSessionData === 'function';
        }).map(function (proc) {
          return proc._getSessionData();
        });

        _settingsManager2.default.set('UserSession', null, data, function (err, res) {
          return err ? reject(err) : resolve(res);
        });
      });
    }

    /**
     * Get last saved sessions
     * @return {Promise<Object[], Error>}
     */

  }, {
    key: 'getLastSession',
    value: function getLastSession() {
      var res = _settingsManager2.default.get('UserSession');
      var list = (res || []).map(function (iter) {
        var args = iter.args;
        args.__resume__ = true;
        args.__windows__ = iter.windows || [];
        return { name: iter.name, args: args };
      });

      return _bluebird2.default.resolve(list);
    }
  }]);

  return Storage;
}();

exports.default = Storage;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _instance = void 0;

/**
 * Authenticator Base Class
 *
 * @abstract
 */

var Authenticator = function () {
  _createClass(Authenticator, null, [{
    key: 'instance',
    get: function get() {
      return _instance;
    }
  }]);

  function Authenticator() {
    _classCallCheck(this, Authenticator);

    /* eslint consistent-this: "off" */
    _instance = this;

    /**
     * User data
     * @type {Object}
     * @example
     * {
     *  id: -1,
     *  username: 'foo',
     *  groups: []
     * }
     */
    this.userData = {
      id: 0,
      username: 'root',
      name: 'root user',
      groups: ['admin']
    };

    /**
     * If user is logged in
     * @type {Boolean}
     */
    this.loggedIn = false;

    /**
     * If we're in standalone
     */
    this.isStandalone = false;
  }

  /**
   * Initializes the Authenticator
   * @return {Promise}
   */


  _createClass(Authenticator, [{
    key: 'init',
    value: function init() {
      return this.createUI();
    }

    /**
     * Destroys the Authenticator
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _instance = null;
    }

    /**
     * Get data for logged in user
     *
     * @return  {Object}      JSON With user data
     */

  }, {
    key: 'getUser',
    value: function getUser() {
      return Object.assign({}, this.userData);
    }

    /**
     * Gets if there is a user logged in
     *
     * @return {Boolean}
     */

  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      return this.isLoggedIn;
    }

    /**
     * Log in user
     *
     * @param  {Object}   data            Login form data
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'login',
    value: function login(data) {
      return new _bluebird2.default(function (resolve, reject) {
        _connection2.default.request('login', data).then(function (result) {
          return resolve(result ? result : (0, _locales._)('ERR_LOGIN_INVALID'));
        }).catch(function (error) {
          reject(new Error((0, _locales._)('ERR_LOGIN_FMT', error)));
        });
      });
    }

    /**
     * Log out user
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'logout',
    value: function logout() {
      return new _bluebird2.default(function (resolve, reject) {
        _connection2.default.request('logout', {}).then(function (result) {
          return resolve(!!result);
        }).catch(function (err) {
          reject(new Error('An error occured: ' + err));
        });
      });
    }

    /**
     * Checks the given permission (groups) against logged in user
     *
     * @param   {String|String[]}     group         Either a string or array of groups
     *
     * @return {Boolean}
     */

  }, {
    key: 'checkPermission',
    value: function checkPermission(group) {
      var user = this.getUser();
      var userGroups = user.groups || [];

      if (!(group instanceof Array)) {
        group = [group];
      }

      if (userGroups.indexOf('admin') === -1) {
        return !!group.every(function (g) {
          return userGroups.indexOf(g) >= 0;
        });
      }

      return true;
    }

    /**
     * When login is requested
     *
     * @param  {Object}               data            Login data
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'requestLogin',
    value: function requestLogin(data) {
      var _this = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this.login(data).then(function (res) {
          return _this.onLogin(res).then(resolve).catch(reject);
        }).catch(reject);
      });
    }

    /**
     * When login has occured
     *
     * @param   {Object}               data            User data
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'onLogin',
    value: function onLogin(data) {
      var userSettings = data.userSettings;
      if (!userSettings || userSettings instanceof Array) {
        userSettings = {};
      }

      this.userData = data.userData;

      // Ensure we get the user-selected locale configured from WM
      function getLocale() {
        var curLocale = (0, _config.getConfig)('Locale');
        var detectedLocale = (0, _config.getUserLocale)();

        if ((0, _config.getConfig)('LocaleOptions.AutoDetect', true) && detectedLocale) {
          console.info('Auto-detected user locale via browser', detectedLocale);
          curLocale = detectedLocale;
        }

        var result = _settingsManager2.default.get('CoreWM');
        if (!result) {
          try {
            result = userSettings.CoreWM;
          } catch (e) {}
        }
        return result ? result.language || curLocale : curLocale;
      }

      document.getElementById('LoadingScreen').style.display = 'block';

      (0, _locales.setLocale)(getLocale());
      _settingsManager2.default.init(userSettings);

      if (data.blacklistedPackages) {
        _packageManager2.default.setBlacklist(data.blacklistedPackages);
      }

      this.loggedIn = true;

      return _bluebird2.default.resolve(true);
    }

    /**
     * When login UI is requested
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'createUI',
    value: function createUI() {
      this._renderUI();
      return this._createUI();
    }
  }, {
    key: '_renderUI',
    value: function _renderUI(html) {
      if (!html) {
        html = __webpack_require__(487);
      }

      var tempNode = document.createElement('div');
      tempNode.innerHTML = html;
      tempNode.childNodes.forEach(function (n) {
        var nn = n.cloneNode(true);
        if (['STYLE', 'SCRIPT'].indexOf(n.tagName) === -1) {
          document.body.appendChild(nn);
        } else {
          document.querySelector('head').appendChild(nn);
        }
      });
    }
  }, {
    key: '_createUI',
    value: function _createUI() {
      var _this2 = this;

      var container = document.getElementById('Login');
      var login = document.getElementById('LoginForm');
      var u = document.getElementById('LoginUsername');
      var p = document.getElementById('LoginPassword');
      var s = document.getElementById('LoginSubmit');

      function _restore() {
        s.removeAttribute('disabled');
        u.removeAttribute('disabled');
        p.removeAttribute('disabled');
      }

      function _lock() {
        s.setAttribute('disabled', 'disabled');
        u.setAttribute('disabled', 'disabled');
        p.setAttribute('disabled', 'disabled');
      }

      container.style.display = 'block';
      _restore();

      return new _bluebird2.default(function (resolve, reject) {
        login.onsubmit = function (ev) {
          _lock();
          if (ev) {
            ev.preventDefault();
          }

          _this2.requestLogin({
            username: u.value,
            password: p.value
          }).then(function () {
            container.parentNode.removeChild(container);
            return resolve();
          }).catch(function (err) {
            alert(err);
            _restore();
          });
        };
      });
    }
  }]);

  return Authenticator;
}();

exports.default = Authenticator;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _promiseLimit = __webpack_require__(488);

var _promiseLimit2 = _interopRequireDefault(_promiseLimit);

var _config = __webpack_require__(15);

var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Gets file type
 * @return {String}
 */
var getFileType = function getFileType(src) {
  if (src.match(/\.js$/i)) {
    return 'javascript';
  } else if (src.match(/\.css$/i)) {
    return 'stylesheet';
  } /* else if ( src.match(/\.html?$/i) ) {
     return 'html';
    }*/
  return 'unknown';
};

/*
 * Ensures correct base uris
 * @return {String}
 */
var getSource = function getSource(src) {
  if (src && !src.match(/^(\/|file|https?)/)) {
    return (0, _config.getBrowserPath)(src);
  }
  return src;
};

/*
 * Check if CSS has been loaded
 * @return {Boolean}
 */
var checkCss = function checkCss(path) {
  var result = false;
  (document.styleSheet || []).forEach(function (iter, i) {
    if (iter.href.indexOf(path) !== -1) {
      result = true;
      return false;
    }
    return true;
  });
  return result;
};

/*
 * Preload File Type Handlers
 */
var handlers = {
  javascript: function javascript(src) {
    return new _bluebird2.default(function (resolve, reject) {
      var el = document.createElement('script');
      el.onreadystatechange = function () {
        if (this.readyState === 'complete' || this.readyState === 'loaded') {
          resolve();
        }
      };
      el.onerror = function (err) {
        var error = new Error();
        error.name = '<script> error';
        error.message = 'Failed to load script';
        reject(error);
      };
      el.onload = function () {
        return resolve();
      };
      el.src = src;

      document.getElementsByTagName('head')[0].appendChild(el);
    });
  },

  stylesheet: function stylesheet(src) {
    return new _bluebird2.default(function (resolve, reject) {
      var timeout = void 0;

      var onerror = function onerror(str) {
        clearTimeout(timeout);

        var error = new Error();
        error.name = '<link> error';
        error.message = str;
        reject(error);
      };

      var link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.onload = function () {
        return resolve();
      };
      link.onerror = function (err) {
        return onerror('Failed to load link');
      };
      link.setAttribute('href', src);

      document.getElementsByTagName('head')[0].appendChild(link);

      timeout = setTimeout(function () {
        onerror('Loading stylesheet timed out');
      }, 30000);

      setTimeout(function () {
        if (checkCss(src)) {
          clearTimeout(timeout);
          resolve();
        }
      }, 10);
    });
  },

  html: function html(src) {
    return new _bluebird2.default(function (resolve, reject) {
      _axios2.default.get(src).then(function (result) {
        return resolve(result.data);
      }).catch(function (err) {
        return reject(err.message);
      });
    });
  }

};

/**
 * Asset preloading class
 */

var Preloader = function () {
  function Preloader() {
    _classCallCheck(this, Preloader);

    this.cache = {};
  }

  _createClass(Preloader, [{
    key: 'clear',
    value: function clear() {
      this.cache = {};
    }

    /**
     * Preloads a given set of assets
     *
     * @param {Object[]}   preloads             The list
     * @param {Object}     [args]               Arguments
     * @param {Number}     [args.max=1]         Maximum number of parallel fetches
     * @param {Boolean}    [args.cache=true]    Cache the result
     * @param {Boolean}    [args.force=false]   Force loading even though in cache
     * @return {Promise<Object, Error>}
     *
     * @example
     * [
     *  {
     *
     *    "type": "javascript" // or "stylesheet",
     *    "src": "url/uri",
     *    "force": true // force to load even (reload)
     *  },
     *  "mycoolscript.js",
     *  "mycoolstyle.css"
     * ]
     */

  }, {
    key: 'preload',
    value: function preload(preloads, args) {
      var _this = this;

      args = args || {};

      preloads = preloads.map(function (p) {
        if (typeof p === 'string') {
          return {
            src: getSource(p),
            force: false,
            type: getFileType(p)
          };
        } else {
          p.src = getSource(p.src);
          if (!p.type) {
            p.type = getFileType(p.src);
          }
        }

        return p;
      }).filter(function (p) {
        return !!p.src;
      });

      console.group('Preloader.load()', preloads);

      var limit = (0, _promiseLimit2.default)(args.max || 1);
      var total = preloads.length;
      var failed = [];
      var loaded = [];
      var data = [];

      var done = function done(item, preloadData, yes) {
        if (typeof preloadData !== 'undefined') {
          data.push({ item: item, data: preloadData });
        }

        if (args.cache !== false && typeof _this.cache[item.src] === 'undefined') {
          _this.cache[item.src] = preloadData;
        }

        loaded.push(item.src);

        return yes();
      };

      var job = function job(item, index) {
        if (typeof args.progress === 'function') {
          args.progress(index, total);
        }

        if (handlers[item.type]) {
          return new _bluebird2.default(function (yes, no) {
            if (!args.force && _this.cache[item.src]) {
              done(item, _this.cache[item.src], yes);
              return;
            }

            handlers[item.type](item.src).then(function (preloadData) {
              return done(item, preloadData, yes);
            }).catch(function (e) {
              console.warn('Failed loading', item.src, e);
              failed.push(item.src);
              return yes();
            });
          });
        }

        return _bluebird2.default.resolve();
      };

      return new _bluebird2.default(function (resolve, reject) {
        _bluebird2.default.all(preloads.map(function (iter, index) {
          return limit(function () {
            return job(iter, index);
          });
        })).then(function () {
          console.groupEnd();

          return resolve({
            success: false,
            data: data,
            failed: failed,
            loaded: loaded
          });
        }).catch(reject);
      });
    }
  }]);

  return Preloader;
}();

exports.default = new Preloader();

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _application = __webpack_require__(124);

var _application2 = _interopRequireDefault(_application);

var _windowManager = __webpack_require__(89);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

var _scheme = __webpack_require__(190);

var _scheme2 = _interopRequireDefault(_scheme);

var _eventHandler = __webpack_require__(122);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _compability = __webpack_require__(123);

var Compability = _interopRequireWildcard(_compability);

var _keycodes = __webpack_require__(88);

var Keycodes = _interopRequireWildcard(_keycodes);

var _menu = __webpack_require__(90);

var Menu = _interopRequireWildcard(_menu);

var _locales = __webpack_require__(10);

var _init = __webpack_require__(184);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The predefined events are as follows:
 * <pre><code>
 *  init          When window is being inited and rendered  => (root, scheme)
 *  inited        When window has been inited and rendered  => (scheme)
 *  focus         When window gets focus                    => ()
 *  blur          When window loses focus                   => ()
 *  destroy       When window is closed                     => ()
 *  maximize      When window is maxmimized                 => ()
 *  minimize      When window is minimized                  => ()
 *  restore       When window is restored                   => ()
 *  resize        When window is resized                    => (w, h)
 *  resized       Triggers after window is resized          => (w, h)
 *  move          When window is moved                      => (x, y)
 *  moved         Triggers after window is moved            => (x, y)
 *  keydown       When keydown                              => (ev, keyCode, shiftKey, ctrlKey, altKey)
 *  keyup         When keyup                                => (ev, keyCode, shiftKey, ctrlKey, altKey)
 *  keypress      When keypress                             => (ev, keyCode, shiftKey, ctrlKey, altKey)
 *  drop          When a drop event occurs                  => (ev, type, item, args, srcEl)
 *  drop:upload   When a upload file was dropped            => (ev, <File>, args)
 *  drop:file     When a internal file object was dropped   => (ev, VFS.File, args, srcEl)
 * </code></pre>
 * @typedef WindowEvent
 */

function camelCased(str) {
  return str.replace(/_([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

/*
 * Get next z-index for Window
 * @return integer
 */
var getNextZindex = function () {
  var _lzindex = 1;
  var _ltzindex = 100000;

  return function (ontop) {
    if (typeof ontop !== 'undefined' && ontop === true) {
      return _ltzindex += 2;
    }
    return _lzindex += 2;
  };
}();

/*
 * Get viewport (Wrapper)
 *
 * @return {Object}
 */
function getWindowSpace() {
  var wm = _windowManager2.default.instance;
  if (wm) {
    return wm.getWindowSpace();
  }

  return {
    top: 0,
    left: 0,
    width: document.body.offsetWidth,
    height: document.body.offsetHeight
  };
}

/*
 * Wrapper to wait for animations to finish
 */
function waitForAnimation(win, cb) {
  var wm = _windowManager2.default.instance;
  var anim = wm ? wm.getSetting('animations') : false;
  if (anim) {
    win._animationCallback = cb;
  } else {
    cb();
  }
}

/*
 * Creates media queries from configuration file
 */
var createMediaQueries = function () {
  var queries = void 0;

  function _createQueries() {
    var result = {};

    var wm = _windowManager2.default.instance;
    if (wm) {
      var qs = wm.getDefaultSetting('mediaQueries') || {};

      Object.keys(qs).forEach(function (k) {
        if (qs[k]) {
          result[k] = function (w, h, ref) {
            return w <= qs[k];
          };
        }
      });
    }

    return result;
  }

  return function () {
    if (!queries) {
      queries = _createQueries();
    }
    return queries;
  };
}();

/*
 * Checks window dimensions and makes media queries dynamic
 */
function checkMediaQueries(win) {
  var wm = _windowManager2.default.instance;
  if (!win._$element || !wm) {
    return;
  }

  var n = '';
  var k = void 0;

  var qs = win._properties.media_queries || {};
  var w = win._$element.offsetWidth;
  var h = win._$element.offsetHeight;

  for (k in qs) {
    if (qs.hasOwnProperty(k)) {
      if (qs[k](w, h, win)) {
        n = k;
        break;
      }
    }
  }

  win._$element.setAttribute('data-media', n);
}

/////////////////////////////////////////////////////////////////////////////
// WINDOW
/////////////////////////////////////////////////////////////////////////////

var _WID = 0;
var _DEFAULT_WIDTH = 200;
var _DEFAULT_HEIGHT = 200;
var _DEFAULT_MIN_HEIGHT = 150;
var _DEFAULT_MIN_WIDTH = 150;
var _DEFAULT_SND_VOLUME = 1.0;
var _NAMES = [];

/**
 * Base Window Class
 *
 * @desc Class used for creating windows.
 *
 * @abstract
 * @mixes EventHandler
 * @throws {Error} On invalid arguments
 */

var Window = function () {

  /**
   * @param   {String}        name                     Window name (unique)
   * @param   {Object}        opts                     List of options
   * @param   {String}        opts.title               Window Title
   * @param   {String}        opts.icon                Window Icon
   * @param   {Number}        [opts.x]                 X Position
   * @param   {Number}        [opts.y]                 Y Position
   * @param   {Number}        [opts.width]             Width
   * @param   {Number}        [opts.height]            Height
   * @param   {String}        [opts.tag]               Window Tag
   * @param   {String}        [opts.gravity]           Window Gravity
   * @param   {boolean}       [opts.auto_size=false]   Window automatically fills to content on init
   * @param   {boolean}       [opts.allow_move]        Allow movment
   * @param   {boolean}       [opts.allow_resize]      Allow resize
   * @param   {boolean}       [opts.allow_minimize]    Allow minimize
   * @param   {boolean}       [opts.allow_maximize]    Allow maximize
   * @param   {boolean}       [opts.allow_close]       Allow closing
   * @param   {boolean}       [opts.allow_windowlist]  Allow appear in WindowList (Panel)
   * @param   {boolean}       [opts.allow_drop]        Allow DnD
   * @param   {boolean}       [opts.allow_iconmenu]    Allow Menu when click on Window Icon
   * @param   {boolean}       [opts.allow_ontop]       Allow ontop
   * @param   {boolean}       [opts.allow_hotkeys]     Allow usage of hotkeys
   * @param   {boolean}       [opts.allow_session]     Allow to store for session
   * @param   {boolean}       [opts.key_capture]       Allow key capture (UNSUSED ?!)
   * @param   {boolean}       [opts.min_width]         Minimum allowed width
   * @param   {boolean}       [opts.min_height]        Minimum allowed height
   * @param   {boolean}       [opts.max_width]         Maximum allowed width
   * @param   {boolean}       [opts.max_height]        Maximum allowed height
   * @param   {Object}        [opts.media_queries]     Media queries to apply CSS attribute => {name: fn(w,h,win) => Boolean }
   * @param   {String}        [opts.sound]             Sound name when window is displayed
   * @param   {Number}        [opts.sound_volume]      Sound volume
   * @param   {Function}      [opts.translator]        Translation method
   * @param   {Application}   appRef                   Application Reference
   */
  function Window(name, opts, appRef) {
    var _this = this;

    _classCallCheck(this, Window);

    if (_NAMES.indexOf(name) >= 0) {
      throw new Error((0, _locales._)('ERR_WIN_DUPLICATE_FMT', name));
    }

    if (appRef && !(appRef instanceof _application2.default)) {
      throw new TypeError('appRef given was not instance of Application');
    }

    opts = Object.assign({}, {
      icon: _theme2.default.getIcon('apps/preferences-system-windows.png'),
      width: _DEFAULT_WIDTH,
      height: _DEFAULT_HEIGHT,
      title: name,
      tag: name,
      auto_size: false
    }, opts);

    console.group('Window::constructor()', _WID, arguments);

    /**
     * The outer container
     * @type {Node}
     */
    this._$element = null;

    /**
     * The inner (content) container
     * @type {Node}
     */
    this._$root = null;

    /**
     * The top container
     * @type {Node}
     */
    this._$top = null;

    /**
     * The icon element
     * @type {Node}
     */
    this._$winicon = null;

    /**
     * The loading overlay
     * @type {Node}
     */
    this._$loading = null;

    /**
     * The disabled overlay
     * @type {Node}
     */
    this._$disabled = null;

    /**
     * The resize underlay
     * @type {Node}
     */
    this._$resize = null;

    /**
     * The warning overlay
     * @type {Node}
     */
    this._$warning = null;

    /**
     * Constructor options copy
     * @type {Object}
     */
    this._opts = opts;

    /**
     * Application reference
     * @type {Application}
     */
    this._app = appRef || null;

    /**
     * If Window has been destroyed
     * @type {Boolean}
     */
    this._destroyed = false;

    /**
     * If Window was restored
     * @type {Boolean}
     */
    this._restored = false;

    /**
     * If Window is finished loading
     * @type {Boolean}
     */
    this._loaded = false;

    /**
     * If Window is finished initing
     * @type {Boolean}
     */
    this._initialized = false;

    /**
     * If Window is currently disabled
     * @type {Boolean}
     */
    this._disabled = true;

    /**
     * If Window is currently loading
     * @type {Boolean}
     */
    this._loading = false;

    /**
     * Window ID (Internal)
     * @type {Number}
     */
    this._wid = _WID;

    /**
     * Window Icon
     * @type {String}
     */
    this._icon = opts.icon;

    /**
     * Window Name
     * @type {String}
     */
    this._name = name;

    /**
     * Window Title
     * @type {String}
     */
    this._title = opts.title;

    /**
     * Window Tag (ex. Use this when you have a group of windows)
     * @type {String}
     */
    this._tag = opts.tag;

    /**
     * Window Position With x and y
     * @type {Object}
     */
    this._position = { x: opts.x, y: opts.y };

    /**
     * Window Dimension With w and h
     * @type {Object}
     */
    this._dimension = { w: opts.width, h: opts.height };

    /**
     * Children
     * @return {Window[]}
     */
    this._children = [];

    /**
     * Parent
     * @type {Window}
     */
    this._parent = null;

    /**
     * Original Window title (The one set on construct)
     * @type {String}
     */
    this._origtitle = this._title;

    /**
     * Last dimension (before window movement)
     * @type {Object}
     */
    this._lastDimension = this._dimension;

    /**
     * Last position (before window movement)
     * @type {Object}
     */
    this._lastPosition = this._position;

    /**
     * The sound this window makes when it is created
     * @type {String}
     */
    this._sound = null;

    /**
     * The volume of the window sound
     * @type {Number} Between 0.0 and 1.0
     */
    this._soundVolume = _DEFAULT_SND_VOLUME;

    /**
     * The active GUI Scheme
     * @type {GUIScheme}
     */
    this._scheme = null;

    /**
     * Window Properties
     * @type {Object}
     */
    this._properties = {
      gravity: null,
      allow_move: true,
      allow_resize: true,
      allow_minimize: true,
      allow_maximize: true,
      allow_close: true,
      allow_windowlist: true,
      allow_drop: false,
      allow_iconmenu: true,
      allow_ontop: true,
      allow_hotkeys: true,
      allow_session: true,
      key_capture: false,
      start_focused: true,
      min_width: _DEFAULT_MIN_HEIGHT,
      min_height: _DEFAULT_MIN_WIDTH,
      max_width: null,
      max_height: null,
      media_queries: createMediaQueries()
    };

    /**
     * Window State
     * @type {Object}
     */
    this._state = {
      focused: false,
      modal: false,
      minimized: false,
      maximized: false,
      ontop: false,
      onbottom: false
    };

    this._animationCallback = null;

    //
    // Internals
    //

    this._queryTimer = null;

    this._evHandler = new _eventHandler2.default(name, ['focus', 'blur', 'destroy', 'maximize', 'minimize', 'restore', 'move', 'moved', 'resize', 'resized', 'keydown', 'keyup', 'keypress', 'drop', 'drop:upload', 'drop:file']);

    //
    // Inherit properties given in arguments
    //

    Object.keys(opts).forEach(function (k) {
      if (typeof _this._properties[k] !== 'undefined') {
        _this._properties[k] = opts[k];
      } else if (typeof _this._state[k] !== 'undefined' && k !== 'focused') {
        _this._state[k] = opts[k];
      } else if (('sound', 'sound_volume').indexOf(k) !== -1) {
        _this['_' + camelCased(k)] = opts[k];
      }
    });

    //
    // Make sure that properties are correct according to requested arguments
    //

    (function (properties, position) {
      if (!properties.gravity && typeof position.x === 'undefined' || typeof position.y === 'undefined') {
        var wm = _windowManager2.default.instance;
        var np = wm ? wm.getWindowPosition() : { x: 0, y: 0 };

        position.x = np.x;
        position.y = np.y;
      }
    })(this._properties, this._position);

    (function (properties, dimension) {
      if (properties.min_height && dimension.h < properties.min_height) {
        dimension.h = properties.min_height;
      }
      if (properties.max_width && dimension.w < properties.max_width) {
        dimension.w = properties.max_width;
      }
      if (properties.max_height && dimension.h > properties.max_height) {
        dimension.h = properties.max_height;
      }
      if (properties.max_width && dimension.w > properties.max_width) {
        dimension.w = properties.max_width;
      }
    })(this._properties, this._dimension);

    (function (position, dimension) {
      if (appRef && appRef.__args && appRef.__args.__windows__) {
        appRef.__args.__windows__.forEach(function (restore) {
          if (!_this._restored && restore.name && restore.name === _this._name) {
            position.x = restore.position.x;
            position.y = restore.position.y;
            if (_this._properties.allow_resize) {
              dimension.w = restore.dimension.w;
              dimension.h = restore.dimension.h;
            }

            console.info('RESTORED FROM SESSION', restore);
            _this._restored = true;
          }
        });
      }
    })(this._position, this._dimension);

    (function (properties, position, dimension, restored) {
      var grav = properties.gravity;
      if (grav && !restored) {
        if (grav === 'center') {
          position.y = window.innerHeight / 2 - _this._dimension.h / 2;
          position.x = window.innerWidth / 2 - _this._dimension.w / 2;
        } else {
          var space = getWindowSpace();
          if (grav.match(/^south/)) {
            position.y = space.height - dimension.h;
          } else {
            position.y = space.top;
          }
          if (grav.match(/west$/)) {
            position.x = space.left;
          } else {
            position.x = space.width - dimension.w;
          }
        }
      }
    })(this._properties, this._position, this._dimension, this._restored);

    console.debug('State', this._state);
    console.debug('Properties', this._properties);
    console.debug('Position', this._position);
    console.debug('Dimension', this._dimension);
    console.groupEnd();

    _WID++;
  }

  /**
   * Initialize the Window
   *
   * This creates all elements and attaches basic events to them.
   * If you are looking for move/resize events, they are located in
   * the WindowManager.
   *
   * @param   {WindowManager}   _wm     Window Manager reference
   * @param   {Application}     _app    Application reference
   *
   * @return  {Node} The Window DOM element
   */


  _createClass(Window, [{
    key: 'init',
    value: function init(_wm, _app) {
      var _this2 = this;

      if (this._initialized || this._loaded) {
        return this._$root;
      }

      // Create DOM
      this._$element = DOM.$create('application-window', {
        className: function (n, t) {
          var classNames = ['Window', DOM.$safeName(n)];
          if (t && n !== t) {
            classNames.push(DOM.$safeName(t));
          }
          return classNames;
        }(this._name, this._tag).join(' '),
        style: {
          width: this._dimension.w + 'px',
          height: this._dimension.h + 'px',
          top: this._position.y + 'px',
          left: this._position.x + 'px',
          zIndex: getNextZindex(this._state.ontop)
        },
        data: {
          window_id: this._wid,
          allow_resize: this._properties.allow_resize,
          allow_minimize: this._properties.allow_minimize,
          allow_maximize: this._properties.allow_maximize,
          allow_close: this._properties.allow_close
        },
        aria: {
          role: 'application',
          live: 'polite',
          hidden: 'false'
        }
      });

      this._$root = document.createElement('application-window-content');
      this._$resize = document.createElement('application-window-resize');

      ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'].forEach(function (i) {
        var h = document.createElement('application-window-resize-handle');
        h.setAttribute('data-direction', i);
        _this2._$resize.appendChild(h);
        h = null;
      });

      this._$loading = document.createElement('application-window-loading');
      this._$disabled = document.createElement('application-window-disabled');
      this._$top = document.createElement('application-window-top');
      this._$winicon = document.createElement('application-window-icon');
      this._$winicon.setAttribute('role', 'button');
      this._$winicon.setAttribute('aria-haspopup', 'true');
      this._$winicon.setAttribute('aria-label', 'Window Menu');

      var windowTitle = document.createElement('application-window-title');
      windowTitle.setAttribute('role', 'heading');

      // Bind events
      var preventTimeout = void 0;
      var _onanimationend = function _onanimationend(ev) {
        if (typeof _this2._animationCallback === 'function') {
          clearTimeout(preventTimeout);
          preventTimeout = setTimeout(function () {
            _this2._animationCallback(ev);
            _this2._animationCallback = false;
            preventTimeout = clearTimeout(preventTimeout);
          }, 10);
        }
      };

      Events.$bind(this._$element, 'transitionend', _onanimationend);
      Events.$bind(this._$element, 'animationend', _onanimationend);
      Events.$bind(this._$element, 'click', function (ev) {
        _this2._focus();
      }, true);

      Events.$bind(this._$top, 'mouseup', function (ev) {
        var t = ev.target;
        if (t) {
          if (t.tagName.match(/^APPLICATION\-WINDOW\-BUTTON/)) {
            _this2._onWindowButtonClick(ev, t, t.getAttribute('data-action'));
          } else if (t.tagName === 'APPLICATION-WINDOW-ICON') {
            _this2._onWindowIconClick(ev);
          }
        }
      });

      Events.$bind(this._$top, 'dblclick', function () {
        _this2._maximize();
      });

      (function (properties, main, compability) {
        if (properties.allow_drop && compability.dnd) {
          var border = document.createElement('div');
          border.className = 'WindowDropRect';

          GUI.createDroppable(main, {
            onOver: function onOver(ev, el, args) {
              main.setAttribute('data-dnd-state', 'true');
            },

            onLeave: function onLeave() {
              main.setAttribute('data-dnd-state', 'false');
            },

            onDrop: function onDrop() {
              main.setAttribute('data-dnd-state', 'false');
            },

            onItemDropped: function onItemDropped(ev, el, item, args) {
              main.setAttribute('data-dnd-state', 'false');
              return _this2._onDndEvent(ev, 'itemDrop', item, args, el);
            },
            onFilesDropped: function onFilesDropped(ev, el, files, args) {
              main.setAttribute('data-dnd-state', 'false');
              return _this2._onDndEvent(ev, 'filesDrop', files, args, el);
            }
          });
        }
      })(this._properties, this._$element, Compability.getCompability());

      // Append to DOM
      windowTitle.appendChild(document.createTextNode(this._title));

      this._$top.appendChild(this._$winicon);
      this._$top.appendChild(windowTitle);
      this._$top.appendChild(DOM.$create('application-window-button-minimize', {
        className: 'application-window-button-entry',
        data: {
          action: 'minimize'
        },
        aria: {
          role: 'button',
          label: 'Minimize Window'
        }
      }));

      this._$top.appendChild(DOM.$create('application-window-button-maximize', {
        className: 'application-window-button-entry',
        data: {
          action: 'maximize'
        },
        aria: {
          role: 'button',
          label: 'Maximize Window'
        }
      }));

      this._$top.appendChild(DOM.$create('application-window-button-close', {
        className: 'application-window-button-entry',
        data: {
          action: 'close'
        },
        aria: {
          role: 'button',
          label: 'Close Window'
        }
      }));

      this._$loading.appendChild(document.createElement('application-window-loading-indicator'));
      this._$element.appendChild(this._$top);
      this._$element.appendChild(this._$root);
      this._$element.appendChild(this._$resize);
      this._$element.appendChild(this._$disabled);
      this._$element.appendChild(this._$loading);
      document.body.appendChild(this._$element);

      // Final stuff
      this._onChange('create');
      this._toggleLoading(false);
      this._toggleDisabled(false);
      this._setIcon(_theme2.default.getIcon(this._icon));
      this._updateMarkup();

      if (this._sound) {
        _theme2.default.playSound(this._sound, this._soundVolume);
      }

      this._initialized = true;
      this._emit('init', [this._$root]);

      return this._$root;
    }

    /**
     * When window is rendered and inited
     */

  }, {
    key: '_inited',
    value: function _inited() {
      var _this3 = this;

      if (this._loaded) {
        return;
      }

      this._loaded = true;

      this._onResize();

      if (!this._restored) {
        if (this._state.maximized) {
          this._maximize(true);
        } else if (this._state.minimized) {
          this._minimize(true);
        } else {
          if (this._opts.auto_size) {
            var maxWidth = 0;
            var maxHeight = 0;

            var traverseTree = function traverseTree(el) {
              el.children.forEach(function (sel) {
                maxWidth = Math.max(maxWidth, sel.offsetWidth);
                maxHeight = Math.max(maxHeight, sel.offsetHeight);
                if (sel.children.length) {
                  traverseTree(sel);
                }
              });
            };

            traverseTree(this._$root);

            this._resize(maxWidth, maxHeight, true);
          }
        }
      }

      var inittimeout = setTimeout(function () {
        _this3._emit('inited', []);
        inittimeout = clearTimeout(inittimeout);
      }, 10);

      if (this._app) {
        this._app._emit('initedWindow', [this]);
      }

      console.debug('Window::_inited()', this._name);
    }

    /**
     * Destroy the Window
     *
     * @param {Boolean}   shutdown    If the action came from a shutdown procedure
     *
     * @return  Boolean
     */

  }, {
    key: 'destroy',
    value: function destroy(shutdown) {
      var _this4 = this;

      if (this._destroyed) {
        return false;
      }

      this._emit('destroy');

      this._destroyed = true;

      var wm = _windowManager2.default.instance;

      console.group('Window::destroy()');

      // Nulls out stuff
      var _removeDOM = function _removeDOM() {
        _this4._setWarning(null);

        _this4._$root = null;
        _this4._$top = null;
        _this4._$winicon = null;
        _this4._$loading = null;
        _this4._$disabled = null;
        _this4._$resize = null;
        _this4._$warning = null;
        _this4._$element = DOM.$remove(_this4._$element);
      };

      // Removed DOM elements and their referring objects (GUI Elements etc)
      var _destroyDOM = function _destroyDOM() {
        if (_this4._$element) {
          // Make sure to remove any remaining event listeners
          _this4._$element.querySelectorAll('*').forEach(function (iter) {
            if (iter) {
              Events.$unbind(iter);
            }
          });
        }
        if (_this4._parent) {
          _this4._parent._removeChild(_this4);
        }
        _this4._parent = null;
        _this4._removeChildren();
      };

      // Destroys the window
      var _destroyWin = function _destroyWin() {
        if (wm) {
          wm.removeWindow(_this4);
        }

        var curWin = wm ? wm.getCurrentWindow() : null;
        if (curWin && curWin._wid === _this4._wid) {
          wm.setCurrentWindow(null);
        }

        var lastWin = wm ? wm.getLastWindow() : null;
        if (lastWin && lastWin._wid === _this4._wid) {
          wm.setLastWindow(null);
        }
      };

      var _animateClose = function _animateClose(fn) {
        if (!(0, _init.running)()) {
          fn();
        } else {
          if (_this4._$element) {
            var anim = wm ? wm.getSetting('animations') : false;
            if (anim) {
              _this4._$element.setAttribute('data-closing', 'true');
              _this4._animationCallback = fn;

              // This prevents windows from sticking when shutting down.
              // In some cases this would happen when you remove the stylesheet
              // with animation properties attached.
              var animatetimeout = setTimeout(function () {
                if (_this4._animationCallback) {
                  _this4._animationCallback();
                }
                animatetimeout = clearTimeout(animatetimeout);
              }, 1000);
            } else {
              _this4._$element.style.display = 'none';
              fn();
            }
          }
        }
      };

      this._onChange('close');

      _animateClose(function () {
        _removeDOM();
      });
      _destroyDOM();
      _destroyWin();

      // App messages
      if (this._app) {
        this._app._onMessage('destroyWindow', this, {});
      }

      if (this._evHandler) {
        this._evHandler.destroy();
      }

      this._app = null;
      this._evHandler = null;
      this._args = {};
      this._queryTimer = clearTimeout(this._queryTimer);
      this._scheme = this._scheme ? this._scheme.destroy() : null;

      console.groupEnd();

      return true;
    }

    //
    // GUI And Event Hooks
    //

    /**
     * Finds a GUI Element by ID from Scheme.
     *
     * @param   {String}                id        Element ID (data-id)
     * @param   {Node}                  [root]    Root Node
     *
     * @return {GUIElement}
     */

  }, {
    key: '_find',
    value: function _find(id, root) {
      var q = '[data-id="' + id + '"]';
      return this._findByQuery(q, root);
    }

    /**
     * Renders a scheme into the window
     *
     * By default uses the internally assigned scheme file from preload (if any)
     *
     * @param {String}           id           Scheme fragment ID
     * @param {String|GUIScheme} scheme       Scheme or HTML
     * @param {Node}             [root]       Root element (defaults to internal Node)
     * @param {Object}           [args]       Arguments to pass to parser
     * @return {GUIScheme}
     */

  }, {
    key: '_render',
    value: function _render(id, scheme, root, args) {
      if (scheme) {
        root = root || this._getRoot();
        args = args || {};

        if (typeof this._opts.translator === 'function') {
          args._ = this._opts.translator;
        }

        this._scheme = typeof scheme === 'string' ? _scheme2.default.fromString(scheme) : scheme;
      }

      if (this._scheme instanceof _scheme2.default) {
        this._scheme.render(this, id, root, null, null, args);
      } else {
        console.warn('Got an invalid scheme in window render()', this._scheme);
      }

      return this._scheme;
    }

    /**
     * Returns given DOMElement by ID
     *
     * @param   {String}                id        Element ID (data-id)
     * @param   {Node}                  [root]    Root Node
     *
     * @return  {Node}
     */

  }, {
    key: '_findDOM',
    value: function _findDOM(id, root) {
      root = root || this._getRoot();
      var q = '[data-id="' + id + '"]';
      return root.querySelector(q);
    }

    /**
     * Creates a new GUI Element
     *
     * @param   {String}                tagName       OS.js GUI Element name
     * @param   {Object}                params        Parameters
     * @param   {Node}                  [parentNode]  Parent Node
     * @param   {Object}                [applyArgs]   New element parameters
     *
     * @return {GUIElement}
     */

  }, {
    key: '_create',
    value: function _create(tagName, params, parentNode, applyArgs) {
      parentNode = parentNode || this._getRoot();
      return _element2.default.createInto(tagName, params, parentNode, applyArgs, this);
    }

    /**
     * Finds a GUI Element by ID from Scheme.
     *
     * @param   {String}                query     DOM Element query
     * @param   {Node}                  [root]    Root Node
     * @param   {Boolean}               [all]     Perform `querySelectorAll`
     *
     * @return {(Array|GUIElement)}
     */

  }, {
    key: '_findByQuery',
    value: function _findByQuery(query, root, all) {
      root = root || this._getRoot();

      if (!(root instanceof window.Node)) {
        return all ? [] : null;
      }

      if (all) {
        return root.querySelectorAll(query).map(function (el) {
          return _element2.default.createFromNode(el, query);
        });
      }

      var el = root.querySelector(query);
      return _element2.default.createFromNode(el, query);
    }

    /**
     * Fire a hook to internal event
     * @see EventHandler#emit
     *
     * @param   {WindowEvent}    k       Event name
     * @param   {Array}          args    Send these arguments (fn.apply)
     *
     * @return {Boolean}
     */

  }, {
    key: '_emit',
    value: function _emit(k, args) {
      if (!this._destroyed) {
        if (this._evHandler) {
          return this._evHandler.emit(k, args);
        }
      }
      return false;
    }

    /**
     * Adds a hook to internal event
     * @see EventHandler#on
     *
     * @param   {WindowEvent}    k       Event name
     * @param   {Function}       func    Callback function
     *
     * @return  {Number}
     */

  }, {
    key: '_on',
    value: function _on(k, func) {
      if (this._evHandler) {
        return this._evHandler.on(k, func, this);
      }
      return false;
    }

    /**
     * Removes a hook to internal event
     *
     * @see EventHandler#off
     *
     * @param   {WindowEvent}    k       Event name
     * @param   {Number}         idx     The hook index returned from _on()
     *
     * @return {Boolean}
     */

  }, {
    key: '_off',
    value: function _off(k, idx) {
      if (this._evHandler) {
        return this._evHandler.off(k, idx);
      }
      return false;
    }

    //
    // Children (Windows)
    //

    /**
     * Add a child-window
     *
     * @param {Window}      w               Window
     * @param {Boolean}     [wmAdd=false]   Add to window manager
     * @param {Boolean}     [wmFocus=false] Focus window when added
     *
     * @see EventHandler#off
     *
     * @return  {Window} The added instance
     */

  }, {
    key: '_addChild',
    value: function _addChild(w, wmAdd, wmFocus) {
      console.debug('Window::_addChild()');
      w._parent = this;

      var wm = _windowManager2.default.instance;
      if (wmAdd && wm) {
        wm.addWindow(w, wmFocus);
      }
      this._children.push(w);

      return w;
    }

    /**
     * Removes a child Window
     *
     * @param   {Window}    w     Widow reference
     *
     * @return  {Boolean}         On success
     */

  }, {
    key: '_removeChild',
    value: function _removeChild(w) {
      var _this5 = this;

      var found = false;
      this._children.forEach(function (child, i) {
        if (child && child._wid === w._wid) {
          console.debug('Window::_removeChild()');
          child.destroy();
          _this5._children[i] = null;
          found = true;
        }
      });

      return found;
    }

    /**
     * Get a Window child by X
     *
     * @param   {String}      value   Value to look for
     * @param   {String}      key     Key to look for
     *
     * @return  {Window} Resulted Window or 'null'
     */

  }, {
    key: '_getChild',
    value: function _getChild(value, key) {
      key = key || 'wid';

      var found = this._getChildren().filter(function (c) {
        return c['_' + key] === value;
      });

      return key === 'tag' ? found : found[0];
    }

    /**
     * Get a Window child by ID
     * @see Window#_getChild
     *
     * @param {Number} id Window id
     * @return {Window}
     */

  }, {
    key: '_getChildById',
    value: function _getChildById(id) {
      return this._getChild(id, 'wid');
    }

    /**
     * Get a Window child by Name
     * @see Window#_getChild
     *
     * @param {String} name Window name
     * @return {Window}
     */

  }, {
    key: '_getChildByName',
    value: function _getChildByName(name) {
      return this._getChild(name, 'name');
    }

    /**
     * Get Window(s) child by Tag
     * @see Window#_getChild
     *
     * @param {String} tag Tag name
     *
     * @return {Window[]}
     */

  }, {
    key: '_getChildrenByTag',
    value: function _getChildrenByTag(tag) {
      return this._getChild(tag, 'tag');
    }

    /**
     * Gets all children Windows
     *
     * @return {Window[]}
     */

  }, {
    key: '_getChildren',
    value: function _getChildren() {
      return this._children.filter(function (w) {
        return !!w;
      });
    }

    /**
     * Removes all children Windows
     */

  }, {
    key: '_removeChildren',
    value: function _removeChildren() {
      this._children.forEach(function (child, i) {
        if (child) {
          child.destroy();
        }
      });
      this._children = [];
    }

    //
    // Actions
    //

    /**
     * Close the Window
     *
     * @return  {Boolean}     On succes
     */

  }, {
    key: '_close',
    value: function _close() {
      if (this._disabled || this._destroyed) {
        return false;
      }
      console.debug('Window::_close()');

      this._blur();
      this.destroy();

      return true;
    }

    /**
     * Minimize the Window
     *
     * @param     {Boolean}   [force=false]   Force action
     *
     * @return    {Boolean}     On success
     */

  }, {
    key: '_minimize',
    value: function _minimize(force) {
      var _this6 = this;

      if (!this._properties.allow_minimize || this._destroyed) {
        return false;
      }

      if (!force && this._state.minimized) {
        this._restore(false, true);
        return true;
      }

      console.debug(this._name, '>', 'Window::_minimize()');

      this._blur();

      this._state.minimized = true;
      this._$element.setAttribute('data-minimized', 'true');

      waitForAnimation(this, function () {
        _this6._$element.style.display = 'none';
        _this6._emit('minimize');
      });

      this._onChange('minimize');

      var wm = _windowManager2.default.instance;
      var win = wm ? wm.getCurrentWindow() : null;
      if (win && win._wid === this._wid) {
        wm.setCurrentWindow(null);
      }

      this._updateMarkup();

      return true;
    }

    /**
     * Maximize the Window
     *
     * @param     {Boolean}   [force=false]   Force action
     *
     * @return    {Boolean}     On success
     */

  }, {
    key: '_maximize',
    value: function _maximize(force) {
      var _this7 = this;

      if (!this._properties.allow_maximize || this._destroyed || !this._$element) {
        return false;
      }

      if (!force && this._state.maximized) {
        this._restore(true, false);
        return true;
      }

      console.debug(this._name, '>', 'Window::_maximize()');

      this._lastPosition = { x: this._position.x, y: this._position.y };
      this._lastDimension = { w: this._dimension.w, h: this._dimension.h };
      this._state.maximized = true;

      var s = this._getMaximizedSize();
      this._$element.style.zIndex = getNextZindex(this._state.ontop);
      this._$element.style.top = s.top + 'px';
      this._$element.style.left = s.left + 'px';
      this._$element.style.width = s.width + 'px';
      this._$element.style.height = s.height + 'px';
      this._$element.setAttribute('data-maximized', 'true');

      //this._resize();
      this._dimension.w = s.width;
      this._dimension.h = s.height;
      this._position.x = s.left;
      this._position.y = s.top;

      this._focus();

      waitForAnimation(this, function () {
        _this7._emit('maximize');
      });

      this._onChange('maximize');
      this._onResize();

      this._updateMarkup();

      return true;
    }

    /**
     * Restore the Window
     *
     * @param     {Boolean}     max     Revert maximize state
     * @param     {Boolean}     min     Revert minimize state
     */

  }, {
    key: '_restore',
    value: function _restore(max, min) {
      var _this8 = this;

      if (!this._$element || this._destroyed) {
        return;
      }

      var restoreMaximized = function restoreMaximized() {
        if (max && _this8._state.maximized) {
          _this8._move(_this8._lastPosition.x, _this8._lastPosition.y);
          _this8._resize(_this8._lastDimension.w, _this8._lastDimension.h);
          _this8._state.maximized = false;
          _this8._$element.setAttribute('data-maximized', 'false');
        }
      };

      var restoreMinimized = function restoreMinimized() {
        if (min && _this8._state.minimized) {
          _this8._$element.style.display = 'block';
          _this8._$element.setAttribute('data-minimized', 'false');
          _this8._state.minimized = false;
        }
      };

      console.debug(this._name, '>', 'Window::_restore()');

      max = typeof max === 'undefined' ? true : max === true;
      min = typeof min === 'undefined' ? true : min === true;

      restoreMaximized();
      restoreMinimized();

      waitForAnimation(this, function () {
        _this8._emit('restore');
      });

      this._onChange('restore');
      this._onResize();

      this._focus();

      this._updateMarkup();
    }

    /**
     * Focus the window
     *
     * @param   {Boolean}     force     Forces focus
     *
     * @return  {Boolean}               On success
     */

  }, {
    key: '_focus',
    value: function _focus(force) {
      if (!this._$element || this._destroyed) {
        return false;
      }

      this._toggleAttentionBlink(false);

      this._$element.style.zIndex = getNextZindex(this._state.ontop);
      this._$element.setAttribute('data-focused', 'true');

      var wm = _windowManager2.default.instance;
      var win = wm ? wm.getCurrentWindow() : null;
      if (win && win._wid !== this._wid) {
        win._blur();
      }

      if (wm) {
        wm.setCurrentWindow(this);
        wm.setLastWindow(this);
      }

      if (!this._state.focused || force) {
        //console.debug(this._name, '>', 'Window::_focus()');
        this._onChange('focus');
        this._emit('focus');
      }

      this._state.focused = true;

      this._updateMarkup();

      return true;
    }

    /**
     * Blur the window
     *
     * @param   {Boolean}     force     Forces blur
     *
     * @return  {Boolean}               On success
     */

  }, {
    key: '_blur',
    value: function _blur(force) {
      if (!this._$element || this._destroyed || !force && !this._state.focused) {
        return false;
      }

      //console.debug(this._name, '>', 'Window::_blur()');

      this._$element.setAttribute('data-focused', 'false');
      this._state.focused = false;

      this._onChange('blur');
      this._emit('blur');

      // Force all standard HTML input elements to loose focus
      this._blurGUI();

      var wm = _windowManager2.default.instance;
      var win = wm ? wm.getCurrentWindow() : null;
      if (win && win._wid === this._wid) {
        wm.setCurrentWindow(null);
      }

      this._updateMarkup();

      return true;
    }

    /**
     * Blurs the GUI
     */

  }, {
    key: '_blurGUI',
    value: function _blurGUI() {
      this._$root.querySelectorAll('input, textarea, select, iframe, button').forEach(function (el) {
        el.blur();
      });
    }

    /**
     * Resize Window to given size
     *
     * Use this method if you want the window to fit into the viewport and not
     * just set a specific size
     *
     * @param   {Number}      dw                   Width
     * @param   {Number}      dh                   Height
     * @param   {Boolean}     [limit=true]         Limit to this size
     * @param   {Boolean}     [move=false]         Move window if too big
     * @param   {Node}        [container=null]     Relative to this container
     * @param   {Boolean}     [force=false]        Force movment
     */

  }, {
    key: '_resizeTo',
    value: function _resizeTo(dw, dh, limit, move, container, force) {
      var _this9 = this;

      if (!this._$element || dw <= 0 || dh <= 0) {
        return;
      }

      limit = typeof limit === 'undefined' || limit === true;

      var dx = 0;
      var dy = 0;

      if (container) {
        var cpos = DOM.$position(container, this._$root);
        dx = parseInt(cpos.left, 10);
        dy = parseInt(cpos.top, 10);
      }

      var space = this._getMaximizedSize();
      var cx = this._position.x + dx;
      var cy = this._position.y + dy;
      var newW = dw;
      var newH = dh;
      var newX = null;
      var newY = null;

      var _limitTo = function _limitTo() {
        if (cx + newW > space.width) {
          if (move) {
            newW = space.width;
            newX = space.left;
          } else {
            newW = space.width - cx + dx;
          }
        } else {
          newW += dx;
        }

        if (cy + newH > space.height) {
          if (move) {
            newH = space.height;
            newY = space.top;
          } else {
            newH = space.height - cy + _this9._$top.offsetHeight + dy;
          }
        } else {
          newH += dy;
        }
      };

      var _moveTo = function _moveTo() {
        if (newX !== null) {
          _this9._move(newX, _this9._position.y);
        }
        if (newY !== null) {
          _this9._move(_this9._position.x, newY);
        }
      };

      var _resizeFinished = function _resizeFinished() {
        var wm = _windowManager2.default.instance;
        var anim = wm ? wm.getSetting('animations') : false;
        if (anim) {
          _this9._animationCallback = function () {
            _this9._emit('resized');
          };
        } else {
          _this9._emit('resized');
        }
      };

      if (limit) {
        _limitTo();
      }

      this._resize(newW, newH, force);

      _moveTo();
      _resizeFinished();
    }
  }, {
    key: '_resize',
    value: function _resize(w, h, force) {
      var p = this._properties;
      if (!this._$element || this._destroyed || !force && !p.allow_resize) {
        return false;
      }

      var getNewSize = function getNewSize(n, min, max) {
        if (!isNaN(n) && n) {
          n = Math.max(n, min);
          if (max !== null) {
            n = Math.min(n, max);
          }
        }
        return n;
      };

      w = force ? w : getNewSize(w, p.min_width, p.max_width);
      if (!isNaN(w) && w) {
        this._$element.style.width = w + 'px';
        this._dimension.w = w;
      }

      h = force ? h : getNewSize(h, p.min_height, p.max_height);
      if (!isNaN(h) && h) {
        this._$element.style.height = h + 'px';
        this._dimension.h = h;
      }

      this._onResize();

      return true;
    }

    /**
     * Move window to position
     *
     * @param   {Object}      pos       Position rectangle
     */

  }, {
    key: '_moveTo',
    value: function _moveTo(pos) {
      var wm = _windowManager2.default.instance;
      if (!wm) {
        return;
      }

      var s = wm.getWindowSpace();
      var cx = this._position.x;
      var cy = this._position.y;

      if (pos === 'left') {
        this._move(s.left, cy);
      } else if (pos === 'right') {
        this._move(s.width - this._dimension.w, cy);
      } else if (pos === 'top') {
        this._move(cx, s.top);
      } else if (pos === 'bottom') {
        this._move(cx, s.height - this._dimension.h);
      }
    }

    /**
     * Move window to position
     *
     * @param   {Number}       x     X Position
     * @param   {Number}       y     Y Position
     *
     * @return  {Boolean}         On success
     */

  }, {
    key: '_move',
    value: function _move(x, y) {
      if (!this._$element || this._destroyed || !this._properties.allow_move) {
        return false;
      }

      if (typeof x === 'undefined' || typeof y === 'undefined') {
        return false;
      }

      this._$element.style.top = y + 'px';
      this._$element.style.left = x + 'px';
      this._position.x = x;
      this._position.y = y;

      return true;
    }

    /**
     * Toggle disabled overlay
     *
     * @param     {Boolean}     t       Toggle
     */

  }, {
    key: '_toggleDisabled',
    value: function _toggleDisabled(t) {
      //console.debug(this._name, '>', 'Window::_toggleDisabled()', t);
      if (this._$disabled) {
        this._$disabled.style.display = t ? 'block' : 'none';
      }

      this._disabled = t ? true : false;

      this._updateMarkup();
    }

    /**
     * Toggle loading overlay
     *
     * @param     {Boolean}     t       Toggle
     */

  }, {
    key: '_toggleLoading',
    value: function _toggleLoading(t) {
      //console.debug(this._name, '>', 'Window::_toggleLoading()', t);
      if (this._$loading) {
        this._$loading.style.display = t ? 'block' : 'none';
      }

      this._loading = t ? true : false;

      this._updateMarkup();
    }

    /**
     * Updates window markup with attributes etc
     *
     * @param {Boolean}   [ui=false]    If action came from UI
     */

  }, {
    key: '_updateMarkup',
    value: function _updateMarkup(ui) {
      if (!this._$element) {
        return;
      }

      var t = this._loading || this._disabled;
      var d = this._disabled;
      var h = this._state.minimized;
      var f = !this._state.focused;

      this._$element.setAttribute('aria-busy', String(t));
      this._$element.setAttribute('aria-hidden', String(h));
      this._$element.setAttribute('aria-disabled', String(d));
      this._$root.setAttribute('aria-hidden', String(f));

      if (!ui) {
        return;
      }

      var dmax = this._properties.allow_maximize === true ? 'inline-block' : 'none';
      var dmin = this._properties.allow_minimize === true ? 'inline-block' : 'none';
      var dclose = this._properties.allow_close === true ? 'inline-block' : 'none';

      this._$top.querySelector('application-window-button-maximize').style.display = dmax;
      this._$top.querySelector('application-window-button-minimize').style.display = dmin;
      this._$top.querySelector('application-window-button-close').style.display = dclose;

      var dres = this._properties.allow_resize === true;

      this._$element.setAttribute('data-allow-resize', String(dres));
    }

    /**
     * Toggle attention
     *
     * @param     {Boolean}     t       Toggle
     *
     * @return {Boolean} If activated
     */

  }, {
    key: '_toggleAttentionBlink',
    value: function _toggleAttentionBlink(t) {
      var _this10 = this;

      if (!this._$element || this._destroyed || this._state.focused) {
        return false;
      }

      var el = this._$element;

      var _blink = function _blink(stat) {
        if (el) {
          if (stat) {
            DOM.$addClass(el, 'WindowAttentionBlink');
          } else {
            DOM.$removeClass(el, 'WindowAttentionBlink');
          }
        }
        _this10._onChange(stat ? 'attention_on' : 'attention_off');
      };

      _blink(t);

      return true;
    }

    /**
     * Check next Tab (cycle Element)
     *
     * @param   {Event}     ev            DOM Event
     */

  }, {
    key: '_nextTabIndex',
    value: function _nextTabIndex(ev) {
      var nextElement = GUI.getNextElement(ev.shiftKey, document.activeElement, this._$root);
      if (nextElement) {
        if (DOM.$hasClass(nextElement, 'gui-data-view')) {
          _element2.default.createFromNode(nextElement).focus();
        } else {
          try {
            nextElement.focus();
          } catch (e) {}
        }
      }
    }

    //
    // Events
    //

    /**
     * On Drag-and-drop event
     *
     * @param   {Event}     ev        DOM Event
     * @param   {String}    type      DnD type
     * @param   {Object}    item      DnD item
     * @param   {Object}    args      DnD arguments
     * @param   {Element}   el        DnD element
     *
     * @return  {Boolean} On success
     */

  }, {
    key: '_onDndEvent',
    value: function _onDndEvent(ev, type, item, args, el) {
      if (this._disabled || this._destroyed) {
        return false;
      }

      console.debug('Window::_onDndEvent()', type, item, args);

      this._emit('drop', [ev, type, item, args, el]);

      if (item) {
        if (type === 'filesDrop') {
          this._emit('drop:upload', [ev, item, args, el]);
        } else if (type === 'itemDrop' && item.type === 'file' && item.data) {
          this._emit('drop:file', [ev, new _file2.default(item.data || {}), args, el]);
        }
      }

      return true;
    }

    /**
     * On Key event
     *
     * @param   {Event}      ev        DOM Event
     * @param   {String}     type      Key type
     *
     * @return {Boolean} If triggered
     */

  }, {
    key: '_onKeyEvent',
    value: function _onKeyEvent(ev, type) {
      if (this._destroyed || !this._state.focused) {
        return false;
      }

      if (type === 'keydown' && ev.keyCode === Keycodes.TAB) {
        this._nextTabIndex(ev);
      }

      this._emit(type, [ev, ev.keyCode, ev.shiftKey, ev.ctrlKey, ev.altKey]);

      return true;
    }

    /**
     * On Window resized
     */

  }, {
    key: '_onResize',
    value: function _onResize() {
      var _this11 = this;

      clearTimeout(this._queryTimer);

      this._queryTimer = setTimeout(function () {
        checkMediaQueries(_this11);
        _this11._queryTimer = clearTimeout(_this11._queryTimer);
      }, 20);
    }

    /**
     * On Window Icon Click
     *
     * @param   {Event}   ev        DOM Event
     */

  }, {
    key: '_onWindowIconClick',
    value: function _onWindowIconClick(ev) {
      var _this12 = this;

      if (!this._properties.allow_iconmenu || this._destroyed) {
        return;
      }

      console.debug(this._name, '>', 'Window::_onWindowIconClick()');

      var control = [[this._properties.allow_minimize, function () {
        return {
          title: (0, _locales._)('WINDOW_MINIMIZE'),
          icon: _theme2.default.getIcon('actions/go-up.png'),
          onClick: function onClick(name, iter) {
            _this12._minimize();
          }
        };
      }], [this._properties.allow_maximize, function () {
        return {
          title: (0, _locales._)('WINDOW_MAXIMIZE'),
          icon: _theme2.default.getIcon('actions/view-fullscreen.png'),
          onClick: function onClick(name, iter) {
            _this12._maximize();
            _this12._focus();
          }
        };
      }], [this._state.maximized, function () {
        return {
          title: (0, _locales._)('WINDOW_RESTORE'),
          icon: _theme2.default.getIcon('actions/view-restore.png'),
          onClick: function onClick(name, iter) {
            _this12._restore();
            _this12._focus();
          }
        };
      }], [this._properties.allow_ontop, function () {
        if (_this12._state.ontop) {
          return {
            title: (0, _locales._)('WINDOW_ONTOP_OFF'),
            icon: _theme2.default.getIcon('actions/window-new.png'),
            onClick: function onClick(name, iter) {
              _this12._state.ontop = false;
              if (_this12._$element) {
                _this12._$element.style.zIndex = getNextZindex(false);
              }
              _this12._focus();
            }
          };
        }

        return {
          title: (0, _locales._)('WINDOW_ONTOP_ON'),
          icon: _theme2.default.getIcon('actions/window-new.png'),
          onClick: function onClick(name, iter) {
            _this12._state.ontop = true;
            if (_this12._$element) {
              _this12._$element.style.zIndex = getNextZindex(true);
            }
            _this12._focus();
          }
        };
      }], [this._properties.allow_close, function () {
        return {
          title: (0, _locales._)('WINDOW_CLOSE'),
          icon: _theme2.default.getIcon('actions/window-close.png'),
          onClick: function onClick(name, iter) {
            _this12._close();
          }
        };
      }]];

      var list = [];
      control.forEach(function (iter) {
        if (iter[0]) {
          list.push(iter[1]());
        }
      });

      this._focus();

      Menu.create(list, ev);
    }

    /**
     * On Window Button Click
     *
     * @param   {Event}   ev        DOM Event
     * @param   {Node}    el        DOM Element
     * @param   {String}  btn       Button name
     */

  }, {
    key: '_onWindowButtonClick',
    value: function _onWindowButtonClick(ev, el, btn) {

      var map = {
        close: this._close,
        minimize: this._minimize,
        maximize: this._maximize
      };

      if (map[btn]) {
        try {
          this._blurGUI();
        } catch (e) {}

        map[btn].call(this);
      }
    }

    /**
     * On Window has changed
     *
     * @param   {Event}     ev        DOM Event
     * @param   {Boolean}   byUser    Performed by user?
     */

  }, {
    key: '_onChange',
    value: function _onChange(ev, byUser) {
      ev = ev || '';
      if (ev) {
        //console.debug(this._name, '>', 'Window::_onChange()', ev);
        var wm = _windowManager2.default.instance;
        if (wm) {
          wm.eventWindow(ev, this);
        }
      }
    }

    //
    // Getters
    //

    /**
     * Get Window maximized size
     *
     * @return    {Object}      Size in rectangle
     */

  }, {
    key: '_getMaximizedSize',
    value: function _getMaximizedSize() {
      var s = getWindowSpace();
      if (!this._$element || this._destroyed) {
        return s;
      }

      var topMargin = 23;
      var borderSize = 0;

      var theme = _theme2.default.getStyleTheme(true, true);
      if (theme && theme.style && theme.style.window) {
        topMargin = theme.style.window.margin;
        borderSize = theme.style.window.border;
      }

      s.left += borderSize;
      s.top += borderSize;
      s.width -= borderSize * 2;
      s.height -= topMargin + borderSize * 2;

      return Object.freeze(s);
    }

    /**
     * Get Window position in DOM
     * @return {Object}
     */

  }, {
    key: '_getViewRect',
    value: function _getViewRect() {
      return this._$element ? Object.freeze(DOM.$position(this._$element)) : null;
    }

    /**
     * Get Window main DOM element
     *
     * @return  {Node}
     */

  }, {
    key: '_getRoot',
    value: function _getRoot() {
      return this._$root;
    }

    /**
     * Get Window z-index
     *
     * @return    {Number}
     */

  }, {
    key: '_getZindex',
    value: function _getZindex() {
      if (this._$element) {
        return parseInt(this._$element.style.zIndex, 10);
      }
      return -1;
    }

    /**
     * Get the title
     * @return {String}
     */

  }, {
    key: '_getTitle',
    value: function _getTitle() {
      return this._title;
    }

    /**
     * Set Window title
     *
     * @param   {String}      t           Title
     * @param   {Boolean}     [append]    Append this to original title
     * @param   {String}      [delimiter] The delimiter (default is -)
     */

  }, {
    key: '_setTitle',
    value: function _setTitle(t, append, delimiter) {
      if (!this._$element || this._destroyed) {
        return;
      }

      delimiter = delimiter || '-';

      var tel = this._$element.getElementsByTagName('application-window-title')[0];
      var text = [];
      if (append) {
        text = [this._origtitle, delimiter, t];
      } else {
        text = [t || this._origtitle];
      }

      this._title = text.join(' ') || this._origtitle;

      if (tel) {
        DOM.$empty(tel);
        tel.appendChild(document.createTextNode(this._title));
      }

      this._onChange('title');

      this._updateMarkup();
    }

    /**
     * Set Windoc icon
     *
     * @param   {String}      i     Icon path
     */

  }, {
    key: '_setIcon',
    value: function _setIcon(i) {
      if (this._$winicon) {
        this._$winicon.title = this._title;
        this._$winicon.style.backgroundImage = 'url(' + i + ')';
      }

      this._icon = i;
      this._onChange('icon');
    }

    /**
     * Set Window warning message (Displays as a popup inside window)
     *
     * @param   {String}      message       Warning message
     */

  }, {
    key: '_setWarning',
    value: function _setWarning(message) {
      var _this13 = this;

      this._$warning = DOM.$remove(this._$warning);

      if (this._destroyed || message === null) {
        return;
      }

      message = message || '';

      var container = document.createElement('application-window-warning');

      var close = document.createElement('div');
      close.innerHTML = 'X';
      Events.$bind(close, 'click', function () {
        _this13._setWarning(null);
      });

      var msg = document.createElement('div');
      msg.appendChild(document.createTextNode(message));

      container.appendChild(close);
      container.appendChild(msg);
      this._$warning = container;
      this._$root.appendChild(this._$warning);
    }

    /**
     * Set a window property
     *
     * @param   {String}    p     Key
     * @param   {String}    v     Value
     */

  }, {
    key: '_setProperty',
    value: function _setProperty(p, v) {
      if (v === '' || v === null || !this._$element || typeof this._properties[p] === 'undefined') {
        return;
      }

      this._properties[p] = String(v) === 'true';

      this._updateMarkup(true);
    }
  }]);

  return Window;
}();

exports.default = Window;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * Event Handler Class
 *
 * @desc
 * This class just holds a map of events that you can trigger.
 */
var EventHandler = function () {

  /**
   * @param   {String}      name        A name (identifier)
   * @param   {Array}       names       List of initial event names
   */
  function EventHandler(name, names) {
    _classCallCheck(this, EventHandler);

    this.name = name;
    this.events = {};

    (names || []).forEach(function (n) {
      this.events[n] = [];
    }, this);

    console.debug('EventHandler::constructor()', this.events);
  }

  _createClass(EventHandler, [{
    key: 'destroy',
    value: function destroy() {
      this.events = {};
    }

    /**
     * Register an event
     *
     * You can also give a RegExp pattern as a name to match multiple entries,
     * as well as a comma separated string.
     * @throws {Error} On invalid callback
     *
     * @param   {String}    name        Event name
     * @param   {Function}  cb          Callback function
     * @param   {Object}    [thisArg]   Set 'this'
     *
     * @return  {Number}
     */

  }, {
    key: 'on',
    value: function on(name, cb, thisArg) {
      var _this = this;

      thisArg = thisArg || this;

      if (!(cb instanceof Function)) {
        throw new TypeError('EventHandler::on() expects cb to be a Function');
      }

      var added = [];

      var _register = function _register(n) {
        if (!(_this.events[n] instanceof Array)) {
          _this.events[n] = [];
        }

        added.push(_this.events[n].push(function (args) {
          return cb.apply(thisArg, args);
        }));
      };

      if (name instanceof RegExp) {
        Object.keys(this.events).forEach(function (n) {
          if (name.test(n)) {
            _register(n);
          }
        });
      } else {
        name.replace(/\s/g, '').split(',').forEach(function (n) {
          _register(n);
        });
      }

      return added.length === 1 ? added[0] : added;
    }

    /**
     * Unregister an event
     *
     * @throws {Error} On event name
     *
     * @param   {String}    name        Event name
     * @param   {Number}    index       Event index (as returned by on())
     */

  }, {
    key: 'off',
    value: function off(name, index) {
      if (!(this.events[name] instanceof Array)) {
        throw new TypeError('Invalid event name');
      }

      if (arguments.length > 1 && typeof index === 'number') {
        this.events[name].splice(index, 1);
      } else {
        this.events[name] = [];
      }
    }

    /**
     * Fire an event
     *
     * @param   {String}    name              Event name
     * @param   {Array}     args              List of arguments to send to .apply()
     * @param   {Object}    [thisArg=this]    The `this` context
     * @param   {Boolean}   [applyArgs=false] Run `apply` on arguments
     */

  }, {
    key: 'emit',
    value: function emit(name, args, thisArg, applyArgs) {
      args = args || [];
      thisArg = thisArg || this;

      if (!(this.events[name] instanceof Array)) {
        return;
      }

      this.events[name].forEach(function (fn) {
        try {
          if (applyArgs) {
            fn.apply(thisArg, args);
          } else {
            fn.call(thisArg, args);
          }
        } catch (e) {
          console.warn('EventHandler::emit() exception', name, e);
          console.warn(e.stack);
        }
      });
    }
  }]);

  return EventHandler;
}();

exports.default = EventHandler;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompability = getCompability;
exports.isIE = isIE;
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

var compability = function () {
  function _checkSupport(enabled, check, isSupported) {
    var supported = {};

    Object.keys(check).forEach(function (key) {
      var chk = check[key];
      var value = false;

      if (chk instanceof Array) {
        chk.forEach(function (c) {
          value = isSupported(c);
          return !value;
        });
      } else {
        value = isSupported(chk);
      }
      supported[key] = value;
    });

    return supported;
  }

  function getUpload() {
    try {
      var xhr = new XMLHttpRequest();
      return !!(xhr && 'upload' in xhr && 'onprogress' in xhr.upload);
    } catch (e) {}
    return false;
  }

  function getCanvasSupported() {
    return document.createElement('canvas').getContext ? document.createElement('canvas') : null;
  }

  function getVideoSupported() {
    return document.createElement('video').canPlayType ? document.createElement('video') : null;
  }

  function canPlayCodec(support, check) {
    return _checkSupport(support, check, function (codec) {
      try {
        return !!support.canPlayType(codec);
      } catch (e) {}
      return false;
    });
  }

  function getVideoTypesSupported() {
    return canPlayCodec(getVideoSupported(), {
      webm: 'video/webm; codecs="vp8.0, vorbis"',
      ogg: 'video/ogg; codecs="theora"',
      h264: ['video/mp4; codecs="avc1.42E01E"', 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"'],
      mpeg: 'video/mp4; codecs="mp4v.20.8"',
      mkv: 'video/x-matroska; codecs="theora, vorbis"'
    });
  }

  function getAudioSupported() {
    return document.createElement('audio').canPlayType ? document.createElement('audio') : null;
  }

  function getAudioTypesSupported() {
    return canPlayCodec(getAudioSupported(), {
      ogg: 'audio/ogg; codecs="vorbis',
      mp3: 'audio/mpeg',
      wav: 'audio/wav; codecs="1"'
    });
  }

  function getAudioContext() {
    if (window.hasOwnProperty('AudioContext') || window.hasOwnProperty('webkitAudioContext')) {
      return true;
    }
    return false;
  }

  var getCanvasContexts = function () {
    var cache = [];

    return function () {
      if (!cache.length) {
        var canvas = getCanvasSupported();
        if (canvas) {
          var test = ['2d', 'webgl', 'experimental-webgl', 'webkit-3d', 'moz-webgl'];
          test.forEach(function (tst, i) {
            try {
              if (!!canvas.getContext(tst)) {
                cache.push(tst);
              }
            } catch (eee) {}
          });
        }
      }

      return cache;
    };
  }();

  function getWebGL() {
    var result = false;
    var contexts = getCanvasContexts();
    try {
      result = contexts.length > 1;
      if (!result) {
        if ('WebGLRenderingContext' in window) {
          result = true;
        }
      }
    } catch (e) {}
    return result;
  }

  function detectCSSFeature(featurename) {
    var feature = false;
    var domPrefixes = 'Webkit Moz ms O'.split(' ');
    var elm = document.createElement('div');
    var featurenameCapital = null;

    featurename = featurename.toLowerCase();

    if (elm.style[featurename]) {
      feature = true;
    }

    if (feature === false) {
      featurenameCapital = featurename.charAt(0).toUpperCase() + featurename.substr(1);
      for (var i = 0; i < domPrefixes.length; i++) {
        if (typeof elm.style[domPrefixes[i] + featurenameCapital] !== 'undefined') {
          feature = true;
          break;
        }
      }
    }
    return feature;
  }

  function getUserMedia() {
    var getMedia = false;
    if (window.navigator) {
      getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    }
    return !!getMedia;
  }

  function getRichText() {
    try {
      return !!document.createElement('textarea').contentEditable;
    } catch (e) {}
    return false;
  }

  function getTouch() {
    // False positives in win 8+
    try {
      if (navigator.userAgent.match(/Windows NT 6\.(2|3)/)) {
        return false;
      }
    } catch (e) {}

    // We only want touch for mobile devices
    try {
      if (navigator.userAgent.match(/iOS|Android|BlackBerry|IEMobile|iPad|iPhone|iPad/i)) {
        return true;
      }
    } catch (e) {}

    return false;
    // This was the old method
    //return ('ontouchstart' in window) || (window.DocumentTouch && (document instanceof window.DocumentTouch));
    //return (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
  }

  function getDnD() {
    return !!('draggable' in document.createElement('span'));
  }

  function getSVG() {
    return !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
  }

  function getFileSystem() {
    return 'requestFileSystem' in window || 'webkitRequestFileSystem' in window;
  }

  var checkWindow = {
    indexedDB: 'indexedDB',
    localStorage: 'localStorage',
    sessionStorage: 'sessionStorage',
    globalStorage: 'globalStorage',
    openDatabase: 'openDatabase',
    socket: 'WebSocket',
    worker: 'Worker',
    file: 'File',
    blob: 'Blob',
    orientation: 'onorientationchange'
  };

  var compability = {
    touch: getTouch(),
    upload: getUpload(),
    getUserMedia: getUserMedia(),
    fileSystem: getFileSystem(),
    localStorage: false,
    sessionStorage: false,
    globalStorage: false,
    openDatabase: false,
    socket: false,
    worker: false,
    file: false,
    blob: false,
    orientation: false,
    dnd: getDnD(),
    css: {
      transition: detectCSSFeature('transition'),
      animation: detectCSSFeature('animation')
    },
    canvas: !!getCanvasSupported(),
    canvasContext: getCanvasContexts(),
    webgl: getWebGL(),
    audioContext: getAudioContext(),
    svg: getSVG(),
    video: !!getVideoSupported(),
    videoTypes: getVideoTypesSupported(),
    audio: !!getAudioSupported(),
    audioTypes: getAudioTypesSupported(),
    richtext: getRichText()
  };

  Object.keys(checkWindow).forEach(function (key) {
    try {
      compability[key] = checkWindow[key] in window && window[checkWindow[key]] !== null;
    } catch (e) {
      console.warn(e);
    }
  });

  return function () {
    return compability;
  };
}();

/**
 * Gets browser compability flags
 *
 * @return    {Object}      List of compability
 */
function getCompability() {
  return compability();
}

/**
 * Check if browser is IE
 *
 * @return    {Boolean}       If IE
 */
function isIE() {
  var dm = parseInt(document.documentMode, 10);
  return dm <= 11 || !!navigator.userAgent.match(/(MSIE|Edge)/);
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _windowManager = __webpack_require__(89);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _window = __webpack_require__(121);

var _window2 = _interopRequireDefault(_window);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Look at the 'ProcessEvent' for more.
 * The predefined events are as follows:
 *
 * <pre><code>
 *  init        When application was inited              => (settings, metadata)
 * </code></pre>
 * @typedef ApplicationEvent
 */

/////////////////////////////////////////////////////////////////////////////
// APPLICATION
/////////////////////////////////////////////////////////////////////////////

/**
 * Application Base Class
 *
 * @desc The class used for creating Applications.
 *
 * @param   {String}    name                         Process name
 * @param   {Object}    args                         Process arguments
 * @param   {Metadata}  metadata                     Application metadata
 * @param   {Object}    [settings]                   Application settings
 * @param   {Object}    [options]                    Options
 * @param   {Boolean}   [options.closeWithMain=true] Close application when main window closes
 * @param   {Boolean}   [options.closeOnEmpty=false] Close applications when all windows have been removed
 *
 * @link https://manual.os-js.org/packages/
 *
 * @abstract
 */
var Application = function (_Process) {
  _inherits(Application, _Process);

  function Application(name, args, metadata, settings, options) {
    _classCallCheck(this, Application);

    console.group('Application::constructor()', arguments);

    options = Object.assign({
      closeWithMain: true,
      closeOnEmpty: true
    }, options || {});

    /**
     * If Application was inited
     * @type {Boolean}
     */
    var _this = _possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).apply(this, arguments));

    _this.__inited = false;

    /**
     * Registered main window
     * @type {Window}
     */
    _this.__mainwindow = null;

    /**
     * Registered Windows
     * @type {Window[]}
     */
    _this.__windows = [];

    /**
     * Registered Settings
     * @type {Object}
     */
    _this.__settings = null;

    /**
     * If is in the process of destroying
     * @type {Boolean}
     */
    _this.__destroying = false;

    /**
     * Custom options
     * @type {Object}
     */
    _this.__options = options;

    try {
      _this.__settings = _settingsManager2.default.instance(name, settings || {});
    } catch (e) {
      console.warn('Application::construct()', 'An error occured while loading application settings', e);
      console.warn(e.stack);
      _this.__settings = _settingsManager2.default.instance(name, {});
    }

    console.groupEnd();
    return _this;
  }

  /**
   * Initialize the Application
   *
   * @param   {Object}      settings      Settings JSON
   * @param   {Object}      metadata      Metadata JSON
   */


  _createClass(Application, [{
    key: 'init',
    value: function init(settings, metadata) {
      var _this2 = this;

      var wm = _windowManager2.default.instance;

      var focusLastWindow = function focusLastWindow() {
        var last = void 0;

        if (wm) {
          _this2.__windows.forEach(function (win, i) {
            if (win) {
              wm.addWindow(win);
              last = win;
            }
          });
        }

        if (last) {
          last._focus();
        }
      };

      if (!this.__inited) {
        console.debug('Application::init()', this.__pname);

        if (this.__settings) {
          this.__settings.set(null, settings);
        }

        this.__inited = true;

        this.__evHandler.emit('init', [settings, metadata]);

        focusLastWindow();
      }
    }

    /**
     * Destroy the application
     *
     * @override
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.__destroying || this.__destroyed) {
        // From 'process.js'
        return true;
      }

      this.__destroying = true;

      console.group('Application::destroy()', this.__pname);

      this.__windows.forEach(function (w) {
        return w && w.destroy();
      });

      if (this.__scheme && typeof this.__scheme.destroy === 'function') {
        this.__scheme.destroy();
      }

      this.__mainwindow = null;
      this.__settings = {};
      this.__windows = [];
      this.__scheme = null;

      var result = _get(Application.prototype.__proto__ || Object.getPrototypeOf(Application.prototype), 'destroy', this).apply(this, arguments);
      console.groupEnd();
      return result;
    }

    /**
     * Application has received a message
     *
     * @param {String}    msg     Message
     * @param {Object}    obj     Message object
     * @param {Object}    args    Arguments
     * @override
     */

  }, {
    key: '_onMessage',
    value: function _onMessage(msg, obj, args) {
      if (this.__destroying || this.__destroyed) {
        return false;
      }

      if (msg === 'destroyWindow') {
        if (!this.__destroying) {
          this._removeWindow(obj);

          if (this.__options.closeOnEmpty && !this.__windows.length) {
            console.info('All windows removed, destroying application');
            this.destroy();
          } else if (obj._name === this.__mainwindow) {
            if (this.__options.closeWithMain) {
              console.info('Main window was closed, destroying application');
              this.destroy();
            }
          }
        }
      } else if (msg === 'attention') {
        if (this.__windows.length && this.__windows[0]) {
          this.__windows[0]._focus();
        }
      }

      return _get(Application.prototype.__proto__ || Object.getPrototypeOf(Application.prototype), '_onMessage', this).apply(this, arguments);
    }

    /**
     * Add a window to the application
     *
     * This will automatically add it to the WindowManager and show it to you
     *
     * @param   {Window}     w           The Window
     * @param   {Function}   [cb]        Callback for when window was successfully inited
     * @param   {Boolean}    [setmain]   Set if this is the main window (First window always will be)
     *
     * @return  {Window}
     */

  }, {
    key: '_addWindow',
    value: function _addWindow(w, cb, setmain) {
      if (!(w instanceof _window2.default)) {
        throw new TypeError('Application::_addWindow() expects Core.Window');
      }

      console.debug('Application::_addWindow()');

      this.__windows.push(w);
      if (setmain || this.__windows.length === 1) {
        this.__mainwindow = w._name;
      }

      var wm = _windowManager2.default.instance;
      if (this.__inited) {
        if (wm) {
          wm.addWindow(w);
        }

        if (w._properties.start_focused) {
          setTimeout(function () {
            w._focus();
          }, 5);
        }
      }

      (cb || function () {})(w, wm);

      return w;
    }

    /**
     * Removes given Window
     *
     * @param   {Window}      w     The Windo
     *
     * @return  {Boolean}
     */

  }, {
    key: '_removeWindow',
    value: function _removeWindow(w) {
      if (!(w instanceof _window2.default)) {
        throw new TypeError('Application::_removeWindow() expects Core.Window');
      }

      var found = this.__windows.findIndex(function (win) {
        return win && win._wid === w._wid;
      });
      if (found !== -1) {
        var win = this.__windows[found];

        console.debug('Application::_removeWindow()', win._wid);
        try {
          win.destroy();
        } catch (e) {
          console.warn(e);
        }

        this.__windows.splice(found, 1);
      }

      return found !== -1;
    }

    /**
     * Gets a Window by X
     *
     * If you specify 'tag' the result will end with an Array because
     * these are not unique.
     *
     * If you specify 'null' it will try to return the 'main' window.
     *
     * @param   {String}    value      The value
     * @param   {String}    key        The key to check for
     *
     * @return  {Window} Or null on error or nothing
     */

  }, {
    key: '_getWindow',
    value: function _getWindow(value, key) {
      key = key || 'name';
      if (value === null) {
        value = this.__mainwindow;
      }

      var result = key === 'tag' ? [] : null;
      this.__windows.every(function (win, i) {
        if (win) {
          if (win['_' + key] === value) {
            if (key === 'tag') {
              result.push(win);
            } else {
              result = win;
              return false;
            }
          }
        }
        return true;
      });

      return result;
    }

    /**
     * Get a Window by Name
     *
     * @see Application#_getWindow
     *
     * @param {String}  name      Window Name
     *
     * @return {Window}
     */

  }, {
    key: '_getWindowByName',
    value: function _getWindowByName(name) {
      return this._getWindow(name);
    }

    /**
     * Get Windows(!) by Tag
     *
     * @see Application#_getWindow
     *
     * @param {String}  tag       Tag name
     *
     * @return {Window[]}
     */

  }, {
    key: '_getWindowsByTag',
    value: function _getWindowsByTag(tag) {
      return this._getWindow(tag, 'tag');
    }

    /**
     * Get a list of all windows
     *
     * @return {Window[]}
     */

  }, {
    key: '_getWindows',
    value: function _getWindows() {
      return this.__windows;
    }

    /**
     * Get the "main" window
     *
     * @return {Window}
     */

  }, {
    key: '_getMainWindow',
    value: function _getMainWindow() {
      return this._getWindow(this.__mainwindow, 'name');
    }

    /**
     * Get the sessions JSON
     *
     * @param   {String}    k       The settings key
     *
     * @return  {Object}    the current settings
     */

  }, {
    key: '_getSetting',
    value: function _getSetting(k) {
      return this.__settings ? this.__settings.get(k) : null;
    }

    /**
     * Get the current application session data
     *
     * @return  {Object}    the current session data
     */

  }, {
    key: '_getSessionData',
    value: function _getSessionData() {
      var args = this.__args;
      var wins = this.__windows;
      var data = { name: this.__pname, args: args, windows: [] };

      wins.forEach(function (win, i) {
        if (win && win._properties.allow_session) {
          data.windows.push({
            name: win._name,
            dimension: win._dimension,
            position: win._position,
            state: win._state
          });
        }
      });

      return data;
    }

    /**
     * Set a setting
     *
     * @param   {String}              k             Key
     * @param   {String}              v             Value
     * @param   {Boolean|Function}    [save=true]   Save given setting(s) (can be a callback function)
     */

  }, {
    key: '_setSetting',
    value: function _setSetting(k, v, save) {
      if (typeof save === 'undefined') {
        save = true;
      }
      if (arguments.length === 4 && typeof arguments[3] === 'function') {
        save = arguments[3];
      }
      if (this.__settings) {
        this.__settings.set(k, v, save);
      }
    }
  }]);

  return Application;
}(_process2.default);

exports.default = Application;

/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                               * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                               * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                               *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                               * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                               *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                               *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                               * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                               * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                               * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                               * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                               * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                               * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                               * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                               * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                               * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * @licence Simplified BSD License
                                                                                                                                                                                                                                                                               */


var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _clipboard = __webpack_require__(203);

var Clipboard = _interopRequireWildcard(_clipboard);

var _keycodes = __webpack_require__(88);

var _keycodes2 = _interopRequireDefault(_keycodes);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/////////////////////////////////////////////////////////////////////////////
// ABSTRACTION HELPERS
/////////////////////////////////////////////////////////////////////////////

var _classMap = { // Defaults to (foo-bar)-entry
  'gui-list-view': 'gui-list-view-row'
};

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function getEntryTagName(type) {
  if (typeof type !== 'string') {
    type = type.tagName.toLowerCase();
  }

  var className = _classMap[type];
  if (!className) {
    className = type + '-entry';
  }

  return className;
}

function getEntryFromEvent(ev, header) {
  var t = ev.target;
  var tn = t.tagName.toLowerCase();

  if (tn.match(/(view|textarea|body)$/)) {
    return null;
  } else if (tn === 'gui-list-view-column' && !header) {
    return t.parentNode;
  }

  return t;
}

function isHeader(ev, row) {
  row = row || getEntryFromEvent(ev);
  return row && row.parentNode.tagName === 'GUI-LIST-VIEW-HEAD';
}

function handleItemSelection(ev, item, idx, className, selected, root, multipleSelect) {
  root = root || item.parentNode;
  if (isHeader(null, item)) {
    return multipleSelect ? [] : null;
  }

  if (idx === -1) {
    root.querySelectorAll(getEntryTagName(root)).forEach(function (e) {
      DOM.$removeClass(e, 'gui-active');
    });
    selected = [];
  } else {
    if (!multipleSelect || !ev.shiftKey) {
      root.querySelectorAll(className).forEach(function (i) {
        DOM.$removeClass(i, 'gui-active');
      });
      selected = [];
    }

    var findex = selected.indexOf(idx);
    if (findex >= 0) {
      selected.splice(findex, 1);
      DOM.$removeClass(item, 'gui-active');
    } else {
      selected.push(idx);
      DOM.$addClass(item, 'gui-active');
    }
  }

  selected.sort(function (a, b) {
    return a - b;
  });

  return selected;
}

function handleKeyPress(cls, el, ev) {
  var map = {};
  var key = ev.keyCode;
  var type = el.tagName.toLowerCase();
  var className = getEntryTagName(type);
  var root = el.querySelector(type + '-body');
  var entries = root.querySelectorAll(className);
  var count = entries.length;

  if (!count) {
    return;
  }

  if (key === _keycodes2.default.ENTER) {
    el.dispatchEvent(new CustomEvent('_activate', { detail: { entries: cls.values() } }));
    return;
  }

  map[_keycodes2.default.C] = function (ev) {
    if (ev.ctrlKey) {
      var _selected = cls.values();
      if (_selected && _selected.length) {
        var data = [];

        _selected.forEach(function (s) {
          if (s && s.data) {
            data.push(new _file2.default(s.data.path, s.data.mime));
          }
        });

        Clipboard.setClipboard(data);
      }
    }
  };

  var selected = el._selected.concat() || [];
  var first = selected.length ? selected[0] : 0;
  var last = selected.length > 1 ? selected[selected.length - 1] : first;

  var current = 0;

  function select() {
    var item = entries[current];
    if (item) {
      el._selected = handleItemSelection(ev, item, current, className, selected, root, ev.shiftKey);
      cls.scrollIntoView(item);
    }
  }

  function getRowSize() {
    /* NOT ACCURATE!
    var ew = entries[0].offsetWidth;
    var tw = root.offsetWidth;
    var d = Math.floor(tw/ew);
    */
    var d = 0;
    var lastTop = -1;

    entries.forEach(function (e) {
      if (lastTop === -1) {
        lastTop = e.offsetTop;
      }

      if (lastTop !== e.offsetTop) {
        return false;
      }

      lastTop = e.offsetTop;
      d++;

      return true;
    });

    return d;
  }

  function handleKey() {
    function next() {
      current = Math.min(last + 1, count);
      select();
    }
    function prev() {
      current = Math.max(0, first - 1);
      select();
    }

    if (type === 'gui-tree-view' || type === 'gui-list-view') {
      map[_keycodes2.default.UP] = prev;
      map[_keycodes2.default.DOWN] = next;
    } else {
      map[_keycodes2.default.UP] = function () {
        current = Math.max(0, first - getRowSize());
        select();
      };
      map[_keycodes2.default.DOWN] = function () {
        current = Math.max(last, last + getRowSize());
        select();
      };
      map[_keycodes2.default.LEFT] = prev;
      map[_keycodes2.default.RIGHT] = next;
    }

    if (map[key]) {
      map[key](ev);
    }
  }

  handleKey();
}

function getValueParameter(r) {
  var value = r.getAttribute('data-value');
  try {
    return JSON.parse(value);
  } catch (e) {}

  return value;
}

function matchValueByKey(r, val, key, idx) {
  var value = r.getAttribute('data-value');
  if (!key && (val === idx || val === value)) {
    return r;
  } else {
    try {
      var json = JSON.parse(value);
      if (_typeof(json[key]) === 'object' ? json[key] === val : String(json[key]) === String(val)) {
        return r;
      }
    } catch (e) {}
  }
  return false;
}

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: '_dataview'
 *
 * @desc
 * This is an abstraction layer for Icon, Tree and List views.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     Mixed         The value/currently selected
 *   getter    selected  Mixed         Alias of 'value'
 *   getter    entry     Mixed         Gets an etnry by value, key
 *   setter    value     Mixed         The value/currently selected
 *   property  multiple  boolean       If multiple elements are selectable
 *   event     select                  When entry was selected => fn(ev)
 *   event     activate                When entry was activated => fn(ev)
 *   action    add                     Add elements(s) => fn(entries)
 *   action    patch                   Patch/Update elements => fn(entries)
 *   action    remove                  Removes element => fn(arg)
 *   action    clear                   Clear elements => fn()
 * </code></pre>
 *
 * @abstract
 * @extends GUIElement
 */

var UIDataView = function (_GUIElement) {
  _inherits(UIDataView, _GUIElement);

  function UIDataView() {
    _classCallCheck(this, UIDataView);

    return _possibleConstructorReturn(this, (UIDataView.__proto__ || Object.getPrototypeOf(UIDataView)).apply(this, arguments));
  }

  _createClass(UIDataView, [{
    key: 'clear',


    /**
     * Clears the view
     *
     * @param {Node} [body] The body to clear
     *
     * @return {GUIElement} this
     */
    value: function clear(body) {
      var el = this.$element;
      if (!arguments.length) {
        body = el;
      }

      el.querySelectorAll(getEntryTagName(el)).forEach(function (row) {
        Events.$unbind(row);
      });

      DOM.$empty(body);
      body.scrollTop = 0;
      el._selected = [];

      return this;
    }

    /**
     * Adds one or more elements
     *
     * @param {Array|Object}  entries       Entry list, or a single entry
     * @param {Function}      [oncreate]    Callback on creation => fn(this, node)
     *
     * @return {GUIElement} this
     */

  }, {
    key: 'add',
    value: function add(entries, oncreate) {
      var _this2 = this;

      oncreate = oncreate || function () {};

      if (!(entries instanceof Array)) {
        entries = [entries];
      }

      entries.forEach(function (el) {
        oncreate(_this2, el);
      });

      return this;
    }

    /**
     * Do a diffed render
     *
     * @param {Array|Object}  entries       Entry list, or a single entry
     * @param {String}        className     Classname of entry
     * @param {Node}          body          The body container
     * @param {Function}      [oncreate]    Callback on creation => fn(this, node)
     * @param {Function}      [oninit]      Callback on init => fn(this, node)
     *
     * @return {GUIElement} this
     */

  }, {
    key: 'patch',
    value: function patch(entries, className, body, oncreate, oninit) {
      var _this3 = this;

      var single = false;

      if (!(entries instanceof Array)) {
        entries = [entries];
        single = true;
      }

      var inView = {};
      body.querySelectorAll(className).forEach(function (row) {
        var id = row.getAttribute('data-id');
        if (id !== null) {
          inView[id] = row;
        }
      });

      entries.forEach(function (entry) {
        var insertBefore = void 0;
        if (typeof entry.id !== 'undefined' && entry.id !== null) {
          if (inView[entry.id]) {
            insertBefore = inView[entry.id];
            delete inView[entry.id];
          }

          var row = oncreate(_this3, entry);
          if (row) {
            if (insertBefore) {
              if (DOM.$hasClass(insertBefore, 'gui-active')) {
                DOM.$addClass(row, 'gui-active');
              }

              body.insertBefore(row, insertBefore);
              //this.remove(null, className, insertBefore, body);
              UIDataView.prototype.remove.call(_this3, null, className, insertBefore, body);
            } else {
              body.appendChild(row);
            }
            oninit(_this3, row);
          }
        }
      });

      if (!single) {
        Object.keys(inView).forEach(function (k) {
          //this.remove(null, className, inView[k]);
          UIDataView.prototype.remove.call(_this3, null, className, inView[k]);
        });
      }

      inView = {};
      this.updateActiveSelection(className);

      return this;
    }

    /**
     * Remove element
     *
     * @param {Array}     [args]      id, key pair
     * @param {String}    [className] Classname of entry
     * @param {Node}      [target]    Remove this target instead of using args
     * @param {Node}      [parentEl]  Entry parent node
     *
     * @return {GUIElement} this
     */

  }, {
    key: 'remove',
    value: function remove(args, className, target, parentEl) {

      args = args || [];
      parentEl = parentEl || this.$element;

      if (target) {
        DOM.$remove(target);
      } else if (typeof args[1] === 'undefined' && typeof args[0] === 'number') {
        DOM.$remove(parentEl.querySelectorAll(className)[args[0]]);
      } else {
        var findId = args[0];
        var findKey = args[1] || 'id';
        var q = 'data-' + findKey + '="' + findId + '"';
        parentEl.querySelectorAll(className + '[' + q + ']').forEach(DOM.$remove);
      }

      this.updateActiveSelection(className);

      return this;
    }

    /*
     * Update active selection
     */

  }, {
    key: 'updateActiveSelection',
    value: function updateActiveSelection(className) {
      var active = [];
      this.$element.querySelectorAll(className + '.gui-active').forEach(function (cel) {
        active.push(DOM.$index(cel));
      });
      this.$element._active = active;
    }

    /*
     * Scroll given element into view
     */

  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(element) {
      var el = this.$element;
      var pos = DOM.$position(element, el);

      var marginTop = 0;
      if (el.tagName.toLowerCase() === 'gui-list-view') {
        var header = el.querySelector('gui-list-view-head');
        if (header) {
          marginTop = header.offsetHeight;
        }
      }

      var scrollSpace = el.scrollTop + el.offsetHeight - marginTop;
      var scrollTop = el.scrollTop + marginTop;
      var elTop = pos.top - marginTop;

      if (pos !== null && (elTop > scrollSpace || elTop < scrollTop)) {
        el.scrollTop = elTop;
        return true;
      }

      return false;
    }

    /*
     * Binds events and such for an entry
     */

  }, {
    key: 'bindEntryEvents',
    value: function bindEntryEvents(row, className) {
      var el = this.$element;

      function createDraggable() {
        var value = row.getAttribute('data-value');
        if (value !== null) {
          try {
            value = JSON.parse(value);
          } catch (e) {}
        }

        var source = row.getAttribute('data-draggable-source');
        if (source === null) {
          source = GUI.getWindowId(el);
          if (source !== null) {
            source = { wid: source };
          }
        }

        GUI.createDraggable(row, {
          type: el.getAttribute('data-draggable-type') || row.getAttribute('data-draggable-type'),
          source: source,
          data: value
        });

        var tooltip = row.getAttribute('data-tooltip');
        if (tooltip && !row.getAttribute('title')) {
          row.setAttribute('title', tooltip);
        }
      }

      el.dispatchEvent(new CustomEvent('_render', { detail: {
          element: row,
          data: GUI.getViewNodeValue(row)
        } }));

      if (el.getAttribute('data-draggable') === 'true') {
        createDraggable();
      }
    }

    /*
     * Get selected from array of nodes
     */

  }, {
    key: 'getSelected',
    value: function getSelected(entries) {
      var selected = [];
      entries.forEach(function (iter, idx) {
        if (DOM.$hasClass(iter, 'gui-active')) {
          selected.push({
            index: idx,
            data: GUI.getViewNodeValue(iter)
          });
        }
      });
      return selected;
    }

    /*
     * Get entry from an array of nodes
     */

  }, {
    key: 'getEntry',
    value: function getEntry(entries, val, key, asValue) {
      if (val) {
        var result = null;
        entries.forEach(function (r, idx) {
          if (!result && matchValueByKey(r, val, key, idx)) {
            result = r;
          }
        });

        return asValue && result ? getValueParameter(result) : result;
      }

      if (asValue && entries) {
        try {
          return entries.map(function (iter) {
            return getValueParameter(iter);
          });
        } catch (e) {
          console.warn(e);
        }
      }

      return entries;
    }

    /*
     * Set selected from array of nodes
     */

  }, {
    key: 'setSelected',
    value: function setSelected(body, entries, val, key, opts) {
      var _this4 = this;

      var select = [];
      var el = this.$element;

      var scrollIntoView = false;
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) === 'object') {
        scrollIntoView = opts.scroll === true;
      }

      var sel = function sel(r, idx) {
        select.push(idx);
        DOM.$addClass(r, 'gui-active');
        if (scrollIntoView) {
          _this4.scrollIntoView(r);
        }
      };

      entries.forEach(function (r, idx) {
        DOM.$removeClass(r, 'gui-active');
        if (matchValueByKey(r, val, key, idx)) {
          sel(r, idx);
        }
      });

      el._selected = select;
    }

    /*
     * Builds element
     */

  }, {
    key: 'build',
    value: function build(applyArgs) {
      var _this5 = this;

      var el = this.$element;
      el._selected = [];
      el.scrollTop = 0;

      DOM.$addClass(el, 'gui-data-view');

      var singleClick = el.getAttribute('data-single-click') === 'true';

      var moved = void 0;
      var wasResized = false;
      var multipleSelect = el.getAttribute('data-multiple');
      multipleSelect = multipleSelect === null || multipleSelect === 'true';

      var select = function select(ev) {
        if (moved || wasResized) {
          return false;
        }

        var row = getEntryFromEvent(ev);
        if (!row) {
          return false;
        }

        var className = row.tagName.toLowerCase();
        if (isHeader(null, row)) {
          var col = getEntryFromEvent(ev, true);
          if (col) {
            var sortBy = col.getAttribute('data-sortby');
            if (sortBy) {
              var sortDir = col.getAttribute('data-sortdir');
              var resetDir = sortDir === 'desc';
              sortDir = sortDir === 'asc' ? 'desc' : resetDir ? null : 'asc';
              sortBy = resetDir ? null : sortBy;

              col.setAttribute('data-sortdir', sortDir);

              el.setAttribute('data-sortby', sortBy || '');
              el.setAttribute('data-sortdir', sortDir || '');

              el.dispatchEvent(new CustomEvent('_sort', { detail: {
                  sortDir: sortDir,
                  sortBy: sortBy
                } }));
            }
          }
          return false;
        }

        if (className === 'gui-tree-view-expander') {
          _this5.expand({
            ev: ev,
            entry: row.parentNode
          });
          return true;
        }

        var idx = DOM.$index(row);
        el._selected = handleItemSelection(ev, row, idx, className, el._selected, el, multipleSelect);
        el.dispatchEvent(new CustomEvent('_select', { detail: { entries: _this5.values() } }));

        return true;
      };

      var activate = function activate(ev) {
        if (moved || isHeader(ev)) {
          return;
        }

        if (singleClick) {
          if (select(ev) === false) {
            return;
          }
        } else {
          if (!getEntryFromEvent(ev)) {
            return;
          }
        }

        el.dispatchEvent(new CustomEvent('_activate', { detail: { entries: _this5.values() } }));
      };

      var context = function context(ev) {
        if (isHeader(ev)) {
          return;
        }

        select(ev);
        el.dispatchEvent(new CustomEvent('_contextmenu', { detail: { entries: _this5.values(), x: ev.clientX, y: ev.clientY } }));
      };

      if (!el.querySelector('textarea.gui-focus-element') && !el.getAttribute('no-selection')) {
        var underlay = document.createElement('textarea');
        underlay.setAttribute('aria-label', '');
        underlay.setAttribute('aria-hidden', 'true');
        underlay.setAttribute('readonly', 'true');
        underlay.className = 'gui-focus-element';
        Events.$bind(underlay, 'focus', function (ev) {
          ev.preventDefault();
          DOM.$addClass(el, 'gui-element-focused');
        });
        Events.$bind(underlay, 'blur', function (ev) {
          ev.preventDefault();
          DOM.$removeClass(el, 'gui-element-focused');
        });
        Events.$bind(underlay, 'keydown', function (ev) {
          ev.preventDefault();
          handleKeyPress(_this5, el, ev);
        });
        Events.$bind(underlay, 'keypress', function (ev) {
          ev.preventDefault();
        });

        Events.$bind(el, 'pointerdown,touchstart', function (ev) {
          moved = false;
          var target = ev.target;
          wasResized = target && target.tagName === 'GUI-LIST-VIEW-COLUMN-RESIZER';
        }, true);
        Events.$bind(el, 'touchmove', function (ev) {
          moved = true;
        }, true);

        if (singleClick) {
          Events.$bind(el, 'click', activate, true);
        } else {
          Events.$bind(el, 'click', select, true);
          Events.$bind(el, 'dblclick', activate, true);
        }

        Events.$bind(el, 'contextmenu', function (ev) {
          ev.preventDefault();
          context(ev);
          return false;
        }, true);

        this.on('select', function (ev) {
          if (DOM.$hasClass(el, 'gui-element-focused')) {
            return;
          }
          // NOTE: This is a fix for Firefox stupid behaviour when focusing/blurring textboxes
          // (which is used to have a focusable area in this case, called underlay)
          var oldTop = el.scrollTop;
          underlay.focus();
          el.scrollTop = oldTop;
          setTimeout(function () {
            el.scrollTop = oldTop;
          }, 2);
        }, true);

        el.appendChild(underlay);
      }
    }

    /*
     * Focuses element
     */

  }, {
    key: 'focus',
    value: function focus() {
      try {
        var underlay = this.$element.querySelector('.gui-focus-element');
        underlay.focus();
      } catch (e) {
        console.warn(e, e.stack);
      }
    }

    /*
     * Blurs element
     */

  }, {
    key: 'blur',
    value: function blur() {
      try {
        var underlay = this.$element.querySelector('.gui-focus-element');
        underlay.blur();
      } catch (e) {
        console.warn(e, e.stack);
      }
    }

    /*
     * Gets values from selected entries
     */

  }, {
    key: 'values',
    value: function values() {
      return [];
    }

    /*
     * Binds an event
     */

  }, {
    key: 'on',
    value: function on(evName, callback, params) {
      if (['activate', 'select', 'expand', 'contextmenu', 'render', 'drop', 'sort'].indexOf(evName) !== -1) {
        evName = '_' + evName;
      }
      Events.$bind(this.$element, evName, callback.bind(this), params);
      return this;
    }
  }]);

  return UIDataView;
}(_element2.default);

exports.default = UIDataView;

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @author  Mohammed Seddik Laraba <lmseddik@icloud.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'خطأ فتح الملف',
  'ERR_WM_NOT_RUNNING': 'مسيير النوافذ ليس قيد التشغيل',
  'ERR_FILE_OPEN_FMT': ' الملف \'**{0}**\' غير قابل للفتح من طرف النظام',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'لم يتمكن النظام من إيجاد تطبيق يدعم هذه الملفات \'{0}\' files',
  'ERR_APP_LAUNCH_FAILED': 'خطأ في تشغيل التطبيق',
  'ERR_APP_LAUNCH_FAILED_FMT': 'حدث خطأ أثناء محاولة التشغيل: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'التطبيق \'{0}\' construct فشل: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'التطبيق \'{0}\' init() فشل: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'موارد التطبيق ناقصة لـ \'{0}\' أو لم تتمكن من التشغيل!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'التطبيق \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'The application \'{0}\' is already launched and allows only one instance!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'خطأ في تشغيل \'{0}\'. لا توجد تعاريف للتطبيق!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'خطأ في تشغيل \'{0}\'. متصفحك غير مدعوم: {1}',

  'ERR_NO_WM_RUNNING': 'لايوجد أي مسيير نوافذ قيد التشغيل',
  'ERR_CORE_INIT_FAILED': 'Failed to initialize OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'حدث خطأ أثناء بداية تشغيل OS.js',
  'ERR_CORE_INIT_NO_WM': 'لا يمكن تشغيل OS.js: لايوجد مسيير نوافذ!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'لايمكن تشغيل OS.js: فشل في تحميل مسير النوافذ: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'لايمكن تشغيل OS.js: فشل في تحميل الموارد...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript إشعار بخطأ',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'خطأ غير متوقع.',

  'ERR_APP_API_ERROR': 'خطأ في API التطبيق ',
  'ERR_APP_API_ERROR_DESC_FMT': 'التطبيق {0} لم يستطيع أن يقوم بالعملية \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'نقص في لعناصر : {0}',
  'ERR_APP_UNKNOWN_ERROR': 'خطأ غير معروف',

  'ERR_OPERATION_TIMEOUT': 'نهاية الوقت المسموع للعملية',
  'ERR_OPERATION_TIMEOUT_FMT': 'نهاية الوقت المسموح للعملية ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' متوقع \'{1}\' أن تكون \'{2}\', \'{3}\' معطى',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'لديك نافذة مسبقا بإسم \'{0}\'',
  'WINDOW_MINIMIZE': 'تصغير',
  'WINDOW_MAXIMIZE': 'تكبير',
  'WINDOW_RESTORE': 'إستعادة',
  'WINDOW_CLOSE': 'إغلاق',
  'WINDOW_ONTOP_ON': 'فوق الجميع (تشغيل)',
  'WINDOW_ONTOP_OFF': 'فوق الجميع (تعطيل)',

  // Handler
  'TITLE_SIGN_OUT': 'تسجيل الخروج',
  'TITLE_SIGNED_IN_AS_FMT': 'متصل بإسم: {0}',
  'ERR_LOGIN_FMT': 'خطأ تسجيل الدخول: {0}',
  'ERR_LOGIN_INVALID': 'تسجيل دخول غير موجود',

  // SESSION
  'ERR_NO_SESSION': 'لا توجد أي حصة منشأة، هل تريد التجربة مرة أخرى ؟',
  'MSG_SESSION_WARNING': 'هل تريد بالتأكيد الخروج من OS.js ؟ جميع التغيرات الغير محفوظة ستلغى !',

  // Service
  'BUGREPORT_MSG': 'الرجاء إشعارنا إذا ضننت أن هذا خطأ،\n أضف شرح قصير حول كيفية حدوث الخطأ، وإن أمكن كيفية إعادة إستحداث الخطأ مرة أخرى',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'تسجيل دخول إلى خدمات خارجية: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'خطأ مميت',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR خطأ: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'تسجيل الخروج (خروج)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'خروج المستخدم \'{0}\'.\nهل تريد بالتأكيد إنهاء الحصة الجارية?',

  'DIALOG_CLOSE': 'إغلاق',
  'DIALOG_CANCEL': 'إلغاء',
  'DIALOG_APPLY': 'تطبيق',
  'DIALOG_OK': 'موافق',

  'DIALOG_ALERT_TITLE': 'نافذة التحذير',

  'DIALOG_COLOR_TITLE': 'نافذة الألوان',
  'DIALOG_COLOR_R': 'أحمر: {0}',
  'DIALOG_COLOR_G': 'أخضر: {0}',
  'DIALOG_COLOR_B': 'أزرق: {0}',
  'DIALOG_COLOR_A': 'ألفا: {0}',

  'DIALOG_CONFIRM_TITLE': 'نافذة التأكيد',

  'DIALOG_ERROR_MESSAGE': 'رسالة',
  'DIALOG_ERROR_SUMMARY': 'الحوصلة',
  'DIALOG_ERROR_TRACE': 'إتباع',
  'DIALOG_ERROR_BUGREPORT': 'إشعار بخطأ',

  'DIALOG_FILE_SAVE': 'حفظ',
  'DIALOG_FILE_OPEN': 'فتح',
  'DIALOG_FILE_MKDIR': 'مجلد جديد',
  'DIALOG_FILE_MKDIR_MSG': 'إنشاء مجلد جديد في **{0}**',
  'DIALOG_FILE_OVERWRITE': 'هل تريد بالتأكيد تجاوز وإستبدال الملف \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'نوع المظهر',
  'DIALOG_FILE_MNU_LISTVIEW': 'مظهر القائمة',
  'DIALOG_FILE_MNU_TREEVIEW': 'مظهر الشجرة',
  'DIALOG_FILE_MNU_ICONVIEW': 'مظهر الأيقونات',
  'DIALOG_FILE_ERROR': 'خطأ نافذة الملفات',
  'DIALOG_FILE_ERROR_SCANDIR': 'فشل إظهار محتوي المجلد \'{0}\' بسبب حدوث خطأ',
  'DIALOG_FILE_ERROR_FIND': 'فشل البحث في المجلد \'{0}\' بسبب حدوث خطأ',
  'DIALOG_FILE_MISSING_FILENAME': 'يجب إختيار ملف أو إدخال ملف جديد!',
  'DIALOG_FILE_MISSING_SELECTION': 'يجب إختيار ملف!',

  'DIALOG_FILEINFO_TITLE': 'معلومات الملف',
  'DIALOG_FILEINFO_LOADING': 'تحميل معلومات الملف: {0}',
  'DIALOG_FILEINFO_ERROR': 'نافذة معلومات الملف خطأ',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'فشل في تحديد معلومات الملف for **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'فشل في تحديد معلومات الملف for: {0}',

  'DIALOG_INPUT_TITLE': 'نافذة الإدخال',

  'DIALOG_FILEPROGRESS_TITLE': 'عملية على الملفات جارية',
  'DIALOG_FILEPROGRESS_LOADING': 'تحميل...',

  'DIALOG_UPLOAD_TITLE': 'نافذة رفع الملفات',
  'DIALOG_UPLOAD_DESC': 'رفم الملف إلى **{0}**.<br />حد الحجم: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'جاري الرفع \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'جاري رفع الملف...',
  'DIALOG_UPLOAD_FAILED': 'رفع الملف',
  'DIALOG_UPLOAD_FAILED_MSG': 'خطأ رفع الملف',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'أسباب غير معروفة...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'إلغي من طرف المستخدم...',
  'DIALOG_UPLOAD_TOO_BIG': 'ملف كبير جدا',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'ملف كبير جدا, تخطى {0}',

  'DIALOG_FONT_TITLE': 'نافذة الخطوط',

  'DIALOG_APPCHOOSER_TITLE': 'إختيار التطبيق',
  'DIALOG_APPCHOOSER_MSG': 'إختار تطبيق لفتحه',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'يجب إختيار تطبيق',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'إستخدام كتطبيق إفتراضي دائم {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Module not configured or disabled',
  'GAPI_SIGN_OUT': 'Sign out from Google API Services',
  'GAPI_REVOKE': 'Revoke permissions and Sign Out',
  'GAPI_AUTH_FAILURE': 'Google API Authentication failed or did not take place',
  'GAPI_AUTH_FAILURE_FMT': 'Failed to authenticate: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Failed to load Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module not configured or disabled',
  'WLAPI_SIGN_OUT': 'Sign out from Window Live API',
  'WLAPI_LOAD_FAILURE': 'Failed to load Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Failed to log into Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Failed to log into Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returned {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'لا يمكن إنشاء IndexedDB دون إسم قاعدة معطيات',
  'IDB_NO_SUCH_ITEM': 'عنصر غير موجود',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'خطأ مميت',
  'ERR_VFS_UNAVAILABLE': 'غير متوفر',
  'ERR_VFS_FILE_ARGS': 'ملف ينتظر على الأقل عنصر',
  'ERR_VFS_NUM_ARGS': 'عدد العناصر غير كافي',
  'ERR_VFS_EXPECT_FILE': 'متوقع ملف',
  'ERR_VFS_EXPECT_SRC_FILE': 'متوقع مصدر الملف',
  'ERR_VFS_EXPECT_DST_FILE': 'متوقع وجهة الملف',
  'ERR_VFS_FILE_EXISTS': 'وجهة موجودة مسبقا',
  'ERR_VFS_TARGET_NOT_EXISTS': 'وجهة غير موجودة',
  'ERR_VFS_TRANSFER_FMT': 'حدث خطأ أثناء التحويل من مساحات التخزين: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'لا يمكن رفع ملف من دون وجهة',
  'ERR_VFS_UPLOAD_NO_FILES': 'لا يمكن رفع الملفات من دون تعيينها',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'خطأ رفع الملف: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'تك إلغاء رفع الملف',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'لا يمكن رفع مسار من دون مسار',
  'ERR_VFS_DOWNLOAD_FAILED': 'حدث خطأ أثناء تحميل: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'الإجابة كانت فارغة',

  'ERR_VFSMODULE_INVALID': 'قسم VFS غير صحيح',
  'ERR_VFSMODULE_INVALID_FMT': 'قسم VFS غير صحيح: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'قسم VFS طريقة',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'قسم VFS طريقة: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'نوع القسم VFS غير صحيح',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'نوع القسم VFS غير صحيح: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'إعدادات القسم VFS غير صحيحة',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'إعدادات القسم VFS إعدادات القسم: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'قسم VFS مركب مسبقا',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'قسم VFS \'{0}\' مركب مسبقا',
  'ERR_VFSMODULE_NOT_MOUNTED': 'قسم VFS غير مركب',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'قسم VFS \'{0}\' غير مركب',
  'ERR_VFSMODULE_EXCEPTION': 'قسم VFS خطأ',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'قسم VFS خطأ: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'لا يوجد VFS {0}. خطأ في شاكلة المسار ?',
  'ERR_VFSMODULE_READONLY': 'هذا VFS للقراءة فقط',
  'ERR_VFSMODULE_READONLY_FMT': 'هذا VFS  للقراءة فقط : {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'جاري تحميل الملف',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR خطأ',
  'ERR_VFSMODULE_ROOT_ID': 'خطأ تحديد معرف root',
  'ERR_VFSMODULE_NOSUCH': 'ملف غير موجود',
  'ERR_VFSMODULE_PARENT': 'لا يوجد أب',
  'ERR_VFSMODULE_PARENT_FMT': 'فشل البحث عن أب: {0}',
  'ERR_VFSMODULE_SCANDIR': 'فشل مسح المجلد',
  'ERR_VFSMODULE_SCANDIR_FMT': 'فشل مسح المجلد : {0}',
  'ERR_VFSMODULE_READ': 'فشل قراءة الملف',
  'ERR_VFSMODULE_READ_FMT': 'فشل قراءة الملف: {0}',
  'ERR_VFSMODULE_WRITE': 'فشل الكتابة في الملف',
  'ERR_VFSMODULE_WRITE_FMT': 'فشل الكتابة في الملف: {0}',
  'ERR_VFSMODULE_COPY': 'فشل في النسخ',
  'ERR_VFSMODULE_COPY_FMT': 'فشل في النسخ: {0}',
  'ERR_VFSMODULE_UNLINK': 'فشل في حذف رابط الملف',
  'ERR_VFSMODULE_UNLINK_FMT': 'فشل في حذف رابط الملف: {0}',
  'ERR_VFSMODULE_MOVE': 'فشل في تحريك الملف',
  'ERR_VFSMODULE_MOVE_FMT': 'فشل في تحريك الملف: {0}',
  'ERR_VFSMODULE_EXIST': 'فشل في تحديد وجود الملف',
  'ERR_VFSMODULE_EXIST_FMT': 'فشل في تحديد وجود الملف: {0}',
  'ERR_VFSMODULE_FILEINFO': 'فشل في تحديد معلومات الملف',
  'ERR_VFSMODULE_FILEINFO_FMT': 'فشل في تحديد معلومات الملف: {0}',
  'ERR_VFSMODULE_MKDIR': 'فشل في إنشاء المجلد',
  'ERR_VFSMODULE_MKDIR_FMT': 'فشل في إنشاء المجلد: {0}',
  'ERR_VFSMODULE_URL': 'فشل في الحصول على رابط الملف',
  'ERR_VFSMODULE_URL_FMT': 'فشل في الحصول على رابط الملف: {0}',
  'ERR_VFSMODULE_TRASH': 'فشل في تحريك الملف إلى سلة المحذوفات',
  'ERR_VFSMODULE_TRASH_FMT': 'فشل في تحريك الملف إلى سلة المحذوفات: {0}',
  'ERR_VFSMODULE_UNTRASH': 'فشل في تحريك الملف من سلة المحذوفات',
  'ERR_VFSMODULE_UNTRASH_FMT': 'فشل في تحريك الملف من سلة المحذوفات: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'فشل في تفريغ سلة المحذوفات',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'فشل في تفريغ سلة المحذوفات: {0}',
  'ERR_VFSMODULE_FIND': 'فشل في البحث',
  'ERR_VFSMODULE_FIND_FMT': 'فشل في البحث: {0}',
  'ERR_VFSMODULE_FREESPACE': 'فشل في الحصول على المساحة الفارغة',
  'ERR_VFSMODULE_FREESPACE_FMT': 'فشل في الحصول على المساحة الفارغة: {0}',
  'ERR_VFSMODULE_EXISTS': 'فشل في التأكيد على الوجود',
  'ERR_VFSMODULE_EXISTS_FMT': 'فشل في التأكيد على الوجود: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'أنت الآن مسجل في Dropbox API',
  'DROPBOX_SIGN_OUT': 'خروج من Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'خطأ في تحديد المسار : لا يوجد أي عنصر',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'خطأ تحميل zip.js',
  'ZIP_VENDOR_FAIL': 'zip.js غير موجود ?',
  'ZIP_NO_RESOURCE': 'لا توجد أي موارد zip.',
  'ZIP_NO_PATH': 'لم يعطى إي مسار',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'جاري البحث...',
  'SEARCH_NO_RESULTS': 'لا توجد أي نتيجة',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'مجلد التثبيت موجود من قبل، من المستحيل المتابعة !',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'لا يمكن فتح الملف',
  'ERR_FILE_APP_OPEN_FMT': 'الملف {0} غير قابل للفتح لأن التعريف {1} غير مدعوم',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'الملف {0} غير ممكن فتحه: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'الملف {0} غير ممكن حفظه: {1}',
  'ERR_GENERIC_APP_FMT': '{0} خطأ في التطبيق',
  'ERR_GENERIC_APP_ACTION_FMT': 'عدم التمكن من إنجاز العملية \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'خطأ غير معروف',
  'ERR_GENERIC_APP_REQUEST': 'حدث خطأ أثناء إجراء العملية المطلوبة',
  'ERR_GENERIC_APP_FATAL_FMT': 'خطأ مميت {0}',
  'MSG_GENERIC_APP_DISCARD': 'إلغاء التغيرات ?',
  'MSG_FILE_CHANGED': 'تم تغيير الملف، هل تريد التحديث',
  'MSG_APPLICATION_WARNING': 'تحذير النطبيق',
  'MSG_MIME_OVERRIDE': 'نوع الملف "{0}" غير مدعوم, إستخدم "{1}" في مكانه.',

  //
  // General
  //

  'LBL_UNKNOWN': 'غير معروف',
  'LBL_APPEARANCE': 'مظهر',
  'LBL_USER': 'مستخدم',
  'LBL_NAME': 'إسم',
  'LBL_APPLY': 'تطبيق',
  'LBL_FILENAME': 'إسم الملف',
  'LBL_PATH': 'مسار',
  'LBL_SIZE': 'حجم',
  'LBL_TYPE': 'نوع',
  'LBL_MIME': 'التعريف',
  'LBL_LOADING': 'جاري التحميل',
  'LBL_SETTINGS': 'إعدادات',
  'LBL_ADD_FILE': 'إضافة ملفات',
  'LBL_COMMENT': 'تعليق',
  'LBL_ACCOUNT': 'حساب',
  'LBL_CONNECT': 'إتصال',
  'LBL_ONLINE': 'متصل',
  'LBL_OFFLINE': 'غير متصل',
  'LBL_AWAY': 'بعيد',
  'LBL_BUSY': 'مشغول',
  'LBL_CHAT': 'دردشة',
  'LBL_HELP': 'مساعدة',
  'LBL_ABOUT': 'عن',
  'LBL_PANELS': 'اللوحات',
  'LBL_LOCALES': 'اللغة/المنطقة',
  'LBL_THEME': 'القالب',
  'LBL_COLOR': 'اللون',
  'LBL_PID': 'رقم العملية',
  'LBL_KILL': 'إنهاء',
  'LBL_ALIVE': 'في الخدمة',
  'LBL_INDEX': 'الرقم',
  'LBL_ADD': 'إضافة',
  'LBL_FONT': 'الخط',
  'LBL_YES': 'نعم',
  'LBL_NO': 'لا',
  'LBL_CANCEL': 'إلغاء',
  'LBL_TOP': 'أعلى',
  'LBL_LEFT': 'اليسار',
  'LBL_RIGHT': 'اليمين',
  'LBL_BOTTOM': 'أسفل',
  'LBL_CENTER': 'وسط',
  'LBL_FILE': 'ملف',
  'LBL_NEW': 'جديد',
  'LBL_OPEN': 'فتح',
  'LBL_SAVE': 'حفظ',
  'LBL_SAVEAS': 'حفظ بإسم...',
  'LBL_CLOSE': 'إغلاق',
  'LBL_MKDIR': 'مجلد جديد',
  'LBL_UPLOAD': 'رفع ملف',
  'LBL_VIEW': 'إظهار',
  'LBL_EDIT': 'تغيير',
  'LBL_RENAME': 'إعادة تسمية',
  'LBL_DELETE': 'حذف',
  'LBL_OPENWITH': 'فتح بواسطة ...',
  'LBL_ICONVIEW': 'إظهار كأيقونات',
  'LBL_TREEVIEW': 'إظهار كشجرة',
  'LBL_LISTVIEW': 'إظهار كقائمة',
  'LBL_REFRESH': 'تحديث',
  'LBL_VIEWTYPE': 'نوع المظهر',
  'LBL_BOLD': 'غليظ',
  'LBL_ITALIC': 'مائل',
  'LBL_UNDERLINE': 'مسطر',
  'LBL_REGULAR': 'عادي',
  'LBL_STRIKE': 'مشطوب',
  'LBL_INDENT': 'مساحة لأمام',
  'LBL_OUTDENT': 'مساحة للخلف',
  'LBL_UNDO': 'تراجع',
  'LBL_REDO': 'إلى الأمام',
  'LBL_CUT': 'قص',
  'LBL_UNLINK': 'حذف الرابط',
  'LBL_COPY': 'نسخ',
  'LBL_PASTE': 'لصق',
  'LBL_INSERT': 'إدراج',
  'LBL_IMAGE': 'صورة',
  'LBL_LINK': 'رابط',
  'LBL_DISCONNECT': 'قطع الإتصال',
  'LBL_APPLICATIONS': 'التطبيقات',
  'LBL_ADD_FOLDER': 'إضافة مجلد',
  'LBL_INFORMATION': 'معلومات',
  'LBL_TEXT_COLOR': 'لون النص',
  'LBL_BACK_COLOR': 'خلفية النص',
  'LBL_RESET_DEFAULT': 'لإستعادة لإفتراضي',
  'LBL_DOWNLOAD_COMP': 'تحميل إلى الكمبيوتر',
  'LBL_ORDERED_LIST': 'ترتيب القائمة',
  'LBL_BACKGROUND_IMAGE': 'صورة الخلفية',
  'LBL_BACKGROUND_COLOR': 'لون الخلفية',
  'LBL_UNORDERED_LIST': 'قائمة غير مرتبة',
  'LBL_STATUS': 'الحالة',
  'LBL_READONLY': 'قراءة-فقط',
  'LBL_CREATED': 'تاريخ الإنشاء',
  'LBL_MODIFIED': 'تاريخ التغيير',
  'LBL_SHOW_COLUMNS': 'إظهار الأعمدة',
  'LBL_MOVE': 'تحريك',
  'LBL_OPTIONS': 'خيارات',
  'LBL_OK': 'موافق',
  'LBL_DIRECTORY': 'مجلد',
  'LBL_CREATE': 'إنشاء',
  'LBL_BUGREPORT': 'إشعار بخطأ',
  'LBL_INSTALL': 'تثبيت',
  'LBL_UPDATE': 'تحديث',
  'LBL_REMOVE': 'إزالة',
  'LBL_SHOW_SIDEBAR': 'إظهار الشريط الجانبي',
  'LBL_SHOW_NAVIGATION': 'إظهار شريط الإنتقال',
  'LBL_SHOW_HIDDENFILES': 'إظهار الملفات المخفية',
  'LBL_SHOW_FILEEXTENSIONS': 'إظهار لواحق الملفات',
  'LBL_MOUNT': 'تركيب',
  'LBL_DESCRIPTION': 'الوصف',
  'LBL_USERNAME': 'المستخدم',
  'LBL_PASSWORD': 'كلمة المرور',
  'LBL_HOST': 'المستضيف',
  'LBL_NAMESPACE': 'إسم الساحة',
  'LBL_SEARCH': 'بحث',
  'LBL_Theme': 'القالب',
  'LBL_SOUNDS': 'أصوات',
  'LBL_ICONS': 'أيقونات',
  'LBL_BACKGROUND': 'خلفيات',
  'LBL_DESKTOP': 'المكتب',
  'LBL_PANEL': 'اللوحة',
  'LBL_POSITION': 'الوصعية',
  'LBL_ONTOP': 'في المقدمة',
  'LBL_ITEMS': 'العناصر',
  'LBL_GENERAL': 'عام',
  'LBL_DEBUG': 'تصحيح',
  'LBL_AUTOHIDE': 'إخفاء تلقائي',
  'LBL_OPACITY': 'الشفافية',
  'LBL_PACKAGES': 'الحزم',
  'LBL_GROUPS': 'المجموعات',
  'LBL_VERSION': 'الطبعة',
  'LBL_AUTHOR': 'الكاتب',
  'LBL_HIDE': 'إخفاء',
  'LBL_APPLICATION': 'تطبيق',
  'LBL_SCOPE': 'الزمرة'
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Ãðåøêà ïðè îòâàðÿíå íà ôàéë',
  'ERR_WM_NOT_RUNNING': 'Ìåíèäæúðà íà ïðîçîðöè íå ðàáîòè ',
  'ERR_FILE_OPEN_FMT': 'Ôàéëúò \'**{0}**\' íå ìîæå äà áúäå îòâîðåí',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Íÿìà íàìåðåíè ïðèëîæåíèÿ ñ ïîääðúæêà çà \'{0}\' ôàéëîâå',
  'ERR_APP_LAUNCH_FAILED': 'Ïðèëîæåíèåòî íå ìîæà äà áúäå ñòàðòèðàíî',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Ïîëó÷è ñå ãðåøêà ïî âðåìå íà ñòàðòèðàíå: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Ïðèìîæåíèåòî \'{0}\' ïðîâàëåíî èçãðàæäàíå: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Ïðèëîæåíèåòî \'{0}\' init() ïðîâàëåíî: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Ëèïñâàùè ðåñóðñè çà ïðèëîæåíèåòî \'{0}\' èëè ñå ïðîâàëè ñòàðòèðàíåòî!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Ïðèëîæåíèåòî \'{0}\' ïðåäâàðèòåëíî ñòàðòèðàíå ïðîâàëåíî: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Ïðèëîæåíèåòî \'{0}\' å âå÷å ñòàðòèðàíî!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Ãðåøêà ïðè ñòàðòèðàíå \'{0}\'. íÿìà íàìåðåíè äàííè!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Ãðåøêà ïðè ñòàðòèðàíå \'{0}\'. íåïîääúðæàí áðàóçúð: {1}',

  'ERR_NO_WM_RUNNING': 'Íÿìà ðàáîòåù ìåíèäæúð íà ïðîçîðöè',
  'ERR_CORE_INIT_FAILED': 'Ïðîâàëåíî èíèöèàëèçèðàíå íà OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Ãðåøêà ïðè èíèöèàëèçèðàíå íà OS.js',
  'ERR_CORE_INIT_NO_WM': 'OS.js íå ìîæå äà ñå ñòàðòèðà: Íå å îïðåäåëåí ìåíèäæúð íà ïðîçîðöè!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js íå ìîæå äà ñå ñòàðòèðà: Ïðîâàëåíî îòâàðÿíå íà ìåíèäæúð íà ïðîçîðöè: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'OS.js íå ìîæå äà ñå ñòàðòèðà: Ïðîâàëåíî çàðåæäàíå íà ðåñóðñèòå...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript èíôîðìàöèÿ íà ãðåøêà ',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Ïîÿâè ñå íåî÷êàâàíà ãðåøêà, âåðîÿòíî áúã.',

  'ERR_APP_API_ERROR': 'Ãðåøêà â  API íà ïðèëîæåíèåòî',
  'ERR_APP_API_ERROR_DESC_FMT': 'Ïðèëîæåíèåòî {0} íå ìîæà äà èçïúëíè îïåðàöèÿòà \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Ëèïñâàù àðãóìåíò: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Íåïîçíàòà ãðåøêà',

  'ERR_OPERATION_TIMEOUT': 'Ïðåñðî÷åíî âðåìå íà îïåðàöèÿòà',
  'ERR_OPERATION_TIMEOUT_FMT': 'Ïðåñðî÷åíî âðåìå íà îïåðàöèÿòà ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Âå÷å èìà íàèìåíîâàí ïðîçîðåö \'{0}\'',
  'WINDOW_MINIMIZE': 'Ìèíèìèçèðàé',
  'WINDOW_MAXIMIZE': 'Ìàêñèìèçèðàíå',
  'WINDOW_RESTORE': 'Âúçîáíîâè',
  'WINDOW_CLOSE': 'çàòâîðè',
  'WINDOW_ONTOP_ON': 'íàé-îòãîðå (ðàçðåøåíî)',
  'WINDOW_ONTOP_OFF': 'íàé-îòãîðå (çàáðàíåíî)',

  // Handler
  'TITLE_SIGN_OUT': 'Èçõîä',
  'TITLE_SIGNED_IN_AS_FMT': 'Âëåçëè ñòå êàòî: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Ñèãóðíè ëè ñòå, ÷å èñêàòå íà èçëåçåòå îò OS.js? Âñè÷êè íå çàïàçåíè íàñòðîéêè è èíôîðìàöèÿ ùå áúäàò çàãóáåíè!',

  // Service
  'BUGREPORT_MSG': 'Ìîëÿ äîêëàäâàéòå òîâà àêî ìèñëèòå, ÷å å áúã.\âêëþ÷åòå äåòàéëíî îïèñàíèå êàê ñå ïîëó÷è ãðåøêàòà è ñàìî àêî ìîæåòå; êàê ìîæå äà áúäå ïîïðàâåíà ',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Âëåçëè ñòå âúâ âúíøíè óñëóãè: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Ôàòàëíà ãðåøêà',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR ãðåøêà: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Èçëåç (Èçõîä)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Èçëèçàíå îò ïîòðåáèòåë \'{0}\'.\nÈñêàòå ëè äà çàïàçèòå òåêóùàòà ñåñèÿ?',

  'DIALOG_CLOSE': 'Çàòâîðè',
  'DIALOG_CANCEL': 'Îòêàæè',
  'DIALOG_APPLY': 'Ïðèëîæè',
  'DIALOG_OK': 'ÎÊ',

  'DIALOG_ALERT_TITLE': 'Äèàëîã çà èçâåñòèå',

  'DIALOG_COLOR_TITLE': 'Öâÿò íà äèàëîãà',
  'DIALOG_COLOR_R': '×åðâåí: {0}',
  'DIALOG_COLOR_G': 'Çåëåí: {0}',
  'DIALOG_COLOR_B': 'Ñèí: {0}',
  'DIALOG_COLOR_A': 'Àëôà: {0}',

  'DIALOG_CONFIRM_TITLE': 'Ïîòâúðäè äèàëîã',

  'DIALOG_ERROR_MESSAGE': 'Ñúîáùåíèå',
  'DIALOG_ERROR_SUMMARY': 'Ñúäúðæàíèå',
  'DIALOG_ERROR_TRACE': 'Òúðñè',
  'DIALOG_ERROR_BUGREPORT': 'Äîêëàäâàé áúã',

  'DIALOG_FILE_SAVE': 'Çàïàçè',
  'DIALOG_FILE_OPEN': 'Îòâîðè',
  'DIALOG_FILE_MKDIR': 'Íîâà ïàïêà',
  'DIALOG_FILE_MKDIR_MSG': 'Ñúçäàé íîâà äèðåêòîðèÿ â **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Ñèãóðíè ëè ñòå, ÷å èñêàòå äà ïðåçàïèøåòå ôàèëúò \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Òèï íà èçãëåä',
  'DIALOG_FILE_MNU_LISTVIEW': 'Ñïèñúê',
  'DIALOG_FILE_MNU_TREEVIEW': 'Äúðâî',
  'DIALOG_FILE_MNU_ICONVIEW': 'Èêîíè',
  'DIALOG_FILE_ERROR': 'Ãðåøêà âúâ ôàéëîâ äèàëîã',
  'DIALOG_FILE_ERROR_SCANDIR': 'Ïðîâàëåíî ðàçãëåæäàíå íà äèðåêòîðèÿòà \'{0}\' ïîðàäè ãðåøêà',
  'DIALOG_FILE_MISSING_FILENAME': 'Òðÿáâà äà èçáåðåòå ôàéë èëè äà âúâåäåòå èìå!',
  'DIALOG_FILE_MISSING_SELECTION': 'Òðÿáâà äà èçáåðåòå ôàéë!',

  'DIALOG_FILEINFO_TITLE': 'Èíôîðàìöèÿ çà ôàéëúò',
  'DIALOG_FILEINFO_LOADING': 'Çàðåæäàíå íà èíôîðìàöèÿ çà: {0}',
  'DIALOG_FILEINFO_ERROR': 'Ãðåøêà â èíôîðìàöèÿ çà ôàéë',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Íå ìîæå äà áúäå íàìåðåíà èíôîðìàöèÿ çà ôàéëúò **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Íå ìîæå äà áúäå íàìåðåíà èíôîðìàöèÿ çà ôàéëúò: {0}',

  'DIALOG_INPUT_TITLE': 'Âõîäÿù äèàëîã',

  'DIALOG_FILEPROGRESS_TITLE': 'Ïðîãðåñ íà îïåðàöèÿòà íà ôàéëúò',
  'DIALOG_FILEPROGRESS_LOADING': 'Çàðåæäàíå...',

  'DIALOG_UPLOAD_TITLE': 'Äîáàâè äèàëîã',
  'DIALOG_UPLOAD_DESC': 'Äîáàâè ôàéë êúì **{0}**.<br />Ìàêñèìàëåí ðàçìåð: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Äîáàâÿíå \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Äîáàâÿíå íà ôàèë...',
  'DIALOG_UPLOAD_FAILED': 'Äîáàâÿíå ïðîâàëåíî',
  'DIALOG_UPLOAD_FAILED_MSG': 'Äîáàâÿíåòî å ïðîâàëåíî',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Íåîïðåäåëåíà ïðè÷èíà...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Îòêàçàíî îò ïîòðåáèòåë...',
  'DIALOG_UPLOAD_TOO_BIG': 'Ôàéëúò å ïðåêàëåíî ãîëÿì',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Ôàéëúò å ïðåêàëåíî ãîëÿì, íàäâèøàâà {0}',

  'DIALOG_FONT_TITLE': 'Øðèôò íà äèàëîã',

  'DIALOG_APPCHOOSER_TITLE': 'Èçáåðåòå ïðèëîæåíèå',
  'DIALOG_APPCHOOSER_MSG': 'Èçáåðåòå ïðèëîæåíèå êîåòî äà ñå îòâîðè',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Òðÿáâà äà èçáåðåòå ïðèëîæåíèå',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Èçïîëçâàé êàòî ïðèëîæåíèå ïî ïîäðàçáèðàíå çà {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Ìîäóë íå å êîíôèãóðèðàí èëè å èçêëþ÷åí',
  'GAPI_SIGN_OUT': 'Èçõîä îò Google API óñëóãè',
  'GAPI_REVOKE': 'Îòòåãëÿíå íà ïðàâàòà è èçõîä',
  'GAPI_AUTH_FAILURE': 'Google API óäîñòîâåðÿâàíå ïðîâàëåíî èëè íå å ïðîâåäåíî',
  'GAPI_AUTH_FAILURE_FMT': 'Ãðåøêà ïðè óäîñòîâåðÿâàíå: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Ïðîâàëåíî ñòàðòèðàíå íà Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API ìîäóë íå å êîíôèãóðèðàí èëè å èçêëþ÷åí',
  'WLAPI_SIGN_OUT': 'Èçõîä îò Window Live API',
  'WLAPI_LOAD_FAILURE': 'Ïðîâàëåíî ñòàðòèðàíå íà Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Ïðîâàëåíî âëèçàíå â Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Ïðîâàëåíî âëèçàíå â Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API îòãîâîðè {0} ñòàòóñ',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Íå ìîæå äà áúäå ñúçäàäåíà IndexedDB áåç èìå íà áàçà äàííè',
  'IDB_NO_SUCH_ITEM': 'Íå ñúùåñòâóâàù îáåêò',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Ôàòàëíà ãðåøêà',
  'ERR_VFS_UNAVAILABLE': 'Íå â íàëè÷íî',
  'ERR_VFS_FILE_ARGS': 'Ôàéëúò î÷àêâà ïîíå åäèí àðãóìåíò',
  'ERR_VFS_NUM_ARGS': 'Íÿìà äîñòàòú÷íî àðãóìåíòè',
  'ERR_VFS_EXPECT_FILE': 'Î÷àêâà ôàéëîâ-îáåêò',
  'ERR_VFS_EXPECT_SRC_FILE': 'Î÷êâà èçòî÷íèê Ôàéëîâ-îáåêò',
  'ERR_VFS_EXPECT_DST_FILE': 'Î÷àêâà äåñòèíàöèÿ Ôàéëîâ-îáåêò',
  'ERR_VFS_FILE_EXISTS': 'Äåñòèíàöèÿòà âå÷å ñúùåñòâóâà',
  'ERR_VFS_TRANSFER_FMT': 'Ïîÿâè ñå ãðåøêà äîêàòî ñå èçâúðøâàøå òðàíñôåð: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Íå ìîæå äà áúäå äîáàâåí ôàéë áåç äåâñòèíàöèÿ',
  'ERR_VFS_UPLOAD_NO_FILES': 'Íå ìîæå äà ñå äîáàâÿ áåç îïðåäåëÿíå íà ôàéëîâå',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Ïðîâàëåíî äîáàâÿíå íà ôàéëîâå: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Äîáàâÿíåòî íà ôàéëîâå áåøå ïðåêðàòåíî',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Íå ìîæå äà ñå èçòåãëè áåç óêàçàí ïúò ',
  'ERR_VFS_DOWNLOAD_FAILED': 'Ïîÿâè ñå ãðåøêà ïðè èçòåãëÿíå: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Îòãîâîðà áåøå ïðàçåí',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Èçòåãëÿíå íà ôàéë',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR ãðåøêà',
  'ERR_VFSMODULE_ROOT_ID': 'Íå ìîæå äà áúäå íàìåðåíî ÈÄ íà root ïàïêàòà',
  'ERR_VFSMODULE_NOSUCH': 'Ôàéëúò íå ñúùåñòâóâà',
  'ERR_VFSMODULE_PARENT': 'Íÿìà íàìåðåí èçòî÷íèê',
  'ERR_VFSMODULE_PARENT_FMT': 'Íå ìîæà äà áúäå íàìåðåí èçòî÷íêè: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Ïðîâàëåíî ñêàíèðàíå íà äèðåêòîðèÿ',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Ïðîâàëåíî ñêàíèðàíå íà äèðåêòîðèÿ: {0}',
  'ERR_VFSMODULE_READ': 'Ïðîâàëåíî ïðî÷èòàíå íà ôàéëúò',
  'ERR_VFSMODULE_READ_FMT': 'Ïðîâàëåíî ïðî÷èòàíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_WRITE': 'Ïðîâàëåíî çàïèñâàíå íà ôàéëúò',
  'ERR_VFSMODULE_WRITE_FMT': 'Ïðîâàëåíî çàïèñâàíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_COPY': 'Ïðîâàëåíî êîïèðàíå',
  'ERR_VFSMODULE_COPY_FMT': 'Ïðîâàëåíî êîïèðàíå: {0}',
  'ERR_VFSMODULE_UNLINK': 'Ïðîâàëåíî ðàçêà÷àíå íà ôàéëúò ',
  'ERR_VFSMODULE_UNLINK_FMT': 'Ïðîâàëåíî ðàçêà÷àíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_MOVE': 'Ïðîâàëåíî ïðåìåñòâàíå íà ôàéëúò',
  'ERR_VFSMODULE_MOVE_FMT': 'Ïðîâàëåíî ïðåìåñòâàíå íà ôàèëúò: {0}',
  'ERR_VFSMODULE_EXIST': 'Ïðîâàëåíà ïðîæåðêà çà ñúùåñòâóâàíå íà ôàéëúò',
  'ERR_VFSMODULE_EXIST_FMT': 'Ïðîâàëåíà ïðîæåðêà çà ñúùåñòâóâàíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Ïðîâàëåíî ïîëó÷àâàíå íà èíôîðìàöèÿ çà ôàéëúò',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Ïðîâàëåíî ïîëó÷àâàíå íà èíôîðìàöèÿ çà ôàéëúò: {0}',
  'ERR_VFSMODULE_MKDIR': 'Ïðîâàëåíî ñúçäàâàíå íà äèðåêòîðèÿ',
  'ERR_VFSMODULE_MKDIR_FMT': 'Ïðîâàëåíî ñúçäàâàíå íà äèðåêòîðèÿ: {0}',
  'ERR_VFSMODULE_URL': 'Ïðîâàëåíî ïîëó÷àâàíå íà URL çà ôàéëúò',
  'ERR_VFSMODULE_URL_FMT': 'Ïðîâàëåíî ïîëó÷àâàíå íà URL çà ôàéëúò: {0}',
  'ERR_VFSMODULE_TRASH': 'Ïðîâàëåíî èçòðèâàíå',
  'ERR_VFSMODULE_TRASH_FMT': 'Ïðîâàëåíî èçòðèâàíå: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Ïðîâàëåíî èçêàðâàíå îò êîø÷åòî',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Ïðîâàëåíî èçêàðâàíå îò êîø÷åòî: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Ïðîâàëåíî èçïðàçâàíå íà êîø÷åòî',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Ïðîâàëåíî èçïðàçâàíå íà êîø÷åòî: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Âëåçëè ñòå â Dropbox API',
  'DROPBOX_SIGN_OUT': 'Èçõîä îò Dropbox API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Ïðîâàëåíî íàìèðàíå íà ïúò: Îáåêòà íå å íàìåðåí',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Äèðåêòîðèÿ çà èíñòàëèðàíå íà ïàêåòè âå÷å ñúùåñòâóâà. Íå ìîæå äà ïðîäúëæèòå!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Íå ìîæå äà áúäå îòâîðåí ôàéëúò',
  'ERR_FILE_APP_OPEN_FMT': 'Ôàéëúò {0} íå ìîæå äà áúäå îòîâîðåí {1} íå ñå ïîääúðæà',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Ôàéëúò {0} íå ìîæå äà áúäå îòâîðåí: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Ôàéëúò {0} íå ìîæå äà áúäå çàïàçåí: {1}',
  'ERR_GENERIC_APP_FMT': '{0} ãðåøêà â ïðèëîæåíèåòî',
  'ERR_GENERIC_APP_ACTION_FMT': 'Ïðîâàëåíî èçïúëíåíÿâàíå íà äåéñòâèå \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Íåïîçíàòà ãðåøêà',
  'ERR_GENERIC_APP_REQUEST': 'Ïîëó÷è ñå ãðåøêà ïðè èçïúëíÿâàíå íà çàÿâêàòà',
  'ERR_GENERIC_APP_FATAL_FMT': 'Ôàòàëíà ãðåøêà: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Îòêàæè ïðîìåíèòå?',
  'MSG_FILE_CHANGED': 'Ôàéëúò å ïðîìåíåí. ïðåçàðåäè?',
  'MSG_APPLICATION_WARNING': 'Ïðåäóïðåæäåíèå',
  'MSG_MIME_OVERRIDE': 'âèäà íà ôàéëà "{0}" íå ñå ïîääúðæà, èçïîëçâàéòå "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Íåïîçíàò',
  'LBL_APPEARANCE': 'Âúíøåí âèä',
  'LBL_USER': 'Ïîòðåáèòåë',
  'LBL_NAME': 'Èìå',
  'LBL_APPLY': 'Ïðèëîæè',
  'LBL_FILENAME': 'Èìå íà ôàéë',
  'LBL_PATH': 'Ïúò',
  'LBL_SIZE': 'Ðàçìåð',
  'LBL_TYPE': 'Òèï',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Çàðåæäàíå',
  'LBL_SETTINGS': 'Íàñòðîéêè',
  'LBL_ADD_FILE': 'Äîáàâè ôàéë',
  'LBL_COMMENT': 'Êîìåíòàð',
  'LBL_ACCOUNT': 'Àêàóíò',
  'LBL_CONNECT': 'Ñâúðæè ñå',
  'LBL_ONLINE': 'Íà ëèíèÿ',
  'LBL_OFFLINE': 'Èçâúí ëèíèÿ',
  'LBL_AWAY': 'Îòñúñòâàù',
  'LBL_BUSY': 'Çàåò',
  'LBL_CHAT': '×àò',
  'LBL_HELP': 'Ïîìîù',
  'LBL_ABOUT': 'Èíôîðìàöèÿ',
  'LBL_PANELS': 'Ïàíåëè',
  'LBL_LOCALES': 'Ëîêàëèçàöèÿ',
  'LBL_THEME': 'Òåìà',
  'LBL_COLOR': 'Öâÿò',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Ïðåêðàòè',
  'LBL_ALIVE': 'Âêëþ÷è',
  'LBL_INDEX': 'Èíäåêñ',
  'LBL_ADD': 'Äîáàâè',
  'LBL_FONT': 'Øðèôò',
  'LBL_YES': 'Äà',
  'LBL_NO': 'Íå',
  'LBL_CANCEL': 'Îòêàæè',
  'LBL_TOP': 'Ãîðå',
  'LBL_LEFT': 'Ëÿâî',
  'LBL_RIGHT': 'Äÿñíî',
  'LBL_BOTTOM': 'Äîëó',
  'LBL_CENTER': 'Öåíòúð',
  'LBL_FILE': 'Ôàéë',
  'LBL_NEW': 'Íîâ',
  'LBL_OPEN': 'Îòâîðè',
  'LBL_SAVE': 'Çàïàçè',
  'LBL_SAVEAS': 'Çàïàçè êàòî...',
  'LBL_CLOSE': 'Çàòðâîðè',
  'LBL_MKDIR': 'Ñúçäàé äèðåêòîðèÿ',
  'LBL_UPLOAD': 'Äîáàâè',
  'LBL_VIEW': 'Èçãëåä',
  'LBL_EDIT': 'Ðåäàêòèðàé',
  'LBL_RENAME': 'Ïðåèìåíóâàé',
  'LBL_DELETE': 'Èçòðèè',
  'LBL_OPENWITH': 'Îòâîðè ñ...',
  'LBL_ICONVIEW': 'Èêîíè',
  'LBL_TREEVIEW': 'Äúðâî',
  'LBL_LISTVIEW': 'Ñïèñúê',
  'LBL_REFRESH': 'Îïðåñíè',
  'LBL_VIEWTYPE': 'Íà÷èí íà èçãëåä',
  'LBL_BOLD': 'Ïîëó÷åð',
  'LBL_ITALIC': 'Íàêëîíåí',
  'LBL_UNDERLINE': 'Ïîä÷åðòàí',
  'LBL_REGULAR': 'Îáèêíîâåí',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Èäåíòèôèêàöèÿ',
  'LBL_OUTDENT': 'Ïðåñðî÷âàíå',
  'LBL_UNDO': 'Ïððåìàõíè',
  'LBL_REDO': 'Îòìåíè ïðåìàõâàíåòî',
  'LBL_CUT': 'Èçðåæè',
  'LBL_UNLINK': 'Îòêà÷è',
  'LBL_COPY': 'Êîïèðàé',
  'LBL_PASTE': 'Ïîñòàâè',
  'LBL_INSERT': 'Äîáàâè',
  'LBL_IMAGE': 'Èçîáðàæåíèå',
  'LBL_LINK': 'Ëèíê',
  'LBL_DISCONNECT': 'Èçëåç îò âðúçêà',
  'LBL_APPLICATIONS': 'Ïðèëîæåíèÿ',
  'LBL_ADD_FOLDER': 'Äîáàâè ïàïêà',
  'LBL_INFORMATION': 'Èíôîðìàöèÿ',
  'LBL_TEXT_COLOR': 'Öâÿò íà òåêñòà',
  'LBL_BACK_COLOR': 'Öâÿò íà ôîíà',
  'LBL_RESET_DEFAULT': 'Âúðíè ïî ïîäðàçáèðàíå',
  'LBL_DOWNLOAD_COMP': 'Èçòåãëÿíå íà êîìïþòúðà',
  'LBL_ORDERED_LIST': 'Ïîäðåäåí ñïèñúê',
  'LBL_BACKGROUND_IMAGE': 'Èçîáðàæåíèÿ çà ôîí',
  'LBL_BACKGROUND_COLOR': 'Öâÿò íà ôîí',
  'LBL_UNORDERED_LIST': 'Íåïîäðåäåí ñïèñúê',
  'LBL_STATUS': 'Ñàòóñ',
  'LBL_READONLY': 'ñàìî çà ÷åòåíå',
  'LBL_CREATED': 'Ñúçäàäåí',
  'LBL_MODIFIED': 'Ìîäèôèöèðàí',
  'LBL_SHOW_COLUMNS': 'Ïîêàæè êîëîíè',
  'LBL_MOVE': 'Ïðåìåñòè',
  'LBL_OPTIONS': 'Îïöèè',
  'LBL_OK': 'ÎÊ',
  'LBL_DIRECTORY': 'Äèðåêòîðèÿ',
  'LBL_CREATE': 'Ñúçäàé',
  'LBL_BUGREPORT': 'Áúã-ðåïîðò',
  'LBL_INSTALL': 'Èíñòàëèðàé',
  'LBL_UPDATE': 'Àêòóàëèçèðàé',
  'LBL_REMOVE': 'Ïðåìàõíè',
  'LBL_SHOW_SIDEBAR': 'покажи страничен бар',
  'LBL_BACKGROUND': 'Фон',
  'LBL_DESKTOP': 'Работен плот',
  'LBL_PANEL': 'Панел',
  'LBL_POSITION': 'Позиция',
  'LBL_ONTOP': 'Най-отгоре',
  'LBL_ITEMS': 'Обекти',
  'LBL_GENERAL': 'Основен'
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': 'Fehler beim Öffnen der Datei',
  'ERR_WM_NOT_RUNNING': 'Fenster-Manager wird nicht ausgeführt',
  'ERR_FILE_OPEN_FMT': 'Die Datei \'**{0}**\' kann nicht geöffnet werden',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Keine Anwendung gefunden, die den Datentyp \'{0}\' unterstützt',
  'ERR_APP_LAUNCH_FAILED': 'Fehler beim Starten der Anwendung',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Ein Fehler ist aufgetreten, während des Versuchs \'{0}\' zu starten',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Anwendung \'{0}\' construct gescheitert: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Anwendung \'{0}\' init() gescheitert: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Anwendungsressourcen fehlen oder wurden nicht geladen für: {0}',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Anwendung \'{0}\' preloading gescheitert: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Anwendung \'{0}\' ist bereits gestartet und erlaubt nur eine Instanz',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '\'{0}\' konnte nicht gestartet werden. Anwendungsmanifest nicht gefunden!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Klarte ikke starte \'{0}\'. Uw browser ondersteunt geen: {1}',

  'ERR_NO_WM_RUNNING': 'Es wird kein Fenster-Manager ausgeführt',
  'ERR_CORE_INIT_FAILED': 'OS.js konnte nicht initialisiert werden',
  'ERR_CORE_INIT_FAILED_DESC': 'Während der Initialisirung von OS.js ist ein Fehler aufgetreten',
  'ERR_CORE_INIT_NO_WM': 'OS.js konnte nicht gestartet werden: Fenster-Manager nicht festgelegt!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js konnte nicht gestartet werden: Fenster-Manager konnte nicht gestartet werden: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'OS.js konnte nicht gestartet werden: Resourssen konnten nicht vorab geladen werden...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Fehlerbericht',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Ein unerwarteter Fehler ist aufgetreten, möglicherweise ein Bug',

  'ERR_APP_API_ERROR': 'Anwendungs API Fehler',
  'ERR_APP_API_ERROR_DESC_FMT': 'Anwendung {0} konnte Aktion nicht ausführen \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Fehlendes Argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Unbekannter Fehler',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Sie haben bereits ein Fenster namens \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimieren',
  'WINDOW_MAXIMIZE': 'Maximieren',
  'WINDOW_RESTORE': 'Wiederherstellen',
  'WINDOW_CLOSE': 'Schließen',
  'WINDOW_ONTOP_ON': 'Im Vordergrund - Aktivieren',
  'WINDOW_ONTOP_OFF': 'Im Vordergrund - Deaktivieren',

  // Handler
  'TITLE_SIGN_OUT': 'Abmelden',
  'TITLE_SIGNED_IN_AS_FMT': 'Angemeldet als: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': 'Abmelden (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Benutzer wird abgemeldet \'{0}\'.\nWollen Sie die aktuelle Sitzung speichern?',

  'DIALOG_CLOSE': 'Schließen',
  'DIALOG_CANCEL': 'Abbrechen',
  'DIALOG_APPLY': 'Übernehmen',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Warnungsdialog',

  'DIALOG_COLOR_TITLE': 'Farb-Dialog',
  'DIALOG_COLOR_R': 'Rot: {0}',
  'DIALOG_COLOR_G': 'Grün: {0}',
  'DIALOG_COLOR_B': 'Blau: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Bestätigungsdialog',

  'DIALOG_ERROR_MESSAGE': 'Meldung',
  'DIALOG_ERROR_SUMMARY': 'Zusammenfassung',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Fehlerbericht',

  'DIALOG_FILE_SAVE': 'Speichern',
  'DIALOG_FILE_OPEN': 'Öffnen',
  'DIALOG_FILE_MKDIR': 'Verzeichnis erstellen',
  'DIALOG_FILE_MKDIR_MSG': 'Erstelle ein neues Verzeichnis in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Sind Sie sicher, dass Sie die Datei \'{0}\' überschreiben wollen?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Ansichtstyp',
  'DIALOG_FILE_MNU_LISTVIEW': 'Liste',
  'DIALOG_FILE_MNU_TREEVIEW': 'Baum',
  'DIALOG_FILE_MNU_ICONVIEW': 'Symbole',
  'DIALOG_FILE_ERROR': 'Datei-Dialog Fehler',
  'DIALOG_FILE_ERROR_SCANDIR': 'Verzeichnis \'{0}\' konnte nicht geöffnet werden',
  'DIALOG_FILE_MISSING_FILENAME': 'Sie müssen eine Datei auswählen oder geben Sie einen neuen Dateinamen an!',
  'DIALOG_FILE_MISSING_SELECTION': 'Sie müssen eine Datei auswählen!',

  'DIALOG_FILEINFO_TITLE': 'Dateiinformationen',
  'DIALOG_FILEINFO_LOADING': 'Laster fil-informasjon for: {0}',
  'DIALOG_FILEINFO_ERROR': 'Dateiinformationen Dialog Fehler',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Fehler beim bekommen von Dateiinformationen für **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Fehler beim bekommen von Dateiinformationen für: {0}',

  'DIALOG_INPUT_TITLE': 'Eingabedialog',

  'DIALOG_FILEPROGRESS_TITLE': 'Fortschritt',
  'DIALOG_FILEPROGRESS_LOADING': 'Lade...',

  'DIALOG_UPLOAD_TITLE': 'Upload-Dialog',
  'DIALOG_UPLOAD_DESC': 'Upload nach **{0}**.<br />Maximale Größe: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Hochladen von \'{0}\' ({1} {2}) von {3}',
  'DIALOG_UPLOAD_MSG': 'Datei-Upload...',
  'DIALOG_UPLOAD_FAILED': 'Upload fehlgeschlagen',
  'DIALOG_UPLOAD_FAILED_MSG': 'Der Upload ist fehlgeschlagen',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Unbekannter Grund...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Abbruch durch Benutzer...',

  'DIALOG_FONT_TITLE': 'Schriftarten-Dialog',

  'DIALOG_APPCHOOSER_TITLE': 'Wählen Sie eine Anwendung',
  'DIALOG_APPCHOOSER_MSG': 'Wählen Sie eine Anwendung zum Öffnen',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Sie müssen eine Anwendung auswählen',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Als Standartanwendung für {0} verwenden',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modul ist nicht konfiguriert oder aktiviert',
  'GAPI_NOTIFICATION_TITLE': 'Sie sind bei Google API angemeldet',
  'GAPI_SIGN_OUT': 'Von Google API Dienst abmelden',
  'GAPI_REVOKE': 'Berechtigungen wiederrufen und abmelden',
  'GAPI_AUTH_FAILURE': 'Google API Authentifizierung ist fehlgeschlagen oder fand nicht statt',
  'GAPI_AUTH_FAILURE_FMT': 'Fehler beim Authentifizieren: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Konnte Google API nicht laden',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'IndexedDB kann nicht ohne Datenbankname erstellt werden',
  'IDB_NO_SUCH_ITEM': 'Keine Elemente',

  // VFS
  'ERR_VFS_FATAL': 'Schwerwiegender Fehler',
  'ERR_VFS_FILE_ARGS': 'Datei erwartet mindestens ein Argument',
  'ERR_VFS_NUM_ARGS': 'Nicht genug Argumente',
  'ERR_VFS_EXPECT_FILE': 'Erwartet ein Datei-Objekt',
  'ERR_VFS_EXPECT_SRC_FILE': 'Erwartet einen Quelldatei-Objekt',
  'ERR_VFS_EXPECT_DST_FILE': 'Erwartet ein Zieldatei-Objekt',
  'ERR_VFS_FILE_EXISTS': 'Ziel existiert bereits',
  'ERR_VFS_TRANSFER_FMT': 'Während des übertragen zwischen Speicher ist ein Fehler aufgetreten: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Eine Datei ohne Ziel kann nicht hochgeladen werden',
  'ERR_VFS_UPLOAD_NO_FILES': 'Ohne Dateien zu definieren kann nicht hochgeladen werden',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Datei-Upload fehlgeschlagen: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Datei-Upload wurde abgebrochen',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Kann keinen Pfad ohne angegebenen Pfad herunterladen',
  'ERR_VFS_DOWNLOAD_FAILED': 'Während des Downloads ist ein Fehler aufgetreten: {0}',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Datei herunterladen',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': 'Datei kann nicht geöffnet werden',
  'ERR_FILE_APP_OPEN_FMT': 'Die Datei {0} kann nicht geöffnet werden, da der Dateityp (MIME) {1} nicht unterstützt wird',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Die Datei {0} konnte nicht geöffnet werden: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Die Datei {0} konnte nicht gespeichert werden: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Anwendungsfehler',
  'ERR_GENERIC_APP_ACTION_FMT': 'Konnte Aktion nicht durchführen: \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Unbekannter Fehler',
  'ERR_GENERIC_APP_REQUEST': 'Während Ihres Requests ist ein Fehler aufgetreten',
  'ERR_GENERIC_APP_FATAL_FMT': 'Schwerwiegender Fehler: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Aktuelles Dokument verwerfen?',
  'MSG_FILE_CHANGED': 'Die Datei wurde geändert. Neuladen?',
  'MSG_APPLICATION_WARNING': 'Anwendungswarnung',
  'MSG_MIME_OVERRIDE': 'Der Dateityp "{0}" wird nicht unterstützt, benutzen Sie "{1}" stattdessen.',

  // General
  'LBL_UNKNOWN': 'Unbekannt',
  'LBL_APPEARANCE': 'Aussehen',
  'LBL_USER': 'Benutzer',
  'LBL_NAME': 'Name',
  'LBL_APPLY': 'Übernehmen',
  'LBL_FILENAME': 'Dateiname',
  'LBL_PATH': 'Pfad',
  'LBL_SIZE': 'Größe',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Lade',
  'LBL_SETTINGS': 'Einstellungen',
  'LBL_ADD_FILE': 'Datei hinzufügen',
  'LBL_COMMENT': 'Kommentar',
  'LBL_ACCOUNT': 'Konto',
  'LBL_CONNECT': 'Verbinden',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Abwesend',
  'LBL_BUSY': 'Beschäftigt',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Hilfe',
  'LBL_ABOUT': 'Über',
  'LBL_PANELS': 'Panel',
  'LBL_LOCALES': 'Lokalisierung',
  'LBL_THEME': 'Design',
  'LBL_COLOR': 'Farbe',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Beenden (Kill)',
  'LBL_ALIVE': 'Aktiv',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Hinzufügen',
  'LBL_FONT': 'Schriftart',
  'LBL_YES': 'Ja',
  'LBL_NO': 'Nein',
  'LBL_CANCEL': 'Abbrechen',
  'LBL_TOP': 'Oben',
  'LBL_LEFT': 'Links',
  'LBL_RIGHT': 'Right',
  'LBL_BOTTOM': 'Unten',
  'LBL_CENTER': 'Zentriert',
  'LBL_FILE': 'Datei',
  'LBL_NEW': 'Neu',
  'LBL_OPEN': 'Öffnen',
  'LBL_SAVE': 'Speichern',
  'LBL_SAVEAS': 'Speichern unter...',
  'LBL_CLOSE': 'Schließen',
  'LBL_MKDIR': 'Verzeichnis erstellen',
  'LBL_UPLOAD': 'Hochladen',
  'LBL_VIEW': 'Ansicht',
  'LBL_EDIT': 'Bearbeiten',
  'LBL_RENAME': 'Umbenennen',
  'LBL_DELETE': 'Löschen',
  'LBL_OPENWITH': 'Öffnen mit...',
  'LBL_ICONVIEW': 'Symbole',
  'LBL_TREEVIEW': 'Baum',
  'LBL_LISTVIEW': 'Liste',
  'LBL_REFRESH': 'Aktualisieren',
  'LBL_VIEWTYPE': 'Ansichtstyp',
  'LBL_BOLD': 'Fett',
  'LBL_ITALIC': 'Kursiv',
  'LBL_UNDERLINE': 'Unterstrichen',
  'LBL_REGULAR': 'Regelmäßig',
  'LBL_STRIKE': 'Gjennomstrek',
  'LBL_INDENT': 'Einzug',
  'LBL_OUTDENT': 'Negativeinzug',
  'LBL_UNDO': 'Rückgängig',
  'LBL_REDO': 'Vorwärts',
  'LBL_CUT': 'Ausschneiden',
  'LBL_UNLINK': 'Verknüpfung entfernen',
  'LBL_COPY': 'Kopieren',
  'LBL_PASTE': 'Einfügen',
  'LBL_INSERT': 'Einfügen',
  'LBL_IMAGE': 'Bild',
  'LBL_LINK': 'Verknüpfung',
  'LBL_DISCONNECT': 'Disconnect',
  'LBL_APPLICATIONS': 'Anwendung',
  'LBL_ADD_FOLDER': 'Verzeichnis hinzufügen',
  'LBL_INFORMATION': 'Information',
  'LBL_TEXT_COLOR': 'Textfarbe',
  'LBL_BACK_COLOR': 'Hintergrundfarbe',
  'LBL_RESET_DEFAULT': 'Werkseinstellungen wiederherstellen',
  'LBL_DOWNLOAD_COMP': 'Auf PC herunterladen',
  'LBL_ORDERED_LIST': 'Sortierte Liste',
  'LBL_BACKGROUND_IMAGE': 'Hintergrundbild',
  'LBL_BACKGROUND_COLOR': 'Hintergrundfarbe',
  'LBL_UNORDERED_LIST': 'Unsortierte Liste',
  'LBL_SHOW_SIDEBAR': 'Seitenleiste anzeigen',
  'LBL_BACKGROUND': 'Hintergrund',
  'LBL_DESKTOP': 'Arbeitsoberflächen',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Position',
  'LBL_ONTOP': 'Vordergrund',
  'LBL_ITEMS': 'Items',
  'LBL_GENERAL': 'General'
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Error opening file',
  'ERR_WM_NOT_RUNNING': 'Window manager is not running',
  'ERR_FILE_OPEN_FMT': 'The file \'**{0}**\' could not be opened',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Could not find any Applications with support for \'{0}\' files',
  'ERR_APP_LAUNCH_FAILED': 'Failed to launch Application',
  'ERR_APP_LAUNCH_FAILED_FMT': 'An error occured while trying to launch: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Application \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Application \'{0}\' init() failed: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Application resources missing for \'{0}\' or it failed to load!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Application \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'The application \'{0}\' is already launched and allows only one instance!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Failed to launch \'{0}\'. Application manifest data not found!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Failed to launch \'{0}\'. Your browser does not support: {1}',

  'ERR_NO_WM_RUNNING': 'No window manager is running',
  'ERR_CORE_INIT_FAILED': 'Failed to initialize OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'An error occured while initializing OS.js',
  'ERR_CORE_INIT_NO_WM': 'Cannot launch OS.js: No window manager defined!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Cannot launch OS.js: Failed to launch Window Manager: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Cannot launch OS.js: Failed to preload resources...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Error Report',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'An unexpected error occured, maybe a bug.',

  'ERR_APP_API_ERROR': 'Application API error',
  'ERR_APP_API_ERROR_DESC_FMT': 'Application {0} failed to perform operation \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Missing argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Unknown error',

  'ERR_OPERATION_TIMEOUT': 'Operation Timeout',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operation Timeout ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' expects \'{1}\' to be a \'{2}\', \'{3}\' given',
  'ERR_INVALID_LOCATION': 'Invalid location',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'You already have a Window named \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimize',
  'WINDOW_MAXIMIZE': 'Maximize',
  'WINDOW_RESTORE': 'Restore',
  'WINDOW_CLOSE': 'Close',
  'WINDOW_ONTOP_ON': 'Ontop (Enable)',
  'WINDOW_ONTOP_OFF': 'Ontop (Disable)',

  // Handler
  'TITLE_SIGN_OUT': 'Sign out',
  'TITLE_SIGNED_IN_AS_FMT': 'Signed in as: {0}',
  'ERR_LOGIN_FMT': 'Login error: {0}',
  'ERR_LOGIN_INVALID': 'Invalid login',

  // SESSION
  'ERR_NO_SESSION': 'No session was created by the server. Do you want to retry login?',
  'MSG_SESSION_WARNING': 'Are you sure you want to quit OS.js? All unsaved settings and application data will be lost!',

  // Service
  'BUGREPORT_MSG': 'Please report this if you think this is a bug.\nInclude a brief description on how the error occured, and if you can; how to replicate it',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Logged into external services: {0}',
  'CONNECTION_LOST': 'Connection to the server was lost. Reconnecting...',
  'CONNECTION_RESTORED': 'Connection to the server was restored',
  'CONNECTION_RESTORE_FAILED': 'Failed to re-establish connection. Trying again.',
  'CONNECTION_ERROR': 'Connection error',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatal Error',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Error: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Log out (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Logging out user \'{0}\'.\nDo you want to save current session?',

  'DIALOG_CLOSE': 'Close',
  'DIALOG_CANCEL': 'Cancel',
  'DIALOG_APPLY': 'Apply',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Alert Dialog',

  'DIALOG_COLOR_TITLE': 'Color Dialog',
  'DIALOG_COLOR_R': 'Red: {0}',
  'DIALOG_COLOR_G': 'Green: {0}',
  'DIALOG_COLOR_B': 'Blue: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Confirm Dialog',

  'DIALOG_ERROR_TITLE': 'Error',
  'DIALOG_ERROR_MESSAGE': 'Message',
  'DIALOG_ERROR_SUMMARY': 'Summary',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Report Bug',

  'DIALOG_FILE_SAVE': 'Save',
  'DIALOG_FILE_OPEN': 'Open',
  'DIALOG_FILE_MKDIR': 'New Folder',
  'DIALOG_FILE_MKDIR_MSG': 'Create a new directory in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Are you sure you want to overwrite the file \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'View type',
  'DIALOG_FILE_MNU_LISTVIEW': 'List View',
  'DIALOG_FILE_MNU_TREEVIEW': 'Tree View',
  'DIALOG_FILE_MNU_ICONVIEW': 'Icon View',
  'DIALOG_FILE_ERROR': 'FileDialog Error',
  'DIALOG_FILE_ERROR_SCANDIR': 'Failed listing directory \'{0}\' because an error occured',
  'DIALOG_FILE_ERROR_FIND': 'Failed searching directory \'{0}\' because an error occured',
  'DIALOG_FILE_MISSING_FILENAME': 'You need to select a file or enter new filename!',
  'DIALOG_FILE_MISSING_SELECTION': 'You need to select a file!',

  'DIALOG_FILEINFO_TITLE': 'File Information',
  'DIALOG_FILEINFO_LOADING': 'Loading file information for: {0}',
  'DIALOG_FILEINFO_ERROR': 'FileInformationDialog Error',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Failed to get file information for **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Failed to get file information for: {0}',

  'DIALOG_INPUT_TITLE': 'Input Dialog',

  'DIALOG_FILEPROGRESS_TITLE': 'File Operation Progress',
  'DIALOG_FILEPROGRESS_LOADING': 'Loading...',

  'DIALOG_UPLOAD_TITLE': 'Upload Dialog',
  'DIALOG_UPLOAD_DESC': 'Upload file to **{0}**.<br />Maximum size: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Uploading \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Uploading file...',
  'DIALOG_UPLOAD_FAILED': 'Upload failed',
  'DIALOG_UPLOAD_FAILED_MSG': 'The upload has failed',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Reason unknown...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancelled by user...',
  'DIALOG_UPLOAD_TOO_BIG': 'File is too big',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'File is too big, exceeds {0}',

  'DIALOG_FONT_TITLE': 'Font Dialog',

  'DIALOG_APPCHOOSER_TITLE': 'Choose Application',
  'DIALOG_APPCHOOSER_MSG': 'Choose an application to open',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'You need to select an application',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Use as default application for {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Module not configured or disabled',
  'GAPI_SIGN_OUT': 'Sign out from Google API Services',
  'GAPI_REVOKE': 'Revoke permissions and Sign Out',
  'GAPI_AUTH_FAILURE': 'Google API Authentication failed or did not take place',
  'GAPI_AUTH_FAILURE_FMT': 'Failed to authenticate: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Failed to load Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module not configured or disabled',
  'WLAPI_SIGN_OUT': 'Sign out from Window Live API',
  'WLAPI_LOAD_FAILURE': 'Failed to load Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Failed to log into Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Failed to log into Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returned {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Cannot create IndexedDB without Database Name',
  'IDB_NO_SUCH_ITEM': 'No such item',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Fatal Error',
  'ERR_VFS_UNAVAILABLE': 'Not available',
  'ERR_VFS_FILE_ARGS': 'File expects at least one argument',
  'ERR_VFS_NUM_ARGS': 'Not enough arguments',
  'ERR_VFS_EXPECT_FILE': 'Expects a file-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Expects a source file-object',
  'ERR_VFS_EXPECT_DST_FILE': 'Expects a destination file-object',
  'ERR_VFS_FILE_EXISTS': 'Destination already exists',
  'ERR_VFS_TARGET_NOT_EXISTS': 'Target does not exist',
  'ERR_VFS_TRANSFER_FMT': 'An error occured while transfering between storage: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Cannot upload a file without a destination',
  'ERR_VFS_UPLOAD_NO_FILES': 'Cannot upload without any files defined',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'File upload failed: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'File upload was cancelled',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Cannot download a path without a path',
  'ERR_VFS_DOWNLOAD_FAILED': 'An error occured while downloading: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Response was empty',
  'ERR_VFS_NO_MIME_DETECT': 'No mime type detected',

  'ERR_VFSMODULE_INVALID': 'Invalid VFS Module',
  'ERR_VFSMODULE_INVALID_FMT': 'Invalid VFS Module: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Invalid VFS Method',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Invalid VFS Method: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Invalid VFS Module type',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Invalid VFS Module type: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Invalid VFS Module configuration',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Invalid VFS Module configuration: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS Module already mounted',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS Module \'{0}\' already mounted',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS Module not mounted',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS Module \'{0}\' not mounted',
  'ERR_VFSMODULE_EXCEPTION': 'VFS Module Exception',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS Module Exception: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'No VFS Module matches {0}. Wrong path or format ?',
  'ERR_VFSMODULE_READONLY': 'This VFS Module is read-only',
  'ERR_VFSMODULE_READONLY_FMT': 'This VFS Module is read-only: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Downloading file',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Error',
  'ERR_VFSMODULE_ROOT_ID': 'Failed to find root folder id',
  'ERR_VFSMODULE_NOSUCH': 'File does not exist',
  'ERR_VFSMODULE_PARENT': 'No such parent',
  'ERR_VFSMODULE_PARENT_FMT': 'Failed to look up parent: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Failed to scan directory',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Failed to scan directory: {0}',
  'ERR_VFSMODULE_READ': 'Failed to read file',
  'ERR_VFSMODULE_READ_FMT': 'Failed to read file: {0}',
  'ERR_VFSMODULE_WRITE': 'Failed to write file',
  'ERR_VFSMODULE_WRITE_FMT': 'Failed to write file: {0}',
  'ERR_VFSMODULE_COPY': 'Failed to copy',
  'ERR_VFSMODULE_COPY_FMT': 'Failed to copy: {0}',
  'ERR_VFSMODULE_UNLINK': 'Failed to unlink file',
  'ERR_VFSMODULE_UNLINK_FMT': 'Failed to unlink file: {0}',
  'ERR_VFSMODULE_MOVE': 'Failed to move file',
  'ERR_VFSMODULE_MOVE_FMT': 'Failed to move file: {0}',
  'ERR_VFSMODULE_EXIST': 'Failed to check file existence',
  'ERR_VFSMODULE_EXIST_FMT': 'Failed to check file existence: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Failed to get file information',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Failed to get file information: {0}',
  'ERR_VFSMODULE_MKDIR': 'Failed to create directory',
  'ERR_VFSMODULE_MKDIR_FMT': 'Failed to create directory: {0}',
  'ERR_VFSMODULE_MKFILE': 'Failed to create file',
  'ERR_VFSMODULE_MKFILE_FMT': 'Failed to create file: {0}',
  'ERR_VFSMODULE_URL': 'Failed to get URL for file',
  'ERR_VFSMODULE_URL_FMT': 'Failed to get URL for file: {0}',
  'ERR_VFSMODULE_TRASH': 'Failed to move file to trash',
  'ERR_VFSMODULE_TRASH_FMT': 'Failed to move file to trash: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Failed to move file out of trash',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Failed to move file out of trash: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Failed to empty trash',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Failed to empty trash: {0}',
  'ERR_VFSMODULE_FIND': 'Failed to search',
  'ERR_VFSMODULE_FIND_FMT': 'Failed to search: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Failed to get free space',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Failed to get free space: {0}',
  'ERR_VFSMODULE_EXISTS': 'Failed to check if exists',
  'ERR_VFSMODULE_EXISTS_FMT': 'Failed to check if exists: {0}',

  // VFS -> Dropbox
  'ERR_DROPBOX_API': 'Failed to load Dropbox API',
  'ERR_DROPBOX_AUTH': 'Failed to authenticate via Dropbox',
  'ERR_DROPBOX_KEY': 'No Dropbox client key configured',
  'DROPBOX_NOTIFICATION_TITLE': 'You are signed in to Dropbox API',
  'DROPBOX_SIGN_OUT': 'Sign out from Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Failed to resolve path: item not found',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Failed to load zip.js',
  'ZIP_VENDOR_FAIL': 'zip.js library was not found. Did it load properly?',
  'ZIP_NO_RESOURCE': 'No zip resource was given',
  'ZIP_NO_PATH': 'No path given',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Searching...',
  'SEARCH_NO_RESULTS': 'No results found',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Package installation directory already exists. Cannot continue!',
  'ERR_PACKAGE_MANIFEST': 'Failed to load package manifest',
  'ERR_PACKAGE_ENUM_FAILED': 'Failed to get package list. Make sure you\'re not using "Private Mode" as this might case problems.',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Cannot open file',
  'ERR_FILE_APP_OPEN_FMT': 'The file {0} could not be opened because the mime {1} is not supported',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'The file {0} could not be opened: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'The file {0} could not be saved: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Application Error',
  'ERR_GENERIC_APP_ACTION_FMT': 'Failed to perform action \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Unknown Error',
  'ERR_GENERIC_APP_REQUEST': 'An error occured while handling your request',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatal Error: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Discard changes?',
  'MSG_FILE_CHANGED': 'The file has changed. Reload?',
  'MSG_APPLICATION_WARNING': 'Application Warning',
  'MSG_MIME_OVERRIDE': 'The filetype "{0}" is not supported, using "{1}" instead.',

  'ERR_OPEN_LOCATION': 'Failed to open location',
  'ERR_OPEN_LOCATION_FMT': 'Failed to open location: {0}',

  //
  // General
  //

  'LBL_UNKNOWN': 'Unknown',
  'LBL_APPEARANCE': 'Appearance',
  'LBL_USER': 'User',
  'LBL_NAME': 'Name',
  'LBL_APPLY': 'Apply',
  'LBL_FILENAME': 'Filename',
  'LBL_PATH': 'Path',
  'LBL_SIZE': 'Size',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Loading',
  'LBL_SETTINGS': 'Settings',
  'LBL_ADD_FILE': 'Add file',
  'LBL_COMMENT': 'Comment',
  'LBL_ACCOUNT': 'Account',
  'LBL_CONNECT': 'Connect',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Away',
  'LBL_BUSY': 'Busy',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Help',
  'LBL_ABOUT': 'About',
  'LBL_PANELS': 'Panels',
  'LBL_LOCALES': 'Locales',
  'LBL_THEME': 'Theme',
  'LBL_COLOR': 'Color',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Kill',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Add',
  'LBL_FONT': 'Font',
  'LBL_YES': 'Yes',
  'LBL_NO': 'No',
  'LBL_CANCEL': 'Cancel',
  'LBL_TOP': 'Top',
  'LBL_LEFT': 'Left',
  'LBL_RIGHT': 'Right',
  'LBL_BOTTOM': 'Bottom',
  'LBL_CENTER': 'Center',
  'LBL_FILE': 'File',
  'LBL_NEW': 'New',
  'LBL_OPEN': 'Open',
  'LBL_SAVE': 'Save',
  'LBL_SAVEAS': 'Save as...',
  'LBL_CLOSE': 'Close',
  'LBL_MKDIR': 'Create directory',
  'LBL_UPLOAD': 'Upload',
  'LBL_VIEW': 'View',
  'LBL_EDIT': 'Edit',
  'LBL_RENAME': 'Rename',
  'LBL_DELETE': 'Delete',
  'LBL_OPENWITH': 'Open With ...',
  'LBL_ICONVIEW': 'Icon View',
  'LBL_TREEVIEW': 'Tree View',
  'LBL_LISTVIEW': 'List View',
  'LBL_REFRESH': 'Refresh',
  'LBL_VIEWTYPE': 'View type',
  'LBL_BOLD': 'Bold',
  'LBL_ITALIC': 'Italic',
  'LBL_UNDERLINE': 'Underline',
  'LBL_REGULAR': 'Regular',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Indent',
  'LBL_OUTDENT': 'Outdate',
  'LBL_UNDO': 'Undo',
  'LBL_REDO': 'Redo',
  'LBL_CUT': 'Cut',
  'LBL_UNLINK': 'Unlink',
  'LBL_COPY': 'Copy',
  'LBL_PASTE': 'Paste',
  'LBL_INSERT': 'Insert',
  'LBL_IMAGE': 'Image',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Disconnect',
  'LBL_APPLICATIONS': 'Applications',
  'LBL_ADD_FOLDER': 'Add folder',
  'LBL_INFORMATION': 'Information',
  'LBL_TEXT_COLOR': 'Text Color',
  'LBL_BACK_COLOR': 'Back Color',
  'LBL_RESET_DEFAULT': 'Reset to defaults',
  'LBL_DOWNLOAD_COMP': 'Download to computer',
  'LBL_ORDERED_LIST': 'Ordered List',
  'LBL_BACKGROUND_IMAGE': 'Background Image',
  'LBL_BACKGROUND_COLOR': 'Background Color',
  'LBL_UNORDERED_LIST': 'Unordered List',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Read-Only',
  'LBL_CREATED': 'Created',
  'LBL_MODIFIED': 'Modified',
  'LBL_SHOW_COLUMNS': 'Show Columns',
  'LBL_MOVE': 'Move',
  'LBL_OPTIONS': 'Options',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Directory',
  'LBL_CREATE': 'Create',
  'LBL_BUGREPORT': 'Bugreport',
  'LBL_INSTALL': 'Install',
  'LBL_UPDATE': 'Update',
  'LBL_REMOVE': 'Remove',
  'LBL_SHOW_SIDEBAR': 'Show sidebar',
  'LBL_SHOW_NAVIGATION': 'Show navigation',
  'LBL_SHOW_HIDDENFILES': 'Show hidden files',
  'LBL_SHOW_FILEEXTENSIONS': 'Show file extensions',
  'LBL_MOUNT': 'Mount',
  'LBL_DESCRIPTION': 'Description',
  'LBL_USERNAME': 'Username',
  'LBL_PASSWORD': 'Password',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_SEARCH': 'Search',
  'LBL_BACK': 'Back',
  'LBL_ICONS': 'Icons',
  'LBL_ICON': 'Icon',
  'LBL_UNINSTALL': 'Uninstall',
  'LBL_REGENERATE': 'Regenerate',
  'LBL_DESKTOP': 'Desktop',
  'LBL_WINDOWMANAGER': 'Window Manager',
  'LBL_HOTKEY': 'Hotkey',
  'LBL_HOTKEYS': 'Hotkeys',
  'LBL_MOUNTS': 'Mounts',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Application',
  'LBL_SCOPE': 'Scope',
  'LBL_HIDE': 'Hide',
  'LBL_REPOSITORY': 'Repository',
  'LBL_VERSION': 'Version',
  'LBL_AUTHOR': 'Author',
  'LBL_GROUPS': 'Groups',
  'LBL_AUTOHIDE': 'Autohide',
  'LBL_PERSONAL': 'Personal',
  'LBL_SYSTEM': 'System',
  'LBL_STARTING': 'Starting',
  'LBL_SOUNDS': 'Sounds',
  'LBL_STORE': 'Store',
  'LBL_LOCALE': 'Locale',
  'LBL_PACKAGE': 'Package',
  'LBL_PACKAGES': 'Packages',
  'LBL_INPUT': 'Input',
  'LBL_MISC': 'Misc',
  'LBL_OTHER': 'Other',
  'LBL_USERS': 'Users',
  'LBL_FONTS': 'Fonts',
  'LBL_OPEN_LOCATION': 'Open Location',
  'LBL_HOME': 'Home',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_LOCK': 'Lock',
  'LBL_UNLOCK': 'Unlock',
  'LBL_WARNING': 'Warning',
  'LBL_INFO': 'Info',
  'LBL_POSITION': 'Position',
  'LBL_OPACITY': 'Opactiy',
  'LBL_ITEMS': 'Items',
  'LBL_ONTOP': 'On top',
  'LBL_BACKGROUND': 'Background',
  'LBL_QUIT': 'Quit',
  'LBL_EXIT': 'Exit',
  'LBL_WINDOWS': 'Windows'
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Error abriendo archivo',
  'ERR_WM_NOT_RUNNING': 'El gestor de ventanas no está en ejecución',
  'ERR_FILE_OPEN_FMT': 'No se pudo abrir el fichero \'**{0}**\'',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'No se pudo encontrar ninguna aplicación asociada a los archivos \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Error abriendo aplicación',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Se produjo un error intentando ejecutar: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Error construyendo la aplicación \'{0}\': {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Error en init() de la applicación \'{0}\': {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': '¡La aplicación  \'{0}\' no pudo obtener los recursos necesarios, o falló al cargarse!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Error en la precarga de la application \'{0}\': \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '¡La aplicación \'{0}\' ya está ejecutándose y sólo permite una instancia!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '¡Error al abrir \'{0}\'. No se encontraron los datos del manifiesto de la aplicación!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': '¡Error al abrir \'{0}\'. Tu explorador no da soporte: {1}',

  'ERR_NO_WM_RUNNING': 'Ningún gestor de ventanas en ejecución',
  'ERR_CORE_INIT_FAILED': 'Error inicializando OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Se produjo un error inicializando OS.js',
  'ERR_CORE_INIT_NO_WM': 'No se puede lanzar OS.js: ¡No se definió ningún gestor de ventanas!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'No se puede lanzar OS.js: se fallo al lanzar el gestor de ventanas: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'No se puede lanzar OS.js: se falló precargando recursos...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Informe de errores de JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Error inesperado, puede que sea un bug.',

  'ERR_APP_API_ERROR': 'Error del API de la aplicación',
  'ERR_APP_API_ERROR_DESC_FMT': 'La aplicación {0} no pudo realizar la operación \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Falta un argumento: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Error desconocido',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Ya tienes una ventana llamada \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimizar',
  'WINDOW_MAXIMIZE': 'Maximizar',
  'WINDOW_RESTORE': 'Restaurar',
  'WINDOW_CLOSE': 'Cerrar',
  'WINDOW_ONTOP_ON': 'En primer plano (Activar)',
  'WINDOW_ONTOP_OFF': 'En primer plano (Desactivar)',

  // Handler
  'TITLE_SIGN_OUT': 'Sesión finalizada',
  'TITLE_SIGNED_IN_AS_FMT': 'Sesión iniciada como: {0}',

  // SESSION
  'MSG_SESSION_WARNING': '¿Estás seguro de que quieres salir de OS.js? Se perderán todas las configuraciones y datos que no se hayan guardado',

  // Service
  'BUGREPORT_MSG': 'Por favor, informa de esto si piensas que es un bug.\nIncluye una breve descripción sobre cómo se produjo el probleñam y si es posible, cómo reproducirlo. Gracias',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Se accedió a servicios externos: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Error fatal',
  'ERR_UTILS_XHR_FMT': 'Error AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Finalizar sesión (Salir)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Usuario \'{0}\' desconectando.\n¿Quieres guardar la sesión en curso?',

  'DIALOG_CLOSE': 'Cerrar',
  'DIALOG_CANCEL': 'Cancelar',
  'DIALOG_APPLY': 'Aplicar',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Diálogo de alerta',

  'DIALOG_COLOR_TITLE': 'Diálogo de color',
  'DIALOG_COLOR_R': 'Rojo: {0}',
  'DIALOG_COLOR_G': 'Verde: {0}',
  'DIALOG_COLOR_B': 'Azul: {0}',
  'DIALOG_COLOR_A': 'Alfa: {0}',

  'DIALOG_CONFIRM_TITLE': 'Diálogo de confirmación',

  'DIALOG_ERROR_MESSAGE': 'Mensaje',
  'DIALOG_ERROR_SUMMARY': 'Resumen',
  'DIALOG_ERROR_TRACE': 'Traza',
  'DIALOG_ERROR_BUGREPORT': 'Informe de errores',

  'DIALOG_FILE_SAVE': 'Guardar',
  'DIALOG_FILE_OPEN': 'Abrir',
  'DIALOG_FILE_MKDIR': 'Nueva carpeta',
  'DIALOG_FILE_MKDIR_MSG': 'Crear una nueva carpeta en **{0}**',
  'DIALOG_FILE_OVERWRITE': '¿Seguro que quieres sobreescribir el fichero \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Tipo de vista',
  'DIALOG_FILE_MNU_LISTVIEW': 'Vista de lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Vista de árbol',
  'DIALOG_FILE_MNU_ICONVIEW': 'Vista de icono',
  'DIALOG_FILE_ERROR': 'Error en el diálogo de fichero',
  'DIALOG_FILE_ERROR_SCANDIR': 'Error listando el directorio \'{0}\' porque ocurrió un error',
  'DIALOG_FILE_MISSING_FILENAME': '¡Tienes que seleccionar un archivo o introducir un nombre de archivo nuevo!',
  'DIALOG_FILE_MISSING_SELECTION': '¡Tienes que seleccionar un archivo!',

  'DIALOG_FILEINFO_TITLE': 'Información de fichero',
  'DIALOG_FILEINFO_LOADING': 'Cargando la información del fichero: {0}',
  'DIALOG_FILEINFO_ERROR': 'Error del diálogo de información de fichero',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'No se pudo obtener la información del fichero **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'No se pudo obtener la información del fichero: {0}',

  'DIALOG_INPUT_TITLE': 'Diálogo de entrada',

  'DIALOG_FILEPROGRESS_TITLE': 'Operación de archivo en progreso',
  'DIALOG_FILEPROGRESS_LOADING': 'Cargando...',

  'DIALOG_UPLOAD_TITLE': 'Diálogo de subida',
  'DIALOG_UPLOAD_DESC': 'Subir archivo a **{0}**.<br />Tamaño máximo: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Subiendo \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Subiendo archivo...',
  'DIALOG_UPLOAD_FAILED': 'Fallo en la subida',
  'DIALOG_UPLOAD_FAILED_MSG': 'La subida ha fallado',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Razón desconocida...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancelado por el usuario...',
  'DIALOG_UPLOAD_TOO_BIG': 'El archivo es demasiado grande',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'El archivo es demasiado grande, excede los {0}',

  'DIALOG_FONT_TITLE': 'Diálogo de tipografía',

  'DIALOG_APPCHOOSER_TITLE': 'Elegir aplicación',
  'DIALOG_APPCHOOSER_MSG': 'Elegir la aplicación a abrir',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Necesitas seleccionar una aplicación',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Usar como la aplicación por defecto para {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'El módulo GoogleAPI no está configurado o está desactivado',
  'GAPI_SIGN_OUT': 'Desconectar de los servicios Google API',
  'GAPI_REVOKE': 'Revocar permisos y desconectar',
  'GAPI_AUTH_FAILURE': 'La autenticación en Google API falló, o no llegó a efectuarse',
  'GAPI_AUTH_FAILURE_FMT': 'No se pudo autenticar: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'No se pudo cargar Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'El módulo Windows Live API no está configurado o está desactivado',
  'WLAPI_SIGN_OUT': 'Desconectar de los servicios Windows Live API',
  'WLAPI_LOAD_FAILURE': 'No se pudo cargar Windows Live API',
  'WLAPI_LOGIN_FAILED': 'No se pudo acceder a Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'No se pudo acceder a Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API devolvió el estado {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'No se pudo crear IndexedDB sin un nombre de base de datos',
  'IDB_NO_SUCH_ITEM': 'No existe ese elemento',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Error fatal',
  'ERR_VFS_UNAVAILABLE': 'No disponible',
  'ERR_VFS_FILE_ARGS': 'El archivo espera al menos un argumento',
  'ERR_VFS_NUM_ARGS': 'Argumentos insuficientes',
  'ERR_VFS_EXPECT_FILE': 'Se espera un objeto-fichero',
  'ERR_VFS_EXPECT_SRC_FILE': 'Se espera un origen objeto-fichero',
  'ERR_VFS_EXPECT_DST_FILE': 'Se espera un destino objeto-fichero',
  'ERR_VFS_FILE_EXISTS': 'El destino ya existe',
  'ERR_VFS_TRANSFER_FMT': 'Se produjo un error al transferir entre almacenamientos: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'No se puede subir un fichero sin un destino',
  'ERR_VFS_UPLOAD_NO_FILES': 'No se puede efectuar la subida si no hay archivos definidos',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Fallo en la subida: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Se canceló la subida del fichero',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'No se puede descargar una ruta sin una ruta',
  'ERR_VFS_DOWNLOAD_FAILED': 'Se produjo un error en la descarga: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'La respuesta estaba vacía',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Descargando fichero',

  'ERR_VFSMODULE_XHR_ERROR': 'Error XHR',
  'ERR_VFSMODULE_ROOT_ID': 'No se pudo encontrar el identificador del directorio raíz',
  'ERR_VFSMODULE_NOSUCH': 'El archivo no existe',
  'ERR_VFSMODULE_PARENT': 'No existe el padre',
  'ERR_VFSMODULE_PARENT_FMT': 'No se pudo localizar el padre: {0}',
  'ERR_VFSMODULE_SCANDIR': 'No se pudo analizar el directorio',
  'ERR_VFSMODULE_SCANDIR_FMT': 'No se pudo analizar el directorio: {0}',
  'ERR_VFSMODULE_READ': 'No se pudo leer el fichero',
  'ERR_VFSMODULE_READ_FMT': 'No se pudo leer el fichero: {0}',
  'ERR_VFSMODULE_WRITE': 'No se pudo escribir el fichero',
  'ERR_VFSMODULE_WRITE_FMT': 'No se pudo escribir el fichero: {0}',
  'ERR_VFSMODULE_COPY': 'No se pudo copiar',
  'ERR_VFSMODULE_COPY_FMT': 'No se pudo copiar: {0}',
  'ERR_VFSMODULE_UNLINK': 'No se pudo desenlazar el fichero',
  'ERR_VFSMODULE_UNLINK_FMT': 'No se pudo desenlazar el fichero: {0}',
  'ERR_VFSMODULE_MOVE': 'No se pudo mover el fichero',
  'ERR_VFSMODULE_MOVE_FMT': 'No se pudo mover el fichero: {0}',
  'ERR_VFSMODULE_EXIST': 'No se pudo comprobar la existencia del fichero',
  'ERR_VFSMODULE_EXIST_FMT': 'No se pudo comprobar la existencia del fichero: {0}',
  'ERR_VFSMODULE_FILEINFO': 'No se pudo obtener la infomación del archivo',
  'ERR_VFSMODULE_FILEINFO_FMT': 'No se pudo obtener la infomación del archivo: {0}',
  'ERR_VFSMODULE_MKDIR': 'No se pudo crear el directorio',
  'ERR_VFSMODULE_MKDIR_FMT': 'No se pudo crear el directorio: {0}',
  'ERR_VFSMODULE_URL': 'No se pudo obtener la URL del archivo',
  'ERR_VFSMODULE_URL_FMT': 'No se pudo obtener la URL del archivo: {0}',
  'ERR_VFSMODULE_TRASH': 'No se pudo enviar el archivo a la papelera',
  'ERR_VFSMODULE_TRASH_FMT': 'No se pudo enviar el archivo a la papelera: {0}',
  'ERR_VFSMODULE_UNTRASH': 'No se pudo recuperar el archivo de la papelera',
  'ERR_VFSMODULE_UNTRASH_FMT': 'No se pudo recuperar el archivo de la papelera: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'No se pudo vaciar la papelera',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'No se pudo vaciar la papelera: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Estás identificado en el API de dropbox',
  'DROPBOX_SIGN_OUT': 'Desconectar de los servicios Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'No se pudo resolver la ruta: no se encontró el elemento',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'No se puede abrir el archivo',
  'ERR_FILE_APP_OPEN_FMT': 'El archivo {0} no pudo abrirse porque no hay soporte para el tipo MIME {1}',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'No pudo abrirse el archivo {0}: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'No pudo guardarse el archivo {0}: {1}',
  'ERR_GENERIC_APP_FMT': 'Error en la aplicación {0}',
  'ERR_GENERIC_APP_ACTION_FMT': 'No se pudo efectuar la acción \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Error desconocido',
  'ERR_GENERIC_APP_REQUEST': 'Se produjo un error manipulando la solicitud',
  'ERR_GENERIC_APP_FATAL_FMT': 'Error fatal: {0}',
  'MSG_GENERIC_APP_DISCARD': '¿Descartar cambios?',
  'MSG_FILE_CHANGED': 'El archivo ha cambiado. ¿Recargar?',
  'MSG_APPLICATION_WARNING': 'Advertencia de aplicación',
  'MSG_MIME_OVERRIDE': 'El tipo de fichero "{0}" no está soportado, se usará "{1}" en su lugar.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Desconocido',
  'LBL_APPEARANCE': 'Aspecto',
  'LBL_USER': 'Usuario',
  'LBL_NAME': 'Nombre',
  'LBL_APPLY': 'Aplicar',
  'LBL_FILENAME': 'Nombre de archivo',
  'LBL_PATH': 'Ruta',
  'LBL_SIZE': 'Tamaño',
  'LBL_TYPE': 'Tipo',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Cargando',
  'LBL_SETTINGS': 'Configuración',
  'LBL_ADD_FILE': 'Añadir fichero',
  'LBL_COMMENT': 'Comentario',
  'LBL_ACCOUNT': 'Cuenta',
  'LBL_CONNECT': 'Conectar',
  'LBL_ONLINE': 'Conectado',
  'LBL_OFFLINE': 'Desconectado',
  'LBL_AWAY': 'No disponible',
  'LBL_BUSY': 'Ocupado',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Ayuda',
  'LBL_ABOUT': 'A propósito de',
  'LBL_PANELS': 'Paneles',
  'LBL_LOCALES': 'Internacionalización',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Color',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Kill',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Índice',
  'LBL_ADD': 'Añadir',
  'LBL_FONT': 'Tipografía',
  'LBL_YES': 'Si',
  'LBL_NO': 'No',
  'LBL_CANCEL': 'Cancelar',
  'LBL_TOP': 'Arriba',
  'LBL_LEFT': 'Izquierda',
  'LBL_RIGHT': 'Derecha',
  'LBL_BOTTOM': 'Abajo',
  'LBL_CENTER': 'Centro',
  'LBL_FILE': 'Fichero',
  'LBL_NEW': 'Nuevo',
  'LBL_OPEN': 'Abrir',
  'LBL_SAVE': 'Guardar',
  'LBL_SAVEAS': 'Guardar cómo...',
  'LBL_CLOSE': 'Cerrar',
  'LBL_MKDIR': 'Crear directorio',
  'LBL_UPLOAD': 'Subir',
  'LBL_VIEW': 'Vista',
  'LBL_EDIT': 'Editar',
  'LBL_RENAME': 'Renombrar',
  'LBL_DELETE': 'Eliminar',
  'LBL_OPENWITH': 'Abrir con...',
  'LBL_ICONVIEW': 'Vista de iconos',
  'LBL_TREEVIEW': 'Vista de árbol',
  'LBL_LISTVIEW': 'Vista de lista',
  'LBL_REFRESH': 'Recargar',
  'LBL_VIEWTYPE': 'Ver tipo',
  'LBL_BOLD': 'Negrita',
  'LBL_ITALIC': 'Cursiva',
  'LBL_UNDERLINE': 'Subrayado',
  'LBL_REGULAR': 'Regular',
  'LBL_STRIKE': 'Barra',
  'LBL_INDENT': 'Indentar',
  'LBL_OUTDENT': 'Obsoleto',
  'LBL_UNDO': 'Deshacer',
  'LBL_REDO': 'Rehacer',
  'LBL_CUT': 'Cortar',
  'LBL_UNLINK': 'Desenlazar',
  'LBL_COPY': 'Copiar',
  'LBL_PASTE': 'Pegar',
  'LBL_INSERT': 'Insertar',
  'LBL_IMAGE': 'Imágen',
  'LBL_LINK': 'Enlace',
  'LBL_DISCONNECT': 'Desconectar',
  'LBL_APPLICATIONS': 'Aplicaciones',
  'LBL_ADD_FOLDER': 'Añadir carpeta',
  'LBL_INFORMATION': 'Información',
  'LBL_TEXT_COLOR': 'Color de texto',
  'LBL_BACK_COLOR': 'Color de fondo',
  'LBL_RESET_DEFAULT': 'Restablecer los valores por defecto',
  'LBL_DOWNLOAD_COMP': 'Descargar en el ordenador',
  'LBL_ORDERED_LIST': 'Lista ordenada',
  'LBL_BACKGROUND_IMAGE': 'Imagen de fondo',
  'LBL_BACKGROUND_COLOR': 'Color de fondo',
  'LBL_UNORDERED_LIST': 'Lista no ordenada',
  'LBL_STATUS': 'Estado',
  'LBL_READONLY': 'Sólo lectura',
  'LBL_CREATED': 'Creado',
  'LBL_MODIFIED': 'Modificado',
  'LBL_SHOW_COLUMNS': 'Mostrar columnas',
  'LBL_MOVE': 'Mover',
  'LBL_OPTIONS': 'Opciones',
  'LBL_OK': 'OK',
  'LBL_Background': 'Fondo',
  'LBL_DESKTOP': 'Escritorio',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Posición',
  'LBL_ONTOP': 'Primer plano',
  'LBL_ITEMS': 'Elementos',
  'LBL_GENERAL': 'General',
  'LBL_BACKGROUND': 'Pozadie'
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'خطا در باز کردن فايل',
  'ERR_WM_NOT_RUNNING': 'مديريت پنجره ها اجرا نشده است',
  'ERR_FILE_OPEN_FMT': 'فايل \'**{0}**\' رانمي توان باز کرد',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'برنامه اي که از \'{0}\' فايل پشتيباني کند پيدا نشد',
  'ERR_APP_LAUNCH_FAILED': 'اجراي برنامه موفق نبود',
  'ERR_APP_LAUNCH_FAILED_FMT': 'وقوع خطادر زمان اجراي برنامه: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'برنامه \'{0}\' خطا در سازنده: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'برنامه \'{0}\' init() با خطا مواجه شد: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'نبودن منابع براي برنامه \'{0}\' يا اجرا کردن نا موفق!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'برنامه \'{0}\'قبل بارگزاري با خطا مواجه شد: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'برنامه \'{0}\' قبلا اجرا شده و فقط ميتواند يک نمونه از آن اجرا شود!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'مشکل در اجرا \'{0}\'. اطلاعات فايل مانيفست پيدا نشد!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'مشکل در اجرا \'{0}\'. مرورگر شما از اين نسخه پشتيباني نميکند: {1}',

  'ERR_NO_WM_RUNNING': 'مديريت پنجره ها در حال اجرا نيست',
  'ERR_CORE_INIT_FAILED': 'اجراي OS.js با مشکل مواجه شد',
  'ERR_CORE_INIT_FAILED_DESC': 'بروز يک مشکل در زمان اجراي OS.js',
  'ERR_CORE_INIT_NO_WM': 'ناتوان در اجراي OS.js: مديريت پنجره مشخص نشده!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'ناتوان در اجراي OS.js: با مشکل مواجه شدن مديريت پنجره : {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'ناتوان در اجراي OS.js: خطا در بارگزاري اوليه منابع ...',
  'ERR_JAVASCRIPT_EXCEPTION': 'گزارش خطا جاواسکريپت',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'يک خطاي غيره منتظره رخ داد, ممکن است يک باگ باشد.',

  'ERR_APP_API_ERROR': 'خظاي API برنامه',
  'ERR_APP_API_ERROR_DESC_FMT': 'برنامه {0} با خطا مواجه شدن اجراي عمليات \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'کمبود آرگامنت: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'خطاي ناشناخته',

  'ERR_OPERATION_TIMEOUT': 'به اتمام رسيدن عمليات',
  'ERR_OPERATION_TIMEOUT_FMT': 'به اتمام رسيدن عمليات ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'شما قبلا يک پنجره با نام  \'{0}\'',
  'WINDOW_MINIMIZE': 'تمام صفحه',
  'WINDOW_MAXIMIZE': 'کوچک  شدن صفحه',
  'WINDOW_RESTORE': 'بازيابي',
  'WINDOW_CLOSE': 'بستن',
  'WINDOW_ONTOP_ON': 'برروي همه (فعال)',
  'WINDOW_ONTOP_OFF': 'برري همه(غيرفعال)',

  // Handler
  'TITLE_SIGN_OUT': 'خروج',
  'TITLE_SIGNED_IN_AS_FMT': 'وارد شده با نام : {0}',
  'ERR_LOGIN_FMT': 'خطاي ورود: {0}',
  'ERR_LOGIN_INVALID': 'نا معتبر بودن ورود',

  // SESSION
  'MSG_SESSION_WARNING': 'آيا شما مطمئن به خارح شدن از برنامه  هستيد? تماميه اطلاعات ذخيره نشد پنجره ها از بين خواهند رفت!',

  // Service
  'BUGREPORT_MSG': 'درصورتي که تصورميکنيد اين يک باگ است گزارش دهيد.\nشامل توضيح کوتاهي که چگونه اين اتفاق افتاد, و اگر شما توانستد  برطرف کنيد نحوه آن را اطلاع دهيد',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'وارد شدن به سرويس هاي خارجي: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'خطاي مخرب',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR خطاي: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'خروج از برنامه', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'خروج کاربر \'{0}\'.\nآيا نميخواهيد جلسه جاري حفظ شود?',

  'DIALOG_CLOSE': 'بستن',
  'DIALOG_CANCEL': 'انصراف',
  'DIALOG_APPLY': 'اعمال',
  'DIALOG_OK': 'تاييد',

  'DIALOG_ALERT_TITLE': 'ديالوگ هشدار',

  'DIALOG_COLOR_TITLE': 'ديالوگ رنگ',
  'DIALOG_COLOR_R': 'قرمز: {0}',
  'DIALOG_COLOR_G': 'سبز: {0}',
  'DIALOG_COLOR_B': 'آبي: {0}',
  'DIALOG_COLOR_A': 'آلفا: {0}',

  'DIALOG_CONFIRM_TITLE': 'ديالوگ تاييد',

  'DIALOG_ERROR_MESSAGE': 'پيام',
  'DIALOG_ERROR_SUMMARY': 'خلاصه',
  'DIALOG_ERROR_TRACE': 'پيگيري',
  'DIALOG_ERROR_BUGREPORT': 'گزارش باگ',

  'DIALOG_FILE_SAVE': 'ذخيره',
  'DIALOG_FILE_OPEN': 'بازکردن',
  'DIALOG_FILE_MKDIR': 'پوشه جديد',
  'DIALOG_FILE_MKDIR_MSG': 'ساخت پوشه در مسير **{0}**',
  'DIALOG_FILE_OVERWRITE': 'داشتن حصول اطمينان از رونوشت فايل \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'نوع نمايش',
  'DIALOG_FILE_MNU_LISTVIEW': 'نمايش ليست',
  'DIALOG_FILE_MNU_TREEVIEW': 'نمايش درختي',
  'DIALOG_FILE_MNU_ICONVIEW': 'نمايش آيکون',
  'DIALOG_FILE_ERROR': 'خطاي ديالوگ فايل',
  'DIALOG_FILE_ERROR_SCANDIR': 'خطا در ليست کردن مسير \'{0}\' به دليل رخ دادن يک خطا',
  'DIALOG_FILE_MISSING_FILENAME': 'شما ميبايست يک فايل انتخاب کنيد يا يک نام فايل جديد وارد کنيد!',
  'DIALOG_FILE_MISSING_SELECTION': 'شما مي بايست يک فايل انتخاب کنيد!',

  'DIALOG_FILEINFO_TITLE': 'اطلاعات فايل',
  'DIALOG_FILEINFO_LOADING': 'بارکزاري اطلاعات فايل براي: {0}',
  'DIALOG_FILEINFO_ERROR': 'خطاي ديالوک انتقال فايل',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'مشکل در گرفتن اطلاعات فايل براي **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'مشکل در گرفتن اطلاعات فايل براي: {0}',

  'DIALOG_INPUT_TITLE': 'ديالوگ ورودي',

  'DIALOG_FILEPROGRESS_TITLE': 'پروسه عمليات فايل',
  'DIALOG_FILEPROGRESS_LOADING': 'بارگزاري...',

  'DIALOG_UPLOAD_TITLE': 'ديالوگ ارسال فايل',
  'DIALOG_UPLOAD_DESC': 'ارسال فايل به **{0}**.<br />بيشترين اندازه: {1} بايت',
  'DIALOG_UPLOAD_MSG_FMT': 'بارگزاري',
  'DIALOG_UPLOAD_MSG': 'درحال ارسال فايل...',
  'DIALOG_UPLOAD_FAILED': 'ارسال فايل با خطا مواجه شد',
  'DIALOG_UPLOAD_FAILED_MSG': 'ارسال فايل با خطا مواجه شده است',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'دليل ناشناخته...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'انصراف به وسيله کاربر...',
  'DIALOG_UPLOAD_TOO_BIG': 'فايل بيش ازاندازه بزرگ است',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'فايل بيش از اندازه بزرک است, سقف {0}',

  'DIALOG_FONT_TITLE': 'ديالوگ فونت',

  'DIALOG_APPCHOOSER_TITLE': 'انتخاب برنامه',
  'DIALOG_APPCHOOSER_MSG': 'انتخاب يک برنامه براي باز شدن',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'شما ميبايست يک برنامه انتخاب کنيد',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'استفاده به عنوان پيش فرض براي {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': ' ماژول GoogleAPI پيکربندي نشده يا غير فعال ميباشد',
  'GAPI_SIGN_OUT': 'خارج شدن از API هاي سرويس هاي گوگل',
  'GAPI_REVOKE': 'رد مجوز هاو خروج از برنامه',
  'GAPI_AUTH_FAILURE': 'Google API تشخيض هويت با مشکل واجه شد و يا اتفاق نيافتاد',
  'GAPI_AUTH_FAILURE_FMT': 'با مشکل مواجه شدن تشخيص هويت: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'مشکل با بارگزاري Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'ماژول هاي Windows Live API پيکربندي نشده و يا غير فعال مي باشد',
  'WLAPI_SIGN_OUT': 'خروج از Window Live API',
  'WLAPI_LOAD_FAILURE': 'مشکل در بارگزاري Windows Live API',
  'WLAPI_LOGIN_FAILED': 'مشکل در ثبت لاگ در Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'مشکل ثبت لاگ در Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API ارجاع {0} وضعيت',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'قادر به ايجاد IndexDB بدون نام پايگاه داده ها نمي باشيم',
  'IDB_NO_SUCH_ITEM': 'آيتم اين چنين نميباد',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'خطاي بحراني',
  'ERR_VFS_UNAVAILABLE': 'موجود نمي باشد',
  'ERR_VFS_FILE_ARGS': 'فايل حدااقل يک آرگامنت مي خواهد',
  'ERR_VFS_NUM_ARGS': 'آرگامنت ها کافي نيست',
  'ERR_VFS_EXPECT_FILE': 'انتظار يک شي فايلي',
  'ERR_VFS_EXPECT_SRC_FILE': 'انتظار يک شي فايلي منبع',
  'ERR_VFS_EXPECT_DST_FILE': 'انتظار شي فايلي مقصد',
  'ERR_VFS_FILE_EXISTS': 'مقصد قبلا وجود دارد',
  'ERR_VFS_TRANSFER_FMT': 'بروز مشکل در زمان انتقال بين ذخيره کننده ها: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'بدون اطلاعات مقصد قادر به ارسال فايل نمي باشد',
  'ERR_VFS_UPLOAD_NO_FILES': 'بدن مشخص کردن فايل امکان پذير نمي باشد',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'ارسال فايل به مشکل برخورد کرد: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'ارسال فايل لغو شد',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'دانلود فايل بدون انتخاب فايل امکان پذير نميباشد',
  'ERR_VFS_DOWNLOAD_FAILED': 'بروز مشکل در حين دانلود فايل : {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'پاسخ تهي ميباشد',

  'ERR_VFSMODULE_INVALID': 'ماژول VFS نا م عتبر ميباشد',
  'ERR_VFSMODULE_INVALID_FMT': ' ماژول VFS نامعتبر ميباشد : {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'متد VُّّFS نامعتبر مي باشد',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'متد VُّّFS نامعتبر مي باشد: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'نوع ماژول VFS نامعتبر ميباشد',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'نوع ماژول VFS نامعتبر ميباشد: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'پيکربندي ماژول VFS نامعتبر مي باشد',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'پيکربندي ماژول VFS نامعتبر مي باشد: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'ماژول VFS قبلا الصاق شده است',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'ماژول VFS \'{0}\' قابلا الصاق شده ',
  'ERR_VFSMODULE_NOT_MOUNTED': 'ماژول VFS  الصاق نشده',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'ماؤول VFS \'{0}\' الصاق نشده است',
  'ERR_VFSMODULE_EXCEPTION': 'بروز خطا در ماژول VFS',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'بروز خطا در ماژول VFS : {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'در حال دانلود فايل',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR خطاي',
  'ERR_VFSMODULE_ROOT_ID': 'پيدا کردن شناسه پوشه روت با خطا مواجه شد',
  'ERR_VFSMODULE_NOSUCH': 'فايل موحود نيست',
  'ERR_VFSMODULE_PARENT': 'والدين اين چنين وجود ندارد',
  'ERR_VFSMODULE_PARENT_FMT': 'جستجوي والدين با خطا مواجه شد: {0}',
  'ERR_VFSMODULE_SCANDIR': 'اسکن دايرکتوري باخطا موجه شد',
  'ERR_VFSMODULE_SCANDIR_FMT': 'اسکن دايرکتوري باخطا موجه شد: {0}',
  'ERR_VFSMODULE_READ': 'خواندن فايل با خطا مواجه شد',
  'ERR_VFSMODULE_READ_FMT': 'خواندن فايل با خطا مواجه شد: {0}',
  'ERR_VFSMODULE_WRITE': 'نوشتن فايل با خطا مواجه شد',
  'ERR_VFSMODULE_WRITE_FMT': 'نوشتن فايل با خطا موجه شد: {0}',
  'ERR_VFSMODULE_COPY': 'کپي با خطا مواجه شد',
  'ERR_VFSMODULE_COPY_FMT': 'کپي با خطا مواجه شد: {0}',
  'ERR_VFSMODULE_UNLINK': 'قطع اتصال با خطا مواجه شد',
  'ERR_VFSMODULE_UNLINK_FMT': 'قطع ارتباط با شکست مواجه شد: {0}',
  'ERR_VFSMODULE_MOVE': 'جابه جايي فايل با شکست مواجه شد',
  'ERR_VFSMODULE_MOVE_FMT': 'جابه جايي فايل با شکست مواجه شد: {0}',
  'ERR_VFSMODULE_EXIST': 'برسي موجود بودن فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_EXIST_FMT': 'برسي موجود بودن فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_FILEINFO': 'به دست آرودن اطلاعات فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_FILEINFO_FMT': 'به دست آرودن اطلاعات فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_MKDIR': 'ساخت دايرکتوري با مشکل مواجه شد',
  'ERR_VFSMODULE_MKDIR_FMT': 'به دست آرودن اطلاعات فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_URL': 'به دست آوردن URL فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_URL_FMT': 'به دست آوردن URL فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_TRASH': 'انتقال فايل به سطل زباله با مشکل مواجه شد',
  'ERR_VFSMODULE_TRASH_FMT': 'انتقال فايل به سطل زباله با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_UNTRASH': 'بازيافت فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_UNTRASH_FMT': 'بازيافت فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'تخليه سطل زباله با مشکل مواجه شد',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'تخليه سطل زباله با مشکل مواجه شد: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'شما به وسيله DroBox API ثبت ورود کرده ايد',
  'DROPBOX_SIGN_OUT': 'خروج از سرويس هاي Google API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'آيتم پيدا نشد: حل و فصل مسير با مشکل مواجه شد',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'بار گزاري zip.js  با مشکل مواجه شد',
  'ZIP_VENDOR_FAIL': 'کتابخانه zip.js پيدا نشد : آيا شما موارد متعلق به آن را بارگزاري کرده ايد ?',
  'ZIP_NO_RESOURCE': 'هيچ يک از منابع zip داده نشده است',
  'ZIP_NO_PATH': 'مسيري داده نشده است',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'ميسر نصب بسته قبلا وجود دارد. قادر به ادامه نميباشيم!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'باز کردن فايل امکان پذير نيست',
  'ERR_FILE_APP_OPEN_FMT': 'فايل {0} قابل باز کردن نمي باشد به دليل اينکه نوع  {1} پشنيباي نميشود',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'فايل {0} را نمي توان باز کرد: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'فايل {0} قادر ذخيره کردن نمي باشد: {1}',
  'ERR_GENERIC_APP_FMT': '{0} خطاي برنامه',
  'ERR_GENERIC_APP_ACTION_FMT': 'مشکل در اجراي فرآيند \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'خطاي ناشناخته',
  'ERR_GENERIC_APP_REQUEST': 'درحال اجراي درخواست شما يک خطا اتفاق افتاد',
  'ERR_GENERIC_APP_FATAL_FMT': 'خطاي مخرب: {0}',
  'MSG_GENERIC_APP_DISCARD': 'لغو تغييرات?',
  'MSG_FILE_CHANGED': 'فايل تغيير کرده است.آيا دوباره بازگزاري شود؟',
  'MSG_APPLICATION_WARNING': 'هشدار برنامه',
  'MSG_MIME_OVERRIDE': 'نوع فايل "{0}" پشتيباني نميشود, ولي از نوع "{1}" استفاده شود.',

  //
  // General
  //

  'LBL_UNKNOWN': 'ناشناخته',
  'LBL_APPEARANCE': 'ظاهر',
  'LBL_USER': 'کاربر',
  'LBL_NAME': 'نام',
  'LBL_APPLY': 'اعمال',
  'LBL_FILENAME': 'نام فايل',
  'LBL_PATH': 'مسير',
  'LBL_SIZE': 'حجم',
  'LBL_TYPE': 'نوع',
  'LBL_MIME': 'نوع',
  'LBL_LOADING': 'درحال بارگزاري',
  'LBL_SETTINGS': 'تنظيمات',
  'LBL_ADD_FILE': 'اضافه کردن فايل',
  'LBL_COMMENT': 'نظر',
  'LBL_ACCOUNT': 'حساب',
  'LBL_CONNECT': 'متصل',
  'LBL_ONLINE': 'روي خط',
  'LBL_OFFLINE': 'چراغ خاموش',
  'LBL_AWAY': 'دور',
  'LBL_BUSY': 'مشغول',
  'LBL_CHAT': 'چت',
  'LBL_HELP': 'کمک',
  'LBL_ABOUT': 'درباره',
  'LBL_PANELS': 'پنل ها',
  'LBL_LOCALES': 'موقعيت ها',
  'LBL_THEME': 'شمايل',
  'LBL_COLOR': 'رنگ',
  'LBL_PID': 'PID',
  'LBL_KILL': 'کشتن',
  'LBL_ALIVE': 'زنده',
  'LBL_INDEX': 'ايندکس',
  'LBL_ADD': 'اضافه',
  'LBL_FONT': 'فونت',
  'LBL_YES': 'بله',
  'LBL_NO': 'نه',
  'LBL_CANCEL': 'انصراف',
  'LBL_TOP': 'روي',
  'LBL_LEFT': 'چپ',
  'LBL_RIGHT': 'راست',
  'LBL_BOTTOM': 'پايين',
  'LBL_CENTER': 'مرکز',
  'LBL_FILE': 'فايل',
  'LBL_NEW': 'جديد',
  'LBL_OPEN': 'بازکردن',
  'LBL_SAVE': 'ذخيره کردن',
  'LBL_SAVEAS': 'ذخيره کردن به صورت...',
  'LBL_CLOSE': 'بستن',
  'LBL_MKDIR': 'ايجاد مسير',
  'LBL_UPLOAD': 'ارسال',
  'LBL_VIEW': 'نمايش',
  'LBL_EDIT': 'ويرايش',
  'LBL_RENAME': 'تغيير نام',
  'LBL_DELETE': 'حذف',
  'LBL_OPENWITH': 'بازکردن با ...',
  'LBL_ICONVIEW': 'نمايش آيکون',
  'LBL_TREEVIEW': 'نمايش درختي',
  'LBL_LISTVIEW': 'نمايش ليست',
  'LBL_REFRESH': 'تازه کردن',
  'LBL_VIEWTYPE': 'نمايش نوع',
  'LBL_BOLD': 'درشت',
  'LBL_ITALIC': 'ايتاليک',
  'LBL_UNDERLINE': 'زير خط',
  'LBL_REGULAR': 'قاعده',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'مقصود',
  'LBL_OUTDENT': 'خارج از تاريخ',
  'LBL_UNDO': 'برعکس ',
  'LBL_REDO': 'دوباره کار',
  'LBL_CUT': 'قطع کردن',
  'LBL_UNLINK': 'برخلاف',
  'LBL_COPY': 'کپي',
  'LBL_PASTE': 'در اين محل',
  'LBL_INSERT': 'درج',
  'LBL_IMAGE': 'تصوير',
  'LBL_LINK': 'اتصال',
  'LBL_DISCONNECT': 'قطع ارتباط',
  'LBL_APPLICATIONS': 'برنامه ها',
  'LBL_ADD_FOLDER': 'اضاقه کردن پوشه',
  'LBL_INFORMATION': 'اطلاعات',
  'LBL_TEXT_COLOR': 'رنگ متن',
  'LBL_BACK_COLOR': 'رنگ سياه',
  'LBL_RESET_DEFAULT': 'برگردان به تنظيمات اوليه',
  'LBL_DOWNLOAD_COMP': 'دانلود به کامپيوتر',
  'LBL_ORDERED_LIST': 'ليست مرتب شده',
  'LBL_BACKGROUND_IMAGE': 'تصوير پس زمينه',
  'LBL_BACKGROUND_COLOR': 'رنگ پس زمينه',
  'LBL_UNORDERED_LIST': 'ليست مرتب نشده',
  'LBL_STATUS': 'وضعيت ها',
  'LBL_READONLY': 'فقط خواندني',
  'LBL_CREATED': 'ايجاد شده',
  'LBL_MODIFIED': 'تغيير داده شده',
  'LBL_SHOW_COLUMNS': 'نمايش ستون ها',
  'LBL_MOVE': 'حرکت',
  'LBL_OPTIONS': 'انتخاب',
  'LBL_OK': 'تاييد',
  'LBL_DIRECTORY': 'دايرکتوري',
  'LBL_CREATE': 'ايجاد کردن',
  'LBL_BUGREPORT': 'گزارش مشکل',
  'LBL_INSTALL': 'نصب',
  'LBL_UPDATE': 'به روز رساني',
  'LBL_REMOVE': 'برداشتن',
  'LBL_SHOW_SIDEBAR': 'نمايش نوار لغزنده',
  'LBL_SHOW_NAVIGATION': 'نمايش ناوبري',
  'LBL_SHOW_HIDDENFILES': 'نمايش فايل هاي مخفي',
  'LBL_SHOW_FILEEXTENSIONS': 'نمايش پسوند فايل'
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @author  Emersion <contact@emersion.fr>
 * @author  Emilien Raffaëlli <emilienraffaelli@hotmail.com>
 * @author James <jameszemouri@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Erreur lors de l\'ouverture du fichier',
  'ERR_WM_NOT_RUNNING': 'Le gestionnaire de fenêtre n\'est pas en cours d\'execution',
  'ERR_FILE_OPEN_FMT': 'Le fichier \'**{0}**\' n\'a pas pu être ouvert',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Impossible de trouver une application supportant les fichiers \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Impossible de lancer l\'application',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Une erreur est survenue lors du lancement de : {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Application \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Application \'{0}\' init() failed: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Application resources missing for \'{0}\' or it failed to load!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Application \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'L\'application \'{0}\' est déjà lancée et n\'autorise qu\'une seule instance !',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Impossible de lancer \'{0}\'. Le manifeste de l\'application n\'a pas été trouvé !',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Impossible de lancer \'{0}\'. Votre navigateur ne supporte pas : {1}',

  'ERR_NO_WM_RUNNING': 'Le gestionnaire de fenêtres n\'est pas lancé',
  'ERR_CORE_INIT_FAILED': 'Impossible d\'initialiser OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Une erreur est survenue lors de l\'initialisation de OS.js',
  'ERR_CORE_INIT_NO_WM': 'Impossible de lancer OS.js: aucun gestionnaire de fenêtres défini !',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Impossible de lancer OS.js: erreur lors du lancement du gestionnaire de fenêtres : {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Impossible de lancer OS.js: impossible de précharger les ressources...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Rapport d\'erreur Javascript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Une erreur inconnue est survenue, peut-être un bug.',

  'ERR_APP_API_ERROR': 'Erreur de l\'API de l\'application',
  'ERR_APP_API_ERROR_DESC_FMT': 'L\'pplication {0} n\'a pas pu exécuter l\'opération \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Argument manquant: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Erreur inconnue',

  'ERR_OPERATION_TIMEOUT': 'Operation Expirée',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operation Expirée ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' attends \'{1}\' d\'être \'{2}\', \'{3}\' fournie',
  'ERR_INVALID_LOCATION': 'Location invalide',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Une autre fenêtre porte déjà le nom \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimiser',
  'WINDOW_MAXIMIZE': 'Maximiser',
  'WINDOW_RESTORE': 'Restaurer',
  'WINDOW_CLOSE': 'Fermer',
  'WINDOW_ONTOP_ON': 'Au-dessus (activer)',
  'WINDOW_ONTOP_OFF': 'Au-dessous (désactiver)',

  // Handler
  'TITLE_SIGN_OUT': 'Déconnexion',
  'TITLE_SIGNED_IN_AS_FMT': 'Connecté en tant que: {0}',
  'ERR_LOGIN_FMT': 'Erreur d\'identification : {0}',
  'ERR_LOGIN_INVALID': 'Identifiant invalide',

  // SESSION
  'ERR_NO_SESSION': 'Aucune session n\'a été crée par le serveur. Voulez-vous réessayer de vous connecter?',
  'MSG_SESSION_WARNING': 'Êtes-vous sûr de vouloir quitter OS.js? Tous vos paramètres et vos données seront perdues!',

  // Service
  'BUGREPORT_MSG': 'Veuillez reporter ceci si vous pensez qu\'il s\'agit d\'un bug. \n Inclure une brève description de la façon dont l\'erreur s\'est produite, et si vous le pouvez; Comment le répliquer',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Connexion à des services externes: {0}',
  'CONNECTION_LOST': 'La connexion au serveur a été perdue. Reconnexion ...',
  'CONNECTION_RESTORED': 'La connexion au serveur a été restaurée',
  'CONNECTION_RESTORE_FAILED': 'Impossible de rétablir la connexion. Essayer à nouveau.',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Erreur Fatale',
  'ERR_UTILS_XHR_FMT': 'Erreure AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Déconnexion (quitter)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Déconnexion de l\'utilisateur \'{0}\'.\nVoulez-vous enregistrer votre session courante ?',

  'DIALOG_CLOSE': 'Fermer',
  'DIALOG_CANCEL': 'Annuler',
  'DIALOG_APPLY': 'Appliquer',
  'DIALOG_OK': 'Valider',

  'DIALOG_ALERT_TITLE': 'Fenêtre d\'alerte',

  'DIALOG_COLOR_TITLE': 'Fenêtre des couleur',
  'DIALOG_COLOR_R': 'Rouge: {0}',
  'DIALOG_COLOR_G': 'Vert: {0}',
  'DIALOG_COLOR_B': 'Bleu: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Fenêtre de confirmation',

  'DIALOG_ERROR_TITLE': 'Erreur',
  'DIALOG_ERROR_MESSAGE': 'Message',
  'DIALOG_ERROR_SUMMARY': 'Résumé',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Rapport de bug',

  'DIALOG_FILE_SAVE': 'Enregistrer',
  'DIALOG_FILE_OPEN': 'Ouvrir',
  'DIALOG_FILE_MKDIR': 'Nouveau dossier',
  'DIALOG_FILE_MKDIR_MSG': 'Créer un nouveau dossier dans **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Êtes-vous sûr de vouloir écraser le fichier \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Type de vue',
  'DIALOG_FILE_MNU_LISTVIEW': 'Vue en liste',
  'DIALOG_FILE_MNU_TREEVIEW': 'Vue en arborescence',
  'DIALOG_FILE_MNU_ICONVIEW': 'Vue en icônes',
  'DIALOG_FILE_ERROR': 'Erreur FileDialog',
  'DIALOG_FILE_ERROR_SCANDIR': 'Impossible de lister le contenu du dossier \'{0}\' car une erreur est survenue',
  'DIALOG_FILE_ERROR_FIND': 'Impossible de recherche dans le répertoire  \'{0}\' car une erreur s\'est produite',
  'DIALOG_FILE_MISSING_FILENAME': 'Vous devez sélectionner un fichier ou entrer un nouveau nom de fichier !',
  'DIALOG_FILE_MISSING_SELECTION': 'Vous devez sélectionner un fichier!',

  'DIALOG_FILEINFO_TITLE': 'Informations sur le fichier',
  'DIALOG_FILEINFO_LOADING': 'Chargement des informations sur le fichier: {0}',
  'DIALOG_FILEINFO_ERROR': 'Erreur FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Impossible de récupérer les informations sur : **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Impossible de récupérer les informations sur : {0}',

  'DIALOG_INPUT_TITLE': 'Fenêtre de saisie',

  'DIALOG_FILEPROGRESS_TITLE': 'Progression des opérations sur les fichiers',
  'DIALOG_FILEPROGRESS_LOADING': 'Chargement...',

  'DIALOG_UPLOAD_TITLE': 'Fenêtre d\'envoi de fichier',
  'DIALOG_UPLOAD_DESC': 'Envoyer un fichier vers **{0}**.\nTaille maximum: {1} octets',
  'DIALOG_UPLOAD_MSG_FMT': 'Envoi de \'{0}\' ({1} {2}) vers {3}',
  'DIALOG_UPLOAD_MSG': 'Envoi du fichier...',
  'DIALOG_UPLOAD_FAILED': 'L\'envoi a échoué!',
  'DIALOG_UPLOAD_FAILED_MSG': 'L\'envoi a échoué',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Raison inconnue...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Annulé pas l\'utilisateur...',
  'DIALOG_UPLOAD_TOO_BIG': 'Le fichier est trop gros',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Le fichier est trop gros, sa taille éxcède {0}',

  'DIALOG_FONT_TITLE': 'Fenêtre de police',

  'DIALOG_APPCHOOSER_TITLE': 'Choisir une application',
  'DIALOG_APPCHOOSER_MSG': 'Choisir une application pour ouvrir',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Vous devez sélectionner une application',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Utiliser comme application par défaut pour {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Module Google API non configuré ou désactivé',
  'GAPI_SIGN_OUT': 'Déconnexion de l\'API Google',
  'GAPI_REVOKE': 'Révoquer les permissions et déconnecter',
  'GAPI_AUTH_FAILURE': 'L\'authentification Google API a échouer ou ne s\'est pas déroulée',
  'GAPI_AUTH_FAILURE_FMT': 'Impossible d\'authentifier: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Impossible de charger l\'API Google',

  // Windows Live API
  'WLAPI_DISABLED': 'Module Live API non configuré ou désactivé',
  'WLAPI_SIGN_OUT': 'Déconnexion de l\'API Live',
  'WLAPI_LOAD_FAILURE': 'Impossible de charger Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Impossible de s\'authentifier dans Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Impossible de s\'authentifier dans Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API a retourné le status {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Impossible de créer une base IndexedDB sans nom de base',
  'IDB_NO_SUCH_ITEM': 'Aucun item correspondant',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Erreur fatale',
  'ERR_VFS_UNAVAILABLE': 'Non disponible',
  'ERR_VFS_FILE_ARGS': 'Le fichier attend au moins un argument',
  'ERR_VFS_NUM_ARGS': 'Pas assez d\'arguments',
  'ERR_VFS_EXPECT_FILE': 'Un objet "fichier" est attendu',
  'ERR_VFS_EXPECT_SRC_FILE': 'Un objet "fichier source" est attendu',
  'ERR_VFS_EXPECT_DST_FILE': 'Un objet "fichier destination" est attendu',
  'ERR_VFS_FILE_EXISTS': 'Le fichier destination existe déjà',
  'ERR_VFS_TARGET_NOT_EXISTS': 'La cible n\'existe pas',
  'ERR_VFS_TRANSFER_FMT': 'Une erreur est survenu lors du transfert entre espaces de stockage : {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Impossible d\'envoyer un fichier sans destination',
  'ERR_VFS_UPLOAD_NO_FILES': 'Impossible d\'envoyer un fichier sans aucun fichier défini',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Impossible d\'envoyer le fichier: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'L\'envoi du fichier a été annulé',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Impossible de télécharger un chemin sans chemin',
  'ERR_VFS_DOWNLOAD_FAILED': 'Une erreur est survenue lors du téléchargement: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'La réponse est vide',
  'ERR_VFS_NO_MIME_DETECT': 'Aucun type de mime détecté',

  'ERR_VFSMODULE_INVALID': 'Module VFS invalide',
  'ERR_VFSMODULE_INVALID_FMT': 'Module VFS invalide: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Méthode VFS invalide',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Méthode VFS invalide: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Type de module VFS invalide',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Type de module VFS invalide: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Configuration VFS Module ',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Configuration VFS Module non valide : {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'Module VFS déjà monté',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'Module VFS \'{0}\' déjà monté',
  'ERR_VFSMODULE_NOT_MOUNTED': 'Module VFS non monté',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'Module VFS \'{0}\' non monté',
  'ERR_VFSMODULE_EXCEPTION': 'Exception du module VFS',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'Exception du module VFS: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Aucun Module VFS ne correspond {0}. Mauvais chemin ou Mauvais formats ?',
  'ERR_VFSMODULE_READONLY': 'Ce module VFS est en lecture seule',
  'ERR_VFSMODULE_READONLY_FMT': 'Ce module VFS est en lecture seule: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Téléchargement du fichier',

  'ERR_VFSMODULE_XHR_ERROR': 'Erreur XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Impossible de trouver l\'id du répertoire racine',
  'ERR_VFSMODULE_NOSUCH': 'Le fichier n\'existe pas',
  'ERR_VFSMODULE_PARENT': 'Pas de parent',
  'ERR_VFSMODULE_PARENT_FMT': 'Impossible de trouver un parent: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Impossible de scanner le répertoire',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Impossible de scanner le répertoire: {0}',
  'ERR_VFSMODULE_READ': 'Impossible de lire le fichier',
  'ERR_VFSMODULE_READ_FMT': 'Impossible de lire le fichier: {0}',
  'ERR_VFSMODULE_WRITE': 'Impossible d\'écrire dans le fichier',
  'ERR_VFSMODULE_WRITE_FMT': 'Impossible d\'écrire dans le fichier: {0}',
  'ERR_VFSMODULE_COPY': 'Impossible de copier',
  'ERR_VFSMODULE_COPY_FMT': 'Impossible de copier: {0}',
  'ERR_VFSMODULE_UNLINK': 'Impossible de détacher le fichier',
  'ERR_VFSMODULE_UNLINK_FMT': 'Impossible de détacher le fichier: {0}',
  'ERR_VFSMODULE_MOVE': 'Impossible de déplacer le fichier',
  'ERR_VFSMODULE_MOVE_FMT': 'Impossible de déplacer le fichier: {0}',
  'ERR_VFSMODULE_EXIST': 'Impossible de vérifier l\'existance du fichier',
  'ERR_VFSMODULE_EXIST_FMT': 'Impossible de vérifier l\'existance du fichier: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Impossible de récuperer les informations du fichier',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Impossible de récuperer les informations du fichier: {0}',
  'ERR_VFSMODULE_MKDIR': 'Impossible de créer un répertoire',
  'ERR_VFSMODULE_MKDIR_FMT': 'Impossible de créer un répertoire: {0}',
  'ERR_VFSMODULE_MKFILE': 'Impossible de créer le fichier',
  'ERR_VFSMODULE_MKFILE_FMT': 'Impossible de créer le fichier: {0}',
  'ERR_VFSMODULE_URL': 'Impossible de récuperer l\'URL du fichier',
  'ERR_VFSMODULE_URL_FMT': 'Impossible de récuperer l\'URL du fichier: {0}',
  'ERR_VFSMODULE_TRASH': 'Impossible de déplacer le fichier dans la corbeille',
  'ERR_VFSMODULE_TRASH_FMT': 'Impossible de déplacer le fichier dans la corbeille: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Impossible de sortir le fichier de la corbeille',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Impossible de sortir le fichier de la corbeille: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Impossible de vider la corbeille',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Impossible de vider la corbeille: {0}',
  'ERR_VFSMODULE_FIND': 'Impossible de chercher',
  'ERR_VFSMODULE_FIND_FMT': 'Impossible de chercher: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Impossible d\'obtenir de l\'espace libre',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Impossible d\'obtenir de l\'espace libre: {0}',
  'ERR_VFSMODULE_EXISTS': 'Impossible de Vérifier s\'il existe',
  'ERR_VFSMODULE_EXISTS_FMT': 'Impossible de Vérifier s\'il existe: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Vous êtes connectés dans l\'API Dropbox',
  'DROPBOX_SIGN_OUT': 'Déconnexion des services Google API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Impossible de résoudre le chemin: objet non trouvé',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'LE chargement de zip.js a échoué',
  'ZIP_VENDOR_FAIL': 'La bibliothèque zip.js n\'a pas été trouvée. A-t-elle été chargée correctement?',
  'ZIP_NO_RESOURCE': 'Aucune archive zip n\'a été fournie',
  'ZIP_NO_PATH': 'Aucun chemin fourni',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Recherche...',
  'SEARCH_NO_RESULTS': 'Aucun resulta trouver',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Le répertoire d\'installation des paquêts existe déjà. L\'opération est interrompue!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Impossible d\'ouvrir le fichier',
  'ERR_FILE_APP_OPEN_FMT': 'Le fichier {0} n\'a pas pu être ouvert car le type mime {1} m\'est pas supporté',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Le fichier {0} n\'a pas pu être ouvert: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Le fichier {0} n\'a pas pu être enregistré: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Erreur de l\'application',
  'ERR_GENERIC_APP_ACTION_FMT': 'Impossible d\'effectuer l\'action \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Erreur inconnue',
  'ERR_GENERIC_APP_REQUEST': 'Une erreur est survenue lors du traitement de votre requête',
  'ERR_GENERIC_APP_FATAL_FMT': 'Erreur fatale : {0}',
  'MSG_GENERIC_APP_DISCARD': 'Abandonner les modifications ?',
  'MSG_FILE_CHANGED': 'Le fichier a été modifié. Le recharger ?',
  'MSG_APPLICATION_WARNING': 'Avertissement de l\'application',
  'MSG_MIME_OVERRIDE': 'Le type de fichier "{0}" n\'est pas supporté, utilisation de "{1}" à la place.',

  'ERR_OPEN_LOCATION': 'Échec de l\'ouverture de l\'emplacement',
  'ERR_OPEN_LOCATION_FMT': 'Échec de l\'ouverture de l\'emplacement: {0}',

  //
  // General
  //

  'LBL_UNKNOWN': 'Inconnu',
  'LBL_APPEARANCE': 'Appearance',
  'LBL_USER': 'Utilisateur',
  'LBL_NAME': 'Nom',
  'LBL_APPLY': 'Appliquer',
  'LBL_FILENAME': 'Nom de fichier',
  'LBL_PATH': 'Chemin',
  'LBL_SIZE': 'Taille',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Chargement',
  'LBL_SETTINGS': 'Paramètres',
  'LBL_ADD_FILE': 'Ajouter un fichier',
  'LBL_COMMENT': 'Commentaire',
  'LBL_ACCOUNT': 'Compte',
  'LBL_CONNECT': 'Connexion',
  'LBL_ONLINE': 'En ligne',
  'LBL_OFFLINE': 'Hors ligne',
  'LBL_AWAY': 'Absent',
  'LBL_BUSY': 'Occupé',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Aide',
  'LBL_ABOUT': 'À propos',
  'LBL_PANELS': 'Dock',
  'LBL_LOCALES': 'Langues',
  'LBL_THEME': 'Thème',
  'LBL_COLOR': 'Couleur',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Fin de tâche',
  'LBL_ALIVE': 'Vivant',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Ajouter',
  'LBL_FONT': 'Police',
  'LBL_YES': 'Oui',
  'LBL_NO': 'Non',
  'LBL_CANCEL': 'Annuler',
  'LBL_TOP': 'Haut',
  'LBL_LEFT': 'Gauche',
  'LBL_RIGHT': 'Droite',
  'LBL_BOTTOM': 'Bas',
  'LBL_CENTER': 'Centre',
  'LBL_FILE': 'Fichier',
  'LBL_NEW': 'Nouveau',
  'LBL_OPEN': 'Ouvrir',
  'LBL_SAVE': 'Enregistrer',
  'LBL_SAVEAS': 'Enregistrer sous...',
  'LBL_CLOSE': 'Fermer',
  'LBL_MKDIR': 'Créer un dossier',
  'LBL_UPLOAD': 'Envoyer un fichier',
  'LBL_VIEW': 'Vue',
  'LBL_EDIT': 'Édition',
  'LBL_RENAME': 'Renommer',
  'LBL_DELETE': 'Supprimer',
  'LBL_OPENWITH': 'Ouvrir avec...',
  'LBL_ICONVIEW': 'Vue en icônes',
  'LBL_TREEVIEW': 'Vue en arborescence',
  'LBL_LISTVIEW': 'Vue en liste',
  'LBL_REFRESH': 'Rafraîchir',
  'LBL_VIEWTYPE': 'Type de vue',
  'LBL_BOLD': 'Gras',
  'LBL_ITALIC': 'Italique',
  'LBL_UNDERLINE': 'Souligné',
  'LBL_REGULAR': 'Régulier',
  'LBL_STRIKE': 'Barré',
  'LBL_INDENT': 'Indentation',
  'LBL_OUTDENT': 'Dépassé',
  'LBL_UNDO': 'Annuler',
  'LBL_REDO': 'Refaire',
  'LBL_CUT': 'Couper',
  'LBL_UNLINK': 'Supprimer le lien',
  'LBL_COPY': 'Copier',
  'LBL_PASTE': 'Coller',
  'LBL_INSERT': 'Insérer',
  'LBL_IMAGE': 'Image',
  'LBL_LINK': 'Lien',
  'LBL_DISCONNECT': 'Déconnexion',
  'LBL_APPLICATIONS': 'Applications',
  'LBL_ADD_FOLDER': 'Ajouter un dossier',
  'LBL_INFORMATION': 'Information',
  'LBL_TEXT_COLOR': 'Couleur du texte',
  'LBL_BACK_COLOR': 'Couleur de fond',
  'LBL_RESET_DEFAULT': 'Rétablir par défaut',
  'LBL_DOWNLOAD_COMP': 'Télécharger sur l\'ordinateur',
  'LBL_ORDERED_LIST': 'Liste ordonnée',
  'LBL_BACKGROUND_IMAGE': 'Image d\'arrière-plan',
  'LBL_BACKGROUND_COLOR': 'Couleur d\'arrière-plan',
  'LBL_UNORDERED_LIST': 'Liste désordonnée',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Lecture seule',
  'LBL_CREATED': 'Crée',
  'LBL_MODIFIED': 'Modifié',
  'LBL_SHOW_COLUMNS': 'Montrer les colonnes',
  'LBL_MOVE': 'Déplacer',
  'LBL_OPTIONS': 'Options',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Repertoire',
  'LBL_CREATE': 'Créer',
  'LBL_BUGREPORT': 'Report de bug',
  'LBL_INSTALL': 'Installer',
  'LBL_UPDATE': 'Mettre à jour',
  'LBL_REMOVE': 'Enlever',
  'LBL_SHOW_SIDEBAR': 'Afficher la barre de côté',
  'LBL_SHOW_NAVIGATION': 'Afficher la navigation',
  'LBL_SHOW_HIDDENFILES': 'Afficher les fichiers cachés',
  'LBL_SHOW_FILEEXTENSIONS': 'Afficher les extensions de fichier',
  'LBL_MOUNT': 'Monter',
  'LBL_DESCRIPTION': 'Description',
  'LBL_USERNAME': 'Nom d\'utilisateur',
  'LBL_PASSWORD': 'Mot de passe',
  'LBL_HOST': 'Hôte',
  'LBL_NAMESPACE': 'Espace de nom',
  'LBL_SEARCH': 'Recherche',
  'LBL_BACK': 'Retour',
  'LBL_ICONS': 'Icônes',
  'LBL_ICON': 'Icône',
  'LBL_UNINSTALL': 'Désinstaller',
  'LBL_REGENERATE': 'Régénérer',
  'LBL_DESKTOP': 'Bureau',
  'LBL_WINDOWMANAGER': 'Gestionnaire de fenêtre',
  'LBL_HOTKEY': ' Raccourci clavier',
  'LBL_HOTKEYS': ' raccourcis clavier',
  'LBL_MOUNTS': 'Supports',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Application',
  'LBL_SCOPE': 'portée',
  'LBL_HIDE': 'Cacher',
  'LBL_REPOSITORY': 'Dépôt',
  'LBL_VERSION': 'Version',
  'LBL_AUTHOR': 'Auteur',
  'LBL_GROUPS': 'Groupes',
  'LBL_AUTOHIDE': 'Masquer automatiquement',
  'LBL_PERSONAL': 'Personnel',
  'LBL_SYSTEM': 'Système',
  'LBL_STARTING': 'Démarage',
  'LBL_SOUNDS': 'Son',
  'LBL_STORE': 'Centre d\'application',
  'LBL_LOCALE': 'Langue',
  'LBL_PACKAGE': 'Paquet',
  'LBL_PACKAGES': 'Paquets',
  'LBL_INPUT': 'Clavier',
  'LBL_MISC': 'Divers',
  'LBL_OTHER': 'Autre',
  'LBL_USERS': 'Gestion des utilisateurs',
  'LBL_FONTS': 'Polices',
  'LBL_OPEN_LOCATION': 'Ouvrir l\'emplacement ',
  'LBL_HOME': 'Accueil',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_LOCK': 'Verrouiller',
  'LBL_UNLOCK': 'Déverrouiller',
  'LBL_WARNING': 'Attention',
  'LBL_INFO': 'Info',
  'LBL_POSITION': 'Position',
  'LBL_OPACITY': 'Opacité',
  'LBL_ITEMS': 'Objets',
  'LBL_ONTOP': 'Premier plan',
  'LBL_BACKGROUND': 'Fond d\'écran'
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Errore durante l\'apertura del file',
  'ERR_WM_NOT_RUNNING': 'Windows manager non in esecuzione',
  'ERR_FILE_OPEN_FMT': 'Il file \'**{0}**\' non può essere aperto',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Nessuna applicazione che supporta il tipo di file \'{0}\' è stata trovata',
  'ERR_APP_LAUNCH_FAILED': 'Avvio Applicazione fallito',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Si è verificato un errore durante l\'avvio di : {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Applicazione \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Applicazione \'{0}\', init() fallito: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Applicazione resources missing for \'{0}\' or it failed to load!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Applicazione \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'L\' Applicazione \'{0}\' è già stata lanciata, ed è permessa una sola istanza!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Avvio di \'{0}\' fallito. Manifesto dell\'applicazione non trovato',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Avvio di \'{0}\' fallito. il tuo browser non supporta: {1}',

  'ERR_NO_WM_RUNNING': 'Nessun window manager in esecuzione',
  'ERR_CORE_INIT_FAILED': 'Inizializzazione OS.js fallita',
  'ERR_CORE_INIT_FAILED_DESC': 'Si è verificato un errore nella Inizializzazione di OS.js',
  'ERR_CORE_INIT_NO_WM': 'Impossibile avviare OS.js: Nessun window manager settato!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Impossibile avviare OS.js: Fallito avvio del window manager: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Impossibile avviare OS.js: Precaricamento risorse fallito...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Error Report',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Si è verificato un errore inaspettato, forse un bug.',

  'ERR_APP_API_ERROR': 'Application API error',
  'ERR_APP_API_ERROR_DESC_FMT': 'L\'Applicazione {0} ha fallito nell\'eseguire l\'operazine \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Argomento mancante: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Errore sconosciuto',

  'ERR_OPERATION_TIMEOUT': 'Operation Timeout',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operation Timeout ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' prevede \'{1}\' di tipo \'{2}\', \'{3}\' ricevuto',
  'ERR_INVALID_LOCATION': 'Percorso non valido',

  'ERR_OPEN_LOCATION': 'Fallito aprire percorso',
  'ERR_OPEN_LOCATION_FMT': 'Fallito aprire il percorso: {0}',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Hai già dato un nome alla finestra \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimizza',
  'WINDOW_MAXIMIZE': 'Massimizza',
  'WINDOW_RESTORE': 'Ripristina',
  'WINDOW_CLOSE': 'Chiudi',
  'WINDOW_ONTOP_ON': 'Primopiano (Abilita)',
  'WINDOW_ONTOP_OFF': 'Primopiano (Disabilita)',

  // Handler
  'TITLE_SIGN_OUT': 'Disconnetti',
  'TITLE_SIGNED_IN_AS_FMT': 'Connesso come: {0}',
  'ERR_LOGIN_FMT': 'Errore di accesso: {0}',
  'ERR_LOGIN_INVALID': 'Accesso non corretto',

  // SESSION
  'ERR_NO_SESSION': 'Nessuna sessione create dal server. Vuoi riprovare l\'autenticazione?',
  'MSG_SESSION_WARNING': 'Sei sicuro di voler chiudere OS.js? Ogni settaggio ed ogni dato non salvato andrà perduto!',

  // Service
  'BUGREPORT_MSG': 'Per piacere, fai un report se pensi che questo sia un bug. \nIncludi una breve descrizione di come l\'errore si è verificato, se possibile come replicarlo.',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Connesso al servizio esterno: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Errore Fatale!',
  'ERR_UTILS_XHR_FMT': 'Errore AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Disconetti (Esci)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Disconnessione utente \'{0}\'.\nVuoi salvare la sessinoe corrente?',

  'DIALOG_CLOSE': 'Chiudi',
  'DIALOG_CANCEL': 'Cancella',
  'DIALOG_APPLY': 'Applica',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Attenzione!',

  'DIALOG_COLOR_TITLE': 'Scegli colori',
  'DIALOG_COLOR_R': 'Rosso: {0}',
  'DIALOG_COLOR_G': 'Verde: {0}',
  'DIALOG_COLOR_B': 'Blue: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Conferma scelta',

  'DIALOG_ERROR_MESSAGE': 'Messaggio',
  'DIALOG_ERROR_SUMMARY': 'Sommario',
  'DIALOG_ERROR_TRACE': 'Stack dell\'errore',
  'DIALOG_ERROR_BUGREPORT': 'Segnala Bug',

  'DIALOG_FILE_SAVE': 'Salva',
  'DIALOG_FILE_OPEN': 'Open',
  'DIALOG_FILE_MKDIR': 'Nuova Cartella',
  'DIALOG_FILE_MKDIR_MSG': 'Crea una nuova cartella in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Sei sicuro di voler sovrascrivere il file \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Mostra tipo',
  'DIALOG_FILE_MNU_LISTVIEW': 'Visualizzazione a lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Visualizzazione ad albero',
  'DIALOG_FILE_MNU_ICONVIEW': 'Visualizzazione ad icone',
  'DIALOG_FILE_ERROR': 'FileDialog Errore',
  'DIALOG_FILE_ERROR_SCANDIR': 'Indicizzazione della cartella \'{0}\' fallito, perchè si è verificato un errore!',
  'DIALOG_FILE_ERROR_FIND': 'Ricerca cartella \'{0}\' fallita perchè si è verificato un errore!',
  'DIALOG_FILE_MISSING_FILENAME': 'Devi selezionare un file o fornire un nuovo nome!',
  'DIALOG_FILE_MISSING_SELECTION': 'Devi selezionare un file!',

  'DIALOG_FILEINFO_TITLE': 'Informazioni file',
  'DIALOG_FILEINFO_LOADING': 'Caricamento informazioni file: {0}',
  'DIALOG_FILEINFO_ERROR': 'Errore FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Recupero informazioni fallito **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Recupero infomazioni file fallito: {0}',

  'DIALOG_INPUT_TITLE': 'Richiesta di inserimento',

  'DIALOG_FILEPROGRESS_TITLE': 'Operazione file in corso',
  'DIALOG_FILEPROGRESS_LOADING': 'Caricamento...',

  'DIALOG_UPLOAD_TITLE': 'Caricamento',
  'DIALOG_UPLOAD_DESC': 'Carimento del filo a **{0}**.<br />Dimensione massima: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Caricamento \'{0}\' ({1} {2}) a {3}',
  'DIALOG_UPLOAD_MSG': 'Caricamento file...',
  'DIALOG_UPLOAD_FAILED': 'Caricamento fallito',
  'DIALOG_UPLOAD_FAILED_MSG': 'Il caricamentoè fallito',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Ragione sconociuta...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancellato dall\'utente...',
  'DIALOG_UPLOAD_TOO_BIG': 'Dimensione file troppo grande',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Dimensione del file troppo grande, in eccesso {0}',

  'DIALOG_FONT_TITLE': 'Scelta Font',

  'DIALOG_APPCHOOSER_TITLE': 'Scegli Applicazione',
  'DIALOG_APPCHOOSER_MSG': 'Scegli un applicazione da aprire',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Devi selezionare un applicazione',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Usa l\'applicazione predefinita per {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Modulo GoogleAPI non configurato o disabilitato',
  'GAPI_SIGN_OUT': 'Disconnettiti da Google API Services',
  'GAPI_REVOKE': 'Revoca i permessi e disconnetti',
  'GAPI_AUTH_FAILURE': 'L\'Autenticazione alla Google API fallito o non avvenuto',
  'GAPI_AUTH_FAILURE_FMT': 'Autenticazione fallita: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Caricamento Google API fallito',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module non configurato o disabilitato',
  'WLAPI_SIGN_OUT': 'Disconnetti da  Window Live API',
  'WLAPI_LOAD_FAILURE': 'Caricamento Windows Live API fallito',
  'WLAPI_LOGIN_FAILED': 'Connessione a Windows Live API fallita',
  'WLAPI_LOGIN_FAILED_FMT': 'Connessione a Windows Live API fallito: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returned {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Impossibile creare IndexedDB senza un nome database',
  'IDB_NO_SUCH_ITEM': 'Nessun elemento',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Errore fatale',
  'ERR_VFS_UNAVAILABLE': 'No disponibile',
  'ERR_VFS_FILE_ARGS': 'Il file richiede almeno un argumento',
  'ERR_VFS_NUM_ARGS': 'Non abbastanza argomenti',
  'ERR_VFS_EXPECT_FILE': 'File-object previsto',
  'ERR_VFS_EXPECT_SRC_FILE': 'Sorgente file-object prevista',
  'ERR_VFS_EXPECT_DST_FILE': 'Destinazion file-object prevista',
  'ERR_VFS_FILE_EXISTS': 'Destinazione già esistente',
  'ERR_VFS_TARGET_NOT_EXISTS': 'La destinazione non esiste',
  'ERR_VFS_TRANSFER_FMT': 'Un errore si è verificato durante il trasferimento tra le memorie: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Impossibile caricare un file senza una destinazione',
  'ERR_VFS_UPLOAD_NO_FILES': 'Impossibile caricare senza definire un file',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Carimento file fallito: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Caricamento file cancellato',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Impossibile scaricare una destinazione senza una destinazione',
  'ERR_VFS_DOWNLOAD_FAILED': 'Si è verificato un errore durante il download: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'La risposta era vuota',

  'ERR_VFSMODULE_INVALID': 'Modulo VFS Invalido',
  'ERR_VFSMODULE_INVALID_FMT': 'Modulo VFS Invalido: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Metodo VFS Invalido',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Metodo VFS Invalido: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Modulo VFS tipo non valido',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Modulo VFS tipo non valido: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Modulo VFS configurazione non valida',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Modulo VFS configurazione non valida: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'Modulo VFS già montato',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'Modulo VFS \'{0}\' già montato',
  'ERR_VFSMODULE_NOT_MOUNTED': 'Modulo VFS non montato',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'Modulo VFS \'{0}\' non montato',
  'ERR_VFSMODULE_EXCEPTION': 'Modulo VFS Eccezione',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'Modulo VFS Eccezione: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Nessun modulo VFS associato con {0}. Desinazione o formato sbagliato?',
  'ERR_VFSMODULE_READONLY': 'Questo modulo VFS è di sola lettura',
  'ERR_VFSMODULE_READONLY_FMT': 'Questo modulo VFS è di sola lettura: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Download file',

  'ERR_VFSMODULE_XHR_ERROR': 'Errore XHR',
  'ERR_VFSMODULE_ROOT_ID': 'ID cartella root non trovato',
  'ERR_VFSMODULE_NOSUCH': 'Il file non esiste',
  'ERR_VFSMODULE_PARENT': 'Nessun parente',
  'ERR_VFSMODULE_PARENT_FMT': 'Cartella parente non trovata: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Scansione cartella fallito',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Scansione cartella fallito: {0}',
  'ERR_VFSMODULE_READ': 'Lettura file fallito',
  'ERR_VFSMODULE_READ_FMT': 'Lettura file fallito: {0}',
  'ERR_VFSMODULE_WRITE': 'Scrittura file fallita',
  'ERR_VFSMODULE_WRITE_FMT': 'Scrittura file fallita: {0}',
  'ERR_VFSMODULE_COPY': 'Copiatura fallita',
  'ERR_VFSMODULE_COPY_FMT': 'Copiatura fallita: {0}',
  'ERR_VFSMODULE_UNLINK': 'Unlink file fallito',
  'ERR_VFSMODULE_UNLINK_FMT': 'Unlink file fallito: {0}',
  'ERR_VFSMODULE_MOVE': 'Spostamento file fallito',
  'ERR_VFSMODULE_MOVE_FMT': 'Spostamento file fallito: {0}',
  'ERR_VFSMODULE_EXIST': 'Verifica esistenza file fallita',
  'ERR_VFSMODULE_EXIST_FMT': 'Verifica esistenza file fallita: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Recupero informazioni file fallito',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Recupero informazioni file fallito: {0}',
  'ERR_VFSMODULE_MKDIR': 'Creazione cartella fallito',
  'ERR_VFSMODULE_MKDIR_FMT': 'Creazione cartella fallito: {0}',
  'ERR_VFSMODULE_MKFILE': 'Creazione file fallita',
  'ERR_VFSMODULE_MKFILE_FMT': 'Creazione file fallita: {0}',
  'ERR_VFSMODULE_URL': 'Recupero URL file fallito',
  'ERR_VFSMODULE_URL_FMT': 'Recupero URL file fallito: {0}',
  'ERR_VFSMODULE_TRASH': 'Spostamento file nel cestino fallito',
  'ERR_VFSMODULE_TRASH_FMT': 'Spostamento file nel cestino fallito: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Spostamento del file fuori dal cestino fallito',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Spostamento del file fuori dal cestino fallito: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Svuotamento cestino fallito',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Svuotamento cestino fallito: {0}',
  'ERR_VFSMODULE_FIND': 'Ricerca fallita',
  'ERR_VFSMODULE_FIND_FMT': 'Ricerca fallita: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Allocamento spazio libero fallito',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Allocamento spazio libero fallito: {0}',
  'ERR_VFSMODULE_EXISTS': 'Verifica esistenza fallito',
  'ERR_VFSMODULE_EXISTS_FMT': 'Verifica esistenza fallito: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Sei connesso a Dropbox API',
  'DROPBOX_SIGN_OUT': 'Disconnetti Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Risoluzione percorso fallita: elemento non trovato',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Caricamento zip.js fallito',
  'ZIP_VENDOR_FAIL': 'Libreria zip.js non trovata. L\'hai caricata correttamente?',
  'ZIP_NO_RESOURCE': 'Nessuna risorsa zip fornita',
  'ZIP_NO_PATH': 'Nessun percorso fornito',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Ricerca in corso...',
  'SEARCH_NO_RESULTS': 'Nessun risultato trovato',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Percorso installazione pacchetto gia esistente. Impossibile continuare!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Impossibile aprire il file',
  'ERR_FILE_APP_OPEN_FMT': 'Impossibile aprire il file {0} perchè il mime {1} non è supportato',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Impossibile aprire il file {0}: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Impossibile salvare il file {0}: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Application Error',
  'ERR_GENERIC_APP_ACTION_FMT': 'Esecuzione azione fallito \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Errore sconosciuto',
  'ERR_GENERIC_APP_REQUEST': 'Si è verificato un errore durante la risoluzione della richiesta',
  'ERR_GENERIC_APP_FATAL_FMT': 'Errore fatale: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Scarta cambiamenti?',
  'MSG_FILE_CHANGED': 'Il file è stato cambiato. Ricaricarlo?',
  'MSG_APPLICATION_WARNING': 'Avviso applicazione',
  'MSG_MIME_OVERRIDE': 'tipo del file "{0}" non supportato, si userà "{1}" al suo posto.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Sconosciuto',
  'LBL_APPEARANCE': 'Aspetto',
  'LBL_USER': 'Utente',
  'LBL_NAME': 'Nome',
  'LBL_APPLY': 'Applica',
  'LBL_FILENAME': 'Nome file',
  'LBL_PATH': 'Percorso',
  'LBL_SIZE': 'Dimensione',
  'LBL_TYPE': 'Tipo',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Caricamento',
  'LBL_SETTINGS': 'Settaggi',
  'LBL_ADD_FILE': 'Aggiungi file',
  'LBL_COMMENT': 'Commenta',
  'LBL_ACCOUNT': 'Account',
  'LBL_CONNECT': 'Connetti',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Non presente',
  'LBL_BUSY': 'Occupato',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Aiuto',
  'LBL_ABOUT': 'Riguardo a',
  'LBL_PANELS': 'Pannelli',
  'LBL_LOCALES': 'Localizzazioni',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Colore',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Terminal (kill)',
  'LBL_ALIVE': 'Mantieni (Alive)',
  'LBL_INDEX': 'Indice',
  'LBL_ADD': 'Aggiungi',
  'LBL_FONT': 'Font',
  'LBL_YES': 'Si',
  'LBL_NO': 'No',
  'LBL_CANCEL': 'Cancella',
  'LBL_TOP': 'Sopra',
  'LBL_LEFT': 'Sinistra',
  'LBL_RIGHT': 'Destra',
  'LBL_BOTTOM': 'Sotto',
  'LBL_CENTER': 'Centro',
  'LBL_FILE': 'File',
  'LBL_NEW': 'Nuovo',
  'LBL_OPEN': 'Apri',
  'LBL_SAVE': 'Salva',
  'LBL_SAVEAS': 'Salva come...',
  'LBL_CLOSE': 'Chiudi',
  'LBL_MKDIR': 'Crea cartella',
  'LBL_UPLOAD': 'Carica',
  'LBL_VIEW': 'Visualizza',
  'LBL_EDIT': 'Modifica',
  'LBL_RENAME': 'Rinomina',
  'LBL_DELETE': 'Cancella',
  'LBL_OPENWITH': 'Apri con...',
  'LBL_ICONVIEW': 'Visualizzazione ad Icone',
  'LBL_TREEVIEW': 'Visualizzazione ad Albero',
  'LBL_LISTVIEW': 'Visualizzazione ad Lista',
  'LBL_REFRESH': 'Aggiorna',
  'LBL_VIEWTYPE': 'Visualizza tipo',
  'LBL_BOLD': 'Grassetto',
  'LBL_ITALIC': 'Corsivo',
  'LBL_UNDERLINE': 'Sottolineato',
  'LBL_REGULAR': 'Regolare',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Indenta',
  'LBL_OUTDENT': 'Unindenta',
  'LBL_UNDO': 'Torna indietro',
  'LBL_REDO': 'Vai avanti',
  'LBL_CUT': 'Taglia',
  'LBL_UNLINK': 'Rimuovi link',
  'LBL_COPY': 'Copia',
  'LBL_PASTE': 'Incolla',
  'LBL_INSERT': 'Inserisci',
  'LBL_IMAGE': 'Immaggine',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Disconnetti',
  'LBL_APPLICATIONS': 'Applicazioni',
  'LBL_ADD_FOLDER': 'Aggiungi cartella',
  'LBL_INFORMATION': 'Informazione',
  'LBL_TEXT_COLOR': 'Colore testo',
  'LBL_BACK_COLOR': 'Colore in secondo piano',
  'LBL_RESET_DEFAULT': 'Resetta ai valori predefiniti',
  'LBL_DOWNLOAD_COMP': 'Scarica sul computer',
  'LBL_ORDERED_LIST': 'Lista ordinata',
  'LBL_BACKGROUND_IMAGE': 'Immagine di sfondo',
  'LBL_BACKGROUND_COLOR': 'Colore di sfondo',
  'LBL_UNORDERED_LIST': 'Lista non ordinata',
  'LBL_STATUS': 'Stato',
  'LBL_READONLY': 'Di sola lettura',
  'LBL_CREATED': 'Creato',
  'LBL_MODIFIED': 'Modificato',
  'LBL_SHOW_COLUMNS': 'Mostra colonne',
  'LBL_MOVE': 'Muovi',
  'LBL_OPTIONS': 'Opzioni',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Cartella',
  'LBL_CREATE': 'Crea',
  'LBL_BUGREPORT': 'Segnalazione bug',
  'LBL_INSTALL': 'Installa',
  'LBL_UPDATE': 'Aggiorna',
  'LBL_REMOVE': 'Rimuovi',
  'LBL_SHOW_SIDEBAR': 'Mostra barra laterale',
  'LBL_SHOW_NAVIGATION': 'Mostra navigazione',
  'LBL_SHOW_HIDDENFILES': 'Mostra file nascosti',
  'LBL_SHOW_FILEEXTENSIONS': 'Mostra le estenzioni dei file',
  'LBL_MOUNT': 'Monta',
  'LBL_DESCRIPTION': 'Descrizione',
  'LBL_USERNAME': 'Nome utente',
  'LBL_PASSWORD': 'Password',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_SEARCH': 'Ricerca',
  'LBL_SOUNDS': 'Suoni',
  'LBL_ICONS': 'Icone',
  'LBL_ICON': 'Icona',
  'LBL_BACKGROUND': 'Sfondo',
  'LBL_DESKTOP': 'Scrivania',
  'LBL_PANEL': 'Panello',
  'LBL_POSITION': 'Posizione',
  'LBL_ONTOP': 'In primo piano',
  'LBL_ITEMS': 'Elementi',
  'LBL_GENERAL': 'Generale',
  'LBL_DEBUG': 'Risoluzione errori',
  'LBL_AUTOHIDE': 'Nascondi automaticamente',
  'LBL_OPACITY': 'Opacità',
  'LBL_PACKAGES': 'Pacchetti',
  'LBL_PACKAGE': 'Pacchetto',
  'LBL_GROUPS': 'Gruppi',
  'LBL_VERSION': 'Versione',
  'LBL_AUTHOR': 'Autore',
  'LBL_HIDE': 'Nascondi',
  'LBL_BACK': 'Indietro',
  'LBL_UNINSTALL': 'Disinstalla',
  'LBL_REGENERATE': 'Rigenera',
  'LBL_WINDOWMANAGER': 'Gestore Finestre Desktop',
  'LBL_HOTKEY': 'Tasto rapido',
  'LBL_HOTKEYS': 'Tasti rapidi',
  'LBL_MOUNTS': 'Monta',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Applicazione',
  'LBL_SCOPE': 'Scope',
  'LBL_REPOSITORY': 'Repository',
  'LBL_PERSONAL': 'Personale',
  'LBL_SYSTEM': 'Sistema',
  'LBL_STARTING': 'Avvio',
  'LBL_STORE': 'Store',
  'LBL_LOCALE': 'Lingue',
  'LBL_INPUT': 'Input',
  'LBL_MISC': 'Vari',
  'LBL_OTHER': 'Altro',
  'LBL_USERS': 'Utenti',
  'LBL_FONTS': 'Fonts',
  'LBL_OPEN_LOCATION': 'Apri percorso',
  'LBL_HOME': 'Cartella Home',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_LOCK': 'Bloccare',
  'LBL_UNLOCK': 'Sbloccare'
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': '파일을 열 수 없습니다',
  'ERR_WM_NOT_RUNNING': '윈도우 관리자가 실행 중이지 않습니다',
  'ERR_FILE_OPEN_FMT': '\'**{0}**\' 파일을 실행할 수 없습니다',
  'ERR_APP_MIME_NOT_FOUND_FMT': '\'{0}\' 파일을 실행할 수 있는 응용 프로그램을 찾을 수 없습니다',
  'ERR_APP_LAUNCH_FAILED': '응용 프로그램을 실행할 수 없습니다',
  'ERR_APP_LAUNCH_FAILED_FMT': '{0}을(를) 실행할 수 없습니다',
  'ERR_APP_CONSTRUCT_FAILED_FMT': '응용 프로그램 \'{0}\'을 준비할 수 없습니다: {1}',
  'ERR_APP_INIT_FAILED_FMT': '응용 프로그램  \'{0}\'을 초기화할 수 없습니다: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': '응용 프로그램 \'{0}\' 리소스를 찾을 수 없거나 로드할 수 없습니다!',
  'ERR_APP_PRELOAD_FAILED_FMT': '응용 프로그램 \'{0}\'을 준비할 수 없습니다: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '\'{0}\'은(는) 이미 실행중이며 하나의 인스턴스만 허용됩니다!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '\'{0}\'을(를) 실행할 수 없습니다. 응용 프로그램 manifest 데이터를 찾을 수 없습니다!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': '\'{0}\'을(를) 실행할 수 없습니다. 사용중인 웹브라우저가 다음 기능을 지원하지 않습니다: {1}',

  'ERR_NO_WM_RUNNING': '윈도우 관리자가 실행 중이지 않습니다',
  'ERR_CORE_INIT_FAILED': 'OS.js를 초기화할 수 없습니다',
  'ERR_CORE_INIT_FAILED_DESC': 'OS.js를 초기화하던 중 오류가 발생했습니다',
  'ERR_CORE_INIT_NO_WM': 'OS.js를 실행할 수 없습니다: 윈도우 관리자가 정의되지 않았습니다!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js를 실행할 수 없습니다: 윈도우 관리자를 실행할 수 없습니다: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'OS.js를 실행할 수 없습니다: 리소스를 준비할 수 없습니다...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript 오류 보고서',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': '오류가 발생했습니다. 버그일 수 있습니다',

  'ERR_APP_API_ERROR': '응용 프로그램 API 오류',
  'ERR_APP_API_ERROR_DESC_FMT': '응용 프로그램 {0}이 명령을 실행할 수 없습니다\'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': '누락된 매개변수: {0}',
  'ERR_APP_UNKNOWN_ERROR': '알 수 없는 오류입니다',

  'ERR_OPERATION_TIMEOUT': '시간초과',
  'ERR_OPERATION_TIMEOUT_FMT': '시간초과 ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\'에서 \'{1}\'는 \'{2}\'이 되어야 하나 \'{3}\'가 주어졌습니다',

  // Window
  'ERR_WIN_DUPLICATE_FMT': '이미 \'{0}\' 창이 있습니다',
  'WINDOW_MINIMIZE': '최소화',
  'WINDOW_MAXIMIZE': '최대화',
  'WINDOW_RESTORE': '이전 크기로',
  'WINDOW_CLOSE': '닫기',
  'WINDOW_ONTOP_ON': '위로 (활성화)',
  'WINDOW_ONTOP_OFF': '위로 (비활성화)',

  // Handler
  'TITLE_SIGN_OUT': '로그아웃',
  'TITLE_SIGNED_IN_AS_FMT': '{0}(으)로 로그인',
  'ERR_LOGIN_FMT': '로그인 오류: {0}',
  'ERR_LOGIN_INVALID': '비정상 로그인',

  // SESSION
  'MSG_SESSION_WARNING': 'OS.js를 정말 종료하시겠습니까? 저장하지 않은 설정과 응용 프로그램 데이터가 손실될 수 있습니다!',

  // Service
  'BUGREPORT_MSG': '버그라고 생각되면 보고해주십시요.\n오류가 어떻게 발생했는지 간단한 설명을 해주십시요. 가능하다면 재현 상황을 설명해주십시요',

  // API
  'SERVICENOTIFICATION_TOOLTIP': '{0}(으)로 외부 서비스 로그인',

  // Utils
  'ERR_UTILS_XHR_FATAL': '심각한 오류',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR 오류: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': '로그아웃 (종료)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': '\'{0}\' 사용자 로그아웃.\n현재 세션을 저장하시겠습니까?',

  'DIALOG_CLOSE': '닫기',
  'DIALOG_CANCEL': '취소',
  'DIALOG_APPLY': '적용',
  'DIALOG_OK': '확인',

  'DIALOG_ALERT_TITLE': '알림 다이얼로그',

  'DIALOG_COLOR_TITLE': '색상 다이얼로그',
  'DIALOG_COLOR_R': '빨강: {0}',
  'DIALOG_COLOR_G': '초록: {0}',
  'DIALOG_COLOR_B': '파랑: {0}',
  'DIALOG_COLOR_A': '투명: {0}',

  'DIALOG_CONFIRM_TITLE': '확인 다이얼로그',

  'DIALOG_ERROR_MESSAGE': '메시지',
  'DIALOG_ERROR_SUMMARY': '요약',
  'DIALOG_ERROR_TRACE': '추적',
  'DIALOG_ERROR_BUGREPORT': '오류 보고',

  'DIALOG_FILE_SAVE': '저장',
  'DIALOG_FILE_OPEN': '열기',
  'DIALOG_FILE_MKDIR': '디렉토리 생성',
  'DIALOG_FILE_MKDIR_MSG': '**{0}**에 디렉토리 생성',
  'DIALOG_FILE_OVERWRITE': '정말 \'{0}\'을 덮어쓰시겠습니까?',
  'DIALOG_FILE_MNU_VIEWTYPE': '보기 타입',
  'DIALOG_FILE_MNU_LISTVIEW': '자세히 보기',
  'DIALOG_FILE_MNU_TREEVIEW': '간단히 보기',
  'DIALOG_FILE_MNU_ICONVIEW': '아이콘으로 보기',
  'DIALOG_FILE_ERROR': '파일 다이얼로그 오류',
  'DIALOG_FILE_ERROR_SCANDIR': '오류가 발생했습니다. \'{0}\' 폴더를 불러올 수 없습니다',
  'DIALOG_FILE_MISSING_FILENAME': '파일을 선택하거나 새로운 파일 이름을 입력해주십시요!',
  'DIALOG_FILE_MISSING_SELECTION': '파일을 선택해야 합니다!',

  'DIALOG_FILEINFO_TITLE': '파일 정보',
  'DIALOG_FILEINFO_LOADING': '파일 정보를 불러오는 중: {0}',
  'DIALOG_FILEINFO_ERROR': '파일 정보 다이얼로그 오류',
  'DIALOG_FILEINFO_ERROR_LOOKUP': '파일 정보를 가져올 수 없습니다 **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': '파일 정보를 가져올 수 없습니다: {0}',

  'DIALOG_INPUT_TITLE': '입력 다이얼로그',

  'DIALOG_FILEPROGRESS_TITLE': '파일 명령 처리',
  'DIALOG_FILEPROGRESS_LOADING': '처리 중...',

  'DIALOG_UPLOAD_TITLE': '업로드 다이얼로그',
  'DIALOG_UPLOAD_DESC': '**{0}**에 파일 업로드.<br />최대 용량: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': '\'{0}\' ({1} {2})을(를) {3}에 업로드 중',
  'DIALOG_UPLOAD_MSG': '파일을 업로드 중...',
  'DIALOG_UPLOAD_FAILED': '업로드 실패',
  'DIALOG_UPLOAD_FAILED_MSG': '업로드에 실패했습니다',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': '알 수 없는 오류...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': '사용자에 의해 취소...',
  'DIALOG_UPLOAD_TOO_BIG': '파일이 너무 큽니다',
  'DIALOG_UPLOAD_TOO_BIG_FMT': '파일이 너무 큽니다, {0} 초과',

  'DIALOG_FONT_TITLE': '글꼴 다이얼로그',

  'DIALOG_APPCHOOSER_TITLE': '응용 프로그램 선택',
  'DIALOG_APPCHOOSER_MSG': '열려는 응용 프로그램을 선택해주십시요',
  'DIALOG_APPCHOOSER_NO_SELECTION': '응용 프로그램을 선택해야 합니다',
  'DIALOG_APPCHOOSER_SET_DEFAULT': '{0}을(를) 기본 응용 프로그램으로 설정',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI 모듈이 설정되지 않았거나 사용할 수 없습니다',
  'GAPI_SIGN_OUT': 'Google API 서비스에서 로그아웃',
  'GAPI_REVOKE': '권한을 해제하고 로그아웃',
  'GAPI_AUTH_FAILURE': 'Google API 인증에 실패했습니다',
  'GAPI_AUTH_FAILURE_FMT': '인증에 실패: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Google API 로드 실패',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API 모듈이 설정되지 않았거나 사용할 수 없습니다',
  'WLAPI_SIGN_OUT': 'Window Live API 서비스에서 로그아웃',
  'WLAPI_LOAD_FAILURE': 'Windows Live API 로드 실패',
  'WLAPI_LOGIN_FAILED': 'Windows Live API에 로그인 실패',
  'WLAPI_LOGIN_FAILED_FMT': 'Windows Live API에 로그인 실패: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API가 {0} 상태를 반환했습니다',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Database의 이름 없이는 IndexedDB를 생성할 수 없습니다',
  'IDB_NO_SUCH_ITEM': '찾을 수 없습니다',

  //
  // VFS
  //
  'ERR_VFS_FATAL': '심각한 오류',
  'ERR_VFS_UNAVAILABLE': '사용할 수 없음',
  'ERR_VFS_FILE_ARGS': '적어도 하나의 매개변수가 필요합니다',
  'ERR_VFS_NUM_ARGS': '매개변수가 충분하지 않습니다',
  'ERR_VFS_EXPECT_FILE': '파일 객체가 필요합니다',
  'ERR_VFS_EXPECT_SRC_FILE': '원본 파일 객체가 필요합니다',
  'ERR_VFS_EXPECT_DST_FILE': '대상 파일 객체가 필요합니다',
  'ERR_VFS_FILE_EXISTS': '대상 파일이 이미 존재합니다',
  'ERR_VFS_TRANSFER_FMT': '저장소 간 파일을 이동하는 중 오류가 발생했습니다: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': '파일을 업로드하려면 대상을 선택해주십시요',
  'ERR_VFS_UPLOAD_NO_FILES': '업로드하려는 파일을 선택해주십시요',
  'ERR_VFS_UPLOAD_FAIL_FMT': '파일을 업로드하는데 실패했습니다: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': '파일 업로드가 취소되었습니다',
  'ERR_VFS_DOWNLOAD_NO_FILE': '경로 없이 경로를 다운로드할 수 없습니다',
  'ERR_VFS_DOWNLOAD_FAILED': '다운로드 중 오류가 발생하였습니다: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': '응답이 비어있습니다',

  'ERR_VFSMODULE_INVALID': '유효하지 않은 VFS 모듈',
  'ERR_VFSMODULE_INVALID_FMT': '유효하지 않은 VFS 모듈: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': '유효하지 않은 VFS 메소드',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': '유효하지 않은 VFS 메소드: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': '유효하지 않은 VFS 모듈 타입',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': '유효하지 않은 VFS 모듈 타입: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': '유효하지 않은 VFS 모듈 설정',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': '유효하지 않은 VFS 모듈 설정: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS 모듈이 이미 마운트 되었습니다',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS 모듈 \'{0}\' 이(가) 이미 마운트 되었습니다',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS 모듈이 마운트 되지 않았습니다',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS 모듈 \'{0}\' 이(가) 마운트 되지 않았습니다',
  'ERR_VFSMODULE_EXCEPTION': 'VFS 모듈 예외 발생',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS 모듈 예외 발생: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': '{0}와 같은 VFS 모듈이 존재하지 않습니다. 잘못된 경로나 형식일 수 있습니다',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': '파일 다운로드',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR 오류',
  'ERR_VFSMODULE_ROOT_ID': '최상위 디렉토리 id를 찾을 수 없습니다',
  'ERR_VFSMODULE_NOSUCH': '파일이 존재하지 않습니다',
  'ERR_VFSMODULE_PARENT': '부모를 찾을 수 없습니다',
  'ERR_VFSMODULE_PARENT_FMT': '부모를 찾을 수 없습니다: {0}',
  'ERR_VFSMODULE_SCANDIR': '디렉토리 불러오기 실패',
  'ERR_VFSMODULE_SCANDIR_FMT': '디렉토리를 불러올 수 없습니다: {0}',
  'ERR_VFSMODULE_READ': '파일 읽기 실패',
  'ERR_VFSMODULE_READ_FMT': '파일을 읽을 수 없습니다: {0}',
  'ERR_VFSMODULE_WRITE': '파일 생성 실패',
  'ERR_VFSMODULE_WRITE_FMT': '파일을 생성할 수 없습니다: {0}',
  'ERR_VFSMODULE_COPY': '복사 실패',
  'ERR_VFSMODULE_COPY_FMT': '복사할 수 없습니다: {0}',
  'ERR_VFSMODULE_UNLINK': '바로가기 해제',
  'ERR_VFSMODULE_UNLINK_FMT': '바로가기를 해제할 수 없습니다: {0}',
  'ERR_VFSMODULE_MOVE': '파일 이동 실패',
  'ERR_VFSMODULE_MOVE_FMT': '파일을 이동할 수 없습니다: {0}',
  'ERR_VFSMODULE_EXIST': '파일 존재 여부 확인',
  'ERR_VFSMODULE_EXIST_FMT': '파일이 존재하는지 확인할 수 없습니다: {0}',
  'ERR_VFSMODULE_FILEINFO': '파일 정보 조회 실패',
  'ERR_VFSMODULE_FILEINFO_FMT': '파일 정보를 읽을 수 없습니다: {0}',
  'ERR_VFSMODULE_MKDIR': '디렉토리 생성 실패',
  'ERR_VFSMODULE_MKDIR_FMT': '디렉토리를 생성할 수 없습니다: {0}',
  'ERR_VFSMODULE_URL': '파일 경로 찾기 실패',
  'ERR_VFSMODULE_URL_FMT': '파일의 경로를 찾을 수 없습니다: {0}',
  'ERR_VFSMODULE_TRASH': '휴지통으로 보내기 실패',
  'ERR_VFSMODULE_TRASH_FMT': '휴지통으로 보낼 수 없습니다: {0}',
  'ERR_VFSMODULE_UNTRASH': '휴지통 복원 실패',
  'ERR_VFSMODULE_UNTRASH_FMT': '휴지통에서 복원할 수 없습니다: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': '휴지통 비우기 실패',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': '휴지통을 비울 수 없습니다: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Dropbox API에 가입되어 있습니다',
  'DROPBOX_SIGN_OUT': 'Google API Services에서 로그아웃',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': '경로 탐색 실패: 항목을 찾을 수 없습니다',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'zip.js를 불러오는 데 실패하였습니다',
  'ZIP_VENDOR_FAIL': 'zip.js 라이브러리를 찾을 수 없습니다. 올바른 방법으로 불러왔는지 확인해주십시오',
  'ZIP_NO_RESOURCE': 'zip 리소스가 주어지지 않았습니다',
  'ZIP_NO_PATH': '경로가 주어지지 않았습니다',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': '패키지 설치 디렉토리가 이미 존재하여 설치를 계속 할 수 없습니다!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': '파일을 열 수 없습니다',
  'ERR_FILE_APP_OPEN_FMT': '마임(MIME) {1} 이(가) 지원되지 않아 파일 {0} 을(를) 열지 못했습니다',
  'ERR_FILE_APP_OPEN_ALT_FMT': '파일 {0} 을(를) 열지 못했습니다: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': '파일 {0} 을(를) 저장하지 못했습니다: {1}',
  'ERR_GENERIC_APP_FMT': '{0} 응용 프로그램 오류',
  'ERR_GENERIC_APP_ACTION_FMT': '\'{0}\' 수행에 실패하였습니다',
  'ERR_GENERIC_APP_UNKNOWN': '알 수 없는 오류',
  'ERR_GENERIC_APP_REQUEST': '명령을 처리하는 도중 오류가 발생하였습니다',
  'ERR_GENERIC_APP_FATAL_FMT': '치명적인 오류: {0}',
  'MSG_GENERIC_APP_DISCARD': '변경사항을 저장하지 않겠습니까?',
  'MSG_FILE_CHANGED': '파일이 변경되었습니다. 새로고침 하시겠습니까?',
  'MSG_APPLICATION_WARNING': '응용 프로그램 경고',
  'MSG_MIME_OVERRIDE': '파일 타입 "{0}" 은(는) 지원되지 않습니다, "{1}" (으)로 대신합니다',

  //
  // General
  //

  'LBL_UNKNOWN': '알수없음',
  'LBL_APPEARANCE': '모양',
  'LBL_USER': '사용자',
  'LBL_NAME': '이름',
  'LBL_APPLY': '적용',
  'LBL_FILENAME': '파일명',
  'LBL_PATH': '경로',
  'LBL_SIZE': '크기',
  'LBL_TYPE': '타입',
  'LBL_MIME': '마임(MIME)',
  'LBL_LOADING': '로딩',
  'LBL_SETTINGS': '설정',
  'LBL_ADD_FILE': '파일 추가',
  'LBL_COMMENT': '댓글',
  'LBL_ACCOUNT': '계정',
  'LBL_CONNECT': '연결',
  'LBL_ONLINE': '온라인',
  'LBL_OFFLINE': '오프라인',
  'LBL_AWAY': '부재중',
  'LBL_BUSY': '바쁨',
  'LBL_CHAT': '채팅',
  'LBL_HELP': '도움말',
  'LBL_ABOUT': '정보',
  'LBL_PANELS': '패널',
  'LBL_LOCALES': '지역',
  'LBL_THEME': '테마',
  'LBL_COLOR': '색상',
  'LBL_PID': '프로세스 ID',
  'LBL_KILL': '종료',
  'LBL_ALIVE': '활성',
  'LBL_INDEX': '인덱스',
  'LBL_ADD': '추가',
  'LBL_FONT': '글꼴',
  'LBL_YES': '예',
  'LBL_NO': '아니오',
  'LBL_CANCEL': '취소',
  'LBL_TOP': '위',
  'LBL_LEFT': '왼쪽',
  'LBL_RIGHT': '오른쪽',
  'LBL_BOTTOM': '아래',
  'LBL_CENTER': '가운데',
  'LBL_FILE': '파일',
  'LBL_NEW': '새로 만들기',
  'LBL_OPEN': '열기',
  'LBL_SAVE': '저장',
  'LBL_SAVEAS': '다른 이름으로 저장',
  'LBL_CLOSE': '닫기',
  'LBL_MKDIR': '디렉토리 생성',
  'LBL_UPLOAD': '업로드',
  'LBL_VIEW': '보기',
  'LBL_EDIT': '편집',
  'LBL_RENAME': '이름 변경',
  'LBL_DELETE': '삭제',
  'LBL_OPENWITH': '다른 프로그램으로 열기',
  'LBL_ICONVIEW': '아이콘으로 보기',
  'LBL_TREEVIEW': '트리로 보기',
  'LBL_LISTVIEW': '리스트로 보기',
  'LBL_REFRESH': '새로고침',
  'LBL_VIEWTYPE': '보기 방식',
  'LBL_BOLD': '굵게',
  'LBL_ITALIC': '이탤릭체',
  'LBL_UNDERLINE': '밑줄',
  'LBL_REGULAR': '일반',
  'LBL_STRIKE': '취소선',
  'LBL_INDENT': '들여쓰기',
  'LBL_OUTDENT': '내어쓰기',
  'LBL_UNDO': '실행 취소',
  'LBL_REDO': '다시 실행',
  'LBL_CUT': '잘라내기',
  'LBL_UNLINK': '링크 해제',
  'LBL_COPY': '복사',
  'LBL_PASTE': '붙여넣기',
  'LBL_INSERT': '삽입',
  'LBL_IMAGE': '이미지',
  'LBL_LINK': '링크',
  'LBL_DISCONNECT': '연결 해제',
  'LBL_APPLICATIONS': '응용 프로그램',
  'LBL_ADD_FOLDER': '폴더 추가',
  'LBL_INFORMATION': '정보',
  'LBL_TEXT_COLOR': '글자색',
  'LBL_BACK_COLOR': '배경색',
  'LBL_RESET_DEFAULT': '기본값으로 복원',
  'LBL_DOWNLOAD_COMP': '컴퓨터로 다운로드',
  'LBL_ORDERED_LIST': '정렬 된 리스트',
  'LBL_BACKGROUND_IMAGE': '배경 이미지',
  'LBL_BACKGROUND_COLOR': '배경 색상',
  'LBL_UNORDERED_LIST': '정렬 되지 않은 리스트',
  'LBL_STATUS': '상태',
  'LBL_READONLY': '읽기 전용',
  'LBL_CREATED': '생성됨',
  'LBL_MODIFIED': '수정됨',
  'LBL_SHOW_COLUMNS': '열 보기',
  'LBL_MOVE': '이동',
  'LBL_OPTIONS': '옵션',
  'LBL_OK': '확인',
  'LBL_DIRECTORY': '디렉토리',
  'LBL_CREATE': '생성',
  'LBL_BUGREPORT': '버그 리포트',
  'LBL_INSTALL': '설치',
  'LBL_UPDATE': '수정',
  'LBL_REMOVE': '제거',
  'LBL_SHOW_SIDEBAR': '사이드바 보이기',
  'LBL_SHOW_NAVIGATION': '네비게이션 보이기',
  'LBL_SHOW_HIDDENFILES': '숨긴 파일 보이기',
  'LBL_SHOW_FILEEXTENSIONS': '파일 확장자 보이기',
  'LBL_MOUNT': '마운트',
  'LBL_DESCRIPTION': '설명',
  'LBL_USERNAME': '사용자 이름',
  'LBL_PASSWORD': '비밀번호',
  'LBL_HOST': '호스트',
  'LBL_NAMESPACE': '네임스페이스',
  'LBL_BACKGROUND': '바탕화면',
  'LBL_DESKTOP': '데스크탑',
  'LBL_PANEL': '패널',
  'LBL_POSITION': '위치',
  'LBL_ONTOP': '상단바 자리 차지',
  'LBL_ITEMS': '항목',
  'LBL_GENERAL': '일반',
  'LBL_SOUNDS': '소리',
  'LBL_ICONS': '아이콘',
  'LBL_DEBUG': '디버그',
  'LBL_AUTOHIDE': '자동 숨기기',
  'LBL_OPACITY': '투명도',
  'LBL_PACKAGES': '패키지',
  'LBL_GROUPS': '그룹',
  'LBL_VERSION': '버전',
  'LBL_AUTHOR': '작성자',
  'LBL_Hide': '숨기기',
  'LBL_APPLICATION': '어플리케이션',
  'LBL_SCOPE': '범위',
  'LBL_SEARCH': '검색'
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 * Dutch translation by Imre Biacsics
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Fout bij openen bestand',
  'ERR_WM_NOT_RUNNING': 'Window manager is niet gestart',
  'ERR_FILE_OPEN_FMT': 'Het bestand \'**{0}**\' kon niet worden geopend',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Kon geen programma vinden die \'{0}\' kan openen',
  'ERR_APP_LAUNCH_FAILED': 'Starten van het programma is mislukt',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Er is een probleem opgetreden tijden het starten van: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Toepassing \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Toepassing \'{0}\' init() failed: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Toepassing bronnen ontbreken \'{0}\' of kon niet laden!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Toepassing \'{0}\' preload niet geslaagd: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'De toepassing \'{0}\' is al gestart en staat geen tweede instantie toe!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Starten van \'{0}\' is niet geslaagd. Application manifest data niet gevonden!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Starteb van \'{0}\' is niet geslaagd. De browser wordt niet ondersteund: {1}',

  'ERR_NO_WM_RUNNING': 'Window manager is niet gestart',
  'ERR_CORE_INIT_FAILED': 'Initialisatie van OS.js mislukt',
  'ERR_CORE_INIT_FAILED_DESC': 'Er is een fout opgetreden tijdens de initialisatie van OS.js',
  'ERR_CORE_INIT_NO_WM': 'Kan OS.js niet starten: Geen window manager gedefineerd!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Kan OS.js niet starten: Window manager: {0} wil niet starten',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Kan OS.js niet starten: Fout bij het voorladen van bronnen...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Fout Rapportage',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Een onverwachte fout opgetreden, mogelijk een bug.',

  'ERR_APP_API_ERROR': 'Applicatie API fout',
  'ERR_APP_API_ERROR_DESC_FMT': 'Applicatie {0} Kan actie \'{1}\' niet uitvoeren',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Missend argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Onbekende fout',

  'ERR_OPERATION_TIMEOUT': 'Operatie Timeout',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operatie Timeout ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' verwacht dat \'{1}\' een \'{2}\' is, niet \'{3}\'',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Er is al een venster met de naam: \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimaliseren',
  'WINDOW_MAXIMIZE': 'Maximaliseren',
  'WINDOW_RESTORE': 'Herstellen',
  'WINDOW_CLOSE': 'Sluiten',
  'WINDOW_ONTOP_ON': 'Naar voorgrond (Aan)',
  'WINDOW_ONTOP_OFF': 'Naar voorgrond (Uit)',

  // Handler
  'TITLE_SIGN_OUT': 'Afmelden',
  'TITLE_SIGNED_IN_AS_FMT': 'Aangemeld als: {0}',
  'ERR_LOGIN_FMT': 'Login fout: {0}',
  'ERR_LOGIN_INVALID': 'Onjuiste aanmelding',

  // SESSION
  'MSG_SESSION_WARNING': 'Weet je zeker dat je OS.js wilt verlaten? Alle niet opgeslagen instellingen en applicatie data zal verloren gaan!',

  // Service
  'BUGREPORT_MSG': 'Vriendelijk verzoek dit probleem te rapporteren.\nVoeg een korte omschrijving toe en als het lukt; Hoe we dit kunnen nabootsen',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Aangemeld bij externe service: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatale Fout',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Fout: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Afmelden', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': ' \'{0}\'.\nWilt u deze sessie opslaan?',

  'DIALOG_CLOSE': 'Sluiten',
  'DIALOG_CANCEL': 'Annuleren',
  'DIALOG_APPLY': 'Bevestigen',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Waarschuwing',

  'DIALOG_COLOR_TITLE': 'Kleuren',
  'DIALOG_COLOR_R': 'Rood: {0}',
  'DIALOG_COLOR_G': 'Groen: {0}',
  'DIALOG_COLOR_B': 'Blauw: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Bevestiging',

  'DIALOG_ERROR_MESSAGE': 'Bericht',
  'DIALOG_ERROR_SUMMARY': 'Opsomming',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Fouten rapport',

  'DIALOG_FILE_SAVE': 'Opslaan',
  'DIALOG_FILE_OPEN': 'Openen',
  'DIALOG_FILE_MKDIR': 'Nieuwe map',
  'DIALOG_FILE_MKDIR_MSG': 'Maak nieuwe map in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Weet u zeker dat het bestand \'{0}\' overschreven moet worden?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Weergave',
  'DIALOG_FILE_MNU_LISTVIEW': 'Lijst weergave',
  'DIALOG_FILE_MNU_TREEVIEW': 'Boom weergave',
  'DIALOG_FILE_MNU_ICONVIEW': 'Icoontje',
  'DIALOG_FILE_ERROR': 'BestandsDialoog Fout',
  'DIALOG_FILE_ERROR_SCANDIR': 'Kan de map niet doorzoeken \'{0}\' Er is een storing opgetreden',
  'DIALOG_FILE_MISSING_FILENAME': 'Selecteer een bestand of geef een naam op!',
  'DIALOG_FILE_MISSING_SELECTION': 'Selecteer een bestand!',

  'DIALOG_FILEINFO_TITLE': 'Bestands informatie',
  'DIALOG_FILEINFO_LOADING': 'Bestands informatie laden van: {0}',
  'DIALOG_FILEINFO_ERROR': 'Bestanda informatie Fout',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Ophalen van informatie van **{0}** is mislukt',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Ophalen van informatie van: {0} is mislukt',

  'DIALOG_INPUT_TITLE': 'Input Dialoog',

  'DIALOG_FILEPROGRESS_TITLE': 'Voortgang',
  'DIALOG_FILEPROGRESS_LOADING': 'Laden...',

  'DIALOG_UPLOAD_TITLE': 'Upload Dialoog',
  'DIALOG_UPLOAD_DESC': 'Upload bestand naar **{0}**.<br />Maximum grootte: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Bezig met uploaden \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Bezig met uploaden...',
  'DIALOG_UPLOAD_FAILED': 'Uploaden is niet gelukt',
  'DIALOG_UPLOAD_FAILED_MSG': 'Uploaden is niet gelukt',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Oorzaak onbekend...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Geannuleerd door de gebruiker...',
  'DIALOG_UPLOAD_TOO_BIG': 'Het bestand is te groot',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Het bestand is te groot, overschrijdt {0}',

  'DIALOG_FONT_TITLE': 'Lettertype',

  'DIALOG_APPCHOOSER_TITLE': 'Kies een programma',
  'DIALOG_APPCHOOSER_MSG': 'Kies een programma om te openen',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'U moet een programma kiezen',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Instellen als standaard programma voor {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Module is niet geconfigureerd of uitgeschakeld',
  'GAPI_SIGN_OUT': 'Afmelden bij Google API Services',
  'GAPI_REVOKE': 'Permissies herstellen en afmelden',
  'GAPI_AUTH_FAILURE': 'Google API Authentificatie niet gelukt of heeft niet plaatsgevonden',
  'GAPI_AUTH_FAILURE_FMT': 'Authentificatie mislukt: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Google API laden is mislukt',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module is niet geconfigureerd of uitgeschakeld',
  'WLAPI_SIGN_OUT': 'Afmelden bij Window Live API',
  'WLAPI_LOAD_FAILURE': 'Windows Live API niet geladen',
  'WLAPI_LOGIN_FAILED': 'Aanmelden bij Windows Live mislukt',
  'WLAPI_LOGIN_FAILED_FMT': 'Aanmelden bij Windows Live misluk: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live status: {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Kan geen IndexedDB maken zonder database naam',
  'IDB_NO_SUCH_ITEM': 'Item bestaat niet',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Fatale Fout',
  'ERR_VFS_UNAVAILABLE': 'Niet beschikbaar',
  'ERR_VFS_FILE_ARGS': 'Bestand verwacht tenminste 1 optie',
  'ERR_VFS_NUM_ARGS': 'Onjuist aantal opties',
  'ERR_VFS_EXPECT_FILE': 'Dit is geen bestands-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Dit is geen bronbestand',
  'ERR_VFS_EXPECT_DST_FILE': 'Verwacht een bestemmings bestand',
  'ERR_VFS_FILE_EXISTS': 'Bestemming bestaat al',
  'ERR_VFS_TRANSFER_FMT': 'Er is een fout opgetreden bij het omzetten van opslag: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Kan het bestand niet uploaden zonder bestemming',
  'ERR_VFS_UPLOAD_NO_FILES': 'Geen bestand gedefineerd om te uploaden',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Bestand uploaden is mislukt: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Bestands upload is geannuleerd',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Kan niet downloaden zonder pad',
  'ERR_VFS_DOWNLOAD_FAILED': 'Er is een fout opgetreden tijdens het downloaden: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'De reactie was leeg',

  'ERR_VFSMODULE_INVALID': 'Ongeldige VFS Module',
  'ERR_VFSMODULE_INVALID_FMT': 'Ongeldige VFS Module: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Ongeldige VFS Methode',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Ongeldige VFS Methode: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Ongeldige VFS Module type',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Ongeldige VFS Module type: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Ongeldige VFS Module configuratie',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Ongeldige VFS Module configuratie: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS Module reeds gekoppeld',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS Module \'{0}\' reeds gekoppeld',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS Module niet gekoppeld',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS Module \'{0}\' niet gekoppeld',
  'ERR_VFSMODULE_EXCEPTION': 'VFS Module Exceptie',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS Module Exceptie: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Geen VFS Module komt overeen met {0}. Verkeerd pad or formaat ?',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Bestand downloaden',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Fout',
  'ERR_VFSMODULE_ROOT_ID': 'ID van root map niet gevonden',
  'ERR_VFSMODULE_NOSUCH': 'Het bestand bestaat niet',
  'ERR_VFSMODULE_PARENT': 'Ouder bestaat niet',
  'ERR_VFSMODULE_PARENT_FMT': 'Ouder opzoeken mislukt: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Mappen scannen mislukt',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Mappen scannen mislukt: {0}',
  'ERR_VFSMODULE_READ': 'Bestand lezen mislukt',
  'ERR_VFSMODULE_READ_FMT': 'Bestand lezen misluk: {0}',
  'ERR_VFSMODULE_WRITE': 'Bestand schrijven misluk',
  'ERR_VFSMODULE_WRITE_FMT': 'Bestand schrijven misluk: {0}',
  'ERR_VFSMODULE_COPY': 'Kopieren mislukt',
  'ERR_VFSMODULE_COPY_FMT': 'Kopieren mislukt: {0}',
  'ERR_VFSMODULE_UNLINK': 'Fout bij unlink opdracht',
  'ERR_VFSMODULE_UNLINK_FMT': 'Fout bij unlink opdrachte: {0}',
  'ERR_VFSMODULE_MOVE': 'Bestand verplaatsen mislukt',
  'ERR_VFSMODULE_MOVE_FMT': 'Bestand verplaatsen mislukt: {0}',
  'ERR_VFSMODULE_EXIST': 'Fout tijdens het bepalen van het bestaan van een bestand',
  'ERR_VFSMODULE_EXIST_FMT': 'Fout tijdens het bepalen van het bestaan van een bestand: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Bestands informatie lezen is mislukt',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Bestands informatie lezen is mislukt: {0}',
  'ERR_VFSMODULE_MKDIR': 'Map maken is mislukt',
  'ERR_VFSMODULE_MKDIR_FMT': 'Map maken is mislukt: {0}',
  'ERR_VFSMODULE_URL': 'Fout bij het verkrijgen van een URL',
  'ERR_VFSMODULE_URL_FMT': 'Fout bij het verkrijgen van een URL: {0}',
  'ERR_VFSMODULE_TRASH': 'Fout bij het verplaatsen naar de prullebak',
  'ERR_VFSMODULE_TRASH_FMT': 'Fout bij het verplaatsen naar de prullebak: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Fout bij het verplaatsen uit de prullebak',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Fout bij het verplaatsen uit de prullebak: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Fout bij het legen van de prullebak',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Fout bij het legen van de prullebak: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Aangemeld bij Dropbox',
  'DROPBOX_SIGN_OUT': 'Afmelden bij Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Kan het pad niet oplossen: item niet gevonden',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Laden van zip.js mislukt',
  'ZIP_VENDOR_FAIL': 'zip.js niet gevonden. Is het correct geladen?',
  'ZIP_NO_RESOURCE': 'Geen zip bestand opgegeven',
  'ZIP_NO_PATH': 'Geen pad opgegeven',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Pakket installatie map bestaat al. Kan niet verder gaan!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Kan het bestand niet openen',
  'ERR_FILE_APP_OPEN_FMT': 'Het bestand {0} kan niet worden geopend {1} wordt niet ondersteund',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Het bestand {0} kan niet worden geopend: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Het bestand {0} kan niet worden opgeslagen: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Toepassing Fout',
  'ERR_GENERIC_APP_ACTION_FMT': 'Kan de actie \'{0}\' niet voltooien',
  'ERR_GENERIC_APP_UNKNOWN': 'Onbekende Fout',
  'ERR_GENERIC_APP_REQUEST': 'Er is een fout opgetreden tijdens het afhandelen van dit verzoek',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatale Fout: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Wijzigingen ongedaan maken?',
  'MSG_FILE_CHANGED': 'Het bestand is gewijzigd. Opnieuw laden?',
  'MSG_APPLICATION_WARNING': 'Waarschuwing',
  'MSG_MIME_OVERRIDE': 'Het bestandstype "{0}" wordt niet ondersteund, suggestie: "{1}"',

  //
  // General
  //

  'LBL_UNKNOWN': 'Onbekend',
  'LBL_APPEARANCE': 'Weergave',
  'LBL_USER': 'Gebruiker',
  'LBL_NAME': 'Naam',
  'LBL_APPLY': 'Bevestigen',
  'LBL_FILENAME': 'Bestandsnaam',
  'LBL_PATH': 'Map',
  'LBL_SIZE': 'Grootte',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Laden',
  'LBL_SETTINGS': 'Instellingen',
  'LBL_ADD_FILE': 'Bestand toevoegen',
  'LBL_COMMENT': 'Opmerking',
  'LBL_ACCOUNT': 'Account',
  'LBL_CONNECT': 'Verbinden',
  'LBL_ONLINE': 'Verbonden',
  'LBL_OFFLINE': 'Verbroken',
  'LBL_AWAY': 'Afwezig',
  'LBL_BUSY': 'Bezig',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Help',
  'LBL_ABOUT': 'Over',
  'LBL_PANELS': 'Panelen',
  'LBL_LOCALES': 'Talen',
  'LBL_THEME': 'Thema',
  'LBL_COLOR': 'Kleur',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Stop',
  'LBL_ALIVE': 'Aktief',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Toevoegen',
  'LBL_FONT': 'Lettertype',
  'LBL_YES': 'Ja',
  'LBL_NO': 'Nee',
  'LBL_CANCEL': 'Annuleren',
  'LBL_TOP': 'Boven',
  'LBL_LEFT': 'Links',
  'LBL_RIGHT': 'Rechts',
  'LBL_BOTTOM': 'Onder',
  'LBL_CENTER': 'Midden',
  'LBL_FILE': 'Bestand',
  'LBL_NEW': 'Nieuw',
  'LBL_OPEN': 'Open',
  'LBL_SAVE': 'Opslaan',
  'LBL_SAVEAS': 'opslaan als...',
  'LBL_CLOSE': 'Sluiten',
  'LBL_MKDIR': 'Nieuwe map maken',
  'LBL_UPLOAD': 'Uploaden',
  'LBL_VIEW': 'Beeld',
  'LBL_EDIT': 'Bewerken',
  'LBL_RENAME': 'Hernoemen',
  'LBL_DELETE': 'Verwijderen',
  'LBL_OPENWITH': 'Openen met ...',
  'LBL_ICONVIEW': 'Icoon weergave',
  'LBL_TREEVIEW': 'Boom weergave',
  'LBL_LISTVIEW': 'Lijst weergave',
  'LBL_REFRESH': 'Verversen',
  'LBL_VIEWTYPE': 'Weergave type',
  'LBL_BOLD': 'Vet',
  'LBL_ITALIC': 'Schuin',
  'LBL_UNDERLINE': 'Onderstreept',
  'LBL_REGULAR': 'Normaal',
  'LBL_STRIKE': 'Doorgehaald',
  'LBL_INDENT': 'Inspringen',
  'LBL_OUTDENT': 'Uitspringen',
  'LBL_UNDO': 'Ongedaan maken',
  'LBL_REDO': 'Ongedaan maken herstellen',
  'LBL_CUT': 'Knip',
  'LBL_UNLINK': 'Unlink',
  'LBL_COPY': 'Kopieren',
  'LBL_PASTE': 'Plakken',
  'LBL_INSERT': 'Invoegen',
  'LBL_IMAGE': 'Afbeelding',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Verbreken',
  'LBL_APPLICATIONS': 'Toepassingen',
  'LBL_ADD_FOLDER': 'Map toevoegen',
  'LBL_INFORMATION': 'Informatie',
  'LBL_TEXT_COLOR': 'Tekst kleur',
  'LBL_BACK_COLOR': 'Achtergrond kleur',
  'LBL_RESET_DEFAULT': 'Standaard instelling terug zetten',
  'LBL_DOWNLOAD_COMP': 'Downloaden naar je computer',
  'LBL_ORDERED_LIST': 'Gesorteerde lijst',
  'LBL_BACKGROUND_IMAGE': 'Achtergrond afbeelding',
  'LBL_BACKGROUND_COLOR': 'Achtergrond kleur',
  'LBL_UNORDERED_LIST': 'Ongesorteerde lijst',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Alleen lezen',
  'LBL_CREATED': 'Aangemaakt',
  'LBL_MODIFIED': 'Gewijzigd',
  'LBL_SHOW_COLUMNS': 'Kolommen tonen',
  'LBL_MOVE': 'Verplaats',
  'LBL_OPTIONS': 'Opties',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Map',
  'LBL_CREATE': 'Aanmaken',
  'LBL_BUGREPORT': 'Bugreport',
  'LBL_INSTALL': 'Installeer',
  'LBL_UPDATE': 'Update',
  'LBL_REMOVE': 'Verwijder',
  'LBL_SHOW_SIDEBAR': 'Zijbar tonen',
  'LBL_SHOW_NAVIGATION': 'Navigatie tonen',
  'LBL_SHOW_HIDDENFILES': 'Laat verborgen bestanden zien',
  'LBL_SHOW_FILEEXTENSIONS': 'Toon bestandsextensies',
  'LBL_MOUNT': 'Koppelen',
  'LBL_DESCRIPTION': 'Omschrijving',
  'LBL_USERNAME': 'Gebruikersnaam',
  'LBL_PASSWORD': 'Wachtwoord',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_BACKGROUND': 'Achtergrond',
  'LBL_DESKTOP': 'Bureaublad',
  'LBL_PANEL': 'Paneel',
  'LBL_POSITION': 'Positie',
  'LBL_ONTOP': 'Voorgrond',
  'LBL_ITEMS': 'Items',
  'LBL_GENERAL': 'Algemeen'

};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': 'Feil ved åpning av fil',
  'ERR_WM_NOT_RUNNING': 'Window Manager kjører ikke',
  'ERR_FILE_OPEN_FMT': 'Filen \'**{0}**\' kunne ikke bli åpnet',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Fant ingen Applikasjoner som støtter \'{0}\' filer',
  'ERR_APP_LAUNCH_FAILED': 'Klarte ikke starte Applikasjon',
  'ERR_APP_LAUNCH_FAILED_FMT': 'En feil oppstod ved oppstart av: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Applikasjonen \'{0}\' construct feilet: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Applikasjonen \'{0}\' init() feilet: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Applikasjonen ressursjer mangler for \'{0}\', eller de feilet under lasting!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Applikasjonen \'{0}\' preloading feilet: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Applikasjonen \'{0}\' kjører allerede og bare en instans er tillatt!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Klarte ikke starte \'{0}\'. Manifest ble ikke funnet!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Klarte ikke starte \'{0}\'. Nettleseren din støtter ikke: {1}',

  'ERR_NO_WM_RUNNING': 'Window Manager kjører ikke',
  'ERR_CORE_INIT_FAILED': 'Klarte ikke starte OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'En feil oppstod under oppstart av OS.js',
  'ERR_CORE_INIT_NO_WM': 'Kan ikke starte OS.js: Ingen window manager definert!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Kan ikke starte OS.js: Window Manager startet ikke: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Kan ikke starte OS.js: Feil under forhåndslasting...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Feilrapport',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'En uventet feil eller bug oppstod.',

  'ERR_APP_API_ERROR': 'Applikasjon API feil',
  'ERR_APP_API_ERROR_DESC_FMT': 'Applikasjon {0} feilet under operasjonen \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Mangler argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Ukjent feil',

  'ERR_OPERATION_TIMEOUT': 'Tidsavbrudd i operasjon',
  'ERR_OPERATION_TIMEOUT_FMT': 'Tidsavbrudd i operasjon ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' expects \'{1}\' to be a \'{2}\', \'{3}\' given',
  'ERR_INVALID_LOCATION': 'Ugyldig plassering',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Du har allerede et Window med navnet \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimiser',
  'WINDOW_MAXIMIZE': 'Maksimer',
  'WINDOW_RESTORE': 'Gjenopprett',
  'WINDOW_CLOSE': 'Lukk',
  'WINDOW_ONTOP_ON': 'På topp (På)',
  'WINDOW_ONTOP_OFF': 'På topp (Av)',

  // Handler
  'TITLE_SIGN_OUT': 'Logg ut',
  'TITLE_SIGNED_IN_AS_FMT': 'Logget inn som: {0}',
  'ERR_LOGIN_FMT': 'Login feil: {0}',
  'ERR_LOGIN_INVALID': 'Ugyldig innlogging',

  // SESSION
  'ERR_NO_SESSION': 'Ingen sessjon er aktiv. Vil du laste på nytt?',
  'MSG_SESSION_WARNING': 'Er du sikker på at du vil avslutte OS.js? Du vil tape alle ulagrede data!',

  // Service
  'BUGREPORT_MSG': 'Vennligst rapporter dette problemet hvis du tror det er en feil.\nLegg ved en beskrivelse om hvordan problemet oppstod og hvordan man kan reprodusere feilen.',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Innloget i eksterne tjenester: {0}',
  'CONNECTION_LOST': 'Kobling til tjener ble brutt. Gjenoppretter...',
  'CONNECTION_RESTORED': 'Kobling til tjener ble gjenopprettet',
  'CONNECTION_RESTORE_FAILED': 'Klarte ikke koble til tjener. Prøver på nytt',
  'CONNECTION_ERROR': 'Tilkoblingsfeil',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatal Feil',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Feil: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': 'Logg ut (Avslutt)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Logger ut bruker \'{0}\'.\nVil du lagre gjeldende sessjon?',

  'DIALOG_CLOSE': 'Lukk',
  'DIALOG_CANCEL': 'Avbryt',
  'DIALOG_APPLY': 'Angi',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Advarsel Dialog',

  'DIALOG_COLOR_TITLE': 'Farge Dialog',
  'DIALOG_COLOR_R': 'Rød: {0}',
  'DIALOG_COLOR_G': 'Grønn: {0}',
  'DIALOG_COLOR_B': 'Blå: {0}',
  'DIALOG_COLOR_A': 'Alfa: {0}',

  'DIALOG_CONFIRM_TITLE': 'Bekreft Dialog',

  'DIALOG_ERROR_MESSAGE': 'Beskjed',
  'DIALOG_ERROR_SUMMARY': 'Oppsummering',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Bugreport',

  'DIALOG_FILE_SAVE': 'Lagre',
  'DIALOG_FILE_OPEN': 'Åpne',
  'DIALOG_FILE_MKDIR': 'Ny Mappe',
  'DIALOG_FILE_MKDIR_MSG': 'Lage ny mappe i **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Vil du overskrive filen \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Visningstype',
  'DIALOG_FILE_MNU_LISTVIEW': 'Liste-visning',
  'DIALOG_FILE_MNU_TREEVIEW': 'Tre-visining',
  'DIALOG_FILE_MNU_ICONVIEW': 'Ikon-visning',
  'DIALOG_FILE_ERROR': 'FileDialog Error',
  'DIALOG_FILE_ERROR_SCANDIR': 'Klarte ikke liste innhold for mappen \'{0}\' fordi en feil oppstod',
  'DIALOG_FILE_ERROR_FIND': 'Klarte ikke søke i mappen \'{0}\' fordi en feil oppstod',
  'DIALOG_FILE_MISSING_FILENAME': 'Du må velge en fil eller skrive inn filnavn!',
  'DIALOG_FILE_MISSING_SELECTION': 'Du må velge en fil!',

  'DIALOG_FILEINFO_TITLE': 'Fil Informasion',
  'DIALOG_FILEINFO_LOADING': 'Laste informasjon for filen: {0}',
  'DIALOG_FILEINFO_ERROR': 'FileInformationDialog Feil',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Klarte ikke hente informasjon for filen **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Klarte ikke hente informasjon for filen: {0}',

  'DIALOG_INPUT_TITLE': 'Inndata Dialog',

  'DIALOG_FILEPROGRESS_TITLE': 'Fil-operasjon fremgang',
  'DIALOG_FILEPROGRESS_LOADING': 'Laster...',

  'DIALOG_UPLOAD_TITLE': 'Opplasting Dialog',
  'DIALOG_UPLOAD_DESC': 'Opplasting fil til **{0}**.<br />Maksimum størrelse: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Laster opp \'{0}\' ({1} {2}) til {3}',
  'DIALOG_UPLOAD_MSG': 'Laster opp fil...',
  'DIALOG_UPLOAD_FAILED': 'Opplasting feilet',
  'DIALOG_UPLOAD_FAILED_MSG': 'Opplastingen feilet',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Ukjent årsak...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Avbrutt av bruker...',
  'DIALOG_UPLOAD_TOO_BIG': 'Fil er for stor',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Fil er for stor, større en {0}',

  'DIALOG_FONT_TITLE': 'Tekst Dialog',

  'DIALOG_APPCHOOSER_TITLE': 'Velg Applikasjon',
  'DIALOG_APPCHOOSER_MSG': 'Velg en applikasjon for åpning',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Du må velge en applikasjon',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Bruk som standard for {0}',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modul dekativert eller ikke konfigurert',
  'GAPI_SIGN_OUT': 'Logg ut av Google API Services',
  'GAPI_REVOKE': 'Tilbakekall tillatelse og Logg ut',
  'GAPI_AUTH_FAILURE': 'Google API autentisering feilet eller tok ikke sted',
  'GAPI_AUTH_FAILURE_FMT': 'Klarte ikke autentisere: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Klarte ikke laste Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API Modul deaktivert eller ikke konfigurert',
  'WLAPI_SIGN_OUT': 'Logg ut av Window Live API',
  'WLAPI_LOAD_FAILURE': 'Klarte ikke laste Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Klarte ikke logge inn Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Klarte ikke logge inn Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returnerte {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Kan ikke opprette IndexedDB uten databasenavn',
  'IDB_NO_SUCH_ITEM': 'Item ble ikke funnet',

  // VFS
  'ERR_VFS_FATAL': 'Fatal Feil',
  'ERR_VFS_UNAVAILABLE': 'Ikke tilgjenglig',
  'ERR_VFS_FILE_ARGS': 'File forventer minst èt argument',
  'ERR_VFS_NUM_ARGS': 'Ikke not argumenter',
  'ERR_VFS_EXPECT_FILE': 'Forventer èt Fil-objekt',
  'ERR_VFS_EXPECT_SRC_FILE': 'Forventer èt kilde Fil-objekt',
  'ERR_VFS_EXPECT_DST_FILE': 'Forventer èt destinasjon Fil-objekt',
  'ERR_VFS_FILE_EXISTS': 'Destinasjonen finnes allerede',
  'ERR_VFS_TARGET_NOT_EXISTS': 'Destinasjon finnes ikke',
  'ERR_VFS_TRANSFER_FMT': 'En feil oppstod under overføring av filen: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Kan ikke laste opp uten destinasjon',
  'ERR_VFS_UPLOAD_NO_FILES': 'Kan ikke laste opp uten noen filer definert',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Fil-opplasting feilet: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Fil-opplastingen ble avbrutt',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Kan ikke laste ned uten en sti',
  'ERR_VFS_DOWNLOAD_FAILED': 'En feil oppstod under nedlasting: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Respons var tom',
  'ERR_VFS_NO_MIME_DETECT': 'Ingen mime-type gjenkjent',

  'ERR_VFSMODULE_INVALID': 'Ugyldig VFS Modul',
  'ERR_VFSMODULE_INVALID_FMT': 'Ugyldig VFS Modul: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Ugyldig VFS Metode',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Ugyldig VFS Metode: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Ugyldig VFS Modul type',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Ugyldig VFS Modul type: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Ugyldig VFS Modul konfigurasjon',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Ugyldig VFS Modul konfigurasjon: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS Modul allerede montert',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS Modul \'{0}\' allerede montert',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS Modul ikke montert',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS Modul \'{0}\' ikke montert',
  'ERR_VFSMODULE_EXCEPTION': 'VFS Modul Exception',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS Modul Exception: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Ingen VFS Modul lik {0}. Fil sti eller format ?',
  'ERR_VFSMODULE_READONLY': 'VFS Modul er bare lesbar',
  'ERR_VFSMODULE_READONLY_FMT': 'VFS Modul er bare lesbar: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Laster ned fil',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Feil',
  'ERR_VFSMODULE_ROOT_ID': 'Klarte ikke hente id for rotmappe',
  'ERR_VFSMODULE_NOSUCH': 'Filen eksister ikke',
  'ERR_VFSMODULE_PARENT': 'Parent finnes ikke',
  'ERR_VFSMODULE_PARENT_FMT': 'Klarte ikke lete opp parent: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Klarte ikke skanne mappe',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Klarte ikke skanne mappe: {0}',
  'ERR_VFSMODULE_READ': 'Klarte ikke lese fil',
  'ERR_VFSMODULE_READ_FMT': 'Klarte ikke lese fil: {0}',
  'ERR_VFSMODULE_WRITE': 'Klarte ikke skrive fil',
  'ERR_VFSMODULE_WRITE_FMT': 'Klarte ikke skrive fil: {0}',
  'ERR_VFSMODULE_COPY': 'Klarte ikke kopiere',
  'ERR_VFSMODULE_COPY_FMT': 'Klarte ikke kopiere: {0}',
  'ERR_VFSMODULE_UNLINK': 'Klarte ikke slette fil',
  'ERR_VFSMODULE_UNLINK_FMT': 'Klarte ikke slette fil: {0}',
  'ERR_VFSMODULE_MOVE': 'Klarte ikke flytte fil',
  'ERR_VFSMODULE_MOVE_FMT': 'Klarte ikke flytte fil: {0}',
  'ERR_VFSMODULE_EXIST': 'Klarte ikke sjekke om fil eksisterer',
  'ERR_VFSMODULE_EXIST_FMT': 'Klarte ikke sjekke om fil eksisterer: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Klarte ikke hente fil-informasjon',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Klarte ikke hente fil-informasjon: {0}',
  'ERR_VFSMODULE_MKDIR': 'Klarte ikke lage mappe',
  'ERR_VFSMODULE_MKDIR_FMT': 'Klarte ikke lage mapp: {0}',
  'ERR_VFSMODULE_MKFILE': 'Klarte ikke lage fil',
  'ERR_VFSMODULE_MKFILE_FMT': 'Klarte ikke lage fil: {0}',
  'ERR_VFSMODULE_URL': 'Klarte ikke hente URL for fil',
  'ERR_VFSMODULE_URL_FMT': 'Klarte ikke hente URL for fil: {0}',
  'ERR_VFSMODULE_TRASH': 'Klarte ikke flytte fil til søppelkassen',
  'ERR_VFSMODULE_TRASH_FMT': 'Klarte ikke flytte fil til søppelkassen: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Klarte ikke flytte fil ut av søppelkassen',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Klarte ikke flytte fil ut av søppelkassen: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Klarte ikke tømme søppel',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Klarte ikke tømme søppel: {0}',
  'ERR_VFSMODULE_FIND': 'Klarte ikke søke',
  'ERR_VFSMODULE_FIND_FMT': 'Klarte ikke søke: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Klarte ikke hente ledig plass',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Klarte ikke hente ledig plass: {0}',
  'ERR_VFSMODULE_EXISTS': 'Klarte ikke sjekke destinasjon',
  'ERR_VFSMODULE_EXISTS_FMT': 'Klarte ikke check sjekke destinasjon: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Du er logget inn i Dropbox API',
  'DROPBOX_SIGN_OUT': 'Logg ut fra Dropbox API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Klarte ikke løse sti: fant ikke filen',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Klarte ikke laste zip.js',
  'ZIP_VENDOR_FAIL': 'zip.js bliblioteket ble ikke funnet!',
  'ZIP_NO_RESOURCE': 'Ingen zip ressursj angitt',
  'ZIP_NO_PATH': 'Ingen sti angitt',

  // SearchEngine
  'SEARCH_LOADING': 'Søker...',
  'SEARCH_NO_RESULTS': 'Ingen resultater',

  // PackageManager
  'ERR_PACKAGE_EXISTS': 'Kan ikke fortsette. Pakkedestinasjonen finnes allerede!',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': 'Kan ikke åpne filen',
  'ERR_FILE_APP_OPEN_FMT': 'Filen {0} ble ikke åpnet fordi MIME {1} ikke er støttet',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Filen {0} ble ikke åpnet: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Filen {0} ble ikke lagret: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Applikasjon Feil',
  'ERR_GENERIC_APP_ACTION_FMT': 'Klarte ikke utføre operasjon \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Ukjent feil',
  'ERR_GENERIC_APP_REQUEST': 'En feil oppstod under håndteringen av din forespursel',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatal Feil: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Forkast endringer?',
  'MSG_FILE_CHANGED': 'Filen har blitt endret. Last inn på nytt?',
  'MSG_APPLICATION_WARNING': 'Applikasjon-advarsel',
  'MSG_MIME_OVERRIDE': 'Filtypen "{0}" er ikke støttet, bruker "{1}" istedet.',

  'ERR_OPEN_LOCATION': 'Klarte ikke åpne sti',
  'ERR_OPEN_LOCATION_FMT': 'Klarte ikke åpne sti: {0}',

  // General

  'LBL_UNKNOWN': 'Ukjent',
  'LBL_APPEARANCE': 'Utseende',
  'LBL_USER': 'Bruker',
  'LBL_NAME': 'Navn',
  'LBL_APPLY': 'Angi',
  'LBL_FILENAME': 'Filnavn',
  'LBL_PATH': 'Sti',
  'LBL_SIZE': 'Størrelse',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Laster',
  'LBL_SETTINGS': 'Instillinger',
  'LBL_ADD_FILE': 'Legg til fil',
  'LBL_COMMENT': 'Kommenter',
  'LBL_ACCOUNT': 'Konto',
  'LBL_CONNECT': 'Koble til',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Borte',
  'LBL_BUSY': 'Opptatt',
  'LBL_CHAT': 'Snakk',
  'LBL_HELP': 'Hjelp',
  'LBL_ABOUT': 'Om',
  'LBL_PANELS': 'Paneler',
  'LBL_LOCALES': 'Lokalisering',
  'LBL_THEME': 'Temaer',
  'LBL_COLOR': 'Farge',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Drep',
  'LBL_ALIVE': 'I live',
  'LBL_INDEX': 'Indeks',
  'LBL_ADD': 'Legg til',
  'LBL_FONT': 'Skrift',
  'LBL_YES': 'Ja',
  'LBL_NO': 'Nei',
  'LBL_CANCEL': 'Avbryt',
  'LBL_TOP': 'Topp',
  'LBL_LEFT': 'Venstre',
  'LBL_RIGHT': 'Høyre',
  'LBL_BOTTOM': 'Bunn',
  'LBL_CENTER': 'Midt',
  'LBL_FILE': 'Fil',
  'LBL_NEW': 'Ny',
  'LBL_OPEN': 'Åpne',
  'LBL_SAVE': 'Lagre',
  'LBL_SAVEAS': 'Lagre som...',
  'LBL_CLOSE': 'Lukk',
  'LBL_MKDIR': 'Lag Mappe',
  'LBL_UPLOAD': 'Last opp',
  'LBL_VIEW': 'Visning',
  'LBL_EDIT': 'Rediger',
  'LBL_RENAME': 'Navngi',
  'LBL_DELETE': 'Slett',
  'LBL_OPENWITH': 'Åpne Med ...',
  'LBL_ICONVIEW': 'Ikon-visning',
  'LBL_TREEVIEW': 'Tre-visning',
  'LBL_LISTVIEW': 'Liste-visning',
  'LBL_REFRESH': 'Gjennoppfrisk',
  'LBL_VIEWTYPE': 'Visningstype',
  'LBL_BOLD': 'Feit',
  'LBL_ITALIC': 'Skeiv',
  'LBL_UNDERLINE': 'Underlinjet',
  'LBL_REGULAR': 'Normal',
  'LBL_STRIKE': 'Gjennomstrøk',
  'LBL_INDENT': 'Innrykk',
  'LBL_OUTDENT': 'Utrykk',
  'LBL_UNDO': 'Angre',
  'LBL_REDO': 'Gjør om igjen',
  'LBL_CUT': 'Kutt',
  'LBL_UNLINK': 'Fjern lenke',
  'LBL_COPY': 'Kopier',
  'LBL_PASTE': 'Lim inn',
  'LBL_INSERT': 'Sett inn',
  'LBL_IMAGE': 'Bilde',
  'LBL_LINK': 'Lenke',
  'LBL_DISCONNECT': 'Koble fra',
  'LBL_APPLICATIONS': 'Applikasjoner',
  'LBL_ADD_FOLDER': 'Legg til mappe',
  'LBL_INFORMATION': 'Informasjon',
  'LBL_TEXT_COLOR': 'Tekst-farge',
  'LBL_BACK_COLOR': 'Bakgrunn-farge',
  'LBL_RESET_DEFAULT': 'Omstill til standard',
  'LBL_DOWNLOAD_COMP': 'Last ned til datamaskin',
  'LBL_ORDERED_LIST': 'Ordnet liste',
  'LBL_BACKGROUND_IMAGE': 'Bakgrunnsbilde',
  'LBL_BACKGROUND_COLOR': 'Bakgrunnsfarge',
  'LBL_UNORDERED_LIST': 'Uordnet Liste',
  'LBL_SHOW_SIDEBAR': 'Vis Sidebar',
  'LBL_SEARCH': 'Søk',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Kun lesbar',
  'LBL_CREATED': 'Opprettet',
  'LBL_MODIFIED': 'Modifisert',
  'LBL_SHOW_COLUMNS': 'Vis Kolonner',
  'LBL_MOVE': 'Flytt',
  'LBL_OPTIONS': 'Opsjoner',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Mappe',
  'LBL_CREATE': 'Opprett',
  'LBL_BUGREPORT': 'Bug-rapport',
  'LBL_INSTALL': 'Installer',
  'LBL_UPDATE': 'Oppdater',
  'LBL_REMOVE': 'Fjern',
  'LBL_SHOW_NAVIGATION': 'Vis navigasjon',
  'LBL_SHOW_HIDDENFILES': 'Vis skjulte filer',
  'LBL_SHOW_FILEEXTENSIONS': 'Vis fil-utvidelser',
  'LBL_MOUNT': 'Montere',
  'LBL_DESCRIPTION': 'Beskrivelse',
  'LBL_USERNAME': 'Brukernavn',
  'LBL_PASSWORD': 'Passord',
  'LBL_HOST': 'Vert',
  'LBL_NAMESPACE': 'Navneplass',
  'LBL_BACK': 'Tilbake',
  'LBL_ICONS': 'Ikoner',
  'LBL_ICON': 'Ikon',
  'LBL_UNINSTALL': 'Avinstaller',
  'LBL_REGENERATE': 'Regenerer',
  'LBL_DESKTOP': 'Skrivebord',
  'LBL_WINDOWMANAGER': 'Vindu-håndterer',
  'LBL_HOTKEY': 'Snarknapp',
  'LBL_HOTKEYS': 'Snarknapper',
  'LBL_MOUNTS': 'Monteringer',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Applikasjon',
  'LBL_SCOPE': 'Skop',
  'LBL_HIDE': 'Skjul',
  'LBL_REPOSITORY': 'Repository',
  'LBL_VERSION': 'Versjon',
  'LBL_AUTHOR': 'Forfatter',
  'LBL_GROUPS': 'Grupper',
  'LBL_AUTOHIDE': 'Auto-skjul',
  'LBL_PERSONAL': 'Personlig',
  'LBL_SYSTEM': 'System',
  'LBL_STARTING': 'Starter',
  'LBL_SOUNDS': 'Lyder',
  'LBL_STORE': 'Butikk',
  'LBL_LOCALE': 'Språkvalg',
  'LBL_PACKAGE': 'Pakke',
  'LBL_PACKAGES': 'Pakker',
  'LBL_INPUT': 'Inndata',
  'LBL_MISC': 'Annet',
  'LBL_OTHER': 'Annet',
  'LBL_USERS': 'Brukere',
  'LBL_FONTS': 'Skrift',
  'LBL_BACKGROUND': 'Bakgrunn',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Posisjon',
  'LBL_OPACITY': 'Gjennomsiktighet',
  'LBL_ONTOP': 'Topp',
  'LBL_ITEMS': 'Objekter',
  'LBL_GENERAL': 'Generelt',
  'LBL_LOCK': 'Lås',
  'LBL_UNLOCK': 'Lås opp',
  'LBL_OPEN_LOCATION': 'Åpne sti',
  'LBL_HOME': 'Hjem',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_WARNING': 'Advarsel',
  'LBL_INFO': 'Info'
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Błąd otwierania pliku',
  'ERR_WM_NOT_RUNNING': 'Menedżer okien nie jest włączony',
  'ERR_FILE_OPEN_FMT': 'Nie można otworzyć \'**{0}**\'',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Nie można znaleźć aplikacji wspierającej \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Błąd otwierania aplikacji',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Błąd podczas uruchamiania aplikacji: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Konstruowanie aplikacji \'{0}\' nie powiodło się: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'init() aplikacji \'{0}\' nie powiodło się: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Brakuje zasobów dla aplikacji \'{0}\' lub ładowanie nie powiodło się!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Wstępne ładowanie aplikacji \'{0}\' nie powiodło się: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Aplikacja \'{0}\' została juz otwarta, a nie może być uruchomiona wielokrotnie!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Nie można otworzyć \'{0}\'. Nie znaleziono danych manifestu aplikacji!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Nie można otworzyć \'{0}\'. Twoja przeglądarka nie wspiera: {1}',

  'ERR_NO_WM_RUNNING': 'Menedżer okien nie został uruchomiony',
  'ERR_CORE_INIT_FAILED': 'Nie można zainicjalizować OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Błąd podczas inicjalizacji OS.js',
  'ERR_CORE_INIT_NO_WM': 'Nie można uruchomić OS.js: Nie wybrano Menedżera Okien!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Nie można uruchomić OS.js: Błąd uruchamiania Menedżera Okien: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Nie można uruchomić OS.js: Błąd przeładowywania plików...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Błąd Javascript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Nieznany błąd.',

  'ERR_APP_API_ERROR': 'Błąd API Aplikacji',
  'ERR_APP_API_ERROR_DESC_FMT': 'Aplikacja {0} nie może wykonać operacji \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Brakujący argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Nieznany błąd',

  'ERR_OPERATION_TIMEOUT': 'Przekroczono Czas Operacji',
  'ERR_OPERATION_TIMEOUT_FMT': 'Przekroczono Czas Operacji ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Masz już uruchomione Okno z nazwą \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimalizuj',
  'WINDOW_MAXIMIZE': 'Maksymalizuj',
  'WINDOW_RESTORE': 'Przywroć',
  'WINDOW_CLOSE': 'Zamknij',
  'WINDOW_ONTOP_ON': 'U Góry (Włączone)',
  'WINDOW_ONTOP_OFF': 'U Góry (Wyłączone)',

  // Handler
  'TITLE_SIGN_OUT': 'Wyloguj',
  'TITLE_SIGNED_IN_AS_FMT': 'Zalogowano jako: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Czy na pewno chcesz opuścić OS.js? Wszystkie niezapisane ustawienia i dane aplikacji zostaną utracone!',

  // Service
  'BUGREPORT_MSG': 'Wyślij proszę raport błędu jesli uważasz, że jest to błąd.\nDołącz opis błędu',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Zalogowano w zewnętrznych serwisach: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Błąd krytyczny',
  'ERR_UTILS_XHR_FMT': 'Błąd AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Wylogowywanie (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Wylogowywanie \'{0}\'.\nCzy chcesz zapisać sesję?',

  'DIALOG_CLOSE': 'Zamknij',
  'DIALOG_CANCEL': 'Anuluj',
  'DIALOG_APPLY': 'Zastosuj',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Powiadomienia',

  'DIALOG_COLOR_TITLE': 'Kolor',
  'DIALOG_COLOR_R': 'Czerwony: {0}',
  'DIALOG_COLOR_G': 'Zielony: {0}',
  'DIALOG_COLOR_B': 'Niebieski: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Potwierdź',

  'DIALOG_ERROR_MESSAGE': 'Wiadomość',
  'DIALOG_ERROR_SUMMARY': 'Podsumowanie',
  'DIALOG_ERROR_TRACE': 'Śledzenie',
  'DIALOG_ERROR_BUGREPORT': 'Raport błędu',

  'DIALOG_FILE_SAVE': 'Zapisz',
  'DIALOG_FILE_OPEN': 'Otwórz',
  'DIALOG_FILE_MKDIR': 'Nowy folder',
  'DIALOG_FILE_MKDIR_MSG': 'Nowy folder w **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Czy chcesz nadpisać plik \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Widok',
  'DIALOG_FILE_MNU_LISTVIEW': 'Lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Drzewo',
  'DIALOG_FILE_MNU_ICONVIEW': 'Ikony',
  'DIALOG_FILE_ERROR': 'Błąd okna dialogowego pliku',
  'DIALOG_FILE_ERROR_SCANDIR': 'Nie udało się wylistować katalogu \'{0}\' z powodu wystąpienia błędu',
  'DIALOG_FILE_MISSING_FILENAME': 'Zaznacz plik albo wpisz nazwę nowego pliku!',
  'DIALOG_FILE_MISSING_SELECTION': 'Zaznacz plik!',

  'DIALOG_FILEINFO_TITLE': 'Informacje',
  'DIALOG_FILEINFO_LOADING': 'Ładowanie informacji dla: {0}',
  'DIALOG_FILEINFO_ERROR': 'Błąd okna Informacji o pliku',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Nie udało się uzyskać informacji dla **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Nie udało się uzyskać informacji dla: {0}',

  'DIALOG_INPUT_TITLE': 'Wprowadzanie',

  'DIALOG_FILEPROGRESS_TITLE': 'Postęp',
  'DIALOG_FILEPROGRESS_LOADING': 'Ładowanie...',

  'DIALOG_UPLOAD_TITLE': 'Wysyłanie',
  'DIALOG_UPLOAD_DESC': 'Wysyłanie pliku do **{0}**.<br />Maksymalny rozmiar: {1} bitów',
  'DIALOG_UPLOAD_MSG_FMT': 'Wysyłanie \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Wysyłanie pliku...',
  'DIALOG_UPLOAD_FAILED': 'Błąd wywołania',
  'DIALOG_UPLOAD_FAILED_MSG': 'Wywołanie nie powiodło się',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Powód nieznany...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Anulowane przez użytkownika...',
  'DIALOG_UPLOAD_TOO_BIG': 'Plik jest za duży',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Plik jest za duży, przekracza {0}',

  'DIALOG_FONT_TITLE': 'Czcionka',

  'DIALOG_APPCHOOSER_TITLE': 'Wybierz aplikację',
  'DIALOG_APPCHOOSER_MSG': 'Wybierz aplikację do otwarcia',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Wybierz aplikację',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Używaj jako domyślną aplikację do {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Moduł GoogleAPI jest nie skonfigurowany albo jest wyłączony',
  'GAPI_SIGN_OUT': 'Wyloguj z Serwisu Google API',
  'GAPI_REVOKE': 'Odwołaj uprawnienia i wyloguj',
  'GAPI_AUTH_FAILURE': 'Autentykacja Google API nie powiodła się lub nie miała miejsca',
  'GAPI_AUTH_FAILURE_FMT': 'Nie można uwierzytelnić: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Nie można załadować Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Moduł Windows Live API nie jest skonfigurowany albo jest wyłączony',
  'WLAPI_SIGN_OUT': 'Wyloguj z Window Live API',
  'WLAPI_LOAD_FAILURE': 'Nie można załadować Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Nie można zalogować do Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Nie można zalogować do Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API zwróciło status {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Nie mozna utworzyć IndexedDB bez Nazwy Bazy Danych',
  'IDB_NO_SUCH_ITEM': 'Brak takiego elementu',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Błąd krytyczny',
  'ERR_VFS_UNAVAILABLE': 'Niedostępne',
  'ERR_VFS_FILE_ARGS': 'Plik oczekuje co najmniej jednego argumentu',
  'ERR_VFS_NUM_ARGS': 'Za mało argumentów',
  'ERR_VFS_EXPECT_FILE': 'Oczekuje obiektu-pliku',
  'ERR_VFS_EXPECT_SRC_FILE': 'Oczekuje źródłowego obiektu-pliku',
  'ERR_VFS_EXPECT_DST_FILE': 'Oczekuje docelowego obiektu-pliku',
  'ERR_VFS_FILE_EXISTS': 'Plik docelowy istnieje',
  'ERR_VFS_TRANSFER_FMT': 'Wystąpił błąd podczas transferu pomiędzy magazynem: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Nie można wysłać pliku bez celu',
  'ERR_VFS_UPLOAD_NO_FILES': 'Nie można wysłać bez okreslenia plików',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Wysyłanie pliku: {0} nie powiodło się',
  'ERR_VFS_UPLOAD_CANCELLED': 'Wysyłanie pliku zostało anulowane',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Nie można pobrać ścieżki bez wskazania ścieżki',
  'ERR_VFS_DOWNLOAD_FAILED': 'Wystąpił błąd podczas pobierania: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Odpowiedź była pusta',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Pobieranie pliku',

  'ERR_VFSMODULE_XHR_ERROR': 'Błąd XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Nie odnaleziono id głównego folderu',
  'ERR_VFSMODULE_NOSUCH': 'Nie ma takiego pliku',
  'ERR_VFSMODULE_PARENT': 'Nie ma takiego rodzica',
  'ERR_VFSMODULE_PARENT_FMT': 'Nie odnaleziono rodzica: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Nie udało się przeskanować folderu',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Nie udało się przeskanować folderu: {0}',
  'ERR_VFSMODULE_READ': 'Nie udało się odczytać pliku',
  'ERR_VFSMODULE_READ_FMT': 'Nie udało się odczytać pliku: {0}',
  'ERR_VFSMODULE_WRITE': 'Nie udało się zapisać pliku',
  'ERR_VFSMODULE_WRITE_FMT': 'Nie udało się zapisać pliku: {0}',
  'ERR_VFSMODULE_COPY': 'Nie można skopiować',
  'ERR_VFSMODULE_COPY_FMT': 'Kopiowanie: {0} nie powiodło się',
  'ERR_VFSMODULE_UNLINK': 'Nie można odlinkować pliku',
  'ERR_VFSMODULE_UNLINK_FMT': 'Odlinkowanie pliku: {0} nie powiodło się',
  'ERR_VFSMODULE_MOVE': 'Nie można przenieść',
  'ERR_VFSMODULE_MOVE_FMT': 'Przenoszenie: {0} nie powiodło się',
  'ERR_VFSMODULE_EXIST': 'Nie udało się sprawdzić czy plik instnieje',
  'ERR_VFSMODULE_EXIST_FMT': 'Nie udało się sprawdzić czy plik instnieje: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Nie udało się uzyskać informacji o pliku',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Nie udało się uzyskać informacji o pliku: {0}',
  'ERR_VFSMODULE_MKDIR': 'Nie można stworzyć folderu',
  'ERR_VFSMODULE_MKDIR_FMT': 'Tworzenie folderu: {0} nie powiodło się',
  'ERR_VFSMODULE_URL': 'Nie udało się uzyskać adresu URL pliku',
  'ERR_VFSMODULE_URL_FMT': 'Nie udało się uzyskać adresu URL pliku: {0}',
  'ERR_VFSMODULE_TRASH': 'Nie udało się przenieść pliku do kosza',
  'ERR_VFSMODULE_TRASH_FMT': 'Nie udało się przenieść pliku do kosza: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Nie udało się przenieść pliku z kosza',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Nie udało się przenieść pliku z kosza: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Nie udało się wyczyścić kosza',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Nie udało się wyczyścić kosza: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Jesteś zalogowany do Dropbox API',
  'DROPBOX_SIGN_OUT': 'Wylogowano z serwisu Dropbox API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Nie znaleziono pozycji',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Folder instalacyjny pakietów już istnieje. Nie można kontynuować!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Nie można otworzyć',
  'ERR_FILE_APP_OPEN_FMT': 'Plik {0} nie może zostać otwarty ,ponieważ mime {1} nie jest wspierane',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Plik {0} nie może zostać otwarty: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Plik {0} nie może zostać zapisany: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Błąd Aplikacji',
  'ERR_GENERIC_APP_ACTION_FMT': 'Nie udało się przeprowadzić akcji \'{0}\'.',
  'ERR_GENERIC_APP_UNKNOWN': 'Nieznany błąd',
  'ERR_GENERIC_APP_REQUEST': 'Wystąpił błąd podczas obsługi żądania',
  'ERR_GENERIC_APP_FATAL_FMT': 'Błąd krytyczny: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Odrzucić zmiany?',
  'MSG_FILE_CHANGED': 'Plik został zmieniony. Przeładować?',
  'MSG_APPLICATION_WARNING': 'Ostrzeżenie Aplikacji',
  'MSG_MIME_OVERRIDE': 'Typ pliku  "{0}" nie jest wspierany, używając w zamian "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Nieznany',
  'LBL_APPEARANCE': 'Wygląd',
  'LBL_USER': 'Użytkownik',
  'LBL_NAME': 'Nazwa',
  'LBL_APPLY': 'Zastosuj',
  'LBL_FILENAME': 'Nazwa pliku',
  'LBL_PATH': 'Ścieżka',
  'LBL_SIZE': 'Rozmiar',
  'LBL_TYPE': 'Typ',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Ładowanie',
  'LBL_SETTINGS': 'Ustawienia',
  'LBL_ADD_FILE': 'Dodaj plik',
  'LBL_COMMENT': 'Komentarz',
  'LBL_ACCOUNT': 'Konto',
  'LBL_CONNECT': 'Połącz',
  'LBL_ONLINE': 'Połączono',
  'LBL_OFFLINE': 'Rozłączono',
  'LBL_AWAY': 'Zaraz wracam',
  'LBL_BUSY': 'Zajęty',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Pomoc',
  'LBL_ABOUT': 'O',
  'LBL_PANELS': 'Panele',
  'LBL_LOCALES': 'Języki',
  'LBL_THEME': 'Motyw',
  'LBL_COLOR': 'Kolor',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Zabij',
  'LBL_ALIVE': 'Aktywne',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Dodaj',
  'LBL_FONT': 'Czcionka',
  'LBL_YES': 'Tak',
  'LBL_NO': 'Nie',
  'LBL_CANCEL': 'Anuluj',
  'LBL_TOP': 'Góra',
  'LBL_LEFT': 'Lewo',
  'LBL_RIGHT': 'Prawo',
  'LBL_BOTTOM': 'Dół',
  'LBL_CENTER': 'Środek',
  'LBL_FILE': 'Plik',
  'LBL_NEW': 'Nowy',
  'LBL_OPEN': 'Otwórz',
  'LBL_SAVE': 'Zapisz',
  'LBL_SAVEAS': 'Zapisz jako...',
  'LBL_CLOSE': 'Zamknij',
  'LBL_MKDIR': 'Nowy folder',
  'LBL_UPLOAD': 'Wyślij',
  'LBL_VIEW': 'Widok',
  'LBL_EDIT': 'Edytuj',
  'LBL_RENAME': 'Zmień nazwę',
  'LBL_DELETE': 'Usuń',
  'LBL_OPENWITH': 'Otwórz za pomocą ...',
  'LBL_ICONVIEW': 'Ikony',
  'LBL_TREEVIEW': 'Drzewo',
  'LBL_LISTVIEW': 'Lista',
  'LBL_REFRESH': 'Odśwież',
  'LBL_VIEWTYPE': 'Typ widoku',
  'LBL_BOLD': 'Pogrubienie',
  'LBL_ITALIC': 'Kursywa',
  'LBL_UNDERLINE': 'Podkreślenie',
  'LBL_REGULAR': 'Regularne',
  'LBL_STRIKE': 'Przekreślenie',
  'LBL_INDENT': 'Wcięcie',
  'LBL_OUTDENT': 'Outdent',
  'LBL_UNDO': 'Cofnij',
  'LBL_REDO': 'Przywróć',
  'LBL_CUT': 'Wytnij',
  'LBL_UNLINK': 'Odlinkuj',
  'LBL_COPY': 'Kopiuj',
  'LBL_PASTE': 'Wklej',
  'LBL_INSERT': 'Wstaw',
  'LBL_IMAGE': 'Obraz',
  'LBL_LINK': 'Linkuj',
  'LBL_DISCONNECT': 'Rozłącz',
  'LBL_APPLICATIONS': 'Aplikacje',
  'LBL_ADD_FOLDER': 'Dodaj folder',
  'LBL_INFORMATION': 'Informacje',
  'LBL_TEXT_COLOR': 'Kolor tekstu',
  'LBL_BACK_COLOR': 'Kolor tła',
  'LBL_RESET_DEFAULT': 'Przywróć fabryczne',
  'LBL_DOWNLOAD_COMP': 'Pobierz',
  'LBL_ORDERED_LIST': 'Lista',
  'LBL_BACKGROUND_IMAGE': 'Tapeta',
  'LBL_BACKGROUND_COLOR': 'Kolor tła',
  'LBL_UNORDERED_LIST': 'Lista nieuporządkowana',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Tylko-odczyt',
  'LBL_CREATED': 'Utworzono',
  'LBL_MODIFIED': 'Zmodyfikowano',
  'LBL_SHOW_COLUMNS': 'Pokaż kolumny',
  'LBL_MOVE': 'Przenieś',
  'LBL_OPTIONS': 'Opcje',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Folder',
  'LBL_CREATE': 'Utwórz',
  'LBL_BUGREPORT': 'Raport błędu',
  'LBL_INSTALL': 'Instaluj',
  'LBL_UPDATE': 'Aktualizuj',
  'LBL_REMOVE': 'Usuń',
  'LBL_SHOW_SIDEBAR': 'Pokaż pasek',
  'LBL_BACKGROUND': 'Tło',
  'LBL_DESKTOP': 'Pulpit',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Pozycja',
  'LBL_ONTOP': 'Na wierzchu',
  'LBL_ITEMS': 'Elementy',
  'LBL_SOUNDS': 'Dźwięki',
  'LBL_ICONS': 'Ikony',
  'LBL_AUTOHIDE': 'Automatyczne ukrywanie',
  'LBL_OPACITY': 'Przeźroczystość',
  'LBL_USERNAME': 'Nazwa konta',
  'LBL_GROUPS': 'Grupy',
  'LBL_VERSION': 'Wersja',
  'LBL_AUTHOR': 'Autor',
  'LBL_HIDE': 'Ukryj',
  'LBL_APPLICATION': 'Aplikacja',
  'LBL_SCOPE': 'Zasięg',
  'LBL_PACKAGES': 'Pakiety',
  'LBL_GENERAL': 'Ogólne',
  'LBL_DEBUG': 'Debugowanie'
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Operating System
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Erro ao abrir arquivo',
  'ERR_WM_NOT_RUNNING': 'Gerenciador de janelas não está executando',
  'ERR_FILE_OPEN_FMT': 'O arquivo \'**{0}**\' não pôde ser aberto',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Não foi encontrado nenhum aplicativo com suporte para arquivos \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Falha em abrir aplicativo',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Um erro ocorreu na tentativa de abrir: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Falha em construção do aplicativo \'{0}\': {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Falha no init() do aplicativo \'{0}\': {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'O aplicativo \'{0}\' está faltando recursos ou falhou em inicializar!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'O aplicativo \'{0}\' falhou no pré-carregamento: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'O aplicativo \'{0}\' já está aberto e só permite uma instância!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Falha em abrir \'{0}\'. Faltando informação sobre o pacote do aplicativo!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Falha em abrir \'{0}\'. Seu navegador não suporta: {1}',

  'ERR_NO_WM_RUNNING': 'Gerenciador de janelas não está executando',
  'ERR_CORE_INIT_FAILED': 'Falha em inicializar OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Um erro ocorreu enquanto OS.js se inicializava',
  'ERR_CORE_INIT_NO_WM': 'Não é possivel começar OS.js: Nenhum Gerenciador de Janelas encontrado!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Não é possível inciar OS.js: Falha em lançar o Gerenciador de Janelas: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Não é possível iniciar OS.js: Falha em pré-carregar recursos...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Erro no JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Um erro inexperado ocorreu, talvez seja um bug.',

  'ERR_APP_API_ERROR': 'Erro na API do aplicativo',
  'ERR_APP_API_ERROR_DESC_FMT': 'Aplicativo {0} falhou em executar \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Faltando argumento: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Erro desconhecido',

  'ERR_OPERATION_TIMEOUT': 'Operação está demorando muito',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operação está demorando muito ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Você já possui uma janela chamada \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimizar',
  'WINDOW_MAXIMIZE': 'Maximizar',
  'WINDOW_RESTORE': 'Restaurar',
  'WINDOW_CLOSE': 'Fechar',
  'WINDOW_ONTOP_ON': 'No topo (Habilitar)',
  'WINDOW_ONTOP_OFF': 'No topo (Desabilitar)',

  // Handler
  'TITLE_SIGN_OUT': 'Deslogar',
  'TITLE_SIGNED_IN_AS_FMT': 'Logado como: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Você tem certeza que quer sair do OS.js? Todas as configurações e dados das aplicações não salvas serão perdidas!',

  // Service
  'BUGREPORT_MSG': 'Por favor, reporte se você achar que isto é um bug.\nInclue uma breve descrição sobre como ocorreu o erro e, se possível, como refazê-lo',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Logado em serviços externos: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Erro fatal',
  'ERR_UTILS_XHR_FMT': 'Erro de AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Logout (Sair)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Deslogando usuário \'{0}\'.\nVocê quer salvar sessão atual?',

  'DIALOG_CLOSE': 'Fechar',
  'DIALOG_CANCEL': 'Cancelar',
  'DIALOG_APPLY': 'Aplicar',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Mensagem de Atenção',

  'DIALOG_COLOR_TITLE': 'Cores',
  'DIALOG_COLOR_R': 'Vermelho: {0}',
  'DIALOG_COLOR_G': 'Verde: {0}',
  'DIALOG_COLOR_B': 'Azul: {0}',
  'DIALOG_COLOR_A': 'Alfa: {0}',

  'DIALOG_CONFIRM_TITLE': 'Mensagem de Confirmação',

  'DIALOG_ERROR_MESSAGE': 'Mensagem',
  'DIALOG_ERROR_SUMMARY': 'Resumo',
  'DIALOG_ERROR_TRACE': 'Rastro',
  'DIALOG_ERROR_BUGREPORT': 'Relate Bug',

  'DIALOG_FILE_SAVE': 'Salvar',
  'DIALOG_FILE_OPEN': 'Abrir',
  'DIALOG_FILE_MKDIR': 'Novo diretório',
  'DIALOG_FILE_MKDIR_MSG': 'Criar novo diretório em **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Você realmente quer sobrescrever o arquivo \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Visuaizar tipo',
  'DIALOG_FILE_MNU_LISTVIEW': 'Visualizar em lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Visualizar em árvore',
  'DIALOG_FILE_MNU_ICONVIEW': 'Visualizar em ícones',
  'DIALOG_FILE_ERROR': 'Mensagem de erro com arquivo',
  'DIALOG_FILE_ERROR_SCANDIR': 'Falha na listagem do diretório \'{0}\' por um erro',
  'DIALOG_FILE_MISSING_FILENAME': 'Você precisa selecionar um arquivo ou introduzir um nome para o novo arquivo!',
  'DIALOG_FILE_MISSING_SELECTION': 'Você precisa selecionar um arquivo!',

  'DIALOG_FILEINFO_TITLE': 'Informação do arquivo',
  'DIALOG_FILEINFO_LOADING': 'Carregando informação do arquivo: {0}',
  'DIALOG_FILEINFO_ERROR': 'Mensagem de erro sobre informação de arquivo',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Falha em obter informação do arquivo **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Falha em obter informação do arquivo: {0}',

  'DIALOG_INPUT_TITLE': 'Diálogo de entrada',

  'DIALOG_FILEPROGRESS_TITLE': 'Operação em progresso',
  'DIALOG_FILEPROGRESS_LOADING': 'Carregando...',

  'DIALOG_UPLOAD_TITLE': 'Janela de Upload',
  'DIALOG_UPLOAD_DESC': 'Upload de arquivo **{0}**.<br />Tamanho máximo: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Fazendo upload \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Fazendo upload do arquivo...',
  'DIALOG_UPLOAD_FAILED': 'Upload falhou',
  'DIALOG_UPLOAD_FAILED_MSG': 'O upload falhou',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Razão desconhecida...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancelado pelo usuário...',
  'DIALOG_UPLOAD_TOO_BIG': 'O arquivo é muito grande',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'O arqyuvo é muito grande, excede {0}',

  'DIALOG_FONT_TITLE': 'Janela de tipografia',

  'DIALOG_APPCHOOSER_TITLE': 'Escolher aplicação',
  'DIALOG_APPCHOOSER_MSG': 'Escolhar uma aplicação para abrir',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Precisa escolher uma aplicação',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Usar como aplicação padrão para {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Módulo do GoogleAPI não está configurado ou está desativado',
  'GAPI_SIGN_OUT': 'Desconectar dos serviços do Google API',
  'GAPI_REVOKE': 'Retirar permissões e desconectar',
  'GAPI_AUTH_FAILURE': 'A tentativa de autenticação com o Google API falhou',
  'GAPI_AUTH_FAILURE_FMT': 'Falha ao tentar autenticar: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Não pôde carregar Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Módulo do Windows Live API não está configurado ou está desativado',
  'WLAPI_SIGN_OUT': 'Desconectar do Window Live API',
  'WLAPI_LOAD_FAILURE': 'Falha em carregar Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Falha em conectar ao Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Falha em conectar ao Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API retornou código {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Não é possível criar IndexedDB sem nome do Banco de Dados',
  'IDB_NO_SUCH_ITEM': 'Não existe este elemento',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Erro fatal',
  'ERR_VFS_UNAVAILABLE': 'Não está disponível',
  'ERR_VFS_FILE_ARGS': 'Arquivo espera ao menos um argumento',
  'ERR_VFS_NUM_ARGS': 'Argumentos insuficientes',
  'ERR_VFS_EXPECT_FILE': 'Espera ao menos um objeto de arquivo',
  'ERR_VFS_EXPECT_SRC_FILE': 'Espera ao menos a origem de um objeto de arquivo',
  'ERR_VFS_EXPECT_DST_FILE': 'Espera ao menos o destino de um objeto de arquivo',
  'ERR_VFS_FILE_EXISTS': 'Destino já existe',
  'ERR_VFS_TRANSFER_FMT': 'Um erro ocorreu ao transferir entre discos de armazenamento: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Não é possível fazer upload de arquivo sem destino',
  'ERR_VFS_UPLOAD_NO_FILES': 'Não é possível fazer upload sem arquivos definidos',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Falha em upload: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Upload foi cancelado',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Não é possível fazer download de destino sem destino',
  'ERR_VFS_DOWNLOAD_FAILED': 'Ocorreu um erro enquanto fazia download: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Resposta vazia',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Fazendo download de arquivo',

  'ERR_VFSMODULE_XHR_ERROR': 'Erro XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Falha em achar a raiz do diretório',
  'ERR_VFSMODULE_NOSUCH': 'Arquivo não existe',
  'ERR_VFSMODULE_PARENT': 'Não existe o pai',
  'ERR_VFSMODULE_PARENT_FMT': 'Falha em encontrar o pai: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Falhou em localizar o diretório',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Falhou em localizar o diretório: {0}',
  'ERR_VFSMODULE_READ': 'Falha em ler o arquivo',
  'ERR_VFSMODULE_READ_FMT': 'Falha em ler o arquivo: {0}',
  'ERR_VFSMODULE_WRITE': 'Falha em escrever o arquivo',
  'ERR_VFSMODULE_WRITE_FMT': 'Falha em escrever o arquivo: {0}',
  'ERR_VFSMODULE_COPY': 'Cópia falhou',
  'ERR_VFSMODULE_COPY_FMT': 'Cópia falhou: {0}',
  'ERR_VFSMODULE_UNLINK': 'Falha em desvincular o arquivo',
  'ERR_VFSMODULE_UNLINK_FMT': 'Falha em desvincular o arquivo: {0}',
  'ERR_VFSMODULE_MOVE': 'Falha em mover o arquivo',
  'ERR_VFSMODULE_MOVE_FMT': 'Falha em mover o arquivo: {0}',
  'ERR_VFSMODULE_EXIST': 'Falha em conferir a existência do arquivo',
  'ERR_VFSMODULE_EXIST_FMT': 'Falha em conferir a existência do arquivo: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Falha em obter informação do arquivo',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Falha em obter informação do arquivo: {0}',
  'ERR_VFSMODULE_MKDIR': 'Falha em criar diretório',
  'ERR_VFSMODULE_MKDIR_FMT': 'Falha em criar diretório: {0}',
  'ERR_VFSMODULE_URL': 'Falha em obter URL do arquivo',
  'ERR_VFSMODULE_URL_FMT': 'Falha em obter URL do arquivo: {0}',
  'ERR_VFSMODULE_TRASH': 'Falha em mover arquivo para lixeira',
  'ERR_VFSMODULE_TRASH_FMT': 'Falha em mover arquivo para lixeira: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Falha em recuperar arquivo da lixeira',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Falha em recuperar arquivo da lixeira: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Falha em esvaziar a lixeira',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Falha em esvaziar a lixeira: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Você logou à API do Dropbox',
  'DROPBOX_SIGN_OUT': 'Desconectar dos serviços da API do Google',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Falha em encontrar a rota: arquivo não encontrado',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Diretório de instalação já existe, por favor escolha outro para continuar',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Não é possível abrir o arquivo',
  'ERR_FILE_APP_OPEN_FMT': 'O arquivo {0} não pode ser aberto pois não existe suporte para {1}',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'O arquivo {0} não pode ser aberto: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'O arquivo {0} Não pode ser salvo: {1}',
  'ERR_GENERIC_APP_FMT': 'O aplicativo encontrou um erro {0}',
  'ERR_GENERIC_APP_ACTION_FMT': 'Falha em realizar ação \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Erro desconhecido',
  'ERR_GENERIC_APP_REQUEST': 'Um erro ocorreu durante sua requisição',
  'ERR_GENERIC_APP_FATAL_FMT': 'Erro fatal: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Descartar mudanças?',
  'MSG_FILE_CHANGED': 'O arquivo sofreu alterações. Recarregar?',
  'MSG_APPLICATION_WARNING': 'Advertência do aplicativo',
  'MSG_MIME_OVERRIDE': 'A extensão "{0}" não é suportada, usando "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Desconhecido',
  'LBL_APPEARANCE': 'Aparência',
  'LBL_USER': 'Usuário',
  'LBL_NAME': 'Nome',
  'LBL_APPLY': 'Aplicar',
  'LBL_FILENAME': 'Nome do arquivo',
  'LBL_PATH': 'Caminho',
  'LBL_SIZE': 'Tamanho',
  'LBL_TYPE': 'Tipo',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Carregando',
  'LBL_SETTINGS': 'Configurações',
  'LBL_ADD_FILE': 'Adicionar arquivo',
  'LBL_COMMENT': 'Comentário',
  'LBL_ACCOUNT': 'Conta',
  'LBL_CONNECT': 'Conectar',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Indisponível',
  'LBL_BUSY': 'Ocupado',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Ajuda',
  'LBL_ABOUT': 'Sobre',
  'LBL_PANELS': 'Paineis',
  'LBL_LOCALES': 'Internacionalização',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Cor',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Kill',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Índice',
  'LBL_ADD': 'Adicionar',
  'LBL_FONT': 'Tipografia',
  'LBL_YES': 'Sim',
  'LBL_NO': 'Não',
  'LBL_CANCEL': 'Cancelar',
  'LBL_TOP': 'Acima',
  'LBL_LEFT': 'Esquerda',
  'LBL_RIGHT': 'Direita',
  'LBL_BOTTOM': 'Abaixo',
  'LBL_CENTER': 'Centro',
  'LBL_FILE': 'Arquivo',
  'LBL_NEW': 'Novo',
  'LBL_OPEN': 'Abrir',
  'LBL_SAVE': 'Salvar',
  'LBL_SAVEAS': 'Salvar como...',
  'LBL_CLOSE': 'Fechar',
  'LBL_MKDIR': 'Criar diretório',
  'LBL_UPLOAD': 'Fazer upload',
  'LBL_VIEW': 'Visualizar',
  'LBL_EDIT': 'Editar',
  'LBL_RENAME': 'Renomear',
  'LBL_DELETE': 'Excluir',
  'LBL_OPENWITH': 'Abrir com...',
  'LBL_ICONVIEW': 'Visualização por ícones',
  'LBL_TREEVIEW': 'Visualização por árvore',
  'LBL_LISTVIEW': 'Visualização por lista',
  'LBL_REFRESH': 'Recarregar',
  'LBL_VIEWTYPE': 'Ver tipo',
  'LBL_BOLD': 'Negrito',
  'LBL_ITALIC': 'Itálico',
  'LBL_UNDERLINE': 'Sublinhado',
  'LBL_REGULAR': 'Regular',
  'LBL_STRIKE': 'Rsicado',
  'LBL_INDENT': 'Indentar',
  'LBL_OUTDENT': 'Voltar',
  'LBL_UNDO': 'Desfazer',
  'LBL_REDO': 'Refazer',
  'LBL_CUT': 'Cortar',
  'LBL_UNLINK': 'Desvincular',
  'LBL_COPY': 'Copiar',
  'LBL_PASTE': 'Colar',
  'LBL_INSERT': 'Inserir',
  'LBL_IMAGE': 'Imagem',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Desconectar',
  'LBL_APPLICATIONS': 'Aplicativos',
  'LBL_ADD_FOLDER': 'Adicionar diretório',
  'LBL_INFORMATION': 'Informação',
  'LBL_TEXT_COLOR': 'Cor do texto',
  'LBL_BACK_COLOR': 'Cor de fundo',
  'LBL_RESET_DEFAULT': 'Redefinir usando valores padrões',
  'LBL_DOWNLOAD_COMP': 'Fazer download para o computador',
  'LBL_ORDERED_LIST': 'Lista ordenada',
  'LBL_BACKGROUND_IMAGE': 'Imagem de fundo',
  'LBL_BACKGROUND_COLOR': 'Cor de fundo',
  'LBL_UNORDERED_LIST': 'Lista não ordenada',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Somente leitura',
  'LBL_CREATED': 'Criado',
  'LBL_MODIFIED': 'Modificado',
  'LBL_SHOW_COLUMNS': 'Mostrar colunas',
  'LBL_MOVE': 'Mover',
  'LBL_OPTIONS': 'Opções',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Diretório',
  'LBL_CREATE': 'Criar',
  'LBL_BUGREPORT': 'Reportar Bug',
  'LBL_INSTALL': 'Instalar',
  'LBL_UPDATE': 'Atualizar',
  'LBL_REMOVE': 'Remover'
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': 'Ошибка открытия файла',
  'ERR_WM_NOT_RUNNING': 'Менеджер окон не запущен',
  'ERR_FILE_OPEN_FMT': 'Файл \'**{0}**\' не может быть открыт',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Неудалось найти приложение, способное открыть файл \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Ошибка запуска приложения',
  'ERR_APP_LAUNCH_FAILED_FMT': 'При попытке запуска, произошла следующая ошибка: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Ошибка при построении приложения \'{0}\': {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Ошибка инициализации в приложении \'{0}\' (init()): {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Для приложения \'{0}\' отсутсвует ресурс или ошибка при его загрузке!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Ошибка предварительной загрузки приложения \'{0}\': \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Приложение \'{0}\' уже запущено и единовременно поддерживает только одну копию!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Ошибка запуска \'{0}\'. Отсутствует манифест данных для приложения!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Ошибка запуска \'{0}\'. Ваш браузер не поддерживает: {1}',

  'ERR_NO_WM_RUNNING': 'Не запущен оконный менеджер',
  'ERR_CORE_INIT_FAILED': 'Ошибка инициализации OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Произошла ошибка в момент инициализации OS.js',
  'ERR_CORE_INIT_NO_WM': 'Невозможно запустить OS.js: Оконный менеджер не определен!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Невозможно запустить OS.js из-за ошибки при запуске оконного менеджера: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Невозможно запустить OS.js: Ошибка при предзагрузке ресурсов..',
  'ERR_JAVASCRIPT_EXCEPTION': 'Отчет об ошибке в JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Произошла непредвиденная ошибка, возможно баг.',

  'ERR_APP_API_ERROR': 'Ошибка связанная с API приложения',
  'ERR_APP_API_ERROR_DESC_FMT': 'Приложению {0} не удалось выполнить операцию \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Пропущен аргумент: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Неизвестная ошибка',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'У вас уже присутствует окно с названием \'{0}\'',
  'WINDOW_MINIMIZE': 'Свернуть',
  'WINDOW_MAXIMIZE': 'Развернуть',
  'WINDOW_RESTORE': 'Восстановить',
  'WINDOW_CLOSE': 'Закрыть',
  'WINDOW_ONTOP_ON': 'Поверх всех окон (Включить)',
  'WINDOW_ONTOP_OFF': 'Поверх всех окон (Выключить)',

  // Handler
  'TITLE_SIGN_OUT': 'Выйти',
  'TITLE_SIGNED_IN_AS_FMT': 'Вы вошли как: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': 'Выйти (Выход)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Выход как пользователь: \'{0}\'.\nЖелаете сохранить текущую сессию?',

  'DIALOG_CLOSE': 'Закрыть',
  'DIALOG_CANCEL': 'Отменить',
  'DIALOG_APPLY': 'Применить',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Внимание',

  'DIALOG_COLOR_TITLE': 'Цвет',
  'DIALOG_COLOR_R': 'Красный: {0}',
  'DIALOG_COLOR_G': 'Зеленый: {0}',
  'DIALOG_COLOR_B': 'Синий: {0}',
  'DIALOG_COLOR_A': 'Прозрачность: {0}',

  'DIALOG_CONFIRM_TITLE': 'Подтверждение',

  'DIALOG_ERROR_MESSAGE': 'Сообщение',
  'DIALOG_ERROR_SUMMARY': 'Сводка',
  'DIALOG_ERROR_TRACE': 'Цепочка вызовов',
  'DIALOG_ERROR_BUGREPORT': 'Отчет об ошибке',

  'DIALOG_FILE_SAVE': 'Сохранить',
  'DIALOG_FILE_OPEN': 'Открыть',
  'DIALOG_FILE_MKDIR': 'Новая папка',
  'DIALOG_FILE_MKDIR_MSG': 'Создать новый каталог в **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Вы уверены, что хотите перезаписать файл \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Режим просмотра',
  'DIALOG_FILE_MNU_LISTVIEW': 'Список',
  'DIALOG_FILE_MNU_TREEVIEW': 'Древовидный',
  'DIALOG_FILE_MNU_ICONVIEW': 'Значки',
  'DIALOG_FILE_ERROR': 'Ошибка связанная с FileDialog',
  'DIALOG_FILE_ERROR_SCANDIR': 'Не удалось отобразить содержимое \'{0}\', произошла ошибка',
  'DIALOG_FILE_MISSING_FILENAME': 'Выберите файл или введите новое имя файла!',
  'DIALOG_FILE_MISSING_SELECTION': 'Выберите файл!',

  'DIALOG_FILEINFO_TITLE': 'Информация о файле',
  'DIALOG_FILEINFO_LOADING': 'Загрузка информации о файле: {0}',
  'DIALOG_FILEINFO_ERROR': 'Ошибка связанная с FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Ошибка при получения информации о файле **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Ошибка при получения информации о файле: {0}',

  'DIALOG_INPUT_TITLE': 'Диалог ввода',

  'DIALOG_FILEPROGRESS_TITLE': 'Состояние операции над файлом',
  'DIALOG_FILEPROGRESS_LOADING': 'Загрузка...',

  'DIALOG_UPLOAD_TITLE': 'Загрузка',
  'DIALOG_UPLOAD_DESC': 'Загрузка файла **{0}**.<br />Максимальный размер: {1} байт',
  'DIALOG_UPLOAD_MSG_FMT': 'Загрузка \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Загрузка файла...',
  'DIALOG_UPLOAD_FAILED': 'Загрузка не удалась',
  'DIALOG_UPLOAD_FAILED_MSG': 'Загрузка завершилась неудачей',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Причина неизвестна...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Отменено пользователем...',

  'DIALOG_FONT_TITLE': 'Шрифт',

  'DIALOG_APPCHOOSER_TITLE': 'Выберите приложение',
  'DIALOG_APPCHOOSER_MSG': 'Выберите приложение для открытия',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Вам необходимо выбрать приложение',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Использовать в качестве приложения по умолчанию для {0}',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI модуль не настроен или отключен',
  'GAPI_SIGN_OUT': 'Выйти из API служб Google',
  'GAPI_REVOKE': 'Отозвать права доступа и выйти',
  'GAPI_AUTH_FAILURE': 'Не удалось аутентифицировать Google API',
  'GAPI_AUTH_FAILURE_FMT': 'Не удалось проверить подлинность: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Не удалось загрузить Google API',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Не удается создать IndexedDB без названия',
  'IDB_NO_SUCH_ITEM': 'Ничего не удалось найти',

  // VFS
  'ERR_VFS_FATAL': 'Критическая ошибка',
  'ERR_VFS_FILE_ARGS': 'Файл ожидает по меньшей мере один аргумент',
  'ERR_VFS_NUM_ARGS': 'Недостаточно аргументов',
  'ERR_VFS_EXPECT_FILE': 'Ожидается file-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Ожидается источник file-object',
  'ERR_VFS_EXPECT_DST_FILE': 'Ожидается имя файла file-object',
  'ERR_VFS_FILE_EXISTS': 'Файл с таким именем уже существует',
  'ERR_VFS_TRANSFER_FMT': 'Произошла ошибка во время переноса между хранилищами: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Невозможно загрузить файл, без указания имени',
  'ERR_VFS_UPLOAD_NO_FILES': 'Не определены файлы для загрузки',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Загрузка файла не удалась: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Загрузка файла была отменена',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Невозможно скачать каталог без пути',
  'ERR_VFS_DOWNLOAD_FAILED': 'Произошла ошибка при загрузке: {0}',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Скачивание файла',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': 'Невозможно открыть файл',
  'ERR_FILE_APP_OPEN_FMT': 'Файл {0} не может быть открыт, mime-type {1} не поддерживается',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Файл {0} не может быть открыт: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Файл {0} не может быть сохранен: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Ошибка приложения',
  'ERR_GENERIC_APP_ACTION_FMT': 'Не удалось выполнить действие \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Неизвестная ошибка',
  'ERR_GENERIC_APP_REQUEST': 'Произошла ошибка при обработке вашего запроса',
  'ERR_GENERIC_APP_FATAL_FMT': 'Критическая ошибка: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Отменить изменения?',
  'MSG_FILE_CHANGED': 'Файл был изменен. Перезагрузить?',
  'MSG_APPLICATION_WARNING': 'Предупреждение',
  'MSG_MIME_OVERRIDE': 'Тип файла "{0}" не поддерживается, используете "{1}".',

  // General
  'LBL_UNKNOWN': 'Неизвестный',
  'LBL_APPEARANCE': 'Появление',
  'LBL_USER': 'Пользователь',
  'LBL_NAME': 'Название',
  'LBL_APPLY': 'Применить',
  'LBL_FILENAME': 'Имя файла',
  'LBL_PATH': 'Путь',
  'LBL_SIZE': 'Размер',
  'LBL_TYPE': 'Тип',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Загрузка',
  'LBL_SETTINGS': 'Настройки',
  'LBL_ADD_FILE': 'Добавить файл',
  'LBL_COMMENT': 'Комментарий',
  'LBL_ACCOUNT': 'Учетная запись',
  'LBL_CONNECT': 'Подключиться',
  'LBL_ONLINE': 'В сети',
  'LBL_OFFLINE': 'Не в сети',
  'LBL_AWAY': 'Отошел',
  'LBL_BUSY': 'Занят',
  'LBL_CHAT': 'Чат',
  'LBL_HELP': 'Помощь',
  'LBL_ABOUT': 'О программе',
  'LBL_PANELS': 'Панели',
  'LBL_LOCALES': 'Языки',
  'LBL_THEME': 'Тема',
  'LBL_COLOR': 'Цвет',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Завершить',
  'LBL_ALIVE': 'Работает',
  'LBL_INDEX': 'Индекс',
  'LBL_ADD': 'Добавить',
  'LBL_FONT': 'Шрифт',
  'LBL_YES': 'Да',
  'LBL_NO': 'Нет',
  'LBL_CANCEL': 'Отмена',
  'LBL_TOP': 'Верх',
  'LBL_LEFT': 'Лево',
  'LBL_RIGHT': 'Право',
  'LBL_BOTTOM': 'Низ',
  'LBL_CENTER': 'Центр',
  'LBL_FILE': 'Файл',
  'LBL_NEW': 'Новый',
  'LBL_OPEN': 'Открыть',
  'LBL_SAVE': 'Сохранить',
  'LBL_SAVEAS': 'Сохранить как...',
  'LBL_CLOSE': 'Закрыть',
  'LBL_MKDIR': 'Создать каталог',
  'LBL_UPLOAD': 'Загрузить',
  'LBL_VIEW': 'Вид',
  'LBL_EDIT': 'Редактировать',
  'LBL_RENAME': 'Переименовать',
  'LBL_DELETE': 'Удалить',
  'LBL_OPENWITH': 'Открыть в ...',
  'LBL_ICONVIEW': 'Значки',
  'LBL_TREEVIEW': 'Древовидный',
  'LBL_LISTVIEW': 'Список',
  'LBL_REFRESH': 'Обновить',
  'LBL_VIEWTYPE': 'Режим просмотра',
  'LBL_BOLD': 'Полужирный',
  'LBL_ITALIC': 'Курсив',
  'LBL_UNDERLINE': 'Подчеркнутый',
  'LBL_REGULAR': 'Обычный',
  'LBL_STRIKE': 'Перечеркнутый',
  'LBL_INDENT': 'Уменьшить отступ',
  'LBL_OUTDENT': 'Увеличить отступ',
  'LBL_UNDO': 'Отменить',
  'LBL_REDO': 'Повторить',
  'LBL_CUT': 'Вырезать',
  'LBL_UNLINK': 'Удалить ссылку',
  'LBL_COPY': 'Копировать',
  'LBL_PASTE': 'Вставить',
  'LBL_INSERT': 'Вставка',
  'LBL_IMAGE': 'Изображение',
  'LBL_LINK': 'Ссылка',
  'LBL_DISCONNECT': 'Отключиться',
  'LBL_APPLICATIONS': 'Приложения',
  'LBL_ADD_FOLDER': 'Добавить папку',
  'LBL_INFORMATION': 'Информация',
  'LBL_TEXT_COLOR': 'Цвет текста',
  'LBL_BACK_COLOR': 'Цвет фона',
  'LBL_RESET_DEFAULT': 'Сбросить к стандартным',
  'LBL_DOWNLOAD_COMP': 'Скачать',
  'LBL_ORDERED_LIST': 'Нумерованный список',
  'LBL_BACKGROUND_IMAGE': 'Фоновое изображение',
  'LBL_BACKGROUND_COLOR': 'Фоновый цвет',
  'LBL_UNORDERED_LIST': 'Неупорядоченный список',
  'LBL_SHOW_SIDEBAR': 'Отобразить боковую панель',
  'LBL_BACKGROUND': 'Фон',
  'LBL_DESKTOP': 'Настройки',
  'LBL_PANEL': 'Панель',
  'LBL_POSITION': 'Расположение',
  'LBL_ONTOP': 'Вверху',
  'LBL_ITEMS': 'Элементы',
  'LBL_AUTOHIDE': 'Автоматически скрывать',
  'LBL_OPACITY': 'Прозрачность',
  'LBL_GENERAL': 'Основные',
  'LBL_DEBUG': 'Отладка'
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Chyba pri otváraní súboru',
  'ERR_WM_NOT_RUNNING': 'Správca okien nebeží',
  'ERR_FILE_OPEN_FMT': 'Súbor \'**{0}**\' sa nedá otvoriť',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Neviem nájsť Aplikáciu pre otvorenie súboru \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Chyba pri spúšťaní Aplikácie',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Nastala chyba pri spúšťaní Aplikácie: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Aplikácia \'{0}\' chyba pri konštrukcii: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Aplikácia \'{0}\' chyba pri funkcii init(): {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Aplikácia \'{0}\' chýbajú prostriedky pre spustenie alebo nastala chyba pri zavádzaní!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Aplikácia \'{0}\' chyba pri zavádzaní: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Aplikácia \'{0}\' už beží a je povolená iba jedna inštancia!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Chyba pri spustení \'{0}\'. Súpisné dáta Aplikácie sa nenašli!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Chyba pri spustení \'{0}\'. Váš prehliadač nie je podporovaný: {1}',

  'ERR_NO_WM_RUNNING': 'Správca okien nebeží',
  'ERR_CORE_INIT_FAILED': 'Chyba pri inicializácii OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Nastala chyba pri inicializácii OS.js',
  'ERR_CORE_INIT_NO_WM': 'Nemôžem spustiť OS.js: Nie je definovaný žiadny Správca okien!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Nemôžem spustiť OS.js: Chyba pri spúšťaní Správcu okien: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Nemôžem spustiť OS.js: Chyba pri zavádzaní prostriedkov...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Chybová správa JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Vyskytla sa neočakávaná chyba, možno sa jedná o chybu v programe.',

  'ERR_APP_API_ERROR': 'Chyba v API Aplikácie',
  'ERR_APP_API_ERROR_DESC_FMT': 'Aplikácia {0} chyba pri vykonávaní operácie \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Chýbajúci argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Neznáma chyba',

  'ERR_OPERATION_TIMEOUT': 'Časový limit vypršal',
  'ERR_OPERATION_TIMEOUT_FMT': 'Časový limit vypršal ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Okno s názvom \'{0}\' už existuje',
  'WINDOW_MINIMIZE': 'Minimalizovať',
  'WINDOW_MAXIMIZE': 'Maximalizovať',
  'WINDOW_RESTORE': 'Obnoviť',
  'WINDOW_CLOSE': 'Zatvoriť',
  'WINDOW_ONTOP_ON': 'Vždy na vrchu (Zapnúť)',
  'WINDOW_ONTOP_OFF': 'Vždy na vrchu (Vypnúť)',

  // Handler
  'TITLE_SIGN_OUT': 'Odhlásiť sa',
  'TITLE_SIGNED_IN_AS_FMT': 'Prihlásený ako: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Ste si istý že chcete opustiť OS.js? Všetky neuložené nastavenia a dáta aplikácii budú vymazané!',

  // Service
  'BUGREPORT_MSG': 'Prosím nahláste túto chybu, ak si myslíte že sa jedná o chybu aplikácie.\nPripojte krátky popis ako k chybe došlo, a ak je to možné informáciu ako ju môžeme zopakovať',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Prihlásený k externej službe: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatálna chyba',
  'ERR_UTILS_XHR_FMT': 'Chyba AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Odhlásiť sa (Ukončiť)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Odhlásenie užívateľa \'{0}\'.\nŽeláte si uložiť nastavenia?',

  'DIALOG_CLOSE': 'Zatvor',
  'DIALOG_CANCEL': 'Zrušiť',
  'DIALOG_APPLY': 'Použiť',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Výstraha',

  'DIALOG_COLOR_TITLE': 'Výber farby',
  'DIALOG_COLOR_R': 'Červená: {0}',
  'DIALOG_COLOR_G': 'Zelená: {0}',
  'DIALOG_COLOR_B': 'Modrá: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Potvrdiť',

  'DIALOG_ERROR_MESSAGE': 'Správa',
  'DIALOG_ERROR_SUMMARY': 'Sumár',
  'DIALOG_ERROR_TRACE': 'Stopovanie',
  'DIALOG_ERROR_BUGREPORT': 'Nahlásiť chybu',

  'DIALOG_FILE_SAVE': 'Uložiť',
  'DIALOG_FILE_OPEN': 'Otvoriť',
  'DIALOG_FILE_MKDIR': 'Nový adresár',
  'DIALOG_FILE_MKDIR_MSG': 'Vytvor nový adresár v **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Ste si istý že chcete nahradiť súbor \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Zobraziť ako',
  'DIALOG_FILE_MNU_LISTVIEW': 'Zoznam',
  'DIALOG_FILE_MNU_TREEVIEW': 'Strom',
  'DIALOG_FILE_MNU_ICONVIEW': 'Ikony',
  'DIALOG_FILE_ERROR': 'Chyba pri práci so súborom',
  'DIALOG_FILE_ERROR_SCANDIR': 'Chyba pri čítaní adresára \'{0}\'',
  'DIALOG_FILE_MISSING_FILENAME': 'Vyberte si súbor alebo zadajte meno nového súboru',
  'DIALOG_FILE_MISSING_SELECTION': 'Vyberte si súbor!',

  'DIALOG_FILEINFO_TITLE': 'Informácie o súbore',
  'DIALOG_FILEINFO_LOADING': 'Nahrávam informácie o súbore: {0}',
  'DIALOG_FILEINFO_ERROR': 'Chyba pri získavaní informácií o súbore',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Nie je možné získať informácie o **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Nie je možné získať informácie o súbore: {0}',

  'DIALOG_INPUT_TITLE': 'Vstupný dialóg',

  'DIALOG_FILEPROGRESS_TITLE': 'Stav práce so súborom',
  'DIALOG_FILEPROGRESS_LOADING': 'Nahrávam...',

  'DIALOG_UPLOAD_TITLE': 'Nahraj na server',
  'DIALOG_UPLOAD_DESC': 'Nahrávam súbor do **{0}**.<br />Maximálna veľkosť" {1} bajtov',
  'DIALOG_UPLOAD_MSG_FMT': 'Nahrávam na server \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Nahrávam súbor na server...',
  'DIALOG_UPLOAD_FAILED': 'Nahrávanie na server sa nepodarilo',
  'DIALOG_UPLOAD_FAILED_MSG': 'Nahrávanie na server sa nepodarilo',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Neznámy dôvod...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Zrušené užívateľom...',
  'DIALOG_UPLOAD_TOO_BIG': 'Súbor je príliš veľký',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Súbor je príliš veľký, presahuje {0}',

  'DIALOG_FONT_TITLE': 'Výber písma',

  'DIALOG_APPCHOOSER_TITLE': 'Vyberte Aplikáciu',
  'DIALOG_APPCHOOSER_MSG': 'Vyberte Aplikáciu ktorou chcete otvoriť',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Vyberte si aplikáciu',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Použi ako východziu aplikáciu pre {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modul je vypnutý alebo nie je nakonfigurovaný',
  'GAPI_SIGN_OUT': 'Odhlásiť sa z Google API Services',
  'GAPI_REVOKE': 'Odobrať práva a odhlásiť',
  'GAPI_AUTH_FAILURE': 'Google API autentifikácia sa nepodarila alebo sa neuskutočnila',
  'GAPI_AUTH_FAILURE_FMT': 'Nepodarilo sa autentifikovať: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Chyba pri nahrávaní Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API modul je vypnutý alebo nie je nakonfigurovaný',
  'WLAPI_SIGN_OUT': 'Odhlásiť sa z Window Live API',
  'WLAPI_LOAD_FAILURE': 'Chyba pri nahrávaní Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Chyba pri prihlasovaní do Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Chyba pri prihlasovaní do Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API vrátil status {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Nemôžem vytvoriť IndexedDB bez mena databázy',
  'IDB_NO_SUCH_ITEM': 'Položka neexistuje',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Fatálna chyba',
  'ERR_VFS_UNAVAILABLE': 'Nie je dostupný',
  'ERR_VFS_FILE_ARGS': 'Súbor vyžaduje aspoň jeden argument',
  'ERR_VFS_NUM_ARGS': 'Málo argumentov',
  'ERR_VFS_EXPECT_FILE': 'Očakáva súbor-objekt',
  'ERR_VFS_EXPECT_SRC_FILE': 'Očakáva zdrojový súbor-objekt',
  'ERR_VFS_EXPECT_DST_FILE': 'Očakáva cieľový súbor-objekt',
  'ERR_VFS_FILE_EXISTS': 'Cieľ už existuje',
  'ERR_VFS_TRANSFER_FMT': 'Nastala chyba počas prenosu medzi úložiskom: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Nemôžem nahrať na server súbor bez špecifikovaného cieľa',
  'ERR_VFS_UPLOAD_NO_FILES': 'Nemôžem nahrať na server bez špecifikovaných súborov',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Nepodarilo sa nahrať na server: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Nahrávanie na server bolo zrušené',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Nemôžem stiahnuť cestu k súboru',
  'ERR_VFS_DOWNLOAD_FAILED': 'Nastala chyba pri sťahovaní: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Prázdna odpoveď',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Sťahujem súbor',

  'ERR_VFSMODULE_XHR_ERROR': 'Chyba XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Nepodarilo sa nájsť id hlavného (koreňového) adresára',
  'ERR_VFSMODULE_NOSUCH': 'Súbor neexistuje',
  'ERR_VFSMODULE_PARENT': 'Nadradený adresár neexistuje',
  'ERR_VFSMODULE_PARENT_FMT': 'Nepodarilo sa nájsť nadradený adresár: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Chyba pri čítaní adresára',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Chyba pri čítaní adresára: {0}',
  'ERR_VFSMODULE_READ': 'Chyba pri čítaní súboru',
  'ERR_VFSMODULE_READ_FMT': 'Chyba pri čítaní súboru: {0}',
  'ERR_VFSMODULE_WRITE': 'Chyba pri zápise do súboru',
  'ERR_VFSMODULE_WRITE_FMT': 'Chyba pri zápise do súboru: {0}',
  'ERR_VFSMODULE_COPY': 'Chyba pri kopírovaní',
  'ERR_VFSMODULE_COPY_FMT': 'Chyba pri kopírovaní: {0}',
  'ERR_VFSMODULE_UNLINK': 'Chyba pri mazaní súboru',
  'ERR_VFSMODULE_UNLINK_FMT': 'Chyba pri mazaní súboru: {0}',
  'ERR_VFSMODULE_MOVE': 'Chyba pri presune súboru',
  'ERR_VFSMODULE_MOVE_FMT': 'Chyba pri presune súboru: {0}',
  'ERR_VFSMODULE_EXIST': 'Chyba pri overovaní existenciu súboru',
  'ERR_VFSMODULE_EXIST_FMT': 'Chyba pri overovaní existenciu súboru: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Chyba pri získavaní informácií o súbore',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Chyba pri získavaní informácií o súbore: {0}',
  'ERR_VFSMODULE_MKDIR': 'Chyba pri vytváraní adresára',
  'ERR_VFSMODULE_MKDIR_FMT': 'Chyba pri vytváraní adresára: {0}',
  'ERR_VFSMODULE_URL': 'Chyba pri získavaní URL pre súbor',
  'ERR_VFSMODULE_URL_FMT': 'Chyba pri získavaní URL pre súbor: {0}',
  'ERR_VFSMODULE_TRASH': 'Chyba pri presune súboru do koša',
  'ERR_VFSMODULE_TRASH_FMT': 'Chyba pri presune súboru do koša: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Chyba pri presune súboru z koša',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Chyba pri presune súboru z koša: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Chyba pri vysýpaní koša',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Chyba pri vysýpaní koša: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Ste prihlásený do Dropbox API',
  'DROPBOX_SIGN_OUT': 'Odhlásiť z Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Chyba v ceste: Položka nebola nájdená',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Adresár pre inštaláciu balíkov už existuje. Nemôžem pokračovať!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Nemôžem otvoriť súbor',
  'ERR_FILE_APP_OPEN_FMT': 'Súbor {0} sa nedá otvoriť pretože mime typ {1} nie je podporovaný',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Súbor {0} sa nedá otvoriť: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Súbor {0} sa nedá uložiť: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Chyba Aplikácie',
  'ERR_GENERIC_APP_ACTION_FMT': 'Nepodarilo sa uskutočniť akciu \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Neznáma chyba',
  'ERR_GENERIC_APP_REQUEST': 'Chyba počas obsluhy Vášho požiadavku',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatálna chyba: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Zrušiť zmeny?',
  'MSG_FILE_CHANGED': 'Súbor sa zmenil. Chcete zmeny načítať?',
  'MSG_APPLICATION_WARNING': 'Varovanie Aplikácie',
  'MSG_MIME_OVERRIDE': 'Typ súboru "{0}" nie je podporovaný, použijem "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Neznámi',
  'LBL_APPEARANCE': 'Výskyt',
  'LBL_USER': 'Užívateľ',
  'LBL_NAME': 'Meno',
  'LBL_APPLY': 'Použiť',
  'LBL_FILENAME': 'Názov súboru',
  'LBL_PATH': 'Cesta',
  'LBL_SIZE': 'Veľkosť',
  'LBL_TYPE': 'Typ',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Nahrávam',
  'LBL_SETTINGS': 'Nastavenia',
  'LBL_ADD_FILE': 'Pridať súbor',
  'LBL_COMMENT': 'Komentár',
  'LBL_ACCOUNT': 'Účet',
  'LBL_CONNECT': 'Pripojiť',
  'LBL_ONLINE': 'Prihlásený',
  'LBL_OFFLINE': 'Neprihlásený',
  'LBL_AWAY': 'Preč',
  'LBL_BUSY': 'Zaneprázdnený',
  'LBL_CHAT': 'Rozhovor',
  'LBL_HELP': 'Pomoc',
  'LBL_ABOUT': 'O programe',
  'LBL_PANELS': 'Panely',
  'LBL_LOCALES': 'Lokalizácie',
  'LBL_THEME': 'Témy',
  'LBL_COLOR': 'Farba',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Ukončiť',
  'LBL_ALIVE': 'živý',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Pridať',
  'LBL_FONT': 'Písmo',
  'LBL_YES': 'Áno',
  'LBL_NO': 'Nie',
  'LBL_CANCEL': 'Zrušiť',
  'LBL_TOP': 'Hore',
  'LBL_LEFT': 'V ľavo',
  'LBL_RIGHT': 'V pravo',
  'LBL_BOTTOM': 'Dole',
  'LBL_CENTER': 'V strede',
  'LBL_FILE': 'Súbor',
  'LBL_NEW': 'Nový',
  'LBL_OPEN': 'Otvoriť',
  'LBL_SAVE': 'Uložiť',
  'LBL_SAVEAS': 'Uložiť ako...',
  'LBL_CLOSE': 'Zatvoriť',
  'LBL_MKDIR': 'Vytvor adresár',
  'LBL_UPLOAD': 'Nahrať na server',
  'LBL_VIEW': 'Zobraziť',
  'LBL_EDIT': 'Upraviť',
  'LBL_RENAME': 'Premenovať',
  'LBL_DELETE': 'Vymazať',
  'LBL_OPENWITH': 'Otvoriť pomocou ...',
  'LBL_ICONVIEW': 'Ikony',
  'LBL_TREEVIEW': 'Strom',
  'LBL_LISTVIEW': 'Zoznam',
  'LBL_REFRESH': 'Obnoviť',
  'LBL_VIEWTYPE': 'Zobraziť ako',
  'LBL_BOLD': 'Bold',
  'LBL_ITALIC': 'Italic',
  'LBL_UNDERLINE': 'Podčiarknuť',
  'LBL_REGULAR': 'Regulárny',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Odrážka',
  'LBL_OUTDENT': 'Outdate',
  'LBL_UNDO': 'Undo',
  'LBL_REDO': 'Redo',
  'LBL_CUT': 'Vystrihnúť',
  'LBL_UNLINK': 'Zrušiť odkaz (URL)',
  'LBL_COPY': 'Kopírovať',
  'LBL_PASTE': 'Prilepiť',
  'LBL_INSERT': 'Vložiť',
  'LBL_IMAGE': 'Obrázok',
  'LBL_LINK': 'Odkaz (URL)',
  'LBL_DISCONNECT': 'Odpojiť',
  'LBL_APPLICATIONS': 'Aplikácie',
  'LBL_ADD_FOLDER': 'Pridaj adresár',
  'LBL_INFORMATION': 'Informácie',
  'LBL_TEXT_COLOR': 'Farba textu',
  'LBL_BACK_COLOR': 'Farba pozadia',
  'LBL_RESET_DEFAULT': 'Obnoviť predvolené nastavenia',
  'LBL_DOWNLOAD_COMP': 'Stiahnuť do počítača',
  'LBL_ORDERED_LIST': 'Zotriedený zoznam',
  'LBL_BACKGROUND_IMAGE': 'Obrázok na pozadí',
  'LBL_BACKGROUND_COLOR': 'Farba pozadia',
  'LBL_UNORDERED_LIST': 'Nezotriedený zoznam',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Iba na čítanie',
  'LBL_CREATED': 'Vytvorený',
  'LBL_MODIFIED': 'Zmenený',
  'LBL_SHOW_COLUMNS': 'Ukáž stĺpce',
  'LBL_MOVE': 'Presuň',
  'LBL_OPTIONS': 'Možnosti',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Adresár',
  'LBL_CREATE': 'Vytvoriť',
  'LBL_BUGREPORT': 'Bugreport',
  'LBL_INSTALL': 'Inštalovať',
  'LBL_UPDATE': 'Aktualizovať',
  'LBL_REMOVE': 'Odstrániť',
  'LBL_SHOW_SIDEBAR': 'Ukáž bočnú lištu'
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2015, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Dosya açılırken hata oluştu',
  'ERR_WM_NOT_RUNNING': 'Window manager çalışır halde değil',
  'ERR_FILE_OPEN_FMT': '\'**{0}**\' dosya açılamadı',
  'ERR_APP_MIME_NOT_FOUND_FMT': ' \'{0}\' dosyalarını destekleyen herhangi bir program bulunamadı',
  'ERR_APP_LAUNCH_FAILED': 'Program açılırken hata oluştun',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Dosyanın açılmaya çalışıldığı sırada br hata meydana geldi: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': ' \'{0}\' programının inşası sırasında bir hata oluştu: {1}',
  'ERR_APP_INIT_FAILED_FMT': ' \'{0}\' programında init() hatası: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': ' \'{0}\' dosyasında kaynak dosyası eksik ya da yüklenirken hata oluştu!',
  'ERR_APP_PRELOAD_FAILED_FMT': ' \'{0}\' programında önyükleme hatası: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '\'{0}\' programı zaten açık.Aynı anda yalnızca bir kez kullanabilirsiniz.',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': ' \'{0}\' açılamadı. Program bulunamadı!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': ' \'{0}\' açılamadı. Tarayıcınız deskteklemiyor: {1}',

  'ERR_NO_WM_RUNNING': 'Çalışan bir pencere bulunamadı',
  'ERR_CORE_INIT_FAILED': ' OS.js başlatılma hatası',
  'ERR_CORE_INIT_FAILED_DESC': ' OS.js başlatılırken bir hata meydana geldi',
  'ERR_CORE_INIT_NO_WM': 'Cannot launch OS.js: No window manager defined!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js başlatılamaz: Window Manager yüklenirken hata oluştu: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': ' OS.js başlatılamaz: Kaynakların önyükleme işlemi sırasında hata oluştu...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Hata Bildir',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Beklenmedik bir hata meydana geldi.',

  'ERR_APP_API_ERROR': 'Program API hatası',
  'ERR_APP_API_ERROR_DESC_FMT': '{0} programı  \'{1}\' işlemini gerçekleşirken hata oluştu',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Gözden kaçırdığınız değişken: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Bilinmeyen bir hata',

  'ERR_OPERATION_TIMEOUT': 'Zaman aşımına ugradı',
  'ERR_OPERATION_TIMEOUT_FMT': 'Zaman aşımı({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Zaten \'{0}\' adına sahip bir pencere var',
  'WINDOW_MINIMIZE': 'Küçült',
  'WINDOW_MAXIMIZE': 'Büyült',
  'WINDOW_RESTORE': 'geri yükle',
  'WINDOW_CLOSE': 'Kapat',
  'WINDOW_ONTOP_ON': 'en üstte (aktif)',
  'WINDOW_ONTOP_OFF': 'en üstte (aktif değil)',

  // Handler
  'TITLE_SIGN_OUT': 'Çıkış Yap',
  'TITLE_SIGNED_IN_AS_FMT': '{0} olarak giriş yap',

  // SESSION
  'MSG_SESSION_WARNING': 'OS.jsda çıkmak istedigine emin misin? Kaydedilmemiş tüm veriler silinecek!',

  // Service
  'BUGREPORT_MSG': 'Hata olduğunu düşünüyorsan lütfen bizimle irtibata geç.\nHatanın nasıl oluştuğunu kısa bir şekilde yaz ve eğer yapabiliyorsan bir kopyasını bize gönder',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Harici bir servise girildi: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Ölümcül Hata',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Hatası: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Oturumu Kapat (Çıkış)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Oturum Kapatılıyor user \'{0}\'.\nKaydetmek ister misin?',

  'DIALOG_CLOSE': 'Kapat',
  'DIALOG_CANCEL': 'İptal',
  'DIALOG_APPLY': 'Uygula',
  'DIALOG_OK': 'Tamam',

  'DIALOG_ALERT_TITLE': 'Uyarı Penceresi',

  'DIALOG_COLOR_TITLE': 'Renk Penceresi',
  'DIALOG_COLOR_R': 'Kırmızı: {0}',
  'DIALOG_COLOR_G': 'Yeşil: {0}',
  'DIALOG_COLOR_B': 'Mavi: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Onay Penceresi',

  'DIALOG_ERROR_MESSAGE': 'Mesaj',
  'DIALOG_ERROR_SUMMARY': 'Özet',
  'DIALOG_ERROR_TRACE': 'İzle',
  'DIALOG_ERROR_BUGREPORT': ' Hata bildir',

  'DIALOG_FILE_SAVE': 'Kaydet',
  'DIALOG_FILE_OPEN': 'Aç',
  'DIALOG_FILE_MKDIR': 'Yeni Klasör',
  'DIALOG_FILE_MKDIR_MSG': '**{0}**da yeni bir Klasör oluştur',
  'DIALOG_FILE_OVERWRITE': 'Dosyanın üzerine yazmak konusunda emin misin \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Görünüm Seçenekleri',
  'DIALOG_FILE_MNU_LISTVIEW': 'Liste Görünümü',
  'DIALOG_FILE_MNU_TREEVIEW': 'Tree Görünümü',
  'DIALOG_FILE_MNU_ICONVIEW': 'Icon Görünümü',
  'DIALOG_FILE_ERROR': 'Dosya Penceresi Hatası',
  'DIALOG_FILE_ERROR_SCANDIR': 'Bir hatadan dolayı \'{0}\' dosyaları listelenemedi',
  'DIALOG_FILE_MISSING_FILENAME': 'Bir dosya seçmeli veya yeni bir dosya ismi girmelisin!',
  'DIALOG_FILE_MISSING_SELECTION': 'Bir dosya seçmelisin!',

  'DIALOG_FILEINFO_TITLE': 'Dosya Bilgileri',
  'DIALOG_FILEINFO_LOADING': 'Dosya bilgileri yükleniyor: {0}',
  'DIALOG_FILEINFO_ERROR': 'Dosya Bilgi Penceresi Hatası',
  'DIALOG_FILEINFO_ERROR_LOOKUP': ' **{0}** hakkında bilgi alınırken hata meydana geldi',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': '{0} Hakkında bilgi alınırken hata meydana geldi',

  'DIALOG_INPUT_TITLE': 'Giriş Penceresi',

  'DIALOG_FILEPROGRESS_TITLE': 'Dosya İşlemlerinin İlerleme Durumu',
  'DIALOG_FILEPROGRESS_LOADING': 'Yükleniyor...',

  'DIALOG_UPLOAD_TITLE': 'Yükleme Penceresi',
  'DIALOG_UPLOAD_DESC': 'Yükle **{0}**.<br />Maksimum boyut: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Yükleniyor \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Yükleniyor...',
  'DIALOG_UPLOAD_FAILED': 'Yükleme başarısız oldu',
  'DIALOG_UPLOAD_FAILED_MSG': 'Yükleme başarısız oldu',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'bilinmeyen bir sebepten dolayı hata oluştu...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Kullanıcı tarafından iptal edildi...',
  'DIALOG_UPLOAD_TOO_BIG': 'Dosya Boyutu çok fazla',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Dosya Boyutu çok fazla, {0} sınırını aştı',

  'DIALOG_FONT_TITLE': 'Yazı Tipi Penceresi',

  'DIALOG_APPCHOOSER_TITLE': 'Program Seç',
  'DIALOG_APPCHOOSER_MSG': 'Açmak İçin Bir Program Seçiniz',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Bir Program Seçmeniz Gerek',
  'DIALOG_APPCHOOSER_SET_DEFAULT': ' {0} için varsayılan bir program seçiniz',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modulü inaktif veya kurulu değil',
  'GAPI_SIGN_OUT': 'Google API Services uygulamasında çık',
  'GAPI_REVOKE': 'İzinleri İptal Et ve Çık',
  'GAPI_AUTH_FAILURE': 'Google API Kimlik Doğrulama Hatası',
  'GAPI_AUTH_FAILURE_FMT': 'Kimlik Doğrulama Hatası: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Google API yüklenemedi',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API inaktif veya kurulu değil',
  'WLAPI_SIGN_OUT': 'Window Live API uygulamasında çık',
  'WLAPI_LOAD_FAILURE': 'Windows Live API yüklenirken hata oluştu',
  'WLAPI_LOGIN_FAILED': 'Windows Live APIe girerken hata oluştu',
  'WLAPI_LOGIN_FAILED_FMT': 'Windows Live APIe girerken hata oluştu: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API  {0} hatası verdi',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Veritabanı ismi olmadan IndexedDB Oluşturulamaz',
  'IDB_NO_SUCH_ITEM': 'Öge mevcut değil',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Ölümcül Hata',
  'ERR_VFS_UNAVAILABLE': 'Kullanılamaz',
  'ERR_VFS_FILE_ARGS': 'Dosyaya en az bir değişken girilmeli',
  'ERR_VFS_NUM_ARGS': 'Yeyersiz Değişken',
  'ERR_VFS_EXPECT_FILE': 'Dosya Bekleniyordu',
  'ERR_VFS_EXPECT_SRC_FILE': 'Kaynak Kod Dosyası Bekleniyordu',
  'ERR_VFS_EXPECT_DST_FILE': 'Hedef Dosyası Bekleniyordu',
  'ERR_VFS_FILE_EXISTS': 'Hedef Dosyası Zaten Mevcut',
  'ERR_VFS_TRANSFER_FMT': 'depo ile {0} arasında aktarım sırasında bir hata meydana geldi',
  'ERR_VFS_UPLOAD_NO_DEST': 'Hedef Dosyası olmadan yükleme yapılamaz',
  'ERR_VFS_UPLOAD_NO_FILES': 'Dosya tanımlamadan yükleme yapılamaz',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Dosya yükleme hatası: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Dosya yükleme iptal edildi',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Hedef belli değilken dosya indirilemez',
  'ERR_VFS_DOWNLOAD_FAILED': 'İndirilme sırasında bir hata meydana geldi: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Geri Dönüş Boş',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Dosya İndiriliyor',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Hatası',
  'ERR_VFSMODULE_ROOT_ID': 'Root idsi bulunamadı',
  'ERR_VFSMODULE_NOSUCH': 'Dosya kullanımda değil',
  'ERR_VFSMODULE_PARENT': 'Üst Öge Bulunmuyors',
  'ERR_VFSMODULE_PARENT_FMT': 'Üst Öge aranırken hata oluştu: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Klasör Görüntülenirken Hata Meydana Geldi',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Klasör Görüntülenirken Hata Meydana Geldi: {0}',
  'ERR_VFSMODULE_READ': 'Dosya Okunurken Hata oluştu',
  'ERR_VFSMODULE_READ_FMT': 'Dosya Okunurken Hata oluştu: {0}',
  'ERR_VFSMODULE_WRITE': 'Dosyaya yazılırken Hata oluştu',
  'ERR_VFSMODULE_WRITE_FMT': 'Dosyaya yazılırken Hata oluştu: {0}',
  'ERR_VFSMODULE_COPY': 'Kopyalanırken Hata meydana geldi.',
  'ERR_VFSMODULE_COPY_FMT': 'Kopyalanırken Hata meydana geldi: {0}',
  'ERR_VFSMODULE_UNLINK': 'Bağlantısız Dosya',
  'ERR_VFSMODULE_UNLINK_FMT': 'Bağlantısız Dosya: {0}',
  'ERR_VFSMODULE_MOVE': 'Dosya Taşınırken Hata Oluştu',
  'ERR_VFSMODULE_MOVE_FMT': 'Dosya Taşınırken Hata Oluştu: {0}',
  'ERR_VFSMODULE_EXIST': 'Dosyanın varlığı teyit edilirken hata meydana geldi',
  'ERR_VFSMODULE_EXIST_FMT': 'Dosyanın varlığı teyit edilirken hata meydana geldi: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Dosya Hakkında Bilgi Toplanırken Hata Oluştu',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Dosya Hakkında Bilgi Toplanırken Hata Oluştu: {0}',
  'ERR_VFSMODULE_MKDIR': 'Klasör Oluşturulurken Hata Oluştu',
  'ERR_VFSMODULE_MKDIR_FMT': 'Klasör Oluşturulurken Hata Oluştu: {0}',
  'ERR_VFSMODULE_URL': 'Dosyanın url adresi getirilirken hata meydana geldi',
  'ERR_VFSMODULE_URL_FMT': 'Dosyanın url adresi getirilirken hata meydana geldi: {0}',
  'ERR_VFSMODULE_TRASH': 'Çöp Kutusuna Taşınırken Hata Oluştu',
  'ERR_VFSMODULE_TRASH_FMT': 'Çöp Kutusuna Taşınırken Hata Oluştu: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Çöp Kutusundan Çıkarılırken Hata Meydana Geldi',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Çöp Kutusundan Çıkarılırken Hata Meydana Geldi: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Çöpü boşaltırken hata meydana geldi',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Çöpü boşaltırken hata meydana geldi: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Dropbox APIya girdiniz',
  'DROPBOX_SIGN_OUT': 'Google API servisi oturumunu kapat',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Öge bulunamadı',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Paketlenecek yer zaten mevcut.Yine de devam etmek istiyor musun?',
  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Dosya Açılamadı',
  'ERR_FILE_APP_OPEN_FMT': '{0} dosyası açılmadı çünkü  {1} desteklenmiyor',
  'ERR_FILE_APP_OPEN_ALT_FMT': '{0} dosyası açılamadı: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': '{0} dosyası kaydedilemedi: {1}',
  'ERR_GENERIC_APP_FMT': '{0} program hatası',
  'ERR_GENERIC_APP_ACTION_FMT': ' \'{0}\' gerçekleşirken hata oluştu',
  'ERR_GENERIC_APP_UNKNOWN': 'Bilinmeyen Hata',
  'ERR_GENERIC_APP_REQUEST': 'İstek cevaplanırken bir hata meydana geldi.',
  'ERR_GENERIC_APP_FATAL_FMT': 'Ölümcül Hata: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Değişiklikleri Çıkar?',
  'MSG_FILE_CHANGED': 'Dosya değişmiş.Tekrar yüklemek ister misin?',
  'MSG_APPLICATION_WARNING': 'Program Uyarısı',
  'MSG_MIME_OVERRIDE': ' "{0}" türü desteklenmiyor :( .Bunun yerine "{1}" kullanının.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Bilinmiyor',
  'LBL_APPEARANCE': 'Görünüm',
  'LBL_USER': 'Kullanıcı',
  'LBL_NAME': 'İsim',
  'LBL_APPLY': 'Uygula',
  'LBL_FILENAME': 'Dosya adı',
  'LBL_PATH': 'Dosya yolu',
  'LBL_SIZE': 'Boyut',
  'LBL_TYPE': 'Tür',
  'LBL_MIME': 'MIME', //Eklenecektir
  'LBL_LOADING': 'Yükleniyor',
  'LBL_SETTINGS': 'Ayarlar',
  'LBL_ADD_FILE': 'Dosya ekle',
  'LBL_COMMENT': 'Yorum',
  'LBL_ACCOUNT': 'Hesap',
  'LBL_CONNECT': 'Bağlan',
  'LBL_ONLINE': 'Aktif',
  'LBL_OFFLINE': 'Aktif değil',
  'LBL_AWAY': 'Yolda',
  'LBL_BUSY': 'Meşgul',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Yardım',
  'LBL_ABOUT': 'Hakkında',
  'LBL_PANELS': 'Panels',
  'LBL_LOCALES': 'Yerler',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Renk',
  'LBL_PID': 'Kişisel Kimlik',
  'LBL_KILL': 'Kes',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Ekle',
  'LBL_FONT': 'Yazı Tipi',
  'LBL_YES': 'Evet',
  'LBL_NO': 'Hayır',
  'LBL_CANCEL': 'İptal',
  'LBL_TOP': 'Üst',
  'LBL_LEFT': 'Sol',
  'LBL_RIGHT': 'Sağ',
  'LBL_BOTTOM': 'Alt',
  'LBL_CENTER': 'Orta',
  'LBL_FILE': 'Dosya',
  'LBL_NEW': 'Yeni',
  'LBL_OPEN': 'Aç',
  'LBL_SAVE': 'Kaydet',
  'LBL_SAVEAS': '-olarak kaydet...',
  'LBL_CLOSE': 'Kapat',
  'LBL_MKDIR': 'Klasör oluştur',
  'LBL_UPLOAD': 'Yükle',
  'LBL_VIEW': 'Görünüm',
  'LBL_EDIT': 'Düzenle',
  'LBL_RENAME': 'İsmi Değiştir',
  'LBL_DELETE': 'Sil',
  'LBL_OPENWITH': '-ile aç ...',
  'LBL_ICONVIEW': 'icon görünüm',
  'LBL_TREEVIEW': 'Tree View',
  'LBL_LISTVIEW': 'Liste Görünüm',
  'LBL_REFRESH': 'Yenile',
  'LBL_VIEWTYPE': 'Görünüm Türü',
  'LBL_BOLD': 'Kalım',
  'LBL_ITALIC': 'İtalik',
  'LBL_UNDERLINE': 'Altı Çizili',
  'LBL_REGULAR': 'Düzenli',
  'LBL_STRIKE': 'Vurgulu',
  'LBL_INDENT': 'Indent', //eklenecek
  'LBL_OUTDENT': 'Outdate', //eklenecek
  'LBL_UNDO': 'Geri Al',
  'LBL_REDO': 'İleri Al',
  'LBL_CUT': 'Kes',
  'LBL_UNLINK': 'Bağlantıyı Kaldır',
  'LBL_COPY': 'Kopyala',
  'LBL_PASTE': 'Yapıştır',
  'LBL_INSERT': 'Araya Ekle',
  'LBL_IMAGE': 'Resim',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Bağlantıyı Kes',
  'LBL_APPLICATIONS': 'Programlar',
  'LBL_ADD_FOLDER': 'Klasör Ekle',
  'LBL_INFORMATION': 'Bilgi',
  'LBL_TEXT_COLOR': 'Yazı Rengi',
  'LBL_BACK_COLOR': 'Zemin Rengi',
  'LBL_RESET_DEFAULT': 'Reset to defaults',
  'LBL_DOWNLOAD_COMP': 'Bilgisayara İndir',
  'LBL_ORDERED_LIST': 'Sıralı Liste',
  'LBL_BACKGROUND_IMAGE': 'Arkaplan Resmi',
  'LBL_BACKGROUND_COLOR': 'Arkaplan Rengi',
  'LBL_UNORDERED_LIST': 'Sırasız Liste',
  'LBL_STATUS': 'Durum',
  'LBL_READONLY': 'Sadece Oku',
  'LBL_CREATED': 'Oluşturulma Tarihi',
  'LBL_MODIFIED': 'Değiştirilme Tarihi',
  'LBL_SHOW_COLUMNS': 'Sütunları Göster',
  'LBL_MOVE': 'Taşı',
  'LBL_OPTIONS': 'Ayarlar',
  'LBL_OK': 'Tamam',
  'LBL_DIRECTORY': 'Klasör',
  'LBL_CREATE': 'oluştur',
  'LBL_BUGREPORT': 'Hata Bildir',
  'LBL_INSTALL': 'Yükle',
  'LBL_UPDATE': 'Güncelle',
  'LBL_REMOVE': 'Kaldır',
  'LBL_SHOW_SIDEBAR': 'Kenar çubuğunu göster',
  'LBL_BACKGROUND': 'arkaplan',
  'LBL_DESKTOP': 'masaüstü',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'pozisyon',
  'LBL_ONTOP': 'en üst',
  'LBL_ITEMS': 'nesneler',
  'LBL_GENERAL': 'genel'
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Lỗi khi mở tệp',
  'ERR_WM_NOT_RUNNING': 'Trình quản lí cửa sổ không hoạt động',
  'ERR_FILE_OPEN_FMT': 'Tập tin \'**{0}**\' không mở được',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Không thể tìm thấy bất kỳ ứng dụng hỗ trợ cho \'{0}\' files',
  'ERR_APP_LAUNCH_FAILED': 'Không thể khởi động ứng dụng',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Có lỗi xảy ra trong khi cố gắng khởi động: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Phần mềm \'{0}\' xây dựng thất bại: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Phần mềm \'{0}\' init() thất bại: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Tài nguyên ứng dụng còn thiếu cho \'{0}\' hoặc nó không tải được!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Nạp trước phần mềm \'{0}\'  thất bại: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Phần mềm \'{0}\' đã được khởi chạy và chỉ cho phép một hoạt động!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Không thể khởi động \'{0}\'. Application manifest không tìm thấy!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Không thể khởi động\'{0}\'. Trình duyệt của bạn không hỗ trợ: {1}',

  'ERR_NO_WM_RUNNING': 'Quản lí cửa sổ không chạy',
  'ERR_CORE_INIT_FAILED': 'Không thể khởi động OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Một lỗi đã xảy ra trong khi khởi tạo OS.js',
  'ERR_CORE_INIT_NO_WM': 'Không thể khởi động OS.js: Không có quản lí cửa sổ nào được xác định!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Không thể khởi động OS.js: Không thể khởi động Window Manager: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Không thể khởi động OS.js: Không thể tải trước tài nguyên...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Báo cáo lỗi JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Một lỗi không mong muốn xảy ra, có thể là một bug.',

  'ERR_APP_API_ERROR': 'Lỗi ứng dụng API',
  'ERR_APP_API_ERROR_DESC_FMT': 'Phần mềm {0} không thực hiện hoạt động \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Thiếu đối số: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Lỗi không xác định',

  'ERR_OPERATION_TIMEOUT': 'Hết thời gian phản hồi',
  'ERR_OPERATION_TIMEOUT_FMT': 'Hết thời gian phản hồi trong ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' dự kiến \'{1}\' là một \'{2}\',cho \'{3}\'',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Bạn đã có một cửa sổ có tên \'{0}\'',
  'WINDOW_MINIMIZE': 'Giảm thiểu',
  'WINDOW_MAXIMIZE': 'Tối đa hóa',
  'WINDOW_RESTORE': 'Khôi phục',
  'WINDOW_CLOSE': 'Đóng',
  'WINDOW_ONTOP_ON': 'Ở trên (Bật)',
  'WINDOW_ONTOP_OFF': 'Ở trên (Tắt)',

  // Handler
  'TITLE_SIGN_OUT': 'Đăng xuất',
  'TITLE_SIGNED_IN_AS_FMT': 'Đăng nhập như: {0}',
  'ERR_LOGIN_FMT': 'Đăng nhập thất bại: {0}',
  'ERR_LOGIN_INVALID': 'Đăng nhập không hợp lệ',

  // SESSION
  'ERR_NO_SESSION': 'Chưa có phiên chạy nào được tạo bởi máy chủ. Bạn có muốn đăng nhập lại không?',
  'MSG_SESSION_WARNING': 'Bạn có muốn thoát khỏi phiên OS.js này? Mọi cài đặt và dữ liệu sẽ bị mất!',

  // Service
  'BUGREPORT_MSG': 'Xin hãy báo lỗi này nếu bạn nghĩ rằng đây là một lỗi.\nHãy viết một mô tả ngắn gọn về lỗi đã xảy ra như thế nào, và nếu có thể, làm cách nào để tái hiện lại nó!',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Đăng nhập vào các dịch vụ bên ngoài: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Lỗi nghiêm trọng',
  'ERR_UTILS_XHR_FMT': 'Lỗi AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Đăng xuất (Thoát)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Đăng xuất người dùng \'{0}\'.\nBạn có muốn lưu lại phiên chạy hiện thời?',

  'DIALOG_CLOSE': 'Đóng',
  'DIALOG_CANCEL': 'Hủy',
  'DIALOG_APPLY': 'Áp dụng',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Cảnh báo',

  'DIALOG_COLOR_TITLE': 'Bảng màu',
  'DIALOG_COLOR_R': 'Đỏ: {0}',
  'DIALOG_COLOR_G': 'Xanh lá cây: {0}',
  'DIALOG_COLOR_B': 'Xanh da trời: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Xác nhận',

  'DIALOG_ERROR_MESSAGE': 'Thông điệp',
  'DIALOG_ERROR_SUMMARY': 'Tóm tắt',
  'DIALOG_ERROR_TRACE': 'Dấu vết',
  'DIALOG_ERROR_BUGREPORT': 'Báo cáo lỗi',

  'DIALOG_FILE_SAVE': 'Lưu',
  'DIALOG_FILE_OPEN': 'Mở',
  'DIALOG_FILE_MKDIR': 'Thư mục mới',
  'DIALOG_FILE_MKDIR_MSG': 'Tạo một thư mục mới trong **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Bạn có chắc muốn ghi đè lên tập tin \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Kiểu xem',
  'DIALOG_FILE_MNU_LISTVIEW': 'Danh sách',
  'DIALOG_FILE_MNU_TREEVIEW': 'Cây',
  'DIALOG_FILE_MNU_ICONVIEW': 'Biểu tượng',
  'DIALOG_FILE_ERROR': 'Lỗi FileDialog',
  'DIALOG_FILE_ERROR_SCANDIR': 'Không thể liệt kê thư mục \'{0}\' vì đã xảy ra lỗi',
  'DIALOG_FILE_ERROR_FIND': 'Không thể tìm kiếm trong thư mục \'{0}\' bởi một lỗi đã xảy ra',
  'DIALOG_FILE_MISSING_FILENAME': 'Bạn cần phải chọn một tập tin hoặc nhập tên tập tin mới!',
  'DIALOG_FILE_MISSING_SELECTION': 'Bạn cần phải chọn một tập tin!',

  'DIALOG_FILEINFO_TITLE': 'Thông tin tập tin',
  'DIALOG_FILEINFO_LOADING': 'Đang tải thông tin tập tin cho: {0}',
  'DIALOG_FILEINFO_ERROR': 'Lỗi FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Không thể có được thông tin tập tin cho **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Không thể có được thông tin tập tin cho: {0}',

  'DIALOG_INPUT_TITLE': 'Nhập liệu',

  'DIALOG_FILEPROGRESS_TITLE': 'Tiến độ của tập tin',
  'DIALOG_FILEPROGRESS_LOADING': 'Đang nạp...',

  'DIALOG_UPLOAD_TITLE': 'Tải lên',
  'DIALOG_UPLOAD_DESC': 'Tải tập tin lên đến **{0}**.<br />Kích thước tối đa: {1} byte',
  'DIALOG_UPLOAD_MSG_FMT': 'Đang tải lên \'{0}\' ({1} {2}) đến {3}',
  'DIALOG_UPLOAD_MSG': 'Đang tải lên tập tin...',
  'DIALOG_UPLOAD_FAILED': 'Tải lên thất bại',
  'DIALOG_UPLOAD_FAILED_MSG': 'Việc tải lên đã thất bại',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Không rõ lý do...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Hủy bỏ bởi người dùng...',
  'DIALOG_UPLOAD_TOO_BIG': 'Tập tin quá lớn',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Tập tin quá lớn, vượt quá {0}',

  'DIALOG_FONT_TITLE': 'Chọn phông',

  'DIALOG_APPCHOOSER_TITLE': 'Chọn ứng dụng',
  'DIALOG_APPCHOOSER_MSG': 'Chọn một ứng dụng để mở',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Bạn cần phải chọn một ứng dụng',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Sử dụng như là ứng dụng mặc định cho {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Mô-đun GoogleAPI không được cấu hình hoặc vô hiệu hóa',
  'GAPI_SIGN_OUT': 'Đăng xuất khỏi dịch vụ Google API',
  'GAPI_REVOKE': 'Thu hồi giấy phép và Đăng xuất',
  'GAPI_AUTH_FAILURE': 'Google API Xác thực không thành công hoặc không diễn ra',
  'GAPI_AUTH_FAILURE_FMT': 'Không xác thực được: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Không tải được Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Mô-đun Windows Live API  không được cấu hình hoặc vô hiệu',
  'WLAPI_SIGN_OUT': 'Đăng xuất khỏi Window Live API',
  'WLAPI_LOAD_FAILURE': 'Không tải được Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Không thể đăng nhập vào Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Không thể đăng nhập vào Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API gửi lại {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Không thể tạo IndexedDB mà không có Tên cơ sở dữ liệu',
  'IDB_NO_SUCH_ITEM': 'Không có item',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Lỗi nghiêm trọng',
  'ERR_VFS_UNAVAILABLE': 'Không khả dụng',
  'ERR_VFS_FILE_ARGS': 'Tập cần ít nhất một tham số',
  'ERR_VFS_NUM_ARGS': 'Không đủ đối số',
  'ERR_VFS_EXPECT_FILE': 'Cần một file-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Cần một nguồn file-object',
  'ERR_VFS_EXPECT_DST_FILE': 'Cần một điểm đến file-object',
  'ERR_VFS_FILE_EXISTS': 'Điểm đến đã tồn tại',
  'ERR_VFS_TARGET_NOT_EXISTS': 'Mục tiêu không tồn tại',
  'ERR_VFS_TRANSFER_FMT': 'Có lỗi xảy ra trong khi chuyển giao lưu trữ tới ổ cứng: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Không thể tải lên một tập tin mà không có một điểm đến',
  'ERR_VFS_UPLOAD_NO_FILES': 'Không thể tải lên bất kỳ tập tin mà không có định nghĩa',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Tải lên không thành công: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Quá trình tải lên đã bị hủy bỏ',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Không thể tải về một đường dẫn mà không có một đường dẫn',
  'ERR_VFS_DOWNLOAD_FAILED': 'Một lỗi đã xảy ra trong khi tải về: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Không có phản hồi',

  'ERR_VFSMODULE_INVALID': 'Invalid VFS Module',
  'ERR_VFSMODULE_INVALID_FMT': 'Invalid VFS Module: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Không có mô đun VFS nào khớp với {0}. Sai đường dẫn hoặc định dạng ?',
  'ERR_VFSMODULE_READONLY': 'Mô đun VFS này là chỉ đọc',
  'ERR_VFSMODULE_READONLY_FMT': 'Mô đun VFS này là chỉ đọc: {0}',
  'ERR_VFSMODULE_EXCEPTION': 'Lỗi mô-đun VFS',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'Lỗi mô-đun VFS: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Sai phương thức VFS',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Sai phương thức VFS: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Sai kiểu mô-đun VFS',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Sai kiểu mô-đun VFS: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Sai thiết lập mô-đun VFS',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Sai thiết lập mô-đun VFS: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'Mô-đun VFS đã được gắn',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'Mô-đun VFS \'{0}\' đã được gắn',
  'ERR_VFSMODULE_NOT_MOUNTED': 'Mô-đun VFS chưa được gắn',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'Mô-đun VFS \'{0}\' chưa được gắn',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Đang tải xuống tập tin',

  'ERR_VFSMODULE_XHR_ERROR': 'Lỗi XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Không thể tìm thấy id thư mục gốc',
  'ERR_VFSMODULE_NOSUCH': 'Tập tin không tồn tại',
  'ERR_VFSMODULE_PARENT': 'Không có thư mục cha nào như vậy',
  'ERR_VFSMODULE_PARENT_FMT': 'Không thể tìm thư mục cha : {0}',
  'ERR_VFSMODULE_SCANDIR': 'Không thể quét thư mục',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Không thể quét thư mục: {0}',
  'ERR_VFSMODULE_READ': 'Không thể đọc tập tin',
  'ERR_VFSMODULE_READ_FMT': 'Không thể đọc tập tin: {0}',
  'ERR_VFSMODULE_WRITE': 'Không thể ghi tập tin',
  'ERR_VFSMODULE_WRITE_FMT': 'Không thể ghi tập tin: {0}',
  'ERR_VFSMODULE_COPY': 'Không thể sao chép',
  'ERR_VFSMODULE_COPY_FMT': 'Không thể sao chép: {0}',
  'ERR_VFSMODULE_UNLINK': 'Không thể bỏ liên kết tập tin',
  'ERR_VFSMODULE_UNLINK_FMT': 'Không thể bỏ liên kết tập tin: {0}',
  'ERR_VFSMODULE_MOVE': 'Không thể di chuyển tập tin',
  'ERR_VFSMODULE_MOVE_FMT': 'Không thể di chuyển tập tin: {0}',
  'ERR_VFSMODULE_EXIST': 'Không thể kiểm tra sự tồn tại của tập tin',
  'ERR_VFSMODULE_EXIST_FMT': 'Không thể kiểm tra sự tồn tại của tập tin: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Không thể lấy thông tin file',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Không thể lấy thông tin file: {0}',
  'ERR_VFSMODULE_MKDIR': 'Không thể tạo thư mục',
  'ERR_VFSMODULE_MKDIR_FMT': 'Không thể tạo thư mục: {0}',
  'ERR_VFSMODULE_MKFILE': 'Không thể tạo tập tin',
  'ERR_VFSMODULE_MKFILE_FMT': 'Không thể tạo tập tin: {0}',
  'ERR_VFSMODULE_URL': 'Không thể lấy URL cho file',
  'ERR_VFSMODULE_URL_FMT': 'Không thể lấy URL cho file: {0}',
  'ERR_VFSMODULE_TRASH': 'Không thể di chuyển tập tin vào thùng rác',
  'ERR_VFSMODULE_TRASH_FMT': 'Không thể di chuyển tập tin vào thùng rác: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Không thể di chuyển tập tin ra khỏi thùng rác',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Không thể di chuyển tập tin ra khỏi thùng rác: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Không thể làm rỗng thùng rác',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Không thể làm rỗng thùng rác : {0}',
  'ERR_VFSMODULE_FIND': 'Không thể tìm kiếm',
  'ERR_VFSMODULE_FIND_FMT': 'Lỗi khi tìm kiếm: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Không thể làm sạch bộ nhớ',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Lỗi khi làm sạch bộ nhớ: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Bạn đã đăng nhập vào Dropbox API',
  'DROPBOX_SIGN_OUT': 'Đăng xuất khỏi dịch vụ Google API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Không thể giải quyết đường dẫn: mục không tìm thấy',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Không thể tải zip.js',
  'ZIP_VENDOR_FAIL': 'Không tìm thấy zip.js, bạn có chắc chắn đã thiết lập nó chưa?',
  'ZIP_NO_RESOURCE': 'Không có nguồn zip đã được đưa ra',
  'ZIP_NO_PATH': 'Không có đường dẫn',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Đang tìm kiếm...',
  'SEARCH_NO_RESULTS': 'Không có kết quả',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Thư mục cài đặt gói phần mềm đã tồn tại. Không thể tiếp tục!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Không thể mở tập tin',
  'ERR_FILE_APP_OPEN_FMT': 'Tập tin {0} không thể mở được vì mime {1} không được hỗ trợ',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Tập tin {0} không mở được: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Tập tin {0} không lưu được: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Lỗi phần mềm',
  'ERR_GENERIC_APP_ACTION_FMT': 'Không thể thực hiện hành động \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Lỗi không xác định',
  'ERR_GENERIC_APP_REQUEST': 'Một lỗi đã xảy ra trong khi xử lý yêu cầu của bạn',
  'ERR_GENERIC_APP_FATAL_FMT': 'Lỗi nghiêm trọng: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Hủy các thay đổi?',
  'MSG_FILE_CHANGED': 'Các tập tin đã thay đổi. Nạp lại?',
  'MSG_APPLICATION_WARNING': 'Cảnh báo ứng dụng',
  'MSG_MIME_OVERRIDE': 'Loại tập tin "{0}" không được hỗ trợ, sử dụng "{1}" thay thế.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Không biết',
  'LBL_APPEARANCE': 'Giao diện',
  'LBL_USER': 'Người dùng',
  'LBL_NAME': 'Tên',
  'LBL_APPLY': 'Áp dụng',
  'LBL_FILENAME': 'Tên tệp',
  'LBL_PATH': 'Đường dẫn',
  'LBL_SIZE': 'Kích cỡ',
  'LBL_TYPE': 'Kiểu',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Đang tải',
  'LBL_SETTINGS': 'Cài đặt',
  'LBL_ADD_FILE': 'Thêm tệp',
  'LBL_COMMENT': 'Chú thích',
  'LBL_ACCOUNT': 'Tài khoản',
  'LBL_CONNECT': 'Kết nối',
  'LBL_ONLINE': 'Trực tuyến',
  'LBL_OFFLINE': 'Ngoại tuyến',
  'LBL_AWAY': 'Ở xa',
  'LBL_BUSY': 'Bận',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Hướng dẫn',
  'LBL_ABOUT': 'Thông tin',
  'LBL_PANELS': 'Panels',
  'LBL_LOCALES': 'Ngôn ngữ',
  'LBL_THEME': 'Giao diện',
  'LBL_COLOR': 'Màu',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Đóng',
  'LBL_ALIVE': 'Còn sống',
  'LBL_INDEX': 'Chỉ mục',
  'LBL_ADD': 'Thêm',
  'LBL_FONT': 'Phông',
  'LBL_YES': 'Có',
  'LBL_NO': 'Không',
  'LBL_CANCEL': 'Hủy bỏ',
  'LBL_TOP': 'Trên',
  'LBL_LEFT': 'Trái',
  'LBL_RIGHT': 'Phải',
  'LBL_BOTTOM': 'Dưới',
  'LBL_CENTER': 'Giữa',
  'LBL_FILE': 'Tệp',
  'LBL_NEW': 'Mới',
  'LBL_OPEN': 'Mở',
  'LBL_SAVE': 'Lưu',
  'LBL_SAVEAS': 'Lưu như...',
  'LBL_CLOSE': 'Đóng',
  'LBL_MKDIR': 'Tạo thư mục',
  'LBL_UPLOAD': 'Tải lên',
  'LBL_VIEW': 'Xem',
  'LBL_EDIT': 'Chỉnh sửa',
  'LBL_RENAME': 'Đổi tên',
  'LBL_DELETE': 'Xóa',
  'LBL_OPENWITH': 'Mở với...',
  'LBL_ICONVIEW': 'Biểu tượng',
  'LBL_TREEVIEW': 'Cây',
  'LBL_LISTVIEW': 'Danh sách',
  'LBL_REFRESH': 'Làm mới',
  'LBL_VIEWTYPE': 'Kiểu xem',
  'LBL_BOLD': 'In đậm',
  'LBL_ITALIC': 'In Ngiêng',
  'LBL_UNDERLINE': 'Gạch dưới',
  'LBL_REGULAR': 'Bình thường',
  'LBL_STRIKE': 'Gạch ngang',
  'LBL_INDENT': 'Thụt về',
  'LBL_OUTDENT': 'Quá hạn',
  'LBL_UNDO': 'Trở lại',
  'LBL_REDO': 'Làm lại',
  'LBL_CUT': 'Cắt',
  'LBL_UNLINK': 'Hủy liên kết',
  'LBL_COPY': 'Sao chép',
  'LBL_PASTE': 'Dán',
  'LBL_INSERT': 'Chèn',
  'LBL_IMAGE': 'Ảnh',
  'LBL_LINK': 'Liên kết',
  'LBL_DISCONNECT': 'Mất kết nối',
  'LBL_APPLICATIONS': 'Các ứng dụng',
  'LBL_ADD_FOLDER': 'Thêm thư mục',
  'LBL_INFORMATION': 'Thông tin',
  'LBL_TEXT_COLOR': 'Màu chữ',
  'LBL_BACK_COLOR': 'Màu nền',
  'LBL_RESET_DEFAULT': 'Khôi phục về mặc định',
  'LBL_DOWNLOAD_COMP': 'Tải về máy',
  'LBL_ORDERED_LIST': 'Danh sách có thứ tự',
  'LBL_BACKGROUND_IMAGE': 'Ảnh nền',
  'LBL_BACKGROUND_COLOR': 'Màu nền',
  'LBL_UNORDERED_LIST': 'Danh sách không có thứ tự',
  'LBL_STATUS': 'Trạng thái',
  'LBL_READONLY': 'Chỉ đọc',
  'LBL_CREATED': 'Tạo lúc',
  'LBL_MODIFIED': 'Sửa lúc',
  'LBL_SHOW_COLUMNS': 'Hiện các cột',
  'LBL_MOVE': 'Di chuyển',
  'LBL_OPTIONS': 'Tùy chọn',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Thư mục',
  'LBL_CREATE': 'Tạo',
  'LBL_BUGREPORT': 'Báo lỗi',
  'LBL_INSTALL': 'Cài đặt',
  'LBL_UPDATE': 'Cập nhật',
  'LBL_REMOVE': 'Gỡ bỏ',
  'LBL_SHOW_SIDEBAR': 'Hiện thanh bên',
  'LBL_SHOW_NAVIGATION': 'Hiện nút điều hướng',
  'LBL_SHOW_HIDDENFILES': 'Hiện tập tin ẩn',
  'LBL_SHOW_FILEEXTENSIONS': 'Hiện đuôi tập tin',
  'LBL_MOUNT': 'Gắn',
  'LBL_DESCRIPTION': 'Mô tả',
  'LBL_USERNAME': 'Tên người dùng',
  'LBL_PASSWORD': 'Mật khẩu',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_SEARCH': 'Tìm kiếm',
  'LBL_BACKGROUND': 'Ảnh nền',
  'LBL_DESKTOP': 'Màn hình chính',
  'LBL_PANEL': 'Khung',
  'LBL_POSITION': 'Vị trí',
  'LBL_ONTOP': 'Ở trên',
  'LBL_ITEMS': 'Các mục',
  'LBL_AUTOHIDE': 'Tự động ẩn',
  'LBL_OPACITY': 'Độ trong suốt',
  'LBL_GROUPS': 'Nhóm',
  'LBL_VERSION': 'Phiên bản',
  'LBL_AUTHOR': 'Tác giả',
  'LBL_HIDE': 'Ẩn',
  'LBL_APPLICATION': 'Phần mềm',
  'LBL_SCOPE': 'Phạm vi',
  'LBL_GENERAL': 'Tổng quát',
  'LBL_PERSONAL': 'Cá nhân',
  'LBL_SYSTEM': 'Hệ thống',
  'LBL_STARTING': 'Đang khởi động',
  'LBL_SOUNDS': 'Âm thanh',
  'LBL_STORE': 'Chợ ứng dụng',
  'LBL_LOCALE': 'Ngôn ngữ',
  'LBL_PACKAGE': 'Phần mềm',
  'LBL_PACKAGES': 'Các phần mềm',
  'LBL_INPUT': 'Đầu vào',
  'LBL_MISC': 'Linh tinh',
  'LBL_OTHER': 'Khác',
  'LBL_USERS': 'Người dùng',
  'LBL_FONTS': 'Phông'
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': '打开文件错误',
  'ERR_WM_NOT_RUNNING': '窗口管理器未支持',
  'ERR_FILE_OPEN_FMT': '文件 \'**{0}**\' 无法打开',
  'ERR_APP_MIME_NOT_FOUND_FMT': '找不到能打开此 \'{0}\' 文件的应用',
  'ERR_APP_LAUNCH_FAILED': '应用运行失败',
  'ERR_APP_LAUNCH_FAILED_FMT': '运行时出现错误: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': '应用 \'{0}\' 构建失败: {1}',
  'ERR_APP_INIT_FAILED_FMT': '应用 \'{0}\' 初始化失败: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': '应用资源文件丢失 \'{0}\' 或加载失败',
  'ERR_APP_PRELOAD_FAILED_FMT': '应用 \'{0}\' 载入失败: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '这个应用 \'{0}\' 已经运行，且只支持单实例运行',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '运行应用失败 \'{0}\'. 未找到清单文件',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': '运行应用失败 \'{0}\'. 你的浏览器支持: {1}',

  'ERR_NO_WM_RUNNING': '没有窗口管理器在运行',
  'ERR_CORE_INIT_FAILED': '初始化OS.js失败',
  'ERR_CORE_INIT_FAILED_DESC': '初始化OS.js时出现一个错误',
  'ERR_CORE_INIT_NO_WM': '无法运行OS.js: 没有指定窗口管理器',
  'ERR_CORE_INIT_WM_FAILED_FMT': '无法运行OS.js: 运行窗口管理器失败: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': '无法运行OS.js: 无法加载资源文件...',
  'ERR_JAVASCRIPT_EXCEPTION': '脚本错误报告',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': '发生未知异常, 也许是个BUG.',

  'ERR_APP_API_ERROR': '应用API错误',
  'ERR_APP_API_ERROR_DESC_FMT': '应用 {0} 执行操作失败 \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': '缺少参数: {0}',
  'ERR_APP_UNKNOWN_ERROR': '未知错误',

  // Window
  'ERR_WIN_DUPLICATE_FMT': '你已经有了一个被命名的窗口 \'{0}\'',
  'WINDOW_MINIMIZE': '最小化',
  'WINDOW_MAXIMIZE': '最大化',
  'WINDOW_RESTORE': '还原',
  'WINDOW_CLOSE': '关闭',
  'WINDOW_ONTOP_ON': '置顶 (开)',
  'WINDOW_ONTOP_OFF': '置顶 (关)',

  // Handler
  'TITLE_SIGN_OUT': '退出',
  'TITLE_SIGNED_IN_AS_FMT': '登录: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': '退出 (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': '注册用户 \'{0}\'.\n你是否想保留当前会话?',

  'DIALOG_CLOSE': '关闭',
  'DIALOG_CANCEL': '取消',
  'DIALOG_APPLY': '应用',
  'DIALOG_OK': '确定',

  'DIALOG_ALERT_TITLE': '错误',

  'DIALOG_COLOR_TITLE': '调色板',
  'DIALOG_COLOR_R': '红: {0}',
  'DIALOG_COLOR_G': '绿: {0}',
  'DIALOG_COLOR_B': '蓝: {0}',
  'DIALOG_COLOR_A': '透明度: {0}',

  'DIALOG_CONFIRM_TITLE': '确认',

  'DIALOG_ERROR_MESSAGE': '错误信息',
  'DIALOG_ERROR_SUMMARY': '错误概要',
  'DIALOG_ERROR_TRACE': '错误跟踪',
  'DIALOG_ERROR_BUGREPORT': 'BUG反馈',

  'DIALOG_FILE_SAVE': '保存',
  'DIALOG_FILE_OPEN': '打开',
  'DIALOG_FILE_MKDIR': '新建目录',
  'DIALOG_FILE_MKDIR_MSG': '在 **{0}** 里创建一个目录',
  'DIALOG_FILE_OVERWRITE': '你确定要覆盖 \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': '视图类型',
  'DIALOG_FILE_MNU_LISTVIEW': '列表',
  'DIALOG_FILE_MNU_TREEVIEW': '树型框',
  'DIALOG_FILE_MNU_ICONVIEW': '图标',
  'DIALOG_FILE_ERROR': '文件错误',
  'DIALOG_FILE_ERROR_SCANDIR': '有错误发生，导致无法显示目录 \'{0}\' 列表',
  'DIALOG_FILE_MISSING_FILENAME': '你需要选择一个文件或者输入一个文件名！',
  'DIALOG_FILE_MISSING_SELECTION': '你需要选择一个文件!',

  'DIALOG_FILEINFO_TITLE': '文件信息',
  'DIALOG_FILEINFO_LOADING': '从 {0} 加载文件信息',
  'DIALOG_FILEINFO_ERROR': '读取文件信息错误',
  'DIALOG_FILEINFO_ERROR_LOOKUP': '无法获取**{0}**的文件信息',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': '无法获取文件信息: {0}',

  'DIALOG_INPUT_TITLE': '输入',

  'DIALOG_FILEPROGRESS_TITLE': '文件操作',
  'DIALOG_FILEPROGRESS_LOADING': '加载中...',

  'DIALOG_UPLOAD_TITLE': '上传',
  'DIALOG_UPLOAD_DESC': '上传文件到**{0}**.<br />最大限制: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': '正在上传 \'{0}\' ({1} {2}) 到 {3}',
  'DIALOG_UPLOAD_MSG': '上传文件...',
  'DIALOG_UPLOAD_FAILED': '上传失败',
  'DIALOG_UPLOAD_FAILED_MSG': '上传文件失败',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': '未知原因...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': '用户取消...',
  'DIALOG_UPLOAD_TOO_BIG': '文件过大',
  'DIALOG_UPLOAD_TOO_BIG_FMT': '文件过大, 超过 {0}',

  'DIALOG_FONT_TITLE': '字体',

  'DIALOG_APPCHOOSER_TITLE': '选择应用',
  'DIALOG_APPCHOOSER_MSG': '选择一个应用打开',
  'DIALOG_APPCHOOSER_NO_SELECTION': '你必须要选择一个应用',
  'DIALOG_APPCHOOSER_SET_DEFAULT': '使用默认应用打开 {0}',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI 模块未配置或者未开启',
  'GAPI_SIGN_OUT': '注销GoogleAPI',
  'GAPI_REVOKE': '撤销权限并注销',
  'GAPI_AUTH_FAILURE': 'GoogleAPI 认证失败或者未认证',
  'GAPI_AUTH_FAILURE_FMT': '认证失败: {0}:{1}',
  'GAPI_LOAD_FAILURE': '加载Google API失败',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API 模块未配置或者未开启',
  'WLAPI_SIGN_OUT': '注销Window Live API',
  'WLAPI_LOAD_FAILURE': '加载 Windows Live API失败',
  'WLAPI_LOGIN_FAILED': '无法登录到Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': '无法登录到Windows Live API: {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': '数据库名称未定义，无法创建数据库',
  'IDB_NO_SUCH_ITEM': '没有项目',

  // VFS
  'ERR_VFS_FATAL': '致命的错误',
  'ERR_VFS_UNAVAILABLE': '不可用',
  'ERR_VFS_FILE_ARGS': '文件至少需要一个参数',
  'ERR_VFS_NUM_ARGS': '参数不够',
  'ERR_VFS_EXPECT_FILE': '需要一个文件对象',
  'ERR_VFS_EXPECT_SRC_FILE': '需要一个文件内容对象',
  'ERR_VFS_EXPECT_DST_FILE': '需要目标文件',
  'ERR_VFS_FILE_EXISTS': '目标文件已存在',
  'ERR_VFS_TRANSFER_FMT': '保存时发生错误: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': '没有指定目标文件路径，无法上传',
  'ERR_VFS_UPLOAD_NO_FILES': '没有指定文件，无法上传。',
  'ERR_VFS_UPLOAD_FAIL_FMT': '上传失败: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': '文件上传取消',
  'ERR_VFS_DOWNLOAD_NO_FILE': '未指定文件路径无法下载',
  'ERR_VFS_DOWNLOAD_FAILED': '文件下载时发生活错误: {0}',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': '下载文件',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR 错误',
  'ERR_VFSMODULE_ROOT_ID': '找不到要根目录',
  'ERR_VFSMODULE_NOSUCH': '文件不存在',
  'ERR_VFSMODULE_PARENT': '上层目录不存在',
  'ERR_VFSMODULE_PARENT_FMT': '无法浏览上层目录: {0}',
  'ERR_VFSMODULE_SCANDIR': '搜索目录失败',
  'ERR_VFSMODULE_SCANDIR_FMT': '搜索目录失败: {0}',
  'ERR_VFSMODULE_READ': '读取文件失败',
  'ERR_VFSMODULE_READ_FMT': '读取文件失败: {0}',
  'ERR_VFSMODULE_WRITE': '写入文件失败',
  'ERR_VFSMODULE_WRITE_FMT': '写入文件失败: {0}',
  'ERR_VFSMODULE_COPY': '复制文件失败',
  'ERR_VFSMODULE_COPY_FMT': '复制文件失败: {0}',
  'ERR_VFSMODULE_UNLINK': '删除文件失败 file',
  'ERR_VFSMODULE_UNLINK_FMT': '删除文件失败: {0}',
  'ERR_VFSMODULE_MOVE': '移动文件失败',
  'ERR_VFSMODULE_MOVE_FMT': '移动文件失败: {0}',
  'ERR_VFSMODULE_EXIST': '检查文件是否存在失败',
  'ERR_VFSMODULE_EXIST_FMT': '检查文件是否存在失败: {0}',
  'ERR_VFSMODULE_FILEINFO': '获取文件信息失败',
  'ERR_VFSMODULE_FILEINFO_FMT': '获取文件信息失败: {0}',
  'ERR_VFSMODULE_MKDIR': '创建目录失败',
  'ERR_VFSMODULE_MKDIR_FMT': '创建目录失败: {0}',
  'ERR_VFSMODULE_URL': '获取远程文件失败',
  'ERR_VFSMODULE_URL_FMT': '获取远程文件失败: {0}',
  'ERR_VFSMODULE_TRASH': '将文件移动到回收站失败',
  'ERR_VFSMODULE_TRASH_FMT': '将文件移动到回收站失败: {0}',
  'ERR_VFSMODULE_UNTRASH': '将文件移出回收站失败',
  'ERR_VFSMODULE_UNTRASH_FMT': '将文件移出回收站失败: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': '清空回收收失败',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': '清空回收收失败: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': '你正在登录到Dropbox API',
  'DROPBOX_SIGN_OUT': '注销Google API 服务',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': '找不到项目',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': '无法打开文件',
  'ERR_FILE_APP_OPEN_FMT': '文件 {0} 的类型 {1} 不支持,无法打开',
  'ERR_FILE_APP_OPEN_ALT_FMT': '文件 {0} 无法打开: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': '文件 {0} 无法保存: {1}',
  'ERR_GENERIC_APP_FMT': '{0} 应用错误',
  'ERR_GENERIC_APP_ACTION_FMT': '无法执行此操作 \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': '未知错误',
  'ERR_GENERIC_APP_REQUEST': '请求时发生错误',
  'ERR_GENERIC_APP_FATAL_FMT': '致命错误: {0}',
  'MSG_GENERIC_APP_DISCARD': '放弃更改?',
  'MSG_FILE_CHANGED': '该文件已更改。确定重新载入？',
  'MSG_APPLICATION_WARNING': '应用警告',
  'MSG_MIME_OVERRIDE': '该文件 "{0}" 的类型不支持，用 "{1}" 替代.',

  // General

  'LBL_UNKNOWN': '未知',
  'LBL_APPEARANCE': '外观',
  'LBL_USER': '用户',
  'LBL_NAME': '名称',
  'LBL_APPLY': '应用',
  'LBL_FILENAME': '文件名',
  'LBL_PATH': '路径',
  'LBL_SIZE': '大小',
  'LBL_TYPE': '类似',
  'LBL_MIME': '扩展类型',
  'LBL_LOADING': '加载',
  'LBL_SETTINGS': '设置',
  'LBL_ADD_FILE': '添加文件',
  'LBL_COMMENT': '评论',
  'LBL_ACCOUNT': '账户',
  'LBL_CONNECT': '联系',
  'LBL_ONLINE': '在线',
  'LBL_OFFLINE': '离线',
  'LBL_AWAY': '离开',
  'LBL_BUSY': '忙碌',
  'LBL_CHAT': '聊天',
  'LBL_HELP': '帮助',
  'LBL_ABOUT': '关于',
  'LBL_PANELS': '控制板',
  'LBL_LOCALES': '本地化',
  'LBL_THEME': '主题',
  'LBL_COLOR': '颜色',
  'LBL_PID': '句柄',
  'LBL_KILL': '结束',
  'LBL_ALIVE': '活动',
  'LBL_INDEX': '索引',
  'LBL_ADD': '添加',
  'LBL_FONT': '字体',
  'LBL_YES': '是',
  'LBL_NO': '否',
  'LBL_CANCEL': '取消',
  'LBL_TOP': '上',
  'LBL_LEFT': '左',
  'LBL_RIGHT': '右',
  'LBL_BOTTOM': '下',
  'LBL_CENTER': '中',
  'LBL_FILE': '文件',
  'LBL_NEW': '新建',
  'LBL_OPEN': '打开',
  'LBL_SAVE': '保存',
  'LBL_SAVEAS': '加存为...',
  'LBL_CLOSE': '关闭',
  'LBL_MKDIR': '创建目录',
  'LBL_UPLOAD': '上传',
  'LBL_VIEW': '查看',
  'LBL_EDIT': '编辑',
  'LBL_RENAME': '重命名',
  'LBL_DELETE': '删除',
  'LBL_OPENWITH': '打开方式...',
  'LBL_ICONVIEW': '图标',
  'LBL_TREEVIEW': '树型框',
  'LBL_LISTVIEW': '列表',
  'LBL_REFRESH': '刷新',
  'LBL_VIEWTYPE': '视图类型',
  'LBL_BOLD': '加粗',
  'LBL_ITALIC': '斜体',
  'LBL_UNDERLINE': '下划线',
  'LBL_REGULAR': '对齐',
  'LBL_STRIKE': '删除线',
  'LBL_INDENT': '缩进',
  'LBL_OUTDENT': '减少缩进',
  'LBL_UNDO': '撤销',
  'LBL_REDO': '重做',
  'LBL_CUT': '剪切',
  'LBL_UNLINK': '删除',
  'LBL_COPY': '复制',
  'LBL_PASTE': '粘贴',
  'LBL_INSERT': '插入',
  'LBL_IMAGE': '图片',
  'LBL_LINK': '链接',
  'LBL_DISCONNECT': '清除链接',
  'LBL_APPLICATIONS': '应用',
  'LBL_ADD_FOLDER': '添加目录',
  'LBL_INFORMATION': '文件信息',
  'LBL_TEXT_COLOR': '字体颜色',
  'LBL_BACK_COLOR': '背景颜色',
  'LBL_RESET_DEFAULT': '恢复默认设置',
  'LBL_DOWNLOAD_COMP': '下载到电脑',
  'LBL_ORDERED_LIST': '有序列表',
  'LBL_BACKGROUND_IMAGE': '背景图片',
  'LBL_BACKGROUND_COLOR': '背景颜色',
  'LBL_UNORDERED_LIST': '无序列表',

  //
  // NEW
  //
  'LBL_STATUS': '状态',
  'LBL_READONLY': '只读'
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerHook = triggerHook;
exports.addHook = addHook;
exports.removeHook = removeHook;

var _eventHandler = __webpack_require__(122);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handler = new _eventHandler2.default('core-hooks', ['initialize', 'initialized', 'sessionLoaded', 'shudown', 'processStart', // => (name, args)
'processStarted', // => (info)
'menuBlur']);

/**
 * Method for triggering a hook
 *
 * @param   {String}    name      Hook name
 * @param   {Array}     args      List of arguments
 * @param   {Object}    thisarg   'this' ref
 */
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
function triggerHook(name, args, thisarg) {
  if (handler) {
    handler.emit(name, args, thisarg, true);
  }
}

/**
 * Method for adding a hook
 *
 * @param   {String}    name    Hook name
 * @param   {Function}  fn      Callback => fn()
 *
 * @return  {Number}       The index of hook
 */
function addHook(name, fn) {
  if (handler) {
    return handler.on(name, fn);
  }
  return -1;
}

/**
 * Method for removing a hook
 *
 * @param   {String}    name    Hook name
 * @param   {Number}    [index] Hook index
 *
 * @return  {Boolean}
 */
function removeHook(name, index) {
  if (handler) {
    return handler.off(name, index);
  }

  return false;
}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _config = __webpack_require__(15);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * OS.js VFS Transport Module
 *
 * This module allows you to interact with files via the OS.js server.
 *
 * @extends Transport
 */
var OSjsTransport = function (_Transport) {
  _inherits(OSjsTransport, _Transport);

  function OSjsTransport() {
    _classCallCheck(this, OSjsTransport);

    return _possibleConstructorReturn(this, (OSjsTransport.__proto__ || Object.getPrototypeOf(OSjsTransport)).apply(this, arguments));
  }

  _createClass(OSjsTransport, [{
    key: '_request',
    value: function _request(method, args, options) {
      return _connection2.default.request('FS:' + method, args, options);
    }
  }, {
    key: '_requestUpload',
    value: function _requestUpload(dest, file, options) {
      options = options || {};
      dest = dest instanceof _file2.default ? dest.path : dest;

      if (typeof file.size !== 'undefined') {
        var maxSize = (0, _config.getConfig)('VFS.MaxUploadSize');
        if (maxSize > 0) {
          var bytes = file.size;
          if (bytes > maxSize) {
            var msg = (0, _locales._)('DIALOG_UPLOAD_TOO_BIG_FMT', FS.humanFileSize(maxSize));
            return _bluebird2.default.reject(new Error(msg));
          }
        }
      }

      var fd = new FormData();
      fd.append('path', dest);
      if (file) {
        fd.append('filename', file.filename);
      }

      if (options) {
        Object.keys(options).forEach(function (key) {
          if (key !== 'meta' && typeof options[key] !== 'function') {
            fd.append(key, String(options[key]));
          }
        });
      }

      if (file instanceof window.ArrayBuffer) {
        fd.append('size', String(file.byteLength));
      }

      FS.addFormFile(fd, 'upload', file, options.meta);

      return this._request('upload', fd, options);
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options) {
      var _this2 = this;

      options = options || {};

      var args = {
        path: item.path,
        options: {
          shortcuts: options.shortcuts
        }
      };

      return new _bluebird2.default(function (resolve, reject) {
        _this2._request('scandir', args, options).then(function (result) {
          return resolve(result.map(function (i) {
            return new _file2.default(i);
          }));
        }).catch(reject);
      });
    }
  }, {
    key: 'read',
    value: function read(item, options) {
      return this._request('get', { path: item.path }, options);
    }
  }, {
    key: 'write',
    value: function write(file, data, options) {
      options = options || {};
      options.meta = file;
      options.overwrite = true;
      options.onprogress = options.onprogress || function () {};

      var parentfile = new _file2.default(FS.dirname(file.path), file.mime);
      return this._requestUpload(parentfile, data, options);
    }
  }, {
    key: 'unlink',
    value: function unlink(src) {
      return this._request('unlink', { path: src.path });
    }
  }, {
    key: 'copy',
    value: function copy(src, dest, options) {
      return this._request('copy', { src: src.path, dest: dest.path }, options);
    }
  }, {
    key: 'move',
    value: function move(src, dest, options) {
      return this._request('move', { src: src.path, dest: dest.path }, options);
    }
  }, {
    key: 'exists',
    value: function exists(item) {
      return this._request('exists', { path: item.path });
    }
  }, {
    key: 'fileinfo',
    value: function fileinfo(item) {
      return this._request('fileinfo', { path: item.path });
    }
  }, {
    key: 'mkdir',
    value: function mkdir(dir) {
      return this._request('mkdir', { path: dir.path });
    }
  }, {
    key: 'upload',
    value: function upload(dest, data, options) {
      return this._requestUpload(dest, data, options);
    }
  }, {
    key: 'url',
    value: function url(item, options) {
      if (typeof item === 'string') {
        item = new _file2.default(item);
      }

      return _bluebird2.default.resolve(_connection2.default.instance.getVFSPath(item, options));
    }
  }, {
    key: 'find',
    value: function find(file, options) {
      return this._request('find', { path: file.path, args: options });
    }
  }, {
    key: 'trash',
    value: function trash(file) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'untrash',
    value: function untrash(file) {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'emptyTrash',
    value: function emptyTrash() {
      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
    }
  }, {
    key: 'freeSpace',
    value: function freeSpace(root) {
      return this._request('freeSpace', { root: root });
    }
  }]);

  return OSjsTransport;
}(_transport2.default);

exports.default = OSjsTransport;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(204);

//
// For browsers without "console" for some reason
//
(function () {
  window.console = window.console || {};
  console.log = console.log || function () {};
  console.debug = console.debug || console.log;
  console.error = console.error || console.log;
  console.warn = console.warn || console.log;
  console.group = console.group || console.log;
  console.groupEnd = console.groupEnd || console.log;
})();

//
// Add certain methods to global objects
//
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
['forEach', 'every', 'map'].forEach(function (n) {
  ['HTMLCollection', 'NodeList', 'FileList'].forEach(function (p) {
    if (window[p]) {
      window[p].prototype[n] = Array.prototype[n];
    }
  });
});

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

//
// CustomEvent for IE
//
(function () {
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: window.undefined };

    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  if (window.navigator.userAgent.match(/MSIE|Edge|Trident/)) {
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  }
})();

//
// MouseEvent
//
/*
(function() {
  // eslint no-new: 0
  try {
    new window.MouseEvent('test');
    return;
  } catch (e) {
  }

  function MouseEvent(eventType, params) {
    params = params || {bubbles: false, cancelable: false};

    var mouseEvent = document.createEvent('MouseEvent');
    mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, params.relatedTarget);
    return mouseEvent;
  }

  MouseEvent.prototype = Event.prototype;
  window.MouseEvent = MouseEvent;
})();
*/

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
exports.stop = stop;
exports.restart = restart;
exports.logout = logout;
exports.running = running;

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _locales = __webpack_require__(10);

var Locales = _interopRequireWildcard(_locales);

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _searchEngine = __webpack_require__(417);

var _searchEngine2 = _interopRequireDefault(_searchEngine);

var _authenticator = __webpack_require__(119);

var _authenticator2 = _interopRequireDefault(_authenticator);

var _windowManager = __webpack_require__(89);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _dialog2 = __webpack_require__(34);

var _dialog3 = _interopRequireDefault(_dialog2);

var _storage = __webpack_require__(118);

var _storage2 = _interopRequireDefault(_storage);

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _hooks = __webpack_require__(181);

var _config = __webpack_require__(15);

var _splash = __webpack_require__(418);

var _splash2 = _interopRequireDefault(_splash);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _menu = __webpack_require__(90);

var Menu = _interopRequireWildcard(_menu);

var _preloader = __webpack_require__(120);

var _preloader2 = _interopRequireDefault(_preloader);

var _alert = __webpack_require__(419);

var _alert2 = _interopRequireDefault(_alert);

var _applicationchooser = __webpack_require__(420);

var _applicationchooser2 = _interopRequireDefault(_applicationchooser);

var _color = __webpack_require__(421);

var _color2 = _interopRequireDefault(_color);

var _confirm = __webpack_require__(422);

var _confirm2 = _interopRequireDefault(_confirm);

var _error = __webpack_require__(423);

var _error2 = _interopRequireDefault(_error);

var _fileinfo = __webpack_require__(424);

var _fileinfo2 = _interopRequireDefault(_fileinfo);

var _file = __webpack_require__(425);

var _file2 = _interopRequireDefault(_file);

var _fileprogress = __webpack_require__(426);

var _fileprogress2 = _interopRequireDefault(_fileprogress);

var _fileupload = __webpack_require__(427);

var _fileupload2 = _interopRequireDefault(_fileupload);

var _font = __webpack_require__(428);

var _font2 = _interopRequireDefault(_font);

var _input = __webpack_require__(429);

var _input2 = _interopRequireDefault(_input);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
var hasBooted = false;
var hasShutDown = false;

///////////////////////////////////////////////////////////////////////////////
// HELPERS
///////////////////////////////////////////////////////////////////////////////

function onError(title, message, error, exception, bugreport) {
  bugreport = function () {
    if ((0, _config.getConfig)('BugReporting.enabled')) {
      return typeof bugreport === 'undefined' ? false : bugreport ? true : false;
    }
    return false;
  }();

  function _dialog() {
    var wm = _windowManager2.default.instance;
    if (wm && wm._fullyLoaded) {
      try {
        _dialog3.default.create('Error', {
          title: title,
          message: message,
          error: error,
          exception: exception,
          bugreport: bugreport
        });

        return true;
      } catch (e) {
        console.warn('An error occured while creating Error Dialog', e);
        console.warn('stack', e.stack);
      }
    }

    return false;
  }

  Menu.blur();

  if (exception instanceof Error && exception.message.match(/^Script Error/i) && String(exception.lineNumber).match(/^0/)) {
    console.error('VENDOR ERROR', {
      title: title,
      message: message,
      error: error,
      exception: exception
    });
    return;
  } else {
    console.error(title, message, error, exception);
  }

  var testMode = false && window.location.hash.match(/mocha=true/);
  if (!testMode) {
    if (!_dialog()) {
      window.alert(title + '\n\n' + message + '\n\n' + error);
    }
  }
}

///////////////////////////////////////////////////////////////////////////////
// INITIALIZERS
///////////////////////////////////////////////////////////////////////////////

/**
 * Initialize: Preloading
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initPreloading = function initPreloading(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var flatten = function flatten(list) {
      return list.reduce(function (a, b) {
        return a.concat(Array.isArray(b) ? flatten(b) : b);
      }, []);
    };

    _preloader2.default.preload(flatten(config.Preloads)).then(function (result) {
      return resolve();
    }).catch(reject);
  });
};

/**
 * Initialize: Handlers
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initHandlers = function initHandlers(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var options = config.Connection;
    console.log({
      authenticator: options.Authenticator,
      connection: options.Connection,
      storage: options.Storage
    });

    var Authenticator = void 0,
        Connection = void 0,
        Storage = void 0;
    var connectionName = options.Connection.split('+').indexOf('ws') !== -1 ? 'ws' : 'http';
    try {
      Authenticator = __webpack_require__(512)("./" + options.Authenticator + '.js').default;
      Connection = __webpack_require__(513)("./" + connectionName + '.js').default;
      Storage = __webpack_require__(514)("./" + options.Storage + '.js').default;
    } catch (e) {
      reject(e);
      return;
    }

    var connection = new Connection();
    var authenticator = new Authenticator();
    var storage = new Storage();

    _bluebird2.default.each([connection, storage, authenticator], function (iter) {
      return iter.init();
    }).then(resolve).catch(reject);
  });
};

/**
 * Initialize: VFS
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initVFS = function initVFS(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var mountPoints = _settingsManager2.default.instance('VFS').get('mounts', []);

    _mountManager2.default.init().then(function (res) {
      return _mountManager2.default.addList(mountPoints).then(function (res) {
        return resolve(res);
      }).catch(function (e) {
        console.warn('A module failed to load!', e);
        resolve();
      });
    }).catch(reject);
  });
};

/**
 * Initialize: Settings Manager
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initSettingsManager = function initSettingsManager(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var pools = config.SettingsManager || {};

    Object.keys(pools).forEach(function (poolName) {
      console.debug('initSettingsManager()', 'initializes pool', poolName, pools[poolName]);
      _settingsManager2.default.instance(poolName, pools[poolName] || {});
    });

    resolve();
  });
};

/**
 * Initialize: Package Manager
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initPackageManager = function initPackageManager(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var list = config.PreloadOnBoot || [];

    var metadata = {};
    try {
      // In case of standalone
      metadata = OSjs.getManifest();
    } catch (e) {}

    var auth = _authenticator2.default.instance;
    _packageManager2.default.init(metadata, auth.isStandalone).then(function () {
      return _bluebird2.default.each(list, function (iter) {
        return new _bluebird2.default(function (next) {
          var pkg = _packageManager2.default.getPackage(iter);
          if (pkg && pkg.preload) {
            _preloader2.default.preload(pkg.preload).then(next).catch(function () {
              return next();
            });
          } else {
            next();
          }
        });
      }).then(resolve).catch(reject);
    }).catch(reject);
  });
};

/**
 * Initialize: Extensions
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initExtensions = function initExtensions(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var packages = _packageManager2.default.getPackages();

    var preloadExtensions = function preloadExtensions() {
      return new _bluebird2.default(function (resolve, reject) {
        var preloads = [];
        Object.keys(packages).forEach(function (k) {
          var iter = packages[k];
          if (iter.type === 'extension' && iter.preload) {
            preloads = preloads.concat(iter.preload);
          }
        });

        if (preloads.length) {
          _preloader2.default.preload(preloads).then(resolve).catch(function () {
            return resolve();
          });
        } else {
          resolve();
        }
      });
    };

    var launchExtensions = function launchExtensions() {
      return new _bluebird2.default(function (resolve, reject) {
        var exts = Object.keys(OSjs.Extensions);

        _bluebird2.default.each(exts, function (entry) {
          return new _bluebird2.default(function (yes, no) {
            try {
              var m = packages[entry];
              var promise = OSjs.Extensions[entry].init(m);
              if (!(promise instanceof _bluebird2.default)) {
                promise = _bluebird2.default.resolve(true);
              }

              promise.then(yes).catch(function (err) {
                console.error(err);
                return yes(false);
              });
            } catch (e) {
              console.warn('Extension init failed', e.stack, e);
              yes(false);
            }
          });
        }).then(resolve).catch(function (err) {
          console.warn(err);
          reject(new Error(err));
        });
      });
    };

    preloadExtensions().then(function () {
      return launchExtensions().then(resolve).catch(reject);
    }).catch(function () {
      return resolve();
    });
  });
};

/**
 * Initialize: Search Engine
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initSearchEngine = function initSearchEngine(config) {
  return new _bluebird2.default(function (resolve, reject) {
    _searchEngine2.default.init().then(resolve).catch(reject);
  });
};

/**
 * Initialize: GUI
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initGUI = function initGUI(config) {
  return new _bluebird2.default(function (resolve, reject) {

    var guiElements = ['containers', 'visual', 'tabs', 'richtext', 'misc', 'inputs', 'treeview', 'listview', 'iconview', 'fileview', 'menus'];
    guiElements.forEach(function (f) {
      var gel = __webpack_require__(515)("./" + f + '.js').default;
      Object.keys(gel).forEach(function (name) {
        gel[name].register();
      });
    });

    OSjs.error = onError;
    OSjs.Dialogs.Alert = _alert2.default;
    OSjs.Dialogs.ApplicationChooser = _applicationchooser2.default;
    OSjs.Dialogs.Color = _color2.default;
    OSjs.Dialogs.Confirm = _confirm2.default;
    OSjs.Dialogs.Error = _error2.default;
    OSjs.Dialogs.File = _file2.default;
    OSjs.Dialogs.FileInfo = _fileinfo2.default;
    OSjs.Dialogs.FileProgress = _fileprogress2.default;
    OSjs.Dialogs.FileUpload = _fileupload2.default;
    OSjs.Dialogs.Font = _font2.default;
    OSjs.Dialogs.Input = _input2.default;

    _theme2.default.init();

    resolve();
  });
};

/**
 * Initialize: Window Manager
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initWindowManager = function initWindowManager(config) {
  return new _bluebird2.default(function (resolve, reject) {
    var wmConfig = config.WindowManager;

    if (!wmConfig || !wmConfig.exec) {
      reject(new Error(Locales._('ERR_CORE_INIT_NO_WM')));
    } else {
      _process2.default.create(wmConfig.exec, wmConfig.args || {}).then(function (app) {
        return app.setup().then(resolve).catch(reject);
      }).catch(function (error) {
        reject(new Error(Locales._('ERR_CORE_INIT_WM_FAILED_FMT', error)));
      });
    }
  });
};

/**
 * Initialize: Mocha
 * @param {Object} config Configuration
 * @return {Promise}
 */
var initMocha = function initMocha(config) {
  return new _bluebird2.default(function (resolve, reject) {

    var div = document.createElement('div');
    div.id = 'mocha';
    document.body.appendChild(div);
    document.body.style.overflow = 'auto';
    document.body.style.backgroundColor = '#ffffff';

    _preloader2.default.preload(['/test.css', '/test.js']).then(function () {
      OSjs.runTests();
    });

    resolve(true);
  });
};

///////////////////////////////////////////////////////////////////////////////
// MISC
///////////////////////////////////////////////////////////////////////////////

/*
 * Initializes the user session
 */
function initSession(config) {
  console.debug('initSession()');

  var list = [];

  // In this case we merge the Autostart and the previous session together.
  // This ensures that items with autostart are loaded with correct
  // session data on restore. This is much better than relying on the internal
  // event/message system which does not trigger until after everything is loaded...
  // this does everything beforehand! :)
  //
  try {
    list = config.AutoStart;
  } catch (e) {
    console.warn('initSession()->autostart()', 'exception', e, e.stack);
  }

  var checkMap = {};
  var skipMap = [];
  list.forEach(function (iter, idx) {
    if (typeof iter === 'string') {
      iter = list[idx] = { name: iter };
    }
    if (skipMap.indexOf(iter.name) === -1) {
      if (!checkMap[iter.name]) {
        checkMap[iter.name] = idx;
        skipMap.push(iter.name);
      }
    }
  });

  return new _bluebird2.default(function (resolve) {
    _storage2.default.instance.getLastSession().then(function (adds) {
      adds.forEach(function (iter) {
        if (typeof checkMap[iter.name] === 'undefined') {
          list.push(iter);
        } else {
          if (iter.args) {
            var refid = checkMap[iter.name];
            var ref = list[refid];
            if (!ref.args) {
              ref.args = {};
            }
            ref.args = Utils.mergeObject(ref.args, iter.args);
          }
        }
      });

      console.info('initSession()->autostart()', list);
      return _process2.default.createFromArray(list).then(resolve).catch(resolve);
    }).catch(function (err) {
      console.warn(err);
      resolve();
    });
  });
}

/*
 * When window gets an external message
 */
function onMessage(ev) {
  if (ev && ev.data && typeof ev.data.message !== 'undefined' && typeof ev.data.pid === 'number') {
    console.debug('window::message()', ev.data);
    var proc = _process2.default.getProcess(ev.data.pid);
    if (proc) {
      if (typeof proc.onPostMessage === 'function') {
        proc.onPostMessage(ev.data.message, ev);
      }

      if (typeof proc._getWindow === 'function') {
        var win = proc._getWindow(ev.data.wid, 'wid');
        if (win) {
          win.onPostMessage(ev.data.message, ev);
        }
      }
    }
  }
}

///////////////////////////////////////////////////////////////////////////////
// API
///////////////////////////////////////////////////////////////////////////////

/**
 * Starts OS.js
 */
function start() {
  if (hasBooted || hasShutDown) {
    return;
  }
  hasBooted = true;

  console.info('Starting OS.js');

  var config = OSjs.getConfig();
  var testMode = false && window.location.hash.match(/mocha=true/);
  var total = 9;

  Locales.init(config.Locale, config.LocaleOptions, config.Languages);

  _splash2.default.watermark(config);
  _splash2.default.show();

  (0, _hooks.triggerHook)('initialize');

  _bluebird2.default.each([initPreloading, initHandlers, initVFS, initSettingsManager, initPackageManager, initExtensions, initSearchEngine, initGUI, testMode ? initMocha : initWindowManager], function (fn, index) {
    return new _bluebird2.default(function (resolve, reject) {
      console.group('Initializing', index + 1, 'of', total);
      _splash2.default.update(index, total);

      return fn(config).then(function (res) {
        console.groupEnd();
        return resolve(res);
      }).catch(function (err) {
        console.warn(err);
        console.groupEnd();
        return reject(new Error(err));
      });
    });
  }).then(function () {
    console.info('Done!');

    window.addEventListener('message', onMessage, false);

    (0, _hooks.triggerHook)('initialized');
    _splash2.default.hide();

    if (!testMode) {
      _theme2.default.playSound('LOGIN');

      var wm = _windowManager2.default.instance;
      if (wm) {
        wm._fullyLoaded = true;
      }

      initSession(config).then(function () {
        return (0, _hooks.triggerHook)('sessionLoaded');
      });
    }

    return true;
  }).catch(function (err) {
    var title = Locales._('ERR_CORE_INIT_FAILED');
    var message = Locales._('ERR_CORE_INIT_FAILED_DESC');
    alert(title + '\n\n' + message);
    console.error(title, message, err);
  });
}

/**
 * Stops OS.js
 * @param {Boolean} [restart=false] Restart instead of full stop
 */
function stop() {
  var restart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (hasShutDown || !hasBooted) {
    return;
  }

  hasShutDown = true;
  hasBooted = false;

  window.removeEventListener('message', onMessage, false);

  var wm = _windowManager2.default.instance;
  if (wm) {
    wm.toggleFullscreen();
  }

  _preloader2.default.clear();
  Menu.blur();
  _process2.default.killAll();
  _searchEngine2.default.destroy();
  _packageManager2.default.destroy();
  _authenticator2.default.instance.destroy();
  _storage2.default.instance.destroy();
  _connection2.default.instance.destroy();

  (0, _hooks.triggerHook)('shutdown');

  console.warn('OS.js was shut down!');

  if (!restart && (0, _config.getConfig)('ReloadOnShutdown') === true) {
    window.location.reload();
  }
}

/**
 * Restarts OS.js
 * @param {Boolean} [save=false] Save session
 */
function restart() {
  var save = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var lout = function lout(cb) {
    return _authenticator2.default.instance.logout().then(cb).catch(cb);
  };

  var saveFunction = save && _storage2.default.instance ? function (cb) {
    _storage2.default.instance.saveSession().then(function () {
      return lout(cb);
    }).catch(function () {
      return lout(cb);
    });
  } : lout;

  saveFunction(function () {
    console.clear();
    stop(true);
    start();
  });
}

/**
 * Perfors a log out of OS.js
 */
function logout() {
  var storage = _storage2.default.instance;
  var wm = _windowManager2.default.instance;

  function signOut(save) {
    _theme2.default.playSound('LOGOUT');

    var lout = function lout(cb) {
      return _authenticator2.default.instance.logout().then(cb).catch(cb);
    };

    if (save) {
      storage.saveSession().then(function () {
        return lout(stop);
      }).catch(function () {
        return lout(stop);
      });
    } else {
      lout(stop);
    }
  }

  if (wm) {
    var user = _authenticator2.default.instance.getUser() || { name: Locales._('LBL_UNKNOWN') };
    _dialog3.default.create('Confirm', {
      title: Locales._('DIALOG_LOGOUT_TITLE'),
      message: Locales._('DIALOG_LOGOUT_MSG_FMT', user.name)
    }, function (ev, btn) {
      if (['no', 'yes'].indexOf(btn) !== -1) {
        signOut(btn === 'yes');
      }
    });
  } else {
    signOut(true);
  }
}

/**
 * Checks if OS.js is running
 * @return {Boolean}
 */
function running() {
  return !hasShutDown;
}

/***/ }),
/* 185 */,
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ar_DZ.js": 163,
	"./bg_BG.js": 164,
	"./de_DE.js": 165,
	"./en_EN.js": 166,
	"./es_ES.js": 167,
	"./fa_FA.js": 168,
	"./fr_FR.js": 169,
	"./it_IT.js": 170,
	"./ko_KR.js": 171,
	"./nl_NL.js": 172,
	"./no_NO.js": 173,
	"./pl_PL.js": 174,
	"./pt_BR.js": 175,
	"./ru_RU.js": 176,
	"./sk_SK.js": 177,
	"./tr_TR.js": 178,
	"./vi_VN.js": 179,
	"./zh_CN.js": 180
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
var Loader = function () {
  function Loader() {
    _classCallCheck(this, Loader);

    this.loaders = {};
    this.loaderGraze = {};
    this.$container = document.createElement('osjs-loaders');
  }

  /**
   * Create (or show) loading indicator
   *
   * @param   {String}    name          Name of notification (unique)
   * @param   {Object}    opts          Options
   */


  _createClass(Loader, [{
    key: 'create',
    value: function create(name, opts) {
      opts = opts || {};
      if (!this.$container.parentNode) {
        document.body.appendChild(this.$container);
      }

      if (this.loaders[name]) {
        return;
      }

      var el = document.createElement('osjs-loading');
      el.title = opts.title || '';
      if (opts.icon) {
        var img = document.createElement('img');
        img.src = opts.icon;
        el.appendChild(img);
      }
      this.$container.appendChild(el);

      this.loaderGraze[name] = setTimeout(function () {
        el.style.display = 'inline-block';
      }, 100);

      this.loaders[name] = el;
    }

    /**
     * Destroy (or hide) loading indicator
     *
     * @param   {String}    name          Name of notification (unique)
     */

  }, {
    key: 'destroy',
    value: function destroy(name) {
      if (!this.loaders[name]) {
        return;
      }

      clearTimeout(this.loaderGraze[name]);

      this.loaders[name].remove();
      delete this.loaders[name];
      delete this.loaderGraze[name];
    }
  }]);

  return Loader;
}();

exports.default = new Loader();

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * This is a object you can pass around in VFS when
 * handling DataURL()s (strings). Normally you would
 * use a File, Blob or ArrayBuffer, but this is an alternative.
 *
 * Useful for canvas data etc.
 */
var FileDataURL = function () {

  /**
   * @param {String}    dataURL     Data URI
   */
  function FileDataURL(dataURL) {
    _classCallCheck(this, FileDataURL);

    /**
     * File URI data (base64 encoded)
     * @type {String}
     */
    this.dataURL = dataURL;
  }

  /**
   * Get base64 data
   * @return {String}
   */


  _createClass(FileDataURL, [{
    key: 'toBase64',
    value: function toBase64() {
      return this.data.split(',')[1];
    }

    /**
     * Get raw data URI
     * @override
     * @return {String}
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.dataURL;
    }
  }]);

  return FileDataURL;
}();

exports.default = FileDataURL;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _windowManager = __webpack_require__(89);

var _windowManager2 = _interopRequireDefault(_windowManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for creating notifications
 */
var Notification = function () {
  function Notification() {
    _classCallCheck(this, Notification);

    this.$notifications = null;
    this.visibles = 0;
  }

  /**
   * Creates a new popup notification
   *
   * @param   {Object}    opts                   Notification options
   * @param   {String}    opts.icon              What icon to display
   * @param   {String}    opts.title             What title to display
   * @param   {String}    opts.message           What message to display
   * @param   {Number}    [opts.timeout=5000]    Timeout
   * @param   {Function}  opts.onClick           Event callback on click => fn(ev)
   */


  _createClass(Notification, [{
    key: 'create',
    value: function create(opts) {
      var _this = this;

      opts = opts || {};
      opts.icon = opts.icon || null;
      opts.title = opts.title || null;
      opts.message = opts.message || '';
      opts.onClick = opts.onClick || function () {};

      if (!this.$notifications) {
        this.$notifications = document.createElement('corewm-notifications');
        this.$notifications.setAttribute('role', 'log');
        document.body.appendChild(this.$notifications);
      }

      if (typeof opts.timeout === 'undefined') {
        opts.timeout = 5000;
      }

      console.debug('CoreWM::notification()', opts);

      var container = document.createElement('corewm-notification');
      var classNames = [''];
      var timeout = null;
      var animationCallback = null;

      var _remove = function _remove() {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        container.onclick = null;
        var _removeDOM = function _removeDOM() {
          Events.$unbind(container);
          if (container.parentNode) {
            container.parentNode.removeChild(container);
          }
          _this.visibles--;
          if (_this.visibles <= 0) {
            _this.$notifications.style.display = 'none';
          }
        };

        var anim = _windowManager2.default.instance.getSetting('animations');
        if (anim) {
          container.setAttribute('data-hint', 'closing');
          animationCallback = function animationCallback() {
            return _removeDOM();
          };
        } else {
          container.style.display = 'none';
          _removeDOM();
        }
      };

      if (opts.icon) {
        var icon = document.createElement('img');
        icon.alt = '';
        icon.src = opts.icon;
        classNames.push('HasIcon');
        container.appendChild(icon);
      }

      if (opts.title) {
        var title = document.createElement('div');
        title.className = 'Title';
        title.appendChild(document.createTextNode(opts.title));
        classNames.push('HasTitle');
        container.appendChild(title);
      }

      if (opts.message) {
        var message = document.createElement('div');
        message.className = 'Message';
        var lines = opts.message.split('\n');
        lines.forEach(function (line, idx) {
          message.appendChild(document.createTextNode(line));
          if (idx < lines.length - 1) {
            message.appendChild(document.createElement('br'));
          }
        });
        classNames.push('HasMessage');
        container.appendChild(message);
      }

      this.visibles++;
      if (this.visibles > 0) {
        this.$notifications.style.display = 'block';
      }

      container.setAttribute('aria-label', String(opts.title));
      container.setAttribute('role', 'alert');

      container.className = classNames.join(' ');
      container.onclick = function (ev) {
        _remove();

        opts.onClick(ev);
      };

      var preventTimeout = void 0;
      function _onanimationend(ev) {
        if (typeof animationCallback === 'function') {
          clearTimeout(preventTimeout);
          preventTimeout = setTimeout(function () {
            animationCallback(ev);
            animationCallback = false;
          }, 10);
        }
      }

      Events.$bind(container, 'transitionend', _onanimationend);
      Events.$bind(container, 'animationend', _onanimationend);

      var space = _windowManager2.default.instance.getWindowSpace(true);
      this.$notifications.style.marginTop = String(space.top) + 'px';
      this.$notifications.appendChild(container);

      if (opts.timeout) {
        timeout = setTimeout(function () {
          _remove();
        }, opts.timeout);
      }
    }

    /**
     * Creates a new Notification Icon
     * @param   {String}    name                      Internal name (unique)
     * @param   {Object}    opts                      Notification options
     * @param   {Object}    [opts.icon]               Icon to display
     * @param   {Object}    [opts.onCreated]          Event: when created
     * @param   {Object}    [opts.onInited]           Event: when inited
     * @param   {Object}    [opts.onDestroy]          Event: when destroyed
     * @param   {Object}    [opts.onClick]            Event: when clicked
     * @param   {Object}    [opts.onContextMenu]      Event: on context menu
     * @return {Boolean}
     */

  }, {
    key: 'createIcon',
    value: function createIcon(name, opts) {
      var wm = _windowManager2.default.instance;
      if (wm && typeof wm.getNotificationArea === 'function') {
        var pitem = wm.getNotificationArea();
        if (pitem) {
          return pitem.createNotification(name, opts);
        }
      }
      return null;
    }

    /**
     * Removes a Notification Icon
     * @param   {String}    name      Internal name (unique)
     * @return {Boolean}
     */

  }, {
    key: 'destroyIcon',
    value: function destroyIcon(name) {
      var wm = _windowManager2.default.instance;
      if (wm && typeof wm.getNotificationArea === 'function') {
        var pitem = wm.getNotificationArea();
        if (pitem) {
          pitem.removeNotification(name);
          return true;
        }
      }
      return false;
    }

    /**
     * Get a notification icon
     * @param   {String}    name      Internal name (unique)
     * @return {object}
     */

  }, {
    key: 'getIcon',
    value: function getIcon(name) {
      var wm = _windowManager2.default.instance;
      if (wm && typeof wm.getNotificationArea === 'function') {
        var pitem = wm.getNotificationArea();
        if (pitem) {
          return pitem.getNotification(name);
        }
      }
      return null;
    }
  }]);

  return Notification;
}();

exports.default = new Notification();

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
//import Promise from 'bluebird';


//import * as FS from 'utils/fs';


var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

var _config = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/////////////////////////////////////////////////////////////////////////////
// INTERNAL HELPERS
/////////////////////////////////////////////////////////////////////////////

/*
 * Method for adding children (moving)
 */
function addChildren(frag, root, before) {
  if (frag) {
    var children = frag.children;

    var i = 0;
    while (children.length && i < 10000) {
      if (before) {
        root.parentNode.insertBefore(children[0], root);
      } else {
        root.appendChild(children[0]);
      }
      i++;
    }
  }
}

/*
 * Makes sure "include" fragments are rendered correctly
 */
function resolveFragments(scheme, node) {
  function _resolve() {
    var nodes = node.querySelectorAll('gui-fragment');
    if (nodes.length) {
      nodes.forEach(function (el) {
        var id = el.getAttribute('data-fragment-id');
        if (id) {
          var frag = scheme.getFragment(id, 'application-fragment');
          if (frag) {
            addChildren(frag.cloneNode(true), el.parentNode);
          } else {
            console.warn('Fragment', id, 'not found');
          }
        }
        DOM.$remove(el); // Or else we'll never get out of the loop!
      });
      return true;
    }
    return false;
  }

  if (scheme) {
    var resolving = true;
    while (resolving) {
      resolving = _resolve();
    }
  }
}

/*
 * Removes self-closing tags from HTML string
 */
function removeSelfClosingTags(str) {
  var split = (str || '').split('/>');

  var newhtml = '';
  for (var i = 0; i < split.length - 1; i++) {
    var edsplit = split[i].split('<');
    newhtml += split[i] + '></' + edsplit[edsplit.length - 1].split(' ')[0] + '>';
  }
  return newhtml + split[split.length - 1];
}

/*
 * Cleans a HTML string
 */
function cleanScheme(html) {
  return DOM.$clean(removeSelfClosingTags(html));
}

/* FIXME: This is no longer used because of Webpack, but I might
 * need this for the IDE ?!
 *
 * Makes sure "external include" fragments are rendered correctly.
 *
 * Currently this only supports one level deep.
 *
 * This occurs on the load() function instead on runtime due to
 * performance concerns.
function resolveExternalFragments(root, html, cb) {
  let doc = document.createElement('div');
  doc.innerHTML = html;

  let nodes = doc.querySelectorAll('gui-fragment[data-fragment-external]');

  Promise.each(nodes.map(function(el) {
    return {
      element: el,
      uri: el.getAttribute('data-fragment-external')
    };
  }), (iter) => {
    return new Promise((next) => {
      const uri = iter.uri.replace(/^\//, '');
      if ( uri.length < 3 ) {
        console.warn('resolveExternalFragments()', 'invalid', iter);
        next();
        return;
      }

      axios({
        url: FS.pathJoin(root, uri),
        method: 'GET'
      }).then((response) => {
        let tmp = document.createElement('div');
        tmp.innerHTML = cleanScheme(response.data);
        addChildren(tmp, iter.element, iter.element);
        tmp = next();
      }).catch((err) => {
        next();
      });
    });

  }).then(() => {
    cb(doc.innerHTML);

    doc = null;
    nodes = null;

    return true;
  });
}
 */

/////////////////////////////////////////////////////////////////////////////
// SCHEME
/////////////////////////////////////////////////////////////////////////////

/**
 * The class for loading and parsing UI Schemes
 *
 * @desc Class for loading, parsing and manipulating Scheme files.
 */

var GUIScheme = function () {

  /**
   * @param {String}    url     Scheme URL
   */
  function GUIScheme(url) {
    _classCallCheck(this, GUIScheme);

    console.debug('GUIScheme::construct()', url);

    /**
     * The URL of the Scheme file
     * @type {String}
     */
    this.url = url;

    /**
     * The Scheme DOM Node
     * @type {DocumentFragment}
     */
    this.scheme = null;

    this.triggers = { render: [] };
  }

  /**
   * Destroys the instance
   */


  _createClass(GUIScheme, [{
    key: 'destroy',
    value: function destroy() {
      DOM.$empty(this.scheme);

      this.scheme = null;
      this.triggers = {};
    }

    /**
     * Register event
     *
     * @param   {String}      f       Event name
     * @param   {Function}    fn      Function/callback
     */

  }, {
    key: 'on',
    value: function on(f, fn) {
      this.triggers[f].push(fn);
    }

    /*
     * Trigger event
     */

  }, {
    key: '_trigger',
    value: function _trigger(f, args) {
      var _this = this;

      args = args || [];

      if (this.triggers[f]) {
        this.triggers[f].forEach(function (fn) {
          fn.apply(_this, args);
        });
      }
    }

    /*
     * Content loading wrapper
     */

  }, {
    key: '_load',
    value: function _load(html, src) {
      var doc = document.createDocumentFragment();
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      doc.appendChild(wrapper);

      this.scheme = doc.cloneNode(true);

      if ((0, _config.getConfig)('DebugScheme')) {
        console.group('Scheme::_load() validation', src);
        this.scheme.querySelectorAll('*').forEach(function (node) {
          var tagName = node.tagName.toLowerCase();
          var gelData = _element2.default.getRegisteredElement(tagName);
          if (gelData) {
            var ac = gelData.metadata.allowedChildren;
            if (ac instanceof Array && ac.length) {
              var childrenTagNames = node.children.map(function (sNode) {
                return sNode.tagName.toLowerCase();
              });

              childrenTagNames.forEach(function (chk, idx) {
                var found = ac.indexOf(chk);
                if (found === -1) {
                  console.warn(chk, node.children[idx], 'is not a valid child of type', tagName);
                }
              });
            }

            var ap = gelData.metadata.allowedParents;
            if (ap instanceof Array && ap.length) {
              var parentTagName = node.parentNode.tagName.toLowerCase();
              if (ap.indexOf(parentTagName) === -1) {
                console.warn(parentTagName, node.parentNode, 'is in an invalid parent of type', tagName);
              }
            }
          }
        });
        console.groupEnd();
      }

      wrapper = null;
      doc = null;
    }

    /**
     * Load Scheme from URL
     *
     * @param   {Function}    cb      callback => fn(error, DocumentFragment)
     * @param   {Function}    [cbxhr] callback on ajax => fn(error, html)
     */

  }, {
    key: 'load',
    value: function load(cb, cbxhr) {
      var _this2 = this;

      cbxhr = cbxhr || function () {};

      console.debug('GUIScheme::load()', this.url);

      var src = this.url;
      if (src.substr(0, 1) !== '/' && !src.match(/^(https?|ftp)/)) {
        src = (0, _config.getBrowserPath)(src);
      }

      //const root = FS.dirname(src);

      (0, _axios2.default)({
        url: src,
        method: 'GET'
      }).then(function (response) {
        var html = cleanScheme(response.data);
        /*
        resolveExternalFragments(root, html, (result) => {
        });
        */
        // This is normally used for the preloader for caching
        cbxhr(false, html);

        // Then we run some manipulations
        _this2._load(html, src);

        // And finally, finish
        cb(false, _this2.scheme);
      }).catch(function (err) {
        cb('Failed to fetch scheme: ' + err.message);
        cbxhr(true);
      });
    }

    /**
     * Get fragment from ID (and/or type)
     *
     * @param   {String}      id      ID
     * @param   {String}      [type]  Type (application-window | application-fragment)
     *
     * @return  {Node}
     */

  }, {
    key: 'getFragment',
    value: function getFragment(id, type) {
      var content = null;
      if (id) {
        if (type) {
          content = this.scheme.querySelector(type + '[data-id="' + id + '"]');
        } else {
          content = this.scheme.querySelector('application-window[data-id="' + id + '"]') || this.scheme.querySelector('application-dialog[data-id="' + id + '"]') || this.scheme.querySelector('application-fragment[data-id="' + id + '"]');
        }
      }
      return content;
    }

    /**
     * Parses the given fragment
     *
     * @param   {String}            id        Fragment ID
     * @param   {String}            [type]    Fragment Type
     * @param   {Window}            [win]     OS.js Window
     * @param   {Function}          [onparse] Callback on parsed
     * @param   {Object}            [args]    Parameters
     *
     * @return  {Node}
     */

  }, {
    key: 'parse',
    value: function parse(id, type, win, onparse, args) {
      var content = this.getFragment(id, type);

      console.debug('GUIScheme::parse()', id);

      if (!content) {
        console.error('GUIScheme::parse()', 'No fragment found', id + '@' + type);
        return null;
      }

      type = type || content.tagName.toLowerCase();
      args = args || {};

      if (content) {
        var node = content.cloneNode(true);

        // Resolve fragment includes before dynamic rendering
        if (args.resolve !== false) {
          resolveFragments(this, node);
        }

        _element2.default.parseNode(win, node, type, args, onparse, id);

        return node;
      }

      return null;
    }

    /**
     * Renders the given fragment into Window
     *
     * @param   {Window}    win       OS.js Window
     * @param   {String}    id        Fragment ID
     * @param   {Node}      [root]    Root HTML Node
     * @param   {String}    [type]    Fragment Type
     * @param   {Function}  [onparse] Callback on parsed
     * @param   {Object}    [args]    Parameters
     */

  }, {
    key: 'render',
    value: function render(win, id, root, type, onparse, args) {
      root = root || win._getRoot();
      if (root instanceof _element2.default) {
        root = root.$element;
      }

      function setWindowProperties(frag) {
        if (frag) {
          var width = parseInt(frag.getAttribute('data-width'), 10) || 0;
          var height = parseInt(frag.getAttribute('data-height'), 10) || 0;
          var allow_maximize = frag.getAttribute('data-allow_maximize');
          var allow_minimize = frag.getAttribute('data-allow_minimize');
          var allow_close = frag.getAttribute('data-allow_close');
          var allow_resize = frag.getAttribute('data-allow_resize');

          if (!isNaN(width) && width > 0 || !isNaN(height) && height > 0) {
            win._resize(width, height);
          }

          win._setProperty('allow_maximize', allow_maximize);
          win._setProperty('allow_minimize', allow_minimize);
          win._setProperty('allow_close', allow_close);
          win._setProperty('allow_resize', allow_resize);
        }
      }

      console.debug('GUIScheme::render()', id);

      var content = this.parse(id, type, win, onparse, args);
      addChildren(content, root);

      root.querySelectorAll('application-fragment').forEach(function (e) {
        DOM.$remove(e);
      });

      if (!win._restored) {
        setWindowProperties(this.getFragment(id));
      }

      this._trigger('render', [root]);
    }

    /**
     * Get HTML from Scheme
     *
     * @return  {String}
     */

  }, {
    key: 'getHTML',
    value: function getHTML() {
      return this.scheme.firstChild.innerHTML;
    }

    /**
     * Creates a new Scheme from a string
     * @param {String} str The string (HTML)
     * @return GUIScheme
     */

  }], [{
    key: 'fromString',
    value: function fromString(str) {
      var inst = new GUIScheme(null);
      var cleaned = cleanScheme(str);
      inst._load(cleaned, '<html>');
      return inst;
    }
  }]);

  return GUIScheme;
}();

exports.default = GUIScheme;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Application VFS Transport Module
 *
 * This is a purely virtual module that allows for listing of applications
 * via scandir etc.
 *
 * @extends Transport
 */
var ApplicationTransport = function (_Transport) {
  _inherits(ApplicationTransport, _Transport);

  function ApplicationTransport() {
    _classCallCheck(this, ApplicationTransport);

    return _possibleConstructorReturn(this, (ApplicationTransport.__proto__ || Object.getPrototypeOf(ApplicationTransport)).apply(this, arguments));
  }

  _createClass(ApplicationTransport, [{
    key: 'request',
    value: function request(method, args, options) {
      if (['scandir'].indexOf(method) === -1) {
        return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
      }

      return _get(ApplicationTransport.prototype.__proto__ || Object.getPrototypeOf(ApplicationTransport.prototype), 'request', this).apply(this, arguments);
    }
  }, {
    key: 'scandir',
    value: function scandir() {
      var metadata = _packageManager2.default.getPackages();
      var files = [];

      Object.keys(metadata).forEach(function (m) {
        var iter = metadata[m];
        if (iter.type !== 'extension') {
          files.push(new _file2.default({
            filename: iter.name,
            type: 'application',
            path: 'applications:///' + m,
            mime: 'osjs/application'
          }, 'osjs/application'));
        }
      });

      return _bluebird2.default.resolve(files);
    }
  }, {
    key: 'url',
    value: function url(item) {
      return _bluebird2.default.resolve(item.path);
    }
  }]);

  return ApplicationTransport;
}(_transport2.default);

exports.default = ApplicationTransport;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _osjs = __webpack_require__(182);

var _osjs2 = _interopRequireDefault(_osjs);

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _config = __webpack_require__(15);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Dist VFS Transport Module
 *
 * This is just an override of the default OS.js transport module
 *
 * @extends OSjsTransport
 */
var DistTransport = function (_OSjsTransport) {
  _inherits(DistTransport, _OSjsTransport);

  function DistTransport() {
    _classCallCheck(this, DistTransport);

    return _possibleConstructorReturn(this, (DistTransport.__proto__ || Object.getPrototypeOf(DistTransport)).apply(this, arguments));
  }

  _createClass(DistTransport, [{
    key: 'request',
    value: function request(method, args, options) {
      if (['url', 'scandir', 'read'].indexOf(method) === -1) {
        return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFS_UNAVAILABLE')));
      }

      return _get(DistTransport.prototype.__proto__ || Object.getPrototypeOf(DistTransport.prototype), 'request', this).apply(this, arguments);
    }
  }, {
    key: 'url',
    value: function url(item) {
      var root = (0, _config.getBrowserPath)();
      var module = _mountManager2.default.getModuleFromPath(item.path);
      var url = item.path.replace(module.option('match'), root).replace(/^\/+/, '/');

      return _bluebird2.default.resolve(url);
    }
  }]);

  return DistTransport;
}(_osjs2.default);

exports.default = DistTransport;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _preloader = __webpack_require__(120);

var _preloader2 = _interopRequireDefault(_preloader);

var _config = __webpack_require__(15);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _misc = __webpack_require__(52);

var _locales = __webpack_require__(10);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// https://github.com/dropbox/dropbox-sdk-js
// https://github.com/dropbox/dropbox-sdk-js/blob/master/examples/javascript/auth/index.html
// http://dropbox.github.io/dropbox-sdk-js/Dropbox.html

var AUTH_TIMEOUT = 1000 * 30;
var MAX_RESULTS = 100;

///////////////////////////////////////////////////////////////////////////////
// TRANSPORTER
///////////////////////////////////////////////////////////////////////////////

/**
 * Dropbox (v2) VFS Transport Module
 *
 * @extends Transport
 */

var DropboxTransport = function (_Transport) {
  _inherits(DropboxTransport, _Transport);

  function DropboxTransport() {
    _classCallCheck(this, DropboxTransport);

    var _this = _possibleConstructorReturn(this, (DropboxTransport.__proto__ || Object.getPrototypeOf(DropboxTransport)).apply(this, arguments));

    _this.loaded = false;
    _this.authed = false;
    _this.dbx = null;
    return _this;
  }

  _createClass(DropboxTransport, [{
    key: '_loadDependencies',
    value: function _loadDependencies() {
      var _this2 = this;

      if (this.loaded) {
        return _bluebird2.default.resolve(true);
      }

      return new _bluebird2.default(function (resolve, reject) {
        _preloader2.default.preload(['https://unpkg.com/dropbox/dist/Dropbox-sdk.min.js']).then(function () {
          if (window.Dropbox) {
            _this2.loaded = true;
            return resolve(true);
          }

          return reject(new Error((0, _locales._)('ERR_DROPBOX_API')));
        }).catch(function (err) {
          _this2.loaded = true;
          return reject(err);
        });
      });
    }
  }, {
    key: '_createClient',
    value: function _createClient(clientId) {
      var _this3 = this;

      if (this.authed) {
        return _bluebird2.default.resolve(true);
      }

      return new _bluebird2.default(function (resolve, reject) {
        var timedOut = void 0;
        var loginTimeout = void 0;

        _this3.dbx = new window.Dropbox({
          clientId: clientId
        });

        var redirectUrl = window.location.href.replace(/\/?$/, '/') + 'dropbox-oauth.html';
        var callbackName = '__osjs__dropbox_callback__';

        window[callbackName] = function (url) {
          clearTimeout(loginTimeout);
          if (timedOut) {
            return;
          }

          var params = (0, _misc.urlparams)(url, true);
          if (params.access_token) {
            _this3.authed = true;
            _this3.dbx = new window.Dropbox({
              accessToken: params.access_token
            });

            resolve(true);
          } else {
            reject(new Error((0, _locales._)('ERR_DROPBOX_AUTH')));
          }
        };

        var authUrl = _this3.dbx.getAuthenticationUrl(redirectUrl);

        loginTimeout = setTimeout(function () {
          timedOut = true;
          reject(new Error((0, _locales._)('ERR_DROPBOX_AUTH')));
        }, AUTH_TIMEOUT);

        window.open(authUrl);
      });
    }
  }, {
    key: '_init',
    value: function _init() {
      var _this4 = this;

      var clientId = (0, _config.getConfig)('DropboxAPI.ClientKey');
      if (!clientId) {
        return _bluebird2.default.reject(new Error((0, _locales._)('ERR_DROPBOX_KEY')));
      }

      return new _bluebird2.default(function (resolve, reject) {
        _this4._loadDependencies().then(function () {
          return _this4._createClient(clientId).then(resolve).catch(reject);
        }).catch(reject);
      });
    }
  }, {
    key: 'request',
    value: function request(method, args, options, mount) {
      var _this5 = this;

      var fargs = arguments;
      return new _bluebird2.default(function (resolve, reject) {
        _this5._init().then(function () {
          var _get2;

          return (_get2 = _get(DropboxTransport.prototype.__proto__ || Object.getPrototypeOf(DropboxTransport.prototype), 'request', _this5)).call.apply(_get2, [_this5].concat(_toConsumableArray(fargs))).then(resolve).catch(function (err) {
            if (typeof err !== 'string' && !(err instanceof Error)) {
              if (err.status && err.response && err.error) {
                return reject(new Error(err.error.error_summary));
              }
            }
            return reject(err);
          });
        }).catch(reject);
      });
    }
  }, {
    key: '_createMetadata',
    value: function _createMetadata(root, iter) {
      return {
        id: iter.id,
        filename: iter.name,
        path: FS.pathJoin(root, iter.path_display),
        type: iter['.tag'] === 'folder' ? 'dir' : 'file',
        size: iter.size || 0
      };
    }
  }, {
    key: 'find',
    value: function find(file, options, a, mount) {
      var _this6 = this;

      var root = FS.getPathFromVirtual(file.path);

      return new _bluebird2.default(function (resolve, reject) {
        _this6.dbx.filesSearch({
          path: root === '/' ? '' : root,
          query: options.query,
          max_results: MAX_RESULTS,
          mode: {
            '.tag': 'filename'
          }
        }).then(function (response) {
          return resolve(response.matches.map(function (iter) {
            return _this6._createMetadata(mount.option('root'), iter.metadata);
          }));
        }).catch(reject);
      });
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options, mount) {
      var _this7 = this;

      var root = FS.getPathFromVirtual(item.path);

      var result = [];

      var scandir = function scandir(cursor) {
        return new _bluebird2.default(function (resolve, reject) {
          var m = cursor ? 'filesListFolderContinue' : 'filesListFolder';
          var a = cursor ? { cursor: cursor } : { path: root === '/' ? '' : root };

          _this7.dbx[m](a).then(function (response) {
            var found = (response.entries || []).map(function (iter) {
              return _this7._createMetadata(mount.option('root'), iter);
            });

            result = result.concat(found);

            if (response.has_more && response.cursor) {
              return scandir(response.cursor).then(resolve).catch(reject);
            }

            return resolve(result);
          }).catch(reject);
        });
      };

      return scandir(null);
    }
  }, {
    key: 'read',
    value: function read(item, options, mount) {
      var _this8 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this8.url(item, { dl: 0 }).then(function (url) {
          _this8.dbx.sharingGetSharedLinkFile({
            url: url
          }).then(function (data) {
            return resolve(data.fileBlob);
          }).catch(reject);
        }).catch(reject);
      });
    }
  }, {
    key: 'write',
    value: function write(file, data) {
      var _this9 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this9.dbx.filesUpload({
          path: FS.getPathFromVirtual(file.path),
          mode: {
            '.tag': 'overwrite'
          },
          contents: data
        }).then(function () {
          return resolve(true);
        }).catch(reject);
      });
    }
  }, {
    key: 'copy',
    value: function copy(src, dest) {
      var _this10 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this10.dbx.filesCopy({
          from_path: FS.getPathFromVirtual(src.path),
          to_path: FS.getPathFromVirtual(dest.path)
        }).then(function () {
          return resolve(true);
        }).catch(reject);
      });
    }
  }, {
    key: 'move',
    value: function move(src, dest) {
      var _this11 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this11.dbx.filesMove({
          from_path: FS.getPathFromVirtual(src.path),
          to_path: FS.getPathFromVirtual(dest.path)
        }).then(function () {
          return resolve(true);
        }).catch(reject);
      });
    }
  }, {
    key: 'exists',
    value: function exists(item) {
      var _this12 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this12.fileinfo(item).then(function () {
          return resolve(true);
        }).catch(function () {
          return resolve(false);
        });
      });
    }
  }, {
    key: 'fileinfo',
    value: function fileinfo(item) {
      return this.dbx.filesGetMetadata({
        path: FS.getPathFromVirtual(item.path)
      });
    }
  }, {
    key: 'url',
    value: function url(item, options) {
      var _this13 = this;

      var visibility = 'public';

      var hasLink = function hasLink() {
        return new _bluebird2.default(function (resolve, reject) {
          _this13.dbx.sharingGetSharedLinks({
            path: FS.getPathFromVirtual(item.path)
          }).then(function (response) {
            if (response.links.length) {
              var found = response.links.find(function (iter) {
                return iter.visibility['.tag'] === visibility;
              });
              var dl = typeof options.dl === 'undefined' ? 1 : options.dl;
              if (found) {
                return resolve(found.url.replace('dl=0', 'dl=' + String(dl)));
              }
            }
            return resolve(false);
          }).catch(reject);
        });
      };

      var newLink = function newLink() {
        return new _bluebird2.default(function (resolve, reject) {
          _this13.dbx.sharingCreateSharedLinkWithSettings({
            path: FS.getPathFromVirtual(item.path),
            settings: {
              requested_visibility: visibility
            }
          }).then(function (response) {
            return resolve(response.url);
          }).catch(reject);
        });
      };

      return new _bluebird2.default(function (resolve, reject) {
        hasLink().then(function (url) {
          if (url) {
            console.warn('ALREADY HAS URL', url);
            return resolve(url);
          }

          console.warn('CREATING NEW URL');
          return newLink().then(resolve).catch(reject);
        }).catch(reject);
      });
    }
  }, {
    key: 'mkdir',
    value: function mkdir(dir) {
      var _this14 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this14.dbx.filesCreateFolder({
          path: FS.getPathFromVirtual(dir.path)
        }).then(function () {
          return resolve(true);
        }).catch(reject);
      });
    }
  }, {
    key: 'upload',
    value: function upload(dest, file) {
      var item = new _file2.default({
        filename: file.name,
        path: FS.pathJoin(dest.path, file.name),
        mime: file.type,
        size: file.size
      });

      return this.write(item, file);
    }
  }, {
    key: 'freeSpace',
    value: function freeSpace(root) {
      var _this15 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this15.dbx.usersGetSpaceUsage().then(function (response) {
          try {
            if (response.allocation && typeof response.allocation.individual !== 'undefined') {
              return resolve(response.allocation.individual.allocated);
            }
          } catch (e) {
            console.warn(e);
          }

          return resolve(-1);
        }).catch(reject);
      });
    }
  }, {
    key: 'unlink',
    value: function unlink(src) {
      var _this16 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this16.dbx.filesDelete({
          path: FS.getPathFromVirtual(src.path)
        }).then(function () {
          return resolve(true);
        }).catch(reject);
      });
    }
  }]);

  return DropboxTransport;
}(_transport2.default);

exports.default = DropboxTransport;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _filedataurl = __webpack_require__(188);

var _filedataurl2 = _interopRequireDefault(_filedataurl);

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _locales = __webpack_require__(10);

var _googleApi = __webpack_require__(412);

var GoogleAPI = _interopRequireWildcard(_googleApi);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var CACHE_CLEAR_TIMEOUT = 7000;

var gapi = window.gapi = window.gapi || {};
var _authenticated = void 0;
var _clearCacheTimeout = void 0;
var _rootFolderId = void 0;
var _treeCache = void 0;

/*
 * Generate FileView compatible array of scandir()
 */
function createDirectoryList(dir, list, item, options, match) {
  var result = [];
  var rdir = dir.replace(match, '/').replace(/\/+/g, '/');
  var isOnRoot = rdir === '/';

  function createItem(iter, i) {
    var path = dir;
    if (iter.title === '..') {
      path = FS.dirname(dir);
    } else {
      if (!isOnRoot) {
        path += '/';
      }
      path += iter.title;
    }
    var fileType = iter.mimeType === 'application/vnd.google-apps.folder' ? 'dir' : iter.kind === 'drive#file' ? 'file' : 'dir';
    if (iter.mimeType === 'application/vnd.google-apps.trash') {
      fileType = 'trash';
    }

    return new _file2.default({
      filename: iter.title,
      path: path,
      id: iter.id,
      size: iter.quotaBytesUsed || 0,
      mime: iter.mimeType === 'application/vnd.google-apps.folder' ? null : iter.mimeType,
      type: fileType
    });
  }

  if (list) {
    list.forEach(function (iter, i) {
      if (!iter) {
        return;
      }
      result.push(createItem(iter, i));
    });
  }
  return result ? result : [];
}

/*
 * Get all files in a directory
 */
function getAllDirectoryFiles(item, callback) {
  console.debug('GoogleDrive::*getAllDirectoryFiles()', item);

  function retrieveAllFiles(cb) {
    if (_clearCacheTimeout) {
      clearTimeout(_clearCacheTimeout);
      _clearCacheTimeout = null;
    }
    if (_treeCache) {
      console.info('USING CACHE FROM PREVIOUS FETCH!');
      cb(false, _treeCache);
      return;
    }
    console.info('UPDATING CACHE');

    var list = [];

    function retrievePageOfFiles(request, result) {
      request.execute(function (resp) {
        if (resp.error) {
          console.warn('GoogleDrive::getAllDirectoryFiles()', 'error', resp);
        }

        result = result.concat(resp.items);

        var nextPageToken = resp.nextPageToken;
        if (nextPageToken) {
          request = gapi.client.drive.files.list({
            pageToken: nextPageToken
          });
          retrievePageOfFiles(request, result);
        } else {
          _treeCache = result;

          cb(false, result);
        }
      });
    }

    try {
      var initialRequest = gapi.client.drive.files.list({});
      retrievePageOfFiles(initialRequest, list);
    } catch (e) {
      console.warn('GoogleDrive::getAllDirectoryFiles() exception', e, e.stack);
      console.warn('THIS ERROR OCCURS WHEN MULTIPLE REQUESTS FIRE AT ONCE ?!'); // FIXME
      cb(false, list);
    }
  }

  function getFilesBelongingTo(list, root, cb) {
    var idList = {};
    var parentList = {};
    list.forEach(function (iter) {
      if (iter) {
        idList[iter.id] = iter;
        var parents = [];
        if (iter.parents) {
          iter.parents.forEach(function (piter) {
            if (piter) {
              parents.push(piter.id);
            }
          });
        }
        parentList[iter.id] = parents;
      }
    });

    var resolves = FS.getPathFromVirtual(root).replace(/^\/+/, '').split('/');
    resolves = resolves.filter(function (el) {
      return el !== '';
    });

    var currentParentId = _rootFolderId;
    var isOnRoot = !resolves.length;

    function _getFileList(foundId) {
      var result = [];

      if (!isOnRoot) {
        result.push({
          title: '..',
          path: FS.dirname(root),
          id: item.id,
          quotaBytesUsed: 0,
          mimeType: 'application/vnd.google-apps.folder'
        });
      }

      list.forEach(function (iter) {
        if (iter && parentList[iter.id] && parentList[iter.id].indexOf(foundId) !== -1) {
          result.push(iter);
        }
      });
      return result;
    }

    function _nextDir(completed) {
      var current = resolves.shift();
      var done = resolves.length <= 0;
      var found = void 0;

      if (isOnRoot) {
        found = currentParentId;
      } else {
        if (current) {
          list.forEach(function (iter) {
            if (iter) {
              if (iter.title === current && parentList[iter.id] && parentList[iter.id].indexOf(currentParentId) !== -1) {
                currentParentId = iter.id;
                found = iter.id;
              }
            }
          });
        }
      }

      if (done) {
        completed(found);
      } else {
        _nextDir(completed);
      }
    }

    _nextDir(function (foundId) {
      if (foundId && idList[foundId]) {
        cb(false, _getFileList(foundId));
        return;
      } else {
        if (isOnRoot) {
          cb(false, _getFileList(currentParentId));
          return;
        }
      }

      cb('Could not list directory');
    });
  }

  function doRetrieve() {
    retrieveAllFiles(function (error, list) {
      var root = item.path;
      if (error) {
        callback(error, false, root);
        return;
      }

      getFilesBelongingTo(list, root, function (error, response) {
        console.groupEnd();

        _clearCacheTimeout = setTimeout(function () {
          console.info('Clearing GoogleDrive filetree cache!');
          _treeCache = null;
        }, CACHE_CLEAR_TIMEOUT);

        console.debug('GoogleDrive::*getAllDirectoryFiles()', '=>', response);
        callback(error, response, root);
      });
    });
  }

  console.group('GoogleDrive::*getAllDirectoryFiles()');

  if (!_rootFolderId) {
    var request = gapi.client.drive.about.get();
    request.execute(function (resp) {
      if (!resp || !resp.rootFolderId) {
        callback((0, _locales._)('ERR_VFSMODULE_ROOT_ID'));
        return;
      }
      _rootFolderId = resp.rootFolderId;

      doRetrieve();
    });
  } else {
    doRetrieve();
  }
}

/*
 * Scans entire file tree for given path
 */
function getFileFromPath(dir, type, callback) {
  if (dir instanceof _file2.default) {
    dir = dir.path;
  }

  var tmpItem = new _file2.default({
    filename: FS.filename(dir),
    type: 'dir',
    path: FS.dirname(dir)
  });

  console.debug('GoogleDrive::*getFileIdFromPath()', dir, type, tmpItem);

  getAllDirectoryFiles(tmpItem, function (error, list, ldir) {
    if (error) {
      callback(error);
      return;
    }

    var found = null;
    list.forEach(function (iter) {
      if (iter.title === FS.filename(dir)) {
        if (type) {
          if (iter.mimeType === type) {
            found = iter;
            return false;
          }
        } else {
          found = iter;
        }
      }
      return true;
    });

    callback(false, found);
  });
}

/*
 * Gets the parent path
 */
function getParentPathId(item, callback) {
  var dir = FS.dirname(item.path);
  var type = 'application/vnd.google-apps.folder';

  console.debug('GoogleDrive::*getParentPathId()', item);

  getFileFromPath(dir, type, function (error, item) {
    if (error) {
      callback(error);
    } else {
      callback(false, item ? item.id : null);
    }
  });
}

/*
 * Creates the boundary data for uploads
 */
function createBoundary(file, data, callback) {
  var boundary = '-------314159265358979323846';
  var delimiter = '\r\n--' + boundary + '\r\n';
  var close_delim = '\r\n--' + boundary + '--';
  var contentType = file.mime || 'text/plain'; //fileData.type || 'application/octet-stream';

  function createBody(result) {
    var metadata = {
      title: file.filename,
      mimeType: contentType
    };
    var base64Data = result;
    var multipartRequestBody = delimiter + 'Content-Type: application/json\r\n\r\n' + JSON.stringify(metadata) + delimiter + 'Content-Type: ' + contentType + '\r\n' + 'Content-Transfer-Encoding: base64\r\n' + '\r\n' + base64Data + close_delim;

    return multipartRequestBody;
  }

  var reqContentType = 'multipart/mixed; boundary=\'' + boundary + '\'';

  if (data instanceof _filedataurl2.default) {
    callback(false, {
      contentType: reqContentType,
      body: createBody(data.toBase64())
    });
  } else {
    FS.abToBinaryString(data, contentType, function (error, response) {
      callback(error, error ? false : {
        contentType: reqContentType,
        body: createBody(btoa(response))
      });
    });
  }
}

/*
 * Sets the folder for a file
 */
function setFolder(item, pid, callback) {
  console.info('GoogleDrive::setFolder()', item, pid);

  pid = pid || 'root';

  function _clearFolders(cb) {
    item.parents.forEach(function (p, i) {
      var request = gapi.client.drive.children.delete({
        folderId: p.id,
        childId: item.id
      });

      request.execute(function (resp) {
        if (i >= item.parents.length - 1) {
          cb();
        }
      });
    });
  }

  function _setFolder(rootId, cb) {
    var request = gapi.client.drive.children.insert({
      folderId: pid,
      resource: { id: item.id }
    });

    request.execute(function (resp) {
      console.info('GoogleDrive::setFolder()', '=>', resp);
      callback(false, true);
    });
  }

  _clearFolders(function () {
    _setFolder(pid, callback);
  });
}

///////////////////////////////////////////////////////////////////////////////
// TRANSPORTER
///////////////////////////////////////////////////////////////////////////////

/**
 * Google Drive VFS Transport Module
 *
 * @extends Transport
 */

var GoogleDriveTransport = function (_Transport) {
  _inherits(GoogleDriveTransport, _Transport);

  function GoogleDriveTransport() {
    _classCallCheck(this, GoogleDriveTransport);

    return _possibleConstructorReturn(this, (GoogleDriveTransport.__proto__ || Object.getPrototypeOf(GoogleDriveTransport)).apply(this, arguments));
  }

  _createClass(GoogleDriveTransport, [{
    key: '_init',
    value: function _init() {
      if (_authenticated) {
        return _bluebird2.default.resolve();
      }

      return new _bluebird2.default(function (resolve, reject) {
        GoogleAPI.create({
          scope: ['https://www.googleapis.com/auth/drive.install', 'https://www.googleapis.com/auth/drive.file', 'openid'],
          load: ['drive-realtime', 'drive-share']
        }, function (err, res) {
          gapi.client.load('drive', 'v2', function (err) {
            if (!err) {
              _authenticated = true;
            }

            return err ? reject(new Error(err)) : resolve(true);
          });
        });
      });
    }
  }, {
    key: 'request',
    value: function request(method, args, options, mount) {
      var _this2 = this;

      var fargs = arguments;
      return new _bluebird2.default(function (resolve, reject) {
        _this2._init().then(function () {
          var _get2;

          return (_get2 = _get(GoogleDriveTransport.prototype.__proto__ || Object.getPrototypeOf(GoogleDriveTransport.prototype), 'request', _this2)).call.apply(_get2, [_this2].concat(_toConsumableArray(fargs))).then(resolve).catch(reject);
        }).catch(reject);
      });
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options, mount) {
      return new _bluebird2.default(function (resolve, reject) {
        getAllDirectoryFiles(item, function (error, list, dir) {
          if (error) {
            reject(new Error(error));
          } else {
            var result = createDirectoryList(dir, list, item, options, mount.option('match'));
            resolve(result);
          }
        });
      });
    }
  }, {
    key: 'read',
    value: function read(item, options, mount) {
      var read = function read(ritem) {
        return new _bluebird2.default(function (resolve, reject) {

          var request = gapi.client.drive.files.get({
            fileId: ritem.id
          });

          request.execute(function (file) {

            if (file && file.id) {
              var accessToken = gapi.auth.getToken().access_token;

              (0, _axios2.default)({
                url: file.downloadUrl,
                method: 'GET',
                responseType: 'arraybuffer',
                headers: { 'Authorization': 'Bearer ' + accessToken }
              }).then(function (response) {
                return resolve(response.data);
              }).catch(function (error) {
                reject(new Error((0, _locales._)('ERR_VFSMODULE_XHR_ERROR') + ' - ' + error.message));
              });
            } else {
              reject(new Error((0, _locales._)('ERR_VFSMODULE_NOSUCH')));
            }
          });
        });
      };

      return new _bluebird2.default(function (resolve, reject) {
        if (item.downloadUrl) {
          read(item).then(resolve).catch(reject);
        } else {
          getFileFromPath(item.path, item.mime, function (error, response) {
            if (error) {
              reject(new Error(error));
            } else if (!response) {
              reject(new Error((0, _locales._)('ERR_VFSMODULE_NOSUCH')));
            } else {
              read(response).then(resolve).catch(reject);
            }
          });
        }
      });
    }
  }, {
    key: 'write',
    value: function write(file, data) {
      var _this3 = this;

      var write = function write(parentId, fileId) {
        return new _bluebird2.default(function (resolve, reject) {
          var uri = '/upload/drive/v2/files';
          var method = 'POST';
          if (fileId) {
            uri = '/upload/drive/v2/files/' + fileId;
            method = 'PUT';
          }

          createBoundary(file, data, function (error, fileData) {
            if (error) {
              reject(new Error(error));
            } else {
              var request = gapi.client.request({
                path: uri,
                method: method,
                params: { uploadType: 'multipart' },
                headers: { 'Content-Type': fileData.contentType },
                body: fileData.body
              });

              request.execute(function (resp) {
                _treeCache = null; // Make sure we refetch any cached stuff

                if (resp && resp.id) {
                  if (parentId) {
                    setFolder(resp, parentId, function (err, res) {
                      return err ? reject(new Error(err)) : resolve(res);
                    });
                  } else {
                    resolve(true);
                  }
                } else {
                  reject((0, _locales._)('ERR_VFSMODULE_NOSUCH'));
                }
              });
            }
          });
        });
      };

      return new _bluebird2.default(function (resolve, reject) {
        getParentPathId(file, function (error, id) {
          if (error) {
            reject(new Error(error));
          } else if (file.id) {
            write(id, file.id).then(resolve).catch(reject);
          } else {
            _this3.exists(file).then(function (exists) {
              return write(id, exists ? exists.id : null).then(resolve).catch(reject);
            }).catch(function () {
              write(id, null).then(resolve).catch(reject);
            });
          }
        });
      });
    }
  }, {
    key: 'copy',
    value: function copy(src, dest) {
      return new _bluebird2.default(function (resolve, reject) {
        var request = gapi.client.drive.files.copy({
          fileId: src.id, //FS.filename(src.path),
          resource: { title: FS.filename(dest.path) }
        });

        request.execute(function (resp) {
          if (resp.id) {
            getParentPathId(dest, function (error, parentId) {
              if (error) {
                console.warn(error);
                resolve(true);
              } else {
                _treeCache = null; // Make sure we refetch any cached stuff

                setFolder(resp, parentId, function (err, res) {
                  return err ? reject(new Error(err)) : resolve(res);
                });
              }
            });
          } else {
            var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
            reject(new Error(msg));
          }
        });
      });
    }
  }, {
    key: 'move',
    value: function move(src, dest) {
      return new _bluebird2.default(function (resolve, reject) {
        var request = gapi.client.drive.files.patch({
          fileId: src.id,
          resource: {
            title: FS.filename(dest.path)
          }
        });

        request.execute(function (resp) {
          if (resp && resp.id) {
            _treeCache = null; // Make sure we refetch any cached stuff

            resolve(true);
          } else {
            var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
            reject(new Error(msg));
          }
        });
      });
    }
  }, {
    key: 'exists',
    value: function exists(item) {
      var _this4 = this;

      // FIXME Is there a better way to do this ?
      return new _bluebird2.default(function (resolve, reject) {
        var req = new _file2.default(FS.dirname(item.path));
        _this4.scandir(req).then(function (result) {
          var found = result.find(function (iter) {
            return iter.path === item.path;
          });
          if (found) {
            var file = new _file2.default(item.path, found.mimeType);
            file.id = found.id;
            file.title = found.title;
            return resolve(file);
          }

          return resolve(false);
        }).catch(reject);
      });
    }
  }, {
    key: 'fileinfo',
    value: function fileinfo(item) {
      return new _bluebird2.default(function (resolve, reject) {
        var request = gapi.client.drive.files.get({
          fileId: item.id
        });

        request.execute(function (resp) {
          if (resp && resp.id) {
            var useKeys = ['createdDate', 'id', 'lastModifyingUser', 'lastViewedByMeDate', 'markedViewedByMeDate', 'mimeType', 'modifiedByMeDate', 'modifiedDate', 'title', 'alternateLink'];
            var info = {};
            useKeys.forEach(function (k) {
              info[k] = resp[k];
            });

            resolve(info);
          } else {
            reject((0, _locales._)('ERR_VFSMODULE_NOSUCH'));
          }
        });
      });
    }
  }, {
    key: 'url',
    value: function url(item) {
      return new _bluebird2.default(function (resolve, reject) {
        if (!item || !item.id) {
          reject(new Error('url() expects a File ref with Id'));
        } else {
          var request = gapi.client.drive.files.get({
            fileId: item.id
          });

          request.execute(function (resp) {
            if (resp && resp.webContentLink) {
              resolve(resp.webContentLink);
            } else {
              var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
              reject(new Error(msg));
            }
          });
        }
      });
    }
  }, {
    key: 'mkdir',
    value: function mkdir(dir) {
      var mkdir = function mkdir(parents) {
        return new _bluebird2.default(function (resolve, reject) {
          var request = gapi.client.request({
            'path': '/drive/v2/files',
            'method': 'POST',
            'body': JSON.stringify({
              title: dir.filename,
              parents: parents,
              mimeType: 'application/vnd.google-apps.folder'
            })
          });

          request.execute(function (resp) {
            if (resp && resp.id) {
              _treeCache = null; // Make sure we refetch any cached stuff
              resolve(true);
            } else {
              var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
              reject(new Error(msg));
            }
          });
        });
      };

      return new _bluebird2.default(function (resolve, reject) {
        var module = _mountManager2.default.getModuleFromPath(dir.path);
        var dirDest = FS.getPathFromVirtual(FS.dirname(dir.path));
        var rootDest = FS.getPathFromVirtual(module.option('root'));

        if (dirDest !== rootDest) {
          getParentPathId(dir, function (error, id) {
            if (error || !id) {
              reject(new Error((0, _locales._)('ERR_VFSMODULE_PARENT_FMT', error || (0, _locales._)('ERR_VFSMODULE_PARENT'))));
            } else {
              mkdir([{ id: id }]).then(resolve).catch(reject);
            }
          });
        } else {
          mkdir(null).then(resolve).catch(reject);
        }
      });
    }
  }, {
    key: 'upload',
    value: function upload(dest, file) {
      var item = new _file2.default({
        filename: file.name,
        path: FS.pathJoin(dest.path, file.name),
        mime: file.type,
        size: file.size
      });

      return this.write(item, file);
    }
  }, {
    key: 'trash',
    value: function trash(file) {
      return new _bluebird2.default(function (resolve, reject) {
        var request = gapi.client.drive.files.trash({
          fileId: file.id
        });

        request.execute(function (resp) {
          if (resp.id) {
            resolve(true);
          } else {
            var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
            reject(new Error(msg));
          }
        });
      });
    }
  }, {
    key: 'untrash',
    value: function untrash(file) {
      return new _bluebird2.default(function (resolve, reject) {
        var request = gapi.client.drive.files.untrash({
          fileId: file.id
        });

        request.execute(function (resp) {
          if (resp.id) {
            resolve(true);
          } else {
            var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
            reject(new Error(msg));
          }
        });
      });
    }
  }, {
    key: 'emptyTrash',
    value: function emptyTrash() {
      return new _bluebird2.default(function (resolve, reject) {
        var request = gapi.client.drive.files.emptyTrash({});
        request.execute(function (resp) {
          if (resp && resp.message) {
            var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
            reject(new Error(msg));
          } else {
            resolve(true);
          }
        });
      });
    }
  }, {
    key: 'freeSpace',
    value: function freeSpace(root) {
      return _bluebird2.default.resolve(-1);
    }
  }, {
    key: 'unlink',
    value: function unlink(src) {
      var unlink = function unlink(s) {
        _treeCache = null; // Make sure we refetch any cached stuff

        return new _bluebird2.default(function (resolve, reject) {
          var request = gapi.client.drive.files.delete({
            fileId: s.id
          });

          request.execute(function (resp) {
            if (resp && _typeof(resp.result) === 'object') {
              resolve(true);
            } else {
              var msg = resp && resp.message ? resp.message : (0, _locales._)('ERR_APP_UNKNOWN_ERROR');
              reject(new Error(msg));
            }
          });
        });
      };

      if (!src.id) {
        return new _bluebird2.default(function (resolve, reject) {
          getFileFromPath(src.path, src.mime, function (error, response) {
            if (error) {
              reject(new Error(error));
            } else if (!response) {
              reject(new Error((0, _locales._)('ERR_VFSMODULE_NOSUCH')));
            } else {
              unlink(response).then(resolve).catch(reject);
            }
          });
        });
      }

      return unlink(src);
    }
  }]);

  return GoogleDriveTransport;
}(_transport2.default);

exports.default = GoogleDriveTransport;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _notification = __webpack_require__(189);

var _notification2 = _interopRequireDefault(_notification);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _menu = __webpack_require__(90);

var Menu = _interopRequireWildcard(_menu);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Service Notification Icon Class
 */
var ServiceNotificationIcon = function () {
  function ServiceNotificationIcon() {
    _classCallCheck(this, ServiceNotificationIcon);

    this.entries = {};
    this.size = 0;
    this.notif = null;
  }

  _createClass(ServiceNotificationIcon, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var show = function show(ev) {
        _this.displayMenu(ev);
        return false;
      };

      this.notif = _notification2.default.createIcon('ServiceNotificationIcon', {
        image: _theme2.default.getIcon('status/dialog-password.png'),
        onContextMenu: show,
        onClick: show,
        onInited: function onInited(el, img) {
          _this._updateIcon();
        }
      });

      this._updateIcon();
    }

    /*
     * Destroys the notification icon
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _notification2.default.destroyIcon('ServiceNotificationIcon');

      this.size = 0;
      this.entries = {};
      this.notif = null;
    }
  }, {
    key: '_updateIcon',
    value: function _updateIcon() {
      if (this.notif) {
        if (this.notif.$container) {
          this.notif.$container.style.display = this.size ? 'inline-block' : 'none';
        }
        this.notif.setTitle((0, _locales._)('SERVICENOTIFICATION_TOOLTIP', this.size.toString()));
      }
    }
  }, {
    key: 'displayMenu',
    value: function displayMenu(ev) {
      var menu = [];
      var entries = this.entries;

      Object.keys(entries).forEach(function (name) {
        menu.push({
          title: name,
          menu: entries[name]
        });
      });

      Menu.create(menu, ev);
    }

    /*
     * Adds an entry
     */

  }, {
    key: 'add',
    value: function add(name, menu) {
      if (!this.entries[name]) {
        this.entries[name] = menu;

        this.size++;
        this._updateIcon();
      }
    }

    /*
     * Removes an entry
     */

  }, {
    key: 'remove',
    value: function remove(name) {
      if (this.entries[name]) {
        delete this.entries[name];
        this.size--;
        this._updateIcon();
      }
    }
  }]);

  return ServiceNotificationIcon;
}();

exports.default = new ServiceNotificationIcon();

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _config = __webpack_require__(15);

var _locales = __webpack_require__(10);

var _windowsLiveApi = __webpack_require__(416);

var WindowsLiveAPI = _interopRequireWildcard(_windowsLiveApi);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _fs2 = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var _isMounted = false;
var _mimeCache = void 0;

/*
 * Perform a REST call to WL API
 */
function onedriveCall(args, callback) {
  console.debug('OneDrive::*onedriveCall()', args);

  var WL = window.WL || {};
  WL.api(args).then(function (response) {
    callback(false, response);
  }, function (responseFailed) {
    console.error('OneDrive::*onedriveCall()', 'error', responseFailed, args);
    callback(responseFailed.error.message);
  });
}

/*
 * Gets OS.js VFS File Metadata type from OneDrive item
 */
function getItemType(iter) {
  var type = 'file';
  if (iter.type === 'folder' || iter.type === 'album') {
    type = 'dir';
  }
  return type;
}

/*
 * Get MIME type from file extension of a file
 * Yeah... it's pretty rough, but OneDrive does
 * not support mimes yet
 */
function getItemMime(iter) {
  if (!_mimeCache) {
    _mimeCache = (0, _config.getConfig)('MIME.mapping', {});
  }
  var mime = null;
  if (getItemType(iter) !== 'dir') {
    mime = 'application/octet-stream';
    var ext = FS.filext(iter.name);
    if (ext.length) {
      ext = '.' + ext;
      if (_mimeCache[ext]) {
        mime = _mimeCache[ext];
      }
    }
  }
  return mime;
}

/*
 * Get OS.js VFS File Metadata from OneDrive item
 */
function getMetadataFromItem(dir, item, root) {
  var par = dir.replace(/^\/+/, '').replace(/\/+$/, '');
  var path = root + (par ? par + '/' : par) + item.name;

  var itemFile = new _file2.default({
    id: item.id,
    filename: item.name,
    size: item.size || 0,
    path: path,
    mime: getItemMime(item),
    type: getItemType(item)
  });
  return itemFile;
}

/*
 * Create an Array filled with OS.js VFS file metadata
 */
function createDirectoryList(dir, list, item, options, root) {
  var result = [];

  if (dir !== '/') {
    result.push(new _file2.default({
      id: item.id,
      filename: '..',
      path: FS.dirname(item.path),
      size: 0,
      type: 'dir'
    }));
  }

  list.forEach(function (iter) {
    result.push(getMetadataFromItem(dir, iter, root));
  });

  return result;
}

/*
 * Get files inside given folder
 */
function getFilesInFolder(folderId, callback) {
  onedriveCall({
    path: folderId + '/files',
    method: 'GET'
  }, function (error, response) {
    if (error) {
      callback(error);
      return;
    }

    console.debug('OneDrive::*getFilesInFolder()', '=>', response);
    callback(false, response.data || []);
  });
}

/*
 * Check if file is existent inside given folder
function isFileInFolder(folderId, file, callback, returnIter) {
  getFilesInFolder(folderId, (error, list) => {
    if ( error ) {
      callback(error);
      return;
    }

    var found;
    list.forEach((iter) => {
      if ( iter.name === file.filename ) {
        found = iter;
        return false;
      }
      return true;
    });

    if ( found ) {
      if ( returnIter ) {
        callback(false, found);
        return;
      }

      var dir = FS.getPathProtocol(FS.dirname(found.path));
      var foundFile = getMetadataFromItem(dir, found);
      callback(false, foundFile);
    } else {
      callback('Could not find requested file');
    }
  });
}
*/

/*
 * Resolve normal /path/to/file to OneDrive ID
 */
function resolvePath(item, callback, useParent) {
  if (!useParent) {
    if (item.id) {
      callback(false, item.id);
      return;
    }
  }

  var path = FS.getPathFromVirtual(item.path).replace(/\/+/, '/');
  if (useParent) {
    path = FS.dirname(path);
  }
  if (path === '/') {
    callback(false, 'me/skydrive');
    return;
  }

  var resolves = path.replace(/^\/+/, '').split('/');
  var isOnRoot = !resolves.length;

  var currentParentId = 'me/skydrive';

  function _nextDir(completed) {
    var current = resolves.shift();
    var done = resolves.length <= 0;
    var found = void 0;

    if (isOnRoot) {
      found = currentParentId;
    } else {

      if (current) {
        getFilesInFolder(currentParentId, function (error, list) {
          list = list || [];

          var lfound = void 0;

          if (!error) {
            list.forEach(function (iter) {
              // FIXME: Not very precise
              if (iter) {
                if (iter.name === current) {
                  lfound = iter.id;
                }
              }
            });

            if (lfound) {
              currentParentId = lfound;
            }
          } else {
            console.warn('OneDrive', 'resolvePath()', 'getFilesInFolder() error', error);
          }

          if (done) {
            completed(lfound);
          } else {
            _nextDir(completed);
          }
        });

        return;
      }
    }

    if (done) {
      completed(found);
    } else {
      _nextDir(completed);
    }
  }

  _nextDir(function (foundId) {
    if (foundId) {
      callback(false, foundId);
    } else {
      callback((0, _locales._)('ONEDRIVE_ERR_RESOLVE'));
    }
  });
}

///////////////////////////////////////////////////////////////////////////////
// TRANSPORTER
///////////////////////////////////////////////////////////////////////////////

/**
 * Microsoft OneDrive VFS Transport Module
 *
 * @extends Transport
 */

var OneDriveTransport = function (_Transport) {
  _inherits(OneDriveTransport, _Transport);

  function OneDriveTransport() {
    _classCallCheck(this, OneDriveTransport);

    return _possibleConstructorReturn(this, (OneDriveTransport.__proto__ || Object.getPrototypeOf(OneDriveTransport)).apply(this, arguments));
  }

  _createClass(OneDriveTransport, [{
    key: '_init',
    value: function _init() {
      return new _bluebird2.default(function (resolve, reject) {
        var iargs = { scope: ['wl.signin', 'wl.skydrive', 'wl.skydrive_update'] };
        if (_isMounted) {
          resolve(true);
        } else {
          WindowsLiveAPI.create(iargs, function (error) {
            if (error) {
              reject(new Error(error));
            } else {
              _isMounted = true;
              resolve(true);
            }
          });
        }
      });
    }
  }, {
    key: 'request',
    value: function request(method, args, options, mount) {
      var _this2 = this;

      var fargs = arguments;
      return new _bluebird2.default(function (resolve, reject) {
        _this2._init().then(function () {
          var _get2;

          return (_get2 = _get(OneDriveTransport.prototype.__proto__ || Object.getPrototypeOf(OneDriveTransport.prototype), 'request', _this2)).call.apply(_get2, [_this2].concat(_toConsumableArray(fargs))).then(resolve).catch(reject);
        }).catch(reject);
      });
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options, mount) {
      return new _bluebird2.default(function (resolve, reject) {
        var relativePath = FS.getPathFromVirtual(item.path);

        resolvePath(item, function (error, drivePath) {
          if (error) {
            reject(new Error(error));
          } else {
            onedriveCall({
              path: drivePath,
              method: 'GET'
            }, function (error, response) {
              if (error) {
                reject(new Error(error));
              } else {
                getFilesInFolder(response.id, function (error, list) {
                  if (error) {
                    reject(new Error(error));
                  } else {
                    var fileList = createDirectoryList(relativePath, list, item, options, mount.option('root'));
                    resolve(fileList);
                  }
                });
              }
            });
          }
        });
      });
    }
  }, {
    key: 'read',
    value: function read(item, options, mount) {
      var _this3 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this3.url(item).then(function (url) {
          var file = new _file2.default(url, item.mime);
          VFS.read(file, options).then(resolve).catch(reject);
        }).catch(reject);
      });
    }
  }, {
    key: 'write',
    value: function write(file, data) {
      return new _bluebird2.default(function (resolve, reject) {
        var inst = WindowsLiveAPI.instance();
        var url = 'https://apis.live.net/v5.0/me/skydrive/files?access_token=' + inst.accessToken;
        var fd = new FormData();
        FS.addFormFile(fd, 'file', data, file);

        (0, _axios2.default)({
          url: url,
          method: 'POST',
          responseType: 'json',
          data: fd
        }).then(function (response) {
          var result = response.data;
          if (result && result.id) {
            return resolve(result.id);
          }
          return reject(new Error((0, _locales._)('ERR_APP_UNKNOWN_ERROR')));
        }).catch(reject);
      });
    }
  }, {
    key: 'copy',
    value: function copy(src, dest) {
      return new _bluebird2.default(function (resolve, reject) {
        dest = new _file2.default(FS.dirname(dest.path));

        resolvePath(src, function (error, srcDrivePath) {
          if (error) {
            reject(new Error(error));
          } else {
            resolvePath(dest, function (error, dstDrivePath) {
              if (error) {
                reject(new Error(error));
              } else {
                onedriveCall({
                  path: srcDrivePath,
                  method: 'COPY',
                  body: {
                    destination: dstDrivePath
                  }
                }, function (error, response) {
                  return error ? reject(new Error(error)) : resolve(true);
                });
              }
            });
          }
        });
      });
    }
  }, {
    key: 'move',
    value: function move(src, dest) {
      return new _bluebird2.default(function (resolve, reject) {
        dest = new _file2.default(FS.dirname(dest.path));

        resolvePath(src, function (error, srcDrivePath) {
          if (error) {
            reject(new Error(error));
          } else {
            resolvePath(dest, function (error, dstDrivePath) {
              if (error) {
                reject(new Error(error));
              } else {
                onedriveCall({
                  path: srcDrivePath,
                  method: 'MOVE',
                  body: {
                    destination: dstDrivePath
                  }
                }, function (error, response) {
                  return error ? reject(new Error(error)) : resolve(true);
                });
              }
            });
          }
        });
      });
    }
  }, {
    key: 'exists',
    value: function exists(item) {
      var _this4 = this;

      return new _bluebird2.default(function (resolve, reject) {
        // FIXME Is there a better way to do this ?
        _this4.fileinfo(item).then(function () {
          return resolve(true);
        }).catch(function () {
          return resolve(false);
        });
      });
    }
  }, {
    key: 'fileinfo',
    value: function fileinfo(item) {
      return new _bluebird2.default(function (resolve, reject) {
        resolvePath(item, function (error, drivePath) {
          if (error) {
            reject(new Error(error));
          } else {
            onedriveCall({
              path: drivePath,
              method: 'GET'
            }, function (error, response) {
              if (error) {
                reject(new Error(error));
              } else {
                var useKeys = ['created_time', 'id', 'link', 'name', 'type', 'updated_time', 'upload_location', 'description', 'client_updated_time'];
                var info = {};
                useKeys.forEach(function (k) {
                  info[k] = response[k];
                });
                resolve(info);
              }
            });
          }
        });
      });
    }
  }, {
    key: 'url',
    value: function url(item) {
      return new _bluebird2.default(function (resolve, reject) {
        resolvePath(item, function (error, drivePath) {
          if (error) {
            reject(new Error(error));
          } else {
            onedriveCall({
              path: drivePath + '/content',
              method: 'GET'
            }, function (error, response) {
              if (error) {
                reject(new Error(error));
              } else {
                resolve(response.location);
              }
            });
          }
        });
      });
    }
  }, {
    key: 'mkdir',
    value: function mkdir(dir) {
      return new _bluebird2.default(function (resolve, reject) {
        resolvePath(dir, function (error, drivePath) {
          if (error) {
            reject(error);
          } else {
            onedriveCall({
              path: drivePath,
              method: 'POST',
              body: {
                name: dir.filename
              }
            }, function (error, response) {
              return error ? reject(new Error(error)) : resolve(true);
            });
          }
        }, true);
      });
    }
  }, {
    key: 'upload',
    value: function upload(dest, file) {
      var item = new _file2.default({
        filename: file.name,
        path: FS.pathJoin(dest.path, file.name),
        mime: file.type,
        size: file.size
      });

      return this.write(item, file);
    }
  }, {
    key: 'freeSpace',
    value: function freeSpace(root) {
      return _bluebird2.default.resolve(-1);
    }
  }, {
    key: 'unlink',
    value: function unlink(src) {
      return new _bluebird2.default(function (resolve, reject) {
        resolvePath(src, function (error, drivePath) {
          if (error) {
            reject(new Error(error));
          } else {
            onedriveCall({
              path: drivePath,
              method: 'DELETE'
            }, function (error, response) {
              return error ? reject(new Error(error)) : resolve(true);
            });
          }
        });
      });
    }
  }]);

  return OneDriveTransport;
}(_transport2.default);

exports.default = OneDriveTransport;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Web VFS Transport Module
 *
 * This module makes it possible to use normal URLs in VFS operations
 *
 * @extends Transport
 */
var WebTransport = function (_Transport) {
  _inherits(WebTransport, _Transport);

  function WebTransport() {
    _classCallCheck(this, WebTransport);

    return _possibleConstructorReturn(this, (WebTransport.__proto__ || Object.getPrototypeOf(WebTransport)).apply(this, arguments));
  }

  _createClass(WebTransport, [{
    key: '_request',
    value: function _request(url, responseType, method, options) {
      return new _bluebird2.default(function (resolve, reject) {
        if (!options.cors) {
          var binary = options.type === 'text' ? false : responseType === 'arraybuffer';

          _connection2.default.request('curl', {
            url: url,
            method: method,
            binary: binary
          }).then(function (result) {
            if (binary) {
              return FS.dataSourceToAb(result.body, 'application/octet-stream', function (err, ab) {
                return err ? reject(err) : resolve(ab);
              });
            }
            return resolve(result.body);
          }).catch(reject);
        } else {
          (0, _axios2.default)({
            responseType: responseType,
            url: url,
            method: method
          }).then(function (response) {
            return resolve(responseType === null ? response.statusText : response.data);
          }).catch(function (e) {
            return reject(new Error(e.message || e));
          });
        }
      });
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options, mount) {
      var _this2 = this;

      return new _bluebird2.default(function (resolve, reject) {
        var root = mount.option('root');
        var url = item.path.replace(/\/?$/, '/_scandir.json');

        _this2._request(url, 'json', 'GET', options).then(function (response) {
          return resolve(response.map(function (iter) {
            iter.path = root + iter.path.replace(/^\//, '');
            return iter;
          }));
        }).catch(reject);
      });
    }
  }, {
    key: 'read',
    value: function read(item, options) {
      var _this3 = this;

      var mime = item.mime || 'application/octet-stream';

      return new _bluebird2.default(function (resolve, reject) {
        _this3._request(item.path, 'arraybuffer', 'GET', options).then(function (response) {
          if (options.cors) {
            if (options.type === 'text') {
              resolve(response);
            } else {
              FS.dataSourceToAb(response, 'application/octet-stream', function (err, ab) {
                return err ? reject(err) : resolve(ab);
              });
            }

            return true;
          }

          if (options.type === 'text') {
            FS.abToText(response, mime, function (err, txt) {
              if (err) {
                reject(new Error(err));
              } else {
                resolve(txt);
              }
            });

            return true;
          }

          return resolve(response);
        }).catch(reject);
      });
    }
  }, {
    key: 'exists',
    value: function exists(item) {
      var _this4 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this4._request(item.path, null, 'HEAD').then(function (response) {
          return resolve(response.toUpperCase() === 'OK');
        }).catch(reject);
      });
    }
  }, {
    key: 'url',
    value: function url(item) {
      return _bluebird2.default.resolve(item.path);
    }
  }]);

  return WebTransport;
}(_transport2.default);

exports.default = WebTransport;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(87);

var _axios2 = _interopRequireDefault(_axios);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _transport = __webpack_require__(86);

var _transport2 = _interopRequireDefault(_transport);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _config = __webpack_require__(15);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


function getTargetPath(item, mount) {
  return item.path.replace(mount.option('match'), '');
}

function getTargetUrl(mount, file, moduleOptions) {
  var baseUrl = moduleOptions.host;
  if (!moduleOptions.cors) {
    baseUrl = Utils.parseurl(moduleOptions.host, { username: moduleOptions.username, password: moduleOptions.password }).url;
  }

  var basename = getTargetPath(file, mount);
  return baseUrl.replace(/\/?$/, basename.replace(/^\/?/, '/'));
}

function getFilePath(c, ns, mount) {
  var moduleOptions = mount.option('options') || {};
  var uri = Utils.parseurl(moduleOptions.host).path;

  try {
    var path = c.getElementsByTagNameNS(ns, 'href')[0].textContent;
    return path.substr(uri.length - 1, path.length);
  } catch (e) {
    console.warn(e);
  }
  return '/';
}

function getFileMime(type, c, ns) {
  if (type === 'file') {
    try {
      return c.getElementsByTagNameNS(ns, 'getcontenttype')[0].textContent || 'application/octet-stream';
    } catch (e) {
      return 'application/octet-stream';
    }
  }
  return null;
}

function getFileId(type, c, ns) {
  try {
    return c.getElementsByTagNameNS(ns, 'getetag')[0].textContent;
  } catch (e) {}
  return null;
}

function getFileSize(type, c, ns) {
  if (type === 'file') {
    try {
      return parseInt(c.getElementsByTagNameNS(ns, 'getcontentlength')[0].textContent, 10) || 0;
    } catch (e) {}
  }
  return 0;
}

function parseListing(doc, item, mount) {
  var root = mount.option('root');
  var moduleOptions = mount.option('options') || {};
  var reqpath = getTargetPath(item, mount);

  var ns = moduleOptions.ns || 'DAV';
  if (ns.substr(-1) !== ':') {
    ns += ':';
  }

  return (doc.children || []).map(function (c) {
    var path = getFilePath(c, ns, mount);
    var type = 'file';
    if (path.match(/\/$/)) {
      type = 'dir';
      path = path.replace(/\/$/, '') || '/';
    }

    if (path === reqpath) {
      return false;
    }

    return new _file2.default({
      id: getFileId(type, c, ns),
      path: root + path.replace(/^\//, ''),
      filename: FS.filename(path),
      size: getFileSize(type, c, ns),
      mime: getFileMime(type, c, ns),
      type: type
    });
  }).filter(function (iter) {
    return iter !== false;
  });
}

function parseResponse(body) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(body, 'application/xml');
  return doc.firstChild;
}

/**
 * WebDAV VFS Transport Module
 *
 * Allows for file operations to WebDAV sources, like
 * OwnCloud.
 *
 * @extends Transport
 */

var WebDAVTransport = function (_Transport) {
  _inherits(WebDAVTransport, _Transport);

  function WebDAVTransport() {
    _classCallCheck(this, WebDAVTransport);

    return _possibleConstructorReturn(this, (WebDAVTransport.__proto__ || Object.getPrototypeOf(WebDAVTransport)).apply(this, arguments));
  }

  _createClass(WebDAVTransport, [{
    key: '_request',
    value: function _request(method, args, options, mount, raw) {
      var mime = args.mime || 'application/octet-stream';
      var file = new _file2.default(args, mime);
      var moduleOptions = mount.option('options') || {};
      var headers = {};

      var url = getTargetUrl(mount, file, moduleOptions);
      if (args.dest) {
        var dest = new _file2.default(args.dest, mime);
        headers.Destination = getTargetUrl(mount, dest, moduleOptions);
      }

      if (mime) {
        headers['Content-Type'] = mime;
      }

      return new _bluebird2.default(function (resolve, reject) {
        if (moduleOptions.cors) {
          var aopts = {
            url: url,
            responseType: raw === true ? 'arraybuffer' : 'text',
            method: method,
            headers: headers,
            data: args.data,
            auth: {
              username: moduleOptions.username,
              password: moduleOptions.password
            }
          };

          (0, _axios2.default)(aopts).then(function (response) {
            return resolve(response.data);
          }).catch(function (e) {
            return reject(new Error(e.message || e));
          });
        } else {
          var copts = {
            url: url,
            method: method,
            binary: raw === true,
            mime: mime,
            headers: headers
          };

          _connection2.default.request('curl', copts).then(function (response) {
            var code = response.httpCode;

            if (!response) {
              return reject(new Error((0, _locales._)('ERR_VFS_REMOTEREAD_EMPTY')));
            } else if ([200, 201, 203, 204, 205, 207].indexOf(code) < 0) {
              var error = new Error((0, _locales._)('ERR_VFSMODULE_XHR_ERROR') + ': ' + code);
              error.httpCode = code;
              return reject(error);
            }

            if (raw === true) {
              return FS.dataSourceToAb(response.body, mime, function (err, ab) {
                return err ? reject(new Error(err)) : resolve(ab);
              });
            }

            return resolve(parseResponse(response.body));
          }).catch(reject);
        }
      });
    }
  }, {
    key: 'scandir',
    value: function scandir(item, options, mount) {
      var _this2 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this2._request('PROPFIND', { path: item.path }, options, mount).then(function (doc) {
          resolve(doc ? parseListing(doc, item, mount).map(function (iter) {
            return new _file2.default(iter);
          }) : []);
        }).catch(reject);
      });
    }
  }, {
    key: 'read',
    value: function read(item, options, mount) {
      return this._request('GET', { path: item.path, mime: item.mime }, options, mount, true);
    }
  }, {
    key: 'write',
    value: function write(item, data, options, mount) {
      return this._request('PUT', { path: item.path, data: data, mime: item.mime }, options, mount);
    }
  }, {
    key: 'unlink',
    value: function unlink(item, options, mount) {
      return this._request('DELETE', { path: item.path }, options, mount);
    }
  }, {
    key: 'copy',
    value: function copy(src, dest, options, mount) {
      return this._request('COPY', { path: src.path, dest: dest.path }, options, mount);
    }
  }, {
    key: 'move',
    value: function move(src, dest, options, mount) {
      return this._request('MOVE', { path: src.path, dest: dest.path }, options, mount);
    }
  }, {
    key: 'exists',
    value: function exists(item, options, mount) {
      var _this3 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _this3._request('PROPFIND', { path: item.path }, options, mount).then(function () {
          resolve(false);
        }).catch(function (err) {
          if (err.httpCode === 404) {
            resolve(false);
          } else {
            console.warn(err);
            resolve(true);
          }
        });
      });
    }
  }, {
    key: 'mkdir',
    value: function mkdir(item, options, mount) {
      return this._request('MKCOL', { path: item.path }, options, mount);
    }
  }, {
    key: 'url',
    value: function url(item, options, mount) {
      var moduleOptions = mount.option('options') || {};
      var requestUrl = getTargetUrl(mount, item, moduleOptions);
      if (!moduleOptions.cors) {
        requestUrl = (0, _config.getConfig)('Connection.FSURI') + '/read?path=' + encodeURIComponent(requestUrl);
      }

      return _bluebird2.default.resolve(requestUrl);
    }
  }, {
    key: 'freeSpace',
    value: function freeSpace(root) {
      return _bluebird2.default.resolve(-1);
    }
  }]);

  return WebDAVTransport;
}(_transport2.default);

exports.default = WebDAVTransport;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertToRGB = convertToRGB;
exports.convertToHEX = convertToHEX;
exports.invertHEX = invertHEX;
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * Convert HEX to RGB
 *
 * @param   {String}      hex     The hex string (with #)
 *
 * @return  {Object}              RGB in form of r, g, b
 */
function convertToRGB(hex) {
  var rgb = parseInt(hex.replace('#', ''), 16);
  var val = {};
  val.r = (rgb & 255 << 16) >> 16;
  val.g = (rgb & 255 << 8) >> 8;
  val.b = rgb & 255;
  return val;
}

/**
 * Convert RGB to HEX
 *
 * @param   {Number|Object}    r         Red value or RGB object
 * @param   {Number|undefined} [g]       Green value
 * @param   {Number|undefined} [b]       Blue value
 *
 * @return  {String}              Hex string (with #)
 */
function convertToHEX(r, g, b) {
  if ((typeof r === 'undefined' ? 'undefined' : _typeof(r)) === 'object') {
    g = r.g;
    b = r.b;
    r = r.r;
  }

  if (typeof r === 'undefined' || typeof g === 'undefined' || typeof b === 'undefined') {
    throw new Error('Invalid RGB supplied to convertToHEX()');
  }

  var hex = [parseInt(r, 10).toString(16), parseInt(g, 10).toString(16), parseInt(b, 10).toString(16)];

  Object.keys(hex).forEach(function (i) {
    if (hex[i].length === 1) {
      hex[i] = '0' + hex[i];
    }
  });

  return '#' + hex.join('').toUpperCase();
}

/**
 * Ivert HEX color
 * @link http://stackoverflow.com/a/9601429/1236086
 *
 * @param   {String}      hex     Hex string (With #)
 *
 * @return  {String}              Inverted hex (With #)
 *
 */
function invertHEX(hex) {
  var color = parseInt(hex.replace('#', ''), 16);
  color = 0xFFFFFF ^ color;
  color = color.toString(16);
  color = ('000000' + color).slice(-6);
  return '#' + color;
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _authenticator = __webpack_require__(119);

var _authenticator2 = _interopRequireDefault(_authenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Demo Authentication Handler
 * @extends Authenticator
 */
var DemoAuthenticator = function (_Authenticator) {
  _inherits(DemoAuthenticator, _Authenticator);

  function DemoAuthenticator() {
    _classCallCheck(this, DemoAuthenticator);

    return _possibleConstructorReturn(this, (DemoAuthenticator.__proto__ || Object.getPrototypeOf(DemoAuthenticator)).apply(this, arguments));
  }

  _createClass(DemoAuthenticator, [{
    key: '_getSettings',
    value: function _getSettings() {
      var settings = {};
      var key = void 0;
      for (var i = 0; i < localStorage.length; i++) {
        key = localStorage.key(i);
        if (key.match(/^OSjs\//)) {
          try {
            settings[key.replace(/^OSjs\//, '')] = JSON.parse(localStorage.getItem(key));
          } catch (e) {
            console.warn('DemoAuthenticator::login()', e, e.stack);
          }
        }
      }

      return settings;
    }
  }, {
    key: 'login',
    value: function login(_login) {
      var _this2 = this;

      return new _bluebird2.default(function (resolve, reject) {
        _get(DemoAuthenticator.prototype.__proto__ || Object.getPrototypeOf(DemoAuthenticator.prototype), 'login', _this2).call(_this2, _login).then(function (result) {
          result.userSettings = _this2._getSettings();
          return resolve(result);
        }).catch(reject);
      });
    }
  }, {
    key: 'createUI',
    value: function createUI() {
      return this.requestLogin({
        username: 'demo',
        password: 'demo'
      });
    }
  }]);

  return DemoAuthenticator;
}(_authenticator2.default);

exports.default = DemoAuthenticator;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * HTTP Connection Handler
 * @extends Connection
 */
var HttpConnection = function (_Connection) {
  _inherits(HttpConnection, _Connection);

  function HttpConnection() {
    _classCallCheck(this, HttpConnection);

    return _possibleConstructorReturn(this, (HttpConnection.__proto__ || Object.getPrototypeOf(HttpConnection)).apply(this, arguments));
  }

  _createClass(HttpConnection, [{
    key: 'onVFSRequestCompleted',
    value: function onVFSRequestCompleted(module, method, args, result, appRef) {
      // Emit a VFS event when a change occures
      if (['upload', 'write', 'mkdir', 'copy', 'move', 'unlink'].indexOf(method) !== -1) {
        var arg = method === 'move' ? {
          source: args[0] instanceof _file2.default ? args[0] : null,
          destination: args[1] instanceof _file2.default ? args[1] : null
        } : args[method === 'copy' ? 1 : 0];

        VFS.triggerWatch(method, arg, appRef);
      }

      return _get(HttpConnection.prototype.__proto__ || Object.getPrototypeOf(HttpConnection.prototype), 'onVFSRequestCompleted', this).apply(this, arguments);
    }
  }]);

  return HttpConnection;
}(_connection2.default);

exports.default = HttpConnection;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _config = __webpack_require__(15);

var _storage = __webpack_require__(118);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Demo Storage Handler
 * @xtends Storage
 */
var DemoStorage = function (_Storage) {
  _inherits(DemoStorage, _Storage);

  function DemoStorage() {
    _classCallCheck(this, DemoStorage);

    return _possibleConstructorReturn(this, (DemoStorage.__proto__ || Object.getPrototypeOf(DemoStorage)).apply(this, arguments));
  }

  _createClass(DemoStorage, [{
    key: 'init',
    value: function init() {
      var curr = (0, _config.getConfig)('Version');
      var version = localStorage.getItem('__version__');

      if (curr !== version) {
        localStorage.clear();
      }
      localStorage.setItem('__version__', String(curr));

      return _bluebird2.default.resolve();
    }
  }, {
    key: 'saveSettings',
    value: function saveSettings(pool, storage) {
      Object.keys(storage).forEach(function (key) {
        if (pool && key !== pool) {
          return;
        }

        try {
          localStorage.setItem('OSjs/' + key, JSON.stringify(storage[key]));
        } catch (e) {
          console.warn('DemoStorage::settings()', e, e.stack);
        }
      });

      return _bluebird2.default.resolve();
    }
  }]);

  return DemoStorage;
}(_storage2.default);

exports.default = DemoStorage;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setClipboard = setClipboard;
exports.getClipboard = getClipboard;
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
var _CLIPBOARD = void 0; // Current 'clipboard' data

/**
 * Set the "clipboard" data
 *
 * NOTE: This does not set the operating system clipboard (yet...)
 *
 * @param   {Object|String|Numer}       data      What data to set
 */
function setClipboard(data) {
  console.debug('setClipboard()', data);
  _CLIPBOARD = data;
}

/**
 * Get the "clipboard" data
 *
 * NOTE: This does not the operating system clipboard (yet...)
 *
 * @return  {Object|String|Number}
 */
function getClipboard() {
  return _CLIPBOARD;
}

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _init = __webpack_require__(184);

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

//
// Makes sure a global namespace is available
//
window.OSjs = Object.assign({
  error: function error(title, message, _error, exception, bugreport) {
    console.error(title, message, _error, exception);
  },
  runTests: function runTests() {
    // void
  },
  getConfig: function getConfig() {
    return {};
  },
  getManifest: function getManifest() {
    return {};
  },
  Themes: {},
  Dialogs: {},
  Locales: {},
  Extensions: {},
  Applications: {}
}, window.OSjs || {});

//
// This allows packages to require modules almost like normal
//
window.OSjs.require = function (n) {
  var mod = __webpack_require__(516)("./" + n);
  return mod && mod.default ? mod.default : mod;
};

//
// Then proceed to start up
//
__webpack_require__(519);


if (document.readyState !== 'loading') {
  (0, _init.start)();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    return (0, _init.start)();
  });
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createMatch(m, sname) {
  if (typeof m === 'string') {
    return new RegExp(m);
  } else if (!m) {
    return new RegExp('^' + (sname + '://').replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'));
  }

  return m;
}

/**
 * A VFS mountpoint
 *
 * @desc Connects to a Transport
 */

var Mountpoint = function () {

  /**
   * Constructs a new Mountpoint
   * @param {Object} options Mountpoint options
   */
  function Mountpoint(options) {
    var _this = this;

    _classCallCheck(this, Mountpoint);

    this.options = Object.assign({
      name: null,
      root: null,
      match: null,

      enabled: true,
      readOnly: false,
      transport: null,
      visible: true,
      searchable: false,
      dynamic: true,
      internal: false,
      special: false,
      options: {}
    }, options);

    if (!this.options.transport) {
      throw new Error('No transport was defined for mountpoint ' + this.options.name);
    }

    if (!this.options.name) {
      throw new Error((0, _locales._)('ERR_VFSMODULE_INVALID_CONFIG_FMT'));
    }

    var sname = this.options.name.replace(/\s/g, '-').toLowerCase();

    var defaults = {
      icon: 'devices/drive-harddisk.png',
      name: sname,
      title: this.options.name,
      description: this.options.description || this.options.name,
      root: sname + ':///',
      match: createMatch(this.options.match, sname)
    };

    Object.keys(defaults).forEach(function (k) {
      if (!_this.options[k]) {
        _this.options[k] = defaults[k];
      }
    });

    this.name = sname;
    this.isMounted = false;
  }

  /**
   * Mounts given Mountpoint
   * @param {Object} [options] Mount options
   * @return {Promise<Boolean, Error>}
   */


  _createClass(Mountpoint, [{
    key: 'mount',
    value: function mount(options) {
      options = Object.assign({
        notify: true
      }, options || {});

      if (!this.isMounted && !this.option('special')) {
        if (options.notify) {
          _process2.default.message('vfs:mount', this.option('name'), { source: null });
        }
        this.isMounted = true;
      }

      return _bluebird2.default.resolve();
    }

    /**
     * Unmount given Mountpoint
     * @param {Object} [options] Unmount options
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'unmount',
    value: function unmount(options) {
      options = Object.assign({
        notify: true
      }, options || {});

      if (this.isMounted && !this.option('special')) {
        if (options.notify) {
          _process2.default.message('vfs:unmount', this.option('name'), { source: null });
        }
        this.isMounted = false;
      }

      return _bluebird2.default.resolve();
    }

    /**
     * Check if mounted
     * @return {Boolean}
     */

  }, {
    key: 'mounted',
    value: function mounted() {
      return this.isMounted;
    }

    /**
     * Check if enabled
     * @return {Boolean}
     */

  }, {
    key: 'enabled',
    value: function enabled() {
      return this.option('enabled');
    }

    /**
     * Gets an option by name
     * @param {String} name Option name
     * @return {*}
     */

  }, {
    key: 'option',
    value: function option(name) {
      return this.options[name];
    }

    /**
     * Check if readonly
     * @return {Boolean}
     */

  }, {
    key: 'isReadOnly',
    value: function isReadOnly() {
      return this.option('readOnly');
    }

    /**
     * Set mounted state
     * @param {Boolean} mounted State
     */

  }, {
    key: 'setMounted',
    value: function setMounted(mounted) {
      this.isMounted = mounted === true;
    }

    /**
     * Perform a request to assiged transport
     * @param {String}   method     VFS Method
     * @param {Array}    args       VFS Arguments
     * @param {Object}   [options]  Options
     * @return {Promise<Object, Error>}
     */

  }, {
    key: 'request',
    value: function request(method, args, options) {
      var transport = this.option('transport');
      if (transport) {
        return transport.request(method, args, options, this);
      }

      return _bluebird2.default.reject(new Error((0, _locales._)('ERR_VFSMODULE_NOT_FOUND_FMT', test)));
    }
  }]);

  return Mountpoint;
}();

exports.default = Mountpoint;

/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _misc = __webpack_require__(52);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/////////////////////////////////////////////////////////////////////////////
// Settings Fragment.
/////////////////////////////////////////////////////////////////////////////

/**
 * Settings Fragment Class
 *
 * @desc
 * <pre><b>
 * This is the object returned when manipulating with SettingsManager.
 * </b></pre>
 *
 * @throws {Error} If an invalid object was given
 */
var SettingsFragment = function () {

  /**
   * @param   {Object}          obj         Settings tree
   * @param   {String}          poolName    Name of the pool
   * @param   {SettingsManager} sm          SettigsManager instance
   */
  function SettingsFragment(obj, poolName, sm) {
    _classCallCheck(this, SettingsFragment);

    this._sm = sm;
    this._pool = poolName;

    if (obj.constructor !== {}.constructor) {
      if (!(obj instanceof Array)) {
        throw new Error('SettingsFragment will not work unless you give it a object to manage.');
      }
    }

    this._settings = obj;
  }

  /**
   * Gets setting(s) by key
   *
   * @param   {String}    [key]              Name of key
   * @param   {*}         [defaultValue]     Default value if result is undefined
   *
   * @return  {*}                   Either an entry or entire tree
   */


  _createClass(SettingsFragment, [{
    key: 'get',
    value: function get(key, defaultValue) {
      var ret = key ? this._settings[key] : this._settings;
      return typeof ret === 'undefined' ? defaultValue : ret;
    }

    /**
     * Sets setting(s) by key/value
     *
     * If you set `key` to `null` you will write to the tree root.
     *
     * @param   {String|Number}     [key]                 The key
     * @param   {Object|*}          value                 The value
     * @param   {Boolean|Function}  save                  Saves the pool (either boolean or callback function)
     * @param   {Boolean}           [triggerWatch=true]   Trigger change event for watchers
     *
     * @return  {SettingsFragment}  Itself `this`
     */

  }, {
    key: 'set',
    value: function set(key, value, save, triggerWatch) {
      // Key here is actually the value
      // So you can update the whole object if you want.
      if (key === null) {
        (0, _misc.mergeObject)(this._settings, value);
      } else {
        if (['number', 'string'].indexOf(typeof key === 'undefined' ? 'undefined' : _typeof(key)) >= 0) {
          this._settings[key] = value;
        } else {
          console.warn('SettingsFragment::set()', 'expects key to be a valid iter, not', key);
        }
      }

      if (save) {
        this._sm.save(this._pool, save);
      }

      if (typeof triggerWatch === 'undefined' || triggerWatch === true) {
        this._sm.changed(this._pool);
      }

      return this;
    }

    /**
     * Saves the pool
     * @see SettingsManager#save
     *
     * @param   {Function}      [callback]        Callback function
     *
     * @return  {Promise<Boolean, Error>}
     */

  }, {
    key: 'save',
    value: function save(callback) {
      return this._sm.save(this._pool, callback);
    }
  }, {
    key: 'getChained',
    value: function getChained() {
      var nestedSetting = this._settings;
      arguments.every(function (key) {
        if (nestedSetting[key]) {
          nestedSetting = nestedSetting[key];
          return true;
        }

        return false;
      });

      return nestedSetting;
    }

    /**
     * Merges given tree with current one
     *
     * @param     {Object}        defaults        The tree
     *
     * @return  {SettingsFragment}  Itself `this`
     */

  }, {
    key: 'mergeDefaults',
    value: function mergeDefaults(defaults) {
      (0, _misc.mergeObject)(this._settings, defaults, { overwrite: false });
      return this;
    }

    /**
     * Creates a new SettingsFragment instance from given key
     * @throws {Error} If the given key does not exist
     *
     * @param     {String}        key     Key name
     *
     * @return  {SettingsFragment}  New instance
     */

  }, {
    key: 'instance',
    value: function instance(key) {
      if (typeof this._settings[key] === 'undefined') {
        throw new Error('The object doesn\'t contain that key. SettingsFragment will not work.');
      }

      return new SettingsFragment(this._settings[key], this._pool, this._sm);
    }
  }]);

  return SettingsFragment;
}();

exports.default = SettingsFragment;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


exports.createWindowBehaviour = createWindowBehaviour;

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Holds information about current behaviour
 */
var BehaviourState = function () {
  function BehaviourState(wm, win, action, mousePosition) {
    var _this = this;

    _classCallCheck(this, BehaviourState);

    this.win = win;
    this.$element = win._$element;
    this.$top = win._$top;
    this.$handle = win._$resize;

    this.rectWorkspace = wm.getWindowSpace(true);
    this.rectWindow = {
      x: win._position.x,
      y: win._position.y,
      w: win._dimension.w,
      h: win._dimension.h,
      r: win._dimension.w + win._position.x,
      b: win._dimension.h + win._position.y
    };

    var theme = Object.assign({}, _theme2.default.getStyleTheme(true, true));
    if (!theme.style) {
      theme.style = { 'window': { margin: 0, border: 0 } };
    }

    this.theme = {
      topMargin: theme.style.window.margin || 0, // FIXME
      borderSize: theme.style.window.border || 0
    };

    this.snapping = {
      cornerSize: wm.getSetting('windowCornerSnap') || 0,
      windowSize: wm.getSetting('windowSnap') || 0
    };

    this.action = action;
    this.moved = false;
    this.direction = null;
    this.startX = mousePosition.x;
    this.startY = mousePosition.y;
    this.minWidth = win._properties.min_width;
    this.minHeight = win._properties.min_height;

    var windowRects = [];
    wm.getWindows().forEach(function (w) {
      if (w && w._wid !== win._wid) {
        var pos = w._position;
        var dim = w._dimension;
        var rect = {
          left: pos.x - _this.theme.borderSize,
          top: pos.y - _this.theme.borderSize,
          width: dim.w + _this.theme.borderSize * 2,
          height: dim.h + _this.theme.borderSize * 2 + _this.theme.topMargin
        };

        rect.right = rect.left + rect.width;
        rect.bottom = pos.y + dim.h + _this.theme.topMargin + _this.theme.borderSize; //rect.top + rect.height;

        windowRects.push(rect);
      }
    });

    this.snapRects = windowRects;
  }

  _createClass(BehaviourState, [{
    key: 'getRect',
    value: function getRect() {
      var win = this.win;

      return {
        left: win._position.x,
        top: win._position.y,
        width: win._dimension.w,
        height: win._dimension.h
      };
    }
  }, {
    key: 'calculateDirection',
    value: function calculateDirection() {
      var dir = DOM.$position(this.$handle);
      var dirX = this.startX - dir.left;
      var dirY = this.startY - dir.top;
      var dirD = 20;

      var checks = {
        nw: dirX <= dirD && dirY <= dirD,
        n: dirX > dirD && dirY <= dirD,
        w: dirX <= dirD && dirY >= dirD,
        ne: dirX >= dir.width - dirD && dirY <= dirD,
        e: dirX >= dir.width - dirD && dirY > dirD,
        se: dirX >= dir.width - dirD && dirY >= dir.height - dirD,
        sw: dirX <= dirD && dirY >= dir.height - dirD
      };

      var direction = 's';
      Object.keys(checks).forEach(function (k) {
        if (checks[k]) {
          direction = k;
        }
      });

      this.direction = direction;
    }
  }]);

  return BehaviourState;
}();

/*
 * Window Behavour Abstraction
 */


function createWindowBehaviour(win, wm) {
  var current = null;
  var newRect = {};

  /*
   * Resizing action
   */
  function onWindowResize(ev, mousePosition, dx, dy) {
    if (!current || !current.direction) {
      return false;
    }

    var nw = void 0,
        nh = void 0,
        nl = void 0,
        nt = void 0;

    (function () {
      // North/South
      if (current.direction.indexOf('s') !== -1) {
        nh = current.rectWindow.h + dy;

        newRect.height = Math.max(current.minHeight, nh);
      } else if (current.direction.indexOf('n') !== -1) {
        nh = current.rectWindow.h - dy;
        nt = current.rectWindow.y + dy;

        if (nt < current.rectWorkspace.top) {
          nt = current.rectWorkspace.top;
          nh = newRect.height;
        } else {
          if (nh < current.minHeight) {
            nt = current.rectWindow.b - current.minHeight;
          }
        }

        newRect.height = Math.max(current.minHeight, nh);
        newRect.top = nt;
      }
    })();

    (function () {
      // East/West
      if (current.direction.indexOf('e') !== -1) {
        nw = current.rectWindow.w + dx;

        newRect.width = Math.max(current.minWidth, nw);
      } else if (current.direction.indexOf('w') !== -1) {
        nw = current.rectWindow.w - dx;
        nl = current.rectWindow.x + dx;

        if (nw < current.minWidth) {
          nl = current.rectWindow.r - current.minWidth;
        }

        newRect.width = Math.max(current.minWidth, nw);
        newRect.left = nl;
      }
    })();

    return newRect;
  }

  /*
   * Movement action
   */
  function onWindowMove(ev, mousePosition, dx, dy) {
    var newWidth = null;
    var newHeight = null;
    var newLeft = current.rectWindow.x + dx;
    var newTop = current.rectWindow.y + dy;

    var borderSize = current.theme.borderSize;
    var topMargin = current.theme.topMargin;
    var cornerSnapSize = current.snapping.cornerSize;
    var windowSnapSize = current.snapping.windowSize;

    if (newTop < current.rectWorkspace.top) {
      newTop = current.rectWorkspace.top;
    }

    var newRight = newLeft + current.rectWindow.w + borderSize * 2;
    var newBottom = newTop + current.rectWindow.h + topMargin + borderSize;

    // 8-directional corner window snapping
    if (cornerSnapSize > 0) {
      if (newLeft - borderSize <= cornerSnapSize && newLeft - borderSize >= -cornerSnapSize) {
        // Left
        newLeft = borderSize;
      } else if (newRight >= current.rectWorkspace.width - cornerSnapSize && newRight <= current.rectWorkspace.width + cornerSnapSize) {
        // Right
        newLeft = current.rectWorkspace.width - current.rectWindow.w - borderSize;
      }
      if (newTop <= current.rectWorkspace.top + cornerSnapSize && newTop >= current.rectWorkspace.top - cornerSnapSize) {
        // Top
        newTop = current.rectWorkspace.top + borderSize;
      } else if (newBottom >= current.rectWorkspace.height + current.rectWorkspace.top - cornerSnapSize && newBottom <= current.rectWorkspace.height + current.rectWorkspace.top + cornerSnapSize) {
        // Bottom
        newTop = current.rectWorkspace.height + current.rectWorkspace.top - current.rectWindow.h - topMargin - borderSize;
      }
    }

    // Snapping to other windows
    if (windowSnapSize > 0) {
      current.snapRects.every(function (rect) {
        // >
        if (newRight >= rect.left - windowSnapSize && newRight <= rect.left + windowSnapSize) {
          // Left
          newLeft = rect.left - (current.rectWindow.w + borderSize * 2);
          return false;
        }

        // <
        if (newLeft - borderSize <= rect.right + windowSnapSize && newLeft - borderSize >= rect.right - windowSnapSize) {
          // Right
          newLeft = rect.right + borderSize * 2;
          return false;
        }

        // \/
        if (newBottom >= rect.top - windowSnapSize && newBottom <= rect.top + windowSnapSize) {
          // Top
          newTop = rect.top - (current.rectWindow.h + borderSize * 2 + topMargin);
          return false;
        }

        // /\
        if (newTop <= rect.bottom + windowSnapSize && newTop >= rect.bottom - windowSnapSize) {
          // Bottom
          newTop = rect.bottom + borderSize * 2;
          return false;
        }

        return true;
      });
    }

    return { left: newLeft, top: newTop, width: newWidth, height: newHeight };
  }

  /*
   * When mouse button is released
   */
  function onMouseUp(ev, action, win, mousePosition) {
    if (!current) {
      return;
    }

    if (current.moved) {
      if (action === 'move') {
        win._onChange('move', true);
        win._emit('moved', [win._position.x, win._position.y]);
      } else if (action === 'resize') {
        win._onChange('resize', true);
        win._emit('resized', [win._dimension.w, win._dimension.h]);
      }
    }

    current.$element.setAttribute('data-hint', '');
    document.body.setAttribute('data-window-hint', '');

    win._emit('postop');

    current = null;
  }

  /*
   * When mouse is moved
   */
  function onMouseMove(ev, action, win, mousePosition) {
    if (!wm.getMouseLocked() || !action || !current) {
      return;
    }

    ev.preventDefault();

    var result = void 0;

    var dx = mousePosition.x - current.startX;
    var dy = mousePosition.y - current.startY;

    if (action === 'move') {
      result = onWindowMove(ev, mousePosition, dx, dy);
    } else {
      result = onWindowResize(ev, mousePosition, dx, dy);
    }

    if (result) {
      if (result.left !== null && result.top !== null) {
        win._move(result.left, result.top);
        win._emit('move', [result.left, result.top]);
      }
      if (result.width !== null && result.height !== null) {
        win._resize(result.width, result.height, true);
        win._emit('resize', [result.width, result.height]);
      }
    }

    current.moved = true;
  }

  /*
   * When mouse button is pressed
   */
  function onMouseDown(ev, action, win, mousePosition) {
    ev.preventDefault();

    if (win._state.maximized) {
      return;
    }

    current = new BehaviourState(wm, win, action, mousePosition);
    newRect = {};

    win._focus();

    if (action === 'move') {
      current.$element.setAttribute('data-hint', 'moving');
      document.body.setAttribute('data-window-hint', 'moving');
    } else {
      current.calculateDirection();
      current.$element.setAttribute('data-hint', 'resizing');
      document.body.setAttribute('data-window-hint', 'resizing');

      newRect = current.getRect();
    }

    win._emit('preop');

    function _onMouseMove(ev, pos) {
      ev.preventDefault();
      if (wm._mouselock) {
        onMouseMove(ev, action, win, pos);
      }
    }
    function _onMouseUp(ev, pos) {
      onMouseUp(ev, action, win, pos);
      Events.$unbind(document, 'pointermove:movewindow,touchmove:movewindowTouch');
      Events.$unbind(document, 'pointerup:movewindowstop,touchend:movewindowstopTouch');
    }

    Events.$bind(document, 'pointermove:movewindow,touchmove:movewindowTouch', _onMouseMove, false);
    Events.$bind(document, 'pointerup:movewindowstop,touchend:movewindowstopTouch', _onMouseUp, false);
  }

  /*
   * Register a window
   */
  if (win._properties.allow_move) {
    Events.$bind(win._$top, 'pointerdown,touchstart', function (ev, pos) {
      ev.preventDefault();
      if (!win._destroyed) {
        onMouseDown(ev, 'move', win, pos);
      }
    }, true);
  }
  if (win._properties.allow_resize) {
    Events.$bind(win._$resize, 'pointerdown,touchstart', function (ev, pos) {
      ev.preventDefault();
      if (!win._destroyed) {
        onMouseDown(ev, 'resize', win, pos);
      }
    });
  }
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


exports.instance = instance;
exports.create = create;

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _serviceNotificationIcon = __webpack_require__(195);

var _serviceNotificationIcon2 = _interopRequireDefault(_serviceNotificationIcon);

var _preloader = __webpack_require__(120);

var _preloader2 = _interopRequireDefault(_preloader);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

var _thenJsonp = __webpack_require__(491);

var _thenJsonp2 = _interopRequireDefault(_thenJsonp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var gapi = window.gapi = window.gapi || {};

/////////////////////////////////////////////////////////////////////////////
// API
/////////////////////////////////////////////////////////////////////////////

var SingletonInstance = null;

/**
 * The GoogleAPI wrapper class
 *
 * <pre><b>
 * Generally you want to create an instance of this helper
 * and when successfully created use `window.gapi`.
 * </b></pre>
 *
 * @desk Helper for communicating with Google API.
 *
 * @link https://developers.google.com/api-client-library/javascript/start/start-js
 * @link https://developers.google.com/api-client-library/javascript/
 * @link https://console.developers.google.com/project
 */

var GoogleAPI = function () {

  /**
   * @param {String}  clientId    Client ID (key)
   */
  function GoogleAPI(clientId) {
    _classCallCheck(this, GoogleAPI);

    this.clientId = clientId;
    this.accessToken = null;
    this.userId = null;
    this.preloaded = false;
    this.authenticated = false;
    this.loaded = [];
    this.preloads = [{
      type: 'javascript',
      src: 'https://apis.google.com/js/api.js'
    }];
  }

  /*
   * Destroy the class
   */


  _createClass(GoogleAPI, [{
    key: 'destroy',
    value: function destroy() {}

    /*
     * Initializes (preloads) the API
     */

  }, {
    key: 'init',
    value: function init(callback) {
      var _this = this;

      callback = callback || function () {};
      if (this.preloaded) {
        callback(false, true);
      } else {
        _preloader2.default.preload(this.preloads).then(function (result) {
          if (result.failed.length) {
            _this.preloaded = true;
          }
          callback(result.failed.join('\n'));
        }).catch(callback);
      }
    }

    /*
     * Loads the API
     */

  }, {
    key: 'load',
    value: function load(_load2, scope, client, callback) {
      var _this2 = this;

      var auth = function auth(cb) {
        _this2.authenticate(scope, function (error, result) {
          if (error) {
            cb(error);
          } else {
            if (!_this2.authenticated) {
              cb((0, _locales._)('GAPI_AUTH_FAILURE'));
              return;
            }
            cb(false, result);
          }
        });
      };

      var loadAll = function loadAll(finished) {
        var lload = [];
        _load2.forEach(function (i) {
          if (_this2.loaded.indexOf(i) === -1) {
            lload.push(i);
          }
        });

        var current = 0;
        var total = lload.length;

        console.debug('GoogleAPI::load()', _load2, '=>', lload, scope);

        var _load = function _load(iter, cb) {
          var args = [];
          var name = null;

          if (iter instanceof Array) {
            if (iter.length > 0 && iter.length < 3) {
              args = args.concat(iter);
              name = iter[0];
            }
          } else {
            args.push(iter);
            name = iter;
          }

          args.push(function (a, b, c, d) {
            _this2.loaded.push(name);

            /* eslint no-invalid-this: "off" */
            cb.call(_this2, a, b, c, d);
          });

          if (client) {
            gapi.client.load.apply(gapi, args);
          } else {
            gapi.load.apply(gapi, args);
          }
        };

        function _next() {
          if (current >= total) {
            finished();
          } else {
            _load(lload[current], function () {
              _next();
            });

            current++;
          }
        }

        _next();
      };

      this.init(function (error) {
        if (error) {
          callback(error);
          return;
        }

        if (!window.gapi || !gapi.load) {
          callback((0, _locales._)('GAPI_LOAD_FAILURE'));
          return;
        }

        auth(function (error) {
          if (error) {
            callback(error);
            return;
          }

          loadAll(function (error, result) {
            callback(error, result, SingletonInstance);
          });
        });
      });
    }

    /**
     * Sign out of GoogleAPI
     *
     * @param   {Function}    cb      Callback => fn(error, result)
     */

  }, {
    key: 'signOut',
    value: function signOut(cb) {
      cb = cb || function () {};

      console.info('GoogleAPI::signOut()');
      if (this.authenticated) {
        try {
          gapi.auth.signOut();
        } catch (e) {
          console.warn('GoogleAPI::signOut()', 'failed', e);
          console.warn(e.stack);
        }

        this.authenticated = false;

        _serviceNotificationIcon2.default.remove('Google API');
      }

      _mountManager2.default.remove('GoogleDrive');

      cb(false, true);
    }

    /**
     * Revoke Google permissions for this app
     *
     * @param   {Function}    callback      Callback => fn(error, result)
     */

  }, {
    key: 'revoke',
    value: function revoke(callback) {
      console.info('GoogleAPI::revoke()');

      if (!this.accessToken) {
        callback(false);
        return;
      }

      var url = 'https://accounts.google.com/o/oauth2/revoke?token=' + this.accessToken;
      (0, _thenJsonp2.default)('GET', url).then(function () {
        return callback(true);
      }).catch(function () {
        return callback(false);
      });
    }

    /*
     * Authenticates the user
     */

  }, {
    key: 'authenticate',
    value: function authenticate(scope, callback) {
      var _this3 = this;

      console.info('GoogleAPI::authenticate()');

      callback = callback || function () {};

      var getUserId = function getUserId(cb) {
        cb = cb || function () {};
        gapi.client.load('oauth2', 'v2', function () {
          gapi.client.oauth2.userinfo.get().execute(function (resp) {
            console.info('GoogleAPI::authenticate() => getUserId()', resp);
            cb(resp.id);
          });
        });
      };

      var login = function login(immediate, cb) {
        console.info('GoogleAPI::authenticate() => login()', immediate);

        cb = cb || function () {};
        gapi.auth.authorize({
          client_id: _this3.clientId,
          scope: scope,
          user_id: _this3.userId,
          immediate: immediate
        }, cb);
      };

      var createRingNotification = function createRingNotification() {
        _serviceNotificationIcon2.default.remove('Google API');

        _serviceNotificationIcon2.default.add('Google API', [{
          title: (0, _locales._)('GAPI_SIGN_OUT'),
          onClick: function onClick() {
            _this3.signOut();
          }
        }, {
          title: (0, _locales._)('GAPI_REVOKE'),
          onClick: function onClick() {
            _this3.revoke(function () {
              _this3.signOut();
            });
          }
        }]);
      };

      var handleAuthResult = function handleAuthResult(authResult, immediate) {
        console.info('GoogleAPI::authenticate() => handleAuthResult()', authResult);

        if (authResult.error) {
          if (authResult.error_subtype === 'origin_mismatch' || authResult.error_subtype === 'access_denied' && !immediate) {
            var msg = (0, _locales._)('GAPI_AUTH_FAILURE_FMT', authResult.error, authResult.error_subtype);
            callback(msg);
            return;
          }
        }

        if (authResult && !authResult.error) {
          getUserId(function (id) {
            _this3.userId = id;

            if (id) {
              createRingNotification();
              _this3.authenticated = true;
              _this3.accessToken = authResult.access_token || null;
              callback(false, true);
            } else {
              callback(false, false);
            }
          });
        } else {
          login(false, function (res) {
            handleAuthResult(res, false);
          });
        }
      };

      gapi.load('auth:client', function (result) {
        if (result && result.error) {
          var msg = (0, _locales._)('GAPI_AUTH_FAILURE_FMT', result.error, result.error_subtype);
          callback(msg);
          return;
        }

        login(true, function (res) {
          handleAuthResult(res, true);
        });
      });
    }
  }]);

  return GoogleAPI;
}();

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

function instance() {
  return SingletonInstance;
}

function create(args, callback) {
  var load = args.load || [];
  var scope = args.scope || [];
  var client = args.client === true;

  function _run() {
    SingletonInstance.load(load, scope, client, callback);
  }

  if (SingletonInstance) {
    _run();
    return;
  }

  var clientId = null;
  try {
    clientId = (0, _config.getConfig)('GoogleAPI.ClientId');
  } catch (e) {
    console.warn('getGoogleAPI()', e, e.stack);
  }

  if (!clientId) {
    callback((0, _locales._)('GAPI_DISABLED'));
    return;
  }

  SingletonInstance = new GoogleAPI(clientId);
  _run();
}

/***/ }),
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

exports.instance = instance;
exports.create = create;

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _serviceNotificationIcon = __webpack_require__(195);

var _serviceNotificationIcon2 = _interopRequireDefault(_serviceNotificationIcon);

var _preloader = __webpack_require__(120);

var _preloader2 = _interopRequireDefault(_preloader);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var redirectURI = window.location.href.replace(/\/$/, '') + '/windows-live-oauth.html';

/////////////////////////////////////////////////////////////////////////////
// API
/////////////////////////////////////////////////////////////////////////////

var SingletonInstance = null;

/**
 * The WindowsLiveAPI wrapper class
 *
 * @desc Helper for communicating with Windows Live API.
 * <pre><b>
 * Generally you want to create an instance of this helper
 * and when successfully created use `window.WL`.
 * </b></pre>
 *
 * @link http://msdn.microsoft.com/en-us/library/hh826547.aspx
 * @link http://msdn.microsoft.com/en-us/library/hh826538.aspx
 * @link http://msdn.microsoft.com/en-us/library/hh550837.aspx
 * @link http://msdn.microsoft.com/en-us/library/dn631844.aspx
 * @link http://msdn.microsoft.com/en-us/library/dn631839.aspx
 * @link http://msdn.microsoft.com/en-us/library/hh243643.aspx
 * @link https://account.live.com/developers/applications/index
 */

var WindowsLiveAPI = function () {

  /**
   * @param {String}  clientId    Client ID (key)
   */
  function WindowsLiveAPI(clientId) {
    _classCallCheck(this, WindowsLiveAPI);

    this.hasSession = false;
    this.clientId = clientId;
    this.loaded = false;
    this.inited = false;
    this.accessToken = null;
    this.lastScope = null;
    this.preloads = [{
      type: 'javascript',
      src: '//js.live.net/v5.0/wl.js'
    }];
  }

  /*
   * Destroy the class
   */


  _createClass(WindowsLiveAPI, [{
    key: 'destroy',
    value: function destroy() {}

    /*
     * Initializes (preloads) the API
     */

  }, {
    key: 'init',
    value: function init(callback) {
      var _this = this;

      callback = callback || function () {};
      if (this.loaded) {
        callback(false, true);
      } else {
        _preloader2.default.preload(this.preloads).then(function (result) {
          if (!result.failed.length) {
            _this.loaded = true;
          }
          callback(result.failed.join('\n'));
        }).catch(function () {
          return callback();
        });
      }
    }

    /*
     * Loads the API
     */

  }, {
    key: 'load',
    value: function load(scope, callback) {
      var _this2 = this;

      console.debug('WindowsLiveAPI::load()', scope);

      var WL = window.WL || {};

      var _login = function _login() {
        var lastScope = (_this2.lastScope || []).sort();
        var currScope = (scope || []).sort();

        if (_this2.hasSession && lastScope.toString() === currScope.toString()) {
          callback(false, true);
          return;
        }

        _this2.login(scope, function (error, response) {
          if (error) {
            callback(error);
            return;
          }

          setTimeout(function () {
            callback(false, true);
          }, 10);
        });
      };

      this.init(function (error) {
        if (error) {
          callback(error);
          return;
        }

        if (!window.WL) {
          callback((0, _locales._)('WLAPI_LOAD_FAILURE'));
          return;
        }
        WL = window.WL || {};

        if (_this2.inited) {
          _login();
        } else {
          _this2.inited = true;
          WL.Event.subscribe('auth.login', function (a, b, c, d) {
            _this2.onLogin(a, b, c, d);
          });
          WL.Event.subscribe('auth.logout', function (a, b, c, d) {
            _this2.onLogout(a, b, c, d);
          });
          WL.Event.subscribe('wl.log', function (a, b, c, d) {
            _this2.onLog(a, b, c, d);
          });
          WL.Event.subscribe('auth.sessionChange', function (a, b, c, d) {
            _this2.onSessionChange(a, b, c, d);
          });

          WL.init({
            client_id: _this2.clientId,
            display: 'popup',
            redirect_uri: redirectURI
          }).then(function (result) {
            console.debug('WindowsLiveAPI::load()', '=>', result);

            if (result.session) {
              _this2.accessToken = result.session.access_token || null;
            }

            if (result.status === 'connected') {
              callback(false, true);
            } else if (result.status === 'success') {
              _login();
            } else {
              callback((0, _locales._)('WLAPI_INIT_FAILED_FMT', result.status.toString()));
            }
          }, function (result) {
            console.error('WindowsLiveAPI::load()', 'init() error', result);
            callback(result.error_description);
          });
        }
      });
    }
  }, {
    key: '_removeRing',
    value: function _removeRing() {
      _serviceNotificationIcon2.default.remove('Windows Live API');
    }

    /**
     * Sign out of WindowsLiveAPI
     *
     * @param   {Function}    callback      Callback => fn(error, result)
     */

  }, {
    key: 'logout',
    value: function logout(callback) {
      var _this3 = this;

      callback = callback || function () {};

      var WL = window.WL || {};

      if (this.hasSession) {
        callback(false, false);
      }

      WL.Event.unsubscribe('auth.logout');
      WL.Event.subscribe('auth.logout', function () {
        _this3._removeRing();

        WL.Event.unsubscribe('auth.logout');
        callback(false, true);
      });

      WL.logout();

      _mountManager2.default.remove('OneDrive');
    }

    /*
     * Authenticates the user
     */

  }, {
    key: 'login',
    value: function login(scope, callback) {
      var WL = window.WL || {};

      if (this.hasSession) {
        callback(false, true);
        return;
      }

      WL.login({
        scope: scope,
        redirect_uri: redirectURI
      }).then(function (result) {
        if (result.status === 'connected') {
          callback(false, true);
        } else {
          callback((0, _locales._)('WLAPI_LOGIN_FAILED'));
        }
      }, function (result) {
        callback((0, _locales._)('WLAPI_LOGIN_FAILED_FMT', result.error_description));
      });
    }

    /*
     * If the API session was changed
     */

  }, {
    key: 'onSessionChange',
    value: function onSessionChange() {
      console.warn('WindowsLiveAPI::onSessionChange()', arguments);
      var WL = window.WL || {};
      var session = WL.getSession();
      if (session) {
        this.hasSession = true;
      } else {
        this.hasSession = false;
      }
    }

    /*
     * When user logged in
     */

  }, {
    key: 'onLogin',
    value: function onLogin() {
      var _this4 = this;

      console.warn('WindowsLiveAPI::onLogin()', arguments);
      this.hasSession = true;

      _serviceNotificationIcon2.default.add('Windows Live API', [{
        title: (0, _locales._)('WLAPI_SIGN_OUT'),
        onClick: function onClick() {
          _this4.logout();
        }
      }]);
    }

    /*
     * When user logs out
     */

  }, {
    key: 'onLogout',
    value: function onLogout() {
      console.warn('WindowsLiveAPI::onLogout()', arguments);
      this.hasSession = false;
      this._removeRing();
    }

    /*
     * When API sends a log message
     */

  }, {
    key: 'onLog',
    value: function onLog() {
      console.debug('WindowsLiveAPI::onLog()', arguments);
    }
  }]);

  return WindowsLiveAPI;
}();

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

function instance() {
  return SingletonInstance;
}

function create(args, callback) {
  args = args || {};

  function _run() {
    var scope = args.scope;
    SingletonInstance.load(scope, function (error) {
      callback(error ? error : false, SingletonInstance);
    });
  }

  if (SingletonInstance) {
    _run();
    return;
  }

  var clientId = null;
  try {
    clientId = (0, _config.getConfig)('WindowsLiveAPI.ClientId');
  } catch (e) {
    console.warn('getWindowsLiveAPI()', e, e.stack);
  }

  if (!clientId) {
    callback((0, _locales._)('WLAPI_DISABLED'));
    return;
  }

  SingletonInstance = new WindowsLiveAPI(clientId);
  _run();
}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

/*
 * Searches an object field for matches
 */
function _search(list, query) {
  var result = [];

  list.forEach(function (obj) {
    var found = false;

    obj.fields.forEach(function (s) {
      if (found) {
        return;
      }

      var qry = String(query).toLowerCase();
      var str = String(s).toLowerCase();
      if (str.indexOf(qry) !== -1) {
        result.push(obj.value);

        found = true;
      }
    });
  });

  return result;
}

/*
 * A search Object
 */
function SearchObject(obj) {
  var _this = this;

  Object.keys(obj).forEach(function (k) {
    _this[k] = obj[k];
  });
}

/////////////////////////////////////////////////////////////////////////////
// MODULES
/////////////////////////////////////////////////////////////////////////////

/*
 * Search Applications
 */
var ApplicationModule = function () {
  function query() {
    var packages = _packageManager2.default.getPackages();

    return Object.keys(packages).map(function (pn) {
      var p = packages[pn];

      return new SearchObject({
        value: {
          title: p.name,
          description: p.description,
          icon: _theme2.default.getFileIcon(new _file2.default('applications:///' + p.className, 'application'), '16x16'),
          launch: { application: pn, args: {} }
        },
        fields: [p.className, p.name, p.description]
      });
    });
  }

  return {
    search: function search(q, args, settings) {
      if (settings.applications) {
        var results = _search(query(), q);

        if (args.limit && results.length > args.dlimit) {
          results = results.splice(0, args.dlimit);
        }

        return _bluebird2.default.resolve(results);
      }
      return _bluebird2.default.resolve([]);
    },
    reindex: function reindex(args) {
      return _bluebird2.default.resolve(true);
    },
    destroy: function destroy() {}
  };
}();

/*
 * Search VFS for files
 */
var FilesystemModule = {
  search: function search(q, args, settings, cb) {
    if (!settings.files || !settings.paths) {
      return _bluebird2.default.resolve([]);
    }

    var found = [];
    var append = function append(result) {
      if (result) {
        found = found.concat(result.map(function (iter) {
          return {
            title: iter.filename,
            description: iter.path,
            icon: _theme2.default.getFileIcon(new _file2.default(iter)),
            launch: { application: '', args: '', file: iter }
          };
        }));
      }
    };

    return new _bluebird2.default(function (resolve, reject) {
      _bluebird2.default.each(settings.paths, function (e) {
        return new _bluebird2.default(function (n) {
          VFS.find(e, { query: q, limit: args.limit ? args.dlimit : 0, recursive: args.recursive }).then(function (result) {
            return n(append(result));
          }).catch(function (error) {
            console.warn(error);
            n();
          });
        });
      }).then(function () {
        return resolve(found);
      }).catch(reject);
    });
  },
  reindex: function reindex(args) {
    return _bluebird2.default.resolve();
  },
  destroy: function destroy() {}
};

/////////////////////////////////////////////////////////////////////////////
// ENGINE
/////////////////////////////////////////////////////////////////////////////

/**
 * Settings Manager Class
 *
 * @desc The Search Engine for location files and application.
 */

var SearchEngine = function () {
  function SearchEngine() {
    _classCallCheck(this, SearchEngine);

    this.settings = {};
    this.inited = false;
    this.modules = [ApplicationModule, FilesystemModule];
  }

  /**
   * Initialize instance
   *
   * @return {Promise<undefined, Error>}
   */


  _createClass(SearchEngine, [{
    key: 'init',
    value: function init() {
      console.debug('SearchEngine::init()');

      if (!this.inited) {
        this.settings = _settingsManager2.default.get('SearchEngine') || {};
        this.inited = true;
      }

      return _bluebird2.default.resolve();
    }

    /**
     * Destroy instance
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      console.debug('SearchEngine::destroy()');

      this.modules.forEach(function (m) {
        m.destroy();
      });

      this.modules = [];
      this.settings = {};
      this.inited = false;
    }

    /**
     * Perform a search
     *
     * @param   {String}      q         Search query
     * @param   {Object}      args      Arguments
     * @return  {Promise<Array, Error>}
     */

  }, {
    key: 'search',
    value: function search(q, args) {
      var _this2 = this;

      var result = [];
      var errors = [];

      args = Object.assign({}, {
        recursive: false,
        limit: 0,
        dlimit: 0
      }, args);

      if (args.limit) {
        args.dlimit = args.limit;
      }

      return new _bluebird2.default(function (resolve, reject) {
        _bluebird2.default.each(_this2.modules, function (module) {
          return new _bluebird2.default(function (next, reject) {

            console.debug('SearchEngine::search()', '=>', module);

            if (!args.limit || args.dlimit > 0) {
              module.search(q, args, _this2.settings).then(function (res) {
                args.dlimit -= res.length;
                result = result.concat(res);

                next();
              }).catch(function (err) {
                console.warn(err);
                errors.push(err instanceof Error ? err.toString() : err);
                next();
              });
            } else {
              next();
              //reject(new Error(errors.join(', ')));
            }
          });
        }).then(function () {
          return resolve(result);
        }).catch(reject);
      });
    }

    /**
     * Reindex databases
     *
     * @TODO implement
     *
     * @param   {Object}      args      Arguments
     * @param   {Function}    cb        Callback => fn(error, result)
     * @return {Promise<Boolean, Error>}
     */

  }, {
    key: 'reindex',
    value: function reindex(args) {
      var errors = [];

      return _bluebird2.default.each(this.modules, function (module) {
        return new _bluebird2.default(function (next) {
          console.debug('SearchEngine::reindex()', '=>', module);

          module.reindex(args).then(next).catch(function (err) {
            if (err) {
              errors.push(err);
            }
            next();
          });
        });
      });
    }

    /**
     * Configure the Search Engine
     *
     * @TODO implement
     *
     * @param   {Object}      opts          Settings Object
     * @param   {Boolean}     [save=true]   Save settings
     */

  }, {
    key: 'configure',
    value: function configure(opts, save) {}
  }]);

  return SearchEngine;
}();

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = new SearchEngine();

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * Splash Screen Class
 * @desc Builds the splash screen
 */
var SplashScreen = function () {
  function SplashScreen() {
    _classCallCheck(this, SplashScreen);

    this.$el = document.getElementById('LoadingScreen');
    this.$progress = this.$el ? this.$el.querySelector('.progress') : null;
  }

  /**
   * Applies the watermark
   * @param {Object} config Configuration tree
   */


  _createClass(SplashScreen, [{
    key: 'watermark',
    value: function watermark(config) {
      if (config.Watermark.enabled) {
        var ver = config.Version || 'unknown version';
        var html = config.Watermark.lines || [];

        var el = document.createElement('osjs-watermark');
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML = html.join('<br />').replace(/%VERSION%/, ver);

        document.body.appendChild(el);
      }
    }

    /**
     * Show the splash
     */

  }, {
    key: 'show',
    value: function show() {
      if (this.$el) {
        this.$el.style.display = 'block';
      }
    }

    /**
     * Hide the splash
     */

  }, {
    key: 'hide',
    value: function hide() {
      if (this.$el) {
        this.$el.style.display = 'none';
      }
    }

    /**
     * Update the splash
     * @param {Number}  p       Step x of...
     * @param {Number}  c       ... y
     */

  }, {
    key: 'update',
    value: function update(p, c) {
      if (this.$progress) {
        var per = c ? 0 : 100;
        if (c) {
          per = p / c * 100;
        }

        this.$progress.style.width = String(per) + '%';
      }
    }
  }]);

  return SplashScreen;
}();

exports.default = new SplashScreen();

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'Alert' dialog
 *
 * @example DialogWindow.create('Alert', {}, fn);
 * @extends DialogWindow
 */
var AlertDialog = function (_DialogWindow) {
  _inherits(AlertDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String}          args.message      Dialog message
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function AlertDialog(args, callback) {
    _classCallCheck(this, AlertDialog);

    args = Object.assign({}, {}, args);

    return _possibleConstructorReturn(this, (AlertDialog.__proto__ || Object.getPrototypeOf(AlertDialog)).call(this, 'AlertDialog', {
      title: args.title || (0, _locales._)('DIALOG_ALERT_TITLE'),
      icon: 'status/dialog-warning.png',
      width: 400,
      height: 100
    }, args, callback));
  }

  _createClass(AlertDialog, [{
    key: 'init',
    value: function init() {
      var root = _get(AlertDialog.prototype.__proto__ || Object.getPrototypeOf(AlertDialog.prototype), 'init', this).apply(this, arguments);

      root.setAttribute('role', 'alertdialog');

      this._find('Message').set('value', this.args.message, true);

      return root;
    }
  }]);

  return AlertDialog;
}(_dialog2.default);

exports.default = AlertDialog;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'Application Chooser' dialog
 *
 * @example DialogWindow.create('ApplicationChooser', {}, fn);
 * @extends DialogWindow
 */
var ApplicationChooserDialog = function (_DialogWindow) {
  _inherits(ApplicationChooserDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String}          args.message      Dialog message
   * @param  {FileMetadata}    args.file         The file to open
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function ApplicationChooserDialog(args, callback) {
    _classCallCheck(this, ApplicationChooserDialog);

    args = Object.assign({}, {}, args);

    return _possibleConstructorReturn(this, (ApplicationChooserDialog.__proto__ || Object.getPrototypeOf(ApplicationChooserDialog)).call(this, 'ApplicationChooserDialog', {
      title: args.title || (0, _locales._)('DIALOG_APPCHOOSER_TITLE'),
      width: 400,
      height: 400
    }, args, callback));
  }

  _createClass(ApplicationChooserDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(ApplicationChooserDialog.prototype.__proto__ || Object.getPrototypeOf(ApplicationChooserDialog.prototype), 'init', this).apply(this, arguments);

      var cols = [{ label: (0, _locales._)('LBL_NAME') }];
      var rows = [];
      var metadata = _packageManager2.default.getPackages();

      (this.args.list || []).forEach(function (name) {
        var iter = metadata[name];

        if (iter && iter.type === 'application') {
          var _label = [iter.name];
          if (iter.description) {
            _label.push(iter.description);
          }
          rows.push({
            value: iter,
            columns: [{ label: _label.join(' - '), icon: _theme2.default.getIcon(iter.icon, null, name), value: JSON.stringify(iter) }]
          });
        }
      });

      this._find('ApplicationList').set('columns', cols).add(rows).on('activate', function (ev) {
        _this2.onClose(ev, 'ok');
      });

      var file = '<unknown file>';
      var label = '<unknown mime>';
      if (this.args.file) {
        file = Utils.format('{0} ({1})', this.args.file.filename, this.args.file.mime);
        label = (0, _locales._)('DIALOG_APPCHOOSER_SET_DEFAULT', this.args.file.mime);
      }

      this._find('FileName').set('value', file);
      this._find('SetDefault').set('label', label);

      return root;
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      var result = null;

      if (button === 'ok') {
        var useDefault = this._find('SetDefault').get('value');
        var selected = this._find('ApplicationList').get('value');

        if (selected && selected.length) {
          result = selected[0].data.className;
        }

        if (!result) {
          _dialog2.default.create('Alert', {
            message: (0, _locales._)('DIALOG_APPCHOOSER_NO_SELECTION')
          }, null, this);

          return;
        }
        result = {
          name: result,
          useDefault: useDefault
        };
      }

      this.closeCallback(ev, button, result);
    }
  }]);

  return ApplicationChooserDialog;
}(_dialog2.default);

exports.default = ApplicationChooserDialog;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _colors = __webpack_require__(199);

var Colors = _interopRequireWildcard(_colors);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


function getColor(rgb) {
  var hex = rgb;

  if (typeof rgb === 'string') {
    hex = rgb;
    rgb = Colors.convertToRGB(rgb);
    rgb.a = null;
  } else {
    if (typeof rgb.a === 'undefined') {
      rgb.a = null;
    } else {
      if (rgb.a > 1.0) {
        rgb.a /= 100;
      }
    }

    rgb = rgb || { r: 0, g: 0, b: 0, a: 100 };
    hex = Colors.convertToHEX(rgb.r, rgb.g, rgb.b);
  }

  return [rgb, hex];
}

/**
 * An 'Color Chooser' dialog
 *
 * @example DialogWindow.create('Color', {}, fn);
 * @extends DialogWindow
 */

var ColorDialog = function (_DialogWindow) {
  _inherits(ColorDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String|Object}   args.color        Either hex string or rbg object
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function ColorDialog(args, callback) {
    _classCallCheck(this, ColorDialog);

    args = Object.assign({}, {}, args);

    var _getColor = getColor(args.color),
        _getColor2 = _slicedToArray(_getColor, 2),
        rgb = _getColor2[0],
        hex = _getColor2[1];

    var _this = _possibleConstructorReturn(this, (ColorDialog.__proto__ || Object.getPrototypeOf(ColorDialog)).call(this, 'ColorDialog', {
      title: args.title || (0, _locales._)('DIALOG_COLOR_TITLE'),
      icon: 'apps/preferences-desktop-theme.png',
      width: 400,
      height: rgb.a !== null ? 300 : 220
    }, args, callback));

    _this.color = { r: rgb.r, g: rgb.g, b: rgb.b, a: rgb.a, hex: hex };
    return _this;
  }

  _createClass(ColorDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(ColorDialog.prototype.__proto__ || Object.getPrototypeOf(ColorDialog.prototype), 'init', this).apply(this, arguments);

      var updateHex = function updateHex(update) {
        _this2._find('LabelRed').set('value', (0, _locales._)('DIALOG_COLOR_R', _this2.color.r));
        _this2._find('LabelGreen').set('value', (0, _locales._)('DIALOG_COLOR_G', _this2.color.g));
        _this2._find('LabelBlue').set('value', (0, _locales._)('DIALOG_COLOR_B', _this2.color.b));
        _this2._find('LabelAlpha').set('value', (0, _locales._)('DIALOG_COLOR_A', _this2.color.a));

        if (update) {
          _this2.color.hex = Colors.convertToHEX(_this2.color.r, _this2.color.g, _this2.color.b);
        }

        var value = _this2.color.hex;
        if (_this2.color.a !== null && !isNaN(_this2.color.a)) {
          value = Utils.format('rgba({0}, {1}, {2}, {3})', _this2.color.r, _this2.color.g, _this2.color.b, _this2.color.a);
        }
        _this2._find('ColorPreview').set('value', value);
      };

      this._find('ColorSelect').on('change', function (ev) {
        _this2.color = ev.detail;
        _this2._find('Red').set('value', _this2.color.r);
        _this2._find('Green').set('value', _this2.color.g);
        _this2._find('Blue').set('value', _this2.color.b);
        updateHex(true);
      });

      this._find('Red').on('change', function (ev) {
        _this2.color.r = parseInt(ev.detail, 10);
        updateHex(true);
      }).set('value', this.color.r);

      this._find('Green').on('change', function (ev) {
        _this2.color.g = parseInt(ev.detail, 10);
        updateHex(true);
      }).set('value', this.color.g);

      this._find('Blue').on('change', function (ev) {
        _this2.color.b = parseInt(ev.detail, 10);
        updateHex(true);
      }).set('value', this.color.b);

      this._find('Alpha').on('change', function (ev) {
        _this2.color.a = parseInt(ev.detail, 10) / 100;
        updateHex(true);
      }).set('value', this.color.a * 100);

      if (this.color.a === null) {
        this._find('AlphaContainer').hide();
        this._find('AlphaLabelContainer').hide();
      }

      updateHex(false, this.color.a !== null);

      return root;
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      this.closeCallback(ev, button, button === 'ok' ? this.color : null);
    }
  }]);

  return ColorDialog;
}(_dialog2.default);

exports.default = ColorDialog;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'Confirm' dialog
 *
 * @example DialogWindow.create('Confirm', {}, fn);
 * @extends DialogWindow
 */
var ConfirmDialog = function (_DialogWindow) {
  _inherits(ConfirmDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String}          args.message      Dialog message
   * @param  {Array}           args.buttons      Dialog buttons (default=yes,no,cancel)
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function ConfirmDialog(args, callback) {
    _classCallCheck(this, ConfirmDialog);

    args = Object.assign({}, {
      buttons: ['yes', 'no', 'cancel']
    }, args);

    return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call(this, 'ConfirmDialog', {
      title: args.title || (0, _locales._)('DIALOG_CONFIRM_TITLE'),
      icon: 'status/dialog-question.png',
      width: 400,
      height: 100
    }, args, callback));
  }

  _createClass(ConfirmDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(ConfirmDialog.prototype.__proto__ || Object.getPrototypeOf(ConfirmDialog.prototype), 'init', this).apply(this, arguments);

      var msg = _dialog2.default.parseMessage(this.args.message);
      this._find('Message').empty().append(msg);

      var buttonMap = {
        yes: 'ButtonYes',
        no: 'ButtonNo',
        cancel: 'ButtonCancel'
      };

      var hide = [];
      ['yes', 'no', 'cancel'].forEach(function (b) {
        if (_this2.args.buttons.indexOf(b) < 0) {
          hide.push(b);
        }
      });

      hide.forEach(function (b) {
        _this2._find(buttonMap[b]).hide();
      });

      return root;
    }
  }]);

  return ConfirmDialog;
}(_dialog2.default);

exports.default = ConfirmDialog;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'Error' dialog
 *
 * @example DialogWindow.create('Error', {}, fn);
 * @extends DialogWindow
 */
var ErrorDialog = function (_DialogWindow) {
  _inherits(ErrorDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String}          args.message      Dialog message
   * @param  {String}          args.error        Error message
   * @param  {Error}           [args.exception]  Exception
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function ErrorDialog(args, callback) {
    _classCallCheck(this, ErrorDialog);

    args = Object.assign({}, {}, args);

    var exception = args.exception || {};

    var error = '';
    if (exception.stack) {
      error = exception.stack;
    } else {
      if (Object.keys(exception).length) {
        error = exception.name;
        error += '\nFilename: ' + exception.fileName || '<unknown>';
        error += '\nLine: ' + exception.lineNumber;
        error += '\nMessage: ' + exception.message;
        if (exception.extMessage) {
          error += '\n' + exception.extMessage;
        }
      }
    }

    var _this = _possibleConstructorReturn(this, (ErrorDialog.__proto__ || Object.getPrototypeOf(ErrorDialog)).call(this, 'ErrorDialog', {
      title: args.title || (0, _locales._)('DIALOG_ERROR_TITLE'),
      icon: 'status/dialog-error.png',
      width: 400,
      height: error ? 400 : 200
    }, args, callback));

    _this._sound = 'ERROR';
    _this._soundVolume = 1.0;

    _this.traceMessage = error;
    return _this;
  }

  _createClass(ErrorDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(ErrorDialog.prototype.__proto__ || Object.getPrototypeOf(ErrorDialog.prototype), 'init', this).apply(this, arguments);
      root.setAttribute('role', 'alertdialog');

      var msg = _dialog2.default.parseMessage(this.args.message);
      this._find('Message').empty().append(msg);
      this._find('Summary').set('value', this.args.error);
      this._find('Trace').set('value', this.traceMessage);
      if (!this.traceMessage) {
        this._find('Trace').hide();
        this._find('TraceLabel').hide();
      }

      if (this.args.bugreport) {
        this._find('ButtonBugReport').on('click', function () {
          var title = '';
          var body = [];

          if ((0, _config.getConfig)('BugReporting.options.issue')) {
            var obj = {};
            var keys = ['userAgent', 'platform', 'language', 'appVersion'];
            keys.forEach(function (k) {
              obj[k] = navigator[k];
            });

            title = (0, _config.getConfig)('BugReporting.options.title');
            body = ['**' + (0, _config.getConfig)('BugReporting.options.message').replace('%VERSION%', (0, _config.getConfig)('Version')) + ':**', '\n', '> ' + _this2.args.message, '\n', '> ' + (_this2.args.error || 'Unknown error'), '\n', '## Expected behaviour', '\n', '## Actual behaviour', '\n', '## Steps to reproduce the error', '\n', '## (Optinal) Browser and OS information', '\n', '```\n' + JSON.stringify(obj) + '\n```'];

            if (_this2.traceMessage) {
              body.push('\n## Stack Trace \n```\n' + _this2.traceMessage + '\n```\n');
            }
          }

          var url = (0, _config.getConfig)('BugReporting.url').replace('%TITLE%', encodeURIComponent(title)).replace('%BODY%', encodeURIComponent(body.join('\n')));

          window.open(url);
        });
      } else {
        this._find('ButtonBugReport').hide();
      }

      return root;
    }
  }]);

  return ErrorDialog;
}(_dialog2.default);

exports.default = ErrorDialog;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'File Information' dialog
 *
 * @example DialogWindow.create('FileInfo', {}, fn);
 * @extends DialogWindow
 */
var FileInfoDialog = function (_DialogWindow) {
  _inherits(FileInfoDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {FileMetadata}    args.file         File to use
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function FileInfoDialog(args, callback) {
    _classCallCheck(this, FileInfoDialog);

    args = Object.assign({}, {}, args);

    var _this = _possibleConstructorReturn(this, (FileInfoDialog.__proto__ || Object.getPrototypeOf(FileInfoDialog)).call(this, 'FileInfoDialog', {
      title: args.title || (0, _locales._)('DIALOG_FILEINFO_TITLE'),
      width: 400,
      height: 400
    }, args, callback));

    if (!_this.args.file) {
      throw new Error('You have to select a file for FileInfo');
    }
    return _this;
  }

  _createClass(FileInfoDialog, [{
    key: 'init',
    value: function init() {
      var root = _get(FileInfoDialog.prototype.__proto__ || Object.getPrototypeOf(FileInfoDialog.prototype), 'init', this).apply(this, arguments);

      var txt = this._find('Info').set('value', (0, _locales._)('LBL_LOADING'));
      var file = this.args.file;

      VFS.fileinfo(file).then(function (data) {
        var info = [];
        Object.keys(data).forEach(function (i) {
          if (i === 'exif') {
            info.push(i + ':\n\n' + data[i]);
          } else {
            info.push(i + ':\n\t' + data[i]);
          }
        });
        txt.set('value', info.join('\n\n'));
        return true;
      }).catch(function (error) {
        txt.set('value', (0, _locales._)('DIALOG_FILEINFO_ERROR_LOOKUP_FMT', file.path));
      });

      return root;
    }
  }]);

  return FileInfoDialog;
}(_dialog2.default);

exports.default = FileInfoDialog;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _mountManager = __webpack_require__(84);

var _mountManager2 = _interopRequireDefault(_mountManager);

var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _fs2 = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs2);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'File' dialog
 *
 * @example DialogWindow.create('File', {}, fn);
 * @extends DialogWindow
 *
 * @param  {Object}           args                      An object with arguments
 * @param  {String}           args.title                Dialog title
 * @param  {String}           [args.type=open]          Dialog type (alternative=save)
 * @param  {Boolean}          [args.multiple=false]     Multiple file selection
 * @param  {FileMetadata}     [args.file]               Current file
 * @param  {String}           [args.path]               Default path
 * @param  {String}           [args.filename]           Default filename
 * @param  {String}           [args.extension]          Default file extension
 * @param  {String}           [args.mime]               Default file MIME
 * @param  {Array}            [args.filter]             Array of MIMIE filters
 * @param  {Array}            [args.mfilter]            Array of function to filter module list
 * @param  {String}           [args.select]             Selection type (file/dir)
 * @param  {CallbackDialog}   callback                  Callback when done
 */
var FileDialog = function (_DialogWindow) {
  _inherits(FileDialog, _DialogWindow);

  function FileDialog(args, callback) {
    _classCallCheck(this, FileDialog);

    args = Object.assign({}, {
      file: null,
      type: 'open',
      path: (0, _config.getDefaultPath)(),
      filename: '',
      filetypes: [],
      extension: '',
      mime: 'application/octet-stream',
      filter: [],
      mfilter: [],
      select: null,
      multiple: false
    }, args);

    args.multiple = args.type === 'save' ? false : args.multiple === true;

    if (args.path && args.path instanceof _file2.default) {
      args.path = FS.dirname(args.path.path);
    }

    if (args.file && args.file.path) {
      args.path = FS.dirname(args.file.path);
      args.filename = args.file.filename;
      args.mime = args.file.mime;

      if (args.filetypes.length) {
        var setTo = args.filetypes[0];
        args.filename = FS.replaceFileExtension(args.filename, setTo.extension);
        args.mime = setTo.mime;
      }
    }

    var title = args.title || (0, _locales._)(args.type === 'save' ? 'DIALOG_FILE_SAVE' : 'DIALOG_FILE_OPEN');
    var icon = args.type === 'open' ? 'actions/document-open.png' : 'actions/documentsave-as.png';

    var _this = _possibleConstructorReturn(this, (FileDialog.__proto__ || Object.getPrototypeOf(FileDialog)).call(this, 'FileDialog', {
      title: title,
      icon: icon,
      width: 600,
      height: 400
    }, args, callback));

    _this.selected = null;
    _this.path = args.path;

    _this.settingsWatch = _settingsManager2.default.watch('VFS', function () {
      _this.changePath();
    });
    return _this;
  }

  _createClass(FileDialog, [{
    key: 'destroy',
    value: function destroy() {
      try {
        _settingsManager2.default.unwatch(this.settingsWatch);
      } catch (e) {}

      return _get(FileDialog.prototype.__proto__ || Object.getPrototypeOf(FileDialog.prototype), 'destroy', this).apply(this, arguments);
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(FileDialog.prototype.__proto__ || Object.getPrototypeOf(FileDialog.prototype), 'init', this).apply(this, arguments);
      var view = this._find('FileView');
      view.set('filter', this.args.filter);
      view.set('filetype', this.args.select || '');
      view.set('defaultcolumns', 'true');

      var filename = this._find('Filename');
      var home = this._find('HomeButton');
      var mlist = this._find('ModuleSelect');

      var checkEmptyInput = function checkEmptyInput() {
        var disable = false;
        if (_this2.args.select !== 'dir') {
          disable = !filename.get('value').length;
        }
        _this2._find('ButtonOK').set('disabled', disable);
      };

      this._toggleLoading(true);
      view.set('multiple', this.args.multiple);
      filename.set('value', this.args.filename || '');

      this._find('ButtonMkdir').on('click', function () {
        _dialog2.default.create('Input', { message: (0, _locales._)('DIALOG_FILE_MKDIR_MSG', _this2.path), value: 'New folder' }, function (ev, btn, value) {
          if (btn === 'ok' && value) {
            var path = FS.pathJoin(_this2.path, value);
            VFS.mkdir(new _file2.default(path, 'dir')).then(function () {
              return _this2.changePath(path);
            }).catch(function (err) {
              OSjs.error((0, _locales._)('DIALOG_FILE_ERROR'), (0, _locales._)('ERR_VFSMODULE_MKDIR'), err);
            });
          }
        }, _this2);
      });

      home.on('click', function () {
        var dpath = (0, _config.getDefaultPath)();
        _this2.changePath(dpath);
      });

      view.on('activate', function (ev) {
        _this2.selected = null;
        if (_this2.args.type !== 'save') {
          filename.set('value', '');
        }

        if (ev && ev.detail && ev.detail.entries) {
          var activated = ev.detail.entries[0];
          if (activated) {
            _this2.selected = new _file2.default(activated.data);
            if (_this2.selected.type !== 'dir') {
              filename.set('value', _this2.selected.filename);
            }
            _this2.checkSelection(ev, true);
          }
        }
      });

      view.on('select', function (ev) {
        _this2.selected = null;
        //filename.set('value', '');

        if (ev && ev.detail && ev.detail.entries) {
          var activated = ev.detail.entries[0];
          if (activated) {
            _this2.selected = new _file2.default(activated.data);

            if (_this2.selected.type !== 'dir') {
              filename.set('value', _this2.selected.filename);
            }
          }
        }

        checkEmptyInput();
      });

      if (this.args.type === 'save') {
        var filetypes = [];
        this.args.filetypes.forEach(function (f) {
          filetypes.push({
            label: Utils.format('{0} (.{1} {2})', f.label, f.extension, f.mime),
            value: f.extension
          });
        });

        var ft = this._find('Filetype').add(filetypes).on('change', function (ev) {
          var newinput = FS.replaceFileExtension(filename.get('value'), ev.detail);
          filename.set('value', newinput);
        });

        if (filetypes.length <= 1) {
          new _element2.default(ft.$element.parentNode).hide();
        }

        filename.on('enter', function (ev) {
          _this2.selected = null;
          _this2.checkSelection(ev);
        });
        filename.on('change', function (ev) {
          checkEmptyInput();
        });
        filename.on('keyup', function (ev) {
          checkEmptyInput();
        });
      } else {

        if (this.args.select !== 'dir') {
          this._find('ButtonMkdir').hide();
        }

        this._find('FileInput').hide();
      }

      var rootPath = _mountManager2.default.getModuleFromPath(this.path).option('root');
      var modules = _mountManager2.default.getModules().filter(function (m) {
        if (!_this2.args.mfilter.length) {
          return true;
        }
        return _this2.args.mfilter.every(function (fn) {
          return fn(m);
        });
      }).map(function (m) {
        return {
          label: m.option('title') + (m.isReadOnly() ? Utils.format(' ({0})', (0, _locales._)('LBL_READONLY')) : ''),
          value: m.option('root')
        };
      });

      mlist.clear().add(modules).set('value', rootPath);
      mlist.on('change', function (ev) {
        _this2.changePath(ev.detail, true);
      });

      this.changePath();

      checkEmptyInput();

      return root;
    }
  }, {
    key: 'changePath',
    value: function changePath(dir, fromDropdown) {
      var _this3 = this;

      var view = this._find('FileView');
      var lastDir = this.path;

      var resetLastSelected = function resetLastSelected() {
        try {
          var rootPath = _mountManager2.default.getModuleFromPath(lastDir).option('root');
          _this3._find('ModuleSelect').set('value', rootPath);
        } catch (e) {
          console.warn('FileDialog::changePath()', 'resetLastSelection()', e);
        }
      };

      this._toggleLoading(true);

      view.chdir({
        path: dir || this.path,
        done: function done(error) {
          if (error) {
            if (fromDropdown) {
              resetLastSelected();
            }
          } else {
            if (dir) {
              _this3.path = dir;
            }
          }

          _this3.selected = null;
          _this3._toggleLoading(false);
        }
      });
    }
  }, {
    key: 'checkFileExtension',
    value: function checkFileExtension() {
      var filename = this._find('Filename');

      var mime = this.args.mime;
      var input = filename.get('value');

      if (this.args.filetypes.length) {
        if (!input && this.args.filename) {
          input = this.args.filename;
        }

        if (input.length) {
          var extension = input.split('.').pop();

          var found = false;
          this.args.filetypes.forEach(function (f) {
            if (f.extension === extension) {
              found = f;
            }
            return !!found;
          });

          found = found || this.args.filetypes[0];
          input = FS.replaceFileExtension(input, found.extension);
          mime = found.mime;
        }
      }

      return {
        filename: input,
        mime: mime
      };
    }
  }, {
    key: 'checkSelection',
    value: function checkSelection(ev, wasActivated) {
      var _this4 = this;

      if (this.selected && this.selected.type === 'dir') {
        if (wasActivated) {
          // this.args.select !== 'dir' &&
          this.changePath(this.selected.path);
          return false;
        }
      }

      if (this.args.type === 'save') {
        var check = this.checkFileExtension();

        if (!this.path || !check.filename) {
          OSjs.error((0, _locales._)('DIALOG_FILE_ERROR'), (0, _locales._)('DIALOG_FILE_MISSING_FILENAME'));
          return false;
        }

        this.selected = new _file2.default(this.path.replace(/^\//, '') + '/' + check.filename, check.mime);
        this._toggleDisabled(true);

        VFS.exists(this.selected).then(function (result) {
          _this4._toggleDisabled(false);
          if (_this4._destroyed) {
            return false;
          }

          if (result) {
            _this4._toggleDisabled(true);

            if (_this4.selected) {
              _dialog2.default.create('Confirm', {
                buttons: ['yes', 'no'],
                message: (0, _locales._)('DIALOG_FILE_OVERWRITE', _this4.selected.filename)
              }, function (ev, button) {
                _this4._toggleDisabled(false);

                if (button === 'yes' || button === 'ok') {
                  _this4.closeCallback(ev, 'ok', _this4.selected);
                }
              }, _this4);
            }
          } else {
            _this4.closeCallback(ev, 'ok', _this4.selected);
          }

          return true;
        }).catch(function (error) {
          _this4._toggleDisabled(false);
          if (_this4._destroyed) {
            return;
          }
          OSjs.error((0, _locales._)('DIALOG_FILE_ERROR'), (0, _locales._)('DIALOG_FILE_MISSING_FILENAME'));
        });

        return false;
      } else {
        if (!this.selected && this.args.select !== 'dir') {
          OSjs.error((0, _locales._)('DIALOG_FILE_ERROR'), (0, _locales._)('DIALOG_FILE_MISSING_SELECTION'));
          return false;
        }

        var res = this.selected;
        if (!res && this.args.select === 'dir') {
          res = new _file2.default({
            filename: FS.filename(this.path),
            path: this.path,
            type: 'dir'
          });
        }

        this.closeCallback(ev, 'ok', res);
      }

      return true;
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      if (button === 'ok' && !this.checkSelection(ev)) {
        return;
      }

      this.closeCallback(ev, button, this.selected);
    }
  }]);

  return FileDialog;
}(_dialog2.default);

exports.default = FileDialog;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'File Progress Indicator' dialog
 *
 * @desc This is only used internally automatically.
 *
 * @example DialogWindow.create('FileProgress', {}, fn);
 * @extends DialogWindow
 */
var FileProgressDialog = function (_DialogWindow) {
  _inherits(FileProgressDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String}          args.message      Dialog message
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function FileProgressDialog(args, callback) {
    _classCallCheck(this, FileProgressDialog);

    args = Object.assign({}, {}, args);

    var _this = _possibleConstructorReturn(this, (FileProgressDialog.__proto__ || Object.getPrototypeOf(FileProgressDialog)).call(this, 'FileProgressDialog', {
      title: args.title || (0, _locales._)('DIALOG_FILEPROGRESS_TITLE'),
      icon: 'actions/document-send.png',
      width: 400,
      height: 100
    }, args, callback));

    _this.busy = !!args.filename;
    return _this;
  }

  _createClass(FileProgressDialog, [{
    key: 'init',
    value: function init() {
      var root = _get(FileProgressDialog.prototype.__proto__ || Object.getPrototypeOf(FileProgressDialog.prototype), 'init', this).apply(this, arguments);
      if (this.args.message) {
        this._find('Message').set('value', this.args.message, true);
      }
      return root;
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      this.closeCallback(ev, button, null);
    }
  }, {
    key: 'setProgress',
    value: function setProgress(p) {
      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var pb = this._find('Progress');
      if (pb) {
        pb.set('progress', p);
      }

      if (close && p >= 100) {
        this._close(true);
      }
    }
  }, {
    key: '_close',
    value: function _close(force) {
      if (!force && this.busy) {
        return false;
      }
      return _get(FileProgressDialog.prototype.__proto__ || Object.getPrototypeOf(FileProgressDialog.prototype), '_close', this).call(this);
    }
  }, {
    key: '_onKeyEvent',
    value: function _onKeyEvent(ev) {
      if (!this.busy) {
        _get(FileProgressDialog.prototype.__proto__ || Object.getPrototypeOf(FileProgressDialog.prototype), '_onKeyEvent', this).apply(this, arguments);
      }
    }
  }]);

  return FileProgressDialog;
}(_dialog2.default);

exports.default = FileProgressDialog;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'FileUpload' dialog
 *
 * @example DialogWindow.create('FileUpload', {}, fn);
 * @extends DialogWindow
 */
var FileUploadDialog = function (_DialogWindow) {
  _inherits(FileUploadDialog, _DialogWindow);

  /**
   * @param  {Object}          args              An object with arguments
   * @param  {String}          args.title        Dialog title
   * @param  {String}          args.dest         VFS destination
   * @param  {FileMetadata}    [args.file]       File to upload
   * @param  {CallbackDialog}  callback          Callback when done
   */
  function FileUploadDialog(args, callback) {
    _classCallCheck(this, FileUploadDialog);

    args = Object.assign({}, {
      dest: (0, _config.getDefaultPath)(),
      progress: {},
      file: null
    }, args);

    if (args.destination) {
      args.dest = args.destination;
    }
    if (!args.dest) {
      args.dest = (0, _config.getDefaultPath)();
    }

    return _possibleConstructorReturn(this, (FileUploadDialog.__proto__ || Object.getPrototypeOf(FileUploadDialog)).call(this, 'FileUploadDialog', {
      title: args.title || (0, _locales._)('DIALOG_UPLOAD_TITLE'),
      icon: 'actions/document-new.png',
      width: 400,
      height: 100
    }, args, callback));
  }

  _createClass(FileUploadDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(FileUploadDialog.prototype.__proto__ || Object.getPrototypeOf(FileUploadDialog.prototype), 'init', this).apply(this, arguments);
      var message = this._find('Message');
      var maxSize = (0, _config.getConfig)('VFS.MaxUploadSize');

      message.set('value', (0, _locales._)('DIALOG_UPLOAD_DESC', this.args.dest, maxSize), true);

      var input = this._find('File');
      if (this.args.file) {
        this.setFile(this.args.file, input);
      } else {
        input.on('change', function (ev) {
          _this2.setFile(ev.detail, input);
        });
      }

      return root;
    }
  }, {
    key: 'setFile',
    value: function setFile(file, input) {
      var _this3 = this;

      var progressDialog = void 0;

      var error = function error(msg, ev) {
        OSjs.error((0, _locales._)('DIALOG_UPLOAD_FAILED'), (0, _locales._)('DIALOG_UPLOAD_FAILED_MSG'), msg || (0, _locales._)('DIALOG_UPLOAD_FAILED_UNKNOWN'));

        progressDialog._close(true);
        _this3.onClose(ev, 'cancel');
      };

      if (file) {
        var fileSize = 0;
        if (file.size > 1024 * 1024) {
          fileSize = (Math.round(file.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
        } else {
          fileSize = (Math.round(file.size * 100 / 1024) / 100).toString() + 'KB';
        }

        if (input) {
          input.set('disabled', true);
        }

        this._find('ButtonCancel').set('disabled', true);

        var desc = (0, _locales._)('DIALOG_UPLOAD_MSG_FMT', file.name, file.type, fileSize, this.args.dest);

        progressDialog = _dialog2.default.create('FileProgress', {
          message: desc,
          dest: this.args.dest,
          filename: file.name,
          mime: file.type,
          size: fileSize
        }, function (ev, button) {
          // Dialog closed
        }, this);

        VFS.upload({ files: [file], destination: this.args.dest }, {
          onprogress: function onprogress(ev) {
            if (ev.lengthComputable) {
              var p = Math.round(ev.loaded * 100 / ev.total);
              progressDialog.setProgress(p);
            }
          }
        }).then(function () {
          progressDialog._close(true);
          return _this3.onClose(null, 'ok', file);
        }).catch(error);

        setTimeout(function () {
          if (progressDialog) {
            progressDialog._focus();
          }
        }, 100);
      }
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button, result) {
      result = result || null;
      this.closeCallback(ev, button, result);
    }
  }]);

  return FileUploadDialog;
}(_dialog2.default);

exports.default = FileUploadDialog;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'Font Selection' dialog
 *
 * @example DialogWindow.create('Font', {}, fn);
 * @extends DialogWindow
 */
var FontDialog = function (_DialogWindow) {
  _inherits(FontDialog, _DialogWindow);

  /**
   * @param  {Object}          args                                An object with arguments
   * @param  {String}          args.title                          Dialog title
   * @param  {String}          [args.fontName=internal]            Current font name
   * @param  {Number}          [args.fontSize=12]                  Current font size
   * @param  {String}          [args.fontColor=#00000]             Font color
   * @param  {String}          [args.backgroundColor=#ffffff]      Background color
   * @param  {Array}           [args.fonts]                        Default font list
   * @param  {Number}          [args.minSize=6]                    Minimun size
   * @param  {Number}          [args.maxSize=30]                   Maximum size
   * @param  {String}          [args.text]                         Preview text
   * @param  {String}          [args.unit=px]                      Size unit
   * @param  {CallbackDialog}  callback                            Callback when done
   */
  function FontDialog(args, callback) {
    _classCallCheck(this, FontDialog);

    args = Object.assign({}, {
      fontName: (0, _config.getConfig)('Fonts.default'),
      fontSize: 12,
      fontColor: '#000000',
      backgroundColor: '#ffffff',
      fonts: (0, _config.getConfig)('Fonts.list'),
      minSize: 6,
      maxSize: 30,
      text: 'The quick brown fox jumps over the lazy dog',
      unit: 'px'
    }, args);

    if (args.unit === 'null' || args.unit === 'unit') {
      args.unit = '';
    }

    var _this = _possibleConstructorReturn(this, (FontDialog.__proto__ || Object.getPrototypeOf(FontDialog)).call(this, 'FontDialog', {
      title: args.title || (0, _locales._)('DIALOG_FONT_TITLE'),
      width: 400,
      height: 300
    }, args, callback));

    _this.selection = {
      fontName: args.fontName,
      fontSize: args.fontSize + args.unit
    };
    return _this;
  }

  _createClass(FontDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(FontDialog.prototype.__proto__ || Object.getPrototypeOf(FontDialog.prototype), 'init', this).apply(this, arguments);

      var preview = this._find('FontPreview');
      var sizes = [];
      var fonts = [];

      for (var i = this.args.minSize; i < this.args.maxSize; i++) {
        sizes.push({ value: i, label: i });
      }
      for (var j = 0; j < this.args.fonts.length; j++) {
        fonts.push({ value: this.args.fonts[j], label: this.args.fonts[j] });
      }

      var updatePreview = function updatePreview() {
        preview.querySelector('textarea').style.fontFamily = _this2.selection.fontName;
        preview.querySelector('textarea').style.fontSize = _this2.selection.fontSize;
      };

      var listFonts = this._find('FontName');
      listFonts.add(fonts).set('value', this.args.fontName);
      listFonts.on('change', function (ev) {
        _this2.selection.fontName = ev.detail;
        updatePreview();
      });

      var listSizes = this._find('FontSize');
      listSizes.add(sizes).set('value', this.args.fontSize);
      listSizes.on('change', function (ev) {
        _this2.selection.fontSize = ev.detail + _this2.args.unit;
        updatePreview();
      });

      preview.$element.style.color = this.args.fontColor;
      preview.$element.style.backgroundColor = this.args.backgroundColor;
      preview.set('value', this.args.text);

      if (this.args.fontSize < 0) {
        this._find('FontSizeContainer').hide();
      }

      updatePreview();

      return root;
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      var result = button === 'ok' ? this.selection : null;
      this.closeCallback(ev, button, result);
    }
  }]);

  return FontDialog;
}(_dialog2.default);

exports.default = FontDialog;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * An 'Input' dialog
 *
 * @example DialogWindow.create('Input', {}, fn);
 * @extends DialogWindow
 */
var InputDialog = function (_DialogWindow) {
  _inherits(InputDialog, _DialogWindow);

  /**
   * @param  {Object}          args                An object with arguments
   * @param  {String}          args.title          Dialog title
   * @param  {String}          args.message        Dialog message
   * @param  {String}          [args.value]        Input value
   * @param  {String}          [args.placeholder]  Input placeholder
   * @param  {CallbackDialog}  callback            Callback when done
   */
  function InputDialog(args, callback) {
    _classCallCheck(this, InputDialog);

    args = Object.assign({}, {}, args);

    return _possibleConstructorReturn(this, (InputDialog.__proto__ || Object.getPrototypeOf(InputDialog)).call(this, 'InputDialog', {
      title: args.title || (0, _locales._)('DIALOG_INPUT_TITLE'),
      icon: 'status/dialog-information.png',
      width: 400,
      height: 120
    }, args, callback));
  }

  _createClass(InputDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var root = _get(InputDialog.prototype.__proto__ || Object.getPrototypeOf(InputDialog.prototype), 'init', this).apply(this, arguments);

      if (this.args.message) {
        var msg = _dialog2.default.parseMessage(this.args.message);
        this._find('Message').empty().append(msg);
      }

      var input = this._find('Input');
      input.set('placeholder', this.args.placeholder || '');
      input.set('value', this.args.value || '');
      input.on('enter', function (ev) {
        _this2.onClose(ev, 'ok');
      });

      return root;
    }
  }, {
    key: '_focus',
    value: function _focus() {
      if (_get(InputDialog.prototype.__proto__ || Object.getPrototypeOf(InputDialog.prototype), '_focus', this).apply(this, arguments)) {
        this._find('Input').focus();
        return true;
      }
      return false;
    }
  }, {
    key: 'onClose',
    value: function onClose(ev, button) {
      var result = this._find('Input').get('value');
      this.closeCallback(ev, button, button === 'ok' ? result : null);
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var input = this._find('Input');
      if (input.$element) {
        input.$element.querySelector('input').select(range);
      }
    }
  }]);

  return InputDialog;
}(_dialog2.default);

exports.default = InputDialog;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authenticator = __webpack_require__(119);

var _authenticator2 = _interopRequireDefault(_authenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Database Authentication Handler
 * @extends Authenticator
 */
var DatabaseAuthenticator = function (_Authenticator) {
  _inherits(DatabaseAuthenticator, _Authenticator);

  function DatabaseAuthenticator() {
    _classCallCheck(this, DatabaseAuthenticator);

    return _possibleConstructorReturn(this, (DatabaseAuthenticator.__proto__ || Object.getPrototypeOf(DatabaseAuthenticator)).apply(this, arguments));
  }

  return DatabaseAuthenticator;
}(_authenticator2.default);

exports.default = DatabaseAuthenticator;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authenticator = __webpack_require__(119);

var _authenticator2 = _interopRequireDefault(_authenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * PAM Authentication Handler
 * @extends Authenticator
 */
var PAMAuthenticator = function (_Authenticator) {
  _inherits(PAMAuthenticator, _Authenticator);

  function PAMAuthenticator() {
    _classCallCheck(this, PAMAuthenticator);

    return _possibleConstructorReturn(this, (PAMAuthenticator.__proto__ || Object.getPrototypeOf(PAMAuthenticator)).apply(this, arguments));
  }

  return PAMAuthenticator;
}(_authenticator2.default);

exports.default = PAMAuthenticator;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _demo = __webpack_require__(200);

var _demo2 = _interopRequireDefault(_demo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Default Standalone Authenticator
 * @extends DemoAuthenticator
 */
var StandaloneAuthenticator = function (_DemoAuthenticator) {
  _inherits(StandaloneAuthenticator, _DemoAuthenticator);

  function StandaloneAuthenticator() {
    _classCallCheck(this, StandaloneAuthenticator);

    var _this = _possibleConstructorReturn(this, (StandaloneAuthenticator.__proto__ || Object.getPrototypeOf(StandaloneAuthenticator)).call(this));

    _this.isStandalone = true;
    return _this;
  }

  _createClass(StandaloneAuthenticator, [{
    key: 'login',
    value: function login(_login) {
      return _bluebird2.default.resolve({
        userData: {
          id: 1,
          username: 'root',
          name: 'Administrator User',
          groups: ['admin']
        },
        userSettings: this._getSettings(),
        blacklistedPackages: []
      });
    }
  }]);

  return StandaloneAuthenticator;
}(_demo2.default);

exports.default = StandaloneAuthenticator;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _http = __webpack_require__(201);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Standalone Connection Handler
 * @extends HttpConnection
 */
var StandaloneConnection = function (_HttpConnection) {
  _inherits(StandaloneConnection, _HttpConnection);

  function StandaloneConnection() {
    _classCallCheck(this, StandaloneConnection);

    return _possibleConstructorReturn(this, (StandaloneConnection.__proto__ || Object.getPrototypeOf(StandaloneConnection)).apply(this, arguments));
  }

  _createClass(StandaloneConnection, [{
    key: 'createRequest',
    value: function createRequest(method, args, options) {
      if (method === 'packages') {
        return _bluebird2.default.resolve({ result: OSjs.getManifest() });
      }
      return _bluebird2.default.reject(new Error('You are currently running locally and cannot perform this operation!'));
    }
  }]);

  return StandaloneConnection;
}(_http2.default);

exports.default = StandaloneConnection;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _config = __webpack_require__(15);

var _locales = __webpack_require__(10);

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _connection = __webpack_require__(53);

var _connection2 = _interopRequireDefault(_connection);

var _bluebird = __webpack_require__(16);

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * WebSocket Connection Handler
 * @xtends Connection
 */
var WSConnection = function (_Connection) {
  _inherits(WSConnection, _Connection);

  function WSConnection() {
    _classCallCheck(this, WSConnection);

    var _this = _possibleConstructorReturn(this, (WSConnection.__proto__ || Object.getPrototypeOf(WSConnection)).apply(this, arguments));

    var port = (0, _config.getConfig)('Connection.WSPort');
    var path = (0, _config.getConfig)('Connection.WSPath') || '';

    var url = window.location.protocol.replace('http', 'ws') + '//' + window.location.host;
    if (port !== 'upgrade') {
      if (url.match(/:\d+$/)) {
        url = url.replace(/:\d+$/, '');
      }
      url += ':' + port;
    }
    url += path;

    _this.ws = null;
    _this.wsurl = url;
    _this.wsqueue = {};
    _this.destroying = false;
    return _this;
  }

  _createClass(WSConnection, [{
    key: 'destroy',
    value: function destroy() {
      if (!this.destroying) {
        if (this.ws) {
          this.ws.close();
        }

        this.ws = null;
        this.wsqueue = {};
      }

      this.destroying = true;

      return _get(WSConnection.prototype.__proto__ || Object.getPrototypeOf(WSConnection.prototype), 'destroy', this).apply(this, arguments);
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.destroying = false;

      return new _bluebird2.default(function (resolve, reject) {
        _this2._connect(false, function (err, res) {
          if (err) {
            reject(err instanceof Error ? err : new Error(err));
          } else {
            resolve(res);
          }
        });
      });
    }
  }, {
    key: '_connect',
    value: function _connect(reconnect, callback) {
      var _this3 = this;

      if (this.destroying || this.ws && !reconnect) {
        return;
      }

      console.info('Trying WebSocket Connection', this.wsurl);

      var connected = false;

      this.ws = new WebSocket(this.wsurl);

      this.ws.onopen = function (ev) {
        connected = true;
        // NOTE: For some reason it needs to be fired on next tick
        setTimeout(function () {
          return callback(false);
        }, 0);
      };

      this.ws.onmessage = function (ev) {
        console.debug('websocket open', ev);
        var data = JSON.parse(ev.data);
        var idx = data._index;
        _this3._onmessage(idx, data);
      };

      this.ws.onerror = function (ev) {
        console.error('websocket error', ev);
      };

      this.ws.onclose = function (ev) {
        console.debug('websocket close', ev);
        if (!connected && ev.code !== 3001) {
          callback((0, _locales._)('CONNECTION_ERROR'));
          return;
        }
        _this3._onclose();
      };
    }
  }, {
    key: '_onmessage',
    value: function _onmessage(idx, data) {
      if (typeof idx === 'undefined') {
        this.message(data);
      } else {
        if (this.wsqueue[idx]) {
          delete data._index;

          this.wsqueue[idx](false, data);

          delete this.wsqueue[idx];
        }
      }
    }
  }, {
    key: '_onclose',
    value: function _onclose(reconnecting) {
      var _this4 = this;

      if (this.destroying) {
        return;
      }

      this.onOffline(reconnecting);

      this.ws = null;

      setTimeout(function () {
        _this4._connect(true, function (err) {
          if (err) {
            _this4._onclose((reconnecting || 0) + 1);
          } else {
            _this4.onOnline();
          }
        });
      }, reconnecting ? 10000 : 1000);
    }
  }, {
    key: 'message',
    value: function message(data) {
      // Emit a VFS event when a change occures
      if (data.action === 'vfs:watch') {
        VFS.triggerWatch(data.args.event, new _file2.default(data.args.file));
      }

      // Emit a subscription event
      if (this._evHandler) {
        this._evHandler.emit(data.action, data.args);
      }
    }
  }, {
    key: 'createRequest',
    value: function createRequest(method, args, options) {
      var _this5 = this;

      if (!this.ws) {
        return _bluebird2.default.reject(new Error('No websocket connection'));
      }

      if (['FS:upload', 'FS:get', 'logout'].indexOf(method) !== -1) {
        return _get(WSConnection.prototype.__proto__ || Object.getPrototypeOf(WSConnection.prototype), 'createRequest', this).apply(this, arguments);
      }

      var idx = this.index++;
      var base = method.match(/^FS:/) ? '/FS/' : '/API/';

      try {
        this.ws.send(JSON.stringify({
          _index: idx,
          path: base + method.replace(/^FS:/, ''),
          args: args
        }));
      } catch (e) {
        return _bluebird2.default.reject(e);
      }

      return new _bluebird2.default(function (resolve, reject) {
        _this5.wsqueue[idx] = function (err, res) {
          return err ? reject(err) : resolve(res);
        };
      });
    }
  }]);

  return WSConnection;
}(_connection2.default);

exports.default = WSConnection;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = __webpack_require__(118);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Database Storage Handler
 * @xtends Storage
 */
var DatabaseStorage = function (_Storage) {
  _inherits(DatabaseStorage, _Storage);

  function DatabaseStorage() {
    _classCallCheck(this, DatabaseStorage);

    return _possibleConstructorReturn(this, (DatabaseStorage.__proto__ || Object.getPrototypeOf(DatabaseStorage)).apply(this, arguments));
  }

  return DatabaseStorage;
}(_storage2.default);

exports.default = DatabaseStorage;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _demo = __webpack_require__(202);

var _demo2 = _interopRequireDefault(_demo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var StandaloneStorage = function (_DemoStorage) {
  _inherits(StandaloneStorage, _DemoStorage);

  function StandaloneStorage() {
    _classCallCheck(this, StandaloneStorage);

    return _possibleConstructorReturn(this, (StandaloneStorage.__proto__ || Object.getPrototypeOf(StandaloneStorage)).apply(this, arguments));
  }

  return StandaloneStorage;
}(_demo2.default);

exports.default = StandaloneStorage;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = __webpack_require__(118);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * System Storage Handler
 * @xtends Storage
 */
var SystemStorage = function (_Storage) {
  _inherits(SystemStorage, _Storage);

  function SystemStorage() {
    _classCallCheck(this, SystemStorage);

    return _possibleConstructorReturn(this, (SystemStorage.__proto__ || Object.getPrototypeOf(SystemStorage)).apply(this, arguments));
  }

  return SystemStorage;
}(_storage2.default);

exports.default = SystemStorage;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


function toggleState(el, expanded) {
  if (typeof expanded === 'undefined') {
    expanded = el.getAttribute('data-expanded') !== 'false';
    expanded = !expanded;
  }

  el.setAttribute('aria-expanded', String(expanded));
  el.setAttribute('data-expanded', String(expanded));
  return expanded;
}

/////////////////////////////////////////////////////////////////////////////
// CLASSES
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-paned-view'
 *
 * A view with resizable content boxes
 */

var GUIPanedView = function (_GUIElement) {
  _inherits(GUIPanedView, _GUIElement);

  function GUIPanedView() {
    _classCallCheck(this, GUIPanedView);

    return _possibleConstructorReturn(this, (GUIPanedView.__proto__ || Object.getPrototypeOf(GUIPanedView)).apply(this, arguments));
  }

  _createClass(GUIPanedView, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var el = this.$element;
      if (evName === 'resize') {
        evName = '_' + evName;
      }
      Events.$bind(el, evName, callback.bind(this), params);

      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var orient = el.getAttribute('data-orientation') || 'horizontal';

      function bindResizer(resizer, idx, cel) {
        var resizeEl = resizer.previousElementSibling;
        if (!resizeEl) {
          return;
        }

        var startWidth = resizeEl.offsetWidth;
        var startHeight = resizeEl.offsetHeight;
        var minSize = 16;
        var maxSize = Number.MAX_VALUE;

        GUI.createDrag(resizer, function (ev) {
          startWidth = resizeEl.offsetWidth;
          startHeight = resizeEl.offsetHeight;
          minSize = parseInt(cel.getAttribute('data-min-size'), 10) || minSize;

          var max = parseInt(cel.getAttribute('data-max-size'), 10);
          if (!max) {
            var totalSize = resizer.parentNode[orient === 'horizontal' ? 'offsetWidth' : 'offsetHeight'];
            var totalContainers = resizer.parentNode.querySelectorAll('gui-paned-view-container').length;
            var totalSpacers = resizer.parentNode.querySelectorAll('gui-paned-view-handle').length;

            maxSize = totalSize - totalContainers * 16 - totalSpacers * 8;
          }
        }, function (ev, diff) {
          var newWidth = startWidth + diff.x;
          var newHeight = startHeight + diff.y;

          var flex = void 0;
          if (orient === 'horizontal') {
            if (!isNaN(newWidth) && newWidth > 0 && newWidth >= minSize && newWidth <= maxSize) {
              flex = newWidth.toString() + 'px';
            }
          } else {
            if (!isNaN(newHeight) && newHeight > 0 && newHeight >= minSize && newHeight <= maxSize) {
              flex = newHeight.toString() + 'px';
            }
          }

          if (flex) {
            resizeEl.style.webkitFlexBasis = flex;
            resizeEl.style.mozFflexBasis = flex;
            resizeEl.style.msFflexBasis = flex;
            resizeEl.style.oFlexBasis = flex;
            resizeEl.style.flexBasis = flex;
          }
        }, function (ev) {
          el.dispatchEvent(new CustomEvent('_resize', { detail: { index: idx } }));
        });
      }

      el.querySelectorAll('gui-paned-view-container').forEach(function (cel, idx) {
        if (idx % 2) {
          var resizer = document.createElement('gui-paned-view-handle');
          resizer.setAttribute('role', 'separator');
          cel.parentNode.insertBefore(resizer, cel);
          bindResizer(resizer, idx, cel);
        }
      });

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIPanedView.__proto__ || Object.getPrototypeOf(GUIPanedView), 'register', this).call(this, {
        tagName: 'gui-paned-view',
        type: 'container',
        allowedChildren: ['gui-paned-view-container']
      }, this);
    }
  }]);

  return GUIPanedView;
}(_element2.default);

/**
 * Element: 'gui-paned-view-container'
 *
 * <pre><code>
 *   property  base      String        CSS base flexbox property
 *   property  grow      integer       CSS grow flexbox property
 *   property  shrink    integer       CSS shrink flexbox property
 *   property  min-size  integer       Minimum size in pixels
 *   property  max-size  integer       Maxmimum size in pixels
 * </code></pre>
 */


var GUIPanedViewContainer = function (_GUIElement2) {
  _inherits(GUIPanedViewContainer, _GUIElement2);

  function GUIPanedViewContainer() {
    _classCallCheck(this, GUIPanedViewContainer);

    return _possibleConstructorReturn(this, (GUIPanedViewContainer.__proto__ || Object.getPrototypeOf(GUIPanedViewContainer)).apply(this, arguments));
  }

  _createClass(GUIPanedViewContainer, [{
    key: 'build',
    value: function build() {
      GUI.setFlexbox(this.$element);
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIPanedViewContainer.__proto__ || Object.getPrototypeOf(GUIPanedViewContainer), 'register', this).call(this, {
        tagName: 'gui-paned-view-container',
        type: 'container',
        allowedParents: ['gui-paned-view']
      }, this);
    }
  }]);

  return GUIPanedViewContainer;
}(_element2.default);

/**
 * Element: 'gui-button-bar'
 */


var GUIButtonBar = function (_GUIElement3) {
  _inherits(GUIButtonBar, _GUIElement3);

  function GUIButtonBar() {
    _classCallCheck(this, GUIButtonBar);

    return _possibleConstructorReturn(this, (GUIButtonBar.__proto__ || Object.getPrototypeOf(GUIButtonBar)).apply(this, arguments));
  }

  _createClass(GUIButtonBar, [{
    key: 'build',
    value: function build() {
      this.$element.setAttribute('role', 'toolbar');
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIButtonBar.__proto__ || Object.getPrototypeOf(GUIButtonBar), 'register', this).call(this, {
        tagName: 'gui-button-bar',
        type: 'container'
      }, this);
    }
  }]);

  return GUIButtonBar;
}(_element2.default);

/**
 * Element: 'gui-toolbar'
 */


var GUIToolBar = function (_GUIElement4) {
  _inherits(GUIToolBar, _GUIElement4);

  function GUIToolBar() {
    _classCallCheck(this, GUIToolBar);

    return _possibleConstructorReturn(this, (GUIToolBar.__proto__ || Object.getPrototypeOf(GUIToolBar)).apply(this, arguments));
  }

  _createClass(GUIToolBar, [{
    key: 'build',
    value: function build() {
      this.$element.setAttribute('role', 'toolbar');
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIToolBar.__proto__ || Object.getPrototypeOf(GUIToolBar), 'register', this).call(this, {
        tagName: 'gui-toolbar',
        type: 'container'
      }, this);
    }
  }]);

  return GUIToolBar;
}(_element2.default);

/**
 * Element: 'gui-grid'
 *
 * A grid-type container with equal-sized containers
 */


var GUIGrid = function (_GUIElement5) {
  _inherits(GUIGrid, _GUIElement5);

  function GUIGrid() {
    _classCallCheck(this, GUIGrid);

    return _possibleConstructorReturn(this, (GUIGrid.__proto__ || Object.getPrototypeOf(GUIGrid)).apply(this, arguments));
  }

  _createClass(GUIGrid, [{
    key: 'build',
    value: function build() {
      var rows = this.$element.querySelectorAll('gui-grid-row');
      var p = 100 / rows.length;

      rows.forEach(function (r) {
        r.style.height = String(p) + '%';
      });

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIGrid.__proto__ || Object.getPrototypeOf(GUIGrid), 'register', this).call(this, {
        tagName: 'gui-grid',
        type: 'container',
        allowedChildren: ['gui-grid-row']
      }, this);
    }
  }]);

  return GUIGrid;
}(_element2.default);

/**
 * Element: 'gui-grid-row'
 */


var GUIGridRow = function (_GUIElement6) {
  _inherits(GUIGridRow, _GUIElement6);

  function GUIGridRow() {
    _classCallCheck(this, GUIGridRow);

    return _possibleConstructorReturn(this, (GUIGridRow.__proto__ || Object.getPrototypeOf(GUIGridRow)).apply(this, arguments));
  }

  _createClass(GUIGridRow, null, [{
    key: 'register',
    value: function register() {
      return _get(GUIGridRow.__proto__ || Object.getPrototypeOf(GUIGridRow), 'register', this).call(this, {
        tagName: 'gui-grid-row',
        type: 'container',
        allowedChildren: ['gui-grid-entry'],
        allowedParents: ['gui-grid-row']
      }, this);
    }
  }]);

  return GUIGridRow;
}(_element2.default);

/**
 * Element: 'gui-grid-entry'
 */


var GUIGridEntry = function (_GUIElement7) {
  _inherits(GUIGridEntry, _GUIElement7);

  function GUIGridEntry() {
    _classCallCheck(this, GUIGridEntry);

    return _possibleConstructorReturn(this, (GUIGridEntry.__proto__ || Object.getPrototypeOf(GUIGridEntry)).apply(this, arguments));
  }

  _createClass(GUIGridEntry, null, [{
    key: 'register',
    value: function register() {
      return _get(GUIGridEntry.__proto__ || Object.getPrototypeOf(GUIGridEntry), 'register', this).call(this, {
        tagName: 'gui-grid-entry',
        type: 'container',
        allowedParents: ['gui-grid-row']
      }, this);
    }
  }]);

  return GUIGridEntry;
}(_element2.default);

/**
 * Element: 'gui-vbox'
 *
 * Vertical boxed layout
 */


var GUIVBox = function (_GUIElement8) {
  _inherits(GUIVBox, _GUIElement8);

  function GUIVBox() {
    _classCallCheck(this, GUIVBox);

    return _possibleConstructorReturn(this, (GUIVBox.__proto__ || Object.getPrototypeOf(GUIVBox)).apply(this, arguments));
  }

  _createClass(GUIVBox, null, [{
    key: 'register',
    value: function register() {
      return _get(GUIVBox.__proto__ || Object.getPrototypeOf(GUIVBox), 'register', this).call(this, {
        tagName: 'gui-vbox',
        type: 'container',
        allowedChildren: ['gui-vbox-container']
      }, this);
    }
  }]);

  return GUIVBox;
}(_element2.default);

/**
 * Element: 'gui-vbox-container'
 *
 * Vertical boxed layout container
 *
 * <pre><code>
 *   property  base      String        CSS base flexbox property
 *   property  grow      integer       CSS grow flexbox property
 *   property  shrink    integer       CSS shrink flexbox property
 *   property  expand    boolean       Make content expand to full width
 *   property  fill      boolean       Make content fill up entire space
 * </code></pre>
 */


var GUIVBoxContainer = function (_GUIElement9) {
  _inherits(GUIVBoxContainer, _GUIElement9);

  function GUIVBoxContainer() {
    _classCallCheck(this, GUIVBoxContainer);

    return _possibleConstructorReturn(this, (GUIVBoxContainer.__proto__ || Object.getPrototypeOf(GUIVBoxContainer)).apply(this, arguments));
  }

  _createClass(GUIVBoxContainer, [{
    key: 'build',
    value: function build() {
      GUI.setFlexbox(this.$element);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIVBoxContainer.__proto__ || Object.getPrototypeOf(GUIVBoxContainer), 'register', this).call(this, {
        tagName: 'gui-vbox-container',
        type: 'container',
        allowedParents: ['gui-vbox']
      }, this);
    }
  }]);

  return GUIVBoxContainer;
}(_element2.default);

/**
 * Element: 'gui-hbox'
 *
 * Horizontal boxed layout
 */


var GUIHBox = function (_GUIElement10) {
  _inherits(GUIHBox, _GUIElement10);

  function GUIHBox() {
    _classCallCheck(this, GUIHBox);

    return _possibleConstructorReturn(this, (GUIHBox.__proto__ || Object.getPrototypeOf(GUIHBox)).apply(this, arguments));
  }

  _createClass(GUIHBox, null, [{
    key: 'register',
    value: function register() {
      return _get(GUIHBox.__proto__ || Object.getPrototypeOf(GUIHBox), 'register', this).call(this, {
        tagName: 'gui-hbox',
        type: 'container',
        allowedChildren: ['gui-hbox-container']
      }, this);
    }
  }]);

  return GUIHBox;
}(_element2.default);

/**
 * Element: 'gui-hbox-container'
 *
 * Horizontal boxed layout container
 *
 * <pre><code>
 *   property  base      String        CSS base flexbox property
 *   property  grow      integer       CSS grow flexbox property
 *   property  shrink    integer       CSS shrink flexbox property
 *   property  expand    boolean       Make content expand to full width
 *   property  fill      boolean       Make content fill up entire space
 * </code></pre>
 */


var GUIHBoxContainer = function (_GUIElement11) {
  _inherits(GUIHBoxContainer, _GUIElement11);

  function GUIHBoxContainer() {
    _classCallCheck(this, GUIHBoxContainer);

    return _possibleConstructorReturn(this, (GUIHBoxContainer.__proto__ || Object.getPrototypeOf(GUIHBoxContainer)).apply(this, arguments));
  }

  _createClass(GUIHBoxContainer, [{
    key: 'build',
    value: function build() {
      GUI.setFlexbox(this.$element);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIHBoxContainer.__proto__ || Object.getPrototypeOf(GUIHBoxContainer), 'register', this).call(this, {
        tagName: 'gui-hbox-container',
        type: 'container',
        allowedParents: ['gui-hbox']
      }, this);
    }
  }]);

  return GUIHBoxContainer;
}(_element2.default);

/**
 * Element: 'gui-expander'
 *
 * A expandable/collapsable container with label and indicator
 *
 * <pre><code>
 *   property  label     String        The label
 *   property  expanded  boolean       Expanded state (default=true)
 * </code></pre>
 */

var GUIExpander = function (_GUIElement12) {
  _inherits(GUIExpander, _GUIElement12);

  function GUIExpander() {
    _classCallCheck(this, GUIExpander);

    return _possibleConstructorReturn(this, (GUIExpander.__proto__ || Object.getPrototypeOf(GUIExpander)).apply(this, arguments));
  }

  _createClass(GUIExpander, [{
    key: 'set',
    value: function set(param, value) {
      if (param === 'expanded') {
        return toggleState(this.$element, value === true);
      }
      return _get(GUIExpander.prototype.__proto__ || Object.getPrototypeOf(GUIExpander.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'on',
    value: function on(evName, callback, params) {
      if (['change'].indexOf(evName) !== -1) {
        evName = '_' + evName;
      }
      Events.$bind(this.$element, evName, callback.bind(this), params);

      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var lbltxt = el.getAttribute('data-label') || '';
      var label = document.createElement('gui-expander-label');

      Events.$bind(label, 'pointerdown', function (ev) {
        el.dispatchEvent(new CustomEvent('_change', { detail: { expanded: toggleState(el) } }));
      }, false);

      label.appendChild(document.createTextNode(lbltxt));

      el.setAttribute('role', 'toolbar');
      el.setAttribute('aria-expanded', 'true');
      el.setAttribute('data-expanded', 'true');
      if (el.children.length) {
        el.insertBefore(label, el.children[0]);
      } else {
        el.appendChild(label);
      }

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIExpander.__proto__ || Object.getPrototypeOf(GUIExpander), 'register', this).call(this, {
        tagName: 'gui-expander',
        type: 'container'
      }, this);
    }
  }]);

  return GUIExpander;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIPanedView: GUIPanedView,
  GUIPanedViewContainer: GUIPanedViewContainer,
  GUIButtonBar: GUIButtonBar,
  GUIToolBar: GUIToolBar,
  GUIGrid: GUIGrid,
  GUIGridRow: GUIGridRow,
  GUIGridEntry: GUIGridEntry,
  GUIVBox: GUIVBox,
  GUIVBoxContainer: GUIVBoxContainer,
  GUIHBox: GUIHBox,
  GUIHBoxContainer: GUIHBoxContainer,
  GUIExpander: GUIExpander
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                               * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                               * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                               *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                               * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                               *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                               *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                               * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                               * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                               * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                               * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                               * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                               * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                               * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                               * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                               * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * @licence Simplified BSD License
                                                                                                                                                                                                                                                                               */


var _fs = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs);

var _fs2 = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs2);

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _misc = __webpack_require__(52);

var Utils = _interopRequireWildcard(_misc);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _menu = __webpack_require__(90);

var Menu = _interopRequireWildcard(_menu);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

var _dataview = __webpack_require__(126);

var _dataview2 = _interopRequireDefault(_dataview);

var _packageManager = __webpack_require__(61);

var _packageManager2 = _interopRequireDefault(_packageManager);

var _settingsManager = __webpack_require__(54);

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _date = __webpack_require__(440);

var _date2 = _interopRequireDefault(_date);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _locales = __webpack_require__(10);

var _config = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/////////////////////////////////////////////////////////////////////////////
// ABSTRACTION HELPERS
/////////////////////////////////////////////////////////////////////////////

var _iconSizes = { // Defaults to 16x16
  'gui-icon-view': '32x32'
};

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function getFileIcon(iter, size) {
  if (iter.icon && _typeof(iter.icon) === 'object') {
    if (iter.icon.application) {
      return _packageManager2.default.getPackageResource(iter.icon.filename, iter.icon.application);
    }
    return _theme2.default.getIcon(iter.icon.filename, size, iter.icon.application);
  }

  var icon = 'status/dialog-question.png';
  return _theme2.default.getFileIcon(iter, size, icon);
}

function getFileSize(iter) {
  var filesize = '';
  if (iter.type !== 'dir' && iter.size >= 0) {
    filesize = FS.humanFileSize(iter.size);
  }
  return filesize;
}

var removeExtension = function () {
  var mimeConfig = void 0;

  return function (str, opts) {
    if (!mimeConfig) {
      mimeConfig = (0, _config.getConfig)('MIME.mapping');
    }

    if (opts.extensions === false) {
      var ext = FS.filext(str);
      if (ext) {
        ext = '.' + ext;
        if (mimeConfig[ext]) {
          str = str.substr(0, str.length - ext.length);
        }
      }
    }
    return str;
  };
}();

function getDateFromStamp(stamp) {
  if (typeof stamp === 'string') {
    var date = null;
    try {
      date = new Date(stamp);
      //date = new Date(stamp.replace('T', ' ').replace(/\..+/, ''));
    } catch (e) {}

    if (date) {
      return _date2.default.format(date);
    }
  }
  return stamp;
}

function getListViewColumns(cls, iter, opts) {
  opts = opts || {};

  var columnMapping = {
    filename: {
      label: 'LBL_FILENAME',
      icon: function icon() {
        return getFileIcon(iter);
      },
      value: function value() {
        return removeExtension(iter.filename, opts);
      }
    },
    mime: {
      label: 'LBL_MIME',
      size: '100px',
      icon: function icon() {
        return null;
      },
      value: function value() {
        return iter.mime;
      }
    },
    mtime: {
      label: 'LBL_MODIFIED',
      size: '160px',
      icon: function icon() {
        return null;
      },
      value: function value() {
        return getDateFromStamp(iter.mtime);
      }
    },
    ctime: {
      label: 'LBL_CREATED',
      size: '160px',
      icon: function icon() {
        return null;
      },
      value: function value() {
        return getDateFromStamp(iter.ctime);
      }
    },
    size: {
      label: 'LBL_SIZE',
      size: '120px',
      icon: function icon() {
        return null;
      },
      value: function value() {
        return getFileSize(iter);
      }
    }
  };

  var defColumns = ['filename', 'mime', 'size'];
  var useColumns = defColumns;

  if (!opts.defaultcolumns) {
    var vfsOptions = Utils.cloneObject(_settingsManager2.default.get('VFS') || {});
    var scandirOptions = vfsOptions.scandir || {};
    useColumns = scandirOptions.columns || defColumns;
  }

  var columns = [];
  var sortBy = cls.$element.getAttribute('data-sortby');
  var sortDir = cls.$element.getAttribute('data-sortdir');

  useColumns.forEach(function (key, idx) {
    var map = columnMapping[key];

    if (iter) {
      columns.push({
        sortBy: key,
        label: map.value(),
        icon: map.icon(),
        textalign: idx === 0 ? 'left' : 'right'
      });
    } else {
      columns.push({
        sortBy: key,
        sortDir: key === sortBy ? sortDir : null,
        label: (0, _locales._)(map.label),
        size: map.size || '',
        resizable: idx > 0,
        textalign: idx === 0 ? 'left' : 'right'
      });
    }
  });

  return columns;
}

function scandir(dir, opts, cb, oncreate) {
  var file = new _file2.default(dir);
  file.type = 'dir';

  var scanopts = {
    backlink: opts.backlink,
    showDotFiles: opts.dotfiles === true,
    showFileExtensions: opts.extensions === true,
    mimeFilter: opts.filter || [],
    typeFilter: opts.filetype || null,
    sortBy: opts.sortby,
    sortDir: opts.sortdir
  };

  VFS.scandir(file, scanopts).then(function (result) {
    var list = [];
    var summary = { size: 0, directories: 0, files: 0, hidden: 0 };

    function isHidden(iter) {
      return (iter.filename || '').substr(0) === '.';
    }

    (result || []).forEach(function (iter) {
      list.push(oncreate(iter));

      summary.size += iter.size || 0;
      summary.directories += iter.type === 'dir' ? 1 : 0;
      summary.files += iter.type !== 'dir' ? 1 : 0;
      summary.hidden += isHidden(iter) ? 1 : 0;
    });

    cb(false, list, summary);
  }).catch(cb);
}

function readdir(cls, dir, done, sopts) {
  var childView = cls.getChildView();
  if (!childView) {
    return;
  }
  sopts = sopts || {};

  var vfsOptions = Utils.cloneObject(_settingsManager2.default.get('VFS') || {});
  var scandirOptions = vfsOptions.scandir || {};

  var el = cls.$element;
  var target = childView.$element;
  var tagName = target.tagName.toLowerCase();
  el.setAttribute('data-path', dir);

  var opts = { filter: null, backlink: sopts.backlink };
  function setOption(s, d, c, cc) {
    if (el.hasAttribute(s)) {
      opts[d] = c(el.getAttribute(s));
    } else {
      opts[d] = (cc || function () {})();
    }
  }

  setOption('data-sortby', 'sortby', function (val) {
    return val;
  });
  setOption('data-sortdir', 'sortdir', function (val) {
    return val;
  });
  setOption('data-dotfiles', 'dotfiles', function (val) {
    return val === 'true';
  }, function () {
    return scandirOptions.showHiddenFiles === true;
  });
  setOption('data-extensions', 'extensions', function (val) {
    return val === 'true';
  }, function () {
    return scandirOptions.showFileExtensions === true;
  });
  setOption('data-filetype', 'filetype', function (val) {
    return val;
  });
  setOption('data-defaultcolumns', 'defaultcolumns', function (val) {
    return val === 'true';
  });

  try {
    opts.filter = JSON.parse(el.getAttribute('data-filter'));
  } catch (e) {}

  scandir(dir, opts, function (error, result, summary) {
    if (tagName === 'gui-list-view') {
      cls.getChildView().set('zebra', true);
      if (sopts.headers !== false) {
        cls.getChildView().set('columns', getListViewColumns(cls, null, opts));
      }
    }

    done(error, result, summary);
  }, function (iter) {
    var tooltip = Utils.format('{0}\n{1}\n{2} {3}', iter.type.toUpperCase(), iter.filename, getFileSize(iter), iter.mime || '');

    function _createEntry() {
      var row = {
        value: iter,
        id: iter.id || removeExtension(iter.filename, opts),
        label: iter.filename,
        tooltip: tooltip,
        icon: getFileIcon(iter, _iconSizes[tagName] || '16x16')
      };

      if (tagName === 'gui-tree-view' && iter.type === 'dir') {
        if (iter.filename !== '..') {
          row.entries = [{
            label: 'Loading...'
          }];
        }
      }

      return row;
    }

    // List view works a little differently
    if (tagName !== 'gui-list-view') {
      return _createEntry();
    }

    return {
      value: iter,
      id: iter.id || iter.filename,
      tooltip: tooltip,
      columns: getListViewColumns(cls, iter, opts)
    };
  });
}

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-file-view'
 *
 * Abstraction layer for displaying files within Icon-, Tree- or List Views
 *
 * For more properties and events etc, see 'dataview'
 *
 * <pre><code>
 *   property  multiple    boolean       If multiple elements are selectable
 *   property  type        String        Child type
 *   property  filter      Array         MIME Filters
 *   property  dotfiles    boolean       Show dotfiles (default=true)
 *   property  extensions  boolean       Show file extensions (default=true)
 *   action    chdir                     Change directory => fn(args)  (args = {path: '', done: function() })
 * </code></pre>
 *
 * @see GUIListView
 * @see GUITreeView
 * @see GUIIconView
 */

var GUIFileView = function (_GUIElement) {
  _inherits(GUIFileView, _GUIElement);

  function GUIFileView() {
    _classCallCheck(this, GUIFileView);

    return _possibleConstructorReturn(this, (GUIFileView.__proto__ || Object.getPrototypeOf(GUIFileView)).apply(this, arguments));
  }

  _createClass(GUIFileView, [{
    key: 'on',
    value: function on(evName, callback, params) {
      if (['activate', 'select', 'contextmenu', 'sort'].indexOf(evName) !== -1) {
        evName = '_' + evName;
      }

      var el = this.$element;
      if (evName === '_contextmenu') {
        el.setAttribute('data-has-contextmenu', 'true');
      }

      Events.$bind(el, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'set',
    value: function set(param, value, arg, arg2) {
      var el = this.$element;

      if (param === 'type') {
        var firstChild = el.children[0];
        if (firstChild && firstChild.tagName.toLowerCase() === value) {
          return true;
        }

        el.setAttribute('data-type', value);
        this.buildChildView();

        if (typeof arg === 'undefined' || arg === true) {
          this.chdir({
            path: el.getAttribute('data-path')
          });
        }
        return this;
      } else if (['filter', 'dotfiles', 'filetype', 'extensions', 'defaultcolumns', 'sortby', 'sortdir'].indexOf(param) >= 0) {
        GUI.setProperty(el, param, value);
        return this;
      }

      var childView = this.getChildView();
      if (childView) {
        return childView.set.apply(childView, arguments);
      }
      return _dataview2.default.prototype.set.apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var _this2 = this;

      if (this.childView) {
        return this;
      }

      this.buildChildView();

      var el = this.$element;

      Events.$bind(el, '_expand', function (ev) {
        var target = ev.detail.element;
        if (target.getAttribute('data-was-rendered')) {
          return;
        }

        if (ev.detail.expanded) {
          var entry = ev.detail.entries[0].data;
          target.setAttribute('data-was-rendered', String(true));
          readdir(_this2, entry.path, function (error, result, summary) {
            if (!error) {
              target.querySelectorAll('gui-tree-view-entry').forEach(function (e) {
                DOM.$remove(e);
              });

              var childView = _this2.getChildView();
              if (childView) {
                childView.add({
                  entries: result,
                  parentNode: target
                });
              }
            }
          }, { backlink: false });
        }
      });

      return this;
    }
  }, {
    key: 'values',
    value: function values() {
      var childView = this.getChildView();
      if (childView) {
        return childView.values();
      }
      return null;
    }
  }, {
    key: 'contextmenu',
    value: function contextmenu(ev) {
      var vfsOptions = _settingsManager2.default.instance('VFS');
      var scandirOptions = vfsOptions.get('scandir') || {};

      function setOption(opt, toggle) {
        var opts = { scandir: {} };
        opts.scandir[opt] = toggle;
        vfsOptions.set(null, opts, true);
      }

      Menu.create([{
        title: (0, _locales._)('LBL_SHOW_HIDDENFILES'),
        type: 'checkbox',
        checked: scandirOptions.showHiddenFiles === true,
        onClick: function onClick() {
          setOption('showHiddenFiles', !scandirOptions.showHiddenFiles);
        }
      }, {
        title: (0, _locales._)('LBL_SHOW_FILEEXTENSIONS'),
        type: 'checkbox',
        checked: scandirOptions.showFileExtensions === true,
        onClick: function onClick() {
          setOption('showFileExtensions', !scandirOptions.showFileExtensions);
        }
      }], ev);
    }
  }, {
    key: 'chdir',
    value: function chdir(args) {
      var _this3 = this;

      var childView = this.getChildView();
      if (!childView) {
        childView = this.buildChildView();
      }

      var cb = args.done || function () {};
      var dir = args.path || (0, _config.getDefaultPath)();
      var child = childView;
      var el = this.$element;

      clearTimeout(el._readdirTimeout);
      el._readdirTimeout = setTimeout(function () {
        readdir(_this3, dir, function (error, result, summary) {
          if (error) {
            OSjs.error((0, _locales._)('ERR_VFSMODULE_XHR_ERROR'), (0, _locales._)('ERR_VFSMODULE_SCANDIR_FMT', dir), error);
          } else {
            child.clear();
            child.add(result);
          }
          cb(error, summary);
        }, args.opts);
      }, 50); // Prevent exessive calls
    }
  }, {
    key: 'getChildViewType',
    value: function getChildViewType() {
      var type = this.$element.getAttribute('data-type') || 'list-view';
      if (!type.match(/^gui\-/)) {
        type = 'gui-' + type;
      }
      return type;
    }
  }, {
    key: 'getChildView',
    value: function getChildView() {
      return _element2.default.createFromNode(this.$element.children[0]);
    }
  }, {
    key: 'buildChildView',
    value: function buildChildView() {
      var _this4 = this;

      var el = this.$element;
      var type = this.getChildViewType();
      var childView = this.getChildView();

      if (childView) {
        if (childView.$element && childView.$element.tagName.toLowerCase() === type) {
          return null;
        }
      }

      DOM.$empty(el);

      var nel = _element2.default.create(type, { 'draggable': true, 'draggable-type': 'file' });
      nel.build();

      nel.on('select', function (ev) {
        el.dispatchEvent(new CustomEvent('_select', { detail: ev.detail }));
      });
      nel.on('activate', function (ev) {
        el.dispatchEvent(new CustomEvent('_activate', { detail: ev.detail }));
      });
      nel.on('sort', function (ev) {
        el.setAttribute('data-sortby', String(ev.detail.sortBy));
        el.setAttribute('data-sortdir', String(ev.detail.sortDir));

        _this4.chdir({
          sopts: {
            headers: false
          },
          path: el.getAttribute('data-path')
        });

        el.dispatchEvent(new CustomEvent('_sort', { detail: ev.detail }));
      });
      nel.on('contextmenu', function (ev) {
        if (!el.hasAttribute('data-has-contextmenu') || el.hasAttribute('data-has-contextmenu') === 'false') {
          _this4.contextmenu(ev);
        }
        el.dispatchEvent(new CustomEvent('_contextmenu', { detail: ev.detail }));
      });

      if (type === 'gui-tree-view') {
        nel.on('expand', function (ev) {
          el.dispatchEvent(new CustomEvent('_expand', { detail: ev.detail }));
        });
      }

      el.setAttribute('role', 'region');
      el.appendChild(nel.$element);

      return nel;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIFileView.__proto__ || Object.getPrototypeOf(GUIFileView), 'register', this).call(this, {
        tagName: 'gui-file-view'
      }, this);
    }
  }]);

  return GUIFileView;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIFileView: GUIFileView
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint valid-jsdoc: "off"*/

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function filter(from, index, shrt, toindex) {
  var list = [];
  for (var i = shrt ? 0 : toindex; i < from.length; i++) {
    list.push(from[i]);
  }
  return list;
}

function _format(fmt, date) {
  /*eslint no-use-before-define: "off"*/
  var utc = void 0;

  if (typeof fmt === 'undefined' || !fmt) {
    fmt = ExtendedDate.config.defaultFormat;
  } else {
    if (typeof fmt !== 'string') {
      utc = fmt.utc;
      fmt = fmt.format;
    } else {
      utc = ExtendedDate.config.utc;
    }
  }

  return formatDate(date, fmt, utc);
}

function _now(now) {
  /*eslint no-use-before-define: "off"*/
  return now ? now instanceof ExtendedDate ? now.date : now : new Date();
}

function _y(y, now) {
  return typeof y === 'undefined' || y === null || y < 0 ? now.getFullYear() : y;
}

function _m(m, now) {
  return typeof m === 'undefined' || m === null || m < 0 ? now.getMonth() : m;
}

/////////////////////////////////////////////////////////////////////////////
// EXTENDED DATE
/////////////////////////////////////////////////////////////////////////////

/**
 * Extended Date Helper
 *
 * Works just like 'Date', but has some extended methods
 *
 * @desc Class for date manipulation and formatting.
 */

var ExtendedDate = function () {

  /**
   * @param {(Date|ExtendedDate)} [date] Create new instance from this date
   */
  function ExtendedDate(date) {
    _classCallCheck(this, ExtendedDate);

    if (date) {
      if (date instanceof Date) {
        this.date = date;
      } else if (date instanceof ExtendedDate) {
        this.date = date.date;
      } else if (typeof date === 'string') {
        this.date = new Date(date);
      }
    }

    if (!this.date) {
      this.date = new Date();
    }
  }

  //
  // Global Configuration
  //


  _createClass(ExtendedDate, [{
    key: 'get',


    //
    // Extended Methods
    //

    /**
     * Get the 'Date' Object
     *
     * @return  {DateExtended}
     */
    value: function get() {
      return this.date;
    }

    /**
     * Format date
     *
     * @param   {String}      fmt     Format (ex: "Y/m/d")
     *
     * @return  {String}              Formatted date
     *
     * <pre><code>
     * Format is (same as PHP docs):
     *
     *   d: Day of the month, 2 digits with leading zeros (01 to 31)
     *   D: A textual representation of a day, three letters (Mon through Sun)
     *   j: Day of the month without leading zeros (1 to 31)
     *   l: A full textual representation of the day of the week (Sunday through Saturday)
     *   w: Numeric representation of the day of the week (0 (for Sunday) through 6 (for Saturday))
     *   z: The day of the year (starting from 0) (0 through 365)
     *   S: English ordinal suffix for the day of the month, 2 characters (st, nd, rd or th. Works well with j)
     *   W: ISO-8601 week number of year, weeks starting on Monday (Example: 42 (the 42nd week in the year))
     *   F: A full textual representation of a month, such as January or March (January through December)
     *   m: Numeric representation of a month, with leading zeros (01 through 12)
     *   M: A short textual representation of a month, three letters (Jan through Dec)
     *   n: Numeric representation of a month, without leading zeros (1 through 12)
     *   t: Number of days in the given month (28 through 31)
     *   Y: A full numeric representation of a year, 4 digits (Examples: 1999 or 2003)
     *   y: A two digit representation of a year (Examples: 99 or 03)
     *   a: Lowercase Ante meridiem and Post meridiem (am or pm)
     *   A: Uppercase Ante meridiem and Post meridiem (AM or PM)
     *   g: 12-hour format of an hour without leading zeros (1 through 12)
     *   G: 24-hour format of an hour without leading zeros (0 through 23)
     *   h: 12-hour format of an hour with leading zeros (01 through 12)
     *   H: 24-hour format of an hour with leading zeros (00 through 23)
     *   i: Minutes with leading zeros (00 to 59)
     *   s: Seconds, with leading zeros (00 through 59)
     *   O: Difference to Greenwich time (GMT) in hours (Example: +0200)
     *   T: Timezone abbreviation (Examples: EST, MDT ...)
     *   U: Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)
     * </code></pre>
     */

  }, {
    key: 'format',
    value: function format(fmt) {
      return ExtendedDate.format(this, fmt);
    }

    /**
     * Get First day in month
     *
     * @see DateExtended#format
     *
     * @param   {String}    [fmt]     Date format
     *
     * @return  {String|ExtendedDate}     If no format is given it will return ExtendedDate
     */

  }, {
    key: 'getFirstDayInMonth',
    value: function getFirstDayInMonth(fmt) {
      return ExtendedDate.getFirstDayInMonth(fmt, null, null, this);
    }

    /**
     * Get Last day in month
     *
     * @see DateExtended#format
     *
     * @param   {String}    [fmt]     Date format
     *
     * @return  {String|ExtendedDate}     If no format is given it will return ExtendedDate
     */

  }, {
    key: 'getLastDayInMonth',
    value: function getLastDayInMonth(fmt) {
      return ExtendedDate.getLastDayInMonth(fmt, null, null, this);
    }

    /**
     * Get numbers of day in month
     *
     * @return  {Number}     Number of days
     */

  }, {
    key: 'getDaysInMonth',
    value: function getDaysInMonth() {
      return ExtendedDate.getDaysInMonth(null, null, this);
    }

    /**
     * Get week number
     *
     * @return  {Number}     Week
     */

  }, {
    key: 'getWeekNumber',
    value: function getWeekNumber() {
      return ExtendedDate.getWeekNumber(this);
    }

    /**
     * Check if given range is within Month
     *
     * @param   {(Date|DateExtended)}    from      From date (can be Date)
     * @param   {(Date|DateExtended)}    to        To date (can be Date)
     *
     * @return  {Boolean}
     */

  }, {
    key: 'isWithinMonth',
    value: function isWithinMonth(from, to) {
      return ExtendedDate.isWithinMonth(this, from, to);
    }

    /**
     * Check if given range is within Year
     *
     * @return  {Boolean}
     */

  }, {
    key: 'getDayOfTheYear',
    value: function getDayOfTheYear() {
      return ExtendedDate.getDayOfTheYear();
    }

    //
    // Static Methods
    //

    /**
     * @see DateExtended#format
     */

  }], [{
    key: 'format',
    value: function format(date, fmt) {
      return _format(fmt, date);
    }

    /**
     * @see DateExtended#getPreviousMonth
     */

  }, {
    key: 'getPreviousMonth',
    value: function getPreviousMonth(now) {
      now = now ? now instanceof ExtendedDate ? now.date : now : new Date();
      var current = void 0;

      if (now.getMonth() === 0) {
        current = new Date(now.getFullYear() - 1, 11, now.getDate());
      } else {
        current = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      }

      return new ExtendedDate(current);
    }

    /**
     * @see DateExtended#getNextMonth
     */

  }, {
    key: 'getNextMonth',
    value: function getNextMonth(now) {
      now = now ? now instanceof ExtendedDate ? now.date : now : new Date();
      var current = void 0;

      if (now.getMonth() === 11) {
        current = new Date(now.getFullYear() + 1, 0, now.getDate());
      } else {
        current = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
      }

      return new ExtendedDate(current);
    }

    /**
     * @see DateExtended#getFirstDayInMonth
     */

  }, {
    key: 'getFirstDayInMonth',
    value: function getFirstDayInMonth(fmt, y, m, now) {
      now = _now(now);
      y = _y(y, now);
      m = _m(m, now);

      var date = new Date();
      date.setFullYear(y, m, 1);
      if (fmt === true) {
        return date.getDate();
      }
      return fmt ? _format(fmt, date) : new ExtendedDate(date);
    }

    /**
     * @see DateExtended#getLastDayInMonth
     */

  }, {
    key: 'getLastDayInMonth',
    value: function getLastDayInMonth(fmt, y, m, now) {
      now = _now(now);
      y = _y(y, now);
      m = _m(m, now);

      var date = new Date();
      date.setFullYear(y, m, 0);
      if (fmt === true) {
        return date.getDate();
      }
      return fmt ? _format(fmt, date) : new ExtendedDate(date);
    }

    /**
     * @see DateExtended#getDaysInMonth
     */

  }, {
    key: 'getDaysInMonth',
    value: function getDaysInMonth(y, m, now) {
      now = _now(now);
      y = _y(y, now);
      m = _m(m, now);

      var date = new Date();
      date.setFullYear(y, m, 0);
      return parseInt(date.getDate(), 10);
    }

    /**
     * @see DateExtended#getWeekNumber
     */

  }, {
    key: 'getWeekNumber',
    value: function getWeekNumber(now) {
      now = now ? now instanceof ExtendedDate ? now.date : now : new Date();

      var d = new Date(+now);
      d.setHours(0, 0, 0);
      d.setDate(d.getDate() + 4 - (d.getDay() || 7));
      return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
    }

    /**
     * @see DateExtended#getDayName
     */

  }, {
    key: 'getDayName',
    value: function getDayName(index, shrt) {
      if (index < 0 || index === null || typeof index === 'undefined') {
        return filter(ExtendedDate.dayNames, index, shrt, 7);
      }

      shrt = shrt ? 0 : 1;
      var idx = index + (shrt + 7);
      return ExtendedDate.dayNames[idx];
    }

    /**
     * @see DateExtended#getMonthName
     */

  }, {
    key: 'getMonthName',
    value: function getMonthName(index, shrt) {
      if (index < 0 || index === null || typeof index === 'undefined') {
        return filter(ExtendedDate.monthNames, index, shrt, 12);
      }

      shrt = shrt ? 0 : 1;
      var idx = index + (shrt + 12);
      return ExtendedDate.monthNames[idx];
    }

    /**
     * @see DateExtended#isWithinMonth
     */

  }, {
    key: 'isWithinMonth',
    value: function isWithinMonth(now, from, to) {
      if (now.getFullYear() >= from.getFullYear() && now.getMonth() >= from.getMonth()) {
        if (now.getFullYear() <= to.getFullYear() && now.getMonth() <= to.getMonth()) {
          return true;
        }
      }
      return false;
    }

    /**
     * @see DateExtended#getDayOfTheYear
     */

  }, {
    key: 'getDayOfTheYear',
    value: function getDayOfTheYear() {
      var now = new Date();
      var start = new Date(now.getFullYear(), 0, 0);
      var diff = now - start;
      var oneDay = 1000 * 60 * 60 * 24;
      return Math.floor(diff / oneDay);
    }
  }, {
    key: 'config',
    get: function get() {
      return {
        defaultFormat: 'isoDateTime'
        //utc: true
      };
    }
  }, {
    key: 'dayNames',
    get: function get() {
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    }
  }, {
    key: 'monthNames',
    get: function get() {
      return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    }
  }]);

  return ExtendedDate;
}();

//
// Date Methods
//

exports.default = ExtendedDate;
var methods = ['UTC', 'toString', 'now', 'parse', 'getDate', 'getDay', 'getFullYear', 'getHours', 'getMilliseconds', 'getMinutes', 'getMonth', 'getSeconds', 'getTime', 'getTimezoneOffset', 'getUTCDate', 'getUTCDay', 'getUTCFullYear', 'getUTCHours', 'getUTCMilliseconds', 'getUTCMinutes', 'getUTCMonth', 'getUTCSeconds', 'getYear', 'setDate', 'setFullYear', 'setHours', 'setMilliseconds', 'setMinutes', 'setMonth', 'setSeconds', 'setTime', 'setUTCDate', 'setUTCFullYear', 'setUTCHours', 'setUTCMilliseconds', 'setUTCMinutes', 'setUTCMonth', 'setUTCSeconds', 'setYear', 'toDateString', 'toGMTString', 'toISOString', 'toJSON', 'toLocaleDateString', 'toLocaleFormat', 'toLocaleString', 'toLocaleTimeString', 'toSource', 'toString', 'toTimeString', 'toUTCString', 'valueOf'];

methods.forEach(function (m) {
  ExtendedDate.prototype[m] = function () {
    return this.date[m].apply(this.date, arguments);
  };
});

/////////////////////////////////////////////////////////////////////////////
// DATE FORMATTING
/////////////////////////////////////////////////////////////////////////////

/**
 * Inspired by: "Date Format" by Steven Levithan
 */
function formatDate(date, format, utc) {
  utc = utc === true;

  function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = '0' + val;
    }
    return val;
  }

  var defaultFormats = {
    'default': 'Y-m-d H:i:s',
    shortDate: 'm/d/y',
    mediumDate: 'M d, Y',
    longDate: 'F d, Y',
    fullDate: 'l, F d, Y',
    shortTime: 'h:i A',
    mediumTime: 'h:i:s A',
    longTime: 'h:i:s A T',
    isoDate: 'Y-m-d',
    isoTime: 'H:i:s',
    isoDateTime: 'Y-m-d H:i:s'
  };

  format = defaultFormats[format] || format;

  if (!(date instanceof ExtendedDate)) {
    date = new ExtendedDate(date);
  }

  var map = {
    /*eslint new-cap: "warn"*/

    //
    // DAY
    //

    // Day of the month, 2 digits with leading zeros (01 to 31)
    d: function d(s) {
      return pad(map.j(s));
    },

    // A textual representation of a day, three letters (Mon through Sun)
    D: function D(s) {
      return ExtendedDate.dayNames[utc ? date.getUTCDay() : date.getDay()];
    },

    // Day of the month without leading zeros (1 to 31)
    j: function j(s) {
      return utc ? date.getUTCDate() : date.getDate();
    },

    // A full textual representation of the day of the week (Sunday through Saturday)
    l: function l(s) {
      return ExtendedDate.dayNames[(utc ? date.getUTCDay() : date.getDay()) + 7];
    },

    // Numeric representation of the day of the week (0 (for Sunday) through 6 (for Saturday))
    w: function w(s) {
      return utc ? date.getUTCDay() : date.getDay();
    },

    // The day of the year (starting from 0) (0 through 365)
    z: function z(s) {
      return date.getDayOfTheYear();
    },

    // S English ordinal suffix for the day of the month, 2 characters (st, nd, rd or th. Works well with j)
    S: function S(s) {
      var d = utc ? date.getUTCDate() : date.getDate();
      return ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 !== 10) * d % 10];
    },

    //
    // WEEK
    //

    // ISO-8601 week number of year, weeks starting on Monday (Example: 42 (the 42nd week in the year))
    W: function W(s) {
      return date.getWeekNumber();
    },

    //
    // MONTH
    //

    // A full textual representation of a month, such as January or March (January through December)
    F: function F(s) {
      return ExtendedDate.monthNames[(utc ? date.getUTCMonth() : date.getMonth()) + 12];
    },

    // Numeric representation of a month, with leading zeros (01 through 12)
    m: function m(s) {
      return pad(map.n(s));
    },

    // A short textual representation of a month, three letters (Jan through Dec)
    M: function M(s) {
      return ExtendedDate.monthNames[utc ? date.getUTCMonth() : date.getMonth()];
    },

    // Numeric representation of a month, without leading zeros (1 through 12)
    n: function n(s) {
      return (utc ? date.getUTCMonth() : date.getMonth()) + 1;
    },

    // Number of days in the given month (28 through 31)
    t: function t(s) {
      return date.getDaysInMonth();
    },

    //
    // YEAR
    //

    // A full numeric representation of a year, 4 digits (Examples: 1999 or 2003)
    Y: function Y(s) {
      return utc ? date.getUTCFullYear() : date.getFullYear();
    },

    // A two digit representation of a year (Examples: 99 or 03)
    y: function y(s) {
      /*eslint new-cap: "off"*/
      return String(map.Y(s)).slice(2);
    },

    //
    // TIME
    //

    // Lowercase Ante meridiem and Post meridiem (am or pm)
    a: function a(s) {
      /*eslint new-cap: "off"*/
      return map.G(s) < 12 ? 'am' : 'pm';
    },

    // Uppercase Ante meridiem and Post meridiem (AM or PM)
    A: function A(s) {
      return map.a(s).toUpperCase();
    },

    // 12-hour format of an hour without leading zeros (1 through 12)
    g: function g(s) {
      /*eslint new-cap: "off"*/
      return map.G(s) % 12 || 12;
    },

    // 24-hour format of an hour without leading zeros (0 through 23)
    G: function G(s) {
      return utc ? date.getUTCHours() : date.getHours();
    },

    // 12-hour format of an hour with leading zeros (01 through 12)
    h: function h(s) {
      return pad(map.g(s));
    },

    // 24-hour format of an hour with leading zeros (00 through 23)
    H: function H(s) {
      /*eslint new-cap: "off"*/
      return pad(map.G(s));
    },

    // Minutes with leading zeros (00 to 59)
    i: function i(s) {
      return pad(utc ? date.getUTCMinutes() : date.getMinutes());
    },

    // Seconds, with leading zeros (00 through 59)
    s: function s(_s) {
      return pad(utc ? date.getUTCSeconds() : date.getSeconds());
    },

    //
    // ZONE
    //

    // Difference to Greenwich time (GMT) in hours (Example: +0200)
    O: function O(s) {
      var tzo = -date.getTimezoneOffset();
      var dif = tzo >= 0 ? '+' : '-';

      function ppad(num) {
        var norm = Math.abs(Math.floor(num));
        return (norm < 10 ? '0' : '') + norm;
      }

      var str = dif + ppad(tzo / 60) + ':' + ppad(tzo % 60);
      return str;
    },

    // Timezone abbreviation (Examples: EST, MDT ...)
    T: function T(s) {
      if (utc) {
        return 'UTC';
      }

      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var zones = String(date.date).match(timezone) || [''];
      return zones.pop().replace(/(\+|\-)[0-9]+$/, '');
    },

    //
    // MISC
    //

    // Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)
    U: function U(s) {
      return date.getTime();
    }
  };

  var result = [];
  format.split('').forEach(function (s) {
    result.push(map[s] ? map[s]() : s);
  });
  return result.join('');
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _dataview = __webpack_require__(126);

var _dataview2 = _interopRequireDefault(_dataview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function createEntry(cls, e) {
  var entry = GUI.createElement('gui-icon-view-entry', e);
  return entry;
}

function initEntry(cls, cel) {
  var icon = cel.getAttribute('data-icon');
  var label = GUI.getLabel(cel);

  var dicon = document.createElement('div');
  var dimg = document.createElement('img');
  dimg.src = icon;
  dicon.appendChild(dimg);

  var dlabel = document.createElement('div');
  var dspan = document.createElement('span');
  dspan.appendChild(document.createTextNode(label));
  dlabel.appendChild(dspan);

  cls.bindEntryEvents(cel, 'gui-icon-view-entry');

  cel.setAttribute('role', 'listitem');
  cel.appendChild(dicon);
  cel.appendChild(dlabel);
}

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-icon-view'
 *
 * A container for displaying icons with labels
 *
 * For more properties and events etc, see 'dataview'
 *
 * <pre><code>
 *   property  icon-size   integer       Icon size (default=16)
 * </code></pre>
 *
 * @example
 *   .add([{
 *      label: "Label",
 *      icon: "Optional icon path",
 *      value: "something or JSON or whatever"
 *   }])
 */

var GUIIconView = function (_GUIDataView) {
  _inherits(GUIIconView, _GUIDataView);

  function GUIIconView() {
    _classCallCheck(this, GUIIconView);

    return _possibleConstructorReturn(this, (GUIIconView.__proto__ || Object.getPrototypeOf(GUIIconView)).apply(this, arguments));
  }

  _createClass(GUIIconView, [{
    key: 'values',
    value: function values() {
      return this.getSelected(this.$element.querySelectorAll('gui-icon-view-entry'));
    }
  }, {
    key: 'build',
    value: function build() {
      var _this2 = this;

      var el = this.$element;
      var body = el.querySelector('gui-icon-view-body');
      var found = !!body;

      if (!found) {
        body = document.createElement('gui-icon-view-body');
        el.appendChild(body);
      }

      el.querySelectorAll('gui-icon-view-entry').forEach(function (cel, idx) {
        if (!found) {
          body.appendChild(cel);
        }
        initEntry(_this2, cel);
      });

      el.setAttribute('role', 'list');

      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'build', this).apply(this, arguments);
    }
  }, {
    key: 'get',
    value: function get(param, value, arg, asValue) {
      if (param === 'entry') {
        var body = this.$element.querySelector('gui-icon-view-body');
        var rows = body.querySelectorAll('gui-icon-view-entry');
        return this.getEntry(rows, value, arg, asValue);
      }
      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'get', this).apply(this, arguments);
    }
  }, {
    key: 'set',
    value: function set(param, value, arg) {
      var body = this.$element.querySelector('gui-icon-view-body');
      if (param === 'selected' || param === 'value') {
        if (body) {
          this.setSelected(body, body.querySelectorAll('gui-icon-view-entry'), value, arg);
        }
        return this;
      }

      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'add',
    value: function add(entries) {
      var _this3 = this;

      var body = this.$element.querySelector('gui-icon-view-body');
      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'add', this).call(this, entries, function (cls, e) {
        var entry = createEntry(_this3, e);
        body.appendChild(entry);
        initEntry(_this3, entry);
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      var body = this.$element.querySelector('gui-icon-view-body');
      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'clear', this).call(this, body);
    }
  }, {
    key: 'remove',
    value: function remove(entries) {
      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'remove', this).call(this, entries, 'gui-icon-view-entry');
    }
  }, {
    key: 'patch',
    value: function patch(entries) {
      var body = this.$element.querySelector('gui-icon-view-body');
      return _get(GUIIconView.prototype.__proto__ || Object.getPrototypeOf(GUIIconView.prototype), 'patch', this).call(this, entries, 'gui-icon-view-entry', body, createEntry, initEntry);
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIIconView.__proto__ || Object.getPrototypeOf(GUIIconView), 'register', this).call(this, {
        parent: _dataview2.default,
        tagName: 'gui-icon-view'
      }, this);
    }
  }]);

  return GUIIconView;
}(_dataview2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIIconView: GUIIconView
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _clipboard = __webpack_require__(203);

var Clipboard = _interopRequireWildcard(_clipboard);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _keycodes = __webpack_require__(88);

var _keycodes2 = _interopRequireDefault(_keycodes);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var _buttonCount = 0;

/////////////////////////////////////////////////////////////////////////////
// INPUT HELPERS
/////////////////////////////////////////////////////////////////////////////

function createInputOfType(el, type) {
  var group = el.getAttribute('data-group');
  var placeholder = el.getAttribute('data-placeholder');
  var disabled = String(el.getAttribute('data-disabled')) === 'true';
  var value = el.childNodes.length ? el.childNodes[0].nodeValue : null;
  DOM.$empty(el);

  var input = document.createElement(type === 'textarea' ? 'textarea' : 'input');

  var attribs = {
    value: null,
    type: type,
    tabindex: -1,
    placeholder: placeholder,
    disabled: disabled ? 'disabled' : null,
    name: group ? group + '[]' : null
  };

  ['autocomplete', 'autocorrect', 'autocapitalize', 'spellcheck'].forEach(function (a) {
    attribs[a] = el.getAttribute('data-' + a) || 'false';
  });

  function _bindDefaults() {
    if (['range', 'slider'].indexOf(type) >= 0) {
      attribs.min = el.getAttribute('data-min');
      attribs.max = el.getAttribute('data-max');
      attribs.step = el.getAttribute('data-step');
    } else if (['radio', 'checkbox'].indexOf(type) >= 0) {
      if (el.getAttribute('data-value') === 'true') {
        attribs.checked = 'checked';
      }
    } else if (['text', 'password', 'textarea'].indexOf(type) >= 0) {
      attribs.value = value || '';
    }

    Object.keys(attribs).forEach(function (a) {
      if (attribs[a] !== null) {
        if (a === 'value') {
          input.value = attribs[a];
        } else {
          input.setAttribute(a, attribs[a]);
        }
      }
    });
  }
  function _bindEvents() {
    if (type === 'text' || type === 'password' || type === 'textarea') {
      Events.$bind(input, 'keydown', function (ev) {
        if (ev.keyCode === _keycodes2.default.ENTER) {
          input.dispatchEvent(new CustomEvent('_enter', { detail: input.value }));
        } else if (ev.keyCode === _keycodes2.default.C && ev.ctrlKey) {
          Clipboard.setClipboard(input.value);
        }

        if (type === 'textarea' && ev.keyCode === _keycodes2.default.TAB) {
          ev.preventDefault();
          input.value += '\t';
        }
      }, false);
    }
  }

  function _create() {
    _bindDefaults();
    _bindEvents();

    GUI.createInputLabel(el, type, input);

    var rolemap = {
      'TEXTAREA': function TEXTAREA() {
        return 'textbox';
      },
      'INPUT': function INPUT(i) {
        var typemap = {
          'range': 'slider',
          'text': 'textbox',
          'password': 'textbox'
        };

        return typemap[i.type] || i.type;
      }
    };

    if (rolemap[el.tagName]) {
      input.setAttribute('role', rolemap[el.tagName](input));
    }
    input.setAttribute('aria-label', el.getAttribute('title') || '');
    el.setAttribute('role', 'region');
    el.setAttribute('aria-disabled', String(disabled));

    Events.$bind(input, 'change', function (ev) {
      var value = input.value;
      if (type === 'radio' || type === 'checkbox') {
        //value = input.getAttribute('checked') === 'checked';
        value = input.checked; //input.value === 'on';
      }
      input.dispatchEvent(new CustomEvent('_change', { detail: value }));
    }, false);
  }

  _create();
}

/////////////////////////////////////////////////////////////////////////////
// SELECT HELPERS
/////////////////////////////////////////////////////////////////////////////

function addToSelectBox(el, entries) {
  var target = el.querySelector('select');
  if (!(entries instanceof Array)) {
    entries = [entries];
  }

  entries.forEach(function (e) {
    var opt = document.createElement('option');
    opt.setAttribute('role', 'option');
    opt.setAttribute('value', e.value);
    opt.appendChild(document.createTextNode(e.label));

    target.appendChild(opt);
  });
}

function removeFromSelectBox(el, what) {
  var target = el.querySelector('select');
  target.querySelectorAll('option').forEach(function (opt) {
    if (String(opt.value) === String(what)) {
      DOM.$remove(opt);
      return false;
    }
    return true;
  });
}

function createSelectInput(el, multiple) {
  var disabled = el.getAttribute('data-disabled') !== null;
  var selected = el.getAttribute('data-selected');

  var select = document.createElement('select');
  if (multiple) {
    select.setAttribute('size', el.getAttribute('data-size') || 2);
    multiple = el.getAttribute('data-multiple') === 'true';
  }

  if (multiple) {
    select.setAttribute('multiple', 'multiple');
  }
  if (disabled) {
    select.setAttribute('disabled', 'disabled');
  }
  if (selected !== null) {
    select.selectedIndex = selected;
  }

  el.querySelectorAll('gui-select-option').forEach(function (sel) {
    var value = sel.getAttribute('data-value') || '';
    var label = sel.childNodes.length ? sel.childNodes[0].nodeValue : '';

    var option = document.createElement('option');
    option.setAttribute('role', 'option');
    option.setAttribute('value', value);
    option.appendChild(document.createTextNode(label));
    if (sel.getAttribute('selected')) {
      option.setAttribute('selected', 'selected');
    }
    select.appendChild(option);
    sel.parentNode.removeChild(sel);
  });

  Events.$bind(select, 'change', function (ev) {
    select.dispatchEvent(new CustomEvent('_change', { detail: select.value }));
  }, false);

  select.setAttribute('role', 'listbox');
  select.setAttribute('aria-label', el.getAttribute('title') || '');
  el.setAttribute('aria-disabled', String(disabled));
  el.setAttribute('role', 'region');
  el.appendChild(select);
}

/////////////////////////////////////////////////////////////////////////////
// OTHER HELPERS
/////////////////////////////////////////////////////////////////////////////

function setSwitchValue(val, input, button) {
  if (val !== true) {
    input.removeAttribute('checked');
    DOM.$removeClass(button, 'gui-active');
    button.innerHTML = '0';
  } else {
    input.setAttribute('checked', 'checked');
    DOM.$addClass(button, 'gui-active');
    button.innerHTML = '1';
  }
}

/////////////////////////////////////////////////////////////////////////////
// CLASSES
/////////////////////////////////////////////////////////////////////////////

var _GUIInput = function (_GUIElement) {
  _inherits(_GUIInput, _GUIElement);

  function _GUIInput() {
    _classCallCheck(this, _GUIInput);

    return _possibleConstructorReturn(this, (_GUIInput.__proto__ || Object.getPrototypeOf(_GUIInput)).apply(this, arguments));
  }

  _createClass(_GUIInput, [{
    key: 'on',
    value: function on(evName, callback, params) {
      /* eslint no-invalid-this: "off" */
      if (evName === 'enter') {
        evName = '_enter';
      } else if (evName === 'change') {
        evName = '_change';
      }

      var target = this.$element.querySelector('textarea, input, select');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }]);

  return _GUIInput;
}(_element2.default);

/**
 * Element: 'gui-label'
 *
 * Just a normal label.
 *
 * <pre><code>
 *   getter    value     String        The value/contents
 *   setter    value     String        The value/contents
 *   setter    label     String        The label text
 *   property  disabled  boolean       Disabled state
 * </code></pre>
 */


var GUILabel = function (_GUIElement2) {
  _inherits(GUILabel, _GUIElement2);

  function GUILabel() {
    _classCallCheck(this, GUILabel);

    return _possibleConstructorReturn(this, (GUILabel.__proto__ || Object.getPrototypeOf(GUILabel)).apply(this, arguments));
  }

  _createClass(GUILabel, [{
    key: 'set',
    value: function set(param, value, isHTML) {
      var el = this.$element;
      if (param === 'value' || param === 'label') {
        el.setAttribute('data-label', String(value));

        var lbl = el.querySelector('label');
        DOM.$empty(lbl);
        if (isHTML) {
          lbl.innerHTML = value;
        } else {
          lbl.appendChild(document.createTextNode(value));
        }
        return this;
      }
      return _get(GUILabel.prototype.__proto__ || Object.getPrototypeOf(GUILabel.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var label = GUI.getValueLabel(el, true);
      var lbl = document.createElement('label');
      lbl.appendChild(document.createTextNode(label));
      el.setAttribute('role', 'heading');
      el.setAttribute('data-label', String(label));
      el.appendChild(lbl);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUILabel.__proto__ || Object.getPrototypeOf(GUILabel), 'register', this).call(this, {
        tagName: 'gui-label'
      }, this);
    }
  }]);

  return GUILabel;
}(_element2.default);

/**
 * Element: 'gui-textarea'
 *
 * Text area input (multi-line)
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value         String        The value/contents
 *   setter    value         String        The value/contents
 *   setter    label         String        The label text
 *   setter    disabled      boolean       Set disabled state
 *   property  disabled      boolean       Disabled state
 *   property  value         String        The input value
 *   property  placeholder   String        An optional placeholder
 *   event     change                      When input has changed => fn(ev)
 * </code></pre>
 */


var GUITextarea = function (_GUIInput2) {
  _inherits(GUITextarea, _GUIInput2);

  function GUITextarea() {
    _classCallCheck(this, GUITextarea);

    return _possibleConstructorReturn(this, (GUITextarea.__proto__ || Object.getPrototypeOf(GUITextarea)).apply(this, arguments));
  }

  _createClass(GUITextarea, [{
    key: 'build',
    value: function build() {
      createInputOfType(this.$element, 'textarea');

      return this;
    }
  }, {
    key: 'set',
    value: function set(param, value) {
      var el = this.$element;
      if (el && param === 'scrollTop') {
        if (typeof value !== 'number') {
          value = el.firstChild.scrollHeight;
        }
        el.firstChild.scrollTop = value;
        return this;
      }
      return _get(GUITextarea.prototype.__proto__ || Object.getPrototypeOf(GUITextarea.prototype), 'set', this).apply(this, arguments);
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUITextarea.__proto__ || Object.getPrototypeOf(GUITextarea), 'register', this).call(this, {
        tagName: 'gui-textarea',
        type: 'input'
      }, this);
    }
  }]);

  return GUITextarea;
}(_GUIInput);

/**
 * Element: 'gui-text'
 *
 * Text input.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value         String        The value/contents
 *   setter    value         String        The value/contents
 *   setter    disabled      boolean       Set disabled state
 *   property  disabled      boolean       Disabled state
 *   property  value         String        The input value
 *   property  placeholder   String        An optional placeholder
 *   event     change                      When input has changed => fn(ev)
 *   event     enter                       When enter key was pressed => fn(ev)
 * </code></pre>
 */


var GUIText = function (_GUIInput3) {
  _inherits(GUIText, _GUIInput3);

  function GUIText() {
    _classCallCheck(this, GUIText);

    return _possibleConstructorReturn(this, (GUIText.__proto__ || Object.getPrototypeOf(GUIText)).apply(this, arguments));
  }

  _createClass(GUIText, [{
    key: 'build',
    value: function build() {
      createInputOfType(this.$element, 'text');
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIText.__proto__ || Object.getPrototypeOf(GUIText), 'register', this).call(this, {
        tagName: 'gui-text',
        type: 'input'
      }, this);
    }
  }]);

  return GUIText;
}(_GUIInput);

/**
 * Element: 'gui-password'
 *
 * Password input.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value         String        The value/contents
 *   setter    value         String        The value/contents
 *   setter    disabled      boolean       Set disabled state
 *   property  disabled      boolean       Disabled state
 *   property  value         String        The input value
 *   property  placeholder   String        An optional placeholder
 *   event     change                      When input has changed => fn(ev)
 *   event     enter                       When enter key was pressed => fn(ev)
 * </code></pre>
 */


var GUIPassword = function (_GUIInput4) {
  _inherits(GUIPassword, _GUIInput4);

  function GUIPassword() {
    _classCallCheck(this, GUIPassword);

    return _possibleConstructorReturn(this, (GUIPassword.__proto__ || Object.getPrototypeOf(GUIPassword)).apply(this, arguments));
  }

  _createClass(GUIPassword, [{
    key: 'build',
    value: function build() {
      createInputOfType(this.$element, 'password');
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIPassword.__proto__ || Object.getPrototypeOf(GUIPassword), 'register', this).call(this, {
        tagName: 'gui-password',
        type: 'input'
      }, this);
    }
  }]);

  return GUIPassword;
}(_GUIInput);

/**
 * Element: 'gui-file-upload'
 *
 * File upload selector.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     String        The value/contents
 *   setter    value     String        The value/contents
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   event     change                  When input has changed => fn(ev)
 * </code></pre>
 */


var GUIFileUpload = function (_GUIInput5) {
  _inherits(GUIFileUpload, _GUIInput5);

  function GUIFileUpload() {
    _classCallCheck(this, GUIFileUpload);

    return _possibleConstructorReturn(this, (GUIFileUpload.__proto__ || Object.getPrototypeOf(GUIFileUpload)).apply(this, arguments));
  }

  _createClass(GUIFileUpload, [{
    key: 'build',
    value: function build() {
      var input = document.createElement('input');
      input.setAttribute('role', 'button');
      input.setAttribute('type', 'file');
      input.onchange = function (ev) {
        input.dispatchEvent(new CustomEvent('_change', { detail: input.files[0] }));
      };
      this.$element.appendChild(input);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIFileUpload.__proto__ || Object.getPrototypeOf(GUIFileUpload), 'register', this).call(this, {
        tagName: 'gui-file-upload',
        type: 'input'
      }, this);
    }
  }]);

  return GUIFileUpload;
}(_GUIInput);

/**
 * Element: 'gui-radio'
 *
 * Radio selection input.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     boolean       The value/checked state
 *   setter    value     boolean       The value/checked state
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   property  label     String        (Optional) Set a label on the input element
 *   property  group     String        (Optional) A group identificator
 *   event     change                  When input has changed => fn(ev)
 * </code></pre>
 */


var GUIRadio = function (_GUIInput6) {
  _inherits(GUIRadio, _GUIInput6);

  function GUIRadio() {
    _classCallCheck(this, GUIRadio);

    return _possibleConstructorReturn(this, (GUIRadio.__proto__ || Object.getPrototypeOf(GUIRadio)).apply(this, arguments));
  }

  _createClass(GUIRadio, [{
    key: 'build',
    value: function build() {
      createInputOfType(this.$element, 'radio');
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIRadio.__proto__ || Object.getPrototypeOf(GUIRadio), 'register', this).call(this, {
        tagName: 'gui-radio',
        type: 'input'
      }, this);
    }
  }]);

  return GUIRadio;
}(_GUIInput);

/**
 * Element: 'gui-checbox'
 *
 * Checkbox selection input.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     boolean       The value/checked state
 *   setter    value     boolean       The value/checked state
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   property  label     String        (Optional) Set a label on the input element
 *   property  group     String        (Optional) A group identificator
 *   event     change                  When input has changed => fn(ev)
 * </code></pre>
 */


var GUICheckbox = function (_GUIInput7) {
  _inherits(GUICheckbox, _GUIInput7);

  function GUICheckbox() {
    _classCallCheck(this, GUICheckbox);

    return _possibleConstructorReturn(this, (GUICheckbox.__proto__ || Object.getPrototypeOf(GUICheckbox)).apply(this, arguments));
  }

  _createClass(GUICheckbox, [{
    key: 'build',
    value: function build() {
      createInputOfType(this.$element, 'checkbox');
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUICheckbox.__proto__ || Object.getPrototypeOf(GUICheckbox), 'register', this).call(this, {
        tagName: 'gui-checkbox',
        type: 'input'
      }, this);
    }
  }]);

  return GUICheckbox;
}(_GUIInput);

/**
 * Element: 'gui-switch'
 *
 * A switch (on/off) input.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     String        The value/enabled state
 *   setter    value     String        The value/enabled state
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   event     change                  When input has changed => fn(ev)
 * </code></pre>
 */


var GUISwitch = function (_GUIInput8) {
  _inherits(GUISwitch, _GUIInput8);

  function GUISwitch() {
    _classCallCheck(this, GUISwitch);

    return _possibleConstructorReturn(this, (GUISwitch.__proto__ || Object.getPrototypeOf(GUISwitch)).apply(this, arguments));
  }

  _createClass(GUISwitch, [{
    key: 'set',
    value: function set(param, value) {
      if (param === 'value') {
        var input = this.$element.querySelector('input');
        var button = this.$element.querySelector('button');

        setSwitchValue(value, input, button);

        return this;
      }
      return _get(GUISwitch.prototype.__proto__ || Object.getPrototypeOf(GUISwitch.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var input = document.createElement('input');
      input.type = 'checkbox';
      el.appendChild(input);

      var inner = document.createElement('div');

      var button = document.createElement('button');
      inner.appendChild(button);
      GUI.createInputLabel(el, 'switch', inner);

      function toggleValue(v) {
        var val = false;
        if (typeof v === 'undefined') {
          val = !!input.checked;
          val = !val;
        } else {
          val = v;
        }

        setSwitchValue(val, input, button);
      }

      Events.$bind(inner, 'pointerup', function (ev) {
        ev.preventDefault();
        var disabled = el.getAttribute('data-disabled') !== null;
        if (!disabled) {
          toggleValue();
        }
      }, false);

      toggleValue(false);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUISwitch.__proto__ || Object.getPrototypeOf(GUISwitch), 'register', this).call(this, {
        tagName: 'gui-switch',
        type: 'input'
      }, this);
    }
  }]);

  return GUISwitch;
}(_GUIInput);

/**
 * Element: 'gui-button'
 *
 * A normal button
 *
 * <pre><code>
 *   getter    value     String        The value
 *   setter    value     String        The value
 *   setter    icon      String        Icon source
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   property  icon      String        Icon source
 *   event     click                   When input was clicked => fn(ev)
 * </code></pre>
 */


var GUIButton = function (_GUIElement3) {
  _inherits(GUIButton, _GUIElement3);

  function GUIButton() {
    _classCallCheck(this, GUIButton);

    return _possibleConstructorReturn(this, (GUIButton.__proto__ || Object.getPrototypeOf(GUIButton)).apply(this, arguments));
  }

  _createClass(GUIButton, [{
    key: 'set',
    value: function set(param, value, isHTML) {
      if (param === 'value' || param === 'label') {
        var lbl = this.$element.querySelector('button');
        DOM.$empty(lbl);
        if (isHTML) {
          lbl.innerHTML = value;
        } else {
          lbl.appendChild(document.createTextNode(value));
        }

        lbl.setAttribute('aria-label', value);

        return this;
      }
      return _get(GUIButton.prototype.__proto__ || Object.getPrototypeOf(GUIButton.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'create',
    value: function create(params) {
      var label = params.label;
      if (params.label) {
        delete params.label;
      }

      var el = GUI.createElement('gui-button', params);
      if (label) {
        el.appendChild(document.createTextNode(label));
      }
      return el;
    }
  }, {
    key: 'on',
    value: function on(evName, callback, params) {
      var target = this.$element.querySelector('button');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var icon = el.getAttribute('data-icon');
      var disabled = el.getAttribute('data-disabled') !== null;
      var group = el.getAttribute('data-group');
      var label = GUI.getValueLabel(el);
      var input = document.createElement('button');

      function setGroup(g) {
        if (g) {
          input.setAttribute('name', g + '[' + _buttonCount + ']');

          Events.$bind(input, 'pointerup', function () {
            // NOTE: This is probably a bit slow
            var root = el;
            while (root.parentNode) {
              if (root.tagName.toLowerCase() === 'application-window-content') {
                break;
              }
              root = root.parentNode;
            }

            DOM.$addClass(input, 'gui-active');
            root.querySelectorAll('gui-button[data-group="' + g + '"] > button').forEach(function (b) {
              if (b.name === input.name) {
                return;
              }
              DOM.$removeClass(b, 'gui-active');
            });
          });
        }
      }

      function setImage() {
        if (icon && icon !== 'null') {
          var tip = (0, _locales._)(el.getAttribute('data-tooltip') || '');
          var img = document.createElement('img');
          img.src = icon;
          img.alt = tip;
          img.title = tip;

          if (input.firstChild) {
            input.insertBefore(img, input.firstChild);
          } else {
            input.appendChild(img);
          }
          DOM.$addClass(el, 'gui-has-image');
        }
      }

      function setLabel() {
        if (label) {
          DOM.$addClass(el, 'gui-has-label');
        }
        input.appendChild(document.createTextNode(label));
        input.setAttribute('aria-label', label);
      }

      if (disabled) {
        input.setAttribute('disabled', 'disabled');
      }

      setLabel();
      setImage();
      setGroup(group);
      _buttonCount++;

      el.setAttribute('role', 'navigation');
      el.appendChild(input);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIButton.__proto__ || Object.getPrototypeOf(GUIButton), 'register', this).call(this, {
        tagName: 'gui-button',
        type: 'input'
      }, this);
    }
  }]);

  return GUIButton;
}(_element2.default);

var _GUISelect = function (_GUIInput9) {
  _inherits(_GUISelect, _GUIInput9);

  function _GUISelect() {
    _classCallCheck(this, _GUISelect);

    return _possibleConstructorReturn(this, (_GUISelect.__proto__ || Object.getPrototypeOf(_GUISelect)).apply(this, arguments));
  }

  _createClass(_GUISelect, [{
    key: 'add',
    value: function add(arg) {
      addToSelectBox(this.$element, arg);
      return this;
    }
  }, {
    key: 'remove',
    value: function remove(arg) {
      removeFromSelectBox(this.$element, arg);
      return this;
    }
  }, {
    key: 'clear',
    value: function clear() {
      var target = this.$element.querySelector('select');
      DOM.$empty(target);
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var multiple = el.tagName.toLowerCase() === 'gui-select-list';
      createSelectInput(el, multiple);

      return this;
    }
  }]);

  return _GUISelect;
}(_GUIInput);

/**
 * Element: 'gui-select'
 *
 * A selection dropdown.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     String        The value
 *   setter    value     String        The value
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   event     change                  When input has changed => fn(ev)
 *   action    add                     Add elements(s) => fn(entries)
 *   action    clear                   Clear elements => fn()
 *   action    remove                  Removes element => fn(arg)
 * </code></pre>
 *
 * @example
 *   add({
 *    label: "Label",
 *    value: "Value"
 *   })
 */


var GUISelect = function (_GUISelect2) {
  _inherits(GUISelect, _GUISelect2);

  function GUISelect() {
    _classCallCheck(this, GUISelect);

    return _possibleConstructorReturn(this, (GUISelect.__proto__ || Object.getPrototypeOf(GUISelect)).apply(this, arguments));
  }

  _createClass(GUISelect, null, [{
    key: 'register',
    value: function register() {
      return _get(GUISelect.__proto__ || Object.getPrototypeOf(GUISelect), 'register', this).call(this, {
        tagName: 'gui-select',
        type: 'input'
      }, this);
    }
  }]);

  return GUISelect;
}(_GUISelect);

/**
 * Element: 'gui-select-list'
 *
 * A selection list (same as dropdown except multiple)
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     String        The value
 *   setter    value     String        The value
 *   setter    disabled  boolean       Set disabled state
 *   property  disabled  boolean       Disabled state
 *   event     change                  When input has changed => fn(ev)
 *   action    add                     Add elements(s) => fn(entries)
 *   action    clear                   Clear elements => fn()
 *   action    remove                  Removes element => fn(arg)
 * </code></pre>
 */


var GUISelectList = function (_GUISelect3) {
  _inherits(GUISelectList, _GUISelect3);

  function GUISelectList() {
    _classCallCheck(this, GUISelectList);

    return _possibleConstructorReturn(this, (GUISelectList.__proto__ || Object.getPrototypeOf(GUISelectList)).apply(this, arguments));
  }

  _createClass(GUISelectList, null, [{
    key: 'register',
    value: function register() {
      return _get(GUISelectList.__proto__ || Object.getPrototypeOf(GUISelectList), 'register', this).call(this, {
        tagName: 'gui-select-list',
        type: 'input'
      }, this);
    }
  }]);

  return GUISelectList;
}(_GUISelect);

/**
 * Element: 'gui-slider'
 *
 * A slider input.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value     String        The value
 *   setter    value     String        The value
 *   setter    disabled  boolean       Set disabled state
 *   property  min       integer       The minimum value
 *   property  max       integer       The maxmimum value
 *   property  disabled  boolean       Disabled state
 *   event     change                  When input has changed => fn(ev)
 * </code></pre>
 */


var GUISlider = function (_GUIInput10) {
  _inherits(GUISlider, _GUIInput10);

  function GUISlider() {
    _classCallCheck(this, GUISlider);

    return _possibleConstructorReturn(this, (GUISlider.__proto__ || Object.getPrototypeOf(GUISlider)).apply(this, arguments));
  }

  _createClass(GUISlider, [{
    key: 'get',
    value: function get(param) {
      var val = GUI.getProperty(this.$element, param);
      if (param === 'value') {
        return parseInt(val, 10);
      }
      return val;
    }
  }, {
    key: 'build',
    value: function build() {
      createInputOfType(this.$element, 'range');

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUISlider.__proto__ || Object.getPrototypeOf(GUISlider), 'register', this).call(this, {
        tagName: 'gui-slider',
        type: 'input'
      }, this);
    }
  }]);

  return GUISlider;
}(_GUIInput);

/**
 * Element: 'gui-input-modal'
 *
 * A text area displaying current value with a button to open a modal/dialog etc.
 *
 * <pre><code>
 *   getter    value     String        The value
 *   setter    value     String        The value
 *   event     open                    When button was pressed => fn(ev)
 * </code></pre>
 */


var GUIInputModal = function (_GUIElement4) {
  _inherits(GUIInputModal, _GUIElement4);

  function GUIInputModal() {
    _classCallCheck(this, GUIInputModal);

    return _possibleConstructorReturn(this, (GUIInputModal.__proto__ || Object.getPrototypeOf(GUIInputModal)).apply(this, arguments));
  }

  _createClass(GUIInputModal, [{
    key: 'on',
    value: function on(evName, callback, params) {
      if (evName === 'open') {
        evName = '_open';
      }
      Events.$bind(this.$element, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'get',
    value: function get(param) {
      if (param === 'value') {
        var input = this.$element.querySelector('input');
        return input.value;
      }
      return _get(GUIInputModal.prototype.__proto__ || Object.getPrototypeOf(GUIInputModal.prototype), 'get', this).apply(this, arguments);
    }
  }, {
    key: 'set',
    value: function set(param, value) {
      if (param === 'value') {
        var input = this.$element.querySelector('input');
        input.removeAttribute('disabled');
        input.value = value;
        input.setAttribute('disabled', 'disabled');
        input.setAttribute('aria-disabled', 'true');

        return this;
      }
      return _get(GUIInputModal.prototype.__proto__ || Object.getPrototypeOf(GUIInputModal.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var container = document.createElement('div');

      var input = document.createElement('input');
      input.type = 'text';
      input.setAttribute('disabled', 'disabled');

      var button = document.createElement('button');
      button.innerHTML = '...';

      Events.$bind(button, 'pointerup', function (ev) {
        el.dispatchEvent(new CustomEvent('_open', { detail: input.value }));
      }, false);

      container.appendChild(input);
      container.appendChild(button);
      el.appendChild(container);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIInputModal.__proto__ || Object.getPrototypeOf(GUIInputModal), 'register', this).call(this, {
        tagName: 'gui-input-modal',
        type: 'input'
      }, this);
    }
  }]);

  return GUIInputModal;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUILabel: GUILabel,
  GUITextarea: GUITextarea,
  GUIText: GUIText,
  GUIPassword: GUIPassword,
  GUIFileUpload: GUIFileUpload,
  GUIRadio: GUIRadio,
  GUICheckbox: GUICheckbox,
  GUISwitch: GUISwitch,
  GUIButton: GUIButton,
  GUISelect: GUISelect,
  GUISelectList: GUISelectList,
  GUISlider: GUISlider,
  GUIInputModal: GUIInputModal
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _dataview = __webpack_require__(126);

var _dataview2 = _interopRequireDefault(_dataview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

/*
 * This is the function that applies a "fake" header to the table
 * floating on top, containing the resizers.
 *
 * There's no other way to do this perfectly using tables.
 * First attempt was using flexboxes, but it has a severe performance penalty
 * when resizing because you have to repaint ALL the rows manually
 */
function createFakeHeader(el) {

  function createResizers() {
    var fhead = el.querySelector('gui-list-view-fake-head');
    var head = el.querySelector('gui-list-view-head');
    var fcols = fhead.querySelectorAll('gui-list-view-column');
    var cols = head.querySelectorAll('gui-list-view-column');

    fhead.querySelectorAll('gui-list-view-column-resizer').forEach(function (rel) {
      DOM.$remove(rel);
    });

    cols.forEach(function (col, idx) {
      var attr = col.getAttribute('data-resizable');
      if (attr === 'true') {
        var fcol = fcols[idx];

        var resizer = document.createElement('gui-list-view-column-resizer');
        fcol.appendChild(resizer);

        var startWidth = 0;
        var maxWidth = 0;
        var widthOffset = 16;
        var minWidth = widthOffset;
        var tmpEl = null;

        GUI.createDrag(resizer, function (ev) {
          startWidth = col.offsetWidth;
          minWidth = widthOffset; //calculateWidth();
          maxWidth = el.offsetWidth - el.children.length * widthOffset;
        }, function (ev, diff) {
          var newWidth = startWidth - diff.x;

          if (!isNaN(newWidth) && newWidth > minWidth && newWidth < maxWidth) {
            col.style.width = String(newWidth) + 'px';
            fcol.style.width = String(newWidth) + 'px';
          }

          tmpEl = DOM.$remove(tmpEl);
        });
      }
    });
  }

  var fh = el.querySelector('gui-list-view-fake-head gui-list-view-head');
  DOM.$empty(fh);

  var row = el.querySelector('gui-list-view-head gui-list-view-row');
  if (row) {
    fh.appendChild(row.cloneNode(true));
    createResizers();
  }
}

/*
 * Applies DOM changes for a row to be rendered properly
 */
function initRow(cls, row) {
  var el = cls.$element;

  row.querySelectorAll('gui-list-view-column').forEach(function (cel, idx) {
    var icon = cel.getAttribute('data-icon');
    if (icon && icon !== 'null') {
      DOM.$addClass(cel, 'gui-has-image');
      cel.style.backgroundImage = 'url(' + icon + ')';
    }

    var text = cel.firstChild;
    if (text && text.nodeType === 3) {
      var span = document.createElement('span');
      span.appendChild(document.createTextNode(text.nodeValue));
      cel.insertBefore(span, text);
      cel.removeChild(text);
    }

    if (el._columns[idx] && !el._columns[idx].visible) {
      cel.style.display = 'none';
    }

    cel.setAttribute('role', 'listitem');
  });

  cls.bindEntryEvents(row, 'gui-list-view-row');
}

/*
 * Creates a new `gui-list-view-column`
 */
function createEntry(cls, v, head) {
  var label = v.label || '';

  if (v.label) {
    delete v.label;
  }

  var setSize = null;
  if (v.size) {
    setSize = v.size;
    delete v.size;
  }

  var nel = GUI.createElement('gui-list-view-column', v);
  if (setSize) {
    nel.style.width = setSize;
  }

  if (typeof label === 'function') {
    nel.appendChild(label.call(nel, nel, v));
  } else {
    var span = document.createElement('span');
    span.appendChild(document.createTextNode(label));
    nel.appendChild(span);
  }

  return nel;
}

/*
 * Creates a new `gui-list-view-row` from iter
 */
function createRow(cls, e) {
  e = e || {};
  if (e.columns) {
    var row = GUI.createElement('gui-list-view-row', e, ['columns']);

    e.columns.forEach(function (se) {
      row.appendChild(createEntry(cls, se));
    });

    return row;
  }
  return null;
}

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-list-view'
 *
 * A list view with columns.
 *
 * <pre><code>
 *   Parameters:
 *    zebra     boolean       Enable zebra stripes
 *
 *   Setters:
 *    columns(arr)  Sets the columns
 * </code></pre>
 *
 * @example
 *
 * .set('columns', [
 *      {label: "Column 1", size: "100px"},
 *      {label: "Column 2", size: "100px", visible: false},
 *      {label: "Column 3", size: "100px", textalign: "right"},
 *      {label: "Column 4", size: "100px", textalign: "right"}
 * ])
 *
 * @example
 *
 * .add([
 *   {
 *      value: "something or JSON or whatever",
 *      columns: [
 *        {label: "Value for column 1", icon: "Optional icon"},
 *        {label: "Value for column 2", icon: "Optional icon"},
 *        {label: "Value for column 3", icon: "Optional icon"},
 *        {label: "Value for column 4", icon: "Optional icon"},
 *      ]
 *   }
 * ])
 */

var GUIListView = function (_GUIDataView) {
  _inherits(GUIListView, _GUIDataView);

  function GUIListView() {
    _classCallCheck(this, GUIListView);

    return _possibleConstructorReturn(this, (GUIListView.__proto__ || Object.getPrototypeOf(GUIListView)).apply(this, arguments));
  }

  _createClass(GUIListView, [{
    key: 'values',
    value: function values() {
      var body = this.$element.querySelector('gui-list-view-body');
      var values = this.getSelected(body.querySelectorAll('gui-list-view-row'));
      return values;
    }
  }, {
    key: 'get',
    value: function get(param, value, arg, asValue) {
      if (param === 'entry') {
        var body = this.$element.querySelector('gui-list-view-body');
        var rows = body.querySelectorAll('gui-list-view-row');
        return this.getEntry(rows, value, arg, asValue);
      }
      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'get', this).apply(this, arguments);
    }
  }, {
    key: 'set',
    value: function set(param, value, arg, arg2) {
      var _this2 = this;

      var el = this.$element;

      if (param === 'columns') {
        var head = el.querySelector('gui-list-view-head');
        var row = document.createElement('gui-list-view-row');
        DOM.$empty(head);

        el._columns = [];

        value.forEach(function (v) {
          v.visible = typeof v.visible === 'undefined' || v.visible === true;

          var nel = createEntry(_this2, v, true);

          el._columns.push(v);

          if (!v.visible) {
            nel.style.display = 'none';
          }
          row.appendChild(nel);
        });

        head.appendChild(row);

        createFakeHeader(el);
        return this;
      } else if (param === 'selected' || param === 'value') {
        var body = el.querySelector('gui-list-view-body');
        this.setSelected(body, body.querySelectorAll('gui-list-view-row'), value, arg, arg2);
        return this;
      }

      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'add',
    value: function add(entries) {
      var _this3 = this;

      var body = this.$element.querySelector('gui-list-view-body');

      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'add', this).call(this, entries, function (cls, e) {
        var cbCreated = e.onCreated || function () {};
        var row = createRow(_this3, e);
        if (row) {
          body.appendChild(row);
          initRow(_this3, row);
        }

        cbCreated(row);
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      var body = this.$element.querySelector('gui-list-view-body');
      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'clear', this).call(this, body);
    }
  }, {
    key: 'remove',
    value: function remove(entries) {
      var body = this.$element.querySelector('gui-list-view-body');
      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'remove', this).call(this, entries, 'gui-list-view-row', null, body);
    }
  }, {
    key: 'patch',
    value: function patch(entries) {
      var body = this.$element.querySelector('gui-list-view-body');
      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'patch', this).call(this, entries, 'gui-list-view-row', body, createRow, initRow);
    }
  }, {
    key: 'build',
    value: function build() {
      var _this4 = this;

      var el = this.$element;
      el._columns = [];

      // Make sure base elements are in the dom
      var inner = el.querySelector('gui-list-view-inner');
      var head = el.querySelector('gui-list-view-head');
      var body = el.querySelector('gui-list-view-body');

      function moveIntoInner(cel) {
        // So user can forget adding the inner
        if (cel.parentNode.tagName !== 'GUI-LIST-VIEW-INNER') {
          inner.appendChild(cel);
        }
      }

      var fakeHead = el.querySelector('gui-list-view-fake-head');
      if (!fakeHead) {
        fakeHead = document.createElement('gui-list-view-fake-head');
        var fakeHeadInner = document.createElement('gui-list-view-inner');
        fakeHeadInner.appendChild(document.createElement('gui-list-view-head'));
        fakeHead.appendChild(fakeHeadInner);
      }

      if (!inner) {
        inner = document.createElement('gui-list-view-inner');
        el.appendChild(inner);
      }

      (function _createBody() {
        if (body) {
          moveIntoInner(body);
        } else {
          body = document.createElement('gui-list-view-body');
          inner.appendChild(body);
        }
        body.setAttribute('role', 'group');
      })();

      (function _createHead() {
        if (head) {
          moveIntoInner(head);
        } else {
          head = document.createElement('gui-list-view-head');
          inner.insertBefore(head, body);
        }
        head.setAttribute('role', 'group');
      })();

      el.setAttribute('role', 'list');
      el.appendChild(fakeHead);

      Events.$bind(el, 'scroll', function (ev) {
        fakeHead.style.top = el.scrollTop + 'px';
      }, false);

      // Create scheme defined header
      var hcols = el.querySelectorAll('gui-list-view-head gui-list-view-column');
      hcols.forEach(function (cel, idx) {
        var vis = cel.getAttribute('data-visible');
        var iter = {
          visible: vis === null || vis === 'true',
          size: cel.getAttribute('data-size')
        };

        if (iter.size) {
          cel.style.width = iter.size;
        }

        el._columns.push(iter);

        if (!iter.visible) {
          cel.style.display = 'none';
        }
      });

      createFakeHeader(el);

      // Create scheme defined rows
      el.querySelectorAll('gui-list-view-body gui-list-view-row').forEach(function (row) {
        initRow(_this4, row);
      });

      return _get(GUIListView.prototype.__proto__ || Object.getPrototypeOf(GUIListView.prototype), 'build', this).apply(this, arguments);
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIListView.__proto__ || Object.getPrototypeOf(GUIListView), 'register', this).call(this, {
        parent: _dataview2.default,
        tagName: 'gui-list-view'
      }, this);
    }
  }]);

  return GUIListView;
}(_dataview2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIListView: GUIListView
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _menu = __webpack_require__(90);

var Menu = _interopRequireWildcard(_menu);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

//import * as Compability from 'utils/compability';


var debounce = void 0;

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function getSelectionEventAttribs(mel, didx) {
  var id = mel.getAttribute('data-id');

  var idx = DOM.$index(mel);
  if (!didx) {
    idx = parseInt(mel.getAttribute('data-index'), 10);
  }

  var result = { index: idx, id: id };
  Array.prototype.slice.call(mel.attributes).forEach(function (item) {
    if (item.name.match(/^data\-/)) {
      var an = item.name.replace(/^data\-/, '');
      if (typeof result[an] === 'undefined') {
        result[an] = item.value;
      }
    }
  });

  return result;
}

function getEventName(evName) {
  if (['select', 'click'].indexOf(evName) !== -1) {
    return '_select';
  }
  return evName;
}

function runChildren(pel, level, winRef, cb) {
  level = level || 0;
  cb = cb || function () {};

  if (pel.children) {
    pel.children.forEach(function (child, i) {
      if (child && child.tagName.toLowerCase() === 'gui-menu-entry') {
        _element2.default.createFromNode(child).build(null, winRef);

        cb(child, level);
      }
    });
  }
}

function onEntryClick(ev, pos, target, original) {
  var isExpander = !!target.querySelector('gui-menu');

  if (!isExpander) {
    var dispatcher = (original || target).querySelector('label');
    dispatcher.dispatchEvent(new CustomEvent('_select', { detail: getSelectionEventAttribs(target, true) }));
  }
}

function createTyped(child, par) {
  var type = child.getAttribute('data-type');
  var value = child.getAttribute('data-checked') === 'true';

  var input = null;
  if (type) {
    var group = child.getAttribute('data-group');
    input = document.createElement('input');
    input.type = type;
    input.name = group ? group + '[]' : '';
    if (value) {
      input.setAttribute('checked', 'checked');
    }

    par.setAttribute('role', 'menuitem' + type);
    par.appendChild(input);
  }
}

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-menu-entry'
 *
 * An entry for a menu.
 *
 * <pre><code>
 *   Events:
 *    select        When an entry was selected (click) => fn(ev)
 * <pre><code>
 */

var GUIMenuEntry = function (_GUIElement) {
  _inherits(GUIMenuEntry, _GUIElement);

  function GUIMenuEntry() {
    _classCallCheck(this, GUIMenuEntry);

    return _possibleConstructorReturn(this, (GUIMenuEntry.__proto__ || Object.getPrototypeOf(GUIMenuEntry)).apply(this, arguments));
  }

  _createClass(GUIMenuEntry, [{
    key: 'on',
    value: function on(evName, callback, params) {
      evName = getEventName(evName);
      var target = this.$element.querySelector('gui-menu-entry > label');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build(arg, winRef) {
      var child = this.$element;
      if (arguments.length < 2) {
        return this;
      }
      child.setAttribute('role', 'menuitem' + (child.getAttribute('data-type') || ''));

      var label = GUI.getLabel(child);
      var icon = GUI.getIcon(child, winRef);
      child.setAttribute('aria-label', label);

      var span = document.createElement('label');
      if (icon) {
        child.style.backgroundImage = 'url(' + icon + ')';
        DOM.$addClass(span, 'gui-has-image');
      }
      child.appendChild(span);

      createTyped(child, span);

      if (child.getAttribute('data-labelhtml') === 'true') {
        span.innerHTML = label;
      } else {
        span.appendChild(document.createTextNode(label));
      }

      if (child.querySelector('gui-menu')) {
        DOM.$addClass(child, 'gui-menu-expand');
        child.setAttribute('aria-haspopup', 'true');
      } else {
        child.setAttribute('aria-haspopup', 'false');
      }

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIMenuEntry.__proto__ || Object.getPrototypeOf(GUIMenuEntry), 'register', this).call(this, {
        tagName: 'gui-menu-entry'
      }, this);
    }
  }]);

  return GUIMenuEntry;
}(_element2.default);

/**
 * Element: 'gui-menu'
 *
 * A normal menu (also contextmenu)
 *
 * <pre><code>
 *   Events:
 *    select        When an entry was selected (click) => fn(ev)
 *
 *   Setters:
 *    checked       Set checkbox/option checked value
 * </code></pre>
 */


var GUIMenu = function (_GUIElement2) {
  _inherits(GUIMenu, _GUIElement2);

  function GUIMenu() {
    _classCallCheck(this, GUIMenu);

    return _possibleConstructorReturn(this, (GUIMenu.__proto__ || Object.getPrototypeOf(GUIMenu)).apply(this, arguments));
  }

  _createClass(GUIMenu, [{
    key: 'on',
    value: function on(evName, callback, params) {
      evName = getEventName(evName);

      Events.$bind(this.$element, evName, function (ev) {
        if (ev.target.tagName === 'LABEL') {
          callback.apply(new _element2.default(ev.target.parentNode), arguments);
        }
      }, true);

      return this;
    }
  }, {
    key: 'show',
    value: function show(ev) {
      ev.stopPropagation();
      ev.preventDefault();

      // This is to use a menu-bar > menu as a contextmenu
      var newNode = this.$element.cloneNode(true);
      Menu.create(null, ev, newNode);
    }
  }, {
    key: 'set',
    value: function set(param, value, arg) {
      if (param === 'checked') {
        var found = this.$element.querySelector('gui-menu-entry[data-id="' + value + '"]');
        if (found) {
          var input = found.querySelector('input');
          if (input) {
            if (arg) {
              input.setAttribute('checked', 'checked');
            } else {
              input.removeAttribute('checked');
            }
          }
        }
        return this;
      }
      return _get(GUIMenu.prototype.__proto__ || Object.getPrototypeOf(GUIMenu.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build(customMenu, winRef) {
      var el = this.$element;
      el.setAttribute('role', 'menu');

      try {
        runChildren(el, 0, winRef, function (child, level) {
          if (customMenu) {
            if (child) {
              var submenus = child.getElementsByTagName('gui-menu');
              submenus.forEach(function (sub) {
                if (sub) {
                  runChildren(sub, level + 1, winRef);
                }
              });
            }
          }
        });
      } catch (e) {
        console.warn(e);
      }

      if (!customMenu) {
        Events.$bind(el, 'click', function (ev, pos) {
          clearTimeout(debounce);
          debounce = setTimeout(function () {
            debounce = clearTimeout(debounce);
            Menu.clickWrapper(ev, pos, onEntryClick);
          }, 1);
        }, true);
      }

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIMenu.__proto__ || Object.getPrototypeOf(GUIMenu), 'register', this).call(this, {
        tagName: 'gui-menu'
      }, this);
    }
  }]);

  return GUIMenu;
}(_element2.default);

/**
 * Element: 'gui-menu-bar'
 *
 * A menubar with sub-menus
 *
 * <pre><code>
 *   event     select               When an entry was selected (click) => fn(ev)
 * </code></pre>
 */


var GUIMenuBar = function (_GUIElement3) {
  _inherits(GUIMenuBar, _GUIElement3);

  function GUIMenuBar() {
    _classCallCheck(this, GUIMenuBar);

    return _possibleConstructorReturn(this, (GUIMenuBar.__proto__ || Object.getPrototypeOf(GUIMenuBar)).apply(this, arguments));
  }

  _createClass(GUIMenuBar, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var _this4 = this;

      evName = getEventName(evName);

      this.$element.querySelectorAll('gui-menu-bar-entry').forEach(function (target) {
        Events.$bind(target, evName, callback.bind(_this4), params);
      });

      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      el.setAttribute('role', 'menubar');

      function updateChildren(sm, level) {
        if (sm && sm.children) {
          var children = sm.children;

          var child = void 0;
          for (var i = 0; i < children.length; i++) {
            child = children[i];
            if (child.tagName === 'GUI-MENU-ENTRY') {
              child.setAttribute('aria-haspopup', String(!!child.firstChild));
              updateChildren(child.firstChild, level + 1);
            }
          }
        }
      }

      function _onClick(ev) {
        ev.preventDefault();

        var mel = ev.target;
        var submenu = mel.querySelector('gui-menu');

        if (mel.getAttribute('data-disabled') === 'true') {
          return;
        }

        mel.querySelectorAll('gui-menu-entry').forEach(function (c) {
          DOM.$removeClass(c, 'gui-hover');
        });

        if (submenu) {
          Menu.setActive(function (ev) {
            if (ev instanceof window.Event) {
              ev.stopPropagation();
            }
            DOM.$removeClass(mel, 'gui-active');
          });
        }

        if (DOM.$hasClass(mel, 'gui-active')) {
          if (submenu) {
            DOM.$removeClass(mel, 'gui-active');
          }
        } else {
          if (submenu) {
            DOM.$addClass(mel, 'gui-active');
          }

          mel.dispatchEvent(new CustomEvent('_select', { detail: getSelectionEventAttribs(mel) }));
        }
      }

      el.querySelectorAll('gui-menu-bar-entry').forEach(function (mel, idx) {
        var label = GUI.getLabel(mel);

        var span = document.createElement('span');
        span.appendChild(document.createTextNode(label));

        mel.setAttribute('role', 'menuitem');

        mel.insertBefore(span, mel.firstChild);

        var submenu = mel.querySelector('gui-menu');

        Menu.clamp(submenu);

        mel.setAttribute('aria-haspopup', String(!!submenu));
        mel.setAttribute('data-index', String(idx));

        updateChildren(submenu, 2);
      });

      Events.$bind(el, 'click', function (ev) {
        if (ev.target.tagName === 'GUI-MENU-BAR-ENTRY') {
          _onClick(ev);
        }
      }, true);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIMenuBar.__proto__ || Object.getPrototypeOf(GUIMenuBar), 'register', this).call(this, {
        tagName: 'gui-menu-bar'
      }, this);
    }
  }]);

  return GUIMenuBar;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIMenuEntry: GUIMenuEntry,
  GUIMenuBar: GUIMenuBar,
  GUIMenu: GUIMenu
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _colors = __webpack_require__(199);

var Colors = _interopRequireWildcard(_colors);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/////////////////////////////////////////////////////////////////////////////
// CLASSES
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-color-box'
 *
 * A box that displays a color.
 *
 * <pre><code>
 *   getter    value   String        The value (color)
 *   setter    value   String        The value (color)
 * </code></pre>
 */
var GUIColorBox = function (_GUIElement) {
  _inherits(GUIColorBox, _GUIElement);

  function GUIColorBox() {
    _classCallCheck(this, GUIColorBox);

    return _possibleConstructorReturn(this, (GUIColorBox.__proto__ || Object.getPrototypeOf(GUIColorBox)).apply(this, arguments));
  }

  _createClass(GUIColorBox, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var el = this.$element;
      var target = el.querySelector('div');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'set',
    value: function set(param, value) {
      if (param === 'value') {
        this.$element.firstChild.style.backgroundColor = value;
        return this;
      }
      return _get(GUIColorBox.prototype.__proto__ || Object.getPrototypeOf(GUIColorBox.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var inner = document.createElement('div');
      this.$element.appendChild(inner);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIColorBox.__proto__ || Object.getPrototypeOf(GUIColorBox), 'register', this).call(this, {
        tagName: 'gui-color-box'
      }, this);
    }
  }]);

  return GUIColorBox;
}(_element2.default);

/**
 * Element: 'gui-color-swatch'
 *
 * A box for selecting color(s) in the rainbow.
 *
 * See `ev.detail` for data on events (like on 'change').
 *
 * <pre><code>
 *   getter    value   String        The value (color)
 *   setter    value   String        The value (color)
 *   event     change                When input has changed => fn(ev)
 * </code></pre>
 */


var GUIColorSwatch = function (_GUIElement2) {
  _inherits(GUIColorSwatch, _GUIElement2);

  function GUIColorSwatch() {
    _classCallCheck(this, GUIColorSwatch);

    return _possibleConstructorReturn(this, (GUIColorSwatch.__proto__ || Object.getPrototypeOf(GUIColorSwatch)).apply(this, arguments));
  }

  _createClass(GUIColorSwatch, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var el = this.$element;
      var target = el.querySelector('canvas');
      if (evName === 'select' || evName === 'change') {
        evName = '_change';
      }
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var cv = document.createElement('canvas');
      cv.width = 100;
      cv.height = 100;

      var ctx = cv.getContext('2d');

      var gradient = ctx.createLinearGradient(0, 0, ctx.canvas.width, 0);

      function getColor(ev) {
        var pos = DOM.$position(cv);
        var cx = typeof ev.offsetX === 'undefined' ? ev.clientX - pos.left : ev.offsetX;
        var cy = typeof ev.offsetY === 'undefined' ? ev.clientY - pos.top : ev.offsetY;

        if (isNaN(cx) || isNaN(cy)) {
          return null;
        }

        var data = ctx.getImageData(cx, cy, 1, 1).data;
        return {
          r: data[0],
          g: data[1],
          b: data[2],
          hex: Colors.convertToHEX(data[0], data[1], data[2])
        };
      }

      gradient.addColorStop(0, 'rgb(255,   0,   0)');
      gradient.addColorStop(0.15, 'rgb(255,   0, 255)');
      gradient.addColorStop(0.33, 'rgb(0,     0, 255)');
      gradient.addColorStop(0.49, 'rgb(0,   255, 255)');
      gradient.addColorStop(0.67, 'rgb(0,   255,   0)');
      gradient.addColorStop(0.84, 'rgb(255, 255,   0)');
      gradient.addColorStop(1, 'rgb(255,   0,   0)');

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
      gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
      gradient.addColorStop(0.5, 'rgba(255, 255, 255, 0)');
      gradient.addColorStop(0.5, 'rgba(0,     0,   0, 0)');
      gradient.addColorStop(1, 'rgba(0,     0,   0, 1)');

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      Events.$bind(cv, 'pointerdown', function (ev) {
        var c = getColor(ev);
        if (c) {
          cv.dispatchEvent(new CustomEvent('_change', { detail: c }));
        }
      }, false);

      el.appendChild(cv);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIColorSwatch.__proto__ || Object.getPrototypeOf(GUIColorSwatch), 'register', this).call(this, {
        tagName: 'gui-color-swatch'
      }, this);
    }
  }]);

  return GUIColorSwatch;
}(_element2.default);

/**
 * Element: 'gui-iframe'
 *
 * IFrame container. On NW/Electron/X11 this is a "webview"
 *
 * <pre><code>
 *   property  src     String        The source (src)
 * </code></pre>
 */


var GUIIframe = function (_GUIElement3) {
  _inherits(GUIIframe, _GUIElement3);

  function GUIIframe() {
    _classCallCheck(this, GUIIframe);

    return _possibleConstructorReturn(this, (GUIIframe.__proto__ || Object.getPrototypeOf(GUIIframe)).apply(this, arguments));
  }

  _createClass(GUIIframe, [{
    key: 'set',
    value: function set(key, val) {
      if (key === 'src') {
        this.$element.querySelector(GUIIframe._tagName).src = val;
        return this;
      }
      return _get(GUIIframe.prototype.__proto__ || Object.getPrototypeOf(GUIIframe.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var src = el.getAttribute('data-src') || 'about:blank';
      var iframe = document.createElement(GUIIframe._tagName);
      iframe.src = src;
      iframe.setAttribute('border', 0);
      el.appendChild(iframe);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIIframe.__proto__ || Object.getPrototypeOf(GUIIframe), 'register', this).call(this, {
        tagName: 'gui-iframe'
      }, this);
    }
  }, {
    key: '_tagName',
    get: function get() {
      var isStandalone = false;

      try {
        isStandalone = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
      } catch (e) {}

      return isStandalone ? 'webview' : 'iframe';
    }
  }]);

  return GUIIframe;
}(_element2.default);

/**
 * Element: 'gui-progress-bar'
 *
 * Progress bar element.
 *
 * <pre><code>
 *   setter    progress    integer     Progress value (percentage)
 *   property  progress    integer     Progress value (percentage)
 * </code></pre>
 */


var GUIProgressBar = function (_GUIElement4) {
  _inherits(GUIProgressBar, _GUIElement4);

  function GUIProgressBar() {
    _classCallCheck(this, GUIProgressBar);

    return _possibleConstructorReturn(this, (GUIProgressBar.__proto__ || Object.getPrototypeOf(GUIProgressBar)).apply(this, arguments));
  }

  _createClass(GUIProgressBar, [{
    key: 'set',
    value: function set(param, value) {
      var el = this.$element;
      el.setAttribute('data-' + param, value);
      if (param === 'progress' || param === 'value') {
        value = parseInt(value, 10);
        value = Math.max(0, Math.min(100, value));

        el.setAttribute('aria-label', String(value));
        el.setAttribute('aria-valuenow', String(value));

        el.querySelector('div').style.width = value.toString() + '%';
        el.querySelector('span').innerHTML = value + '%';
        return this;
      }

      return _get(GUIProgressBar.prototype.__proto__ || Object.getPrototypeOf(GUIProgressBar.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;

      var p = el.getAttribute('data-progress') || 0;
      p = Math.max(0, Math.min(100, p));

      var percentage = p.toString() + '%';

      var progress = document.createElement('div');
      progress.style.width = percentage;

      var span = document.createElement('span');
      span.appendChild(document.createTextNode(percentage));

      el.setAttribute('role', 'progressbar');
      el.setAttribute('aria-valuemin', 0);
      el.setAttribute('aria-valuemax', 100);
      el.setAttribute('aria-label', 0);
      el.setAttribute('aria-valuenow', 0);

      el.appendChild(progress);
      el.appendChild(span);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIProgressBar.__proto__ || Object.getPrototypeOf(GUIProgressBar), 'register', this).call(this, {
        tagName: 'gui-progress-bar'
      }, this);
    }
  }]);

  return GUIProgressBar;
}(_element2.default);

/**
 * Element: 'gui-statusbar'
 *
 * Status bar element.
 *
 * <pre><code>
 *   setter    value       String      Content to set
 *   setter    label       String      Alias of 'value'
 * </code></pre>
 */


var GUIStatusBar = function (_GUIElement5) {
  _inherits(GUIStatusBar, _GUIElement5);

  function GUIStatusBar() {
    _classCallCheck(this, GUIStatusBar);

    return _possibleConstructorReturn(this, (GUIStatusBar.__proto__ || Object.getPrototypeOf(GUIStatusBar)).apply(this, arguments));
  }

  _createClass(GUIStatusBar, [{
    key: 'set',
    value: function set(param, value) {
      if (param === 'label' || param === 'value') {
        var span = this.$element.getElementsByTagName('gui-statusbar-label')[0];
        if (span) {
          DOM.$empty(span);
          span.innerHTML = value;
        }
        return this;
      }
      return _get(GUIStatusBar.prototype.__proto__ || Object.getPrototypeOf(GUIStatusBar.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'build',
    value: function build(args, win) {
      var el = this.$element;
      var span = document.createElement('gui-statusbar-label');

      var lbl = el.getAttribute('data-label') || el.getAttribute('data-value');
      if (!lbl) {
        lbl = function () {
          var textNodes = [];
          var node = void 0,
              value = void 0;
          for (var i = 0; i < el.childNodes.length; i++) {
            node = el.childNodes[i];
            if (node.nodeType === Node.TEXT_NODE) {
              value = node.nodeValue.replace(/\s+/g, '').replace(/^\s+/g, '');
              if (value.length > 0) {
                textNodes.push(value);
              }

              el.removeChild(node);
              i++;
            }
          }

          return textNodes.join(' ');
        }();
      }

      span.innerHTML = lbl;
      el.setAttribute('role', 'log');
      el.appendChild(span);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIStatusBar.__proto__ || Object.getPrototypeOf(GUIStatusBar), 'register', this).call(this, {
        tagName: 'gui-statusbar'
      }, this);
    }
  }]);

  return GUIStatusBar;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIColorBox: GUIColorBox,
  GUIColorSwatch: GUIColorSwatch,
  GUIIframe: GUIIframe,
  GUIProgressBar: GUIProgressBar,
  GUIStatusBar: GUIStatusBar
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _theme = __webpack_require__(60);

var _theme2 = _interopRequireDefault(_theme);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function getDocument(el, iframe) {
  iframe = iframe || el.querySelector('iframe');
  return iframe.contentDocument || iframe.contentWindow.document;
}

function getDocumentData(el) {
  try {
    var doc = getDocument(el);
    return doc.body.innerHTML;
  } catch (error) {
    console.error('gui-richtext', 'getDocumentData()', error.stack, error);
  }
  return '';
}

function destroyFixInterval(el) {
  el._fixTry = 0;
  el._fixInterval = clearInterval(el._fixInterval);
}

function createFixInterval(el, doc, text) {
  if (el._fixTry > 10) {
    el._fixTry = 0;
    return;
  }

  el._fixInterval = setInterval(function () {
    try {
      if (text) {
        doc.body.innerHTML = text;
      }
      destroyFixInterval(el);
    } catch (error) {
      console.warn('gui-richtext', 'setDocumentData()', error.stack, error, '... trying again');
    }
    el._fixTry++;
  }, 100);
}

function setDocumentData(el, text) {
  destroyFixInterval(el);

  text = text || '';

  var themeName = _theme2.default.getStyleTheme();
  var themeSrc = '/themes.css';
  var editable = el.getAttribute('data-editable');
  editable = editable === null || editable === 'true';

  function onMouseDown(ev) {
    function insertTextAtCursor(text) {
      var sel = void 0,
          range = void 0;
      if (window.getSelection) {
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();
          range.insertNode(document.createTextNode(text));
        }
      } else if (document.selection && document.selection.createRange) {
        document.selection.createRange().text = text;
      }
    }

    if (ev.keyCode === 9) {
      /*
      const t = ev.shiftKey ? "outdent" : "indent";
      document.execCommand("styleWithCSS",true,null);
      document.execCommand(t, false, null)
      */
      insertTextAtCursor('\xA0');
      ev.preventDefault();
    }
  }

  var script = onMouseDown.toString() + ';window.addEventListener("keydown", onMouseDown)';

  var template = '<!DOCTYPE html><html><head><link rel="stylesheet" type="text/css" href="' + themeSrc + '" /><script>' + script + '</script></head><body contentEditable="true" data-style-theme="' + themeName + '"></body></html>';
  if (!editable) {
    template = template.replace(' contentEditable="true"', '');
  }

  var doc = getDocument(el);
  doc.open();
  doc.write(template);
  doc.close();
  createFixInterval(el, doc, text);
}

/////////////////////////////////////////////////////////////////////////////
// CLASSES
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-richtext'
 *
 * "Richt text" input area.
 *
 * <pre><code>
 *   getter    value   String        The value/contents
 *   setter    value   String        The value/contents
 * </code></pre>
 */

var GUIRichText = function (_GUIElement) {
  _inherits(GUIRichText, _GUIElement);

  function GUIRichText() {
    _classCallCheck(this, GUIRichText);

    return _possibleConstructorReturn(this, (GUIRichText.__proto__ || Object.getPrototypeOf(GUIRichText)).apply(this, arguments));
  }

  _createClass(GUIRichText, [{
    key: 'on',
    value: function on(evName, callback, params) {
      if (['selection'].indexOf(evName) !== -1) {
        evName = '_' + evName;
      }
      Events.$bind(this.$element, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var text = el.childNodes.length ? el.childNodes[0].nodeValue : '';

      DOM.$empty(el);

      var iframe = document.createElement('iframe');
      iframe.setAttribute('border', 0);
      iframe.onload = function () {
        iframe.contentWindow.addEventListener('selectstart', function () {
          el.dispatchEvent(new CustomEvent('_selection', { detail: {} }));
        });
        iframe.contentWindow.addEventListener('pointerup', function () {
          el.dispatchEvent(new CustomEvent('_selection', { detail: {} }));
        });
      };
      el.appendChild(iframe);

      setTimeout(function () {
        try {
          setDocumentData(el, text);
        } catch (e) {
          console.warn('gui-richtext', 'build()', e);
        }
      }, 1);

      return this;
    }
  }, {
    key: 'command',
    value: function command() {
      try {
        var doc = getDocument(this.$element);
        if (doc && doc.execCommand) {
          return doc.execCommand.apply(doc, arguments);
        }
      } catch (e) {
        console.warn('gui-richtext call() warning', e.stack, e);
      }
      return this;
    }
  }, {
    key: 'query',
    value: function query() {
      try {
        var doc = getDocument(this.$element);
        if (doc && doc.queryCommandValue) {
          return doc.queryCommandValue.apply(doc, arguments);
        }
      } catch (e) {
        console.warn('gui-richtext call() warning', e.stack, e);
      }
      return null;
    }
  }, {
    key: 'get',
    value: function get(param, value) {
      if (param === 'value') {
        return getDocumentData(this.$element);
      }
      return _get(GUIRichText.prototype.__proto__ || Object.getPrototypeOf(GUIRichText.prototype), 'get', this).apply(this, arguments);
    }
  }, {
    key: 'set',
    value: function set(param, value) {
      if (param === 'value') {
        setDocumentData(this.$element, value);
        return this;
      }
      return _get(GUIRichText.prototype.__proto__ || Object.getPrototypeOf(GUIRichText.prototype), 'set', this).apply(this, arguments);
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIRichText.__proto__ || Object.getPrototypeOf(GUIRichText), 'register', this).call(this, {
        tagName: 'gui-richtext'
      }, this);
    }
  }]);

  return GUIRichText;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIRichText: GUIRichText
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function toggleActive(el, eidx, idx) {
  DOM.$removeClass(el, 'gui-active');
  if (eidx === idx) {
    DOM.$addClass(el, 'gui-active');
  }
}

function selectTab(el, tabs, ev, idx, tab) {
  tabs.querySelectorAll('li').forEach(function (tel, eidx) {
    toggleActive(tel, eidx, idx);
  });

  el.querySelectorAll('gui-tab-container').forEach(function (tel, eidx) {
    toggleActive(tel, eidx, idx);
  });

  DOM.$addClass(tab, 'gui-active');

  el.dispatchEvent(new CustomEvent('_change', { detail: { index: idx } }));
}

function findTab(el, tabs, idx) {
  var found = null;
  if (typeof idx === 'number') {
    found = idx;
  } else {
    tabs.querySelectorAll('li').forEach(function (iter, i) {
      if (found === null && iter.firstChild.textContent === idx) {
        found = i;
      }
    });
  }
  return found;
}

function removeTab(el, tabs, idx) {
  var found = findTab(el, tabs, idx);
  if (found !== null) {
    tabs.children[found].remove();
    el.querySelectorAll('gui-tab-container')[found].remove();
  }
}

function createTab(el, tabs, label, prog) {
  var tab = document.createElement('li');
  var idx = tabs.children.length;

  Events.$bind(tab, 'pointerdown', function (ev) {
    selectTab(el, tabs, ev, idx, tab);
  }, false);

  tab.setAttribute('role', 'tab');
  tab.setAttribute('aria-label', label);
  tab.appendChild(document.createTextNode(label));
  tabs.appendChild(tab);

  if (prog) {
    var tel = document.createElement('gui-tab-container');
    tel.setAttribute('data-label', label);
    tel.setAttribute('role', 'tabpanel');
    el.appendChild(tel);
  }
}

/////////////////////////////////////////////////////////////////////////////
// CLASSES
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-tabs'
 *
 * A container with tabs for displaying content.
 *
 * <pre><code>
 *   event     select                    When tab has changed => fn(ev)
 *   event     activate                  Alias of 'select'
 * </code></pre>
 */

var GUITabs = function (_GUIElement) {
  _inherits(GUITabs, _GUIElement);

  function GUITabs() {
    _classCallCheck(this, GUITabs);

    return _possibleConstructorReturn(this, (GUITabs.__proto__ || Object.getPrototypeOf(GUITabs)).apply(this, arguments));
  }

  _createClass(GUITabs, [{
    key: 'on',
    value: function on(evName, callback, params) {
      if (['select', 'activate'].indexOf(evName) !== -1) {
        evName = 'change';
      }
      if (evName === 'change') {
        evName = '_' + evName;
      }

      Events.$bind(this.$element, evName, callback.bind(this), params);

      return this;
    }
  }, {
    key: 'set',
    value: function set(param, value) {
      if (['current', 'selected', 'active'].indexOf(param) !== -1) {
        var el = this.$element;
        var tabs = el.querySelector('ul');
        var found = findTab(el, tabs, value);
        if (found !== null) {
          selectTab(el, tabs, null, found, tabs[found]);
        }

        return this;
      }
      return _get(GUITabs.prototype.__proto__ || Object.getPrototypeOf(GUITabs.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'get',
    value: function get(param, value) {
      if (['current', 'selected', 'active'].indexOf(param) !== -1) {
        var cur = this.$element.querySelector('ul > li[class="gui-active"]');
        return DOM.$index(cur);
      }
      return _get(GUITabs.prototype.__proto__ || Object.getPrototypeOf(GUITabs.prototype), 'get', this).apply(this, arguments);
    }
  }, {
    key: 'add',
    value: function add(newtabs) {
      var el = this.$element;
      var tabs = el.querySelector('ul');

      if (!(newtabs instanceof Array)) {
        newtabs = [newtabs];
      }

      newtabs.forEach(function (label) {
        createTab(el, tabs, label, true);
      });

      return this;
    }
  }, {
    key: 'remove',
    value: function remove(removetabs) {
      var el = this.$element;
      var tabs = el.querySelector('ul');

      if (!(removetabs instanceof Array)) {
        removetabs = [removetabs];
      }

      removetabs.forEach(function (id) {
        removeTab(el, tabs, id);
      });

      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var el = this.$element;
      var tabs = document.createElement('ul');

      el.querySelectorAll('gui-tab-container').forEach(function (tel, idx) {
        createTab(el, tabs, GUI.getLabel(tel));
        tel.setAttribute('role', 'tabpanel');
      });

      tabs.setAttribute('role', 'tablist');
      el.setAttribute('role', 'navigation');

      if (el.children.length) {
        el.insertBefore(tabs, el.children[0]);
      } else {
        el.appendChild(tabs);
      }

      var currentTab = parseInt(el.getAttribute('data-selected-index'), 10) || 0;
      selectTab(el, tabs, null, currentTab);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUITabs.__proto__ || Object.getPrototypeOf(GUITabs), 'register', this).call(this, {
        tagName: 'gui-tabs'
      }, this);
    }
  }]);

  return GUITabs;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUITabs: GUITabs
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dom = __webpack_require__(31);

var DOM = _interopRequireWildcard(_dom);

var _gui = __webpack_require__(55);

var GUI = _interopRequireWildcard(_gui);

var _dataview = __webpack_require__(126);

var _dataview2 = _interopRequireDefault(_dataview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function createEntry(cls, e) {
  var entry = GUI.createElement('gui-tree-view-entry', e, ['entries']);
  return entry;
}

function handleItemExpand(ev, el, root, expanded) {
  if (typeof expanded === 'undefined') {
    expanded = !DOM.$hasClass(root, 'gui-expanded');
  }

  DOM.$removeClass(root, 'gui-expanded');
  if (expanded) {
    DOM.$addClass(root, 'gui-expanded');
  }

  var children = root.children;
  for (var i = 0; i < children.length; i++) {
    if (children[i].tagName.toLowerCase() === 'gui-tree-view-entry') {
      children[i].style.display = expanded ? 'block' : 'none';
    }
  }

  var selected = {
    index: DOM.$index(root),
    data: GUI.getViewNodeValue(root)
  };

  root.setAttribute('data-expanded', String(expanded));
  root.setAttribute('aria-expanded', String(expanded));

  el.dispatchEvent(new CustomEvent('_expand', { detail: { entries: [selected], expanded: expanded, element: root } }));
} // handleItemExpand()

function initEntry(cls, sel) {
  var el = cls.$element;
  if (sel._rendered) {
    return;
  }
  sel._rendered = true;

  var icon = sel.getAttribute('data-icon');
  var label = GUI.getLabel(sel);
  var expanded = el.getAttribute('data-expanded') === 'true';
  var next = sel.querySelector('gui-tree-view-entry');
  var container = document.createElement('div');
  var dspan = document.createElement('span');

  function onDndEnter(ev) {
    ev.stopPropagation();
    DOM.$addClass(sel, 'dnd-over');
  }

  function onDndLeave(ev) {
    DOM.$removeClass(sel, 'dnd-over');
  }

  if (icon) {
    dspan.style.backgroundImage = 'url(' + icon + ')';
    DOM.$addClass(dspan, 'gui-has-image');
  }
  dspan.appendChild(document.createTextNode(label));

  container.appendChild(dspan);

  if (next) {
    DOM.$addClass(sel, 'gui-expandable');
    var expander = document.createElement('gui-tree-view-expander');
    sel.insertBefore(container, next);
    sel.insertBefore(expander, container);
  } else {
    sel.appendChild(container);
  }

  if (String(sel.getAttribute('data-draggable')) === 'true') {
    GUI.createDraggable(container, function () {
      var data = {};
      try {
        data = JSON.parse(sel.getAttribute('data-value'));
      } catch (e) {}

      return { data: data };
    }());
  }

  if (String(sel.getAttribute('data-droppable')) === 'true') {
    var timeout = void 0;
    GUI.createDroppable(container, {
      onEnter: onDndEnter,
      onOver: onDndEnter,
      onLeave: onDndLeave,
      onDrop: onDndLeave,
      onItemDropped: function onItemDropped(ev, eel, item) {
        ev.stopPropagation();
        ev.preventDefault();

        timeout = clearTimeout(timeout);
        timeout = setTimeout(function () {
          DOM.$removeClass(sel, 'dnd-over');
        }, 10);

        var dval = {};
        try {
          dval = JSON.parse(eel.parentNode.getAttribute('data-value'));
        } catch (e) {}

        el.dispatchEvent(new CustomEvent('_drop', { detail: {
            src: item.data,
            dest: dval
          } }));
      }
    });
  }

  handleItemExpand(null, el, sel, expanded);

  cls.bindEntryEvents(sel, 'gui-tree-view-entry');
}

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-tree-view'
 *
 * A tree view for nested content
 *
 * For more properties and events etc, see 'dataview'
 *
 * @example
 *
 *   .add({
 *      label: "Label",
 *      icon: "Optional icon path",
 *      value: "something or JSON or whatever",
 *      entries: [] // Recurse :)
 *   })
 */

var GUITreeView = function (_GUIDataView) {
  _inherits(GUITreeView, _GUIDataView);

  function GUITreeView() {
    _classCallCheck(this, GUITreeView);

    return _possibleConstructorReturn(this, (GUITreeView.__proto__ || Object.getPrototypeOf(GUITreeView)).apply(this, arguments));
  }

  _createClass(GUITreeView, [{
    key: 'values',
    value: function values() {
      var el = this.$element;
      return this.getSelected(el.querySelectorAll('gui-tree-view-entry'));
    }
  }, {
    key: 'build',
    value: function build(applyArgs) {
      var _this2 = this;

      var el = this.$element;

      var body = el.querySelector('gui-tree-view-body');
      var found = !!body;

      if (!body) {
        body = document.createElement('gui-tree-view-body');
        el.appendChild(body);
      }

      body.setAttribute('role', 'group');
      el.setAttribute('role', 'tree');
      el.setAttribute('aria-multiselectable', body.getAttribute('data-multiselect') || 'false');

      el.querySelectorAll('gui-tree-view-entry').forEach(function (sel, idx) {
        sel.setAttribute('aria-expanded', 'false');

        if (!found) {
          body.appendChild(sel);
        }

        sel.setAttribute('role', 'treeitem');
        initEntry(_this2, sel);
      });

      return _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'build', this).apply(this, arguments);
    }
  }, {
    key: 'get',
    value: function get(param, value, arg) {
      if (param === 'entry') {
        var body = this.$element.querySelector('gui-tree-view-body');
        return this.getEntry(body.querySelectorAll('gui-tree-view-entry'), value, arg);
      }
      return _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'get', this).apply(this, arguments);
    }
  }, {
    key: 'set',
    value: function set(param, value, arg, arg2) {
      var el = this.$element;
      var body = el.querySelector('gui-tree-view-body');
      if (param === 'selected' || param === 'value') {
        this.setSelected(body, body.querySelectorAll('gui-tree-view-entry'), value, arg, arg2);
        return this;
      }
      return _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'set', this).apply(this, arguments);
    }
  }, {
    key: 'clear',
    value: function clear() {
      var body = this.$element.querySelector('gui-tree-view-body');
      return _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'clear', this).call(this, body);
    }
  }, {
    key: 'add',
    value: function add(entries) {
      var _this3 = this;

      var body = this.$element.querySelector('gui-tree-view-body');

      var parentNode = body;

      var recurse = function recurse(a, root, level) {
        _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'add', _this3).call(_this3, a, function (cls, e) {
          if (e) {
            if (e.parentNode) {
              delete e.parentNode;
            }

            var entry = createEntry(_this3, e);
            root.appendChild(entry);

            if (e.entries) {
              recurse(e.entries, entry, level + 1);
            }

            initEntry(_this3, entry);
          }
        });
      };

      if ((typeof entries === 'undefined' ? 'undefined' : _typeof(entries)) === 'object' && !(entries instanceof Array) && Object.keys(entries).length) {
        parentNode = entries.parentNode || body;
        entries = entries.entries || [];
      }

      recurse(entries, parentNode, 0);

      return this;
    }
  }, {
    key: 'remove',
    value: function remove(entries) {
      return _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'remove', this).call(this, entries, 'gui-tree-view-entry');
    }
  }, {
    key: 'patch',
    value: function patch(entries) {
      var body = this.$element.querySelector('gui-tree-view-body');
      return _get(GUITreeView.prototype.__proto__ || Object.getPrototypeOf(GUITreeView.prototype), 'patch', this).call(this, entries, 'gui-list-view-entry', body, createEntry, initEntry);
    }
  }, {
    key: 'expand',
    value: function expand(entry) {
      handleItemExpand(entry.ev, this.$element, entry.entry);
      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUITreeView.__proto__ || Object.getPrototypeOf(GUITreeView), 'register', this).call(this, {
        parent: _dataview2.default,
        tagName: 'gui-tree-view'
      }, this);
    }
  }]);

  return GUITreeView;
}(_dataview2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUITreeView: GUITreeView
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                               * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                               * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                               *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                               * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                               *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                               *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                               * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                               * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                               * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                               * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                               * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                               * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                               * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                               * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                               * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                               * @licence Simplified BSD License
                                                                                                                                                                                                                                                                               */


var _events = __webpack_require__(35);

var Events = _interopRequireWildcard(_events);

var _element = __webpack_require__(40);

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/////////////////////////////////////////////////////////////////////////////
// HELPERS
/////////////////////////////////////////////////////////////////////////////

function createVisualElement(el, nodeType, applyArgs) {
  applyArgs = applyArgs || {};
  if ((typeof applyArgs === 'undefined' ? 'undefined' : _typeof(applyArgs)) !== 'object') {
    console.error('Derp', 'applyArgs was not an object ?!');
    applyArgs = {};
  }

  var img = document.createElement(nodeType);
  var src = el.getAttribute('data-src');
  var controls = el.getAttribute('data-controls');
  if (controls) {
    img.setAttribute('controls', 'controls');
  }
  var autoplay = el.getAttribute('data-autoplay');
  if (autoplay) {
    img.setAttribute('autoplay', 'autoplay');
  }

  Object.keys(applyArgs).forEach(function (k) {
    var val = applyArgs[k];
    if (typeof val === 'function') {
      k = k.replace(/^on/, '');
      if ((nodeType === 'video' || nodeType === 'audio') && k === 'load') {
        k = 'loadedmetadata';
      }
      Events.$bind(img, k, val.bind(img), false);
    } else {
      if (typeof applyArgs[k] === 'boolean') {
        val = val ? 'true' : 'false';
      }
      img.setAttribute(k, val);
    }
  });

  img.src = src || 'about:blank';
  el.appendChild(img);
}

/////////////////////////////////////////////////////////////////////////////
// CLASSES
/////////////////////////////////////////////////////////////////////////////

/**
 * Element: 'gui-audio'
 *
 * HTML5 Audio Element.
 *
 * <pre><code>
 *   getter    src   String        The source (src)
 *   setter    src   String        The source (src)
 *   property  src   String        The source (src)
 * </code></pre>
 */

var GUIAudio = function (_GUIElement) {
  _inherits(GUIAudio, _GUIElement);

  function GUIAudio() {
    _classCallCheck(this, GUIAudio);

    return _possibleConstructorReturn(this, (GUIAudio.__proto__ || Object.getPrototypeOf(GUIAudio)).apply(this, arguments));
  }

  _createClass(GUIAudio, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var target = this.$element.querySelector('audio');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build(applyArgs) {
      createVisualElement(this.$element, 'audio', applyArgs);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIAudio.__proto__ || Object.getPrototypeOf(GUIAudio), 'register', this).call(this, {
        tagName: 'gui-audio'
      }, this);
    }
  }]);

  return GUIAudio;
}(_element2.default);

/**
 * Element: 'gui-video'
 *
 * HTML5 Video Element.
 *
 * <pre><code>
 *   getter    src   String        The source (src)
 *   setter    src   String        The source (src)
 *   property  src   String        The source (src)
 * </code></pre>
 */


var GUIVideo = function (_GUIElement2) {
  _inherits(GUIVideo, _GUIElement2);

  function GUIVideo() {
    _classCallCheck(this, GUIVideo);

    return _possibleConstructorReturn(this, (GUIVideo.__proto__ || Object.getPrototypeOf(GUIVideo)).apply(this, arguments));
  }

  _createClass(GUIVideo, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var target = this.$element.querySelector('video');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build(applyArgs) {
      createVisualElement(this.$element, 'video', applyArgs);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIVideo.__proto__ || Object.getPrototypeOf(GUIVideo), 'register', this).call(this, {
        tagName: 'gui-video'
      }, this);
    }
  }]);

  return GUIVideo;
}(_element2.default);

/**
 * Element: 'gui-image'
 *
 * Normal Image Element.
 *
 * <pre><code>
 *   getter    src   String        The source (src)
 *   setter    src   String        The source (src)
 *   property  src   String        The source (src)
 * </code></pre>
 */


var GUIImage = function (_GUIElement3) {
  _inherits(GUIImage, _GUIElement3);

  function GUIImage() {
    _classCallCheck(this, GUIImage);

    return _possibleConstructorReturn(this, (GUIImage.__proto__ || Object.getPrototypeOf(GUIImage)).apply(this, arguments));
  }

  _createClass(GUIImage, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var target = this.$element.querySelector('img');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build(applyArgs) {
      createVisualElement(this.$element, 'img', applyArgs);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUIImage.__proto__ || Object.getPrototypeOf(GUIImage), 'register', this).call(this, {
        tagName: 'gui-image'
      }, this);
    }
  }]);

  return GUIImage;
}(_element2.default);

/**
 * Element: 'gui-canvas'
 *
 * Canvas Element.
 *
 * <pre><code>
 *   getter    src   String        The source (src)
 *   setter    src   String        The source (src)
 *   property  src   String        The source (src)
 * </code></pre>
 */


var GUICanvas = function (_GUIElement4) {
  _inherits(GUICanvas, _GUIElement4);

  function GUICanvas() {
    _classCallCheck(this, GUICanvas);

    return _possibleConstructorReturn(this, (GUICanvas.__proto__ || Object.getPrototypeOf(GUICanvas)).apply(this, arguments));
  }

  _createClass(GUICanvas, [{
    key: 'on',
    value: function on(evName, callback, params) {
      var target = this.$element.querySelector('canvas');
      Events.$bind(target, evName, callback.bind(this), params);
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      var canvas = document.createElement('canvas');
      this.$element.appendChild(canvas);

      return this;
    }
  }], [{
    key: 'register',
    value: function register() {
      return _get(GUICanvas.__proto__ || Object.getPrototypeOf(GUICanvas), 'register', this).call(this, {
        tagName: 'gui-canvas'
      }, this);
    }
  }]);

  return GUICanvas;
}(_element2.default);

/////////////////////////////////////////////////////////////////////////////
// EXPORTS
/////////////////////////////////////////////////////////////////////////////

exports.default = {
  GUIAudio: GUIAudio,
  GUIVideo: GUIVideo,
  GUIImage: GUIImage,
  GUICanvas: GUICanvas
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _window = __webpack_require__(121);

var _window2 = _interopRequireDefault(_window);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var IFRAME_COUNT = 0;

/**
 * IFrame Application Window constructor
 *
 * @desc
 * <pre><b>
 * This class is a basic implementation of Window
 * that uses Iframe as window content. It's usefull for creating
 * applications that is not using OS.js API.
 *
 * You can use this in combination with 'IFrameApplication'
 * </b></pre>
 *
 * @link https://manual.os-js.org/packages/iframe/
 */

var IFrameApplicationWindow = function (_Window) {
  _inherits(IFrameApplicationWindow, _Window);

  /**
   * @param  {String}       name          Window name
   * @param  {Object}       opts          Window options
   * @param  {String}       opts.src      The Iframe source
   * @param  {String}       opts.icon     The Icon relative/absolute path (./ for app dir)
   * @param  {String}       opts.title    The Window title
   * @param  {Application}  app           The Application reference
   */
  function IFrameApplicationWindow(name, opts, app) {
    _classCallCheck(this, IFrameApplicationWindow);

    opts = Object.assign({}, {
      src: 'about:blank',
      focus: function focus() {},
      blur: function blur() {},
      icon: null,
      title: 'IframeApplicationWindow',
      width: 320,
      height: 240,
      allow_resize: false,
      allow_restore: false,
      allow_maximize: false
    }, opts);

    var _this = _possibleConstructorReturn(this, (IFrameApplicationWindow.__proto__ || Object.getPrototypeOf(IFrameApplicationWindow)).call(this, 'IFrameApplicationWindow', opts, app));

    _this._iwin = null;
    _this._frame = null;
    return _this;
  }

  _createClass(IFrameApplicationWindow, [{
    key: 'destroy',
    value: function destroy() {
      this.postMessage('Window::destroy');
      return _get(IFrameApplicationWindow.prototype.__proto__ || Object.getPrototypeOf(IFrameApplicationWindow.prototype), 'destroy', this).apply(this, arguments);
    }
  }, {
    key: 'init',
    value: function init(wmRef, app) {
      var _this2 = this;

      var root = _get(IFrameApplicationWindow.prototype.__proto__ || Object.getPrototypeOf(IFrameApplicationWindow.prototype), 'init', this).apply(this, arguments);
      root.style.overflow = 'visible';

      var id = 'IframeApplicationWindow' + IFRAME_COUNT.toString();
      var iframe = document.createElement('iframe');
      iframe.setAttribute('border', 0);
      iframe.id = id;
      iframe.className = 'IframeApplicationFrame';
      iframe.addEventListener('load', function () {
        _this2._iwin = iframe.contentWindow;
        _this2.postMessage('Window::init');
      });

      this.setLocation(this._opts.src, iframe);
      root.appendChild(iframe);

      this._frame = iframe;

      try {
        this._iwin = iframe.contentWindow;
      } catch (e) {}

      if (this._iwin) {
        this._iwin.focus();
      }

      this._frame.focus();
      this._opts.focus(this._frame, this._iwin);

      IFRAME_COUNT++;

      return root;
    }
  }, {
    key: '_blur',
    value: function _blur() {
      if (_get(IFrameApplicationWindow.prototype.__proto__ || Object.getPrototypeOf(IFrameApplicationWindow.prototype), '_blur', this).apply(this, arguments)) {
        if (this._iwin) {
          this._iwin.blur();
        }
        if (this._frame) {
          this._frame.blur();
        }

        this._opts.blur(this._frame, this._iwin);
        return true;
      }
      return false;
    }
  }, {
    key: '_focus',
    value: function _focus() {
      if (_get(IFrameApplicationWindow.prototype.__proto__ || Object.getPrototypeOf(IFrameApplicationWindow.prototype), '_focus', this).apply(this, arguments)) {
        if (this._iwin) {
          this._iwin.focus();
        }
        if (this._frame) {
          this._frame.focus();
        }
        this._opts.focus(this._frame, this._iwin);
        return true;
      }
      return false;
    }

    /**
     * Post a message to IFrame Application
     *
     * @param   {*}       message     The message
     */

  }, {
    key: 'postMessage',
    value: function postMessage(message) {
      if (this._iwin && this._app) {
        console.debug('IFrameApplicationWindow::postMessage()', message);
        this._iwin.postMessage({
          message: message,
          pid: this._app.__pid,
          wid: this._wid
        }, window.location.href);
      }
    }

    /**
     * When Window receives a message from IFrame Application
     *
     * @param   {*}       message     The message
     * @param   {Event}   ev          DOM Event
     */

  }, {
    key: 'onPostMessage',
    value: function onPostMessage(message, ev) {
      console.debug('IFrameApplicationWindow::onPostMessage()', message);
    }

    /**
     * Set Iframe source
     *
     * @param   {String}      src       Source
     * @param   {Element}     iframe    Iframe element
     */

  }, {
    key: 'setLocation',
    value: function setLocation(src, iframe) {
      iframe = iframe || this._frame;

      var oldbefore = window.onbeforeunload;
      window.onbeforeunload = null;
      iframe.src = src;
      window.onbeforeunload = oldbefore;
    }
  }]);

  return IFrameApplicationWindow;
}(_window2.default);

exports.default = IFrameApplicationWindow;

/***/ }),
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _process = __webpack_require__(85);

var _process2 = _interopRequireDefault(_process);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/////////////////////////////////////////////////////////////////////////////
// SERVICE
/////////////////////////////////////////////////////////////////////////////

/**
 * Service Base Class
 *
 * @desc Class used for making Services
 *
 * @param   {String}    name        Process name
 * @param   {Object}    args        Process arguments
 * @param   {Object}    metadata    Package metadata
 *
 * @extends Process
 * @abstract
 */
var Service = function (_Process) {
  _inherits(Service, _Process);

  function Service(name, args, metadata) {
    _classCallCheck(this, Service);

    console.group('Service::constructor()', name);

    var _this = _possibleConstructorReturn(this, (Service.__proto__ || Object.getPrototypeOf(Service)).apply(this, arguments));

    console.groupEnd();
    return _this;
  }

  return Service;
}(_process2.default);

exports.default = Service;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _application = __webpack_require__(124);

var _application2 = _interopRequireDefault(_application);

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _fs = __webpack_require__(62);

var VFS = _interopRequireWildcard(_fs);

var _fs2 = __webpack_require__(39);

var FS = _interopRequireWildcard(_fs2);

var _locales = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/*eslint valid-jsdoc: "off"*/


/////////////////////////////////////////////////////////////////////////////
// Default Application Helper
/////////////////////////////////////////////////////////////////////////////

/**
 * This is a helper to more easily create an application.
 *
 * Handles opening, saving and creation of files.
 *
 * @desc Helper for making Applications with file interaction.
 */
var DefaultApplication = function (_Application) {
  _inherits(DefaultApplication, _Application);

  function DefaultApplication(name, args, metadata, opts) {
    _classCallCheck(this, DefaultApplication);

    var _this = _possibleConstructorReturn(this, (DefaultApplication.__proto__ || Object.getPrototypeOf(DefaultApplication)).apply(this, arguments));

    _this.defaultOptions = Object.assign({}, {
      readData: true,
      rawData: false,
      extension: '',
      mime: 'application/octet-stream',
      filetypes: [],
      filename: 'New file'
    }, opts);
    return _this;
  }

  /*
   * Destroy
   */


  _createClass(DefaultApplication, [{
    key: 'destroy',
    value: function destroy() {
      _get(DefaultApplication.prototype.__proto__ || Object.getPrototypeOf(DefaultApplication.prototype), 'destroy', this).apply(this, arguments);
    }

    /*
     * On Message
     */

  }, {
    key: '_onMessage',
    value: function _onMessage(msg, obj, args) {
      var _this2 = this;

      _get(DefaultApplication.prototype.__proto__ || Object.getPrototypeOf(DefaultApplication.prototype), '_onMessage', this).apply(this, arguments);

      var current = this._getArgument('file');
      var win = this._getWindow(this.__mainwindow);

      if (msg === 'vfs' && args.source !== null && args.source !== this.__pid && args.file) {
        if (win && current && current.path === args.file.path) {
          _dialog2.default.create('Confirm', {
            buttons: ['yes', 'no'],
            message: (0, _locales._)('MSG_FILE_CHANGED')
          }, function (ev, button) {
            if (button === 'ok' || button === 'yes') {
              _this2.openFile(new _file2.default(args.file), win);
            }
          }, { parent: win, modal: true });
        }
      }
    }

    /**
     * Open given File
     *
     * @param   {FileMetadata}  file        File
     * @param   {Window}        win         Window reference
     */

  }, {
    key: 'openFile',
    value: function openFile(file, win) {
      var _this3 = this;

      if (!file) {
        return false;
      }

      var onError = function onError(error) {
        if (error) {
          OSjs.error(_this3.__label, (0, _locales._)('ERR_FILE_APP_OPEN'), (0, _locales._)('ERR_FILE_APP_OPEN_ALT_FMT', file.path, error));
          return true;
        }
        return false;
      };

      var onDone = function onDone(result) {
        _this3._setArgument('file', file);
        win.showFile(file, result);
      };

      var check = this.__metadata.mime || [];
      if (!FS.checkAcceptMime(file.mime, check)) {
        OSjs.error(this.__label, (0, _locales._)('ERR_FILE_APP_OPEN'), (0, _locales._)('ERR_FILE_APP_OPEN_FMT', file.path, file.mime));
        return false;
      }

      win._toggleLoading(true);

      function callbackVFS(error, result) {
        win._toggleLoading(false);
        if (onError(error)) {
          return;
        }
        onDone(result);
      }

      if (this.defaultOptions.readData) {
        VFS.read(file, { type: this.defaultOptions.rawData ? 'binary' : 'text' }, this).then(function (res) {
          return callbackVFS(false, res);
        }).catch(function (err) {
          return callbackVFS(err);
        });
      } else {
        VFS.url(file).then(function (res) {
          return callbackVFS(false, res);
        }).catch(function (err) {
          return callbackVFS(err);
        });
      }

      return true;
    }

    /**
     * Save given File
     *
     * @param   {FileMetadata}  file        File
     * @param   {String|Object} value       File contents
     * @param   {Window}        win         Window reference
     */

  }, {
    key: 'saveFile',
    value: function saveFile(file, value, win) {
      var _this4 = this;

      if (!file) {
        return;
      }

      win._toggleLoading(true);
      VFS.write(file, value || '', null, this).then(function () {
        _this4._setArgument('file', file);
        win.updateFile(file);
        return true;
      }).catch(function (error) {
        OSjs.error(_this4.__label, (0, _locales._)('ERR_FILE_APP_SAVE'), (0, _locales._)('ERR_FILE_APP_SAVE_ALT_FMT', file.path, error));
      }).finally(function () {
        win._toggleLoading(false);
      });
    }

    /**
     * Open Save dialog
     *
     * @param   {FileMetadata}       file        File
     * @param   {Window}             win         Window reference
     * @param   {Boolean}            saveAs      SaveAs ?
     * @param   {CallbackDialog}     cb          Called after the user closed the dialog
     */

  }, {
    key: 'saveDialog',
    value: function saveDialog(file, win, saveAs, cb) {
      var _this5 = this;

      var value = win.getFileData();

      if (!saveAs) {
        this.saveFile(file, value, win);
        return;
      }

      _dialog2.default.create('File', {
        file: file,
        filename: file ? file.filename : this.defaultOptions.filename,
        filetypes: this.defaultOptions.filetypes,
        filter: this.__metadata.mime,
        extension: this.defaultOptions.extension,
        mime: this.defaultOptions.mime,
        type: 'save'
      }, function (ev, button, result) {
        if (button === 'ok') {
          _this5.saveFile(result, value, win);
        }
        if (typeof cb === 'function') {
          cb(ev, button, result);
        }
      }, { parent: win, modal: true });
    }

    /**
     * Open Open dialog
     *
     * @param   {FileMetadata}   [file]      Current File
     * @param   {Window}         [win]       Window reference
     */

  }, {
    key: 'openDialog',
    value: function openDialog(file, win) {
      var _this6 = this;

      var openDialog = function openDialog() {
        _dialog2.default.create('File', {
          file: file,
          filter: _this6.__metadata.mime
        }, function (ev, button, result) {
          if (button === 'ok' && result) {
            _this6.openFile(new _file2.default(result), win);
          }
        }, { parent: win, modal: true });
      };

      win.checkHasChanged(function (discard) {
        if (discard) {
          openDialog();
        }
      });
    }

    /**
     * Create a new file
     *
     * @param   {String}    [path]        Current path
     * @param   {Window}    [win]         Window reference
     */

  }, {
    key: 'newDialog',
    value: function newDialog(path, win) {
      var _this7 = this;

      win.checkHasChanged(function (discard) {
        if (discard) {
          _this7._setArgument('file', null);
          win.showFile(null, null);
        }
      });
    }
  }]);

  return DefaultApplication;
}(_application2.default);

exports.default = DefaultApplication;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _file = __webpack_require__(30);

var _file2 = _interopRequireDefault(_file);

var _window = __webpack_require__(121);

var _window2 = _interopRequireDefault(_window);

var _dialog = __webpack_require__(34);

var _dialog2 = _interopRequireDefault(_dialog);

var _locales = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/*eslint valid-jsdoc: "off"*/


/////////////////////////////////////////////////////////////////////////////
// Default Application Window Helper
/////////////////////////////////////////////////////////////////////////////

/**
 * This is a helper to more easily create an application.
 *
 * Use in combination with 'DefaultApplication'
 *
 * @desc Helper for making Applications with file interaction.
 */
var DefaultApplicationWindow = function (_Window) {
  _inherits(DefaultApplicationWindow, _Window);

  function DefaultApplicationWindow(name, args, app, file) {
    _classCallCheck(this, DefaultApplicationWindow);

    var _this = _possibleConstructorReturn(this, (DefaultApplicationWindow.__proto__ || Object.getPrototypeOf(DefaultApplicationWindow)).apply(this, arguments));

    _this.hasClosingDialog = false;
    _this.currentFile = file ? new _file2.default(file) : null;
    _this.hasChanged = false;
    return _this;
  }

  /*
   * Destroy
   */


  _createClass(DefaultApplicationWindow, [{
    key: 'destroy',
    value: function destroy() {
      _get(DefaultApplicationWindow.prototype.__proto__ || Object.getPrototypeOf(DefaultApplicationWindow.prototype), 'destroy', this).apply(this, arguments);
      this.currentFile = null;
    }

    /*
     * Initialize
     */

  }, {
    key: 'init',
    value: function init(wm, app) {
      var root = _get(DefaultApplicationWindow.prototype.__proto__ || Object.getPrototypeOf(DefaultApplicationWindow.prototype), 'init', this).apply(this, arguments);
      return root;
    }

    /*
     * Applies default Window GUI stuff
     */

  }, {
    key: '_inited',
    value: function _inited() {
      var _this2 = this;

      var result = _window2.default.prototype._inited.apply(this, arguments);
      var app = this._app;

      var menuMap = {
        MenuNew: function MenuNew() {
          app.newDialog(_this2.currentFile, _this2);
        },
        MenuSave: function MenuSave() {
          app.saveDialog(_this2.currentFile, _this2);
        },
        MenuSaveAs: function MenuSaveAs() {
          app.saveDialog(_this2.currentFile, _this2, true);
        },
        MenuOpen: function MenuOpen() {
          app.openDialog(_this2.currentFile, _this2);
        },
        MenuClose: function MenuClose() {
          _this2._close();
        }
      };

      this._find('SubmenuFile').on('select', function (ev) {
        if (menuMap[ev.detail.id]) {
          menuMap[ev.detail.id]();
        }
      });

      this._find('MenuSave').set('disabled', true);

      // Load given file
      if (this.currentFile) {
        if (!this._app.openFile(this.currentFile, this)) {
          this.currentFile = null;
        }
      }

      return result;
    }

    /*
     * On Drag-And-Drop Event
     */

  }, {
    key: '_onDndEvent',
    value: function _onDndEvent(ev, type, item, args) {
      if (!_window2.default.prototype._onDndEvent.apply(this, arguments)) {
        return;
      }

      if (type === 'itemDrop' && item) {
        var data = item.data;
        if (data && data.type === 'file' && data.mime) {
          this._app.openFile(new _file2.default(data), this);
        }
      }
    }

    /*
     * On Close
     */

  }, {
    key: '_close',
    value: function _close() {
      var _this3 = this;

      if (this.hasClosingDialog) {
        return;
      }

      if (this.hasChanged) {
        this.hasClosingDialog = true;
        this.checkHasChanged(function (discard) {
          _this3.hasClosingDialog = false;
          if (discard) {
            _this3.hasChanged = false; // IMPORTANT
            _this3._close();
          }
        });
        return;
      }

      _window2.default.prototype._close.apply(this, arguments);
    }

    /**
     * Checks if current file has changed
     *
     * @param   {Function}      cb        Callback => fn(discard_changes)
     */

  }, {
    key: 'checkHasChanged',
    value: function checkHasChanged(cb) {
      if (this.hasChanged) {
        _dialog2.default.create('Confirm', {
          buttons: ['yes', 'no'],
          message: (0, _locales._)('MSG_GENERIC_APP_DISCARD')
        }, function (ev, button) {
          cb(button === 'ok' || button === 'yes');
        }, { parent: this, modal: true });
        return;
      }

      cb(true);
    }

    /**
     * Show opened/created file
     *
     * YOU SHOULD EXTEND THIS METHOD IN YOUR WINDOW TO ACTUALLY DISPLAY CONTENT
     *
     * @param   {FileMetadata}   file        File
     * @param   {String|Object}  content     File contents
     */

  }, {
    key: 'showFile',
    value: function showFile(file, content) {
      this.updateFile(file);
    }

    /**
     * Updates current view for given File
     *
     * @param   {FileMetadata}       file        File
     */

  }, {
    key: 'updateFile',
    value: function updateFile(file) {
      this.currentFile = file || null;
      this.hasChanged = false;

      if (this._scheme) {
        this._find('MenuSave').set('disabled', !file);
      }

      if (file) {
        this._setTitle(file.filename, true);
      } else {
        this._setTitle();
      }
    }

    /**
     * Gets file data
     *
     * YOU SHOULD IMPLEMENT THIS METHOD IN YOUR WINDOW TO RETURN FILE CONTENTS
     *
     * @return  {*} File contents
     */

  }, {
    key: 'getFileData',
    value: function getFileData() {
      return null;
    }

    /**
     * Window key
     */

  }, {
    key: '_onKeyEvent',
    value: function _onKeyEvent(ev, type, shortcut) {
      if (shortcut === 'SAVE') {
        this._app.saveDialog(this.currentFile, this, !this.currentFile);
        return false;
      } else if (shortcut === 'SAVEAS') {
        this._app.saveDialog(this.currentFile, this, true);
        return false;
      } else if (shortcut === 'OPEN') {
        this._app.openDialog(this.currentFile, this);
        return false;
      }

      return _window2.default.prototype._onKeyEvent.apply(this, arguments);
    }
  }]);

  return DefaultApplicationWindow;
}(_window2.default);

exports.default = DefaultApplicationWindow;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _iframeApplicationWindow = __webpack_require__(450);

var _iframeApplicationWindow2 = _interopRequireDefault(_iframeApplicationWindow);

var _application = __webpack_require__(124);

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OS.js - JavaScript Cloud/Web Desktop Platform
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Redistribution and use in source and binary forms, with or without
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * modification, are permitted provided that the following conditions are met:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 1. Redistributions of source code must retain the above copyright notice, this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    list of conditions and the following disclaimer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 2. Redistributions in binary form must reproduce the above copyright notice,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    this list of conditions and the following disclaimer in the documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    and/or other materials provided with the distribution.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author  Anders Evenrud <andersevenrud@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @licence Simplified BSD License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/////////////////////////////////////////////////////////////////////////////
// IFrame Application Helper
/////////////////////////////////////////////////////////////////////////////

/**
 * IFrame Application constructor
 *
 * @desc
 * <pre><code>
 * Usage: Just apply the correct options and this should work
 * automatically.
 *
 * This just inits an empty application with a window that uses
 * iframe for contents. Look at the IFrameApplicationWindow
 * constructor for more options you can apply here.
 * </code></pre>
 */
var IFrameApplication = function (_Application) {
  _inherits(IFrameApplication, _Application);

  /**
   * This is an Iframe Window
   *
   * See `Window` for more options
   *
   * @param   {String}    name          Process name
   * @param   {Object}    args          Process arguments
   * @param   {Object}    metadata      Application metadata
   * @param   {Object}    opts          Application options
   * @param   {Object}    opts.src      Iframe Source
   */
  function IFrameApplication(name, args, metadata, opts) {
    _classCallCheck(this, IFrameApplication);

    var _this = _possibleConstructorReturn(this, (IFrameApplication.__proto__ || Object.getPrototypeOf(IFrameApplication)).apply(this, arguments));

    _this.options = Object.assign({}, {
      icon: '',
      title: 'IframeApplicationWindow'
    }, opts);
    _this.options.src = _this._getResource(_this.options.src);
    return _this;
  }

  _createClass(IFrameApplication, [{
    key: 'init',
    value: function init(settings, metadata) {
      _get(IFrameApplication.prototype.__proto__ || Object.getPrototypeOf(IFrameApplication.prototype), 'init', this).apply(this, arguments);

      var name = this.__pname + 'Window';
      this._addWindow(new _iframeApplicationWindow2.default(name, this.options, this));
    }

    /**
     * When Application receives a message from IFrame
     *
     * @alias IFrameApplicationWindow#onPostMessage
     *
     * @param   {*}       message     The message
     * @param   {Event}   ev          DOM Event
     */

  }, {
    key: 'onPostMessage',
    value: function onPostMessage(message, ev) {
      var _this2 = this;

      console.debug('IFrameApplication::onPostMessage()', message);

      var _response = function _response(err, res) {
        _this2.postMessage({
          id: message.id,
          method: message.method,
          error: err,
          result: Object.assign({}, res)
        });
      };

      if (typeof message.id === 'number' && message.method) {
        if (this[message.method]) {
          this[message.method](message.args || {}, _response);
        } else {
          _response('No such method');
        }
      }
    }

    /**
     * @param   {*}       message     The message
     * @alias IFrameApplicationWindow#postMessage
     */

  }, {
    key: 'postMessage',
    value: function postMessage(message) {
      var win = this._getMainWindow();
      if (win) {
        win.postMessage(message);
      }
    }
  }]);

  return IFrameApplication;
}(_application2.default);

exports.default = IFrameApplication;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/**
 * Gets a cookie by key, or all cookies
 *
 * @param {String} [k] What key to get
 * @return {String|Object}  Depending on 'k' parameter
 */
function getCookie(k) {
  var map = {};
  document.cookie.split(/;\s+?/g).forEach(function (i) {
    var idx = i.indexOf('=');
    map[i.substr(i, idx)] = i.substr(idx + 1);
  });
  return k ? map[k] : map;
}

/***/ }),
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(407);
__webpack_require__(520);
module.exports = __webpack_require__(522);


/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

module.exports = "<div id=\"Login\"> <form method=\"post\" id=\"LoginForm\"> <div> <label for=\"LoginUsername\">Username</label> <input type=\"text\" name=\"LoginUsername\" id=\"LoginUsername\" value=\"\" placeholder=\"Username\" /> </div> <div> <label for=\"LoginPassword\">Password</label> <input type=\"password\" name=\"LoginPassword\" id=\"LoginPassword\" value=\"\" placeholder=\"Password\" /> </div> <div class=\"Submit\"> <input type=\"submit\" name=\"LoginSubmit\" id=\"LoginSubmit\" value=\"Login\" /> </div> </form></div><style type=\"text/css\">#Login { background : #fff; width : 400px; height : 230px; padding : 20px; position : absolute; left : 50%; top : 50%; z-index : 9999; margin-left : -200px; margin-top : -155px; border : 4px solid rgba(0, 0, 0, .1); -webkit-box-shadow: 0 0 5px 4px rgba(0,0,0,0.15); -moz-box-shadow: 0 0 5px 4px rgba(0,0,0,0.15); box-shadow: 0 0 5px 4px rgba(0,0,0,0.15); box-sizing : border-box; display : none;} #LoginForm > div { margin-bottom : 20px; } #Login label { display : block; font-weight : bold; height : 30px; line-height : 30px; } #Login input[type=text], #Login input[type=password] { display : block; width : 100%; height : 24px; padding : 4px; line-height : 12px; box-sizing : border-box; } #Login input[type=submit] { height : 40px; padding : 10px; padding-left : 20px; padding-right : 20px; box-sizing : border-box; background : rgba(0, 0, 0, .1); border : 0 none; cursor : pointer; } #Login .Submit { text-align : right; }</style>";

/***/ }),
/* 488 */,
/* 489 */
/***/ (function(module, exports) {

module.exports = "<!-- Dialog: Error--><application-dialog data-id=\"Error\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"Message\">DIALOG_ERROR_MESSAGE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"SummaryLabel\">DIALOG_ERROR_SUMMARY</gui-label> </gui-vbox-container> <gui-vbox-container data-fill=\"true\" data-basis=\"90px\"> <gui-textarea data-id=\"Summary\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"TraceLabel\">DIALOG_ERROR_TRACE</gui-label> </gui-vbox-container> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-textarea data-id=\"Trace\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_CLOSE</gui-button> <gui-button data-id=\"ButtonBugReport\">LBL_BUGREPORT</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Application Chooser--><application-dialog data-id=\"ApplicationChooser\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"Message\">DIALOG_APPCHOOSER_MSG</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"FileName\">filename (mime)</gui-label> </gui-vbox-container> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-list-view data-id=\"ApplicationList\" data-multiple=\"false\"> </gui-list-view> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-checkbox data-id=\"SetDefault\" data-label=\"DIALOG_APPCHOOSER_SET_DEFAULT\"></gui-checkbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Save/Open--><application-dialog data-id=\"File\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-hbox> <gui-hbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-button data-id=\"HomeButton\" data-stock-icon=\"16x16/places/user-home.png\" data-tooltip=\"LBL_HOME\"></gui-button> </gui-hbox-container> <gui-hbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-button data-id=\"ButtonMkdir\" data-stock-icon=\"16x16/actions/folder-new.png\" data-tooltip=\"LBL_MKDIR\"></gui-button> </gui-hbox-container> <gui-hbox-container data-grow=\"1\" data-expand=\"true\"> <gui-select data-id=\"ModuleSelect\"></gui-select> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-file-view data-id=\"FileView\"> </gui-file-view> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-id=\"FileInput\"> <gui-hbox> <gui-hbox-container data-grow=\"1\" data-expand=\"true\"> <gui-text data-id=\"Filename\"></gui-text> </gui-hbox-container> <gui-hbox-container data-shrink=\"0\" data-basis=\"150px\" data-expand=\"true\"> <gui-select data-id=\"Filetype\"></gui-select> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Progress--><application-dialog data-id=\"FileProgress\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">LBL_LOADING</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-progress-bar data-id=\"Progress\"></gui-progress-bar> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonCancel\" data-disabled=\"true\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Upload--><application-dialog data-id=\"FileUpload\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"Message\">DIALOG_UPLOAD_DESC</gui-label> </gui-vbox-container> <gui-vbox-container data-grow=\"1\"> <gui-file-upload data-id=\"File\"></gui-file-upload> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Information--><application-dialog data-id=\"FileInfo\"> <gui-vbox> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-textarea data-id=\"Info\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Input--><application-dialog data-id=\"Input\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">DIALOG_INPUT_TITLE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-text data-id=\"Input\"></gui-text> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Alert--><application-dialog data-id=\"Alert\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">DIALOG_ALERT_TITLE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Confirm--><application-dialog data-id=\"Confirm\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">DIALOG_CONFIRM_TITLE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonYes\">LBL_YES</gui-button> <gui-button data-id=\"ButtonNo\">LBL_NO</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Color--><application-dialog data-id=\"Color\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-hbox> <gui-hbox-container data-shrink=\"1\"> <gui-vbox> <gui-vbox-container shrink=\"1\"> <gui-color-swatch data-id=\"ColorSelect\"></gui-color-swatch> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-color-box data-id=\"ColorPreview\" data-disabled=\"true\"></gui-color-box> </gui-vbox-container> </gui-vbox> </gui-hbox-container> <gui-hbox-container data-grow=\"1\"> <gui-vbox> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-label data-id=\"LabelRed\">Red</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-slider data-min=\"0\" data-max=\"255\" data-id=\"Red\"></gui-slider> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-label data-id=\"LabelGreen\">Green</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-slider data-min=\"0\" data-max=\"255\" data-id=\"Green\"></gui-slider> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-label data-id=\"LabelBlue\">Blue</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-slider data-min=\"0\" data-max=\"255\" data-id=\"Blue\"></gui-slider> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\" data-id=\"AlphaLabelContainer\"> <gui-label data-id=\"LabelAlpha\">Alpha</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\" data-id=\"AlphaContainer\"> <gui-slider data-min=\"0\" data-max=\"100\" data-id=\"Alpha\"></gui-slider> </gui-vbox-container> </gui-vbox> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Font--><application-dialog data-id=\"Font\"> <gui-vbox> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-hbox> <gui-hbox-container data-grow=\"1\" data-shrink=\"1\" data-basis=\"50%\" data-fill=\"true\"> <gui-select-list data-id=\"FontName\"></gui-select-list> </gui-hbox-container> <gui-hbox-container data-grow=\"1\" data-shrink=\"1\" data-basis=\"50%\" data-fill=\"true\" data-id=\"FontSizeContainer\"> <gui-select-list data-id=\"FontSize\"></gui-select-list> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-basis=\"50px\" data-fill=\"true\"> <gui-textarea data-id=\"FontPreview\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog>";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./applications": 191,
	"./applications.js": 191,
	"./dist": 192,
	"./dist.js": 192,
	"./dropbox": 193,
	"./dropbox.js": 193,
	"./google-drive": 194,
	"./google-drive.js": 194,
	"./onedrive": 196,
	"./onedrive.js": 196,
	"./osjs": 182,
	"./osjs.js": 182,
	"./web": 197,
	"./web.js": 197,
	"./webdav": 198,
	"./webdav.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 490;

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 511 */,
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./database.js": 430,
	"./demo.js": 200,
	"./pam.js": 431,
	"./standalone.js": 432
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./http.js": 201,
	"./standalone.js": 433,
	"./ws.js": 434
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./database.js": 435,
	"./demo.js": 202,
	"./standalone.js": 436,
	"./system.js": 437
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./containers.js": 438,
	"./fileview.js": 439,
	"./iconview.js": 441,
	"./inputs.js": 442,
	"./listview.js": 443,
	"./menus.js": 444,
	"./misc.js": 445,
	"./richtext.js": 446,
	"./tabs.js": 447,
	"./treeview.js": 448,
	"./visual.js": 449
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./boot": 407,
	"./boot.js": 407,
	"./core/application": 124,
	"./core/application.js": 124,
	"./core/auth/database": 430,
	"./core/auth/database.js": 430,
	"./core/auth/demo": 200,
	"./core/auth/demo.js": 200,
	"./core/auth/pam": 431,
	"./core/auth/pam.js": 431,
	"./core/auth/standalone": 432,
	"./core/auth/standalone.js": 432,
	"./core/authenticator": 119,
	"./core/authenticator.js": 119,
	"./core/config": 15,
	"./core/config.js": 15,
	"./core/connection": 53,
	"./core/connection.js": 53,
	"./core/connections/http": 201,
	"./core/connections/http.js": 201,
	"./core/connections/standalone": 433,
	"./core/connections/standalone.js": 433,
	"./core/connections/ws": 434,
	"./core/connections/ws.js": 434,
	"./core/dialog": 34,
	"./core/dialog.js": 34,
	"./core/init": 184,
	"./core/init.js": 184,
	"./core/locales": 10,
	"./core/locales.js": 10,
	"./core/mount-manager": 84,
	"./core/mount-manager.js": 84,
	"./core/package-manager": 61,
	"./core/package-manager.js": 61,
	"./core/process": 85,
	"./core/process.js": 85,
	"./core/search-engine": 417,
	"./core/search-engine.js": 417,
	"./core/service": 459,
	"./core/service.js": 459,
	"./core/settings-manager": 54,
	"./core/settings-manager.js": 54,
	"./core/storage": 118,
	"./core/storage.js": 118,
	"./core/storage/database": 435,
	"./core/storage/database.js": 435,
	"./core/storage/demo": 202,
	"./core/storage/demo.js": 202,
	"./core/storage/standalone": 436,
	"./core/storage/standalone.js": 436,
	"./core/storage/system": 437,
	"./core/storage/system.js": 437,
	"./core/theme": 60,
	"./core/theme.js": 60,
	"./core/window": 121,
	"./core/window-manager": 89,
	"./core/window-manager.js": 89,
	"./core/window.js": 121,
	"./dialogs.html": 517,
	"./dialogs/alert": 419,
	"./dialogs/alert.js": 419,
	"./dialogs/applicationchooser": 420,
	"./dialogs/applicationchooser.js": 420,
	"./dialogs/color": 421,
	"./dialogs/color.js": 421,
	"./dialogs/confirm": 422,
	"./dialogs/confirm.js": 422,
	"./dialogs/error": 423,
	"./dialogs/error.js": 423,
	"./dialogs/file": 425,
	"./dialogs/file.js": 425,
	"./dialogs/fileinfo": 424,
	"./dialogs/fileinfo.js": 424,
	"./dialogs/fileprogress": 426,
	"./dialogs/fileprogress.js": 426,
	"./dialogs/fileupload": 427,
	"./dialogs/fileupload.js": 427,
	"./dialogs/font": 428,
	"./dialogs/font.js": 428,
	"./dialogs/input": 429,
	"./dialogs/input.js": 429,
	"./gui/dataview": 126,
	"./gui/dataview.js": 126,
	"./gui/element": 40,
	"./gui/element.js": 40,
	"./gui/elements/containers": 438,
	"./gui/elements/containers.js": 438,
	"./gui/elements/fileview": 439,
	"./gui/elements/fileview.js": 439,
	"./gui/elements/iconview": 441,
	"./gui/elements/iconview.js": 441,
	"./gui/elements/inputs": 442,
	"./gui/elements/inputs.js": 442,
	"./gui/elements/listview": 443,
	"./gui/elements/listview.js": 443,
	"./gui/elements/menus": 444,
	"./gui/elements/menus.js": 444,
	"./gui/elements/misc": 445,
	"./gui/elements/misc.js": 445,
	"./gui/elements/richtext": 446,
	"./gui/elements/richtext.js": 446,
	"./gui/elements/tabs": 447,
	"./gui/elements/tabs.js": 447,
	"./gui/elements/treeview": 448,
	"./gui/elements/treeview.js": 448,
	"./gui/elements/visual": 449,
	"./gui/elements/visual.js": 449,
	"./gui/menu": 90,
	"./gui/menu.js": 90,
	"./gui/notification": 189,
	"./gui/notification.js": 189,
	"./gui/scheme": 190,
	"./gui/scheme.js": 190,
	"./gui/splash": 418,
	"./gui/splash.js": 418,
	"./helpers/date": 440,
	"./helpers/date.js": 440,
	"./helpers/default-application": 460,
	"./helpers/default-application-window": 461,
	"./helpers/default-application-window.js": 461,
	"./helpers/default-application.js": 460,
	"./helpers/event-handler": 122,
	"./helpers/event-handler.js": 122,
	"./helpers/google-api": 412,
	"./helpers/google-api.js": 412,
	"./helpers/hooks": 181,
	"./helpers/hooks.js": 181,
	"./helpers/iframe-application": 462,
	"./helpers/iframe-application-window": 450,
	"./helpers/iframe-application-window.js": 450,
	"./helpers/iframe-application.js": 462,
	"./helpers/loader": 187,
	"./helpers/loader.js": 187,
	"./helpers/service-notification-icon": 195,
	"./helpers/service-notification-icon.js": 195,
	"./helpers/settings-fragment": 410,
	"./helpers/settings-fragment.js": 410,
	"./helpers/window-behaviour": 411,
	"./helpers/window-behaviour.js": 411,
	"./helpers/windows-live-api": 416,
	"./helpers/windows-live-api.js": 416,
	"./locales/ar_DZ": 163,
	"./locales/ar_DZ.js": 163,
	"./locales/bg_BG": 164,
	"./locales/bg_BG.js": 164,
	"./locales/de_DE": 165,
	"./locales/de_DE.js": 165,
	"./locales/en_EN": 166,
	"./locales/en_EN.js": 166,
	"./locales/es_ES": 167,
	"./locales/es_ES.js": 167,
	"./locales/fa_FA": 168,
	"./locales/fa_FA.js": 168,
	"./locales/fr_FR": 169,
	"./locales/fr_FR.js": 169,
	"./locales/it_IT": 170,
	"./locales/it_IT.js": 170,
	"./locales/ko_KR": 171,
	"./locales/ko_KR.js": 171,
	"./locales/nl_NL": 172,
	"./locales/nl_NL.js": 172,
	"./locales/no_NO": 173,
	"./locales/no_NO.js": 173,
	"./locales/pl_PL": 174,
	"./locales/pl_PL.js": 174,
	"./locales/pt_BR": 175,
	"./locales/pt_BR.js": 175,
	"./locales/ru_RU": 176,
	"./locales/ru_RU.js": 176,
	"./locales/sk_SK": 177,
	"./locales/sk_SK.js": 177,
	"./locales/tr_TR": 178,
	"./locales/tr_TR.js": 178,
	"./locales/vi_VN": 179,
	"./locales/vi_VN.js": 179,
	"./locales/zh_CN": 180,
	"./locales/zh_CN.js": 180,
	"./login.html": 518,
	"./polyfill": 183,
	"./polyfill.js": 183,
	"./utils/clipboard": 203,
	"./utils/clipboard.js": 203,
	"./utils/colors": 199,
	"./utils/colors.js": 199,
	"./utils/compability": 123,
	"./utils/compability.js": 123,
	"./utils/cookies": 463,
	"./utils/cookies.js": 463,
	"./utils/dom": 31,
	"./utils/dom.js": 31,
	"./utils/events": 35,
	"./utils/events.js": 35,
	"./utils/fs": 39,
	"./utils/fs.js": 39,
	"./utils/gui": 55,
	"./utils/gui.js": 55,
	"./utils/keycodes": 88,
	"./utils/keycodes.js": 88,
	"./utils/misc": 52,
	"./utils/misc.js": 52,
	"./utils/preloader": 120,
	"./utils/preloader.js": 120,
	"./vfs/file": 30,
	"./vfs/file.js": 30,
	"./vfs/filedataurl": 188,
	"./vfs/filedataurl.js": 188,
	"./vfs/fs": 62,
	"./vfs/fs.js": 62,
	"./vfs/mountpoint": 408,
	"./vfs/mountpoint.js": 408,
	"./vfs/transport": 86,
	"./vfs/transport.js": 86,
	"./vfs/transports/applications": 191,
	"./vfs/transports/applications.js": 191,
	"./vfs/transports/dist": 192,
	"./vfs/transports/dist.js": 192,
	"./vfs/transports/dropbox": 193,
	"./vfs/transports/dropbox.js": 193,
	"./vfs/transports/google-drive": 194,
	"./vfs/transports/google-drive.js": 194,
	"./vfs/transports/onedrive": 196,
	"./vfs/transports/onedrive.js": 196,
	"./vfs/transports/osjs": 182,
	"./vfs/transports/osjs.js": 182,
	"./vfs/transports/web": 197,
	"./vfs/transports/web.js": 197,
	"./vfs/transports/webdav": 198,
	"./vfs/transports/webdav.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<!-- Dialog: Error--><application-dialog data-id=\"Error\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"Message\">DIALOG_ERROR_MESSAGE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"SummaryLabel\">DIALOG_ERROR_SUMMARY</gui-label> </gui-vbox-container> <gui-vbox-container data-fill=\"true\" data-basis=\"90px\"> <gui-textarea data-id=\"Summary\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"TraceLabel\">DIALOG_ERROR_TRACE</gui-label> </gui-vbox-container> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-textarea data-id=\"Trace\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_CLOSE</gui-button> <gui-button data-id=\"ButtonBugReport\">LBL_BUGREPORT</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Application Chooser--><application-dialog data-id=\"ApplicationChooser\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"Message\">DIALOG_APPCHOOSER_MSG</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"FileName\">filename (mime)</gui-label> </gui-vbox-container> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-list-view data-id=\"ApplicationList\" data-multiple=\"false\"> </gui-list-view> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\"> <gui-checkbox data-id=\"SetDefault\" data-label=\"DIALOG_APPCHOOSER_SET_DEFAULT\"></gui-checkbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Save/Open--><application-dialog data-id=\"File\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-hbox> <gui-hbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-button data-id=\"HomeButton\" data-stock-icon=\"16x16/places/user-home.png\" data-tooltip=\"LBL_HOME\"></gui-button> </gui-hbox-container> <gui-hbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-button data-id=\"ButtonMkdir\" data-stock-icon=\"16x16/actions/folder-new.png\" data-tooltip=\"LBL_MKDIR\"></gui-button> </gui-hbox-container> <gui-hbox-container data-grow=\"1\" data-expand=\"true\"> <gui-select data-id=\"ModuleSelect\"></gui-select> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-file-view data-id=\"FileView\"> </gui-file-view> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-id=\"FileInput\"> <gui-hbox> <gui-hbox-container data-grow=\"1\" data-expand=\"true\"> <gui-text data-id=\"Filename\"></gui-text> </gui-hbox-container> <gui-hbox-container data-shrink=\"0\" data-basis=\"150px\" data-expand=\"true\"> <gui-select data-id=\"Filetype\"></gui-select> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Progress--><application-dialog data-id=\"FileProgress\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">LBL_LOADING</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-progress-bar data-id=\"Progress\"></gui-progress-bar> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonCancel\" data-disabled=\"true\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Upload--><application-dialog data-id=\"FileUpload\"> <gui-vbox> <gui-vbox-container data-shrink=\"1\"> <gui-label data-id=\"Message\">DIALOG_UPLOAD_DESC</gui-label> </gui-vbox-container> <gui-vbox-container data-grow=\"1\"> <gui-file-upload data-id=\"File\"></gui-file-upload> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: File Information--><application-dialog data-id=\"FileInfo\"> <gui-vbox> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-textarea data-id=\"Info\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Input--><application-dialog data-id=\"Input\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">DIALOG_INPUT_TITLE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-expand=\"true\"> <gui-text data-id=\"Input\"></gui-text> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Alert--><application-dialog data-id=\"Alert\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">DIALOG_ALERT_TITLE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Confirm--><application-dialog data-id=\"Confirm\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-label data-id=\"Message\">DIALOG_CONFIRM_TITLE</gui-label> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonYes\">LBL_YES</gui-button> <gui-button data-id=\"ButtonNo\">LBL_NO</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Color--><application-dialog data-id=\"Color\"> <gui-vbox> <gui-vbox-container data-grow=\"1\"> <gui-hbox> <gui-hbox-container data-shrink=\"1\"> <gui-vbox> <gui-vbox-container shrink=\"1\"> <gui-color-swatch data-id=\"ColorSelect\"></gui-color-swatch> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-color-box data-id=\"ColorPreview\" data-disabled=\"true\"></gui-color-box> </gui-vbox-container> </gui-vbox> </gui-hbox-container> <gui-hbox-container data-grow=\"1\"> <gui-vbox> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-label data-id=\"LabelRed\">Red</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-slider data-min=\"0\" data-max=\"255\" data-id=\"Red\"></gui-slider> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-label data-id=\"LabelGreen\">Green</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-slider data-min=\"0\" data-max=\"255\" data-id=\"Green\"></gui-slider> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-label data-id=\"LabelBlue\">Blue</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\"> <gui-slider data-min=\"0\" data-max=\"255\" data-id=\"Blue\"></gui-slider> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\" data-id=\"AlphaLabelContainer\"> <gui-label data-id=\"LabelAlpha\">Alpha</gui-label> </gui-vbox-container> <gui-vbox-container shrink=\"1\" data-expand=\"true\" data-id=\"AlphaContainer\"> <gui-slider data-min=\"0\" data-max=\"100\" data-id=\"Alpha\"></gui-slider> </gui-vbox-container> </gui-vbox> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog><!-- Dialog: Font--><application-dialog data-id=\"Font\"> <gui-vbox> <gui-vbox-container data-grow=\"1\" data-fill=\"true\"> <gui-hbox> <gui-hbox-container data-grow=\"1\" data-shrink=\"1\" data-basis=\"50%\" data-fill=\"true\"> <gui-select-list data-id=\"FontName\"></gui-select-list> </gui-hbox-container> <gui-hbox-container data-grow=\"1\" data-shrink=\"1\" data-basis=\"50%\" data-fill=\"true\" data-id=\"FontSizeContainer\"> <gui-select-list data-id=\"FontSize\"></gui-select-list> </gui-hbox-container> </gui-hbox> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-basis=\"50px\" data-fill=\"true\"> <gui-textarea data-id=\"FontPreview\"></gui-textarea> </gui-vbox-container> <gui-vbox-container data-shrink=\"1\" data-align=\"end\"> <gui-button-bar> <gui-button data-id=\"ButtonOK\">LBL_OK</gui-button> <gui-button data-id=\"ButtonCancel\">LBL_CANCEL</gui-button> </gui-button-bar> </gui-vbox-container> </gui-vbox></application-dialog>";

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "\n<div id=\"Login\">\n  <form method=\"post\" id=\"LoginForm\">\n    <div>\n      <label for=\"LoginUsername\">Username</label>\n      <input type=\"text\" name=\"LoginUsername\" id=\"LoginUsername\" value=\"\" placeholder=\"Username\" />\n    </div>\n    <div>\n      <label for=\"LoginPassword\">Password</label>\n      <input type=\"password\" name=\"LoginPassword\" id=\"LoginPassword\" value=\"\" placeholder=\"Password\" />\n    </div>\n    <div class=\"Submit\">\n      <input type=\"submit\" name=\"LoginSubmit\" id=\"LoginSubmit\" value=\"Login\" />\n    </div>\n  </form>\n</div>\n\n<style type=\"text/css\">\n\n#Login {\n  background : #fff;\n  width : 400px;\n  height : 230px;\n  padding : 20px;\n  position : absolute;\n  left : 50%;\n  top : 50%;\n  z-index : 9999;\n  margin-left : -200px;\n  margin-top : -155px;\n  border : 4px solid rgba(0, 0, 0, .1);\n  -webkit-box-shadow: 0 0 5px 4px rgba(0,0,0,0.15);\n  -moz-box-shadow: 0 0 5px 4px rgba(0,0,0,0.15);\n  box-shadow: 0 0 5px 4px rgba(0,0,0,0.15);\n  box-sizing : border-box;\n\n  display : none;\n}\n  #LoginForm > div {\n    margin-bottom : 20px;\n  }\n  #Login label {\n    display : block;\n    font-weight : bold;\n    height : 30px;\n    line-height : 30px;\n  }\n  #Login input[type=text],\n  #Login input[type=password] {\n    display : block;\n    width : 100%;\n    height : 24px;\n    padding : 4px;\n    line-height : 12px;\n    box-sizing : border-box;\n  }\n  #Login input[type=submit] {\n    height : 40px;\n    padding : 10px;\n    padding-left : 20px;\n    padding-right : 20px;\n    box-sizing : border-box;\n    background : rgba(0, 0, 0, .1);\n    border : 0 none;\n    cursor : pointer;\n  }\n  #Login .Submit {\n    text-align : right;\n  }\n\n</style>\n\n";

/***/ }),
/* 519 */,
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */,
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[465]);


// WEBPACK FOOTER //
// osjs.js